(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5053],{

/***/ 98144:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ storage; }
/* harmony export */ });
var storage = function(key) {
    var get = function() {
        var serializedValue = localStorage.getItem(key);
        if (serializedValue !== null) {
            return JSON.parse(serializedValue);
        }
        return null;
    };
    var set = function(value) {
        var serializedValue = JSON.stringify(value);
        localStorage.setItem(key, serializedValue);
    };
    return {
        get: get,
        set: set
    };
};



/***/ }),

/***/ 60988:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ LeadCategory; }
/* harmony export */ });
var LeadCategory;
(function(LeadCategory) {
    LeadCategory["SweepsImage"] = "sweepsImage";
    LeadCategory["TourEntryLeadForm"] = "tourEntryLeadForm";
    LeadCategory["InTourLeadImage"] = "inTourLeadImage";
    LeadCategory["TourContactForm"] = "tourContactForm";
    LeadCategory["AssertTouchForm"] = "assertTouchForm";
})(LeadCategory || (LeadCategory = {}));


/***/ }),

/***/ 91833:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "x": function() { return /* binding */ createHTMLMesh; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_get.mjs + 1 modules
var _get = __webpack_require__(45785);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_get_prototype_of.mjs
var _get_prototype_of = __webpack_require__(82662);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 1 modules
var _create_super = __webpack_require__(71418);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(82670);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/three/build/three.module.js
var three_module = __webpack_require__(99477);
;// CONCATENATED MODULE: ./_models/virtualStaging/HTMLMesh/utils/html2canvas.ts



var html2canvas = function(element, canvases) {
    var Clipper = function Clipper(context) {
        var clips = [];
        var isClipping = false;
        function doClip() {
            if (isClipping) {
                isClipping = false;
                context.restore();
            }
            if (clips.length === 0) return;
            var minX = -Infinity, minY = -Infinity;
            var maxX = Infinity, maxY = Infinity;
            for(var i = 0; i < clips.length; i++){
                var clip = clips[i];
                minX = Math.max(minX, clip.x);
                minY = Math.max(minY, clip.y);
                maxX = Math.min(maxX, clip.x + clip.width);
                maxY = Math.min(maxY, clip.y + clip.height);
            }
            context.save();
            context.beginPath();
            context.rect(minX, minY, maxX - minX, maxY - minY);
            context.clip();
            isClipping = true;
        }
        return {
            add: function add(clip) {
                clips.push(clip);
                doClip();
            },
            remove: function remove() {
                clips.pop();
                doClip();
            }
        };
    };
    var getLines = function getLines(element, text, maxWidth) {
        var words = text.split(" ");
        var lines = [];
        var currentLine = words[0];
        for(var i = 1; i < words.length; i++){
            // Somehow, the textnode width in pixels differs from the parent element width.
            // Using the range instead of the context to compute the wrapping width fixes this problem.
            var word = words[i];
            range.setStart(element, 0);
            var newLine = currentLine + " " + word;
            range.setEnd(element, newLine.length);
            var width = range.getBoundingClientRect().width;
            if (width < maxWidth) currentLine = newLine;
            else {
                lines.push(currentLine);
                currentLine = word;
            }
        }
        lines.push(currentLine);
        return lines;
    };
    var drawText = function drawText(style, x, y, string) {
        if (string !== "") {
            if (style.textTransform === "uppercase") {
                string = string.toUpperCase();
            }
            context.font = style.fontWeight + " " + style.fontSize + " " + style.fontFamily;
            context.textBaseline = "top";
            context.fillStyle = style.color;
            context.fillText(string, x, y + parseFloat(style.fontSize) * 0.1);
        }
    };
    var buildRectPath = function buildRectPath(x, y, w, h, r) {
        if (w < 2 * r) r = w / 2;
        if (h < 2 * r) r = h / 2;
        context.beginPath();
        context.moveTo(x + r, y);
        context.arcTo(x + w, y, x + w, y + h, r);
        context.arcTo(x + w, y + h, x, y + h, r);
        context.arcTo(x, y + h, x, y, r);
        context.arcTo(x, y, x + w, y, r);
        context.closePath();
    };
    var drawBorder = function drawBorder(style, which, x, y, width, height) {
        var borderWidth = style[which + "Width"];
        var borderStyle = style[which + "Style"];
        var borderColor = style[which + "Color"];
        if (borderWidth !== "0px" && borderStyle !== "none" && borderColor !== "transparent" && borderColor !== "rgba(0, 0, 0, 0)") {
            context.strokeStyle = borderColor;
            context.lineWidth = parseFloat(borderWidth);
            context.beginPath();
            context.moveTo(x, y);
            context.lineTo(x + width, y + height);
            context.stroke();
        }
    };
    var range = document.createRange();
    var color = new three_module/* Color */.Ilk();
    function drawElement(element, style) {
        var x = 0, y = 0, width = 0, height = 0;
        if (element.nodeType === Node.TEXT_NODE) {
            // text
            range.selectNode(element);
            var rect = range.getBoundingClientRect();
            x = rect.left - offset.left - 0.5;
            y = rect.top - offset.top - 0.5;
            width = rect.width;
            height = rect.height;
            // drawText(style, x, y, element.nodeValue.trim());
            var text = element.nodeValue.trim();
            if (element.parentElement) {
                var parentEl = element.parentElement;
                var parentWidth = parentEl.offsetWidth;
                //set to nowrap so that range doesn't warp in the getLines function
                parentEl.style.whiteSpace = "nowrap";
                var lineHeight = range.getBoundingClientRect().height;
                var lines = getLines(element, text, parentWidth);
                parentEl.style.whiteSpace = null;
                range.selectNode(element);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = lines[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var line = _step.value;
                        drawText(style, x, y, line);
                        y += lineHeight;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            } else drawText(style, x, y, text);
        } else if (element.nodeType === Node.COMMENT_NODE) {
            return;
        } else if ((0,_instanceof/* default */.Z)(element, HTMLCanvasElement)) {
            // Canvas element
            if (element.style.display === "none") return;
            context.save();
            var dpr = window.devicePixelRatio;
            context.scale(1 / dpr, 1 / dpr);
            context.drawImage(element, 0, 0);
            context.restore();
        } else {
            if (element.style.display === "none") return;
            var rect1 = element.getBoundingClientRect();
            x = rect1.left - offset.left - 0.5;
            y = rect1.top - offset.top - 0.5;
            width = rect1.width;
            height = rect1.height;
            style = window.getComputedStyle(element);
            // Get the border of the element used for fill and border
            buildRectPath(x, y, width, height, parseFloat(style.borderRadius));
            var backgroundColor = style.backgroundColor;
            if (backgroundColor !== "transparent" && backgroundColor !== "rgba(0, 0, 0, 0)") {
                context.fillStyle = backgroundColor;
                context.fill();
            }
            // If all the borders match then stroke the round rectangle
            var borders = [
                "borderTop",
                "borderLeft",
                "borderBottom",
                "borderRight"
            ];
            var match = true;
            var prevBorder = null;
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = borders[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var border = _step1.value;
                    if (prevBorder !== null) {
                        match = style[border + "Width"] === style[prevBorder + "Width"] && style[border + "Color"] === style[prevBorder + "Color"] && style[border + "Style"] === style[prevBorder + "Style"];
                    }
                    if (match === false) break;
                    prevBorder = border;
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
            if (match === true) {
                // They all match so stroke the rectangle from before allows for border-radius
                var width1 = parseFloat(style.borderTopWidth);
                if (style.borderTopWidth !== "0px" && style.borderTopStyle !== "none" && style.borderTopColor !== "transparent" && style.borderTopColor !== "rgba(0, 0, 0, 0)") {
                    context.strokeStyle = style.borderTopColor;
                    context.lineWidth = width1;
                    context.stroke();
                }
            } else {
                // Otherwise draw individual borders
                drawBorder(style, "borderTop", x, y, width, 0);
                drawBorder(style, "borderLeft", x, y, 0, height);
                drawBorder(style, "borderBottom", x, y + height, width, 0);
                drawBorder(style, "borderRight", x + width, y, 0, height);
            }
            if ((0,_instanceof/* default */.Z)(element, HTMLInputElement)) {
                var accentColor = style.accentColor;
                if (accentColor === undefined || accentColor === "auto") accentColor = style.color;
                color.set(accentColor);
                var luminance = Math.sqrt(0.299 * Math.pow(color.r, 2) + 0.587 * Math.pow(color.g, 2) + 0.114 * Math.pow(color.b, 2));
                var accentTextColor = luminance < 0.5 ? "white" : "#111111";
                if (element.type === "radio") {
                    buildRectPath(x, y, width, height, height);
                    context.fillStyle = "white";
                    context.strokeStyle = accentColor;
                    context.lineWidth = 1;
                    context.fill();
                    context.stroke();
                    if (element.checked) {
                        buildRectPath(x + 2, y + 2, width - 4, height - 4, height);
                        context.fillStyle = accentColor;
                        context.strokeStyle = accentTextColor;
                        context.lineWidth = 2;
                        context.fill();
                        context.stroke();
                    }
                }
                if (element.type === "checkbox") {
                    buildRectPath(x, y, width, height, 2);
                    context.fillStyle = element.checked ? accentColor : "white";
                    context.strokeStyle = element.checked ? accentTextColor : accentColor;
                    context.lineWidth = 1;
                    context.stroke();
                    context.fill();
                    if (element.checked) {
                        var currentTextAlign = context.textAlign;
                        context.textAlign = "center";
                        var properties = {
                            color: accentTextColor,
                            fontFamily: style.fontFamily,
                            fontSize: height + "px",
                            fontWeight: "bold"
                        };
                        drawText(properties, x + width / 2, y, "✔");
                        context.textAlign = currentTextAlign;
                    }
                }
                if (element.type === "range") {
                    var ref = (0,_sliced_to_array/* default */.Z)([
                        "min",
                        "max",
                        "value"
                    ].map(function(property) {
                        return parseFloat(element[property]);
                    }), 3), min = ref[0], max = ref[1], value = ref[2];
                    var position = (value - min) / (max - min) * (width - height);
                    buildRectPath(x, y + height / 4, width, height / 2, height / 4);
                    context.fillStyle = accentTextColor;
                    context.strokeStyle = accentColor;
                    context.lineWidth = 1;
                    context.fill();
                    context.stroke();
                    buildRectPath(x, y + height / 4, position + height / 2, height / 2, height / 4);
                    context.fillStyle = accentColor;
                    context.fill();
                    buildRectPath(x + position, y, height, height, height / 2);
                    context.fillStyle = accentColor;
                    context.fill();
                }
                if (element.type === "color" || element.type === "text" || element.type === "number") {
                    clipper.add({
                        x: x,
                        y: y,
                        width: width,
                        height: height
                    });
                    drawText(style, x + parseInt(style.paddingLeft), y + parseInt(style.paddingTop), element.value);
                    clipper.remove();
                }
            }
        }
        /*
    // debug
    context.strokeStyle = '#' + Math.random().toString( 16 ).slice( - 3 );
    context.strokeRect( x - 0.5, y - 0.5, width + 1, height + 1 );
    */ var isClipping = style.overflow === "auto" || style.overflow === "hidden";
        if (isClipping) clipper.add({
            x: x,
            y: y,
            width: width,
            height: height
        });
        for(var i = 0; i < element.childNodes.length; i++){
            drawElement(element.childNodes[i], style);
        }
        if (isClipping) clipper.remove();
    }
    var offset = element.getBoundingClientRect();
    var canvas = canvases.get(element);
    if (canvas === undefined) {
        canvas = document.createElement("canvas");
        canvas.width = offset.width;
        canvas.height = offset.height;
        canvases.set(element, canvas);
    }
    var context = canvas.getContext("2d" /*, { alpha: false }*/ );
    // @ts-ignore
    var clipper = new Clipper(context);
    // console.time( 'drawElement' );
    // @ts-ignore
    drawElement(element);
    // console.timeEnd( 'drawElement' );
    return canvas;
};

;// CONCATENATED MODULE: ./_models/virtualStaging/HTMLMesh/utils/htmlevent.ts


var htmlevent = function(element, event, x, y) {
    var mouseEventInit = {
        clientX: x * element.offsetWidth + element.offsetLeft,
        clientY: y * element.offsetHeight + element.offsetTop,
        view: element.ownerDocument.defaultView
    };
    //causes error in tours with 'react-zoom-pan-pinch'
    if (event === "mousedown") return;
    window.dispatchEvent(new MouseEvent(event, mouseEventInit));
    var rect = element.getBoundingClientRect();
    x = x * rect.width + rect.left;
    y = y * rect.height + rect.top;
    function traverse(element) {
        if (element.nodeType !== Node.TEXT_NODE && element.nodeType !== Node.COMMENT_NODE) {
            var rect = element.getBoundingClientRect();
            if (x > rect.left && x < rect.right && y > rect.top && y < rect.bottom) {
                element.dispatchEvent(new MouseEvent(event, mouseEventInit));
                if ((0,_instanceof/* default */.Z)(element, HTMLInputElement) && element.type === "range" && (event === "mousedown" || event === "click")) {
                    var ref = (0,_sliced_to_array/* default */.Z)([
                        "min",
                        "max"
                    ].map(function(property) {
                        return parseFloat(element[property]);
                    }), 2), min = ref[0], max = ref[1];
                    var width = rect.width;
                    var offsetX = x - rect.x;
                    var proportion = offsetX / width;
                    // @ts-ignore
                    element.value = min + (max - min) * proportion;
                    element.dispatchEvent(new InputEvent("input", {
                        bubbles: true
                    }));
                }
            }
            for(var i = 0; i < element.childNodes.length; i++){
                traverse(element.childNodes[i]);
            }
        }
    }
    traverse(element);
};

;// CONCATENATED MODULE: ./_models/virtualStaging/HTMLMesh/HTMLMesh.tsx







var createHTMLMesh = function(dom, THREE) {
    var canvases = new WeakMap();
    var HTMLTexture = /*#__PURE__*/ function(_CanvasTexture) {
        "use strict";
        (0,_inherits/* default */.Z)(HTMLTexture, _CanvasTexture);
        var _super = (0,_create_super/* default */.Z)(HTMLTexture);
        function HTMLTexture() {
            (0,_class_call_check/* default */.Z)(this, HTMLTexture);
            var _this;
            _this = _super.call(this, html2canvas(dom, canvases));
            _this.dom = dom;
            _this.anisotropy = 16;
            _this.encoding = THREE.sRGBEncoding;
            _this.minFilter = THREE.LinearFilter;
            _this.magFilter = THREE.LinearFilter;
            // Create an observer on the DOM, and run html2canvas update in the next loop
            var observer = new MutationObserver(function() {
                if (!_this.scheduleUpdate) {
                    // ideally should use xr.requestAnimationFrame, here setTimeout to avoid passing the renderer
                    _this.scheduleUpdate = setTimeout(function() {
                        return _this.update();
                    }, 16);
                }
            });
            var config = {
                attributes: true,
                childList: true,
                subtree: true,
                characterData: true
            };
            observer.observe(dom, config);
            _this.observer = observer;
            return _this;
        }
        var _proto = HTMLTexture.prototype;
        _proto.dispatchDOMEvent = function dispatchDOMEvent(event) {
            if (event.data) {
                htmlevent(this.dom, event.type, event.data.x, event.data.y);
            }
        };
        _proto.update = function update() {
            this.image = html2canvas(this.dom, canvases);
            this.needsUpdate = true;
            this.scheduleUpdate = null;
        };
        _proto.dispose = function dispose() {
            if (this.observer) {
                this.observer.disconnect();
            }
            this.scheduleUpdate = clearTimeout(this.scheduleUpdate);
            (0,_get/* default */.Z)((0,_get_prototype_of/* default */.Z)(HTMLTexture.prototype), "dispose", this).call(this);
        };
        return HTMLTexture;
    }(THREE.CanvasTexture);
    var HTMLMesh = /*#__PURE__*/ function(_Mesh) {
        "use strict";
        (0,_inherits/* default */.Z)(HTMLMesh, _Mesh);
        var _super = (0,_create_super/* default */.Z)(HTMLMesh);
        function HTMLMesh() {
            (0,_class_call_check/* default */.Z)(this, HTMLMesh);
            var _this;
            var onEvent = function onEvent(event) {
                material.map.dispatchDOMEvent(event);
            };
            var texture = new HTMLTexture();
            var geometry = new THREE.PlaneGeometry(texture.image.width * 0.001, texture.image.height * 0.001);
            var material = new THREE.MeshBasicMaterial({
                map: texture,
                toneMapped: false,
                transparent: true
            });
            _this = _super.call(this, geometry, material);
            _this.addEventListener("mousedown", onEvent);
            _this.addEventListener("mousemove", onEvent);
            _this.addEventListener("mouseup", onEvent);
            _this.addEventListener("click", onEvent);
            _this.dispose = function() {
                geometry.dispose();
                material.dispose();
                material.map.dispose();
                canvases.delete(dom);
                this.removeEventListener("mousedown", onEvent);
                this.removeEventListener("mousemove", onEvent);
                this.removeEventListener("mouseup", onEvent);
                this.removeEventListener("click", onEvent);
            };
            return _this;
        }
        return HTMLMesh;
    }(THREE.Mesh);
    return new HTMLMesh();
};


/***/ }),

/***/ 39277:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ AbstractHTMLMesh; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88029);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71418);
/* harmony import */ var _models_virtualStaging_Scene_component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98472);
/* harmony import */ var _models_virtualStaging_VSObject__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15864);






var AbstractHTMLMesh = /*#__PURE__*/ function(SceneComponent) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(AbstractHTMLMesh, SceneComponent);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(AbstractHTMLMesh);
    function AbstractHTMLMesh() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this, AbstractHTMLMesh);
        var _this;
        _this = _super.apply(this, arguments);
        _this.root = null;
        _this.pivot = null;
        _this.inputs = {
            html: null,
            visible: false,
            scale: 1
        };
        _this.outputs = {
            loadingState: _models_virtualStaging_VSObject__WEBPACK_IMPORTED_MODULE_1__/* .LoadingState.Idle */ .Gu.Idle
        };
        var _obj;
        _this.events = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, _models_virtualStaging_Scene_component__WEBPACK_IMPORTED_MODULE_0__/* .ComponentInteractionType.CLICK */ .td.CLICK, true), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, _models_virtualStaging_Scene_component__WEBPACK_IMPORTED_MODULE_0__/* .ComponentInteractionType.HOVER */ .td.HOVER, true), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, _models_virtualStaging_Scene_component__WEBPACK_IMPORTED_MODULE_0__/* .ComponentInteractionType.DRAG */ .td.DRAG, false), _obj);
        return _this;
    }
    var _proto = AbstractHTMLMesh.prototype;
    _proto.initRoot = function initRoot() {
        var THREE = this.context.three;
        this.root = new THREE.Object3D();
        this.root.visible = this.inputs.visible;
        this.root.scale.set(this.inputs.scale, this.inputs.scale, this.inputs.scale);
        this.pivot = new THREE.Object3D();
        this.root.add(this.pivot);
        this.outputs.objectRoot = this.root;
        this.outputs.collider = this.root;
        this.outputs.loadingState = _models_virtualStaging_VSObject__WEBPACK_IMPORTED_MODULE_1__/* .LoadingState.Loading */ .Gu.Loading;
    };
    _proto.getXRController = function getXRController() {
        var _this = this;
        var xr = this.context.renderer.xr;
        this.controllers = [
            xr.getController(0),
            xr.getController(1)
        ];
        this.controllers.forEach(function(controller) {
            controller.addEventListener("connected", function(event) {
                var inputSource = event.data;
                var handedness = inputSource.handedness;
                if (handedness === "left") {
                    _this.controllerL = controller;
                    _this.gamepadL = inputSource.gamepad;
                } else if (handedness === "right") {
                    _this.controllerR = controller;
                    _this.gamepadR = inputSource.gamepad;
                }
            });
        });
    };
    _proto.onVisibleChange = function onVisibleChange() {};
    _proto.setVisible = function setVisible(visible) {
        this.inputs.visible = visible;
        if (this.onVisibleChange) this.onVisibleChange();
    };
    _proto.onInputsUpdated = function onInputsUpdated(previousInputs) {
        this.root.visible = this.inputs.visible;
    };
    _proto.onDestroy = function onDestroy() {};
    return AbstractHTMLMesh;
}(_models_virtualStaging_Scene_component__WEBPACK_IMPORTED_MODULE_0__/* .SceneComponent */ .Ad);


/***/ }),

/***/ 20093:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ ControllerType; }
/* harmony export */ });
var ControllerType;
(function(ControllerType) {
    ControllerType["GamepadL"] = "gamepadL";
    ControllerType["GamepadR"] = "gamepadR";
})(ControllerType || (ControllerType = {}));


/***/ }),

/***/ 79502:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ InteractiveGroup; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88029);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71418);
/* harmony import */ var three__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99477);




var _pointer = new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector2 */ .FM8();
var _event = {
    type: "",
    data: _pointer
};
var InteractiveGroup = /*#__PURE__*/ function(Group) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(InteractiveGroup, Group);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(InteractiveGroup);
    function InteractiveGroup(renderer, camera, context) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, InteractiveGroup);
        var _this;
        _this = _super.call(this);
        _this.isPointerOver = false;
        var debug = false;
        var arrowHelper1;
        var arrowHelper2;
        if (context && debug) {
            var dir = new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4(1, 0, 0);
            dir.normalize();
            var origin = new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4(0, 0, 0);
            var length = 1;
            var hex = 0xffff00;
            arrowHelper1 = new context.three.ArrowHelper(dir, origin, length, hex);
            arrowHelper2 = new context.three.ArrowHelper(dir, origin, length, hex);
            context.scene.add(arrowHelper1);
            context.scene.add(arrowHelper2);
        }
        var raycasterL = new three__WEBPACK_IMPORTED_MODULE_0__/* .Raycaster */ .iMs();
        var raycasterR = new three__WEBPACK_IMPORTED_MODULE_0__/* .Raycaster */ .iMs();
        var tempMatrix = new three__WEBPACK_IMPORTED_MODULE_0__/* .Matrix4 */ .yGw();
        var element = renderer.domElement;
        var onPointerEvent = function(event) {
            event.stopPropagation();
            var rect = renderer.domElement.getBoundingClientRect();
            _pointer.x = (event.clientX - rect.left) / rect.width * 2 - 1;
            _pointer.y = -(event.clientY - rect.top) / rect.height * 2 + 1;
            raycasterL.setFromCamera(_pointer, camera);
            raycasterR.setFromCamera(_pointer, camera);
            var intersectsL = raycasterL.intersectObjects(_this.children, false);
            var intersectsR = raycasterR.intersectObjects(_this.children, false);
            if (!intersectsL.length && _this.isPointerOver && _this.targetObject) {
                _this.isPointerOver = false;
                _this.targetObject.userData.isPointerOver = _this.isPointerOver;
            }
            if (!intersectsR.length && _this.isPointerOver && _this.targetObject) {
                _this.isPointerOver = false;
                _this.targetObject.userData.isPointerOver = _this.isPointerOver;
            }
            if (intersectsL.length > 0) {
                var intersection = intersectsL[0];
                _this.targetObject = intersection.object;
                var uv = intersection.uv;
                _event.type = event.type;
                _event.data.set(uv.x, 1 - uv.y);
                if (!_this.isPointerOver) {
                    _this.isPointerOver = true;
                    _this.targetObject.userData.isPointerOver = _this.isPointerOver;
                }
                _this.targetObject.dispatchEvent(_event);
            }
            if (intersectsR.length > 0) {
                var intersection1 = intersectsR[0];
                _this.targetObject = intersection1.object;
                var uv1 = intersection1.uv;
                _event.type = event.type;
                _event.data.set(uv1.x, 1 - uv1.y);
                if (!_this.isPointerOver) {
                    _this.isPointerOver = true;
                    _this.targetObject.userData.isPointerOver = _this.isPointerOver;
                }
                _this.targetObject.dispatchEvent(_event);
            }
        };
        element.addEventListener("pointerdown", onPointerEvent);
        element.addEventListener("pointerup", onPointerEvent);
        element.addEventListener("pointermove", onPointerEvent);
        element.addEventListener("mousedown", onPointerEvent);
        element.addEventListener("mouseup", onPointerEvent);
        element.addEventListener("mousemove", onPointerEvent);
        element.addEventListener("click", onPointerEvent);
        // WebXR Controller Events
        // TODO: Dispatch pointerevents too
        var events = {
            move: "mousemove",
            select: "click",
            selectstart: "mousedown",
            selectend: "mouseup"
        };
        var controller1 = renderer.xr.getController(0);
        var controller2 = renderer.xr.getController(1);
        var visualiseRaycaster = function(arrowHelper, raycaster) {
            if (!debug) return;
            arrowHelper.setDirection(raycaster.ray.direction);
            arrowHelper.position.set(raycaster.ray.origin.x, raycaster.ray.origin.y, raycaster.ray.origin.z);
        };
        var onXRControllerEvent = function(event) {
            var controller = event.target;
            var raycaster;
            var arrowHelper;
            if (event.target === controller1) {
                raycaster = raycasterR;
                arrowHelper = arrowHelper1;
            }
            if (event.target === controller2) {
                raycaster = raycasterL;
                arrowHelper = arrowHelper2;
            }
            tempMatrix.identity().extractRotation(controller.matrixWorld);
            raycaster.ray.origin.setFromMatrixPosition(controller.matrixWorld);
            raycaster.ray.direction.set(0, 0, -1).applyMatrix4(tempMatrix);
            if (arrowHelper) visualiseRaycaster(arrowHelper, raycaster);
            var intersections = raycaster.intersectObjects(_this.children, false);
            if (intersections.length > 0) {
                var intersection = intersections[0];
                var object = intersection.object;
                var uv = intersection.uv;
                _event.type = events[event.type];
                _event.data.set(uv.x, 1 - uv.y);
                object.dispatchEvent(_event);
            }
        };
        controller1.addEventListener("move", onXRControllerEvent);
        controller1.addEventListener("select", onXRControllerEvent);
        controller1.addEventListener("selectstart", onXRControllerEvent);
        controller1.addEventListener("selectend", onXRControllerEvent);
        controller2.addEventListener("move", onXRControllerEvent);
        controller2.addEventListener("select", onXRControllerEvent);
        controller2.addEventListener("selectstart", onXRControllerEvent);
        controller2.addEventListener("selectend", onXRControllerEvent);
        return _this;
    }
    return InteractiveGroup;
}(three__WEBPACK_IMPORTED_MODULE_0__/* .Group */ .ZAu);



/***/ }),

/***/ 87161:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ getRelativePaddingLeft; },
/* harmony export */   "X": function() { return /* binding */ getRelativePaddingTop; }
/* harmony export */ });
var getRelativePaddingTop = function(html) {
    var rect = html.getBoundingClientRect();
    var paddingTop = parseInt(getComputedStyle(html).paddingTop, 10);
    return paddingTop * 100 / rect.height * 0.01;
};
var getRelativePaddingLeft = function(html) {
    var rect = html.getBoundingClientRect();
    var paddingLeft = parseInt(getComputedStyle(html).paddingLeft, 10);
    return paddingLeft * 100 / rect.width * 0.01;
};


/***/ }),

/***/ 71425:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ AvatarPredictor; },
/* harmony export */   "v": function() { return /* binding */ AUPredictorQuality; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20414);
/* harmony import */ var _quarkworks_inc_avatar_webkit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9995);




var AUPredictorQuality;
(function(AUPredictorQuality) {
    AUPredictorQuality["Low"] = "low";
    AUPredictorQuality["High"] = "high";
})(AUPredictorQuality || (AUPredictorQuality = {}));
var AvatarPredictor = /*#__PURE__*/ function() {
    "use strict";
    function AvatarPredictor(config) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, AvatarPredictor);
        this.predictor = new _quarkworks_inc_avatar_webkit__WEBPACK_IMPORTED_MODULE_0__/* .AUPredictor */ .SM({
            apiToken: "fbd204a7-318e-4dd3-86e0-e6d524fc3f98",
            shouldMirrorOutput: false,
            fps: 30,
            predictionQuality: config.predictionQuality || AUPredictorQuality.Low
        });
    }
    var _proto = AvatarPredictor.prototype;
    _proto.start = function start(stream, cb) {
        var _this = this;
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
            var ref, hasVideoTrack;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        hasVideoTrack = stream === null || stream === void 0 ? void 0 : (ref = stream.getTracks) === null || ref === void 0 ? void 0 : ref.call(stream).some(function(track) {
                            return track.kind === "video";
                        });
                        if (!hasVideoTrack) {
                            throw new Error("Video track not found.");
                        }
                        return [
                            4,
                            _this.predictor.start({
                                stream: stream
                            })
                        ];
                    case 1:
                        _state.sent();
                        _this.predictor.dataStream.subscribe(cb);
                        return [
                            2
                        ];
                }
            });
        })();
    };
    _proto.stop = function stop() {
        var _this = this;
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            _this.predictor.stop()
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        })();
    };
    return AvatarPredictor;
}();


/***/ }),

/***/ 49093:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "lZ": function() { return /* reexport */ AVATAR_ANIMATION_BLENDING; },
  "iG": function() { return /* reexport */ AVATAR_CIRCLE_RADIUS; },
  "WV": function() { return /* reexport */ AVATAR_ROTATION_SPEED; },
  "rQ": function() { return /* reexport */ AVATAR_WALKING_SPEED; },
  "qE": function() { return /* reexport */ Avatar; },
  "KP": function() { return /* reexport */ AvatarPredictor/* AvatarPredictor */.K; },
  "bB": function() { return /* reexport */ avatarComponentType; },
  "Sr": function() { return /* reexport */ makeAvatarComponent; }
});

// UNUSED EXPORTS: AvatarComponent, DEFAULT_AVATARS

// EXTERNAL MODULE: ./_models/virtualStaging/avatar/AvatarPredictor.ts
var AvatarPredictor = __webpack_require__(71425);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/lodash/isNil.js
var isNil = __webpack_require__(14293);
var isNil_default = /*#__PURE__*/__webpack_require__.n(isNil);
;// CONCATENATED MODULE: ./_models/virtualStaging/avatar/Avatar.tsx


var DEFAULT_AVATARS = (/* unused pure expression or super */ null && ([
    "https://static.treedis.com/avatars/62cd861b48960be56eae26b8.glb",
    "https://static.treedis.com/avatars/62f3ae0a3e172e00542676ec.glb",
    "https://static.treedis.com/avatars/635fcfdb41d7a22057ef1495.glb",
    "https://static.treedis.com/avatars/63626a6efff3a4d4797dae05.glb",
    "https://static.treedis.com/avatars/63626a94fff3a4d4797dae46.glb",
    "https://static.treedis.com/avatars/63626accfff3a4d4797daeb5.glb",
    "https://static.treedis.com/avatars/63626adffff3a4d4797daee4.glb",
    "https://static.treedis.com/avatars/63626b6e52b953b7b71fce6a.glb",
    "https://static.treedis.com/avatars/63626bb152b953b7b71fcef0.glb",
    "https://static.treedis.com/avatars/63626bd552b953b7b71fcf39.glb",
    "https://static.treedis.com/avatars/63626c8a52b953b7b71fd044.glb",
    "https://static.treedis.com/avatars/636269effff3a4d4797dad1f.glb",
    "https://static.treedis.com/avatars/6317163a666e9239d9c635cf.glb",
    "https://static.treedis.com/avatars/63171619666e9239d9c63168.glb", 
]));
var AVATAR_CIRCLE_RADIUS = 0.65;
var AVATAR_WALKING_SPEED = 1.5; // Avatar speed in m/s
var AVATAR_ROTATION_SPEED = 0.5; // Avatar rotation speed
var AVATAR_ANIMATION_BLENDING = 0.2; // How smooth avatar animations transition between each other
var Avatar = function Avatar() {
    "use strict";
    var model = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    (0,_class_call_check/* default */.Z)(this, Avatar);
    this.name = model.name || "";
    this.bodyType = model.bodyType;
    this.url = model.url;
    this.positionX = model.positionX || 0;
    this.positionY = model.positionY || 0;
    this.positionZ = model.positionZ || 0;
    this.rotationX = model.rotationX || 0;
    this.rotationY = model.rotationY || 0;
    this.rotationZ = model.rotationZ || 0;
    this.quaternionX = model.quaternionX || 0;
    this.quaternionY = model.quaternionY || 0;
    this.quaternionZ = model.quaternionZ || 0;
    this.quaternionW = model.quaternionW || 0;
    this.uuid = model.uuid || null;
    this.color = model.color || "0xEA475C";
    this.muted = isNil_default()(model.muted) || model.muted;
    this.visible = typeof model.visible === "boolean" ? model.visible : true;
    this.degree = model.degree || null;
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 1 modules
var _create_super = __webpack_require__(71418);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./node_modules/@quarkworks-inc/avatar-webkit/dist/index.modern.js
var index_modern = __webpack_require__(9995);
// EXTERNAL MODULE: ./node_modules/three/examples/jsm/libs/tween.module.min.js
var tween_module_min = __webpack_require__(27970);
// EXTERNAL MODULE: ./_models/virtualStaging/VSObject.tsx
var VSObject = __webpack_require__(15864);
;// CONCATENATED MODULE: ./_models/virtualStaging/avatar/component/utils/emojiKeyMap.ts
var emojiKeyMap = {
    mouthOpen: "mouthOpen",
    mouthSmile: "mouthSmile",
    eyesClosed: "eyesClosed",
    eyesLookUp: "eyesLookUp",
    eyesLookDown: "eyesLookDown",
    eyeBlinkLeft: "eyeBlink_L",
    eyeBlinkRight: "eyeBlink_R",
    eyeSquintLeft: "eyeSquint_L",
    eyeSquintRight: "eyeSquint_R",
    eyeWideLeft: "eyeWide_L",
    eyeWideRight: "eyeWide_R",
    jawForward: "jawForward",
    jawLeft: "jawLeft",
    jawRight: "jawRight",
    jawOpen: "jawOpen",
    mouthClose: "mouthClose",
    mouthFunnel: "mouthFunnel",
    mouthPucker: "mouthPucker",
    mouthLeft: "mouthLeft",
    mouthRight: "mouthRight",
    // mouthSmileLeft: 'mouthSmileLeft',
    mouthSmileLeft: "mouthSmile_L",
    mouthSmileRight: "mouthSmile_R",
    mouthFrownLeft: "mouthFrown_L",
    mouthFrownRight: "mouthFrown_R",
    mouthDimpleLeft: "mouthDimple_L",
    mouthDimpleRight: "mouthDimple_R",
    mouthStretchLeft: "mouthStretch_L",
    mouthStretchRight: "mouthStretch_R",
    mouthRollLower: "mouthRollLower",
    mouthRollUpper: "mouthRollUpper",
    mouthShrugLower: "mouthShrugLower",
    mouthShrugHigher: "mouthShrugHigher",
    mouthPressLeft: "mouthPress_L",
    mouthPressRight: "mouthPress_R",
    mouthLowerDownLeft: "mouthLowerDown_L",
    mouthLowerDownRight: "mouthLowerDown_R",
    mouthUpperUpLeft: "mouthUpperUp_L",
    mouthUpperUpRight: "mouthUpperUp_R",
    browDownLeft: "browDown_L",
    browDownRight: "browDown_R",
    browInnerUp: "browInnerUp",
    browOuterUpLeft: "browOuterUp_L",
    browOuterUpRight: "browOuterUp_R",
    cheekPuff: "cheekPuff",
    cheekSquintLeft: "cheekSquint_L",
    cheekSquintRight: "cheekSquint_R",
    noseSneerLeft: "noseSneer_L",
    noseSneerRight: "noseSneer_R",
    tongueOut: "tongueOut",
    mouthShrugUpper: "mouthShrugUpper",
    eyeLookInLeft: "eyeLookIn_L",
    eyeLookInRight: "eyeLookIn_R",
    eyeLookOutLeft: "eyeLookOut_L",
    eyeLookOutRight: "eyeLookOut_R",
    eyeLookUpLeft: "eyeLookUp_L",
    eyeLookUpRight: "eyeLookUp_R",
    eyeLookDownLeft: "eyeLookDown_L",
    eyeLookDownRight: "eyeLookDown_R"
}; // mouthOpen: 0
 // mouthSmile: 1

;// CONCATENATED MODULE: ./_models/virtualStaging/avatar/component/utils/helper.ts
var findObject3DChildByName = function(object, name) {
    return object.children.find(function(child) {
        return child.name === name;
    });
};
var setMorphTarget = function(mesh, key, value) {
    if (!mesh) return;
    var idx = mesh.morphTargetDictionary[key];
    if (!idx) return;
    mesh.morphTargetInfluences[idx] = value;
};

;// CONCATENATED MODULE: ./_models/virtualStaging/avatar/component/utils/index.ts



// EXTERNAL MODULE: ./_models/virtualStaging/Scene.component.tsx
var Scene_component = __webpack_require__(98472);
// EXTERNAL MODULE: ./node_modules/three/build/three.module.js
var three_module = __webpack_require__(99477);
;// CONCATENATED MODULE: ./_models/virtualStaging/materials/CircleShaderMaterial.ts

var getCircleShaderMaterial = function(texture, radius, planeWidth, planeHeight) {
    return new three_module/* ShaderMaterial */.jyz({
        uniforms: {
            uTexture: {
                value: texture
            },
            uRadius: {
                value: radius
            },
            uPlaneWidth: {
                value: planeWidth
            },
            uPlaneHeight: {
                value: planeHeight
            }
        },
        vertexShader: "\n        varying vec2 vUv;\n        void main() {\n            vUv = uv;\n            gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);\n        }\n    ",
        fragmentShader: "\n    uniform sampler2D uTexture;\n    uniform float uRadius;\n    uniform float uPlaneWidth;\n    uniform float uPlaneHeight;\n    varying vec2 vUv;\n    void main() {\n        vec2 aspectCorrectedUV = uPlaneHeight < uPlaneWidth ? \n                         vec2(vUv.x * uPlaneWidth / uPlaneHeight, vUv.y) :\n                         vec2(vUv.x, vUv.y * uPlaneHeight / uPlaneWidth);\n        float dist = distance(aspectCorrectedUV, vec2(0.5 * uPlaneWidth, 0.5 * uPlaneHeight));\n        if (dist > uRadius) discard;\n\n        gl_FragColor = texture2D(uTexture, vUv);\n    }\n",
        transparent: true
    });
};

;// CONCATENATED MODULE: ./utils/normalizeDimensions.ts
var normalizeDimensions = function(width, height) {
    var normalizedWidth, normalizedHeight;
    if (width > height) {
        normalizedWidth = width / height;
        normalizedHeight = 1;
    } else {
        normalizedHeight = height / width;
        normalizedWidth = 1;
    }
    return {
        width: normalizedWidth,
        height: normalizedHeight
    };
};

;// CONCATENATED MODULE: ./_models/virtualStaging/avatar/component/AbstractAvatar.ts
/* eslint-disable no-prototype-builtins */ 








var AbstractAvatar = /*#__PURE__*/ function(SceneComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(AbstractAvatar, SceneComponent);
    var _super = (0,_create_super/* default */.Z)(AbstractAvatar);
    function AbstractAvatar() {
        (0,_class_call_check/* default */.Z)(this, AbstractAvatar);
        var _this;
        _this = _super.apply(this, arguments);
        _this.id = null;
        _this.root = null;
        _this.pivot = null;
        _this.label = null;
        _this.labelSize = [
            0,
            0
        ];
        _this.model = null;
        _this.inputs = {
            color: 0xff0033,
            label: "User",
            bodyType: null,
            url: null,
            uuid: null,
            visible: true,
            sweep: null
        };
        _this.outputs = {
            loadingState: VSObject/* LoadingState.Idle */.Gu.Idle
        };
        _this.getPosition = function() {
            return _this.model.position;
        };
        _this.loadAsync = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(THREE, url) {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    if (url.includes(".gltf") || url.includes(".glb")) return [
                        2,
                        new Promise(function(resolve, reject) {
                            var loader = new THREE.GLTFLoader();
                            loader.load(url, function(gltf) {
                                return resolve(gltf);
                            }, function() {
                                return null;
                            }, function(err) {
                                return reject(err);
                            });
                        })
                    ];
                    if (url.includes(".fbx")) return [
                        2,
                        new Promise(function(resolve, reject) {
                            var loader = new THREE.FBXLoader();
                            loader.load(url, function(model) {
                                return resolve(model);
                            }, function() {
                                return null;
                            }, function(err) {
                                return reject(err);
                            });
                        })
                    ];
                    if (url.includes(".png") || url.includes(".jpg") || url.includes("base64")) return [
                        2,
                        new Promise(function(resolve, reject) {
                            var loader = new THREE.TextureLoader();
                            loader.load(url, function(texture) {
                                return resolve(texture);
                            }, function() {
                                return null;
                            }, function(err) {
                                return reject(err);
                            });
                        })
                    ];
                    return [
                        2
                    ];
                });
            });
            return function(THREE, url) {
                return _ref.apply(this, arguments);
            };
        }();
        return _this;
    }
    var _proto = AbstractAvatar.prototype;
    _proto.initRoot = function initRoot() {
        var THREE = this.context.three;
        this.root = new THREE.Object3D();
        this.pivot = new THREE.Object3D();
        this.root.add(this.pivot);
        this.outputs.objectRoot = this.root;
    };
    _proto.initLabel = function initLabel() {
        this.label = this.makeLabel(this.inputs.label, {
            fontsize: 48,
            textColor: {
                r: 255,
                g: 255,
                b: 255,
                a: 1.0
            },
            borderColor: {
                r: 0,
                g: 0,
                b: 0,
                a: 0
            },
            backgroundColor: {
                r: 0,
                g: 0,
                b: 0,
                a: 0.7
            },
            borderThickness: 16
        });
        if (this.inputs.bodyType === "fullbody") {
            this.label.rotateX(Math.PI / 2);
            this.label.position.setY(-0.05);
            this.label.position.setZ(2.3);
            this.pivot.add(this.label);
        } else {
            this.label.position.setY(0.83);
            this.pivot.add(this.label);
        }
        if (this.root && this.root.parent) {
            this.root.parent.visible = this.inputs.visible;
        }
    };
    _proto.getLabelSize = function getLabelSize() {
        return this.labelSize;
    };
    _proto.makeLabel = function makeLabel(message, parameters) {
        var THREE = this.context.three;
        if (parameters === undefined) parameters = {};
        var fontface = parameters.hasOwnProperty("fontface") ? parameters.fontface : "Arial";
        var fontsize = parameters.hasOwnProperty("fontsize") ? parameters.fontsize : 18;
        var borderThickness = parameters.hasOwnProperty("borderThickness") ? parameters.borderThickness : 4;
        var borderColor = parameters.hasOwnProperty("borderColor") ? parameters.borderColor : {
            r: 0,
            g: 0,
            b: 0,
            a: 1.0
        };
        var backgroundColor = parameters.hasOwnProperty("backgroundColor") ? parameters.backgroundColor : {
            r: 255,
            g: 255,
            b: 255,
            a: 1.0
        };
        var textColor = parameters.hasOwnProperty("textColor") ? parameters.textColor : {
            r: 255,
            g: 255,
            b: 255,
            a: 1.0
        };
        var canvas = document.createElement("canvas");
        var context = canvas.getContext("2d");
        context.font = "Bold ".concat(fontsize, "px ").concat(fontface);
        var metrics = context.measureText(message);
        var textWidth = metrics.width;
        context.fillStyle = "rgba(".concat(backgroundColor.r, ",").concat(backgroundColor.g, ",").concat(backgroundColor.b, ",").concat(backgroundColor.a, ")");
        context.strokeStyle = "rgba(".concat(borderColor.r, ",").concat(borderColor.g, ",").concat(borderColor.b, ",").concat(borderColor.a, ")");
        context.lineWidth = borderThickness;
        var rectW = (textWidth + borderThickness) * 1.1;
        var rectH = fontsize * 1.4 + borderThickness;
        this.roundRect(context, borderThickness / 2, borderThickness / 2, rectW, rectH, 8);
        context.fillStyle = "rgba(".concat(textColor.r, ", ").concat(textColor.g, ", ").concat(textColor.b, ", 1.0)");
        context.fillText(message, borderThickness, fontsize + borderThickness);
        // crop exactly the rectangle size
        var label = this.crop(canvas, 0, 0, rectW + borderThickness, rectH + borderThickness);
        var texture = new THREE.Texture(label);
        texture.needsUpdate = true;
        texture.wrapS = THREE.RepeatWrapping;
        texture.wrapT = THREE.RepeatWrapping;
        texture.encoding = THREE.sRGBEncoding;
        texture.repeat.set(1, 1);
        var planeWidth = label.width / 1000; // scaling down
        var planeHeight = label.height / 1000;
        // need for dynamic mute button positioning
        this.labelSize = [
            planeWidth,
            planeHeight
        ];
        var plane = this.makePlane(planeWidth, planeHeight, texture);
        plane.scale.set(1, 1, 1);
        return plane;
    };
    _proto.makeAvatarImageRound = function makeAvatarImageRound(str) {
        if (!str) {
            console.error("Invalid name");
            return;
        }
        var THREE = this.context.three;
        var colors = [
            {
                bg: "red",
                text: {
                    r: 255,
                    g: 255,
                    b: 255,
                    a: 1.0
                }
            },
            {
                bg: "green",
                text: {
                    r: 255,
                    g: 255,
                    b: 255,
                    a: 1.0
                }
            },
            {
                bg: "blue",
                text: {
                    r: 255,
                    g: 255,
                    b: 255,
                    a: 1.0
                }
            },
            {
                bg: "pink",
                text: {
                    r: 255,
                    g: 255,
                    b: 255,
                    a: 1.0
                }
            },
            {
                bg: "orange",
                text: {
                    r: 0,
                    g: 0,
                    b: 0,
                    a: 1.0
                }
            },
            {
                bg: "white",
                text: {
                    r: 0,
                    g: 0,
                    b: 0,
                    a: 1.0
                }
            },
            {
                bg: "grey",
                text: {
                    r: 255,
                    g: 255,
                    b: 255,
                    a: 1.0
                }
            }, 
        ];
        var letter = str[0].toUpperCase();
        var asciiValue = letter.charCodeAt(0);
        var colorIndex = asciiValue % colors.length;
        var letterObject = this.makeLabel(letter, {
            fontsize: 48,
            textColor: colors[colorIndex].text,
            borderColor: {
                r: 0,
                g: 0,
                b: 0,
                a: 0
            },
            backgroundColor: {
                r: 255,
                g: 255,
                b: 255,
                a: 0
            },
            borderThickness: 0,
            shape: "round"
        });
        letterObject.scale.setScalar(7);
        var geometry = new THREE.CircleGeometry(0.5, 32);
        var material = new THREE.MeshBasicMaterial({
            color: colors[colorIndex].bg
        });
        var backgroundCircle = new THREE.Mesh(geometry, material);
        var avatarImage = new THREE.Group();
        avatarImage.add(backgroundCircle);
        avatarImage.add(letterObject);
        letterObject.position.z = 0.05;
        return avatarImage;
    };
    // function for drawing rounded rectangles
    // eslint-disable-next-line class-methods-use-this
    _proto.roundRect = function roundRect(ctx, x, y, w, h, r) {
        ctx.beginPath();
        ctx.moveTo(x + r, y);
        ctx.lineTo(x + w - r, y);
        ctx.quadraticCurveTo(x + w, y, x + w, y + r);
        ctx.lineTo(x + w, y + h - r);
        ctx.quadraticCurveTo(x + w, y + h, x + w - r, y + h);
        ctx.lineTo(x + r, y + h);
        ctx.quadraticCurveTo(x, y + h, x, y + h - r);
        ctx.lineTo(x, y + r);
        ctx.quadraticCurveTo(x, y, x + r, y);
        ctx.closePath();
        ctx.fill();
        ctx.stroke();
    };
    _proto.makePlane = function makePlane(width, height, texture) {
        var THREE = this.context.three;
        var geometry = new THREE.PlaneGeometry(width, height, 10, 10);
        var material = new THREE.MeshBasicMaterial({
            map: texture,
            side: THREE.DoubleSide,
            blending: THREE.NormalBlending,
            transparent: true
        });
        return new THREE.Mesh(geometry, material);
    };
    _proto.makeRoundPlane = function makeRoundPlane(texture) {
        // uncomment if we need adaptive border color
        // const { r, g, b } = getAverageRGB(texture.image);
        // const luma = parseInt(`${getBrightness(r, g, b)}`, 10);
        var THREE = this.context.three;
        var ref = normalizeDimensions(texture.image.width, texture.image.height), width = ref.width, height = ref.height;
        var radius = Math.min(width, height) / 2;
        var material = getCircleShaderMaterial(texture, radius, width, height);
        var geometry = new THREE.PlaneGeometry(width, height);
        var outerCircleGeometry = new THREE.CircleGeometry(Math.min(width, height) / 2, 64);
        var outerCircleMaterial = new THREE.MeshBasicMaterial({
            color: "white"
        });
        var outerCircle = new THREE.Mesh(outerCircleGeometry, outerCircleMaterial);
        var image = new THREE.Mesh(geometry, material);
        var group = new THREE.Group();
        group.add(outerCircle);
        group.add(image);
        image.position.z = 0.005;
        image.scale.setScalar(0.92);
        return group;
    };
    // eslint-disable-next-line class-methods-use-this
    _proto.crop = function crop(can, x, y, w, h) {
        // get your canvas and a context for it
        var ctx = can.getContext("2d");
        // get the image data you want to keep.
        var imageData = ctx.getImageData(x, y, w * 2, h);
        // create a new cavnas same as clipped size and a context
        var newCan = document.createElement("canvas");
        newCan.width = w - x;
        newCan.height = h - y;
        var newCtx = newCan.getContext("2d");
        // put the clipped image on the new canvas.
        newCtx.putImageData(imageData, 0, 0);
        return newCan;
    };
    _proto.loadAnimation = function loadAnimation(THREE, url) {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                return [
                    2,
                    _this.loadAsync(THREE, url)
                ];
            });
        })();
    };
    _proto.loadModel = function loadModel(THREE, url) {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var modelData;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            _this.loadAsync(THREE, url)
                        ];
                    case 1:
                        modelData = _state.sent();
                        if (modelData.isTexture) {
                            return [
                                2,
                                _this.makeRoundPlane(modelData)
                            ];
                        } else {
                            modelData.scene.position.set(0, 0, 0);
                            return [
                                2,
                                modelData.scene
                            ];
                        }
                        return [
                            2
                        ];
                }
            });
        })();
    };
    return AbstractAvatar;
}(Scene_component/* SceneComponent */.Ad);
/* harmony default export */ var component_AbstractAvatar = (AbstractAvatar);

;// CONCATENATED MODULE: ./_models/virtualStaging/avatar/component/Avatar.component.tsx
/* eslint-disable no-prototype-builtins */ 











var AvatarComponent = /*#__PURE__*/ function(AbstractAvatar) {
    "use strict";
    (0,_inherits/* default */.Z)(AvatarComponent, AbstractAvatar);
    var _super = (0,_create_super/* default */.Z)(AvatarComponent);
    function AvatarComponent() {
        (0,_class_call_check/* default */.Z)(this, AvatarComponent);
        var _this;
        _this = _super.apply(this, arguments);
        _this.animationActions = [];
        _this.activeAnimation = null;
        // instantly teleport avatar to position on first avatar_move event
        _this.avatarHasMoved = false;
        _this.setMorphTarget = function(mesh, key, value) {
            if (!mesh) return;
            var idx = mesh.morphTargetDictionary[key];
            if (!idx) return;
            mesh.morphTargetInfluences[idx] = value;
        };
        return _this;
    }
    var _proto = AvatarComponent.prototype;
    _proto.onInit = function onInit() {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var THREE, _tmp, _, ref, ref1;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _this.outputs.loadingState = VSObject/* LoadingState.Loading */.Gu.Loading;
                        THREE = _this.context.three;
                        _this.vec3 = new THREE.Vector3();
                        _this.initRoot();
                        _this.root.visible = false;
                        if (!_this.inputs.url || _this.inputs.url.includes(".png") || _this.inputs.url.includes(".jpg") || _this.inputs.url.includes(".jpeg")) _this.inputs.bodyType = "image";
                        if (!_this.inputs.url) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            _this.loadModel(THREE, _this.inputs.url)
                        ];
                    case 1:
                        _tmp = _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        _tmp = _this.makeAvatarImageRound(_this.inputs.label);
                        _state.label = 3;
                    case 3:
                        _this.model = _tmp;
                        _ = _this.inputs.bodyType;
                        switch(_){
                            case "fullbody":
                                return [
                                    3,
                                    4
                                ];
                            case "halfbody":
                                return [
                                    3,
                                    6
                                ];
                            case "image":
                                return [
                                    3,
                                    7
                                ];
                        }
                        return [
                            3,
                            8
                        ];
                    case 4:
                        ref = (0,_sliced_to_array/* default */.Z)(_this.model.children, 1), _this.avatarRoot = ref[0], ref;
                        _this.faceNode = findObject3DChildByName(_this.avatarRoot, "Wolf3D_Head");
                        _this.teethNode = findObject3DChildByName(_this.avatarRoot, "Wolf3D_Teeth");
                        _this.wolf3DAvatar = findObject3DChildByName(_this.avatarRoot, "Wolf3D_Avatar") || findObject3DChildByName(_this.avatarRoot, "Wolf3D_Body") || findObject3DChildByName(_this.avatarRoot, "Hips");
                        _this.mixer = new THREE.AnimationMixer(_this.wolf3DAvatar);
                        _this.root.parent.position.y = 0;
                        _this.pivot.rotation.set(-Math.PI / 2, 0, 0);
                        _this.model.scale.set(1.1, 1.1, 1.1);
                        return [
                            4,
                            _this.initAnimations()
                        ];
                    case 5:
                        _state.sent();
                        return [
                            3,
                            9
                        ];
                    case 6:
                        ref1 = (0,_sliced_to_array/* default */.Z)(_this.model.children, 1), _this.avatarRoot = ref1[0], ref1;
                        _this.faceNode = findObject3DChildByName(_this.avatarRoot, "Wolf3D_Head");
                        _this.teethNode = findObject3DChildByName(_this.avatarRoot, "Wolf3D_Teeth");
                        _this.wolf3DAvatar = findObject3DChildByName(_this.avatarRoot, "Wolf3D_Avatar");
                        _this.mixer = new THREE.AnimationMixer(_this.wolf3DAvatar);
                        return [
                            3,
                            9
                        ];
                    case 7:
                        _this.model.scale.setScalar(0.4);
                        _this.model.position.y = 1.1;
                        _this.pivot.position.y = -1.2;
                        return [
                            3,
                            9
                        ];
                    case 8:
                        return [
                            3,
                            9
                        ];
                    case 9:
                        _this.model.frustumCulled = false;
                        if (_this.model.children) _this.model.traverse(function(object) {
                            object.frustumCulled = false;
                        });
                        _this.pivot.add(_this.model);
                        _this.initLabel();
                        _this.outputs.loadingState = VSObject/* LoadingState.Loaded */.Gu.Loaded;
                        return [
                            2
                        ];
                }
            });
        })();
    };
    _proto.initAnimations = function initAnimations() {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var THREE, idleAnimation, walkingAnimation, idleAnimationAction, walkingAnimationAction;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        THREE = _this.context.three;
                        return [
                            4,
                            _this.loadAnimation(THREE, "../../images/Idle.fbx")
                        ];
                    case 1:
                        idleAnimation = _state.sent();
                        idleAnimation.animations[0].name = "idle";
                        return [
                            4,
                            _this.loadAnimation(THREE, "../../images/Walking.fbx")
                        ];
                    case 2:
                        walkingAnimation = _state.sent();
                        walkingAnimation.animations[0].name = "walking";
                        idleAnimationAction = _this.mixer.clipAction(idleAnimation.animations[0]);
                        walkingAnimationAction = _this.mixer.clipAction(walkingAnimation.animations[0]);
                        _this.animationActions.push(idleAnimationAction);
                        _this.animationActions.push(walkingAnimationAction);
                        console.log("Avatar: ".concat(_this.inputs.label, "\n Animations loaded, initializing 'idle' state..."), _this.animationActions, _this);
                        _this.fadeInAnimation("idle");
                        return [
                            2
                        ];
                }
            });
        })();
    };
    _proto.fadeInAnimation = function fadeInAnimation(clipName) {
        var animation = this.animationActions.find(function(action) {
            return action.getClip().name === clipName;
        });
        if (animation) {
            if (animation === this.activeAnimation) {
                return;
            }
            if (this.activeAnimation) this.activeAnimation.fadeOut(AVATAR_ANIMATION_BLENDING);
            console.log("Avatar: ".concat(this.inputs.label, "\n Animation ").concat(animation._clip.name, " start, last active animation is ").concat(this.activeAnimation ? this.activeAnimation._clip.name : "null"), animation);
            animation.reset().fadeIn(AVATAR_ANIMATION_BLENDING).play();
            this.activeAnimation = animation;
        }
    };
    _proto.moveToPos = function moveToPos(target, qt, onStart, onComplete) {
        var _this = this;
        var distance = this.root.parent.position.distanceTo(target);
        if (this.avatarHasMoved) {
            var tween = new tween_module_min/* TWEEN.Tween */.w.Tween(this.root.parent.position).to({
                x: target.x,
                y: target.y - 1.25,
                z: target.z
            }, distance / (AVATAR_WALKING_SPEED / 1000)).onStart(function() {
                _this.fadeInAnimation("walking");
                if (onStart) onStart(tween);
            }).onComplete(function() {
                _this.fadeInAnimation("idle");
                if (onComplete) onComplete(tween);
            }).onUpdate(function() {
                _this.root.quaternion.set(qt.x, qt.y, qt.z, qt.w);
            }).start();
        } else {
            this.root.parent.position.set(target.x, target.y - 1.25, target.z);
            this.root.visible = true;
            this.avatarHasMoved = true;
        }
    };
    _proto.rotateTo = function rotateTo(target, onStart, onComplete) {
        var _this = this;
        var alpha = {
            current: 0
        };
        var tween = new tween_module_min/* TWEEN.Tween */.w.Tween(alpha).to({
            current: 1
        }, 1000 * AVATAR_ROTATION_SPEED).onStart(function() {
            if (onStart) onStart(tween);
        }).onUpdate(function() {
            _this.root.quaternion.slerpQuaternions(_this.root.quaternion, target, alpha.current);
        }).onComplete(function() {
            if (onComplete) onComplete(tween);
        }).start();
    };
    _proto.onDestroy = function onDestroy() {
        if (this.label) {
            this.label.geometry.dispose();
            this.label.material.dispose();
        }
    };
    _proto.onTick = function onTick(tickDelta) {
        if (this.context.camera && this.inputs.bodyType === "image") {
            this.context.camera.getWorldPosition(this.vec3);
            var _vec3 = this.vec3, x = _vec3.x, z = _vec3.z;
            var vec = new this.context.three.Vector3();
            this.root.getWorldPosition(vec);
            this.root.lookAt(x, vec.y, z);
        }
        if (this.mixer) {
            this.mixer.update(tickDelta / 1000);
        }
    // super.onTick(tickDelta);
    };
    // called back when any inputs properties change
    _proto.onInputsUpdated = function onInputsUpdated() {
        if (this.outputs.loadingState !== VSObject/* LoadingState.Loading */.Gu.Loading) this.onInit();
    };
    _proto.updateFromResults = function updateFromResults(prediction) {
        if (!this.model) return;
        // this.updateMorphTargets(prediction.blendShapes);
        if (this.inputs.bodyType === "halfbody") {
            this.updateHeadRotation(-prediction.rotation.pitch, -prediction.rotation.yaw, -prediction.rotation.roll);
            this.updatePosition(prediction.transform.x, prediction.transform.y, prediction.transform.z);
        }
    };
    // @ts-ignore morph targets are not currently used
    _proto.updateMorphTargets = function updateMorphTargets(blendShapes) {
        for(var key in blendShapes){
            // RPM uses the ARKit key convention ("mouthSmileLeft" as opposed to "mouthSmile_L")
            var arKitKey = index_modern/* BlendShapeKeys.toARKitConvention */.lN.toARKitConvention(key);
            // Need to set all morphtargets for both meshes
            // ex. only setting jaw open for wolf3DAvatar will result in the mesh mouth opening but not the bones movingss1
            this.setMorphTarget(this.faceNode, arKitKey, blendShapes[key]);
            this.setMorphTarget(this.teethNode, arKitKey, blendShapes[key]);
            this.setMorphTarget(this.wolf3DAvatar, arKitKey, blendShapes[key]);
        }
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars,class-methods-use-this
    _proto.updateHeadRotation = function updateHeadRotation(pitch, yaw, roll) {
        // Inverse yaw & roll effects for yourself to give mirror effect
        this.pivot.rotation.set(pitch, yaw, roll);
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars,class-methods-use-this
    _proto.updatePosition = function updatePosition(x, y, z) {
    // const SCALE = 0.2;
    // const Y_OFFSET = 0;
    // this.avatarRoot?.position.set(x * SCALE, Y_OFFSET + y * SCALE, z);
    };
    return AvatarComponent;
}(component_AbstractAvatar);
var avatarComponentType = "mp.avatarComponent";
var makeAvatarComponent = function() {
    return new AvatarComponent();
};

;// CONCATENATED MODULE: ./_models/virtualStaging/avatar/index.ts





/***/ }),

/***/ 75293:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var SidebarHr = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("hr", {
        style: {
            border: "1px solid #ffffff29",
            width: "80%",
            margin: "auto"
        }
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SidebarHr);


/***/ }),

/***/ 96858:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Icon; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62097);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61225);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61953);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);





function Icon(param) {
    var icon = param.icon, _style = param.style, style = _style === void 0 ? "far" : _style, _size = param.size, size = _size === void 0 ? "medium" : _size, onClick = param.onClick, sx = param.sx;
    var theme = (0,_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    var isMobile = (0,_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(theme.breakpoints.down("sm"));
    // Logic for responsive icon font size. Will be finished later
    var fontSize = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        if (size === "large") {
            return isMobile ? "20px" : "30px";
        }
        if (size === "medium") {
            return isMobile ? "20px" : "20px";
        }
        return "15px";
    }, [
        size,
        isMobile
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        onClick: onClick,
        component: "i",
        className: "".concat(style, " ").concat(icon, " fa-fw"),
        sx: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, sx), {
            fontSize: "".concat(fontSize, " !important"),
            color: theme.palette.common.white
        })
    });
}


/***/ }),

/***/ 17937:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PathSelectModal */
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(29815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var store__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70989);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(18533);
/* harmony import */ var _helpers_base__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41154);



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  /* bottom: 0; */\n  /* width: 100%; */\n  z-index: 999;\n  background: rgba(0, 0, 0, 0.3);\n  backdrop-filter: blur(7.5px);\n  /* border-radius: 20px 20px 0px 0px; */\n  padding: 20px;\n  color: white;\n  font-size: 16px;\n  max-height: 90vh;\n  padding-top: 0;\n\n  width: 300px;\n  bottom: 200px;\n  right: 50px;\n  border-radius: 20px;\n\n  animation: 1s ease 0s 1 normal forwards running alert-toast-appear;\n\n  &.dsp-sbIsOpen {\n    right: 162px;\n  }\n\n  .psm-header {\n    display: flex;\n    justify-content: space-between;\n\n    align-items: center;\n    margin-bottom: 3px;\n  }\n  .psm-closeBlock {\n    width: 40px;\n    height: 40px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n  .psm-item {\n    display: flex;\n    justify-content: space-between;\n    margin-bottom: 13px;\n    background: rgba(0, 0, 0, 0.18);\n    border-radius: 15px;\n    padding: 6px 7px;\n  }\n  .psm-imgWrap {\n    width: 40px;\n    height: 40px;\n    border-radius: 9px;\n    background-position: center;\n    background-size: cover;\n    background-repeat: no-repeat;\n    margin-right: 7px;\n  }\n  .psm-name {\n    font-size: 14px;\n  }\n  .psm-next {\n    margin-right: 17px;\n    align-items: center;\n    display: flex;\n  }\n  .psm-steps {\n    font-size: 12px;\n  }\n  .psm-imgDeskWrap {\n    display: flex;\n  }\n  i {\n    font-size: 16px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var PathSelectModal = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "DesktopSwitchPath__PathSelectModal",
    componentId: "sc-2057725-0"
})(_templateObject());
var DesktopSwitchPath = function(props) {
    var pathLocks = props.pathLocks, pathLockId = props.pathLockId, currentPathStepId = props.currentPathStepId, gameId = props.gameId, handleChangePath = props.handleChangePath, finishedPaths = props.finishedPaths;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,store__WEBPACK_IMPORTED_MODULE_2__/* .useRecoilState */ .FV)(store__WEBPACK_IMPORTED_MODULE_2__/* .forceShowPathSwitchMobileModalState */ .g$), 2), forceShowPathSwitchMobileModal = ref[0], setForceShowPathSwitchMobileModal = ref[1];
    var translation = (0,store__WEBPACK_IMPORTED_MODULE_2__/* .useRecoilValue */ .sJ)(store__WEBPACK_IMPORTED_MODULE_2__/* .translationDataState */ .Jv);
    var sbIsOpen = (0,store__WEBPACK_IMPORTED_MODULE_2__/* .useRecoilValue */ .sJ)(store__WEBPACK_IMPORTED_MODULE_2__/* .sidebarOpenState */ .eo);
    var device = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .useTheme */ .Fg)().device;
    var pathSnapshot = _helpers_base__WEBPACK_IMPORTED_MODULE_3__/* .asyncStore */ .k6 === null || _helpers_base__WEBPACK_IMPORTED_MODULE_3__/* .asyncStore */ .k6 === void 0 ? void 0 : _helpers_base__WEBPACK_IMPORTED_MODULE_3__/* .asyncStore.pathSnapshot */ .k6.pathSnapshot;
    var handleCloseSwitchModal = function() {
        setForceShowPathSwitchMobileModal(false);
    };
    var onChangePath = function(path, currentStep, stepsLength) {
        return function() {
            var multiPaths = window.multiPaths;
            var data = [
                {
                    id: path.id,
                    name: path.name,
                    startTime: Date.now(),
                    currentStep: currentStep,
                    stepsLength: stepsLength
                }
            ];
            var existingPath = multiPaths === null || multiPaths === void 0 ? void 0 : multiPaths.find(function(multiPath) {
                return multiPath.id === path.id;
            });
            if (!existingPath) {
                if (multiPaths) {
                    data = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(data).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(multiPaths));
                }
                // @ts-ignore
                window.multiPaths = data;
            }
            setForceShowPathSwitchMobileModal(false);
            if (handleChangePath) handleChangePath({
                target: {
                    value: path.id
                }
            });
        };
    };
    return !(device === null || device === void 0 ? void 0 : device.mobile) && forceShowPathSwitchMobileModal && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(PathSelectModal, {
        className: sbIsOpen && "dsp-sbIsOpen",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                className: "psm-header",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        children: (translation === null || translation === void 0 ? void 0 : translation.multipathSwitcher) || "Multipath switcher"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: "psm-closeBlock",
                        onClick: handleCloseSwitchModal,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("i", {
                            className: "far fa-times"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: "psm-items-wrap",
                children: pathLocks === null || pathLocks === void 0 ? void 0 : pathLocks.map(function(p) {
                    var ref;
                    var isFinished = finishedPaths === null || finishedPaths === void 0 ? void 0 : finishedPaths.includes(p.id);
                    // use this if p.id = currentLock
                    var currentStep;
                    var stepsLength;
                    if (p.id === pathLockId) {
                        var ref1, ref2;
                        currentStep = ((ref1 = (_helpers_base__WEBPACK_IMPORTED_MODULE_3__/* .asyncStore */ .k6 === null || _helpers_base__WEBPACK_IMPORTED_MODULE_3__/* .asyncStore */ .k6 === void 0 ? void 0 : _helpers_base__WEBPACK_IMPORTED_MODULE_3__/* .asyncStore.pathIds */ .k6.pathIds) || []) === null || ref1 === void 0 ? void 0 : ref1.indexOf(currentPathStepId)) + 1;
                        stepsLength = _helpers_base__WEBPACK_IMPORTED_MODULE_3__/* .asyncStore */ .k6 === null || _helpers_base__WEBPACK_IMPORTED_MODULE_3__/* .asyncStore */ .k6 === void 0 ? void 0 : (ref2 = _helpers_base__WEBPACK_IMPORTED_MODULE_3__/* .asyncStore.pathIds */ .k6.pathIds) === null || ref2 === void 0 ? void 0 : ref2.length;
                    } else if (pathSnapshot[p.id]) {
                        var ref3, ref4, ref5, ref6, ref7, ref8;
                        currentStep = ((ref4 = ((ref3 = pathSnapshot[p.id]) === null || ref3 === void 0 ? void 0 : ref3.pathIds) || []) === null || ref4 === void 0 ? void 0 : ref4.indexOf((ref5 = pathSnapshot[p.id]) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.currentPathStep) === null || ref6 === void 0 ? void 0 : ref6.id)) + 1;
                        stepsLength = (ref7 = pathSnapshot[p.id]) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.pathIds) === null || ref8 === void 0 ? void 0 : ref8.length;
                    } else {
                        var ref9;
                        currentStep = 1;
                        stepsLength = p === null || p === void 0 ? void 0 : (ref9 = p.paths) === null || ref9 === void 0 ? void 0 : ref9.length;
                    }
                    // if not, we need to check is it exists on pathSnapshot
                    // if yes - get data from there
                    // if no - cound steps and set 0 / length
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: "psm-item",
                        onClick: isFinished ? undefined : onChangePath(p, currentStep, stepsLength),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                className: "psm-imgDeskWrap",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                        className: "psm-imgWrap",
                                        style: {
                                            backgroundImage: "url(".concat("".concat("https://cdn.treedis.com", "/games/").concat(gameId, "/locks/").concat(p.id, "/").concat((ref = p.pathSetting) === null || ref === void 0 ? void 0 : ref.icon), ")")
                                        }
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                        className: "psm-deskWrap",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                className: "psm-name",
                                                children: p.name
                                            }),
                                            isFinished ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                className: "psm-steps",
                                                children: translation.finished || "finished"
                                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                className: "psm-steps",
                                                children: [
                                                    currentStep,
                                                    "/",
                                                    stepsLength,
                                                    " ",
                                                    translation.stepsCompleted || "steps completed"
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                className: "psm-next",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("i", {
                                    className: "far fa-arrow-right"
                                })
                            })
                        ]
                    }, p === null || p === void 0 ? void 0 : p.id);
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (DesktopSwitchPath);


/***/ }),

/***/ 48517:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "JO": function() { return /* reexport */ Icon/* default */.Z; },
  "Ee": function() { return /* reexport */ Image; },
  "lE": function() { return /* reexport */ MapResponsive; },
  "h2": function() { return /* reexport */ ResponsiveContainer; }
});

// UNUSED EXPORTS: SidebarHr

// EXTERNAL MODULE: ./components-new/common/icon/Icon.tsx
var Icon = __webpack_require__(96858);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Box/Box.js + 1 modules
var Box = __webpack_require__(61953);
// EXTERNAL MODULE: ./utils/getRatio.ts
var getRatio = __webpack_require__(19245);
;// CONCATENATED MODULE: ./components-new/common/MapResponsive.tsx



function MapResponsive(param) {
    var ratio = param.ratio, address = param.address;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        component: "span",
        sx: {
            width: 1,
            lineHeight: 1,
            display: "block",
            overflow: "hidden",
            position: "relative",
            borderRadius: "5px",
            pt: (0,getRatio/* default */.Z)(ratio),
            "& .wrapper": {
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                lineHeight: 0,
                position: "absolute",
                backgroundSize: "cover !important"
            }
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            className: "wrapper",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                src: "https://www.google.com/maps/embed/v1/place?key=".concat("AIzaSyAxJYg1iR0WMy4vpFa3zB7E0Dx7lz8h5dk", "&q=").concat(address),
                style: {
                    width: "100%",
                    height: "100%"
                },
                loading: "lazy"
            })
        })
    });
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react-lazy-load-image-component/build/index.js
var build = __webpack_require__(72679);
;// CONCATENATED MODULE: ./components-new/common/Image.tsx






function Image(_param) {
    var ratio = _param.ratio, _disabledEffect = _param.disabledEffect, disabledEffect = _disabledEffect === void 0 ? false : _disabledEffect, _effect = _param.effect, effect = _effect === void 0 ? "blur" : _effect, objectFit = _param.objectFit, overComponent = _param.overComponent, sx = _param.sx, other = (0,_object_without_properties/* default */.Z)(_param, [
        "ratio",
        "disabledEffect",
        "effect",
        "objectFit",
        "overComponent",
        "sx"
    ]);
    var imageComponent = /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, (0,_object_spread/* default */.Z)({
        component: build.LazyLoadImage,
        wrapperClassName: "wrapper",
        effect: disabledEffect ? undefined : effect,
        placeholderSrc: "https://treedis-public.s3-accelerate.amazonaws.com/assets/image-placeholder.svg",
        sx: {
            width: 1,
            height: 1,
            objectFit: objectFit
        }
    }, other));
    if (ratio) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
            component: "span",
            sx: (0,_object_spread/* default */.Z)({
                width: 1,
                lineHeight: 1,
                display: "block",
                overflow: "hidden",
                position: "relative",
                pt: (0,getRatio/* default */.Z)(ratio),
                "& .wrapper": {
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    lineHeight: 0,
                    position: "absolute",
                    backgroundSize: "cover !important"
                }
            }, sx),
            children: [
                imageComponent,
                overComponent
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        component: "span",
        sx: (0,_object_spread/* default */.Z)({
            lineHeight: 0,
            display: "block",
            overflow: "hidden",
            "& .wrapper": {
                width: 1,
                height: 1,
                backgroundSize: "cover !important"
            }
        }, sx),
        children: imageComponent
    });
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
;// CONCATENATED MODULE: ./components-new/common/ResponsiveContainer.tsx






function ResponsiveContainer(_param) {
    var _ratio = _param.ratio, ratio = _ratio === void 0 ? "1/1" : _ratio, containerStyles = _param.containerStyles, children = _param.children, other = (0,_object_without_properties/* default */.Z)(_param, [
        "ratio",
        "containerStyles",
        "children"
    ]);
    return ratio === "cover" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        position: "relative",
        sx: {
            paddingTop: "100vh"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            sx: {
                position: "absolute",
                top: "43px",
                left: "-16px",
                width: "100vw",
                height: "calc(100vh - 59px)"
            },
            children: children
        })
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        component: "span",
        sx: (0,_object_spread/* default */.Z)({
            width: 1,
            lineHeight: 1,
            display: "block",
            overflow: "hidden",
            position: "relative",
            pt: (0,getRatio/* default */.Z)(ratio),
            "& .wrapper": {
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                lineHeight: 0,
                position: "absolute",
                backgroundSize: "cover !important"
            }
        }, containerStyles),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            className: "wrapper",
            sx: {
                width: 1,
                height: 1
            }
        }, other), {
            children: children
        }))
    });
}

// EXTERNAL MODULE: ./components-new/common/SidebarHr.tsx
var SidebarHr = __webpack_require__(75293);
;// CONCATENATED MODULE: ./components-new/index.ts








/***/ }),

/***/ 4550:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ BaseTour; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(82670);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 1 modules
var _create_super = __webpack_require__(71418);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Box/Box.js + 1 modules
var Box = __webpack_require__(61953);
// EXTERNAL MODULE: ./node_modules/@treedis/tour-loader/dist/index.js + 149 modules
var dist = __webpack_require__(83625);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Paper/Paper.js + 1 modules
var Paper = __webpack_require__(70918);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(29630);
// EXTERNAL MODULE: ./node_modules/html-react-parser/index.mjs
var html_react_parser = __webpack_require__(25935);
;// CONCATENATED MODULE: ./components-new/common/LegalNote.tsx



function LegalNote(param) {
    var note = param.note, clientLogoWidth = param.clientLogoWidth;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Paper/* default */.Z, {
        id: "legal-note",
        elevation: 3,
        sx: {
            position: "fixed",
            top: 0,
            left: clientLogoWidth ? clientLogoWidth + 20 : 0,
            zIndex: 99,
            margin: 0.5,
            padding: 1
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
            variant: "body2",
            color: "textSecondary",
            align: "center",
            sx: {
                color: "white"
            },
            children: (0,html_react_parser/* default */.ZP)(note)
        })
    });
}

// EXTERNAL MODULE: ./node_modules/lodash/cloneDeep.js
var cloneDeep = __webpack_require__(50361);
var cloneDeep_default = /*#__PURE__*/__webpack_require__.n(cloneDeep);
// EXTERNAL MODULE: ./node_modules/lodash/debounce.js
var debounce = __webpack_require__(23279);
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);
// EXTERNAL MODULE: ./node_modules/lodash/isEqual.js
var isEqual = __webpack_require__(18446);
var isEqual_default = /*#__PURE__*/__webpack_require__.n(isEqual);
// EXTERNAL MODULE: ./node_modules/lodash/sortBy.js
var sortBy = __webpack_require__(89734);
var sortBy_default = /*#__PURE__*/__webpack_require__.n(sortBy);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-toastify/dist/react-toastify.esm.js
var react_toastify_esm = __webpack_require__(72132);
// EXTERNAL MODULE: ./node_modules/three/examples/jsm/libs/tween.module.min.js
var tween_module_min = __webpack_require__(27970);
// EXTERNAL MODULE: ./node_modules/uuid/dist/esm-browser/v4.js + 4 modules
var v4 = __webpack_require__(25934);
// EXTERNAL MODULE: ./_models/Agent.tsx
var Agent = __webpack_require__(2828);
// EXTERNAL MODULE: ./_models/Game.tsx
var Game = __webpack_require__(81766);
// EXTERNAL MODULE: ./_models/game/GameBook.ts
var GameBook = __webpack_require__(97741);
// EXTERNAL MODULE: ./_models/Menu.tsx
var Menu = __webpack_require__(78073);
// EXTERNAL MODULE: ./_models/Tour.tsx + 1 modules
var Tour = __webpack_require__(40784);
// EXTERNAL MODULE: ./_models/virtualStaging/avatar/index.ts + 8 modules
var virtualStaging_avatar = __webpack_require__(49093);
;// CONCATENATED MODULE: ./_models/virtualStaging/FRFloor.tsx

var FRFloor = function FRFloor() {
    "use strict";
    var model = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    (0,_class_call_check/* default */.Z)(this, FRFloor);
    this.id = model.id || null;
    this.tourId = model.tourId;
    this.floor = model.floor;
    this.active = typeof model.active === "boolean" ? model.active : true;
    this.updatedAt = model.updatedAt;
    this.position = model.position;
    this.sweeps = model.sweeps || [];
};

;// CONCATENATED MODULE: ./_models/virtualStaging/helper.ts
var getAspectRatio = function(src) {
    return new Promise(function(resolve) {
        var img = document.createElement("img");
        img.src = src;
        img.onload = function() {
            img.style.visibility = "hidden";
            document.body.appendChild(img);
            resolve([
                img.clientWidth,
                img.clientHeight
            ]);
            document.body.removeChild(img);
        };
    });
};
/**
 * Calculate x and y in circle's circumference
 * @param {number} r - The circle's radius
 * @param {number} angle - The angle in degrees
 * @param {number} cx - The circle's origin x
 * @param {number} cz - The circle's origin z
 * @returns {Array[number,number]} The calculated x and y
 */ // eslint-disable-next-line class-methods-use-this
var pointsOnCircle2D = function(r, angle, cx, cz) {
    var a = angle * (Math.PI / 180); // convert from degrees to radians
    var x = cx + r * Math.cos(a);
    var z = cz + r * Math.sin(a);
    return [
        x,
        z
    ];
};


// EXTERNAL MODULE: ./_models/virtualStaging/LoadingQueue.ts + 1 modules
var LoadingQueue = __webpack_require__(44041);
// EXTERNAL MODULE: ./_models/virtualStaging/Polygon.tsx
var Polygon = __webpack_require__(59524);
// EXTERNAL MODULE: ./_models/virtualStaging/VideoRenderer.component.tsx
var VideoRenderer_component = __webpack_require__(23276);
// EXTERNAL MODULE: ./api/TreedisAdminDAO.ts
var TreedisAdminDAO = __webpack_require__(83680);
// EXTERNAL MODULE: ./_models/virtualStaging/VSObject.tsx
var VSObject = __webpack_require__(15864);
// EXTERNAL MODULE: ./_models/virtualStaging/VSSettings.tsx
var VSSettings = __webpack_require__(20594);
// EXTERNAL MODULE: ./components/common/CookieConsent.tsx
var CookieConsent = __webpack_require__(72789);
;// CONCATENATED MODULE: ./components/util/sdk/mattertag/data.ts



/**
 * Merge tags from matterport and treedis
 * @param matterTags
 * @param treedisTags
 * @param threads
 * @param iotDevicesWithTags
 */ var getAllTags = function(matterTags, treedisTags, threads, iotDevicesWithTags) {
    var allTags = new Map();
    var matterTagsArray = [];
    matterTags.forEach(function(t) {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
        var index = treedisTags.findLastIndex(function(item) {
            return t.sid === (item === null || item === void 0 ? void 0 : item.sid);
        });
        var found = index === -1 ? null : treedisTags[index];
        var media;
        if (t.media) {
            media = t.media;
        }
        var tag = Object.assign(cloneDeep_default()(found) || {}, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            title: found && found.title && found.title.length ? found.title : t.label,
            positionX: (found === null || found === void 0 ? void 0 : found.positionX) ? found.positionX : t === null || t === void 0 ? void 0 : (ref = t.position) === null || ref === void 0 ? void 0 : ref.x,
            positionY: (found === null || found === void 0 ? void 0 : found.positionY) ? found.positionY : t === null || t === void 0 ? void 0 : (ref1 = t.position) === null || ref1 === void 0 ? void 0 : ref1.y,
            positionZ: (found === null || found === void 0 ? void 0 : found.positionZ) ? found.positionZ : t === null || t === void 0 ? void 0 : (ref2 = t.position) === null || ref2 === void 0 ? void 0 : ref2.z,
            stemVectorX: (found === null || found === void 0 ? void 0 : found.stemVectorX) && (found === null || found === void 0 ? void 0 : found.svXEnabled) ? found.stemVectorX : (t === null || t === void 0 ? void 0 : (ref3 = t.stem) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.direction) === null || ref4 === void 0 ? void 0 : ref4.x) || 0,
            stemVectorY: (found === null || found === void 0 ? void 0 : found.stemVectorY) && (found === null || found === void 0 ? void 0 : found.svYEnabled) ? found.stemVectorY : (t === null || t === void 0 ? void 0 : (ref5 = t.stem) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.direction) === null || ref6 === void 0 ? void 0 : ref6.y) || 0.3,
            stemVectorZ: (found === null || found === void 0 ? void 0 : found.stemVectorZ) && (found === null || found === void 0 ? void 0 : found.svZEnabled) ? found.stemVectorZ : (t === null || t === void 0 ? void 0 : (ref7 = t.stem) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.direction) === null || ref8 === void 0 ? void 0 : ref8.z) || 0,
            iconColor: found ? found.iconColor : t.color,
            opacity: found ? found.opacity : 100,
            mpTitle: found ? found.mpTitle : true,
            tooltip: found ? found.tooltip : true,
            mpNavigation: found ? found.mpNavigation : true,
            whiteCircle: found ? found.whiteCircle : false,
            transparentBackground: found ? found.transparentBackground : false,
            id: (found === null || found === void 0 ? void 0 : found.id) || t.sid || t.defaultSid
        }, t), {
            media: media,
            description: (found === null || found === void 0 ? void 0 : (ref9 = found.description) === null || ref9 === void 0 ? void 0 : ref9.length) ? found.description : t.description,
            customIcon: found ? found.customIcon : false
        }));
        if (found) {
            tag.modifiedTag = true; // flag that tag has been modified through treedis
        } else {
            matterTagsArray.push(tag);
        }
        treedisTags[index] = tag;
    });
    treedisTags.concat(matterTagsArray).forEach(function(tag) {
        var foundTagsWithDevice = iotDevicesWithTags === null || iotDevicesWithTags === void 0 ? void 0 : iotDevicesWithTags.filter(// eslint-disable-next-line eqeqeq
        function(item) {
            return item.relatedAssets.find(function(asset) {
                return asset.id == tag.sid;
            }) || item.relatedAssets.find(function(asset) {
                return asset.id == tag.defaultSid;
            });
        });
        tag.iotDevices = foundTagsWithDevice;
        allTags.set(tag.sid, cloneDeep_default()(tag));
    });
    threads.forEach(function(thread) {
        var ref, ref1, ref2, ref3, ref4, ref5;
        var media;
        if (thread.media) {
            media = thread.media;
        }
        var tag = Object.assign(cloneDeep_default()(thread) || {}, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            title: thread.title,
            positionX: thread === null || thread === void 0 ? void 0 : thread.positionX,
            positionY: thread === null || thread === void 0 ? void 0 : thread.positionY,
            positionZ: thread === null || thread === void 0 ? void 0 : thread.positionZ,
            stemVectorX: (thread === null || thread === void 0 ? void 0 : thread.stemVectorX) && (thread === null || thread === void 0 ? void 0 : thread.svXEnabled) ? thread.stemVectorX : (thread === null || thread === void 0 ? void 0 : (ref = thread.stem) === null || ref === void 0 ? void 0 : (ref1 = ref.direction) === null || ref1 === void 0 ? void 0 : ref1.x) || 0,
            stemVectorY: (thread === null || thread === void 0 ? void 0 : thread.stemVectorY) && (thread === null || thread === void 0 ? void 0 : thread.svYEnabled) ? thread.stemVectorY : (thread === null || thread === void 0 ? void 0 : (ref2 = thread.stem) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.direction) === null || ref3 === void 0 ? void 0 : ref3.y) || 0.3,
            stemVectorZ: (thread === null || thread === void 0 ? void 0 : thread.stemVectorZ) && (thread === null || thread === void 0 ? void 0 : thread.svZEnabled) ? thread.stemVectorZ : (thread === null || thread === void 0 ? void 0 : (ref4 = thread.stem) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.direction) === null || ref5 === void 0 ? void 0 : ref5.z) || 0,
            mpTitle: thread.mpTitle,
            tooltip: thread.tooltip,
            mpNavigation: true,
            whiteCircle: true,
            transparentBackground: false,
            id: thread.id
        }, thread), {
            media: media,
            description: thread.description,
            custom: true,
            customIcon: "thread",
            stemVisible: true,
            isThread: true
        }));
        allTags.set(thread.sid, cloneDeep_default()(tag));
    });
    return allTags;
};

;// CONCATENATED MODULE: ./components/util/sdk/tag/TagManager.ts






var TagManager = function TagManager(mpSdk) {
    "use strict";
    var _this = this;
    (0,_class_call_check/* default */.Z)(this, TagManager);
    this.tagAttachments = [];
    this.matterTags = new Map();
    this.init = function() {
        _this.mpSdk.Tag.attachments.subscribe({
            onCollectionUpdated: function(collection) {
                _this.tagAttachments = Object.values(collection);
            }
        });
    };
    this.subscribe = function(param, subscriber) {
        var mpTags = param.mpTags, treedisTags = param.treedisTags, threads = param.threads, iotDevicesWithTags = param.iotDevicesWithTags;
        if (!mpTags) return subscriber(new Map());
        Object.keys(mpTags).forEach(function(idx) {
            _this.matterTags.set(idx, mpTags[idx]);
        });
        var matterportTags = Object.values(mpTags);
        var allTags = getAllTags(matterportTags, treedisTags, threads, iotDevicesWithTags);
        subscriber(allTags);
    };
    this.hasAttachment = function(name) {
        var matched = false;
        if (name) {
            matched = !!_this.tagAttachments.find(function(item) {
                return item.src.includes(name);
            });
        }
        return matched;
    };
    this.getAttachment = function(name) {
        var matched;
        if (name) {
            matched = _this.tagAttachments.find(function(item) {
                return item.src.includes(name);
            });
        }
        return matched;
    };
    var _this1 = this;
    this.addAttachment = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(attachment, tagSid) {
            var originName, url, attachmentIds, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        originName = attachment.originName, url = attachment.url;
                        if (_this1.hasAttachment(originName)) {
                            return [
                                2,
                                Promise.resolve()
                            ];
                        }
                        return [
                            4,
                            _this1.mpSdk.Tag.registerAttachment(url).catch(Promise.reject)
                        ];
                    case 1:
                        attachmentIds = _state.sent();
                        if (!attachmentIds.length) {
                            return [
                                2,
                                Promise.resolve()
                            ];
                        }
                        return [
                            2,
                            _this1.mpSdk.Tag.attach(tagSid, attachmentIds[0])
                        ];
                    case 2:
                        error = _state.sent();
                        return [
                            2,
                            Promise.reject(error)
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function(attachment, tagSid) {
            return _ref.apply(this, arguments);
        };
    }();
    var _this2 = this;
    this.addAttachments = /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var attachments, tagSid, _Tag, _Tag1, urls, attachmentIds, error;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    attachments = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : [], tagSid = _arguments.length > 1 ? _arguments[1] : void 0;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    urls = attachments.reduce(function(acc, attachment) {
                        if (!_this2.hasAttachment(attachment.originName)) {
                            acc.push(attachment.url);
                        }
                        return acc;
                    }, []);
                    if (!urls.length) {
                        return [
                            2,
                            Promise.resolve()
                        ];
                    }
                    return [
                        4,
                        (_Tag = _this2.mpSdk.Tag).registerAttachment.apply(_Tag, (0,_to_consumable_array/* default */.Z)(urls))
                    ];
                case 2:
                    attachmentIds = _state.sent();
                    if (!attachmentIds.length) {
                        return [
                            2,
                            Promise.resolve()
                        ];
                    }
                    return [
                        2,
                        (_Tag1 = _this2.mpSdk.Tag).attach.apply(_Tag1, [
                            tagSid
                        ].concat((0,_to_consumable_array/* default */.Z)(attachmentIds)))
                    ];
                case 3:
                    error = _state.sent();
                    return [
                        2,
                        Promise.reject(error)
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    var _this3 = this;
    this.replaceAttachment = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(attachment, newUrl, tagSid) {
            var originName, tagAttachment, ref, attachmentId, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        originName = attachment.originName;
                        tagAttachment = _this3.getAttachment(originName);
                        if (!tagAttachment) {
                            _this3.mpSdk.Tag.detach(tagSid, tagAttachment.id).catch(Promise.reject);
                        }
                        return [
                            4,
                            _this3.mpSdk.Tag.registerAttachment(newUrl).catch(Promise.reject)
                        ];
                    case 1:
                        ref = _sliced_to_array/* default.apply */.Z.apply(void 0, [
                            _state.sent(),
                            1
                        ]), attachmentId = ref[0];
                        return [
                            2,
                            _this3.mpSdk.Tag.attach(tagSid, attachmentId)
                        ];
                    case 2:
                        error = _state.sent();
                        return [
                            2,
                            Promise.reject(error)
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function(attachment, newUrl, tagSid) {
            return _ref.apply(this, arguments);
        };
    }();
    this.getMatterTags = function() {
        return _this.matterTags;
    };
    this.getAttachments = function() {
        return _this.tagAttachments;
    };
    this.mpSdk = mpSdk;
    this.init();
};

;// CONCATENATED MODULE: ./components/util/sdk/tag/index.ts


// EXTERNAL MODULE: ./utils/file.ts
var file = __webpack_require__(94697);
// EXTERNAL MODULE: ./api/TreedisPublicDAO.ts
var TreedisPublicDAO = __webpack_require__(80250);
// EXTERNAL MODULE: ./utils/index.ts + 6 modules
var utils = __webpack_require__(65290);
// EXTERNAL MODULE: ./components/util/all.ts
var util_all = __webpack_require__(40488);
// EXTERNAL MODULE: ./components/util/analytic.ts
var analytic = __webpack_require__(83784);
// EXTERNAL MODULE: ./components/util/index.ts + 7 modules
var util = __webpack_require__(97666);
// EXTERNAL MODULE: ./components/util/deviceManager.ts
var deviceManager = __webpack_require__(99080);
// EXTERNAL MODULE: ./components/util/popups.ts
var popups = __webpack_require__(62818);
// EXTERNAL MODULE: ./components/util/sdk.ts + 2 modules
var sdk = __webpack_require__(68687);
// EXTERNAL MODULE: ./components/util/navigation.ts
var navigation = __webpack_require__(64915);
// EXTERNAL MODULE: ./_models/virtualStaging/Scene.component.tsx
var Scene_component = __webpack_require__(98472);
;// CONCATENATED MODULE: ./_models/virtualStaging/BIM/utils.ts

var createMenuItem = function(data) {
    return {
        id: data.id,
        url: data.itemId,
        mobileUrl: null,
        title: data.name,
        type: Menu/* MenuType.BIMItem */.o.BIMItem,
        icon: null,
        order: 0,
        panoramaId: null,
        tag: null,
        changeMinimap: true,
        changePanorama: false,
        labelId: null,
        floorId: null,
        itemId: data.itemId,
        iframeSettings: {
            desktop: {
                sizeType: "",
                width: "",
                height: ""
            },
            mobile: {
                sizeType: "",
                width: "",
                height: ""
            }
        },
        shouldHighlight: false,
        changeReel: false,
        createdAt: "2024-06-10T07:34:23.754Z",
        updatedAt: "2024-06-10T07:34:23.754Z",
        tourId: 5872,
        subMenus: []
    };
};

;// CONCATENATED MODULE: ./_models/virtualStaging/BIM/AnimatedPipe.ts




var AnimatedPipe = /*#__PURE__*/ function() {
    "use strict";
    function AnimatedPipe(obj3D, inputs, context) {
        (0,_class_call_check/* default */.Z)(this, AnimatedPipe);
        this.inputs = {
            opacityDefault: 0,
            textureRotation: Math.PI / 2,
            textureRepeat: {
                x: 1,
                y: 4
            },
            textureOffset: {
                x: 0,
                y: 0
            }
        };
        this.obj3D = obj3D.clone();
        obj3D.parent.add(this.obj3D);
        this.inputs = (0,_object_spread/* default */.Z)({}, this.inputs, inputs);
        this.context = context;
        this.arrowMaterial = this.initAnimatedMaterial();
        this.obj3D.material = this.arrowMaterial;
    }
    var _proto = AnimatedPipe.prototype;
    _proto.initAnimatedMaterial = function initAnimatedMaterial() {
        var THREE = this.context.three;
        var arrowTexture = AnimatedPipe.arrowTexture.clone();
        arrowTexture.rotation = this.inputs.textureRotation;
        arrowTexture.wrapS = THREE.RepeatWrapping;
        arrowTexture.wrapT = THREE.RepeatWrapping;
        arrowTexture.repeat.set(this.inputs.textureRepeat.x, this.inputs.textureRepeat.y);
        arrowTexture.offset.set(this.inputs.textureOffset.x, this.inputs.textureOffset.y);
        arrowTexture.needsUpdate = true;
        return new THREE.MeshBasicMaterial({
            map: arrowTexture,
            transparent: true,
            opacity: this.inputs.opacityDefault,
            depthTest: false,
            depthWrite: false,
            side: THREE.FrontSide
        });
    };
    AnimatedPipe.preloadTextures = function preloadTextures(loader) {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            loader.load("/images/Arrow-Right.png")
                        ];
                    case 1:
                        _this.arrowTexture = _state.sent();
                        return [
                            2
                        ];
                }
            });
        })();
    };
    return AnimatedPipe;
}();

// EXTERNAL MODULE: ./_models/virtualStaging/BIM/component/data.ts
var data = __webpack_require__(36834);
;// CONCATENATED MODULE: ./_models/virtualStaging/BIM/component/BIM.component.ts













var BIMComponent = /*#__PURE__*/ function(SceneComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(BIMComponent, SceneComponent);
    var _super = (0,_create_super/* default */.Z)(BIMComponent);
    function BIMComponent() {
        (0,_class_call_check/* default */.Z)(this, BIMComponent);
        var _this;
        _this = _super.apply(this, arguments);
        _this.root = null;
        _this.pivot = null;
        _this.itemsMap = new Map();
        _this.BMListItems = [];
        _this.animatedPipes = new Map();
        _this.inputs = {
            url: "../../BIM.fbx",
            position: {
                x: 0,
                y: 0,
                z: 0
            },
            rotation: {
                x: 0,
                y: 0,
                z: 0
            },
            scale: {
                x: 1,
                y: 1,
                z: 1
            },
            visible: true,
            colorDefault: "grey",
            colorHover: "red",
            colorClick: "red",
            opacityDefault: 0,
            opacityHover: 0.5,
            opacityClick: 0.5
        };
        _this.outputs = {
            loadingState: VSObject/* LoadingState.Idle */.Gu.Idle
        };
        var _obj;
        _this.events = (_obj = {}, (0,_define_property/* default */.Z)(_obj, Scene_component/* ComponentInteractionType.CLICK */.td.CLICK, true), (0,_define_property/* default */.Z)(_obj, Scene_component/* ComponentInteractionType.HOVER */.td.HOVER, true), (0,_define_property/* default */.Z)(_obj, Scene_component/* ComponentInteractionType.DRAG */.td.DRAG, false), _obj);
        var _this1 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.loadAsync = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(url) {
                var THREE;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    THREE = _this1.context.three;
                    if (url.includes(".gltf") || url.includes(".glb")) return [
                        2,
                        new Promise(function(resolve, reject) {
                            var loader = new THREE.GLTFLoader();
                            loader.load(url, function(gltf) {
                                return resolve(gltf);
                            }, function() {
                                return null;
                            }, function(err) {
                                return reject(err);
                            });
                        })
                    ];
                    if (url.includes(".fbx")) return [
                        2,
                        new Promise(function(resolve, reject) {
                            var loader = new THREE.FBXLoader();
                            loader.load(url, function(model) {
                                return resolve(model);
                            }, function() {
                                return null;
                            }, function(err) {
                                return reject(err);
                            });
                        })
                    ];
                    if (url.includes(".png") || url.includes(".jpg") || url.includes("base64")) return [
                        2,
                        new Promise(function(resolve, reject) {
                            var loader = new THREE.TextureLoader();
                            loader.load(url, function(texture) {
                                return resolve(texture);
                            }, function() {
                                return null;
                            }, function(err) {
                                return reject(err);
                            });
                        })
                    ];
                    return [
                        2
                    ];
                });
            });
            return function(url) {
                return _ref.apply(this, arguments);
            };
        }();
        return _this;
    }
    var _proto = BIMComponent.prototype;
    _proto.onInit = function onInit() {
        var THREE = this.context.three;
        this.root = new THREE.Object3D();
        this.root.position.set(this.inputs.position.x, this.inputs.position.y, this.inputs.position.z);
        this.root.visible = this.inputs.visible;
        this.root.scale.set(this.inputs.scale.x, this.inputs.scale.y, this.inputs.scale.z);
        this.pivot = new THREE.Object3D();
        this.root.add(this.pivot);
        this.root.rotation.set(this.inputs.rotation.x, this.inputs.rotation.y, this.inputs.rotation.z);
        this.outputs.objectRoot = this.root;
        this.outputs.collider = this.root;
        this.outputs.loadingState = VSObject/* LoadingState.Loading */.Gu.Loading;
        var textureLoader = new THREE.TextureLoader();
        var _this = this;
        this.initModel().then(function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(model) {
                var floors;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                AnimatedPipe.preloadTextures(textureLoader)
                            ];
                        case 1:
                            _state.sent();
                            floors = [];
                            model.traverse(function(obj) {
                                // if (obj.type !== 'Group') obj.visible = false;
                                if (obj.name.startsWith("Floor")) floors.push(obj);
                                if (obj.isMesh && obj.material) {
                                    _this.fixMaterial(obj);
                                }
                                if (obj.isMesh) {
                                    obj.visible = true;
                                    _this.itemsMap.set(obj.id, obj);
                                }
                                if (obj.name === "Pipe_Types_Standard_2302961") {
                                    _this.animatedPipes.set(obj.id, new AnimatedPipe(obj, {
                                        textureRotation: -Math.PI / 2,
                                        offsetSpeedX: 0.0003,
                                        offsetSpeedY: 0
                                    }, _this.context));
                                }
                                if (obj.name === "Pipe_Types_Standard_2302977") {
                                    _this.animatedPipes.set(obj.id, new AnimatedPipe(obj, {
                                        textureRotation: Math.PI / 2,
                                        offsetSpeedX: 0.0003,
                                        offsetSpeedY: 0
                                    }, _this.context));
                                }
                                if (obj.name === "Pipe_Types_Standard_2177850") {
                                    _this.animatedPipes.set(obj.id, new AnimatedPipe(obj, {
                                        textureRotation: Math.PI / 2,
                                        offsetSpeedX: 0.0003,
                                        offsetSpeedY: 0
                                    }, _this.context));
                                }
                                if (obj.name === "Pipe_Types_Standard_2177264") {
                                    _this.animatedPipes.set(obj.id, new AnimatedPipe(obj, {
                                        textureRotation: Math.PI / 2,
                                        offsetSpeedX: 0.0003,
                                        offsetSpeedY: 0,
                                        textureRepeat: {
                                            x: 1,
                                            y: 3
                                        }
                                    }, _this.context));
                                }
                                if (obj.name === "Pipe_Types_Standard_2024792") {
                                    _this.animatedPipes.set(obj.id, new AnimatedPipe(obj, {
                                        textureRotation: Math.PI / 2,
                                        offsetSpeedX: 0.0003,
                                        offsetSpeedY: 0,
                                        textureRepeat: {
                                            x: 1,
                                            y: 3
                                        }
                                    }, _this.context));
                                }
                                if (obj.name === "Pipe_Types_Standard_2024670") {
                                    _this.animatedPipes.set(obj.id, new AnimatedPipe(obj, {
                                        textureRotation: -Math.PI / 2,
                                        offsetSpeedX: 0.0003,
                                        offsetSpeedY: 0,
                                        textureRepeat: {
                                            x: 1,
                                            y: 4
                                        }
                                    }, _this.context));
                                }
                                if (obj.name === "Pipe_Types_Standard_2202212") {
                                    _this.animatedPipes.set(obj.id, new AnimatedPipe(obj, {
                                        textureRotation: -Math.PI / 2,
                                        offsetSpeedX: 0.0003,
                                        offsetSpeedY: 0,
                                        textureRepeat: {
                                            x: 1,
                                            y: 4
                                        }
                                    }, _this.context));
                                }
                            });
                            floors.forEach(function(floor) {
                                floor.parent.remove(floor);
                            });
                            _this.itemsMap.forEach(function(pipe, index) {
                                var item = createMenuItem({
                                    id: index,
                                    name: pipe.name,
                                    itemId: pipe.id
                                });
                                _this.BMListItems.push(item);
                            });
                            _this.outputs.loadingState = VSObject/* LoadingState.Loaded */.Gu.Loaded;
                            return [
                                2
                            ];
                    }
                });
            });
            return function(model) {
                return _ref.apply(this, arguments);
            };
        }());
    };
    _proto.initModel = function initModel() {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var url, model;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        url = _this.inputs.url;
                        return [
                            4,
                            _this.loadAsync(url)
                        ];
                    case 1:
                        model = _state.sent();
                        model.rotation.z = -Math.PI / 2;
                        model.rotation.x = -Math.PI / 2;
                        _this.root.add(model);
                        return [
                            2,
                            model
                        ];
                }
            });
        })();
    };
    _proto.getItem = function getItem(id) {
        return this.itemsMap.get(id);
    };
    _proto.setItemColor = function setItemColor(id, color) {
        this.itemsMap.get(id).material.color.set(color);
    };
    _proto.setItemOpacity = function setItemOpacity(id, opacity) {
        this.itemsMap.get(id).material.opacity = opacity;
    };
    _proto.setAnimatedPipeOpacity = function setAnimatedPipeOpacity(id, opacity) {
        var animatedPipe = this.animatedPipes.get(id);
        if (!animatedPipe) return;
        animatedPipe.obj3D.material.opacity = opacity;
    };
    _proto.getSegmentsOfPipe = function getSegmentsOfPipe(segmentName) {
        var pipe = data/* segmentToPipeMap.get */.O.get(segmentName);
        if (!pipe) return [];
        return (0,_to_consumable_array/* default */.Z)(pipe.segments.map(function(s) {
            return s.name;
        })).concat((0,_to_consumable_array/* default */.Z)(pipe.animatedSegments.map(function(s) {
            return s.name;
        })));
    };
    _proto.getSegmentIdByName = function getSegmentIdByName(name) {
        var segmentId = null;
        this.itemsMap.forEach(function(segment, id) {
            if (segment.name === name) {
                segmentId = id;
            }
        });
        return segmentId;
    };
    _proto.fixMaterial = function fixMaterial(mesh) {
        var THREE = this.context.three;
        mesh.material.dispose();
        mesh.material = new THREE.MeshBasicMaterial({
            color: this.inputs.colorDefault,
            transparent: true,
            opacity: this.inputs.opacityDefault,
            depthTest: false,
            depthWrite: false
        });
    };
    _proto.onTick = function onTick(tickDelta) {
        this.animatedPipes.forEach(function(pipe) {
            var arrowSpeedX = pipe.inputs.offsetSpeedX;
            var arrowSpeedY = pipe.inputs.offsetSpeedY;
            var arrowOffset = pipe.arrowMaterial.map.offset;
            arrowOffset.x -= arrowSpeedX * tickDelta;
            arrowOffset.y -= arrowSpeedY * tickDelta;
            pipe.arrowMaterial.map.offset = arrowOffset;
        });
    };
    return BIMComponent;
}(Scene_component/* SceneComponent */.Ad);
var BIMComponentType = "mp.BIMComponent";
var makeBIMComponent = function() {
    return new BIMComponent();
};

;// CONCATENATED MODULE: ./_models/virtualStaging/Tube/component/Tube.component.ts








var TubeComponent = /*#__PURE__*/ function(SceneComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(TubeComponent, SceneComponent);
    var _super = (0,_create_super/* default */.Z)(TubeComponent);
    function TubeComponent() {
        (0,_class_call_check/* default */.Z)(this, TubeComponent);
        var _this;
        _this = _super.apply(this, arguments);
        _this.root = null;
        _this.pivot = null;
        _this.isDestroyed = false;
        _this.arrowMaterial = null;
        _this.innerTubeMaterial = null;
        _this.renderer = null;
        _this.inputs = {
            position: {
                x: 0,
                y: 0,
                z: 0
            },
            rotation: {
                x: 0,
                y: 0,
                z: 0
            },
            visible: true,
            opacity: 0.35,
            color: "red",
            hasTexture: true,
            textureRepeat: {
                x: 7,
                y: 4
            },
            textureOffset: {
                x: 0,
                y: 0
            },
            length: 10,
            width: 1,
            scale: 1,
            arrowSpeed: 0.004,
            linkedPolygon: null,
            interval: 0,
            delay: 0
        };
        _this.outputs = {
            loadingState: VSObject/* LoadingState.Idle */.Gu.Idle
        };
        var _obj;
        _this.events = (_obj = {}, (0,_define_property/* default */.Z)(_obj, Scene_component/* ComponentInteractionType.CLICK */.td.CLICK, false), (0,_define_property/* default */.Z)(_obj, Scene_component/* ComponentInteractionType.HOVER */.td.HOVER, false), (0,_define_property/* default */.Z)(_obj, Scene_component/* ComponentInteractionType.DRAG */.td.DRAG, false), _obj);
        return _this;
    }
    var _proto = TubeComponent.prototype;
    _proto.onInit = function onInit() {
        var THREE = this.context.three;
        this.root = new THREE.Object3D();
        this.root.position.set(this.inputs.position.x, this.inputs.position.y, this.inputs.position.z);
        this.root.visible = this.inputs.visible;
        this.root.scale.set(this.inputs.scale, this.inputs.scale, this.inputs.scale);
        this.pivot = new THREE.Object3D();
        this.root.add(this.pivot);
        this.pivot.rotation.set(this.inputs.rotation.x, this.inputs.rotation.y, this.inputs.rotation.z);
        this.outputs.objectRoot = this.root;
        this.outputs.collider = this.root;
        this.createPipe();
        this.outputs.loadingState = VSObject/* LoadingState.Loading */.Gu.Loading;
    };
    _proto.createPipe = function createPipe() {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var THREE, path, tubeGeometry, textureLoader, arrowTexture, outerTubeMesh, innerTubeMesh;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        THREE = _this.context.three;
                        path = new THREE.CatmullRomCurve3([
                            new THREE.Vector3(0, 0, 0),
                            new THREE.Vector3(0, 0, _this.inputs.length)
                        ]);
                        tubeGeometry = new THREE.TubeGeometry(path, 1, _this.inputs.width, 24, false);
                        _this.innerTubeMaterial = new THREE.MeshBasicMaterial({
                            transparent: true,
                            opacity: _this.inputs.opacity,
                            color: _this.inputs.color
                        });
                        if (!_this.inputs.hasTexture) return [
                            3,
                            2
                        ];
                        textureLoader = new THREE.TextureLoader();
                        return [
                            4,
                            textureLoader.load("/images/Arrow-Right.png")
                        ];
                    case 1:
                        arrowTexture = _state.sent();
                        arrowTexture.wrapS = THREE.RepeatWrapping;
                        arrowTexture.wrapT = THREE.RepeatWrapping;
                        arrowTexture.repeat.set(_this.inputs.textureRepeat.x, _this.inputs.textureRepeat.y);
                        arrowTexture.offset.set(_this.inputs.textureOffset.x, _this.inputs.textureOffset.y);
                        _this.arrowMaterial = new THREE.MeshBasicMaterial({
                            map: arrowTexture,
                            transparent: true,
                            opacity: 1,
                            depthWrite: false,
                            side: THREE.FrontSide
                        });
                        outerTubeMesh = new THREE.Mesh(tubeGeometry, _this.arrowMaterial);
                        outerTubeMesh.scale.set(1.05, 1.05, 1);
                        outerTubeMesh.renderOrder += 1;
                        _this.pivot.add(outerTubeMesh);
                        _state.label = 2;
                    case 2:
                        innerTubeMesh = new THREE.Mesh(tubeGeometry, _this.innerTubeMaterial);
                        _this.pivot.add(innerTubeMesh);
                        return [
                            2
                        ];
                }
            });
        })();
    };
    _proto.setVisible = function setVisible(visible) {
        this.inputs.visible = visible;
    };
    _proto.onInputsUpdated = function onInputsUpdated(previousInputs) {
        this.root.visible = this.inputs.visible;
        if (previousInputs.color !== this.inputs.color && this.innerTubeMaterial) {
            this.innerTubeMaterial.color.set(this.inputs.color);
            this.innerTubeMaterial.needsUpdate = true;
        }
    };
    _proto.onTick = function onTick() {
        var ref, ref1;
        if (this.arrowMaterial && !((ref = this.renderer) === null || ref === void 0 ? void 0 : (ref1 = ref.xr) === null || ref1 === void 0 ? void 0 : ref1.isPresenting)) {
            var arrowSpeed = this.inputs.arrowSpeed;
            var arrowOffset = this.arrowMaterial.map.offset;
            arrowOffset.x -= arrowSpeed;
            this.arrowMaterial.map.offset = arrowOffset;
        }
    };
    _proto.onDestroy = function onDestroy() {};
    return TubeComponent;
}(Scene_component/* SceneComponent */.Ad);
var tubeComponentType = "mp.tubeComponent";
var makeTubeComponent = function() {
    return new TubeComponent();
};

;// CONCATENATED MODULE: ./_models/virtualStaging/Tube/constants.ts
var PIPES_CONSTANTS = {
    POLYGONS: [
        "Pipe-Polygon1",
        "Pipe-Polygon2",
        "Pipe-Polygon3",
        "Pipe-Polygon4",
        "Pipe-Polygon5",
        "Pipe-Polygon6",
        "Pipe-Polygon7"
    ]
};
var PIPES_CONSTANTS_AMERICAN_WATER = {
    POLYGONS: [
        "Pipe-Polygon1",
        "Pipe-Polygon2",
        "Pipe-Polygon3"
    ]
};

;// CONCATENATED MODULE: ./utils/getRandomRange.ts
var getRandomRange = function() {
    var min = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, max = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
    return Math.random() * (max - min) + min;
};

;// CONCATENATED MODULE: ./_models/virtualStaging/Tube/index.ts






var initTubeObject = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(options, showcaseTemp) {
        var modelNode, component;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        showcaseTemp.showcase.Scene.register(tubeComponentType, makeTubeComponent)
                    ];
                case 1:
                    _state.sent();
                    return [
                        4,
                        showcaseTemp.mpSDK.Scene.createNode()
                    ];
                case 2:
                    modelNode = _state.sent();
                    return [
                        4,
                        modelNode.addComponent(tubeComponentType, options)
                    ];
                case 3:
                    component = _state.sent();
                    return [
                        4,
                        modelNode.start()
                    ];
                case 4:
                    _state.sent();
                    return [
                        2,
                        component
                    ];
            }
        });
    });
    return function initTubeObject(options, showcaseTemp) {
        return _ref.apply(this, arguments);
    };
}();
var getPolygonByTitle = function(title, polygons, modelNodes) {
    var ref;
    var uuid = (ref = polygons.find(function(polygon) {
        return polygon.title === title;
    })) === null || ref === void 0 ? void 0 : ref.uuid;
    if (uuid) {
        return modelNodes.find(function(node) {
            return node.length === 2 && node[0].obj3D.uuid === uuid;
        });
    }
};
var initPolygonUpdateFromVideo = function(asset, node, pipesData, THREE, renderer) {
    var targetPolygonIndex = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : 0;
    var targetPolygon = pipesData.polygonArr[targetPolygonIndex];
    var linkedPipes = pipesData.components.filter(function(component) {
        var ref;
        return ((ref = component.inputs.linkedPolygon) === null || ref === void 0 ? void 0 : ref.id) === targetPolygon.id;
    });
    var lightGreen = new THREE.Color("#5cab89");
    var green = new THREE.Color("green");
    var red = new THREE.Color("#ff0000");
    var blue = new THREE.Color("#0000ff");
    var pipeColor = {
        current: new THREE.Color("white")
    };
    var setColor = function(polygonColor, color) {
        targetPolygon.polygon.material.color.set(polygonColor);
        linkedPipes.forEach(function(component) {
            component.inputs.color = "#".concat(color.getHexString());
        });
        pipeColor.current.set(color);
    };
    var animate = function() {
        var ref;
        requestAnimationFrame(animate);
        if (!(renderer === null || renderer === void 0 ? void 0 : (ref = renderer.xr) === null || ref === void 0 ? void 0 : ref.isPresenting)) {
            if ((node[1].video.currentTime < 2 || node[1].video.currentTime > 10) && !pipeColor.current.equals(blue)) {
                setColor(lightGreen, blue);
            }
            if (node[1].video.currentTime >= 2 && node[1].video.currentTime <= 9 && !pipeColor.current.equals(green)) {
                setColor(lightGreen, green);
            }
            if (node[1].video.currentTime > 4 && node[1].video.currentTime <= 8 && !pipeColor.current.equals(red)) {
                setColor(red, red);
            }
            if (node[1].video.currentTime > 8 && node[1].video.currentTime <= 10 && !pipeColor.current.equals(green)) {
                setColor(lightGreen, blue);
            }
        }
    };
    animate();
};
var initPipes = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(showcaseTemp, modelNodes, polygons, renderer) {
        var polygonArr, bottomPipe1, bottomPipe2, verticalPipeUp1, verticalPipeUp2, verticalPipeDown1, verticalPipeDown2, verticalPipeDown3, upperPipeLong, upperPipeLong2, upperPipeShort, outsidePipe1, components;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    polygonArr = [];
                    PIPES_CONSTANTS.POLYGONS.forEach(function(title) {
                        var polygon = getPolygonByTitle(title, polygons, modelNodes);
                        if ((polygon === null || polygon === void 0 ? void 0 : polygon.length) === 2) {
                            polygon[1].outputs.collider = null;
                            polygonArr.push(polygon[1]);
                        }
                    });
                    return [
                        4,
                        initTubeObject({
                            position: {
                                x: 8.44,
                                y: 0.58,
                                z: 24.7
                            },
                            rotation: {
                                x: 0,
                                y: Math.PI,
                                z: 0
                            },
                            visible: true,
                            color: "blue",
                            textureRepeat: {
                                x: 10,
                                y: 5
                            },
                            textureOffset: {
                                x: 0,
                                y: 0.5
                            },
                            length: 5.5,
                            width: 0.21,
                            scale: 1,
                            arrowSpeed: 0.004,
                            linkedPolygon: polygonArr[0]
                        }, showcaseTemp)
                    ];
                case 1:
                    bottomPipe1 = _state.sent();
                    return [
                        4,
                        initTubeObject({
                            position: {
                                x: 8.44,
                                y: 0.58,
                                z: 18.8
                            },
                            rotation: {
                                x: 0,
                                y: Math.PI,
                                z: 0
                            },
                            visible: true,
                            color: "blue",
                            textureRepeat: {
                                x: 30,
                                y: 5
                            },
                            textureOffset: {
                                x: 0,
                                y: 0.5
                            },
                            length: 15,
                            width: 0.21,
                            scale: 1,
                            arrowSpeed: 0.004,
                            linkedPolygon: polygonArr[1]
                        }, showcaseTemp)
                    ];
                case 2:
                    bottomPipe2 = _state.sent();
                    return [
                        4,
                        initTubeObject({
                            position: {
                                x: 8.44,
                                y: 0.9,
                                z: 3.34
                            },
                            rotation: {
                                x: Math.PI / 2,
                                y: Math.PI,
                                z: 0
                            },
                            visible: true,
                            color: "blue",
                            textureRepeat: {
                                x: 2,
                                y: 4
                            },
                            textureOffset: {
                                x: 0,
                                y: 0.5
                            },
                            length: 0.7,
                            width: 0.21,
                            scale: 1,
                            arrowSpeed: 0.004,
                            linkedPolygon: polygonArr[1]
                        }, showcaseTemp)
                    ];
                case 3:
                    verticalPipeUp1 = _state.sent();
                    return [
                        4,
                        initTubeObject({
                            position: {
                                x: 8.44,
                                y: 2.2,
                                z: 3.34
                            },
                            rotation: {
                                x: Math.PI / 2,
                                y: Math.PI,
                                z: 0
                            },
                            visible: true,
                            color: "blue",
                            textureRepeat: {
                                x: 4,
                                y: 4
                            },
                            textureOffset: {
                                x: 0,
                                y: 0.5
                            },
                            length: 1,
                            width: 0.21,
                            scale: 1,
                            arrowSpeed: 0.004,
                            linkedPolygon: polygonArr[2]
                        }, showcaseTemp)
                    ];
                case 4:
                    verticalPipeUp2 = _state.sent();
                    return [
                        4,
                        initTubeObject({
                            position: {
                                x: 4.97,
                                y: 2.88,
                                z: 2.47
                            },
                            rotation: {
                                x: Math.PI * 1.5,
                                y: Math.PI,
                                z: 0
                            },
                            visible: true,
                            color: "blue",
                            textureRepeat: {
                                x: 6,
                                y: 4
                            },
                            textureOffset: {
                                x: 0,
                                y: 0.5
                            },
                            length: 2.25,
                            width: 0.14,
                            scale: 1,
                            arrowSpeed: 0.004,
                            linkedPolygon: polygonArr[3]
                        }, showcaseTemp)
                    ];
                case 5:
                    verticalPipeDown1 = _state.sent();
                    return [
                        4,
                        initTubeObject({
                            position: {
                                x: 5.03,
                                y: 2.88,
                                z: 4.89
                            },
                            rotation: {
                                x: Math.PI * 1.5,
                                y: Math.PI,
                                z: 0
                            },
                            visible: true,
                            color: "blue",
                            textureRepeat: {
                                x: 6,
                                y: 4
                            },
                            textureOffset: {
                                x: 0,
                                y: 0.5
                            },
                            length: 2.25,
                            width: 0.14,
                            scale: 1,
                            arrowSpeed: 0.004,
                            linkedPolygon: polygonArr[4]
                        }, showcaseTemp)
                    ];
                case 6:
                    verticalPipeDown2 = _state.sent();
                    return [
                        4,
                        initTubeObject({
                            position: {
                                x: 8.44,
                                y: 2.64,
                                z: 25.1
                            },
                            rotation: {
                                x: Math.PI * 1.5,
                                y: Math.PI,
                                z: 0
                            },
                            visible: true,
                            color: "blue",
                            textureRepeat: {
                                x: 4,
                                y: 4
                            },
                            textureOffset: {
                                x: 0,
                                y: 0.5
                            },
                            length: 1.8,
                            width: 0.21,
                            scale: 1,
                            arrowSpeed: 0.004,
                            linkedPolygon: polygonArr[0]
                        }, showcaseTemp)
                    ];
                case 7:
                    verticalPipeDown3 = _state.sent();
                    return [
                        4,
                        initTubeObject({
                            position: {
                                x: 7.9,
                                y: 3.49,
                                z: 3.31
                            },
                            rotation: {
                                x: 0,
                                y: Math.PI * 1.5,
                                z: 0
                            },
                            visible: true,
                            color: "blue",
                            textureRepeat: {
                                x: 5,
                                y: 4
                            },
                            textureOffset: {
                                x: 0,
                                y: 0.5
                            },
                            length: 2.3,
                            width: 0.21,
                            scale: 1,
                            arrowSpeed: 0.004,
                            linkedPolygon: polygonArr[2]
                        }, showcaseTemp)
                    ];
                case 8:
                    upperPipeLong = _state.sent();
                    return [
                        4,
                        initTubeObject({
                            position: {
                                x: -4.18,
                                y: 3.06,
                                z: 26.54
                            },
                            rotation: {
                                x: 0,
                                y: Math.PI / 2,
                                z: 0
                            },
                            visible: true,
                            color: "blue",
                            textureRepeat: {
                                x: 30,
                                y: 4
                            },
                            textureOffset: {
                                x: 0,
                                y: 0.5
                            },
                            length: 12.3,
                            width: 0.21,
                            scale: 1,
                            arrowSpeed: 0.004,
                            linkedPolygon: polygonArr[0]
                        }, showcaseTemp)
                    ];
                case 9:
                    upperPipeLong2 = _state.sent();
                    return [
                        4,
                        initTubeObject({
                            position: {
                                x: 4.99,
                                y: 3.49,
                                z: 3.95
                            },
                            rotation: {
                                x: 0,
                                y: 0,
                                z: 0
                            },
                            visible: true,
                            color: "blue",
                            textureRepeat: {
                                x: 4,
                                y: 5
                            },
                            textureOffset: {
                                x: 0,
                                y: 0.5
                            },
                            length: 0.7,
                            width: 0.14,
                            scale: 1,
                            arrowSpeed: 0.004,
                            linkedPolygon: polygonArr[4]
                        }, showcaseTemp)
                    ];
                case 10:
                    upperPipeShort = _state.sent();
                    return [
                        4,
                        initTubeObject({
                            position: {
                                x: 17.28,
                                y: 0.69,
                                z: 9.25
                            },
                            rotation: {
                                x: 0,
                                y: 3.13,
                                z: 0
                            },
                            visible: true,
                            color: "blue",
                            textureRepeat: {
                                x: 5,
                                y: 4
                            },
                            textureOffset: {
                                x: 0,
                                y: 0.5
                            },
                            length: 6.2,
                            width: 0.26,
                            scale: 1,
                            arrowSpeed: 0.004,
                            linkedPolygon: polygonArr[5]
                        }, showcaseTemp)
                    ];
                case 11:
                    outsidePipe1 = _state.sent();
                    components = [
                        bottomPipe1,
                        bottomPipe2,
                        verticalPipeUp1,
                        verticalPipeUp2,
                        verticalPipeDown1,
                        verticalPipeDown2,
                        verticalPipeDown3,
                        upperPipeLong,
                        upperPipeLong2,
                        upperPipeShort,
                        outsidePipe1
                    ];
                    components.forEach(function(component) {
                        component.renderer = renderer;
                    });
                    return [
                        2,
                        {
                            components: components,
                            polygonArr: polygonArr
                        }
                    ];
            }
        });
    });
    return function initPipes(showcaseTemp, modelNodes, polygons, renderer) {
        return _ref.apply(this, arguments);
    };
}();
var animateDustPipe = function(component) {
    var tweenUp = new tween_module_min/* TWEEN.Tween */.w.Tween(component.root.scale).to({
        y: 2.3
    }, getRandomRange(2000, 4000)).easing(tween_module_min/* TWEEN.Easing.Quadratic.InOut */.w.Easing.Quadratic.InOut); // Change this to suit your needs
    var tweenDown = new tween_module_min/* TWEEN.Tween */.w.Tween(component.root.scale).to({
        y: 1
    }, getRandomRange(2000, 4000)).easing(tween_module_min/* TWEEN.Easing.Quadratic.InOut */.w.Easing.Quadratic.InOut); // Change this to suit your needs
    // Modify onComplete to assign new random duration when tween finishes
    tweenUp.onComplete(function() {
        tweenDown.to({
            y: getRandomRange(1, 2.3)
        }, getRandomRange(2000, 4000));
    });
    tweenDown.onComplete(function() {
        tweenUp.to({
            y: getRandomRange(1, 2.3)
        }, getRandomRange(2000, 4000));
    });
    tweenUp.chain(tweenDown);
    tweenDown.chain(tweenUp);
    tweenUp.start();
};
var initPipesAmericanWater = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(showcaseTemp, modelNodes, polygons, renderer) {
        var polygonArr, outsidePipeVertical, outsidePipeHorizontal, innerPipeX1, innerPipeZ1, innerPipeZ2, innerPipeZ3Long, innerPipeY1, innerPipeY2, innerPipeY3, innerPipeX2, dustPipe, components;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    polygonArr = [];
                    PIPES_CONSTANTS_AMERICAN_WATER.POLYGONS.forEach(function(title) {
                        var polygon = getPolygonByTitle(title, polygons, modelNodes);
                        if ((polygon === null || polygon === void 0 ? void 0 : polygon.length) === 2) {
                            polygon[1].outputs.collider = null;
                            polygonArr.push(polygon[1]);
                        }
                    });
                    return [
                        4,
                        initTubeObject({
                            position: {
                                x: 1.63,
                                y: 2.84,
                                z: 7.72
                            },
                            rotation: {
                                x: Math.PI * 1.5,
                                y: 0,
                                z: 0
                            },
                            visible: true,
                            color: "blue",
                            textureRepeat: {
                                x: 10,
                                y: 5
                            },
                            textureOffset: {
                                x: 0,
                                y: 0.3
                            },
                            length: 6.05,
                            width: 0.37,
                            scale: 1,
                            arrowSpeed: 0.004
                        }, showcaseTemp)
                    ];
                case 1:
                    outsidePipeVertical = _state.sent();
                    return [
                        4,
                        initTubeObject({
                            position: {
                                x: 1.59,
                                y: 9.75,
                                z: 7.27
                            },
                            rotation: {
                                x: Math.PI,
                                y: 0,
                                z: 0
                            },
                            visible: true,
                            color: "blue",
                            textureRepeat: {
                                x: 1,
                                y: 5
                            },
                            textureOffset: {
                                x: 0,
                                y: 0.3
                            },
                            length: 0.5,
                            width: 0.38,
                            scale: 1,
                            arrowSpeed: 0.004
                        }, showcaseTemp)
                    ];
                case 2:
                    outsidePipeHorizontal = _state.sent();
                    return [
                        4,
                        initTubeObject({
                            position: {
                                x: -53.32,
                                y: 0.69,
                                z: 29.59
                            },
                            rotation: {
                                x: 0,
                                y: Math.PI / 2,
                                z: 0
                            },
                            visible: true,
                            color: "blue",
                            textureRepeat: {
                                x: 6,
                                y: 5
                            },
                            textureOffset: {
                                x: 0,
                                y: 0.3
                            },
                            length: 4.75,
                            width: 0.43,
                            scale: 1,
                            arrowSpeed: 0.004
                        }, showcaseTemp)
                    ];
                case 3:
                    innerPipeX1 = _state.sent();
                    return [
                        4,
                        initTubeObject({
                            position: {
                                x: -51.39,
                                y: 0.74,
                                z: 32.25
                            },
                            rotation: {
                                x: 0,
                                y: Math.PI,
                                z: 0
                            },
                            visible: true,
                            color: "blue",
                            textureRepeat: {
                                x: 2,
                                y: 5
                            },
                            textureOffset: {
                                x: 0,
                                y: 0.3
                            },
                            length: 1.9,
                            width: 0.43,
                            scale: 1,
                            arrowSpeed: 0.004,
                            linkedPolygon: polygonArr[1]
                        }, showcaseTemp)
                    ];
                case 4:
                    innerPipeZ1 = _state.sent();
                    return [
                        4,
                        initTubeObject({
                            position: {
                                x: -53.76,
                                y: 0.69,
                                z: 32.18
                            },
                            rotation: {
                                x: 0,
                                y: Math.PI,
                                z: 0
                            },
                            visible: true,
                            color: "blue",
                            textureRepeat: {
                                x: 2,
                                y: 5
                            },
                            textureOffset: {
                                x: 0,
                                y: 0.3
                            },
                            length: 1.9,
                            width: 0.46,
                            scale: 1,
                            arrowSpeed: 0.004,
                            linkedPolygon: polygonArr[2]
                        }, showcaseTemp)
                    ];
                case 5:
                    innerPipeZ2 = _state.sent();
                    return [
                        4,
                        initTubeObject({
                            position: {
                                x: -56.29,
                                y: 2.76,
                                z: 40
                            },
                            rotation: {
                                x: 0,
                                y: Math.PI,
                                z: 0
                            },
                            visible: true,
                            color: "blue",
                            textureRepeat: {
                                x: 34,
                                y: 5
                            },
                            textureOffset: {
                                x: 0,
                                y: 0.3
                            },
                            length: 18,
                            width: 0.2,
                            scale: 1,
                            arrowSpeed: 0.004,
                            linkedPolygon: polygonArr[0]
                        }, showcaseTemp)
                    ];
                case 6:
                    innerPipeZ3Long = _state.sent();
                    return [
                        4,
                        initTubeObject({
                            position: {
                                x: -55.55,
                                y: 0.85,
                                z: 24.97
                            },
                            rotation: {
                                x: 1.52,
                                y: 0,
                                z: 0
                            },
                            visible: true,
                            color: "blue",
                            textureRepeat: {
                                x: 2,
                                y: 5
                            },
                            textureOffset: {
                                x: 0,
                                y: 0.3
                            },
                            length: 0.4,
                            width: 0.13,
                            scale: 1,
                            arrowSpeed: 0.004
                        }, showcaseTemp)
                    ];
                case 7:
                    innerPipeY1 = _state.sent();
                    return [
                        4,
                        initTubeObject({
                            position: {
                                x: -55.9,
                                y: 0.43,
                                z: 24.96
                            },
                            rotation: {
                                x: Math.PI * 1.5,
                                y: 0,
                                z: 0
                            },
                            visible: true,
                            color: "blue",
                            textureRepeat: {
                                x: 2,
                                y: 5
                            },
                            textureOffset: {
                                x: 0,
                                y: 0.3
                            },
                            length: 0.4,
                            width: 0.13,
                            scale: 1,
                            arrowSpeed: 0.004,
                            linkedPolygon: polygonArr[0]
                        }, showcaseTemp)
                    ];
                case 8:
                    innerPipeY2 = _state.sent();
                    return [
                        4,
                        initTubeObject({
                            position: {
                                x: -53.86,
                                y: 0.43,
                                z: 25.07
                            },
                            rotation: {
                                x: Math.PI * 1.5,
                                y: 0,
                                z: 0
                            },
                            visible: true,
                            color: "blue",
                            textureRepeat: {
                                x: 2,
                                y: 5
                            },
                            textureOffset: {
                                x: 0,
                                y: 0.3
                            },
                            length: 0.4,
                            width: 0.13,
                            scale: 1,
                            arrowSpeed: 0.004
                        }, showcaseTemp)
                    ];
                case 9:
                    innerPipeY3 = _state.sent();
                    return [
                        4,
                        initTubeObject({
                            position: {
                                x: -55.14,
                                y: 0.28,
                                z: 24.95
                            },
                            rotation: {
                                x: 0,
                                y: Math.PI * 0.5,
                                z: 0
                            },
                            visible: true,
                            color: "blue",
                            textureRepeat: {
                                x: 4,
                                y: 5
                            },
                            textureOffset: {
                                x: 0,
                                y: 0.3
                            },
                            length: 1.1,
                            width: 0.12,
                            scale: 1,
                            arrowSpeed: 0.004
                        }, showcaseTemp)
                    ];
                case 10:
                    innerPipeX2 = _state.sent();
                    return [
                        4,
                        initTubeObject({
                            position: {
                                x: -19,
                                y: -0.85,
                                z: 20.54
                            },
                            rotation: {
                                x: Math.PI * 1.5,
                                y: 0,
                                z: 0
                            },
                            visible: true,
                            color: "#b4d4bc",
                            hasTexture: false,
                            length: 6.05,
                            width: 2.3,
                            scale: 1
                        }, showcaseTemp)
                    ];
                case 11:
                    dustPipe = _state.sent();
                    animateDustPipe(dustPipe);
                    components = [
                        outsidePipeVertical,
                        outsidePipeHorizontal,
                        innerPipeZ1,
                        innerPipeZ2,
                        innerPipeZ3Long,
                        innerPipeX1,
                        innerPipeY1,
                        innerPipeY2,
                        innerPipeY3,
                        innerPipeX2
                    ];
                    components.forEach(function(component) {
                        component.renderer = renderer;
                    });
                    return [
                        2,
                        {
                            components: components,
                            polygonArr: polygonArr
                        }
                    ];
            }
        });
    });
    return function initPipesAmericanWater(showcaseTemp, modelNodes, polygons, renderer) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./components/util/pipes.ts








function buildPipes() {
    return _buildPipes.apply(this, arguments);
}
function _buildPipes() {
    _buildPipes = (0,_async_to_generator/* default */.Z)(function() {
        var _this, ref, ref1, modelNode, component, _this1, _;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _this = this;
                    return [
                        4,
                        this.showCaseTemp.showcase.Scene.register(BIMComponentType, makeBIMComponent)
                    ];
                case 1:
                    _state.sent();
                    return [
                        4,
                        this.showCaseTemp.mpSDK.Scene.createNode()
                    ];
                case 2:
                    modelNode = _state.sent();
                    return [
                        4,
                        modelNode.addComponent(BIMComponentType, {
                            position: {
                                x: -44.24,
                                y: -0.1,
                                z: 1.18
                            },
                            rotation: {
                                x: 0,
                                y: -Math.PI / 2,
                                z: 0
                            },
                            scale: {
                                x: 0.1,
                                y: 0.1,
                                z: 0.1
                            }
                        })
                    ];
                case 3:
                    component = _state.sent();
                    this.BIMComponent = component;
                    return [
                        4,
                        modelNode.start()
                    ];
                case 4:
                    _state.sent();
                    component.onEvent = function(type, eventData) {
                        var item = component.getItem(eventData.collider.id);
                        if (!item) return;
                        var selectedPipe = component.getSegmentsOfPipe(eventData.collider.name);
                        if (type === Scene_component/* ComponentInteractionType.HOVER */.td.HOVER) {
                            _this.iframe.contentWindow.document.body.style.cursor = eventData.hover ? "pointer" : "auto";
                            if (eventData.hover) {
                                item.hovered = true;
                                selectedPipe.forEach(function(segment) {
                                    var segmentId = component.getSegmentIdByName(segment);
                                    if (segmentId) {
                                        component.setItemColor(segmentId, component.inputs.colorClick);
                                        component.setItemOpacity(segmentId, component.inputs.opacityClick);
                                        if (component.animatedPipes.has(segmentId)) {
                                            component.setAnimatedPipeOpacity(segmentId, 1);
                                        }
                                        var segmentItem = component.getItem(segmentId);
                                        if (segmentItem) segmentItem.hovered = true;
                                    }
                                });
                            } else {
                                item.hovered = false;
                                if (item.selected === true) return;
                                selectedPipe.forEach(function(segment) {
                                    var segmentId = component.getSegmentIdByName(segment);
                                    if (segmentId) {
                                        component.setItemColor(segmentId, component.inputs.colorDefault);
                                        component.setItemOpacity(segmentId, component.inputs.opacityDefault);
                                        if (component.animatedPipes.has(segmentId)) {
                                            component.setAnimatedPipeOpacity(segmentId, 0);
                                        }
                                        var segmentItem = component.getItem(segmentId);
                                        if (segmentItem) segmentItem.hovered = false;
                                    }
                                });
                            }
                        }
                        if (type === Scene_component/* ComponentInteractionType.CLICK */.td.CLICK) {
                            if (component.selectedPipe) {
                                component.selectedPipe.forEach(function(segment) {
                                    var segmentId = component.getSegmentIdByName(segment);
                                    if (segmentId) {
                                        component.setItemColor(segmentId, component.inputs.colorDefault);
                                        component.setItemOpacity(segmentId, component.inputs.opacityDefault);
                                        if (component.animatedPipes.has(segmentId)) {
                                            component.setAnimatedPipeOpacity(segmentId, 0);
                                        }
                                        var segmentItem = component.getItem(segmentId);
                                        if (segmentItem) segmentItem.selected = false;
                                    }
                                });
                                component.selectedPipe = null;
                            }
                            selectedPipe.forEach(function(segment) {
                                var segmentId = component.getSegmentIdByName(segment);
                                if (segmentId) {
                                    component.setItemColor(segmentId, component.inputs.colorClick);
                                    component.setItemOpacity(segmentId, component.inputs.opacityClick);
                                    if (component.animatedPipes.has(segmentId)) {
                                        component.setAnimatedPipeOpacity(segmentId, 1);
                                    }
                                    var segmentItem = component.getItem(segmentId);
                                    if (segmentItem) segmentItem.selected = true;
                                }
                            });
                            component.selectedPipe = selectedPipe;
                        }
                    };
                    component.selectedPipe = null;
                    _this1 = this;
                    component.outputs.onPropertyChanged("loadingState", function() {
                        var _ref = (0,_async_to_generator/* default */.Z)(function(state) {
                            var menus;
                            return (0,tslib_es6.__generator)(this, function(_state) {
                                if (state === VSObject/* LoadingState.Loaded */.Gu.Loaded) {
                                    menus = [];
                                    data/* pipesConfig.pipes.forEach */.y.pipes.forEach(function(pipe, index) {
                                        var listItem = createMenuItem({
                                            id: index,
                                            name: pipe.name,
                                            itemId: pipe.id
                                        });
                                        menus.push(listItem);
                                    });
                                    _this1.setState({
                                        menus: menus
                                    });
                                }
                                return [
                                    2
                                ];
                            });
                        });
                        return function(state) {
                            return _ref.apply(this, arguments);
                        };
                    }());
                    if (!((ref = this.iframe) === null || ref === void 0 ? void 0 : (ref1 = ref.contentWindow) === null || ref1 === void 0 ? void 0 : ref1.location.href.includes("m=cKEUCfKQmHn"))) return [
                        3,
                        6
                    ];
                    _ = this;
                    return [
                        4,
                        initPipesAmericanWater(this.showCaseTemp, this.modelNodes, this.state.polygons, this.renderer)
                    ];
                case 5:
                    _.pipesData = _state.sent();
                    _state.label = 6;
                case 6:
                    return [
                        2
                    ];
            }
        });
    });
    return _buildPipes.apply(this, arguments);
}

// EXTERNAL MODULE: ./components/util/socket.ts
var socket = __webpack_require__(13607);
// EXTERNAL MODULE: ./components/util/styles.ts
var styles = __webpack_require__(24069);
// EXTERNAL MODULE: ./components/tour/regular/bottomBar/SoundControls.tsx
var SoundControls = __webpack_require__(67644);
// EXTERNAL MODULE: ./components/tour/regular/fullScreen/FullScreen.tsx
var FullScreen = __webpack_require__(44);
// EXTERNAL MODULE: ./components/ticketingNew/components/InfoModal.tsx + 1 modules
var InfoModal = __webpack_require__(47887);
// EXTERNAL MODULE: ./store/index.ts + 8 modules
var store = __webpack_require__(70989);
;// CONCATENATED MODULE: ./components/tour/components/SetDataToRecoil.tsx




var SetDataToRecoil = function(props) {
    var translation = props.translation, tourConfigsInput = props.tourConfigsInput;
    var ref = (0,react.useState)(false), inited = ref[0], setInited = ref[1];
    var setTranslation = (0,store/* useSetRecoilState */.Zl)(store/* translationDataState */.Jv);
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,store/* useRecoilState */.FV)(store/* tourConfigsState */.Uq), 2), tourConfigs = ref1[0], setTourConfigs = ref1[1];
    (0,react.useEffect)(function() {
        if (!inited) {
            if (translation && Object.keys(translation).length > 0) {
                setTranslation(translation);
                setTourConfigs((0,_object_spread/* default */.Z)({}, tourConfigs, tourConfigsInput));
                setInited(true);
            }
        }
    }, [
        translation
    ]);
    return null;
};
/* harmony default export */ var components_SetDataToRecoil = (SetDataToRecoil);

// EXTERNAL MODULE: ./node_modules/lodash/isNil.js
var isNil = __webpack_require__(14293);
var isNil_default = /*#__PURE__*/__webpack_require__.n(isNil);
;// CONCATENATED MODULE: ./_models/game/GameAnalytic.ts


var GameAnalytic = function GameAnalytic(model) {
    "use strict";
    (0,_class_call_check/* default */.Z)(this, GameAnalytic);
    this.id = model.id || null;
    this.name = model.name || null;
    this.startDateTime = model.startDateTime || null;
    this.country = model.country || null;
    this.point = !isNil_default()(model.point) ? model.point : null;
    this.time = !isNil_default()(model.time) ? model.time : null;
    this.completed = model.completed || false;
    this.gameId = model.gameId || null;
    this.comment = model.comment || null;
    this.rating = !isNil_default()(model.rating) ? model.rating : null;
    this.slug = model.slug || null;
};

;// CONCATENATED MODULE: ./components/tour/game/services/GameAnalyticService.ts






var GameAnalyticService = /*#__PURE__*/ function() {
    "use strict";
    function GameAnalyticService(gameId, slug) {
        var _this = this;
        (0,_class_call_check/* default */.Z)(this, GameAnalyticService);
        this.analytic = new GameAnalytic({
            gameId: gameId,
            country: "",
            startDateTime: new Date(),
            slug: slug
        });
        window.addEventListener("beforeunload", function() {
            return _this.update();
        });
    }
    var _proto = GameAnalyticService.prototype;
    _proto.getTime = function getTime() {
        return this.analytic.time;
    };
    _proto.setName = function setName(name) {
        this.analytic.name = name;
    };
    _proto.setTime = function setTime(time) {
        this.analytic.time = time;
    };
    _proto.getPoint = function getPoint() {
        return this.analytic.point;
    };
    _proto.setPoint = function setPoint(point) {
        this.analytic.point = point;
    };
    _proto.update = function update() {
        var data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var obj, newAnalytic, res;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        obj = (0,_object_spread/* default */.Z)({}, data);
                        if (obj.id) delete obj.id;
                        newAnalytic = new GameAnalytic((0,_object_spread/* default */.Z)({}, _this.analytic, obj));
                        if (!_this.analytic.time) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            _this.saveAnalytics(newAnalytic)
                        ];
                    case 1:
                        res = _state.sent();
                        if (res) {
                            _this.analytic = new GameAnalytic(res.data);
                        }
                        _state.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        })();
    };
    // eslint-disable-next-line class-methods-use-this
    _proto.saveAnalytics = function saveAnalytics(analytic) {
        return TreedisAdminDAO/* default.saveAnalytics */.Z.saveAnalytics(analytic);
    };
    return GameAnalyticService;
}();


;// CONCATENATED MODULE: ./components/tour/calculateLocation.ts
function calculateLocation(sweep) {
    if (this.state.panoramaOn) return false;
    var px = this.state.mapWalkerX;
    var py = this.state.mapWalkerY;
    var minimaps = this.state.minimaps;
    var selectedMinimap = this.state.selectedMinimap;
    var tour = this.state.tour;
    var minimap = minimaps[selectedMinimap];
    if (tour.minimap && minimaps.length > 0 && minimap && minimap.originX != null && minimap.originY != null && minimap.width != null && minimap.height != null && minimap.ppm != null) {
        var hotspots = minimap.hotspots, custom = minimap.custom;
        var foundHotspot = null;
        hotspots.forEach(function(hotspot) {
            if (hotspot.scanId === sweep.sid || hotspot.scanId === sweep.id || hotspot.scanId === sweep.uuid || hotspot.scanId === sweep.sweep_uuid) {
                hotspot.active = true;
                foundHotspot = hotspot;
            } else {
                hotspot.active = false;
            }
        });
        if (foundHotspot) {
            px = foundHotspot.x;
            py = foundHotspot.y;
        } else if (!custom) {
            var ref, ref1;
            px = (((ref = sweep.position) === null || ref === void 0 ? void 0 : ref.x) - minimap.originX) * minimap.ppm / minimap.width * 100;
            py = (((ref1 = sweep.position) === null || ref1 === void 0 ? void 0 : ref1.z) * -1 - minimap.originY) * minimap.ppm / minimap.height * 100;
        }
    }
    return {
        px: px,
        py: py,
        minimaps: minimaps
    };
}

;// CONCATENATED MODULE: ./components/tour/regular/loadTourIframe/LoadTourIframe.tsx




var LoadTourIframe = function(param) {
    var mesurementsOn = param.mesurementsOn, iframeStyle = param.iframeStyle, iframeUrl = param.iframeUrl, isFullScreen = param.isFullScreen, iframeId = param.iframeId, cb = param.cb;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Frame */.RQ, {
        elementId: iframeId,
        iframeUrl: iframeUrl,
        className: classnames_default()("showcase", deviceManager/* default.isMobile */.Z.isMobile() && !isFullScreen && mesurementsOn && "mesurements-mobile-not-fullscreen"),
        style: iframeStyle,
        handleRef: cb
    });
};
/* harmony default export */ var loadTourIframe_LoadTourIframe = (LoadTourIframe);

// EXTERNAL MODULE: ./_helpers/base.tsx
var base = __webpack_require__(41154);
// EXTERNAL MODULE: ./_helpers/renderDebug.ts
var renderDebug = __webpack_require__(66725);
// EXTERNAL MODULE: ./_helpers/storage.ts
var storage = __webpack_require__(98144);
// EXTERNAL MODULE: ./_models/Tag.tsx
var Tag = __webpack_require__(42725);
// EXTERNAL MODULE: ./_models/User.tsx
var User = __webpack_require__(43500);
// EXTERNAL MODULE: ./_models/virtualStaging/HTMLMesh/HTMLMesh.tsx + 2 modules
var HTMLMesh = __webpack_require__(91833);
// EXTERNAL MODULE: ./_models/virtualStaging/HTMLMesh/utils/InteractiveGroup.ts
var InteractiveGroup = __webpack_require__(79502);
;// CONCATENATED MODULE: ./components/util/math/getXZCoordinatesOnCircle.ts
var getXZCoordinatesOnCircle = function(radius, angle) {
    var x = radius * Math.sin(Math.PI * 2 * angle / 360);
    var z = radius * Math.cos(Math.PI * 2 * angle / 360);
    return {
        x: x,
        z: z
    };
};
var getXYZCoordinatesOnCircle = function(radius, lon, lat) {
    var x = radius * Math.sin(Math.PI * 2 * lat / 360) * Math.cos(Math.PI * 2 * lon / 360);
    var y = radius * Math.sin(Math.PI * 2 * lon / 360);
    var z = radius * Math.cos(Math.PI * 2 * lat / 360) * Math.cos(Math.PI * 2 * lon / 360);
    return {
        x: x,
        y: y,
        z: z
    };
};

// EXTERNAL MODULE: ./_models/virtualStaging/HTMLMesh/component/AbstractHTMLMesh.ts
var AbstractHTMLMesh = __webpack_require__(39277);
;// CONCATENATED MODULE: ./_models/virtualStaging/HTMLMesh/component/Backpack/BackpackMesh.component.ts
// eslint-disable-next-line @typescript-eslint/ban-ts-comment








var BackpackMeshComponent = /*#__PURE__*/ function(AbstractHTMLMesh) {
    "use strict";
    (0,_inherits/* default */.Z)(BackpackMeshComponent, AbstractHTMLMesh);
    var _super = (0,_create_super/* default */.Z)(BackpackMeshComponent);
    function BackpackMeshComponent() {
        (0,_class_call_check/* default */.Z)(this, BackpackMeshComponent);
        var _this;
        _this = _super.apply(this, arguments);
        _this.inputs = {
            html: null,
            visible: false,
            scale: 1,
            refs: null
        };
        return _this;
    }
    var _proto = BackpackMeshComponent.prototype;
    _proto.onInit = function onInit() {
        var html = this.inputs.html;
        this.initMesh(html);
        this.initRoot();
        this.addMeshPointerEvents();
        this.getXRController();
        this.outputs.loadingState = VSObject/* LoadingState.Loaded */.Gu.Loaded;
    };
    _proto.initMesh = function initMesh(html) {
        this.mesh = (0,HTMLMesh/* createHTMLMesh */.x)(html, this.context.three);
        this.mesh.material.side = this.context.three.DoubleSide;
        this.mesh.material.depthWrite = false;
        this.mesh.material.depthTest = false;
        this.mesh.renderOrder = 980;
        this.mesh.scale.setScalar(2);
        this.mesh.userData = {
            isPointerOver: false
        };
    };
    _proto.addMeshPointerEvents = function addMeshPointerEvents() {
        var group = new InteractiveGroup/* InteractiveGroup */.e(this.context.renderer, this.context.camera, this.context);
        this.pivot.add(group);
        group.add(this.mesh);
    };
    _proto.setHostPose = function setHostPose(pose) {
        this.hostPose = pose;
    };
    _proto.setPositionFromPose = function setPositionFromPose(pose) {
        var ref = getXZCoordinatesOnCircle(0.85, pose.rotation.y + 180), x = ref.x, z = ref.z;
        this.root.position.set(pose.position.x + x, pose.position.y - 0.2, pose.position.z + z);
        this.root.lookAt(pose.position.x, pose.position.y - 0.1, pose.position.z);
    };
    _proto.setFromHostPose = function setFromHostPose() {
        this.setPositionFromPose(this.hostPose);
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _proto.cycleVR = function cycleVR(_session) {
        var ref, ref1, ref2, ref3;
        if (((ref1 = (ref = this.gamepadL) === null || ref === void 0 ? void 0 : ref.buttons[4]) === null || ref1 === void 0 ? void 0 : ref1.pressed) && this.hostPose && !this.gamepadButtonActive) {
            this.setVisible(!this.inputs.visible);
            this.setFromHostPose();
            this.gamepadButtonActive = true;
        }
        if (!((ref3 = (ref2 = this.gamepadL) === null || ref2 === void 0 ? void 0 : ref2.buttons[4]) === null || ref3 === void 0 ? void 0 : ref3.pressed) && this.gamepadButtonActive) {
            this.gamepadButtonActive = false;
        }
    };
    _proto.onTick = function onTick() {
        var _this = this;
        var ref, ref1, ref2;
        if ((ref = this.context) === null || ref === void 0 ? void 0 : (ref1 = ref.renderer) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.xr) === null || ref2 === void 0 ? void 0 : ref2.isPresenting) {
            var _session = this.context.renderer.xr.getSession();
            _session.requestAnimationFrame(function() {
                return _this.cycleVR(_session);
            });
        }
    };
    return BackpackMeshComponent;
}(AbstractHTMLMesh/* AbstractHTMLMesh */.n);
var backpackMeshComponentType = "mp.backpackMeshComponent";
var makeBackpackMeshComponent = function() {
    return new BackpackMeshComponent();
};

// EXTERNAL MODULE: ./_models/virtualStaging/HTMLMesh/utils/getRelativePaddingTop.ts
var getRelativePaddingTop = __webpack_require__(87161);
;// CONCATENATED MODULE: ./_models/virtualStaging/HTMLMesh/utils/createSVG.ts
var createCircleIconSVG = function(hexColor) {
    // Create the SVG element
    var svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    svg.setAttribute("viewBox", "0 0 48 48");
    svg.setAttribute("width", "48");
    svg.setAttribute("height", "48");
    // Create the outer circle
    var circleOuter = document.createElementNS("http://www.w3.org/2000/svg", "circle");
    circleOuter.setAttribute("cx", "24");
    circleOuter.setAttribute("cy", "24");
    circleOuter.setAttribute("r", "22.5");
    circleOuter.setAttribute("fill", hexColor);
    circleOuter.setAttribute("stroke", "#fff");
    circleOuter.setAttribute("stroke-width", "3");
    // Create the inner circle
    var group = document.createElementNS("http://www.w3.org/2000/svg", "g");
    group.setAttribute("transform", "translate(24, 24)");
    var circleInner = document.createElementNS("http://www.w3.org/2000/svg", "circle");
    circleInner.setAttribute("r", "10");
    circleInner.setAttribute("fill", "#fff");
    // Add the elements to the SVG element
    group.appendChild(circleInner);
    svg.appendChild(circleOuter);
    svg.appendChild(group);
    return svg;
};

;// CONCATENATED MODULE: ./_models/virtualStaging/HTMLMesh/utils/svgToPng.ts
function svgToPng(svgElement) {
    // Create a canvas element
    var canvas = document.createElement("canvas");
    canvas.width = svgElement.getAttribute("width");
    canvas.height = svgElement.getAttribute("height");
    // Get the SVG as a string
    var svgString = new XMLSerializer().serializeToString(svgElement);
    // Draw the SVG onto the canvas
    var ctx = canvas.getContext("2d");
    var img = new Image();
    img.onload = function() {
        ctx.drawImage(img, 0, 0);
        // Get the data URL of the resulting PNG image
        var dataUrl = canvas.toDataURL("image/png");
        return dataUrl;
    };
    return "data:image/svg+xml;base64," + btoa(svgString);
}

;// CONCATENATED MODULE: ./_models/virtualStaging/HTMLMesh/component/MatterTag/MatterTagMesh.component.tsx
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
















var MatterTagMeshComponent = /*#__PURE__*/ function(AbstractHTMLMesh) {
    "use strict";
    (0,_inherits/* default */.Z)(MatterTagMeshComponent, AbstractHTMLMesh);
    var _super = (0,_create_super/* default */.Z)(MatterTagMeshComponent);
    function MatterTagMeshComponent() {
        (0,_class_call_check/* default */.Z)(this, MatterTagMeshComponent);
        var _this;
        _this = _super.apply(this, arguments);
        _this.inputs = {
            html: null,
            tagData: null,
            media: null,
            dimensions: {
                width: 400,
                height: 400
            },
            scale: 1,
            visible: true,
            popupVisible: false,
            popupScale: 16
        };
        var _obj;
        _this.events = (_obj = {}, (0,_define_property/* default */.Z)(_obj, Scene_component/* ComponentInteractionType.CLICK */.td.CLICK, true), (0,_define_property/* default */.Z)(_obj, Scene_component/* ComponentInteractionType.HOVER */.td.HOVER, true), (0,_define_property/* default */.Z)(_obj, Scene_component/* ComponentInteractionType.DRAG */.td.DRAG, false), _obj);
        return _this;
    }
    var _proto = MatterTagMeshComponent.prototype;
    _proto.onInit = function onInit() {
        var THREE = this.context.three;
        var _inputs = this.inputs, html = _inputs.html, media = _inputs.media;
        this.tagId = this.inputs.tagData.id;
        this.initRoot();
        this.textureLoader = new THREE.TextureLoader();
        this.initTag();
        this.initPopupMesh(html);
        if (media) this.initMedia(media);
        this.addMeshPointerEvents();
        this.getXRController();
        this.outputs.loadingState = VSObject/* LoadingState.Loaded */.Gu.Loaded;
    };
    _proto.initTag = function initTag() {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var THREE, iconSVG, tag, tagIconUrl, iconSrc;
            return (0,tslib_es6.__generator)(this, function(_state) {
                THREE = _this.context.three;
                tag = _this.inputs.tagData;
                if (tag.iconFile) {
                    if (tag.iconFile.startsWith("http")) {
                        tagIconUrl = "".concat(tag.iconFile);
                    } else {
                        tagIconUrl = "".concat("https://cdn.treedis.com", "/tours/").concat(tag.tourId, "/tags/icons/").concat(tag.iconFile);
                    }
                } else if (tag.customIcon && tag.customIcon !== "null") {
                    tagIconUrl = "".concat("https://api.treedis.com" || 0, "/v1/public/icons/").concat(tag.customIcon, "?hex=").concat(encodeURIComponent(tag.iconColor), "&circle=").concat(tag.whiteCircle);
                }
                if (_this.inputs.tagData.iconColor) iconSVG = createCircleIconSVG(_this.inputs.tagData.iconColor);
                else if (!_this.inputs.tagData.iconColor) iconSVG = createCircleIconSVG("#03687d");
                iconSrc = tagIconUrl || svgToPng(iconSVG);
                _this.textureLoader.load(iconSrc, function(texture) {
                    texture.image.width = 128;
                    texture.image.height = 128;
                    var aspect = texture.image.width / texture.image.height;
                    var ref = (0,_sliced_to_array/* default */.Z)(aspect >= 1 ? [
                        1,
                        1 / aspect
                    ] : [
                        1 / aspect,
                        1
                    ], 2), width = ref[0], height = ref[1];
                    var geometry = new THREE.PlaneGeometry(width, height);
                    var material = new THREE.MeshBasicMaterial({
                        map: texture,
                        side: THREE.DoubleSide,
                        blending: THREE.NormalBlending,
                        transparent: true
                    });
                    _this.tag = new THREE.Mesh(geometry, material);
                    _this.tag.name = "tag";
                    _this.pivot.add(_this.tag);
                    _this.root.position.set(_this.inputs.tagData.positionX + _this.inputs.tagData.stemVectorX, _this.inputs.tagData.positionY + _this.inputs.tagData.stemVectorY, _this.inputs.tagData.positionZ + _this.inputs.tagData.stemVectorZ);
                });
                return [
                    2
                ];
            });
        })();
    };
    _proto.initPopupMesh = function initPopupMesh(html) {
        this.popupMesh = (0,HTMLMesh/* createHTMLMesh */.x)(html, this.context.three);
        this.popupMesh.material.side = this.context.three.DoubleSide;
        this.popupMesh.material.depthWrite = false;
        this.popupMesh.material.depthTest = false;
        this.popupMesh.renderOrder = 970;
        this.popupMesh.scale.setScalar(0);
        this.popupMesh.userData = {
            isPointerOver: false
        };
    };
    _proto.initMedia = function initMedia(media) {
        var _this = this;
        var THREE = this.context.three;
        this.textureLoader.load(media, function(texture) {
            if (!texture) return;
            var texWidth = texture.image.width;
            var texHeight = texture.image.height;
            // Calculate the aspect ratio of the texture
            var aspectRatio = texWidth / texHeight;
            // Set the width and height of the mesh
            var meshWidth = 0.35;
            var meshHeight = 0.35 / aspectRatio;
            // Create the plane geometry and mesh
            var geometry = new THREE.PlaneGeometry(meshWidth, meshHeight);
            var material = new THREE.MeshBasicMaterial({
                map: texture,
                side: THREE.DoubleSide,
                blending: THREE.NormalBlending,
                transparent: true
            });
            _this.mediaMesh = new THREE.Mesh(geometry, material);
            _this.mediaMesh.material.depthWrite = false;
            _this.mediaMesh.material.depthTest = false;
            _this.mediaMesh.renderOrder = 975;
            _this.mediaMesh.position.z = 0.01;
            var offset = (0,getRelativePaddingTop/* getRelativePaddingTop */.X)(_this.inputs.html);
            _this.mediaMesh.position.y = (_this.popupMesh.geometry.parameters.height - _this.mediaMesh.geometry.parameters.height) * 0.5 - offset * _this.popupMesh.geometry.parameters.height;
            _this.popupMesh.add(_this.mediaMesh);
        });
    };
    _proto.initCloseBtn = function initCloseBtn() {
        var THREE = this.context.three;
        var geometry = new THREE.PlaneGeometry(1, 1);
        var texture = new THREE.TextureLoader().load("/images/close-icon.png");
        var material = new THREE.MeshBasicMaterial({
            map: texture,
            side: THREE.DoubleSide,
            transparent: true,
            color: "white"
        });
        var mesh = new THREE.Mesh(geometry, material);
        mesh.position.set(0.25, this.popupMesh.geometry.parameters.height * 0.5, 0);
        mesh.scale.setScalar(0.1);
        mesh.name = "closeBtn";
        mesh.renderOrder = 980;
        this.popupMesh.add(mesh);
        mesh.position.z = -0.1;
    };
    _proto.addMeshPointerEvents = function addMeshPointerEvents() {
        var group = new InteractiveGroup/* InteractiveGroup */.e(this.context.renderer, this.context.camera, this.context);
        this.context.camera.parent.parent.add(group);
        this.root.add(group);
        this.popupMeshInteractiveGroup = group;
        group.add(this.popupMesh);
        this.initCloseBtn();
    };
    _proto.setHostPose = function setHostPose(pose) {
        if (!pose) return;
        this.hostPose = pose;
    };
    _proto.setPopupFromPose = function setPopupFromPose(pose) {
        var THREE = this.context.three;
        var ref = getXZCoordinatesOnCircle(0.85, pose.rotation.y + 180), x = ref.x, z = ref.z;
        var worldPosition = new THREE.Vector3(pose.position.x + x, pose.position.y - 0.2, pose.position.z + z); // Replace with your world coordinates
        var localPosition = this.root.worldToLocal(worldPosition);
        this.popupMeshInteractiveGroup.position.copy(localPosition);
        this.popupMeshInteractiveGroup.lookAt(pose.position.x, pose.position.y - 0.1, pose.position.z);
    };
    _proto.setPopupFromHostPose = function setPopupFromHostPose() {
        this.setPopupFromPose(this.hostPose);
    };
    _proto.cycleVR = function cycleVR(session) {
        this.lookAtHost();
    };
    _proto.lookAtHost = function lookAtHost() {
        this.root.lookAt(this.hostPose.position.x, this.hostPose.position.y, this.hostPose.position.z);
        this.popupMesh.lookAt(this.hostPose.position.x, this.hostPose.position.y, this.hostPose.position.z);
    };
    _proto.onInputsUpdated = function onInputsUpdated(previousInputs) {
        if (previousInputs.popupVisible !== this.inputs.popupVisible) {
            if (this.inputs.popupVisible) {
                this.popupMesh.scale.setScalar(this.inputs.popupScale);
                if (this.hostPose) this.setPopupFromHostPose();
            } else this.popupMesh.scale.setScalar(0);
        }
        if (previousInputs.visible !== this.inputs.visible) {
            this.root.visible = this.inputs.visible;
        }
    };
    _proto.onTick = function onTick() {
        var _this = this;
        var ref, ref1, ref2;
        if ((ref = this.context) === null || ref === void 0 ? void 0 : (ref1 = ref.renderer) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.xr) === null || ref2 === void 0 ? void 0 : ref2.isPresenting) {
            var _session = this.context.renderer.xr.getSession();
            _session.requestAnimationFrame(function() {
                return _this.cycleVR(_session);
            });
        }
    };
    return MatterTagMeshComponent;
}(AbstractHTMLMesh/* AbstractHTMLMesh */.n);
var matterTagMeshComponentType = "mp.matterTagMeshComponent";
var makeMatterTagMeshComponent = function() {
    return new MatterTagMeshComponent();
};

// EXTERNAL MODULE: ./node_modules/three/build/three.module.js
var three_module = __webpack_require__(99477);
// EXTERNAL MODULE: ./_models/virtualStaging/HTMLMesh/component/Menu/types.ts
var types = __webpack_require__(20093);
;// CONCATENATED MODULE: ./_models/virtualStaging/HTMLMesh/component/Menu/MenuMesh.component.ts
// eslint-disable-next-line @typescript-eslint/ban-ts-comment










var MenuMeshComponent = /*#__PURE__*/ function(AbstractHTMLMesh) {
    "use strict";
    (0,_inherits/* default */.Z)(MenuMeshComponent, AbstractHTMLMesh);
    var _super = (0,_create_super/* default */.Z)(MenuMeshComponent);
    function MenuMeshComponent() {
        (0,_class_call_check/* default */.Z)(this, MenuMeshComponent);
        var _this;
        _this = _super.apply(this, arguments);
        _this.selectedItemIndex = 0;
        _this.gamepadButtonCallback = null;
        _this.thumbStickCallback = null;
        _this.triggerCallback = null;
        _this.inputs = {
            html: null,
            visible: false,
            scale: 1,
            itemRefArr: [],
            controller: types/* ControllerType.GamepadL */.C.GamepadL,
            controllerButtonIndex: 4,
            yOffset: -0.2
        };
        return _this;
    }
    var _proto = MenuMeshComponent.prototype;
    _proto.onInit = function onInit() {
        var html = this.inputs.html;
        this.initMesh(html);
        this.initRoot();
        this.addMeshPointerEvents();
        this.getXRController();
        this.outputs.loadingState = VSObject/* LoadingState.Loaded */.Gu.Loaded;
    };
    _proto.initMesh = function initMesh(html) {
        this.mesh = (0,HTMLMesh/* createHTMLMesh */.x)(html, this.context.three);
        this.mesh.material.side = this.context.three.DoubleSide;
        this.mesh.material.depthWrite = false;
        this.mesh.material.depthTest = false;
        this.mesh.renderOrder = 980;
        this.mesh.scale.setScalar(2);
        this.mesh.userData = {
            isPointerOver: false
        };
    };
    _proto.addMeshPointerEvents = function addMeshPointerEvents() {
        this.interactiveGroup = new InteractiveGroup/* InteractiveGroup */.e(this.context.renderer, this.context.camera, this.context);
        this.pivot.add(this.interactiveGroup);
        this.interactiveGroup.add(this.mesh);
    };
    _proto.setHostPose = function setHostPose(pose) {
        this.hostPose = pose;
    };
    _proto.setPositionFromPose = function setPositionFromPose(pose) {
        var ref = getXZCoordinatesOnCircle(0.85, pose.rotation.y + 180), x = ref.x, z = ref.z;
        this.root.position.set(pose.position.x + x, pose.position.y + this.inputs.yOffset, pose.position.z + z);
        this.root.lookAt(pose.position.x, pose.position.y - 0.1, pose.position.z);
    };
    _proto.setFromHostPose = function setFromHostPose() {
        this.setPositionFromPose(this.hostPose);
    };
    _proto.setFromController = function setFromController(controller) {
        var controllerWorld = new three_module/* Vector3 */.Pa4();
        controller.getWorldPosition(controllerWorld);
        this.root.position.copy(controllerWorld);
    };
    _proto.updateMesh = function updateMesh() {
        this.interactiveGroup.traverse(function(el) {
            if (el.material) {
                var material = el.material;
                if (material.map) material.map.dispose();
                material.dispose();
            }
            if (el.geometry) {
                el.geometry.dispose();
            }
        });
        this.pivot.remove(this.interactiveGroup);
        this.initMesh(this.inputs.html);
        this.addMeshPointerEvents();
    };
    _proto.selectItem = function selectItem(index) {
        if (!this.inputs.itemRefArr[this.selectedItemIndex] || !this.inputs.itemRefArr[index]) return;
        this.inputs.itemRefArr[this.selectedItemIndex].style.backgroundColor = "transparent";
        this.inputs.itemRefArr[index].style.backgroundColor = "blue";
        this.selectedItemIndex = index;
    };
    _proto.selectItemUp = function selectItemUp() {
        this.selectItem(this.inputs.itemRefArr.length - 1 === this.selectedItemIndex ? 0 : this.selectedItemIndex + 1);
    };
    _proto.selectItemDown = function selectItemDown() {
        this.selectItem(this.selectedItemIndex === 0 ? this.inputs.itemRefArr.length - 1 : this.selectedItemIndex - 1);
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _proto.cycleVR = function cycleVR(_session) {
        if (this.hostPose && this.inputs.visible) this.setFromHostPose();
        if (this.inputs.controller) {
            var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
            if (this[this.inputs.controller]) {
                if (!this.gamepadThumbStickYActive && (this[this.inputs.controller].axes[3] < -0.5 || this[this.inputs.controller].axes[3] > 0.5)) {
                    this.gamepadThumbStickYActive = true;
                    var directionY = this[this.inputs.controller].axes[3] > 0.5 ? 1 : -1;
                    if (directionY === 1) this.selectItemUp();
                    if (directionY === -1) this.selectItemDown();
                    if (this.thumbStickCallback) this.thumbStickCallback(this[this.inputs.controller].axes);
                }
                if (this.gamepadThumbStickYActive && this[this.inputs.controller].axes[3] >= -0.5 && this[this.inputs.controller].axes[3] <= 0.5) {
                    this.gamepadThumbStickYActive = false;
                }
            }
            if (((ref1 = (ref = this[this.inputs.controller]) === null || ref === void 0 ? void 0 : ref.buttons[this.inputs.controllerButtonIndex]) === null || ref1 === void 0 ? void 0 : ref1.pressed) && !this.gamepadButtonActive && this.hostPose) {
                var ref8;
                this.setVisible(!this.inputs.visible);
                this.gamepadButtonActive = true;
                if (this.gamepadButtonCallback) this.gamepadButtonCallback((ref8 = this[this.inputs.controller]) === null || ref8 === void 0 ? void 0 : ref8.buttons[this.inputs.controllerButtonIndex]);
            }
            if (!((ref3 = (ref2 = this[this.inputs.controller]) === null || ref2 === void 0 ? void 0 : ref2.buttons[this.inputs.controllerButtonIndex]) === null || ref3 === void 0 ? void 0 : ref3.pressed) && this.gamepadButtonActive) {
                this.gamepadButtonActive = false;
            }
            if (((ref5 = (ref4 = this[this.inputs.controller]) === null || ref4 === void 0 ? void 0 : ref4.buttons[4]) === null || ref5 === void 0 ? void 0 : ref5.pressed) && !this.triggerActive && this.hostPose) {
                var ref9;
                this.triggerActive = true;
                if (this.triggerCallback) this.triggerCallback((ref9 = this[this.inputs.controller]) === null || ref9 === void 0 ? void 0 : ref9.buttons);
            }
            if (!((ref7 = (ref6 = this[this.inputs.controller]) === null || ref6 === void 0 ? void 0 : ref6.buttons[4]) === null || ref7 === void 0 ? void 0 : ref7.pressed) && this.triggerActive) {
                this.triggerActive = false;
            }
        }
    };
    _proto.onTick = function onTick() {
        var _this = this;
        var ref, ref1, ref2;
        if ((ref = this.context) === null || ref === void 0 ? void 0 : (ref1 = ref.renderer) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.xr) === null || ref2 === void 0 ? void 0 : ref2.isPresenting) {
            var _session = this.context.renderer.xr.getSession();
            _session.requestAnimationFrame(function() {
                return _this.cycleVR(_session);
            });
        }
    };
    return MenuMeshComponent;
}(AbstractHTMLMesh/* AbstractHTMLMesh */.n);
var menuMeshComponentType = "mp.menuMeshComponent";
var makeMenuMeshComponent = function() {
    return new MenuMeshComponent();
};

;// CONCATENATED MODULE: ./_models/virtualStaging/HTMLMesh/component/PathFinder/PathFinderMesh.component.tsx
// eslint-disable-next-line @typescript-eslint/ban-ts-comment









var PathFinderMeshComponent = /*#__PURE__*/ function(AbstractHTMLMesh) {
    "use strict";
    (0,_inherits/* default */.Z)(PathFinderMeshComponent, AbstractHTMLMesh);
    var _super = (0,_create_super/* default */.Z)(PathFinderMeshComponent);
    function PathFinderMeshComponent() {
        (0,_class_call_check/* default */.Z)(this, PathFinderMeshComponent);
        var _this;
        _this = _super.apply(this, arguments);
        _this.inputs = {
            html: null,
            visible: false,
            scale: 1,
            refs: null,
            hasPathFinderData: false
        };
        return _this;
    }
    var _proto = PathFinderMeshComponent.prototype;
    _proto.onInit = function onInit() {
        var html = this.inputs.html;
        this.initPathFinderMesh(html);
        this.initRoot();
        this.addMeshPointerEvents();
        this.getXRController();
        this.outputs.loadingState = VSObject/* LoadingState.Loaded */.Gu.Loaded;
    };
    _proto.initPathFinderMesh = function initPathFinderMesh(pathFinderHTML) {
        this.mesh = (0,HTMLMesh/* createHTMLMesh */.x)(pathFinderHTML, this.context.three);
        this.mesh.material.side = this.context.three.DoubleSide;
        this.mesh.material.depthWrite = false;
        this.mesh.material.depthTest = false;
        this.mesh.renderOrder = 970;
        this.mesh.scale.setScalar(2);
        this.mesh.userData = {
            isPointerOver: false
        };
    };
    _proto.addMeshPointerEvents = function addMeshPointerEvents() {
        var group = new InteractiveGroup/* InteractiveGroup */.e(this.context.renderer, this.context.camera, this.context);
        this.pivot.add(group);
        group.add(this.mesh);
    };
    _proto.setHostPose = function setHostPose(pose) {
        this.hostPose = pose;
    };
    _proto.setPositionFromPose = function setPositionFromPose(pose) {
        if (!pose.rotation || !pose.position) return;
        var ref = getXZCoordinatesOnCircle(0.85, pose.rotation.y + 180), x = ref.x, z = ref.z;
        this.root.position.set(pose.position.x + x, pose.position.y - 0.2, pose.position.z + z);
        this.root.lookAt(pose.position.x, pose.position.y - 0.1, pose.position.z);
    };
    _proto.setFromHostPose = function setFromHostPose() {
        this.setPositionFromPose(this.hostPose);
    };
    _proto.setOnControllerButtonSecondaryClicked = function setOnControllerButtonSecondaryClicked(cb) {
        this.onControllerButtonSecondaryClicked = cb;
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _proto.cycleVR = function cycleVR(_session) {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
        tween_module_min/* TWEEN.update */.w.update();
        if (((ref1 = (ref = this.gamepadR) === null || ref === void 0 ? void 0 : ref.buttons[4]) === null || ref1 === void 0 ? void 0 : ref1.pressed) && !this.gamepadButtonActive && this.hostPose && this.inputs.hasPathFinderData) {
            this.setVisible(!this.inputs.visible);
            this.setFromHostPose();
            this.gamepadButtonActive = true;
        }
        if (!((ref3 = (ref2 = this.gamepadR) === null || ref2 === void 0 ? void 0 : ref2.buttons[4]) === null || ref3 === void 0 ? void 0 : ref3.pressed) && this.gamepadButtonActive) {
            this.gamepadButtonActive = false;
        }
        if (((ref5 = (ref4 = this.gamepadR) === null || ref4 === void 0 ? void 0 : ref4.buttons[5]) === null || ref5 === void 0 ? void 0 : ref5.pressed) && !this.gamepadButtonSecondaryActive && this.hostPose && this.inputs.hasPathFinderData) {
            this.gamepadButtonSecondaryActive = true;
        }
        if (!((ref7 = (ref6 = this.gamepadR) === null || ref6 === void 0 ? void 0 : ref6.buttons[5]) === null || ref7 === void 0 ? void 0 : ref7.pressed) && this.gamepadButtonSecondaryActive) {
            this.gamepadButtonSecondaryActive = false;
            if (this.onControllerButtonSecondaryClicked) this.onControllerButtonSecondaryClicked();
        }
    };
    _proto.onTick = function onTick() {
        var _this = this;
        var ref, ref1, ref2;
        if ((ref = this.context) === null || ref === void 0 ? void 0 : (ref1 = ref.renderer) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.xr) === null || ref2 === void 0 ? void 0 : ref2.isPresenting) {
            var _session = this.context.renderer.xr.getSession();
            _session.requestAnimationFrame(function() {
                return _this.cycleVR(_session);
            });
        }
    };
    return PathFinderMeshComponent;
}(AbstractHTMLMesh/* AbstractHTMLMesh */.n);
var pathFinderMeshComponentType = "mp.pathFinderMeshComponent";
var makePathFinderMeshComponent = function() {
    return new PathFinderMeshComponent();
};

;// CONCATENATED MODULE: ./_models/virtualStaging/HTMLMesh/utils/createBackpackhtml.ts
var createBackpackhtml = function(items) {
    var wrapper = document.createElement("div");
    wrapper.id = "backpack-mesh";
    wrapper.className = "backpack-mesh-wrapper";
    var container = document.createElement("div");
    container.className = "backpack-mesh";
    wrapper.appendChild(container);
    var header = document.createElement("div");
    header.className = "backpack-mesh-header";
    header.innerHTML = "Backpack";
    var content = document.createElement("div");
    content.className = "backpack-mesh-content";
    var itemElements = [];
    items.forEach(function(item) {
        var count = document.createElement("p");
        count.className = "backpack-mesh-item";
        count.id = item.name;
        count.innerHTML = "".concat(item.name, " ").concat(item.collected.length, "/").concat(item.solution.split("|").length);
        content.appendChild(count);
        itemElements.push({
            name: item.name,
            ref: count
        });
    });
    container.appendChild(header);
    container.appendChild(content);
    document.body.appendChild(wrapper);
    return {
        html: wrapper,
        refs: {
            header: header,
            content: content,
            itemElements: itemElements
        }
    };
};

;// CONCATENATED MODULE: ./_models/virtualStaging/HTMLMesh/utils/createMatterTagHTML.ts
var createMatterTagHTML = function(tag, media, dimensions) {
    var container = document.createElement("div");
    container.id = "tag-mesh";
    container.className = "tag-mesh-wrapper";
    container.style.width = "".concat(dimensions.width, "px");
    var header = document.createElement("div");
    header.className = "tag-mesh-header";
    header.innerHTML = tag.title;
    var content = document.createElement("div");
    content.className = "tag-mesh-content";
    var description = document.createElement("div");
    description.className = "tag-mesh-description";
    description.innerHTML = tag.type === "text" ? tag.text : tag.description;
    content.appendChild(description);
    var imageContainer = null;
    if (media) {
        imageContainer = document.createElement("img");
        imageContainer.className = "tag-mesh-image";
        container.prepend(imageContainer);
    }
    container.appendChild(header);
    container.appendChild(content);
    document.body.appendChild(container);
    return {
        html: container,
        imageContainer: imageContainer
    };
};

;// CONCATENATED MODULE: ./_models/virtualStaging/HTMLMesh/utils/createMenuHTML.ts
var createMenuHTML = function(menus) {
    var container = document.createElement("div");
    container.id = "menu-mesh";
    container.className = "menu-mesh-wrapper";
    container.style.height = "".concat(60 + 36 * menus.length, "px");
    var header = document.createElement("div");
    header.className = "menu-mesh-header";
    header.innerHTML = "Menu";
    var content = document.createElement("div");
    content.className = "menu-mesh-content";
    var itemRefArr = [];
    menus.forEach(function(menu) {
        var menuItem = document.createElement("div");
        menuItem.className = "menu-mesh-item";
        menuItem.innerHTML = menu.title;
        itemRefArr.push(menuItem);
        content.appendChild(menuItem);
    });
    container.appendChild(header);
    container.appendChild(content);
    document.body.appendChild(container);
    return {
        html: container,
        itemRefArr: itemRefArr
    };
};
var createFlowsMenuHTML = function(menus) {
    var container = document.createElement("div");
    container.id = "menu-mesh";
    container.className = "menu-mesh-wrapper";
    container.style.height = "".concat(60 + 36 * menus.length, "px");
    var header = document.createElement("div");
    header.className = "menu-mesh-header";
    header.innerHTML = "Menu";
    var content = document.createElement("div");
    content.className = "menu-mesh-content";
    var itemRefArr = [];
    menus.forEach(function(menu, index) {
        var menuItem = document.createElement("div");
        menuItem.className = "menu-mesh-item";
        menuItem.innerHTML = menu.name;
        menuItem.dataset.indexNumber = index;
        if (index === 0) menuItem.style.backgroundColor = "blue";
        itemRefArr.push(menuItem);
        content.appendChild(menuItem);
    });
    container.appendChild(header);
    container.appendChild(content);
    document.body.appendChild(container);
    return {
        html: container,
        itemRefArr: itemRefArr
    };
};
var createFlowsBarHTML = function() {
    var container = document.createElement("div");
    container.id = "flows-bar";
    container.className = "flows-bar";
    // container.style.height = `${60 + 36 * menus.length}px`;
    var info = document.createElement("div");
    info.className = "flows-bar-info";
    var title = document.createElement("span");
    title.className = "flows-bar-title";
    title.innerHTML = "Title";
    var description = document.createElement("span");
    description.className = "flows-bar-description";
    description.innerHTML = "This is a test message, change this this is a test message, this  is a test message, change thisThis is a test message, change This is a test message, change this this is a test message";
    info.appendChild(title);
    info.appendChild(description);
    var buttonBack = document.createElement("div");
    buttonBack.className = "flows-bar-button flows-bar-button-wide";
    var buttonBackText = document.createElement("span");
    buttonBackText.innerHTML = "Back";
    buttonBack.appendChild(buttonBackText);
    var buttonNext = document.createElement("div");
    buttonNext.className = "flows-bar-button flows-bar-button-wide";
    var buttonNextText = document.createElement("span");
    buttonNextText.innerHTML = "Next";
    buttonNext.appendChild(buttonNextText);
    var buttonTeleport = document.createElement("div");
    buttonTeleport.className = "flows-bar-button flows-bar-button-wide";
    var buttonTeleportText = document.createElement("span");
    buttonTeleportText.innerHTML = "Teleport";
    buttonTeleport.appendChild(buttonTeleportText);
    var itemRefArr = [
        buttonBack,
        buttonNext,
        buttonTeleport
    ];
    // menus.forEach((menu, index) => {
    //   const menuItem = document.createElement('div');
    //   menuItem.className = 'menu-mesh-item';
    //   menuItem.innerHTML = menu.name;
    //   menuItem.dataset.indexNumber = index;
    //   if (index === 0) menuItem.style.backgroundColor = 'blue';
    //   itemRefArr.push(menuItem);
    //   content.appendChild(menuItem);
    // });
    container.appendChild(info);
    container.appendChild(buttonBack);
    container.appendChild(buttonNext);
    container.appendChild(buttonTeleport);
    // buttonBack.outerHTML = ' <div class="flows-bar-button"><i class="fa-solid fa-arrow-left"/></div>';
    //
    // buttonTeleport.outerHTML =
    //   '<div class="flows-bar-button">' +
    //   ' <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
    //   '      <path\n' +
    //   '        d="M5.54069 11.998C5.54069 8.43063 8.43259 5.53874 11.9999 5.53874M5.54069 11.998C5.54069 15.5653 8.43259 18.4572 11.9999 18.4572M5.54069 11.998L3.69519 11.998M11.9999 5.53874C15.5673 5.53874 18.4592 8.43064 18.4592 11.998M11.9999 5.53874L11.9999 3.69324M11.9999 18.4572C15.5673 18.4572 18.4592 15.5653 18.4592 11.998M11.9999 18.4572L11.9999 20.3027M18.4592 11.998L20.3047 11.998M9.23169 11.998C9.23169 10.4691 10.471 9.22974 11.9999 9.22974C13.5288 9.22974 14.7682 10.4691 14.7682 11.998C14.7682 13.5269 13.5288 14.7662 11.9999 14.7662C10.471 14.7662 9.23169 13.5269 9.23169 11.998Z"\n' +
    //   '        stroke="#2055FF"\n' +
    //   '        strokeWidth="1.81195"\n' +
    //   '        strokeLinecap="round"\n' +
    //   '        strokeLinejoin="round"\n' +
    //   '      />\n' +
    //   '    </svg>' +
    //   '</div>';
    document.body.appendChild(container);
    return {
        html: container,
        itemRefArr: itemRefArr
    };
};

;// CONCATENATED MODULE: ./_models/virtualStaging/HTMLMesh/utils/createPathFinderHTML.ts
var createPathFinderHTML = function() {
    var container = document.createElement("div");
    container.id = "pf-mesh";
    container.className = "pf-mesh-wrapper";
    var header = document.createElement("div");
    header.className = "pf-mesh-header";
    header.innerHTML = "";
    var content = document.createElement("div");
    content.className = "pf-mesh-content";
    var description = document.createElement("div");
    description.className = "pf-mesh-content-description";
    description.innerHTML = "";
    var stepCount = document.createElement("div");
    stepCount.className = "pf-mesh-content-step-count";
    stepCount.innerHTML = "";
    var footer = document.createElement("div");
    footer.className = "pf-mesh-footer";
    var buttonBack = document.createElement("button");
    buttonBack.className = "pf-mesh-button pf-mesh-button--back";
    buttonBack.innerHTML = "PREVIOUS";
    var buttonNext = document.createElement("button");
    buttonNext.className = "pf-mesh-button pf-mesh-button--next";
    buttonNext.innerHTML = "NEXT";
    content.appendChild(description);
    content.appendChild(stepCount);
    footer.appendChild(buttonBack);
    footer.appendChild(buttonNext);
    container.appendChild(header);
    container.appendChild(content);
    container.appendChild(footer);
    document.body.appendChild(container);
    return {
        html: container,
        refs: {
            header: header,
            description: description,
            stepCount: stepCount,
            footer: footer,
            buttonBack: buttonBack,
            buttonNext: buttonNext
        }
    };
};

;// CONCATENATED MODULE: ./_models/virtualStaging/HTMLMesh/utils/pathFinderUtils.ts
var hasPathFinderData = function(pathfinderDataState) {
    return !(Object.keys(pathfinderDataState).length === 0);
};
var updateStylesAndContent = function(param) {
    var pathFinderMeshComponent = param.pathFinderMeshComponent, pathfinderDataState = param.pathfinderDataState, game = param.game, prevPathFinderData = param.prevPathFinderData;
    var ref, ref1, ref2;
    var stepIndex = game === null || game === void 0 ? void 0 : (ref = game.paths) === null || ref === void 0 ? void 0 : (ref1 = ref.paths) === null || ref1 === void 0 ? void 0 : ref1.findIndex(function(step) {
        return step.id === pathfinderDataState.currentPathStepId;
    });
    var _refs = pathFinderMeshComponent.inputs.refs, header = _refs.header, description = _refs.description, stepCount = _refs.stepCount, footer = _refs.footer, buttonNext = _refs.buttonNext, buttonBack = _refs.buttonBack;
    var ref3 = (pathfinderDataState === null || pathfinderDataState === void 0 ? void 0 : pathfinderDataState.pathSettings) || {}, backgroundColor = ref3.backgroundColor, colorButton = ref3.colorButton, colorButtonText = ref3.colorButtonText, colorText = ref3.colorText, titleColorText = ref3.titleColorText, titleEnabled = ref3.titleEnabled, stepEnabled = ref3.stepEnabled;
    var _inputs = pathFinderMeshComponent.inputs, html = _inputs.html, refs = _inputs.refs;
    if (backgroundColor) html.style.backgroundColor = backgroundColor;
    if (colorButton) refs.buttonNext.style.backgroundColor = colorButton;
    if (colorButtonText) refs.buttonNext.style.color = colorButtonText;
    if (colorText) refs.description.style.color = colorText;
    if (titleEnabled) {
        header.innerHTML = pathfinderDataState.title;
        header.style.color = titleColorText || "black";
        header.style.width = "600px";
    }
    if (stepEnabled && typeof stepIndex === "number") {
        var ref4, ref5;
        stepCount.innerHTML = "Step ".concat(stepIndex + 1, "/").concat(game === null || game === void 0 ? void 0 : (ref4 = game.paths) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.paths) === null || ref5 === void 0 ? void 0 : ref5.length);
        stepCount.style.color = colorText || "black";
    }
    if (pathfinderDataState === null || pathfinderDataState === void 0 ? void 0 : pathfinderDataState.isEnablePreviousStep) {
        buttonBack.style.display = "flex";
        footer.style.justifyContent = "space-between";
    } else {
        buttonBack.style.display = "none";
        footer.style.justifyContent = "end";
    }
    buttonNext.innerHTML = ((ref2 = pathfinderDataState.translation) === null || ref2 === void 0 ? void 0 : ref2.next) || "Next";
    description.innerHTML = pathfinderDataState.description;
    prevPathFinderData.description = pathfinderDataState.description;
    prevPathFinderData.isEnablePreviousStep = pathfinderDataState.isEnablePreviousStep;
};

// EXTERNAL MODULE: ./node_modules/three/src/math/MathUtils.js
var MathUtils = __webpack_require__(69542);
;// CONCATENATED MODULE: ./_models/virtualStaging/VRCameraController/index.ts



var VRCameraController = /*#__PURE__*/ function() {
    "use strict";
    function VRCameraController(THREE, renderer, camera, cameraPose) {
        (0,_class_call_check/* default */.Z)(this, VRCameraController);
        this.THREE = THREE;
        this.renderer = renderer;
        this.camera = camera;
        this.cameraPose = cameraPose;
    }
    var _proto = VRCameraController.prototype;
    // rotate VR view based on camera sweep and object for camera to look at
    _proto.rotateVRView = function rotateVRView(targetSweep, targetObj) {
        var _this = this;
        if (!this.baseReferenceSpace) {
            this.baseReferenceSpace = this.renderer.xr.getReferenceSpace();
        }
        var geometry = new this.THREE.BoxGeometry(1, 1, 1);
        var material = new this.THREE.MeshBasicMaterial({
            color: 0x000000,
            transparent: true,
            side: this.THREE.DoubleSide,
            opacity: 0,
            depthTest: false,
            depthWrite: false
        });
        var helperObj = new this.THREE.Mesh(geometry, material);
        this.camera.parent.parent.add(helperObj);
        helperObj.position.set(targetSweep.position.x, targetSweep.position.y, targetSweep.position.z);
        new tween_module_min/* TWEEN.Tween */.w.Tween(helperObj.material).to({
            opacity: 1
        }, 150).start().onComplete(function() {
            var transform2 = new XRRigidTransform(new _this.THREE.Vector3(), {
                x: 0,
                y: 0,
                z: 0,
                w: 1
            });
            var teleportSpaceOffset2 = _this.baseReferenceSpace.getOffsetReferenceSpace(transform2);
            _this.renderer.xr.setReferenceSpace(teleportSpaceOffset2);
            setTimeout(function() {
                var posAvatar = new _this.THREE.Vector3();
                _this.camera.getWorldPosition(posAvatar);
                var posObj = new _this.THREE.Vector3();
                if (targetObj) targetObj.getWorldPosition(posObj);
                else if (targetObj.hasOwnProperty("positionX") && targetObj.hasOwnProperty("positionY") && targetObj.hasOwnProperty("positionZ")) {
                    posObj.set(targetObj.position.x, targetObj.position.y, targetObj.position.z);
                }
                var xDist = posObj.x - posAvatar.x;
                var zDist = posObj.z - posAvatar.z;
                var angle = Math.atan2(zDist, xDist);
                var quaternion = new _this.THREE.Quaternion();
                quaternion.setFromAxisAngle(new _this.THREE.Vector3(0, 1, 0), (0,MathUtils/* degToRad */.Id)(_this.cameraPose.current.rotation.y) + angle + Math.PI / 2);
                var transform = new XRRigidTransform(new _this.THREE.Vector3(), {
                    x: quaternion.x,
                    y: quaternion.y,
                    z: quaternion.z,
                    w: quaternion.w
                });
                var teleportSpaceOffset = _this.baseReferenceSpace.getOffsetReferenceSpace(transform);
                _this.renderer.xr.setReferenceSpace(teleportSpaceOffset);
                new tween_module_min/* TWEEN.Tween */.w.Tween(helperObj.material).to({
                    opacity: 0
                }, 150).onComplete(function() {
                    _this.camera.parent.parent.remove(helperObj);
                    geometry.dispose();
                    material.dispose();
                    if (targetObj.userData.temp) {
                        _this.camera.parent.parent.remove(targetObj);
                        targetObj.geometry.dispose();
                        targetObj.material.dispose();
                    }
                }).start();
            }, 300);
        });
    };
    // Create helper object based on target camera rotation direction then rotate VR view
    _proto.rotateVRViewByCameraRotation = function rotateVRViewByCameraRotation(targetSweep, rotation) {
        var vec = this.getDirectionFromRotation(rotation.x, rotation.y);
        var geometry = new this.THREE.SphereGeometry(0.3, 32, 16);
        var material = new this.THREE.MeshBasicMaterial({
            color: 0xffff00
        });
        var sphere = new this.THREE.Mesh(geometry, material);
        sphere.visible = false;
        sphere.position.set(targetSweep.position.x + vec.x, targetSweep.position.y + vec.y, targetSweep.position.z + vec.z);
        this.camera.parent.parent.add(sphere);
        sphere.userData = {
            temp: true
        };
        this.rotateVRView(targetSweep, sphere);
    };
    _proto.getDirectionFromRotation = function getDirectionFromRotation(rotationX, rotationY) {
        var forward = new this.THREE.Vector3(0, 0, -1);
        var euler = new this.THREE.Euler(this.THREE.MathUtils.degToRad(rotationX), this.THREE.MathUtils.degToRad(rotationY), 0, "YXZ");
        forward.applyEuler(euler);
        return forward;
    };
    return VRCameraController;
}();

;// CONCATENATED MODULE: ./_models/virtualStaging/VRPointer/component/VRPointer.component.ts






var VRPointerComponent = /*#__PURE__*/ function(SceneComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(VRPointerComponent, SceneComponent);
    var _super = (0,_create_super/* default */.Z)(VRPointerComponent);
    function VRPointerComponent() {
        (0,_class_call_check/* default */.Z)(this, VRPointerComponent);
        var _this;
        _this = _super.apply(this, arguments);
        _this.root = null;
        _this.pivot = null;
        _this.inputs = {
            visible: false,
            scale: 0.05,
            offset: {
                x: 0.006,
                y: -0.025,
                z: 0.03
            }
        };
        _this.outputs = {
            loadingState: VSObject/* LoadingState.Idle */.Gu.Idle
        };
        var _obj;
        _this.events = (_obj = {}, (0,_define_property/* default */.Z)(_obj, Scene_component/* ComponentInteractionType.CLICK */.td.CLICK, false), (0,_define_property/* default */.Z)(_obj, Scene_component/* ComponentInteractionType.HOVER */.td.HOVER, false), (0,_define_property/* default */.Z)(_obj, Scene_component/* ComponentInteractionType.DRAG */.td.DRAG, false), _obj);
        return _this;
    }
    var _proto = VRPointerComponent.prototype;
    _proto.onInit = function onInit() {
        var _this = this;
        var ref, ref1, ref2, ref3;
        var THREE = this.context.three;
        this.root = new THREE.Object3D();
        this.pivot = new THREE.Object3D();
        this.vec3 = new THREE.Vector3();
        this.root.add(this.pivot);
        this.outputs.objectRoot = this.root;
        this.root.visible = this.inputs.visible;
        this.pivot.visible = false;
        (ref = this.context.renderer) === null || ref === void 0 ? void 0 : (ref1 = ref.xr) === null || ref1 === void 0 ? void 0 : ref1.addEventListener("sessionstart", function() {
            _this.pivot.visible = true;
        });
        (ref2 = this.context.renderer) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.xr) === null || ref3 === void 0 ? void 0 : ref3.addEventListener("sessionend", function() {
            _this.pivot.visible = false;
        });
        this.createPointer();
    };
    _proto.createPointer = function createPointer() {
        var _this = this;
        var THREE = this.context.three;
        new THREE.TextureLoader().load("/images/pointer_vr.png", function(texture) {
            var material = new THREE.MeshBasicMaterial({
                map: texture,
                side: THREE.DoubleSide,
                transparent: true
            });
            var geometry = new THREE.PlaneGeometry(1, 1);
            var mesh = new THREE.Mesh(geometry, material);
            var _offset = _this.inputs.offset, x = _offset.x, y = _offset.y, z = _offset.z;
            mesh.position.set(x, y, z);
            mesh.scale.setScalar(_this.inputs.scale);
            mesh.material.depthWrite = false;
            mesh.material.depthTest = false;
            mesh.renderOrder = 990;
            _this.pointerMesh = mesh;
            _this.pivot.add(mesh);
            _this.outputs.loadingState = VSObject/* LoadingState.Loaded */.Gu.Loaded;
        });
    };
    _proto.setVisible = function setVisible(visible) {
        this.inputs.visible = visible;
    };
    _proto.onInputsUpdated = function onInputsUpdated(previousInputs) {
        this.root.visible = this.inputs.visible;
    };
    _proto.cycleVR = function cycleVR(_session) {
        this.hostPose.getWorldPosition(this.vec3);
        var _vec3 = this.vec3, x = _vec3.x, y = _vec3.y, z = _vec3.z;
        this.root.lookAt(x, y, z);
    };
    _proto.onTick = function onTick() {
        var _this = this;
        if (this.root && this.hostPose) {
            var ref, ref1, ref2;
            if ((ref = this.context) === null || ref === void 0 ? void 0 : (ref1 = ref.renderer) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.xr) === null || ref2 === void 0 ? void 0 : ref2.isPresenting) {
                var _session = this.context.renderer.xr.getSession();
                _session.requestAnimationFrame(function() {
                    return _this.cycleVR(_session);
                });
            }
        }
    };
    _proto.onDestroy = function onDestroy() {};
    return VRPointerComponent;
}(Scene_component/* SceneComponent */.Ad);
var VRPointerComponentType = "mp.VRPointerComponent";
var makeVRPointerComponent = function() {
    return new VRPointerComponent();
};

// EXTERNAL MODULE: ./api/queries.ts
var queries = __webpack_require__(79575);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(18533);
;// CONCATENATED MODULE: ./components/common/VSHTMLPopup/VSHTMLPopup.styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: fixed;\n  z-index: 999;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100vw;\n  height: 100vh;\n  background: rgba(0, 0, 0, 0.67);\n  backdrop-filter: blur(5px);\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 80%;\n  height: 75%;\n  margin-bottom: ",
        "; ;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  width: 100%;\n  flex-grow: 1;\n  background-color: white;\n  border-radius: 10px;\n  margin-bottom: ",
        "; ;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 35px;\n  height: 35px;\n  border-radius: 100rem;\n  background-color: white;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 10px;\n  width: 100%;\n  height: 100%;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  display: ",
        "; ;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}

var Overlay = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "VSHTMLPopup.styles__Overlay",
    componentId: "sc-c159b39c-0"
})(_templateObject());
var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "VSHTMLPopup.styles__Container",
    componentId: "sc-c159b39c-1"
})(_templateObject1(), function(props) {
    return props.isHorizontal ? "2%" : "10%";
});
var Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "VSHTMLPopup.styles__Content",
    componentId: "sc-c159b39c-2"
})(_templateObject2(), function(props) {
    return props.isHorizontal ? "2%" : "10%";
});
var Button = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    displayName: "VSHTMLPopup.styles__Button",
    componentId: "sc-c159b39c-3"
})(_templateObject3());
var IFrame = styled_components_browser_esm/* default.iframe.withConfig */.ZP.iframe.withConfig({
    displayName: "VSHTMLPopup.styles__IFrame",
    componentId: "sc-c159b39c-4"
})(_templateObject4());
var LoaderContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "VSHTMLPopup.styles__LoaderContainer",
    componentId: "sc-c159b39c-5"
})(_templateObject5(), function(props) {
    return props.show ? "block" : "none";
});

;// CONCATENATED MODULE: ./components/common/VSHTMLPopup/index.tsx





var VSHTMLPopup = function(param) {
    var setShow = param.setShow, src = param.src;
    var ref = (0,react.useState)(true), showLoader = ref[0], setShowLoader = ref[1];
    var isHorizontal = deviceManager/* default.isHorizontalMobileView */.Z.isHorizontalMobileView();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Overlay, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
            onClick: function() {
                setShow(false);
            },
            isHorizontal: isHorizontal,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Content, {
                    isHorizontal: isHorizontal,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LoaderContainer, {
                            show: showLoader,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Loader */.aN, {
                                color: "black"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(IFrame, {
                            src: src,
                            onLoad: function() {
                                setShowLoader(false);
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "/images/cross.svg",
                        alt: "close"
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/tour/addPinnedVideoFunc.ts

var addPinnedVideoFunc = function(p, pinnedVideosData, cb) {
    try {
        var ref;
        if (((ref = p.track) === null || ref === void 0 ? void 0 : ref.kind) === "video") {
            var pinnedVideos = (0,_to_consumable_array/* default */.Z)(pinnedVideosData);
            var index = pinnedVideos.findIndex(function(i) {
                return i.sid === p.sid;
            });
            var dominantIndex = pinnedVideos.findIndex(function(i) {
                return i.pinned === true;
            });
            if (dominantIndex >= 0) {
                var dominantSpeaker = pinnedVideos[dominantIndex];
                // replace the dominant speaker, first remove it
                if (dominantSpeaker.sid !== p.sid) {
                    pinnedVideos.splice(dominantIndex, 1);
                }
            }
            if (index >= 0) {
                pinnedVideos[index] = p;
            } else {
                pinnedVideos.push(p);
            }
            cb(pinnedVideos);
        }
    } catch (e) {
        console.error(e);
    }
};

;// CONCATENATED MODULE: ./components/tour/components/CrashScreen/styled.ts

function styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow: hidden;\n  font-family: 'Roboto';\n  font-size: 16px;\n  color: white;\n  width: 100vw;\n  height: 100vh;\n  margin: 0;\n  z-index: 999;\n  position: absolute;\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  align-items: center;\n  background: #333;\n\n  ",
        "\n"
    ]);
    styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-image: url('/images/crash.svg');\n  background-size: cover;\n  height: 12.5em;\n  width: 12.5em;\n"
    ]);
    styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 50px auto 0 auto;\n  max-width: 700px;\n  text-align: center;\n  ",
        "\n"
    ]);
    styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 400;\n  font-size: 3em;\n  line-height: 116.7%;\n  text-align: center;\n  color: #ffffff;\n  margin: 0 auto 30px;\n"
    ]);
    styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: none;\n  font-size: 1.25em;\n  padding: 0 50px;\n  margin-bottom: 30px;\n  line-height: 160%;\n  letter-spacing: 0.15px;\n"
    ]);
    styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 1em;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n\n  & > button {\n    margin-right: 1.25em;\n  }\n"
    ]);
    styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  padding: 6px 16px;\n  min-height: 40px;\n  background: rgba(107, 107, 107, 0.01);\n  border: 1px solid #ffffff;\n  border-radius: 4px;\n  color: white;\n\n  & > i {\n    margin-right: 0.2em;\n  }\n\n  &:hover {\n    opacity: 0.7;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}

var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styled__Wrapper",
    componentId: "sc-bbe0105e-0"
})(styled_templateObject(), function(param) {
    var theme = param.theme;
    return theme.device.mobile && "\n    font-size: 12px;\n    height: calc(var(--vh, 1vh) * 100);\n  ";
});
var ImageBlock = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styled__ImageBlock",
    componentId: "sc-bbe0105e-1"
})(styled_templateObject1());
var TextBlockWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styled__TextBlockWrap",
    componentId: "sc-bbe0105e-2"
})(styled_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.device.mobile && "\n      margin-top: 20px;\n      ".concat(!theme.device.landscape && "max-width: 320px;", "\n    ");
});
var TitleText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styled__TitleText",
    componentId: "sc-bbe0105e-3"
})(styled_templateObject3());
var DescriptionText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styled__DescriptionText",
    componentId: "sc-bbe0105e-4"
})(styled_templateObject4());
var ButtonWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styled__ButtonWrap",
    componentId: "sc-bbe0105e-5"
})(styled_templateObject5());
var styled_Button = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    displayName: "styled__Button",
    componentId: "sc-bbe0105e-6"
})(_templateObject6());

;// CONCATENATED MODULE: ./components/tour/components/CrashScreen/index.tsx


var defaultTranslation = {
    crashScreenTitle: "Seems like something isn't working",
    crashScreenDescription: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    crashScreenRestoreBtn: "Restore",
    crashScreenRefreshBtn: "Reload"
};
var CrashScreen = function(param) {
    var show = param.show, onRestore = param.onRestore, backgroundImage = param.backgroundImage;
    var refresh = function() {
        window.location.reload();
    };
    if (!show) return null;
    var crashScreenTitle = defaultTranslation.crashScreenTitle, crashScreenRestoreBtn = defaultTranslation.crashScreenRestoreBtn, crashScreenRefreshBtn = defaultTranslation.crashScreenRefreshBtn, crashScreenDescription = defaultTranslation.crashScreenDescription;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        backgroundImage: backgroundImage,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageBlock, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TextBlockWrap, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleText, {
                        className: "titleText",
                        children: crashScreenTitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DescriptionText, {
                        children: crashScreenDescription
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonWrap, {
                children: [
                    onRestore && /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_Button, {
                        className: "mb-2",
                        onClick: onRestore,
                        children: crashScreenRestoreBtn
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_Button, {
                        className: "mb-2",
                        onClick: refresh,
                        children: crashScreenRefreshBtn
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_CrashScreen = (CrashScreen);

// EXTERNAL MODULE: ./components/tour/game/ScreenNavigationArrow/index.tsx
var ScreenNavigationArrow = __webpack_require__(20000);
;// CONCATENATED MODULE: ./components/tour/getIframeStyle.ts
var getIframeStyle = function(param) {
    var tour = param.tour, activeSweepGroup = param.activeSweepGroup, sweepGroups = param.sweepGroups;
    var iframeStyle = {};
    if (tour) {
        var brightness = tour.brightness === 1 ? "" : "brightness(".concat(tour.brightness, ")");
        var saturation = tour.saturation === 1 ? "" : "saturate(".concat(tour.saturation, ")");
        var contrast = tour.contrast === 1 ? "" : "contrast(".concat(tour.contrast, ")");
        iframeStyle = {
            filter: "".concat(brightness, " ").concat(saturation, " ").concat(contrast)
        };
        if (activeSweepGroup) {
            var sweepGroup = sweepGroups.find(function(sg) {
                return sg.id === activeSweepGroup;
            });
            if (sweepGroup) {
                var hasColorSettings = sweepGroup.brightness !== 1 || sweepGroup.saturation !== 1 || sweepGroup.contrast !== 1;
                if (hasColorSettings) {
                    var sweepBrightness = sweepGroup.brightness === 1 ? "" : "brightness(".concat(sweepGroup.brightness, ")");
                    var sweepSaturation = sweepGroup.saturation === 1 ? "" : "saturate(".concat(sweepGroup.saturation, ")");
                    var sweepContrast = sweepGroup.contrast === 1 ? "" : "contrast(".concat(sweepGroup.contrast, ")");
                    iframeStyle = {
                        filter: "".concat(sweepBrightness, " ").concat(sweepSaturation, " ").concat(sweepContrast)
                    };
                }
            }
        }
    }
    return iframeStyle;
};

;// CONCATENATED MODULE: ./components/tour/getUrlVariables.ts

var getUrlVariables = function(url, iframeUrl) {
    var id = (0,util/* getQueryVariable */.Dv)(url, "m");
    var iframeId = (0,util/* getQueryVariable */.Dv)(iframeUrl, "m");
    var start = (0,util/* getQueryVariable */.Dv)(url, "start");
    // normal
    var sr = (0,util/* getQueryVariable */.Dv)(url, "sr"); // rotation
    var ss = (0,util/* getQueryVariable */.Dv)(url, "ss"); // sweep
    // floor plan or dollhouse
    var sm = (0,util/* getQueryVariable */.Dv)(url, "sm"); // mode
    var sz = (0,util/* getQueryVariable */.Dv)(url, "sz"); // zoom
    var sp = (0,util/* getQueryVariable */.Dv)(url, "sp"); // position
    var linkData = start ? JSON.parse(String(start)) : false;
    var rand = Math.floor(Math.random() * 1000000 + 1);
    var linkDataShort = sr && ss ? {
        sr: sr.split(","),
        ss: parseInt(String(ss), 10)
    } : false;
    if (!linkDataShort) linkDataShort = sp && sr && sm ? {
        sm: parseInt(sm, 10),
        sr: sr.split(","),
        sp: sp.split(","),
        sz: sz ? parseFloat(String(sz)) : null
    } : false;
    return {
        id: id,
        iframeId: iframeId,
        linkData: linkData,
        rand: rand,
        linkDataShort: linkDataShort
    };
};

;// CONCATENATED MODULE: ./components/tour/logoutHandler.ts




var logoutHandler = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var ticket, ticketingOrderedTicket;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ticket = param.ticket, ticketingOrderedTicket = param.ticketingOrderedTicket;
                    if (!(ticket && ticketingOrderedTicket && ticketingOrderedTicket.ticketType === "tourByYourself")) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        TreedisPublicDAO/* default.logoutTicket */.Z.logoutTicket({
                            ticketId: ticketingOrderedTicket === null || ticketingOrderedTicket === void 0 ? void 0 : ticketingOrderedTicket.id,
                            deviceId: (0,utils/* getDeviceFingerprint */.UI)()
                        })
                    ];
                case 1:
                    _state.sent();
                    _state.label = 2;
                case 2:
                    return [
                        2
                    ];
            }
        });
    });
    return function logoutHandler(_) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./components/tour/stopApp.ts
var stopApp = function() {
    console.log("[reload] BaseTour.stopApp");
    window.location.reload();
};

;// CONCATENATED MODULE: ./components/tour/takePositionData.ts


var takePositionData = function(param) {
    var slug = param.slug, matterId = param.matterId, sweep = param.sweep, rotation = param.rotation;
    var segmants = window.location.href.split("/");
    var id = segmants[segmants.length - 1].split("?")[0];
    if (slug === id || matterId === id) {
        (0,util_all/* copyToClipboard */.vQ)((0,util_all/* buildLink */.DF)(sweep, rotation));
    } else {
        var baseUrl = (0,util_all/* getBaseURL */.BS)();
        var updatedUrl = baseUrl.split("/").map(function(part, index, arr) {
            return index === arr.length - 1 ? slug : part;
        }).join("/");
        var link = "".concat(updatedUrl, "?s=").concat(sweep, "&x=").concat(rotation.x, "&y=").concat(rotation.y);
        (0,util_all/* copyToClipboard */.vQ)(link);
    }
    react_toastify_esm/* toast.success */.Am.success("Copied current position");
};

// EXTERNAL MODULE: ./components/types.ts
var components_types = __webpack_require__(31828);
// EXTERNAL MODULE: ./hooks/useCookies.tsx
var useCookies = __webpack_require__(77666);
// EXTERNAL MODULE: ./units/index.ts + 32 modules
var units = __webpack_require__(19326);
// EXTERNAL MODULE: ./utils/extractSweepIdFromURL.ts
var extractSweepIdFromURL = __webpack_require__(33797);
;// CONCATENATED MODULE: ./utils/getProjectedQuaternion.ts
var getProjectedQuaternion = function(pos, target, axisVec, THREE) {
    var dir = new THREE.Vector3();
    dir.subVectors(target, pos).normalize();
    dir.projectOnPlane(axisVec);
    var mx = new THREE.Matrix4().lookAt(dir, new THREE.Vector3(0, 0, 0), new THREE.Vector3(0, 1, 0));
    return new THREE.Quaternion().setFromRotationMatrix(mx);
};

;// CONCATENATED MODULE: ./utils/getRPMModelId.ts
var getRPMModelId = function(url) {
    return url.substring(url.lastIndexOf("/") + 1).split(".glb").at(0);
};

// EXTERNAL MODULE: ./utils/randomNumberId.ts
var randomNumberId = __webpack_require__(18066);
// EXTERNAL MODULE: ./components-new/common/AudioModule.ts + 2 modules
var AudioModule = __webpack_require__(29519);
// EXTERNAL MODULE: ./node_modules/socket.io-client/build/esm/index.js + 27 modules
var esm = __webpack_require__(18847);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
;// CONCATENATED MODULE: ./components/iot/icons.tsx

var LockedIcon = /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
    width: "18",
    height: "18",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
        d: "M9 9.75V11.625M6 6.75V4.5C6 2.84314 7.34314 1.5 9 1.5C10.6568 1.5 12 2.84314 12 4.5V6.75M5.25 14.25H12.75C13.5784 14.25 14.25 13.5784 14.25 12.75V8.25C14.25 7.42157 13.5784 6.75 12.75 6.75H5.25C4.42157 6.75 3.75 7.42157 3.75 8.25V12.75C3.75 13.5784 4.42157 14.25 5.25 14.25Z",
        stroke: "#ED0E1B",
        strokeWidth: "1.40724",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    })
});
var LockdownIcon = /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
    width: "18",
    height: "18",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12.3164 6.71698C12.3164 7.09003 12.014 7.39245 11.6409 7.39245H5.2321C4.85904 7.39245 4.55662 7.09003 4.55662 6.71698C4.55662 6.34392 4.85904 6.0415 5.2321 6.0415L11.6409 6.0415C12.014 6.0415 12.3164 6.34392 12.3164 6.71698Z",
            fill: "#ED0E1B"
        }),
        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M6.80941 2.83363C6.55546 3.03843 6.34595 3.35583 6.25145 3.8828C6.18546 4.25071 5.89434 4.5568 5.52055 4.5568C5.14676 4.5568 4.83742 4.2524 4.88375 3.88149C4.99491 2.99155 5.34083 2.27905 5.95969 1.77997C6.69664 1.18565 7.69538 1 8.76055 1C11.1856 1 12.3173 2.77928 12.3173 4.1968V6.1105C12.6479 6.1773 13.0074 6.29762 13.3388 6.49645C13.9566 6.86718 14.4773 7.51991 14.4773 8.5168V9.93803C14.4773 10.3036 14.181 10.6 13.8154 10.6C13.4551 10.6 13.161 10.3119 13.1536 9.95178L13.1237 8.5168C13.1237 8.07369 12.9245 7.82642 12.6423 7.65715C12.3249 7.46667 11.9143 7.3936 11.6405 7.3936C11.2668 7.3936 10.9638 7.09059 10.9638 6.7168V4.1968C10.9638 3.45432 10.3675 2.3536 8.76055 2.3536C7.80972 2.3536 7.18846 2.52795 6.80941 2.83363Z",
            fill: "#ED0E1B"
        }),
        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M3 5.27686L15 13.96L3 5.27686Z",
            fill: "#ED0E1B"
        }),
        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M3 5.27686L15 13.96",
            stroke: "#ED0E1B",
            strokeWidth: "1.3536",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }),
        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M4.3536 12.5131C4.3536 12.8685 4.48653 13.0254 4.61226 13.1159C4.77249 13.2313 4.9851 13.2763 5.1168 13.2763H11.7653C12.1391 13.2763 12.4421 13.5793 12.4421 13.9531C12.4421 14.3269 12.1391 14.6299 11.7653 14.6299H5.1168C4.7685 14.6299 4.26111 14.531 3.82134 14.2144C3.34707 13.8729 3 13.3097 3 12.5131V8.91313C3 8.53934 3.30301 8.23633 3.6768 8.23633C4.05059 8.23633 4.3536 8.53934 4.3536 8.91313V12.5131Z",
            fill: "#ED0E1B"
        }),
        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M13.1386 13.5131C13.6129 13.1717 14.4922 14.857 14.4922 14.0604V9.91313C14.4922 9.53934 14.1892 9.23633 13.8154 9.23633C13.4416 9.23633 13.1386 9.53934 13.1386 9.91313V13.5131Z",
            fill: "#ED0E1B"
        })
    ]
});
var UnlockedIcon = /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
    width: "18",
    height: "18",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
        d: "M9 9.75V11.625M6.08979 3.76858C6.41632 2.46524 7.5954 1.5 9 1.5C10.6568 1.5 12 2.84314 12 4.5V6.75M5.25 14.25H12.75C13.5784 14.25 14.25 13.5784 14.25 12.75V8.25C14.25 7.42157 13.5784 6.75 12.75 6.75H5.25C4.42157 6.75 3.75 7.42157 3.75 8.25V12.75C3.75 13.5784 4.42157 14.25 5.25 14.25Z",
        stroke: "#1BAC29",
        strokeWidth: "1.40724",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    })
});

;// CONCATENATED MODULE: ./components/iot/config.tsx





var CDN = "https://cdn.treedis.com/assets";
var LOCKED_IMAGE_TITLE = "iot_locked_image";
var UNLOCKED_IMAGE_TITLE = "iot_unlocked_image";
var LOCKDOWN_IMAGE_TITLE = "iot_lockdown_image";
var IOT_TOAST_CONFIG = {
    hideProgressBar: true,
    autoClose: 3000,
    closeOnClick: false,
    closeButton: false,
    style: {
        borderRadius: "3px",
        background: "rgba(0, 0, 0, 0.7)",
        color: "#fff",
        height: "40px"
    }
};
var iotToast = function(message, icon, type) {
    var t = type ? react_toastify_esm/* toast */.Am[type] : react_toastify_esm/* toast */.Am;
    t(message, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, IOT_TOAST_CONFIG), {
        // eslint-disable-next-line no-nested-ternary
        icon: icon === "lockdown" ? LockdownIcon : icon === "unlocked" ? UnlockedIcon : icon === "locked" ? LockedIcon : undefined,
        // To prevent duplicate toasts
        toastId: (0,lodash.snakeCase)(message)
    }));
};
var getDeviceMediaImage = function(d) {
    if (d.lockedDown) {
        return {
            title: LOCKDOWN_IMAGE_TITLE,
            url: "".concat(CDN, "/lockdown_high_res.png")
        };
    }
    if (d.unlocked) {
        return {
            title: UNLOCKED_IMAGE_TITLE,
            url: "".concat(CDN, "/unlocked_high_res.png")
        };
    }
    return {
        title: LOCKED_IMAGE_TITLE,
        url: "".concat(CDN, "/locked_high_res.png")
    };
};

;// CONCATENATED MODULE: ./components/iot/IotLogic.tsx











function IotLogic(param) {
    var showcaseProp = param.showcase, iot = param.iot, tourId = param.tourId, tourSlug = param.tourSlug, updateIotState = param.updateIotState, setState = param.setState, moveToTagIO = param.moveToTagIO;
    var ref = (0,react.useState)(), devices = ref[0], setDevices = ref[1];
    var ref1 = (0,react.useState)(), providers = ref1[0], setProviders = ref1[1];
    var scene = showcaseProp.scene, showcase = showcaseProp.showcase;
    var sceneAssets = iot.sceneAssets, lockDeviceId = iot.lockDeviceId, moveToDevice = iot.moveToDevice;
    var initialDataRequest = (0,react.useRef)(false);
    var initialStreamRequest = (0,react.useRef)(false);
    var msSqlProvider = (0,react.useMemo)(function() {
        return providers === null || providers === void 0 ? void 0 : providers.find(function(provider) {
            var ref;
            return (provider === null || provider === void 0 ? void 0 : (ref = provider.provider) === null || ref === void 0 ? void 0 : ref.name) === dist/* EIoTProviders.MS_SQL */.hJ.MS_SQL;
        });
    }, [
        providers
    ]);
    var rhombusProvider = (0,react.useMemo)(function() {
        return providers === null || providers === void 0 ? void 0 : providers.find(function(provider) {
            var ref;
            return (provider === null || provider === void 0 ? void 0 : (ref = provider.provider) === null || ref === void 0 ? void 0 : ref.name) === dist/* EIoTProviders.RHOMBUS */.hJ.RHOMBUS;
        });
    }, [
        providers
    ]);
    var twinmakerProvider = (0,react.useMemo)(function() {
        return providers === null || providers === void 0 ? void 0 : providers.find(function(provider) {
            var ref;
            return (provider === null || provider === void 0 ? void 0 : (ref = provider.provider) === null || ref === void 0 ? void 0 : ref.name) === dist/* EIoTProviders.TWINMAKER */.hJ.TWINMAKER;
        });
    }, [
        providers
    ]);
    var tanklogixProvider = (0,react.useMemo)(function() {
        return providers === null || providers === void 0 ? void 0 : providers.find(function(provider) {
            var ref;
            return (provider === null || provider === void 0 ? void 0 : (ref = provider.provider) === null || ref === void 0 ? void 0 : ref.name) === dist/* EIoTProviders.TANKLOGIX */.hJ.TANKLOGIX;
        });
    }, [
        providers
    ]);
    var msSqlDevices = (0,react.useMemo)(function() {
        return devices === null || devices === void 0 ? void 0 : devices.filter(function(d) {
            var ref;
            return d.providerId === (msSqlProvider === null || msSqlProvider === void 0 ? void 0 : (ref = msSqlProvider.provider) === null || ref === void 0 ? void 0 : ref.id);
        });
    }, [
        devices,
        msSqlProvider
    ]);
    var rhombusDevices = (0,react.useMemo)(function() {
        return devices === null || devices === void 0 ? void 0 : devices.filter(function(d) {
            var ref;
            return d.providerId === (rhombusProvider === null || rhombusProvider === void 0 ? void 0 : (ref = rhombusProvider.provider) === null || ref === void 0 ? void 0 : ref.id);
        });
    }, [
        devices,
        rhombusProvider
    ]);
    var twinmakerDevices = (0,react.useMemo)(function() {
        return devices === null || devices === void 0 ? void 0 : devices.filter(function(d) {
            var ref;
            return d.providerId === (twinmakerProvider === null || twinmakerProvider === void 0 ? void 0 : (ref = twinmakerProvider.provider) === null || ref === void 0 ? void 0 : ref.id);
        });
    }, [
        devices,
        twinmakerProvider
    ]);
    var tanklogixDevices = (0,react.useMemo)(function() {
        return devices === null || devices === void 0 ? void 0 : devices.filter(function(d) {
            var ref;
            return d.providerId === (tanklogixProvider === null || tanklogixProvider === void 0 ? void 0 : (ref = tanklogixProvider.provider) === null || ref === void 0 ? void 0 : ref.id);
        });
    }, [
        devices,
        tanklogixProvider
    ]);
    (0,react.useEffect)(function() {
        (0,_async_to_generator/* default */.Z)(function() {
            var providersRes;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setDevices(iot === null || iot === void 0 ? void 0 : iot.devices);
                        return [
                            4,
                            TreedisPublicDAO/* default.getIoTProviders */.Z.getIoTProviders({
                                query: {
                                    tourId: tourId
                                }
                            })
                        ];
                    case 1:
                        providersRes = _state.sent();
                        setProviders(providersRes === null || providersRes === void 0 ? void 0 : providersRes.data);
                        return [
                            2
                        ];
                }
            });
        })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        iot
    ]);
    (0,react.useEffect)(function() {
        if ((rhombusDevices === null || rhombusDevices === void 0 ? void 0 : rhombusDevices.length) && !initialStreamRequest.current) {
            (0,_async_to_generator/* default */.Z)(function() {
                var promises, result, updatedDevices, favouriteCameras;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            promises = rhombusDevices.map(function() {
                                var _ref = (0,_async_to_generator/* default */.Z)(function(device) {
                                    var ref, stream, ref1;
                                    return (0,tslib_es6.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                return [
                                                    4,
                                                    TreedisPublicDAO/* default.getStream */.Z.getStream({
                                                        query: {
                                                            providerId: device.providerId,
                                                            deviceId: device.id,
                                                            tourId: device.tourId
                                                        }
                                                    })
                                                ];
                                            case 1:
                                                stream = _state.sent();
                                                if (stream === null || stream === void 0 ? void 0 : (ref = stream.data) === null || ref === void 0 ? void 0 : ref.sharedLiveVideoStreamUrl) {
                                                    ;
                                                    device.videoUrl = stream === null || stream === void 0 ? void 0 : (ref1 = stream.data) === null || ref1 === void 0 ? void 0 : ref1.sharedLiveVideoStreamUrl;
                                                }
                                                return [
                                                    2,
                                                    device
                                                ];
                                        }
                                    });
                                });
                                return function(device) {
                                    return _ref.apply(this, arguments);
                                };
                            }());
                            initialStreamRequest.current = true;
                            return [
                                4,
                                Promise.all(promises)
                            ];
                        case 1:
                            result = _state.sent();
                            updatedDevices = devices === null || devices === void 0 ? void 0 : devices.map(function(d) {
                                var ref;
                                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, d), {
                                    videoUrl: (ref = result === null || result === void 0 ? void 0 : result.find(function(rd) {
                                        return rd.id === d.id;
                                    })) === null || ref === void 0 ? void 0 : ref.videoUrl
                                });
                            });
                            return [
                                4,
                                TreedisPublicDAO/* default.getFavouriteCameras */.Z.getFavouriteCameras({
                                    query: {
                                        tourId: tourId
                                    }
                                })
                            ];
                        case 2:
                            favouriteCameras = _state.sent();
                            updateIotState({
                                devices: updatedDevices,
                                providers: providers,
                                favouriteCameras: favouriteCameras === null || favouriteCameras === void 0 ? void 0 : favouriteCameras.data
                            });
                            return [
                                2
                            ];
                    }
                });
            })();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        rhombusDevices
    ]);
    (0,react.useEffect)(function() {
        function fetchAndUpdateDeviceData() {
            return _fetchAndUpdateDeviceData.apply(this, arguments);
        }
        function _fetchAndUpdateDeviceData() {
            _fetchAndUpdateDeviceData = (0,_async_to_generator/* default */.Z)(function() {
                var deviceDataRes, updatedDevices, deviceDataRes1, updatedDevices1;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!(msSqlDevices === null || msSqlDevices === void 0 ? void 0 : msSqlDevices.length)) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                TreedisPublicDAO/* default.getIoTMSSQLDevicesData */.Z.getIoTMSSQLDevicesData(tourSlug, {
                                    tags: msSqlDevices === null || msSqlDevices === void 0 ? void 0 : msSqlDevices.map(function(d) {
                                        return d.externalDeviceId;
                                    })
                                })
                            ];
                        case 1:
                            deviceDataRes = _state.sent();
                            updatedDevices = devices === null || devices === void 0 ? void 0 : devices.map(function(d) {
                                var ref, ref1, ref2, ref3;
                                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, d), {
                                    value: (ref1 = deviceDataRes === null || deviceDataRes === void 0 ? void 0 : (ref = deviceDataRes.data) === null || ref === void 0 ? void 0 : ref.find(function(dd) {
                                        return dd.tag === d.externalDeviceId;
                                    })) === null || ref1 === void 0 ? void 0 : ref1.value,
                                    time: (ref3 = deviceDataRes === null || deviceDataRes === void 0 ? void 0 : (ref2 = deviceDataRes.data) === null || ref2 === void 0 ? void 0 : ref2.find(function(dd) {
                                        return dd.tag === d.externalDeviceId;
                                    })) === null || ref3 === void 0 ? void 0 : ref3.time
                                });
                            });
                            updateIotState({
                                devices: updatedDevices,
                                providers: providers
                            });
                            _state.label = 2;
                        case 2:
                            if (!(twinmakerDevices === null || twinmakerDevices === void 0 ? void 0 : twinmakerDevices.length)) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                TreedisPublicDAO/* default.getIoTTwinmakerDevicesData */.Z.getIoTTwinmakerDevicesData(tourSlug, {
                                    tags: twinmakerDevices === null || twinmakerDevices === void 0 ? void 0 : twinmakerDevices.map(function(d) {
                                        return d.externalDeviceId;
                                    })
                                })
                            ];
                        case 3:
                            deviceDataRes1 = _state.sent();
                            updatedDevices1 = devices === null || devices === void 0 ? void 0 : devices.map(function(d) {
                                var ref, ref1, ref2, ref3;
                                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, d), {
                                    value: (ref1 = deviceDataRes1 === null || deviceDataRes1 === void 0 ? void 0 : (ref = deviceDataRes1.data) === null || ref === void 0 ? void 0 : ref.find(function(dd) {
                                        return (dd === null || dd === void 0 ? void 0 : dd.name) === (d === null || d === void 0 ? void 0 : d.externalDeviceId);
                                    })) === null || ref1 === void 0 ? void 0 : ref1.value,
                                    time: (ref3 = deviceDataRes1 === null || deviceDataRes1 === void 0 ? void 0 : (ref2 = deviceDataRes1.data) === null || ref2 === void 0 ? void 0 : ref2.find(function(dd) {
                                        return (dd === null || dd === void 0 ? void 0 : dd.name) === (d === null || d === void 0 ? void 0 : d.externalDeviceId);
                                    })) === null || ref3 === void 0 ? void 0 : ref3.timestamp
                                });
                            });
                            updateIotState({
                                devices: updatedDevices1,
                                providers: providers
                            });
                            _state.label = 4;
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return _fetchAndUpdateDeviceData.apply(this, arguments);
        }
        var intervalId;
        if ((msSqlDevices === null || msSqlDevices === void 0 ? void 0 : msSqlDevices.length) || (twinmakerDevices === null || twinmakerDevices === void 0 ? void 0 : twinmakerDevices.length)) {
            if (!initialDataRequest.current) {
                fetchAndUpdateDeviceData();
                initialDataRequest.current = true;
            }
            intervalId = setInterval(function() {
                fetchAndUpdateDeviceData();
            }, 300000);
        }
        return function() {
            if (intervalId) {
                clearInterval(intervalId);
            }
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        msSqlDevices,
        twinmakerDevices
    ]);
    (0,react.useEffect)(function() {
        function fetchAndUpdateDeviceData() {
            return _fetchAndUpdateDeviceData.apply(this, arguments);
        }
        function _fetchAndUpdateDeviceData() {
            _fetchAndUpdateDeviceData = (0,_async_to_generator/* default */.Z)(function() {
                var ref, deviceDataRes, updatedDevices;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!(tanklogixDevices === null || tanklogixDevices === void 0 ? void 0 : tanklogixDevices.length)) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                TreedisPublicDAO/* default.getIotTanklogixData */.Z.getIotTanklogixData({
                                    query: {
                                        tourId: tanklogixProvider === null || tanklogixProvider === void 0 ? void 0 : tanklogixProvider.tourId,
                                        providerId: tanklogixProvider === null || tanklogixProvider === void 0 ? void 0 : tanklogixProvider.providerId
                                    }
                                })
                            ];
                        case 1:
                            deviceDataRes = _state.sent();
                            if ((deviceDataRes === null || deviceDataRes === void 0 ? void 0 : (ref = deviceDataRes.data) === null || ref === void 0 ? void 0 : ref.length) > 0) {
                                updatedDevices = devices === null || devices === void 0 ? void 0 : devices.map(function(d) {
                                    var ref;
                                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, d), {
                                        additionalInfo: deviceDataRes === null || deviceDataRes === void 0 ? void 0 : (ref = deviceDataRes.data) === null || ref === void 0 ? void 0 : ref.find(function(dd) {
                                            var ref;
                                            return (dd === null || dd === void 0 ? void 0 : dd.TagPath) === (d === null || d === void 0 ? void 0 : (ref = d.additionalInfo) === null || ref === void 0 ? void 0 : ref.TagPath);
                                        })
                                    });
                                });
                                updateIotState({
                                    devices: updatedDevices,
                                    providers: providers
                                });
                            }
                            _state.label = 2;
                        case 2:
                            return [
                                2
                            ];
                    }
                });
            });
            return _fetchAndUpdateDeviceData.apply(this, arguments);
        }
        var intervalId;
        if (tanklogixDevices === null || tanklogixDevices === void 0 ? void 0 : tanklogixDevices.length) {
            if (!initialDataRequest.current) {
                fetchAndUpdateDeviceData();
                initialDataRequest.current = true;
            }
            intervalId = setInterval(function() {
                fetchAndUpdateDeviceData();
            }, 60000);
        }
        return function() {
            if (intervalId) {
                clearInterval(intervalId);
            }
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        tanklogixDevices
    ]);
    var iotRenderedAssets = (0,react.useRef)([]);
    var replaceImageSceneNode = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(asset) {
            var // If we get newAsset, it means we get a new scene vsImage to replace
            ref, ref1;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        scene === null || scene === void 0 ? void 0 : (ref = scene.sceneImage) === null || ref === void 0 ? void 0 : ref.remove(asset);
                        return [
                            4,
                            scene === null || scene === void 0 ? void 0 : (ref1 = scene.sceneImage) === null || ref1 === void 0 ? void 0 : ref1.create(asset)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(asset) {
            return _ref.apply(this, arguments);
        };
    }(), [
        scene === null || scene === void 0 ? void 0 : scene.sceneImage
    ]);
    var updateStateDevices = (0,react.useCallback)(function(deviceId, key, value) {
        setDevices(function(prev) {
            var devicesClone = (0,_to_consumable_array/* default */.Z)(prev || []);
            var idx = devicesClone.findIndex(function(d) {
                return d.id.toString() === deviceId.toString() || d.externalDeviceId.toString() === deviceId.toString();
            });
            if (idx !== -1) {
                devicesClone[idx][key] = value;
            }
            updateIotState({
                devices: devicesClone
            }); // BaseTour iot devices .. needed for iotMenu
            return devicesClone;
        });
    }, [
        updateIotState
    ]);
    var handleLockEvent = (0,react.useCallback)(function(data, locked) {
        iotToast("".concat(data.doorName, " door was ").concat(data.doorAction, "ed"), locked ? "locked" : "unlocked");
        updateIotState({
            newDoorNotification: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data), {
                text: "".concat(data.doorName, " door was ").concat(data.doorAction, "ed"),
                seen: false
            })
        });
        updateStateDevices(data.doorId, "unlocked", !locked);
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        updateStateDevices,
        iot === null || iot === void 0 ? void 0 : iot.newDoorNotification
    ]);
    var handleLockdownEvent = (0,react.useCallback)(function(data, locked) {
        iotToast("Lockdown was ".concat(locked ? "activated" : "cancelled", " for ").concat(data.doorName, " door"), locked ? "lockdown" : "locked");
        updateIotState({
            newDoorNotification: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data), {
                text: "".concat(data.doorName, " door was ").concat(data.doorAction, "ed"),
                seen: false
            })
        });
        updateStateDevices(data.doorId, "lockedDown", locked);
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        updateStateDevices
    ]);
    var handleMoveToLock = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(d) {
            var ref, ref1, ref2, relatedTag, vsObject;
            return (0,tslib_es6.__generator)(this, function(_state) {
                updateIotState({
                    moveToDevice: null
                });
                relatedTag = (ref = d.relatedAssets) === null || ref === void 0 ? void 0 : ref.find(function(a) {
                    return a.type === "tag";
                });
                if (relatedTag) {
                    moveToTagIO("".concat(relatedTag.id));
                }
                if (!d.toursVsImageId) return [
                    2
                ];
                vsObject = sceneAssets.find(function(o) {
                    return o.id === d.toursVsImageId;
                });
                if (!vsObject) return [
                    2
                ];
                showcase === null || showcase === void 0 ? void 0 : (ref1 = showcase.Sweep) === null || ref1 === void 0 ? void 0 : ref1.moveTo(vsObject.sweepUuid, {
                    rotation: {
                        x: vsObject.srX,
                        y: vsObject.srY,
                        z: vsObject.srZ
                    },
                    transition: showcase === null || showcase === void 0 ? void 0 : (ref2 = showcase.Sweep) === null || ref2 === void 0 ? void 0 : ref2.Transition.FLY
                });
                return [
                    2
                ];
            });
        });
        return function(d) {
            return _ref.apply(this, arguments);
        };
    }(), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        sceneAssets,
        updateIotState,
        showcase === null || showcase === void 0 ? void 0 : showcase.Sweep
    ]);
    var handleUnlockAgree = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(d, code) {
            var promise, res;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        promise = !d.unlocked ? TreedisPublicDAO/* default.unlockIoTDevice */.Z.unlockIoTDevice : undefined;
                        return [
                            4,
                            promise({
                                data: (0,_object_spread/* default */.Z)({
                                    tourId: tourId,
                                    deviceId: d.id,
                                    providerId: d.providerId
                                }, code && {
                                    passCode: Number(code)
                                })
                            })
                        ];
                    case 1:
                        res = _state.sent();
                        setState({
                            confirmDialog: {
                                open: false
                            }
                        });
                        if ((res === null || res === void 0 ? void 0 : res.message) !== "Success.") {
                            // Not ideal to check for message, but the status code is too generic
                            // We have situations where the message is either 'Wrong Pass Code' or 'Invalid request' and in both cases we need to show to the user 'Wrong code!'
                            // 4 digits wrong code will generate a 'Wrong Pass Code' message and 3 digits wrong code will generate a 'Invalid request' message
                            // But we also have situations where the message is 'The door has no assigned Kisi controller' and in this case we need to show to the user the message from the server
                            if ((res === null || res === void 0 ? void 0 : res.message) === "Wrong Pass Code" || (res === null || res === void 0 ? void 0 : res.message) === "Invalid request") {
                                iotToast("Wrong code!", undefined, "error");
                            } else {
                                iotToast(res === null || res === void 0 ? void 0 : res.message, undefined, "error");
                            }
                            return [
                                2
                            ];
                        }
                        updateStateDevices(d.id, "unlocked", true);
                        return [
                            2
                        ];
                }
            });
        });
        return function(d, code) {
            return _ref.apply(this, arguments);
        };
    }(), [
        setState,
        tourId,
        updateStateDevices
    ]);
    var handleUnlock = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(d) {
            var hasCode, title, desc;
            return (0,tslib_es6.__generator)(this, function(_state) {
                updateIotState({
                    lockDeviceId: null
                });
                if (d.lockedDown) {
                    iotToast("".concat(d.name, " door is on lockdown"), "lockdown");
                    return [
                        2
                    ];
                }
                if (d.unlocked) {
                    iotToast("".concat(d.name, " door will automatically lock soon"), undefined, "info");
                    return [
                        2
                    ];
                }
                hasCode = providers === null || providers === void 0 ? void 0 : providers.some(function(p) {
                    return p.hasPassCode;
                });
                title = "Confirm action";
                desc = "Are you sure you want to <br /> ".concat(!d.unlocked ? "unlock" : "lock", " ").concat(d.name, " door?");
                setState({
                    confirmDialog: {
                        open: true,
                        title: title,
                        desc: desc,
                        showInput: hasCode,
                        onAgree: function() {
                            var _ref = (0,_async_to_generator/* default */.Z)(function(code) {
                                return (0,tslib_es6.__generator)(this, function(_state) {
                                    return [
                                        2,
                                        handleUnlockAgree(d, code)
                                    ];
                                });
                            });
                            return function(code) {
                                return _ref.apply(this, arguments);
                            };
                        }(),
                        onCancel: function() {
                            setState({
                                confirmDialog: {
                                    open: false
                                }
                            });
                        }
                    }
                });
                return [
                    2
                ];
            });
        });
        return function(d) {
            return _ref.apply(this, arguments);
        };
    }(), [
        handleUnlockAgree,
        providers,
        setState,
        updateIotState
    ]);
    var connectIotSocket = (0,react.useCallback)(function() {
        var iotSocket = (0,esm.io)("https://api.treedis.com", {
            transports: [
                "websocket"
            ],
            autoConnect: true
        });
        iotSocket.on("lock-device", function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
                var ref;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    if ((ref = data.tourIds) === null || ref === void 0 ? void 0 : ref.includes(tourId)) {
                        handleLockEvent(data, true);
                    }
                    return [
                        2
                    ];
                });
            });
            return function(data) {
                return _ref.apply(this, arguments);
            };
        }());
        iotSocket.on("unlock-device", function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
                var ref;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    if ((ref = data.tourIds) === null || ref === void 0 ? void 0 : ref.includes(tourId)) {
                        handleLockEvent(data, false);
                    }
                    return [
                        2
                    ];
                });
            });
            return function(data) {
                return _ref.apply(this, arguments);
            };
        }());
        iotSocket.on("lockdown-device", function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
                var ref;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    if ((ref = data.tourIds) === null || ref === void 0 ? void 0 : ref.includes(tourId)) {
                        handleLockdownEvent(data, true);
                    }
                    return [
                        2
                    ];
                });
            });
            return function(data) {
                return _ref.apply(this, arguments);
            };
        }());
        iotSocket.on("unlockdown-device", function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
                var ref;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    if ((ref = data.tourIds) === null || ref === void 0 ? void 0 : ref.includes(tourId)) {
                        handleLockdownEvent(data, false);
                    }
                    return [
                        2
                    ];
                });
            });
            return function(data) {
                return _ref.apply(this, arguments);
            };
        }());
    }, [
        handleLockEvent,
        handleLockdownEvent,
        tourId
    ]);
    (0,react.useEffect)(function() {
        if (lockDeviceId) {
            var lockDevice = devices === null || devices === void 0 ? void 0 : devices.find(function(d) {
                return d.id === lockDeviceId || d.toursVsImageId === lockDeviceId;
            });
            if (lockDevice) handleUnlock(lockDevice);
        }
    }, [
        lockDeviceId,
        handleUnlock,
        devices
    ]);
    (0,react.useEffect)(function() {
        if (moveToDevice) {
            handleMoveToLock(moveToDevice);
        }
    }, [
        moveToDevice,
        handleMoveToLock
    ]);
    (0,react.useEffect)(function() {
        connectIotSocket();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // Updating scene IoT images/tags
    (0,react.useEffect)(function() {
        if (!scene) return;
        devices === null || devices === void 0 ? void 0 : devices.forEach(function(d) {
            var ref, ref1;
            if (!d.toursVsImageId) return;
            var asset = sceneAssets === null || sceneAssets === void 0 ? void 0 : sceneAssets.find(function(a) {
                return a.id === d.toursVsImageId;
            });
            if (!asset) return;
            var mediaImage = getDeviceMediaImage(d);
            // If asset is already rendered, we need to check if we need to replace it with a new one
            var renderedAsset = (ref = iotRenderedAssets.current) === null || ref === void 0 ? void 0 : ref.find(function(a) {
                return a.id === asset.id;
            });
            if ((mediaImage === null || mediaImage === void 0 ? void 0 : mediaImage.title) !== (renderedAsset === null || renderedAsset === void 0 ? void 0 : (ref1 = renderedAsset.details) === null || ref1 === void 0 ? void 0 : ref1.title)) {
                // @ts-ignore
                var newAsset = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, asset), {
                    details: mediaImage
                });
                replaceImageSceneNode(newAsset);
                var index = iotRenderedAssets.current.findIndex(function(a) {
                    return a.id === asset.id;
                });
                if (index !== -1) {
                    iotRenderedAssets.current[index] = newAsset;
                } else {
                    iotRenderedAssets.current.push(newAsset);
                }
            }
        });
    }, [
        devices,
        scene,
        sceneAssets,
        replaceImageSceneNode
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
}

// EXTERNAL MODULE: ./components/util/getLocationUrl.ts
var getLocationUrl = __webpack_require__(49058);
// EXTERNAL MODULE: ./components/tour/game/ClipScreen/index.tsx + 2 modules
var ClipScreen = __webpack_require__(82107);
// EXTERNAL MODULE: ./components/tour/game/GameBookHandle/index.tsx + 40 modules
var GameBookHandle = __webpack_require__(25406);
// EXTERNAL MODULE: ./components-new/eCommerce/DesktopSwitchPath.tsx
var DesktopSwitchPath = __webpack_require__(17937);
// EXTERNAL MODULE: ./node_modules/react-confirm-alert/lib/index.js
var lib = __webpack_require__(68045);
// EXTERNAL MODULE: ./hooks/index.ts + 4 modules
var hooks = __webpack_require__(19004);
// EXTERNAL MODULE: ./node_modules/react-confirm-alert/src/react-confirm-alert.css
var react_confirm_alert = __webpack_require__(27986);
;// CONCATENATED MODULE: ./components/tour/game/RegularPaths/index.tsx
/* eslint-disable react-hooks/exhaustive-deps */ /* eslint-disable no-console */ 




















var pathSnapshot = base/* asyncStore */.k6 === null || base/* asyncStore */.k6 === void 0 ? void 0 : base/* asyncStore.pathSnapshot */.k6.pathSnapshot;
var skipPathTo;
var RegularPaths = function(param) {
    var showcase = param.showcase, gamePaths = param.gamePaths, allTags = param.allTags, polygons = param.polygons, vsObjects = param.vsObjects, sweeps = param.sweeps, currentSweep = param.currentSweep, clickedElement = param.clickedElement, translation = param.translation, gameId = param.gameId, onAction = param.onAction, isRtl = param.isRtl, // panoIsOpen,
    __hideItems = param.__hideItems, __revealItems = param.__revealItems, hideElements = param.hideElements, showElements = param.showElements, pathfinderDataState = param.pathfinderDataState, setPathfinderDataState = param.setPathfinderDataState;
    var ref, ref1, ref2, ref3, ref4;
    var ref5 = (0,react.useState)(null), lockPath = ref5[0], setLockPath = ref5[1];
    var currentPathStep = (0,react.useRef)(null);
    var paths = (0,react.useRef)(new Map());
    // @ts-ignore
    var ref6 = (0,react.useState)(false), isFinish = ref6[0], setIsFinish = ref6[1];
    var ref7 = (0,react.useState)([]), finishedPaths = ref7[0], setFinishedPaths = ref7[1];
    var ref8 = (0,react.useState)(true), delayedDisable = ref8[0], setDelayedDisable = ref8[1];
    var ref9 = (0,react.useState)(false), isEnablePreviousStep = ref9[0], setIsEnablePreviousStep = ref9[1];
    var ref10 = (0,react.useState)(false), _ = ref10[0], setUpdateState = ref10[1];
    var ref11 = (0,_sliced_to_array/* default */.Z)((0,store/* useRecoilState */.FV)(store/* forceShowPathSwitchMobileModalState */.g$), 2), forceShowPathSwitchMobileModal = ref11[0], setForceShowPathSwitchMobileModal = ref11[1];
    var theme = (0,styled_components_browser_esm/* useTheme */.Fg)();
    var tagRefForData = (0,react.useRef)();
    tagRefForData.current = {
        lockPath: lockPath,
        allTags: allTags
    };
    base/* asyncStore.currentPathStep */.k6.currentPathStep = currentPathStep.current;
    (0,react.useEffect)(function() {
        var ref, ref1;
        if ((currentPathStep === null || currentPathStep === void 0 ? void 0 : (ref = currentPathStep.current) === null || ref === void 0 ? void 0 : ref.triggerItem) !== -1 && (currentPathStep === null || currentPathStep === void 0 ? void 0 : (ref1 = currentPathStep.current) === null || ref1 === void 0 ? void 0 : ref1.triggerType)) {
            setIsEnablePreviousStep(lockPath === null || lockPath === void 0 ? void 0 : lockPath.previousStep);
        } else {
            setIsEnablePreviousStep(false);
        }
    }, [
        currentPathStep === null || currentPathStep === void 0 ? void 0 : currentPathStep.current
    ]);
    (0,hooks/* useGlobalDOMEvents */.AG)({
        keyup: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(ev) {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!(ev.code === "Space")) return [
                                3,
                                2
                            ];
                            // eslint-disable-next-line no-use-before-define
                            return [
                                4,
                                handleNextStep()
                            ];
                        case 1:
                            _state.sent();
                            _state.label = 2;
                        case 2:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(ev) {
                return _ref.apply(this, arguments);
            };
        }()
    }, [
        vsObjects,
        allTags
    ]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    var goToNextStep = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(forcedLockPath) {
            var ref, ref1, _lockPath, nextStep, delay, nextStepId, ref2, ref3, step, allTagsArray, tagsToReveal, polygonsToReveal, vsImagesToReveal, vsVideosToReveal, vsItemsToReveal, ref4, ref5, prevStep, newFinishedPaths;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _lockPath = forcedLockPath || lockPath || ((ref = tagRefForData.current) === null || ref === void 0 ? void 0 : ref.lockPath);
                        nextStep = currentPathStep === null || currentPathStep === void 0 ? void 0 : (ref1 = currentPathStep.current) === null || ref1 === void 0 ? void 0 : ref1.next;
                        delay = parseInt(nextStep === null || nextStep === void 0 ? void 0 : nextStep.appearanceDelay);
                        nextStepId = nextStep === null || nextStep === void 0 ? void 0 : nextStep.id;
                        if (!(nextStepId && paths.current.has(nextStepId))) return [
                            3,
                            3
                        ];
                        step = paths === null || paths === void 0 ? void 0 : (ref2 = paths.current) === null || ref2 === void 0 ? void 0 : ref2.get(nextStepId);
                        if (!(_lockPath === null || _lockPath === void 0 ? void 0 : _lockPath.hideItems)) return [
                            3,
                            2
                        ];
                        allTagsArray = Array.from(allTags, function(param) {
                            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), value = _param[1];
                            return value;
                        });
                        tagsToReveal = step.locationType === Game/* EntityType.Tag */.py.Tag ? allTagsArray.filter(function(tag) {
                            return (tag === null || tag === void 0 ? void 0 : tag.id) === step.locationItem || tag.sid === step.locationItem || tag.defaultSid === step.locationItem;
                        }) : [];
                        polygonsToReveal = step.locationType === Game/* EntityType.Polygon */.py.Polygon ? polygons.filter(function(polygon) {
                            var ref;
                            return polygon.id === step.locationItem || ((ref = polygon.id) === null || ref === void 0 ? void 0 : ref.toString()) === step.locationItem;
                        }) : [];
                        vsImagesToReveal = step.locationType === Game/* EntityType.VSImage */.py.VSImage ? vsObjects.filter(function(object) {
                            var ref;
                            return (0,_instanceof/* default */.Z)(object, VSObject/* TourImage */.oP) && (object.id === step.locationItem || ((ref = object.id) === null || ref === void 0 ? void 0 : ref.toString()) === step.locationItem);
                        }) : [];
                        vsVideosToReveal = step.locationType === Game/* EntityType.VSVideo */.py.VSVideo ? vsObjects.filter(function(object) {
                            var ref;
                            return (0,_instanceof/* default */.Z)(object, VSObject/* TourVideo */.Up) && (object.id === step.locationItem || ((ref = object.id) === null || ref === void 0 ? void 0 : ref.toString()) === step.locationItem);
                        }) : [];
                        vsItemsToReveal = step.locationType === Game/* EntityType.VSItem */.py.VSItem ? vsObjects.filter(function(object) {
                            var ref;
                            return (0,_instanceof/* default */.Z)(object, VSObject/* TourObject */.zB) && (object.id === step.locationItem || ((ref = object.id) === null || ref === void 0 ? void 0 : ref.toString()) === step.locationItem);
                        }) : [];
                        return [
                            4,
                            showElements({
                                tagsToReveal: tagsToReveal.map(function(e) {
                                    return (e === null || e === void 0 ? void 0 : e.defaultSid) || (e === null || e === void 0 ? void 0 : e.sid);
                                }),
                                polygonsToReveal: polygonsToReveal.map(function(e) {
                                    var ref;
                                    return e === null || e === void 0 ? void 0 : (ref = e.id) === null || ref === void 0 ? void 0 : ref.toString();
                                }),
                                vsImagesToReveal: vsImagesToReveal.map(function(e) {
                                    var ref;
                                    return e === null || e === void 0 ? void 0 : (ref = e.id) === null || ref === void 0 ? void 0 : ref.toString();
                                }),
                                vsVideosToReveal: vsVideosToReveal.map(function(e) {
                                    var ref;
                                    return e === null || e === void 0 ? void 0 : (ref = e.id) === null || ref === void 0 ? void 0 : ref.toString();
                                }),
                                vsItemsToReveal: vsItemsToReveal.map(function(e) {
                                    var ref;
                                    return e === null || e === void 0 ? void 0 : (ref = e.id) === null || ref === void 0 ? void 0 : ref.toString();
                                })
                            })
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        if (currentPathStep === null || currentPathStep === void 0 ? void 0 : (ref3 = currentPathStep.current) === null || ref3 === void 0 ? void 0 : ref3.hideStep) {
                            ;
                            // hide clicked element
                            __hideItems([
                                {
                                    conditionType: "hide",
                                    entity_type: currentPathStep === null || currentPathStep === void 0 ? void 0 : (ref4 = currentPathStep.current) === null || ref4 === void 0 ? void 0 : ref4.locationType,
                                    entity_ids: [
                                        currentPathStep === null || currentPathStep === void 0 ? void 0 : (ref5 = currentPathStep.current) === null || ref5 === void 0 ? void 0 : ref5.locationItem
                                    ]
                                }
                            ]);
                        }
                        prevStep = currentPathStep === null || currentPathStep === void 0 ? void 0 : currentPathStep.current;
                        currentPathStep.current = step;
                        // if delay then path will appear with timeout / reset previous timeout
                        (0,base/* handlePathDelay */.L)(delay, setDelayedDisable);
                        if (skipPathTo && skipPathTo !== prevStep.id) {
                            goToNextStep(_lockPath);
                        } else {
                            skipPathTo = null;
                        }
                        return [
                            3,
                            4
                        ];
                    case 3:
                        skipPathTo = null;
                        newFinishedPaths = (0,_to_consumable_array/* default */.Z)(finishedPaths).concat([
                            _lockPath === null || _lockPath === void 0 ? void 0 : _lockPath.id
                        ]);
                        // check if there is another uncomoleted paths?
                        // const unfinishedPaths = gamePaths.filter((path) => !newFinishedPaths.includes(path.id));
                        // if (unfinishedPaths.length > 0) {
                        //   _changePath(unfinishedPaths[0].id);
                        // } else {
                        //   setIsFinish(true);
                        // }
                        currentPathStep.current = null;
                        paths.current = null;
                        base/* asyncStore.pathIds */.k6.pathIds = [];
                        // console.debug('aaa setLockPath null 3');
                        setLockPath(null);
                        setFinishedPaths(newFinishedPaths);
                        _state.label = 4;
                    case 4:
                        // force update of path, because it's using data from reference which is not updating it's Reference
                        setUpdateState(function(updateState) {
                            return !updateState;
                        });
                        return [
                            2
                        ];
                }
            });
        });
        return function goToNextStep(forcedLockPath) {
            return _ref.apply(this, arguments);
        };
    }();
    var goToPreviousStep = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var ref, ref1, prevStepId, ref2, step;
            return (0,tslib_es6.__generator)(this, function(_state) {
                prevStepId = currentPathStep === null || currentPathStep === void 0 ? void 0 : (ref = currentPathStep.current) === null || ref === void 0 ? void 0 : (ref1 = ref.prev) === null || ref1 === void 0 ? void 0 : ref1.id;
                if (prevStepId) {
                    ;
                    step = paths === null || paths === void 0 ? void 0 : (ref2 = paths.current) === null || ref2 === void 0 ? void 0 : ref2.get(prevStepId);
                    if (step === null || step === void 0 ? void 0 : step.hideStep) {
                        // reveal previous hidden element
                        __revealItems([
                            {
                                conditionType: "reveal",
                                entity_type: step === null || step === void 0 ? void 0 : step.locationType,
                                entity_ids: [
                                    step === null || step === void 0 ? void 0 : step.locationItem
                                ]
                            }
                        ]);
                    }
                    currentPathStep.current = step;
                } else {
                    setIsEnablePreviousStep(false);
                }
                return [
                    2
                ];
            });
        });
        return function goToPreviousStep() {
            return _ref.apply(this, arguments);
        };
    }();
    // @ts-ignore commented debug
    var belongToCurrentPath = function() {
        var _skipPathTo;
        if (lockPath === null || lockPath === void 0 ? void 0 : lockPath.allowSkipping) {
            var safeCycle = 1000; // prevent infinite loop if linked to itself or recursive
            var currentStep = currentPathStep === null || currentPathStep === void 0 ? void 0 : currentPathStep.current;
            while(safeCycle > 0 && currentStep && !_skipPathTo){
                var ref, ref1, ref2, ref3, ref4;
                if (((currentStep === null || currentStep === void 0 ? void 0 : (ref = currentStep.locationItem) === null || ref === void 0 ? void 0 : ref.toString()) === clickedElement.id.toString() || (currentStep === null || currentStep === void 0 ? void 0 : (ref1 = currentStep.locationItem) === null || ref1 === void 0 ? void 0 : ref1.toString()) === (clickedElement === null || clickedElement === void 0 ? void 0 : clickedElement.sid) || (currentStep === null || currentStep === void 0 ? void 0 : (ref2 = currentStep.locationItem) === null || ref2 === void 0 ? void 0 : ref2.toString()) === (clickedElement === null || clickedElement === void 0 ? void 0 : clickedElement.defaultSid)) && (currentStep === null || currentStep === void 0 ? void 0 : currentStep.locationType) === clickedElement.type) {
                    _skipPathTo = currentStep.id;
                }
                currentStep = (ref3 = paths.current) === null || ref3 === void 0 ? void 0 : ref3.get(currentStep === null || currentStep === void 0 ? void 0 : (ref4 = currentStep.next) === null || ref4 === void 0 ? void 0 : ref4.id);
                safeCycle--;
            }
            if (_skipPathTo) {
                skipPathTo = _skipPathTo;
                goToNextStep();
                return true;
            }
        } else {
            var ref5, ref6, ref7, ref8, ref9, ref10, ref11;
            // also check if it's belong to future steps & allowSkipping enabled
            if (((currentPathStep === null || currentPathStep === void 0 ? void 0 : (ref5 = currentPathStep.current) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.locationItem) === null || ref6 === void 0 ? void 0 : ref6.toString()) === clickedElement.id.toString() || (currentPathStep === null || currentPathStep === void 0 ? void 0 : (ref7 = currentPathStep.current) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.locationItem) === null || ref8 === void 0 ? void 0 : ref8.toString()) === (clickedElement === null || clickedElement === void 0 ? void 0 : clickedElement.sid) || (currentPathStep === null || currentPathStep === void 0 ? void 0 : (ref9 = currentPathStep.current) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.locationItem) === null || ref10 === void 0 ? void 0 : ref10.toString()) === (clickedElement === null || clickedElement === void 0 ? void 0 : clickedElement.defaultSid)) && (currentPathStep === null || currentPathStep === void 0 ? void 0 : (ref11 = currentPathStep.current) === null || ref11 === void 0 ? void 0 : ref11.locationType) === clickedElement.type) {
                goToNextStep();
                return true;
            }
            return false;
        }
    };
    (0,react.useEffect)(function() {
        if (gamePaths && (gamePaths === null || gamePaths === void 0 ? void 0 : gamePaths.length)) {
            if (gamePaths.length === 1) {
                base/* asyncStore.regularActivePath */.k6.regularActivePath = 0;
                setLockPath(gamePaths[0]);
            }
        }
    }, [
        gamePaths
    ]);
    var createPath = function(items, triggerType, triggerItem) {
        var ref;
        var step = lockPath === null || lockPath === void 0 ? void 0 : (ref = lockPath.paths) === null || ref === void 0 ? void 0 : ref.find(function(path) {
            return path.triggerType === triggerType && (path.triggerItem === triggerItem || path.triggerItem === null && triggerItem === -1);
        });
        if (!step) return items;
        var next = lockPath === null || lockPath === void 0 ? void 0 : lockPath.paths.find(function(path) {
            return path.triggerType === step.locationType && path.triggerItem === step.locationItem;
        });
        var prev = lockPath === null || lockPath === void 0 ? void 0 : lockPath.paths.find(function(path) {
            return path.locationType === step.triggerType && path.locationItem === step.triggerItem;
        });
        if (!triggerType) {
            var ref1;
            currentPathStep.current = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, step), {
                prev: prev || null,
                next: next && next.id !== step.id ? next : null
            });
            var delay = parseInt(step === null || step === void 0 ? void 0 : (ref1 = step.appearanceDelay) === null || ref1 === void 0 ? void 0 : ref1.toString());
            // if delay then path will appear with timeout / reset previous timeout
            (0,base/* handlePathDelay */.L)(delay, setDelayedDisable);
        }
        items.set(step.id, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, step), {
            prev: prev || null,
            next: next && next.id !== step.id ? next : null
        }));
        base/* asyncStore.pathIds.push */.k6.pathIds.push(step.id);
        return next && !items.get(next.id) ? createPath(items, next.triggerType, next.triggerItem) : items;
    };
    var rotateCameraTo = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(t) {
            var THREE, l, d, a, r, o, s, u, f, p, m, b, h, g, err;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            4,
                            ,
                            5
                        ]);
                        if (base/* asyncStore.vrIsOn */.k6.vrIsOn) return [
                            2,
                            console.error("Camera rotate is disabled for VR mode")
                        ];
                        return [
                            4,
                            (0,dist/* iTHREE */.Sc)()
                        ];
                    case 1:
                        THREE = _state.sent();
                        l = function(value) {
                            return value * Math.PI / 180;
                        };
                        d = new THREE.Vector3(0, 0, -1);
                        return [
                            4,
                            showcase.mpSDK.Camera.getPose()
                        ];
                    case 2:
                        a = _state.sent();
                        r = new THREE.Euler(l(a.rotation.x), l(a.rotation.y), 0, "XYZ");
                        o = d.clone().applyEuler(r);
                        s = new THREE.Vector3(a.position.x, a.position.y, a.position.z);
                        u = t.clone();
                        f = o.clone().normalize();
                        p = u.clone().sub(s).normalize();
                        m = new THREE.Vector3(f.x, 0, f.z);
                        b = new THREE.Vector3(p.x, 0, p.z);
                        h = m.angleTo(b);
                        g = f.x * p.z - f.z * p.x < 0 ? -1 : 1;
                        return [
                            4,
                            showcase.mpSDK.Camera.rotate(180 * h / Math.PI * g)
                        ];
                    case 3:
                        _state.sent();
                        return [
                            3,
                            5
                        ];
                    case 4:
                        err = _state.sent();
                        console.error(err);
                        return [
                            3,
                            5
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function rotateCameraTo(t) {
            return _ref.apply(this, arguments);
        };
    }();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    var moveToPathStepElement = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(type, value) {
            var destinationSweepData, pathSweep, obj, allTagsArray, ref, THREE, transitionType, ref1;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        destinationSweepData = (0,base/* parsePathDestinationSweepData */.wv)(currentPathStep === null || currentPathStep === void 0 ? void 0 : currentPathStep.current);
                        pathSweep = sweeps.find(function(sweep) {
                            return (destinationSweepData === null || destinationSweepData === void 0 ? void 0 : destinationSweepData.sweepUuid) === sweep.uuid || (destinationSweepData === null || destinationSweepData === void 0 ? void 0 : destinationSweepData.sweepUuid) === sweep.sid || (destinationSweepData === null || destinationSweepData === void 0 ? void 0 : destinationSweepData.sweepUuid) === sweep.sweep_uuid;
                        });
                        switch(type){
                            case GameBook/* ChapterType.Tag */._U.Tag:
                                {
                                    allTagsArray = Array.from(allTags, function(param) {
                                        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), v = _param[1];
                                        return v;
                                    });
                                    obj = allTagsArray === null || allTagsArray === void 0 ? void 0 : allTagsArray.find(function(item) {
                                        return value === (item === null || item === void 0 ? void 0 : item.id) || value === (item === null || item === void 0 ? void 0 : item.defaultSid) || value === (item === null || item === void 0 ? void 0 : item.sid);
                                    });
                                    break;
                                }
                            case GameBook/* ChapterType.Polygon */._U.Polygon:
                                {
                                    obj = polygons.find(function(item) {
                                        var ref;
                                        return value === item.id || value === ((ref = item.id) === null || ref === void 0 ? void 0 : ref.toString());
                                    });
                                    break;
                                }
                            case GameBook/* ChapterType.VSImage */._U.VSImage:
                                {
                                    obj = vsObjects.find(function(item) {
                                        var ref;
                                        return (0,_instanceof/* default */.Z)(item, VSObject/* TourImage */.oP) && (value === item.id || value === ((ref = item.id) === null || ref === void 0 ? void 0 : ref.toString()));
                                    });
                                    break;
                                }
                            case GameBook/* ChapterType.VSVideo */._U.VSVideo:
                                {
                                    obj = vsObjects.find(function(item) {
                                        var ref;
                                        return (0,_instanceof/* default */.Z)(item, VSObject/* TourVideo */.Up) && (value === item.id || value === ((ref = item.id) === null || ref === void 0 ? void 0 : ref.toString()));
                                    });
                                    break;
                                }
                            case GameBook/* ChapterType.VSItem */._U.VSItem:
                                {
                                    obj = vsObjects.find(function(item) {
                                        var ref;
                                        return (0,_instanceof/* default */.Z)(item, VSObject/* TourObject */.zB) && (value === item.id || value === ((ref = item.id) === null || ref === void 0 ? void 0 : ref.toString()));
                                    });
                                    break;
                                }
                            default:
                                break;
                        }
                        if (!(obj && pathSweep)) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            (0,dist/* iTHREE */.Sc)()
                        ];
                    case 1:
                        THREE = _state.sent();
                        transitionType = (currentPathStep === null || currentPathStep === void 0 ? void 0 : (ref = currentPathStep.current) === null || ref === void 0 ? void 0 : ref.transitionType) || Game/* GameLockPathTransitionType.INSTANT */.KO.INSTANT;
                        return [
                            4,
                            showcase.mpSDK.Sweep.moveTo(pathSweep.uuid, {
                                transition: showcase.mpSDK.Sweep.Transition[transitionType === null || transitionType === void 0 ? void 0 : transitionType.toUpperCase()]
                            })
                        ];
                    case 2:
                        _state.sent();
                        if (!!base/* asyncStore.vrIsOn */.k6.vrIsOn) return [
                            3,
                            5
                        ];
                        if (!destinationSweepData.isTourLink) return [
                            3,
                            3
                        ];
                        (ref1 = showcase.mpSDK) === null || ref1 === void 0 ? void 0 : ref1.Camera.setRotation({
                            x: destinationSweepData.x,
                            y: destinationSweepData.y
                        });
                        return [
                            3,
                            5
                        ];
                    case 3:
                        return [
                            4,
                            rotateCameraTo(new THREE.Vector3(obj.positionX, obj.positionY, obj.positionZ))
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        return [
                            2,
                            obj
                        ];
                }
            });
        });
        return function moveToPathStepElement(type, value) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleNextStep = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var ref, ref1, ref2, vsElement;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!(currentPathStep === null || currentPathStep === void 0 ? void 0 : currentPathStep.current)) return [
                        2
                    ];
                    if (!((currentPathStep === null || currentPathStep === void 0 ? void 0 : currentPathStep.current.sweepUuid) === currentSweep.uuid)) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        goToNextStep()
                    ];
                case 1:
                    _state.sent();
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        moveToPathStepElement(currentPathStep === null || currentPathStep === void 0 ? void 0 : (ref = currentPathStep.current) === null || ref === void 0 ? void 0 : ref.locationType, currentPathStep === null || currentPathStep === void 0 ? void 0 : (ref1 = currentPathStep.current) === null || ref1 === void 0 ? void 0 : ref1.locationItem)
                    ];
                case 3:
                    vsElement = _state.sent();
                    if (currentPathStep === null || currentPathStep === void 0 ? void 0 : (ref2 = currentPathStep.current) === null || ref2 === void 0 ? void 0 : ref2.autoOpenDestination) {
                        onAction(vsElement, currentPathStep.current.locationType);
                    }
                    return [
                        2
                    ];
            }
        });
    }), [
        moveToPathStepElement
    ]);
    var handlePreviousStep = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var ref, ref1, ref2, vsElement;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            goToPreviousStep()
                        ];
                    case 1:
                        _state.sent();
                        return [
                            4,
                            moveToPathStepElement(currentPathStep === null || currentPathStep === void 0 ? void 0 : (ref = currentPathStep.current) === null || ref === void 0 ? void 0 : ref.locationType, currentPathStep === null || currentPathStep === void 0 ? void 0 : (ref1 = currentPathStep.current) === null || ref1 === void 0 ? void 0 : ref1.locationItem)
                        ];
                    case 2:
                        vsElement = _state.sent();
                        if (currentPathStep === null || currentPathStep === void 0 ? void 0 : (ref2 = currentPathStep.current) === null || ref2 === void 0 ? void 0 : ref2.autoOpenDestination) {
                            onAction(vsElement, currentPathStep.current.locationType);
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function handlePreviousStep() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        (0,_async_to_generator/* default */.Z)(function() {
            var ref, pathArray;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(lockPath && !((ref = paths.current) === null || ref === void 0 ? void 0 : ref.size))) return [
                            3,
                            3
                        ];
                        base/* asyncStore.pathIds */.k6.pathIds = [];
                        paths.current = createPath(new Map(), null, -1);
                        pathArray = Array.from(paths.current, function(param) {
                            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), value = _param[1];
                            return value;
                        });
                        pathArray = pathArray.filter(function(e) {
                            var ref;
                            return e.id !== (currentPathStep === null || currentPathStep === void 0 ? void 0 : (ref = currentPathStep.current) === null || ref === void 0 ? void 0 : ref.id);
                        });
                        if (!(lockPath === null || lockPath === void 0 ? void 0 : lockPath.hideItems)) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            hideElements({
                                hideTags: pathArray.filter(function(v) {
                                    return v.locationType === Game/* EntityType.Tag */.py.Tag;
                                }).map(function(e) {
                                    return e === null || e === void 0 ? void 0 : e.locationItem;
                                }),
                                polygonsToHide: pathArray.filter(function(v) {
                                    return v.locationType === Game/* EntityType.Polygon */.py.Polygon;
                                }).map(function(e) {
                                    return e === null || e === void 0 ? void 0 : e.locationItem;
                                }),
                                vsImagesToHide: pathArray.filter(function(v) {
                                    return v.locationType === Game/* EntityType.VSImage */.py.VSImage;
                                }).map(function(e) {
                                    return e === null || e === void 0 ? void 0 : e.locationItem;
                                }),
                                vsVideosToHide: pathArray.filter(function(v) {
                                    return v.locationType === Game/* EntityType.VSVideo */.py.VSVideo;
                                }).map(function(e) {
                                    return e === null || e === void 0 ? void 0 : e.locationItem;
                                }),
                                vsItemsToHide: pathArray.filter(function(v) {
                                    return v.locationType === Game/* EntityType.VSItem */.py.VSItem;
                                }).map(function(e) {
                                    return e === null || e === void 0 ? void 0 : e.locationItem;
                                })
                            })
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        if (skipPathTo) {
                            goToNextStep();
                        } else {
                            // screen render update, because changing ref not trigger rerender
                            setUpdateState(function(updateState) {
                                return !updateState;
                            });
                        }
                        _state.label = 3;
                    case 3:
                        return [
                            2
                        ];
                }
            });
        })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        lockPath,
        handleNextStep,
        paths === null || paths === void 0 ? void 0 : paths.current,
        skipPathTo
    ]);
    var _changePath = function(pathId, restart) {
        if (pathId == (lockPath === null || lockPath === void 0 ? void 0 : lockPath.id)) return;
        var skipChangePath = false;
        var path = gamePaths.find(function(p) {
            var ref;
            return p.id === pathId || ((ref = p.id) === null || ref === void 0 ? void 0 : ref.toString()) === pathId;
        });
        // save current path to restore later
        pathSnapshot[lockPath === null || lockPath === void 0 ? void 0 : lockPath.id] = {
            currentPathStep: currentPathStep.current,
            paths: paths.current,
            pathIds: base/* asyncStore.pathIds */.k6.pathIds
        };
        if (pathSnapshot[pathId] && !restart) {
            var ref, ref1, ref2;
            // set stored path as current
            currentPathStep.current = (ref = pathSnapshot[pathId]) === null || ref === void 0 ? void 0 : ref.currentPathStep;
            paths.current = (ref1 = pathSnapshot[pathId]) === null || ref1 === void 0 ? void 0 : ref1.paths;
            base/* asyncStore.pathIds */.k6.pathIds = (ref2 = pathSnapshot[pathId]) === null || ref2 === void 0 ? void 0 : ref2.pathIds;
            if (skipPathTo) {
                skipChangePath = true;
                goToNextStep(path);
            }
        } else {
            currentPathStep.current = null;
            paths.current = null;
            base/* asyncStore.pathIds */.k6.pathIds = [];
        }
        if (!skipChangePath) {
            // console.debug('aaa setLockPath _changePath 2', path);
            setLockPath(path);
        }
        base/* asyncStore.regularActivePath */.k6.regularActivePath = gamePaths.map(function(p) {
            return p.id;
        }).indexOf(path.id);
    };
    var askForReset = function(pathId) {
        (0,lib/* confirmAlert */._1)({
            title: "",
            message: translation.restartPath || "Do you wish to restart this path or continue where you left?",
            buttons: [
                {
                    label: translation.restart || "Restart",
                    onClick: function() {
                        skipPathTo = null;
                        _changePath(pathId, true);
                    }
                },
                {
                    label: translation.continue || "Continue",
                    onClick: function() {
                        _changePath(pathId);
                    }
                }, 
            ]
        });
    };
    var handleChangePath = function(ev) {
        if ((lockPath === null || lockPath === void 0 ? void 0 : lockPath.id) === ev.target.value) return;
        var targetPath = gamePaths.find(function(p) {
            var ref;
            return p.id === ev.target.value || ((ref = p.id) === null || ref === void 0 ? void 0 : ref.toString()) === ev.target.value;
        });
        (0,lib/* confirmAlert */._1)({
            title: "",
            message: translation.switchPath || "Are you sure you wish to begin a new path? The current path will be turned off",
            buttons: [
                {
                    label: translation.yes || "Yes",
                    onClick: function() {
                        var ref;
                        var pathId = ev.target.value;
                        if (targetPath === null || targetPath === void 0 ? void 0 : (ref = targetPath.pathSetting) === null || ref === void 0 ? void 0 : ref.resetPathOnSwitch) {
                            setTimeout(function() {
                                askForReset(pathId);
                            }, 1000);
                        } else {
                            _changePath(pathId);
                        }
                    }
                },
                {
                    label: translation.no || "No",
                    onClick: function() {
                        skipPathTo = null;
                    }
                }, 
            ]
        });
    };
    // console.debug('aaa -----------------------------------------------------------------------');
    // console.debug('aaa game', game);
    // console.debug('aaa lockPath', lockPath);
    // console.debug('aaa finishedPaths', finishedPaths);
    // console.debug('aaa currentPathStep.current', currentPathStep.current);
    // console.debug('aaa paths.current', paths.current);
    // console.debug('aaa asyncStore.pathIds', asyncStore.pathIds);
    // console.debug('aaa isShowPathLockByExperience && showPathLock', isShowPathLockByExperience, showPathLock);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            !isFinish && /*#__PURE__*/ (0,jsx_runtime.jsx)(DesktopSwitchPath/* default */.Z, {
                finishedPaths: finishedPaths,
                gameId: gameId,
                pathLocks: gamePaths,
                pathLockId: lockPath === null || lockPath === void 0 ? void 0 : lockPath.id,
                currentPathStepId: currentPathStep === null || currentPathStep === void 0 ? void 0 : (ref = currentPathStep.current) === null || ref === void 0 ? void 0 : ref.id,
                handleChangePath: handleChangePath
            }),
            !isFinish && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* GameLockPathModal */.SR, {
                finishedPaths: finishedPaths,
                forceShowPathSwitchMobileModal: forceShowPathSwitchMobileModal,
                setForceShowPathSwitchMobileModal: setForceShowPathSwitchMobileModal,
                handleChangePath: handleChangePath,
                pathLocks: gamePaths,
                APP_AWS: "https://cdn.treedis.com",
                useRecoilValue: store/* useRecoilValue */.sJ,
                recoilStateObj: {
                    bottomBarOpenState: store/* bottomBarOpenState */.DF,
                    tourConfigsState: store/* tourConfigsState */.Uq
                },
                asyncStore: base/* asyncStore */.k6,
                theme: theme,
                color: utils/* color */.$_,
                pathSnapshot: pathSnapshot,
                currentPathStepId: currentPathStep === null || currentPathStep === void 0 ? void 0 : (ref1 = currentPathStep.current) === null || ref1 === void 0 ? void 0 : ref1.id,
                pathfinderDataState: pathfinderDataState,
                setPathfinderDataState: setPathfinderDataState,
                delayedDisable: delayedDisable,
                isRtl: isRtl,
                pathLockId: lockPath === null || lockPath === void 0 ? void 0 : lockPath.id,
                gameId: gameId,
                pathSettings: (lockPath === null || lockPath === void 0 ? void 0 : lockPath.pathSetting) || {},
                handleNextStep: handleNextStep,
                handlePreviousStep: handlePreviousStep,
                translation: translation,
                title: currentPathStep === null || currentPathStep === void 0 ? void 0 : (ref2 = currentPathStep.current) === null || ref2 === void 0 ? void 0 : ref2.title,
                description: currentPathStep === null || currentPathStep === void 0 ? void 0 : (ref3 = currentPathStep.current) === null || ref3 === void 0 ? void 0 : ref3.description,
                isEnablePreviousStep: isEnablePreviousStep && (lockPath === null || lockPath === void 0 ? void 0 : lockPath.previousStep),
                // @ts-ignore property added to types
                isEnableNextStep: true,
                // @ts-ignore
                buttonOnlyMode: lockPath === null || lockPath === void 0 ? void 0 : lockPath.buttonOnlyMode,
                nextButtonVisibility: lockPath === null || lockPath === void 0 ? void 0 : lockPath.nextButtonVisibility,
                // @ts-ignore property added to types
                icon: currentPathStep === null || currentPathStep === void 0 ? void 0 : (ref4 = currentPathStep.current) === null || ref4 === void 0 ? void 0 : ref4.icon
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/recoil/es/recoil.js
var recoil = __webpack_require__(2804);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Badge/Badge.js + 5 modules
var Badge = __webpack_require__(60082);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/SvgIcon/SvgIcon.js + 1 modules
var SvgIcon = __webpack_require__(81645);
;// CONCATENATED MODULE: ./units/Icon/Sketchfab.tsx




var Icon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: "17",
        height: "16",
        viewBox: "0 0 17 16",
        fill: "none"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "0.296387",
                width: "16",
                height: "16",
                fill: "url(#pattern0)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("pattern", {
                        id: "pattern0",
                        patternContentUnits: "objectBoundingBox",
                        width: "1",
                        height: "1",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("use", {
                            href: "#image0_1713_109817",
                            transform: "scale(0.0005)"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("image", {
                        id: "image0_1713_109817",
                        width: "2000",
                        height: "2000",
                        href: "data:image/png;base64,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"
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var Sketchfab = (Icon);

// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Stack/Stack.js
var Stack = __webpack_require__(9144);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Drawer/Drawer.js + 1 modules
var Drawer = __webpack_require__(60684);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(80562);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Divider/Divider.js
var Divider = __webpack_require__(44373);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Slide/Slide.js
var Slide = __webpack_require__(25425);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Alert/Alert.js + 6 modules
var Alert = __webpack_require__(82741);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/TextField/TextField.js + 1 modules
var TextField = __webpack_require__(67836);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Menu/Menu.js + 3 modules
var Menu_Menu = __webpack_require__(39530);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/MenuItem/MenuItem.js + 1 modules
var MenuItem = __webpack_require__(31538);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Card/Card.js + 1 modules
var Card = __webpack_require__(49837);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/CardHeader/CardHeader.js + 1 modules
var CardHeader = __webpack_require__(59742);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Collapse/Collapse.js + 1 modules
var Collapse = __webpack_require__(93481);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Container/Container.js + 2 modules
var Container_Container = __webpack_require__(36336);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Avatar/Avatar.js + 2 modules
var Avatar = __webpack_require__(44731);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Button/Button.js + 1 modules
var Button_Button = __webpack_require__(54225);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Dialog/Dialog.js + 2 modules
var Dialog = __webpack_require__(31470);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/DialogContent/DialogContent.js + 2 modules
var DialogContent = __webpack_require__(78944);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/DialogActions/DialogActions.js + 1 modules
var DialogActions = __webpack_require__(76779);
// EXTERNAL MODULE: ./units/Icon/index.ts + 53 modules
var units_Icon = __webpack_require__(95829);
;// CONCATENATED MODULE: ./components/tour/Threads/components/modals/CompleteNoteModal.tsx







var CompleteNoteModal = function(param) {
    var selectedNote = param.selectedNote, foundUser = param.foundUser, isCompletionModalOpen = param.isCompletionModalOpen, handleClose = param.handleClose, completeNote = param.completeNote;
    var handleConfirm = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(e) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        e.stopPropagation();
                        if (foundUser.id !== selectedNote.userId) {
                            react_toastify_esm/* toast.error */.Am.error("Only user, who creted this Note can mark it as complete");
                            handleClose();
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            completeNote(selectedNote.id)
                        ];
                    case 1:
                        _state.sent();
                        handleClose();
                        return [
                            2
                        ];
                }
            });
        });
        return function handleConfirm(e) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Dialog/* default */.Z, {
        open: isCompletionModalOpen,
        onClose: handleClose,
        "aria-labelledby": "alert-dialog-title",
        "aria-describedby": "alert-dialog-description",
        sx: {
            "& .MuiDialog-paper": {
                background: "transparent",
                borderRadius: "12px"
            }
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
            sx: {
                maxWidth: "400px",
                background: "white",
                borderRadius: "12px"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(DialogContent/* default */.Z, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            display: "flex",
                            alignItems: "start",
                            justifyContent: "flex-start",
                            paddingBottom: 2,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(units_Icon/* default.Attention */.Z.Attention, {
                                style: {
                                    fontSize: 40
                                }
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "h6",
                            align: "left",
                            gutterBottom: true,
                            children: "Mark as completed?"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "body2",
                            align: "left",
                            color: "textSecondary",
                            children: "Are you sure you want to mark this note as completed? You can find and restore the note from archive later."
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(DialogActions/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                        direction: "row",
                        spacing: 2,
                        justifyContent: "center",
                        width: "100%",
                        padding: 2,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                variant: "outlined",
                                onClick: handleClose,
                                style: {
                                    width: 120
                                },
                                children: "Cancel"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                variant: "contained",
                                onClick: handleConfirm,
                                color: "primary",
                                style: {
                                    width: 120
                                },
                                children: "Confirm"
                            })
                        ]
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/tour/Threads/components/modals/DeleteNoteModal.tsx











var DeleteNoteModal = function(param) {
    var threads = param.threads, tourSlug = param.tourSlug, selectedThread = param.selectedThread, userId = param.userId, setThreads = param.setThreads, isDeleteNoteModalOpen = param.isDeleteNoteModalOpen, setIsDeleteNoteModalOpen = param.setIsDeleteNoteModalOpen, removeThreadFromSpace = param.removeThreadFromSpace, setSelectedThread = param.setSelectedThread;
    var handleDelete = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var result, updatedNotes;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setIsDeleteNoteModalOpen(false);
                        if (!selectedThread) {
                            react_toastify_esm/* toast.error */.Am.error("Could not delete note");
                        }
                        if (selectedThread.userId !== userId) {
                            react_toastify_esm/* toast.error */.Am.error("You can not delete this note");
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            TreedisPublicDAO/* default.deleteThread */.Z.deleteThread({
                                data: {
                                    threadId: selectedThread.id
                                }
                            })
                        ];
                    case 1:
                        result = _state.sent();
                        if (!(result.message === "Success")) return [
                            3,
                            3
                        ];
                        updatedNotes = threads.filter(function(t) {
                            return t.id !== selectedThread.id;
                        });
                        setThreads(updatedNotes);
                        return [
                            4,
                            removeThreadFromSpace(selectedThread)
                        ];
                    case 2:
                        _state.sent();
                        socket/* default.emit */.Z.emit("thread_delete", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, selectedThread), {
                            room: tourSlug
                        }));
                        _state.label = 3;
                    case 3:
                        if (setSelectedThread) {
                            setSelectedThread(null);
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function handleDelete() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Dialog/* default */.Z, {
        open: isDeleteNoteModalOpen,
        onClose: function() {
            return setIsDeleteNoteModalOpen(false);
        },
        "aria-labelledby": "alert-dialog-title",
        "aria-describedby": "alert-dialog-description",
        sx: {
            "& .MuiDialog-paper": {
                background: "transparent",
                borderRadius: "12px"
            }
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
            sx: {
                maxWidth: "400px",
                background: "white",
                borderRadius: "12px"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(DialogContent/* default */.Z, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            display: "flex",
                            alignItems: "start",
                            justifyContent: "flex-start",
                            paddingBottom: 2,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                sx: {
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    width: "48px",
                                    height: "48px",
                                    borderRadius: "50%",
                                    background: "#FEF3F2"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                    sx: {
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        width: "35px",
                                        height: "35px",
                                        borderRadius: "50%",
                                        background: "#FEE4E2"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(units_Icon/* default.Delete */.Z.Delete, {
                                        style: {
                                            color: "transparent",
                                            fontSize: 20
                                        }
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "h6",
                            align: "left",
                            children: "Delete this note?"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            align: "left",
                            sx: {
                                color: "#667085",
                                fontSize: "14px",
                                fontWeight: "400"
                            },
                            children: "Are you sure you want to delete this note? This action cannot be undone."
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(DialogActions/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                        direction: "row",
                        spacing: 2,
                        justifyContent: "space-between",
                        width: "100%",
                        padding: 2,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                variant: "outlined",
                                onClick: function() {
                                    return setIsDeleteNoteModalOpen(false);
                                },
                                style: {
                                    color: "#344054",
                                    flex: 1,
                                    marginRight: 12,
                                    border: "1px solid #D0D5DD",
                                    borderRadius: 8,
                                    height: 48
                                },
                                children: "Cancel"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                variant: "contained",
                                onClick: handleDelete,
                                color: "primary",
                                style: {
                                    flex: 1,
                                    marginLeft: 12,
                                    borderRadius: 8,
                                    height: 48,
                                    background: "#D92D20"
                                },
                                children: "Delete"
                            })
                        ]
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./utils/getInitials.ts
function getInitials(name) {
    var initials = "";
    if (!name.includes(" ")) {
        initials = name === null || name === void 0 ? void 0 : name.charAt(0);
    } else {
        initials = "".concat(name.split(" ")[0][0]).concat(name.split(" ")[1][0]);
    }
    return initials.toUpperCase();
}

;// CONCATENATED MODULE: ./utils/formData.ts
/* eslint-disable no-prototype-builtins */ /* eslint-disable no-plusplus */ /* eslint-disable no-restricted-syntax */ // eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
// TODO: remove ts-nocheck

var create = function(// eslint-disable-next-line @typescript-eslint/ban-types
object, form, namespace, stringify) {
    var formData = form || new FormData();
    for(var property in object){
        if (object.hasOwnProperty(property) || object[property]) {
            var formKey = namespace ? "".concat(namespace, "[").concat(property, "]") : property;
            if ((0,_instanceof/* default */.Z)(object[property], Date)) {
                formData.append(formKey, object[property].toISOString());
            } else if (Array.isArray(object[property]) && object[property].length > 0) {
                for(var i = 0; i < object[property].length; i++){
                    formData.append((0,_instanceof/* default */.Z)(object[property][i], File) ? property : "".concat(property, "[]"), (0,_instanceof/* default */.Z)(object[property][i], File) ? object[property][i] : JSON.stringify([
                        object[property][i]
                    ]));
                }
            } else if (typeof object[property] === "object" && (0,_instanceof/* default */.Z)(object[property], Array) && object[property].length === 0) {
                formData.append(formKey, "[]");
            } else if (typeof object[property] === "object" && !(0,_instanceof/* default */.Z)(object[property], File) && !stringify) {
                create(object[property], formData, formKey);
            } else if (typeof object[property] === "object" && stringify) {
                formData.append(formKey, JSON.stringify(object[property]));
            } else if (typeof object[property] === "string" && object[property].length === 0) {
                formData.append(formKey, String(null));
            } else if (object[property] !== undefined) {
                formData.append(formKey, object[property]);
            }
        }
    }
    return formData;
};
var formData = {
    create: create
};

// EXTERNAL MODULE: ./node_modules/lodash/orderBy.js
var orderBy = __webpack_require__(75472);
var orderBy_default = /*#__PURE__*/__webpack_require__.n(orderBy);
;// CONCATENATED MODULE: ./components/tour/Threads/components/data.ts

var groupThreadsByUpdateDate = function(items) {
    var oneDay = 24 * 60 * 60 * 1000; // in milliseconds
    var now = new Date();
    var startOfDay = function(date) {
        return new Date(date.getFullYear(), date.getMonth(), date.getDate());
    };
    var today = startOfDay(now);
    var yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);
    var groups = {};
    var sortedThreads = orderBy_default()(items, "createdAt", "desc");
    sortedThreads.forEach(function(item) {
        var updateDate = new Date(item.createdAt);
        // @ts-ignore
        var diffTime = Math.abs(today - startOfDay(updateDate));
        var diffDays = Math.floor(diffTime / oneDay);
        var group;
        if (diffDays === 0) {
            group = "Today";
        } else if (diffDays === 1) {
            group = "Yesterday";
        } else if (diffDays > 1 && diffDays <= 7) {
            group = "This Week";
        } else if (diffDays > 7 && diffDays <= 14) {
            group = "Last Week";
        } else {
            var weeksAgo = Math.floor(diffDays / 7);
            group = "".concat(weeksAgo, " Weeks Before");
        }
        if (!groups[group]) {
            groups[group] = [];
        }
        groups[group].push(item);
    });
    Object.keys(groups).forEach(function(key) {
        if (groups[key].length === 0) {
            delete groups[key];
        }
    });
    return groups;
};

;// CONCATENATED MODULE: ./components/tour/Threads/components/NoNotesFound.tsx



var NoNotesFound = function(param) {
    var handleAddThread = param.handleAddThread, isCompleted = param.isCompleted, setFilterState = param.setFilterState, isGuest = param.isGuest;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
        sx: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            paddingX: "66px"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                sx: {
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "42px",
                    height: "42px",
                    backgroundColor: "#F2F4F7",
                    border: "6px solid #F9FAFB",
                    borderRadius: "50%",
                    padding: "7px",
                    textAlign: "center",
                    mb: "16px"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(units_Icon/* default.Search */.Z.Search, {
                    sx: {
                        fontSize: "22px",
                        color: "#2055FF"
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                sx: {
                    font: "Inter",
                    fontSize: "16px",
                    fontWeight: "600",
                    lineHeight: "24px",
                    color: "#101828",
                    mb: "4px"
                },
                children: "No results found"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                sx: {
                    font: "Inter",
                    fontSize: "14px",
                    fontWeight: "400",
                    lineHeight: "20px",
                    color: "#667085",
                    mb: "24px"
                },
                children: isCompleted ? "Click “reset the filter” to see the list again." : "Click “Add Note” to create your first note."
            }),
            isCompleted ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                startIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                    className: "fa-solid fa-arrow-rotate-left",
                    style: {
                        color: "#101828"
                    }
                }),
                onClick: function() {
                    return setFilterState("all");
                },
                sx: {
                    background: "white",
                    border: "1px solid #EAECF0",
                    borderRadius: "8px",
                    paddingX: "52px",
                    paddingY: "10px",
                    "&:hover": {
                        background: "white",
                        border: "1px solid #2055FF"
                    }
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    sx: {
                        color: "#101828",
                        fontWeight: "600",
                        fontSize: "16px"
                    },
                    children: "Reset the filter"
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                startIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                    className: "fa-regular fa-plus"
                }),
                disabled: isGuest,
                onClick: handleAddThread,
                sx: {
                    background: "#2055FF",
                    borderRadius: "8px",
                    paddingX: "52px",
                    paddingY: "10px",
                    "&:hover": {
                        background: "#2055FF"
                    }
                },
                children: "Add Note"
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
;// CONCATENATED MODULE: ./components/tour/Threads/components/ThreadsItems.tsx





















var ThreadsItems = function(param) {
    var rtl = param.rtl, threads = param.threads, setThreads = param.setThreads, onThreadItemSelect = param.onThreadItemSelect, collaborators = param.collaborators, userId = param.userId, showCaseTemp = param.showCaseTemp, showcaseTag = param.showcaseTag, tourSlug = param.tourSlug, isTourAdmin = param.isTourAdmin, toggleThreadVisibility = param.toggleThreadVisibility, hideElements = param.hideElements, newThreadMessages = param.newThreadMessages, tagNode = param.tagNode, inputNodeComponent = param.inputNodeComponent, controls = param.controls, removeThreadFromSpace = param.removeThreadFromSpace, editMode = param.editMode, setEditMode = param.setEditMode, handleAddThread = param.handleAddThread, moveToTag = param.moveToTag, setFilteredCount = param.setFilteredCount, onCompleteNote = param.onCompleteNote, isGuest = param.isGuest;
    var ref = (0,react.useState)([]), filteredThreads = ref[0], setfilteredThreads = ref[1];
    var ref1 = (0,react.useState)(null), selectedThread = ref1[0], setSelectedThread = ref1[1];
    var ref2 = (0,react.useState)("Today"), open = ref2[0], setOpen = ref2[1];
    var ref3 = (0,react.useState)({}), anchorEls = ref3[0], setAnchorEls = ref3[1];
    var ref4 = (0,react.useState)("active"), filterState = ref4[0], setFilterState = ref4[1];
    var ref5 = (0,react.useState)(null), filterAnchor = ref5[0], setFilterAnchor = ref5[1];
    var ref6 = (0,react.useState)(null), openedMenuId = ref6[0], setOpenedMenuId = ref6[1];
    var ref7 = (0,react.useState)(null), hoveredNoteId = ref7[0], setHoveredNoteId = ref7[1];
    var ref8 = (0,react.useState)(false), isDeleteNoteModalOpen = ref8[0], setIsDeleteNoteModalOpen = ref8[1];
    var ref9 = (0,react.useState)(false), isCompletionModalOpen = ref9[0], setIsCompletionModalOpen = ref9[1];
    var recentNote = (0,react.useRef)(null);
    var threadPosition = (0,react.useRef)(null);
    var isFilterOpen = Boolean(filterAnchor);
    var selectedThreadRef = (0,react.useRef)(null);
    var foundUser = collaborators === null || collaborators === void 0 ? void 0 : collaborators.find(function(c) {
        return c.id === userId;
    });
    (0,react.useEffect)(function() {
        var filtered;
        var threadsToHide;
        switch(filterState){
            case "active":
                filtered = threads.filter(function(t) {
                    return !t.isCompleted;
                });
                threadsToHide = threads.filter(function(t) {
                    return t.isCompleted;
                }).map(function(t) {
                    return t.id;
                });
                setfilteredThreads(filtered);
                setFilteredCount(filtered.length);
                if (threadsToHide.length) {
                    hideElements({
                        hideTags: threadsToHide,
                        polygonsToHide: [],
                        vsImagesToHide: [],
                        vsVideosToHide: [],
                        vsItemsToHide: []
                    });
                }
                filtered.forEach(function(thread) {
                    toggleThreadVisibility(thread, true);
                });
                break;
            case "completed":
                filtered = threads.filter(function(t) {
                    return t.isCompleted;
                });
                threadsToHide = threads.filter(function(t) {
                    return !t.isCompleted;
                }).map(function(t) {
                    return t.id;
                });
                setfilteredThreads(filtered);
                setFilteredCount(filtered.length);
                hideElements({
                    hideTags: threadsToHide,
                    polygonsToHide: [],
                    vsImagesToHide: [],
                    vsVideosToHide: [],
                    vsItemsToHide: []
                });
                filtered.forEach(function(thread) {
                    toggleThreadVisibility(thread, true);
                });
                break;
            case "all":
                setfilteredThreads(threads);
                setFilteredCount(threads.length);
                threads.forEach(function(thread) {
                    toggleThreadVisibility(thread, true);
                });
                break;
            default:
                setfilteredThreads(threads);
        }
    }, [
        threads,
        filterState,
        hideElements,
        toggleThreadVisibility
    ]);
    var groupedThreads = (0,react.useCallback)(function() {
        return groupThreadsByUpdateDate(filteredThreads);
    }, [
        filteredThreads
    ]);
    var openMenu = function(e, threadId) {
        e.stopPropagation();
        setAnchorEls(function(prev) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), (0,_define_property/* default */.Z)({}, threadId, e.currentTarget));
        });
        setOpenedMenuId(threadId);
    };
    var openFilter = function(e) {
        setFilterAnchor(e.currentTarget);
    };
    var handleClose = function(e) {
        e.stopPropagation();
        setAnchorEls(function(prev) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), (0,_define_property/* default */.Z)({}, openedMenuId, null));
        });
        setOpenedMenuId(null);
    };
    var handleCloseFilter = function() {
        setFilterAnchor(null);
    };
    var handleEditPosition = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(thread) {
            var inShowcaseTemp, intervalId;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setEditMode(true);
                        if (threadPosition.current === null) threadPosition.current = {
                            x: thread.positionX,
                            y: thread.positionY,
                            z: thread.positionZ
                        };
                        inShowcaseTemp = showCaseTemp.tag.allTags && showCaseTemp.tag.allTags.has(thread.sid);
                        recentNote.current = inShowcaseTemp;
                        if (!inShowcaseTemp) return [
                            3,
                            1
                        ];
                        showCaseTemp.tag.startTranslateControls({
                            tag: thread,
                            tagNode: tagNode,
                            inputNodeComponent: inputNodeComponent,
                            controls: controls,
                            cb: function() {
                                var _position = tagNode.current.obj3D.position, x = _position.x, y = _position.y, z = _position.z;
                                thread.positionX = x;
                                thread.positionY = y;
                                thread.positionZ = z;
                                showCaseTemp.tag.edit(thread);
                            }
                        });
                        return [
                            3,
                            3
                        ];
                    case 1:
                        if (!(showcaseTag && controls.current)) return [
                            3,
                            3
                        ];
                        intervalId = setInterval(function() {
                            var ref, ref1, ref2, ref3;
                            var threeJsTag = (ref = controls.current) === null || ref === void 0 ? void 0 : (ref1 = ref.inputs) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.selection) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.obj3D) === null || ref3 === void 0 ? void 0 : ref3.children[0];
                            if (threeJsTag) {
                                threeJsTag.children.forEach(function(obj) {
                                    obj.visible = false;
                                });
                                clearInterval(intervalId);
                            }
                        }, 10);
                        return [
                            4,
                            showCaseTemp.tag.startTranslateControls({
                                tag: thread,
                                tagNode: tagNode,
                                inputNodeComponent: inputNodeComponent,
                                controls: controls,
                                cb: function() {
                                    var _position = tagNode.current.obj3D.position, x = _position.x, y = _position.y, z = _position.z;
                                    thread.positionX = x;
                                    thread.positionY = y;
                                    thread.positionZ = z;
                                    showcaseTag.editPosition(thread.sid, {
                                        anchorPosition: {
                                            x: thread.positionX,
                                            y: thread.positionY,
                                            z: thread.positionZ
                                        }
                                    });
                                }
                            })
                        ];
                    case 2:
                        _state.sent();
                        _state.label = 3;
                    case 3:
                        setSelectedThread(thread);
                        setAnchorEls(function(prev) {
                            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), (0,_define_property/* default */.Z)({}, openedMenuId, null));
                        });
                        return [
                            2
                        ];
                }
            });
        });
        return function(thread) {
            return _ref.apply(this, arguments);
        };
    }(), [
        controls,
        inputNodeComponent,
        openedMenuId,
        setEditMode,
        showCaseTemp.tag,
        tagNode,
        showcaseTag
    ]);
    var handleCancleEditPosition = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(thread) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        thread.positionX = threadPosition.current.x;
                        thread.positionY = threadPosition.current.y;
                        thread.positionZ = threadPosition.current.z;
                        showCaseTemp.tag.stopPositionUpdates({
                            controls: controls
                        });
                        if (!thread.isRecentNote) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            showCaseTemp.tag.edit(thread)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 2:
                        return [
                            4,
                            showcaseTag.editPosition(thread.sid, {
                                anchorPosition: {
                                    x: thread.positionX,
                                    y: thread.positionY,
                                    z: thread.positionZ
                                }
                            })
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        if (tagNode.current) {
                            tagNode.current.stop();
                            tagNode.current = undefined;
                        }
                        if (inputNodeComponent.current) {
                            inputNodeComponent.current = undefined;
                        }
                        controls.current.inputs.selection = null;
                        threadPosition.current = null;
                        setEditMode(false);
                        setSelectedThread(null);
                        return [
                            2
                        ];
                }
            });
        });
        return function(thread) {
            return _ref.apply(this, arguments);
        };
    }(), [
        controls,
        inputNodeComponent,
        setEditMode,
        showCaseTemp.tag,
        tagNode,
        showcaseTag
    ]);
    var handleSavePosition = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(thread) {
            var dataToSave, result, savedThread;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        delete thread.message;
                        delete thread.dummyObject;
                        delete thread.description;
                        delete thread.mediaUrls;
                        dataToSave = formData.create((0,_object_spread/* default */.Z)({}, thread));
                        return [
                            4,
                            TreedisPublicDAO/* default.saveThread */.Z.saveThread({
                                data: dataToSave
                            })
                        ];
                    case 1:
                        result = _state.sent();
                        if (result.message === "Success") {
                            savedThread = result.savedThread;
                            showCaseTemp.tag.stopPositionUpdates({
                                controls: controls
                            });
                            if (tagNode.current) {
                                tagNode.current.stop();
                                tagNode.current = undefined;
                            }
                            if (inputNodeComponent.current) {
                                inputNodeComponent.current = undefined;
                            }
                            controls.current.inputs.selection = null;
                            threadPosition.current = null;
                            setEditMode(false);
                            setSelectedThread(null);
                            socket/* default.emit */.Z.emit("thread_edit", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, savedThread), {
                                room: tourSlug,
                                eventType: NoteEditEventType.EditPosition,
                                isRecentNote: recentNote.current
                            }));
                            recentNote.current = null;
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSavePosition(thread) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleSearch = function(e) {
        var searchTerm = e.target.value.toLowerCase();
        var result = searchTerm ? threads.filter(function(t) {
            return t.reporter.toLowerCase().includes(searchTerm) || t.title.toLowerCase().includes(searchTerm) || t.messages.find(function(message) {
                return message.description.toLowerCase().includes(searchTerm);
            });
        }) : threads;
        setfilteredThreads(result);
    };
    var filterByStatus = function(e) {
        var id = e.currentTarget.id;
        setFilterAnchor(null);
        setFilterState(id);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                direction: "row",
                gap: 2,
                width: "100%",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                        variant: "outlined",
                        onChange: handleSearch,
                        InputProps: {
                            startAdornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(units_Icon/* default.Search */.Z.Search, {
                                sx: {
                                    fontSize: "20px",
                                    fontWeight: "300",
                                    marginRight: "7px",
                                    color: "#667085"
                                }
                            }),
                            sx: {
                                "& input::placeholder": {
                                    color: "#667085",
                                    opacity: 1,
                                    fontSize: "16px"
                                }
                            }
                        },
                        inputProps: {
                            sx: {
                                maxHeight: "44px",
                                height: "100%"
                            }
                        },
                        sx: {
                            borderRadius: "8px",
                            border: "1px solid #D1D1D1",
                            background: "#FFF",
                            width: "100%",
                            "& .MuiOutlinedInput-notchedOutline legend": {
                                display: "none"
                            },
                            "& fieldset": {
                                height: "100%",
                                top: 0
                            },
                            "& .MuiOutlinedInput-notchedOutline": {
                                borderColor: "#D0D5DD",
                                borderRadius: "8px"
                            },
                            "& .MuiOutlinedInput-root": {
                                borderRadius: "8px",
                                background: "#FFF"
                            }
                        },
                        placeholder: "Search"
                    }),
                    !threads.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                        onClick: handleAddThread,
                        disabled: isGuest,
                        id: "add-button",
                        "aria-controls": isFilterOpen ? "filter-menu" : undefined,
                        "aria-haspopup": "true",
                        "aria-expanded": isFilterOpen ? "true" : undefined,
                        sx: {
                            borderRadius: "8px",
                            border: "1px solid #D1D1D1",
                            background: "#FFF",
                            width: "44px",
                            height: "44px",
                            "& .MuiOutlinedInput-notchedOutline legend": {
                                display: "none"
                            },
                            fieldset: {
                                height: "100%",
                                top: 0
                            }
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                            className: "fa-regular fa-plus",
                            style: {
                                fontSize: "16px",
                                color: "#2055FF"
                            }
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                onClick: openFilter,
                                id: "filter-button",
                                "aria-controls": isFilterOpen ? "filter-menu" : undefined,
                                "aria-haspopup": "true",
                                "aria-expanded": isFilterOpen ? "true" : undefined,
                                sx: {
                                    borderRadius: "8px",
                                    border: "1px solid #D0D5DD !important",
                                    background: "#FFF",
                                    width: "44px",
                                    height: "44px",
                                    "& .MuiOutlinedInput-notchedOutline legend": {
                                        display: "none"
                                    },
                                    fieldset: {
                                        height: "100%",
                                        top: 0
                                    }
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                    className: "fa-regular fa-filter",
                                    style: {
                                        fontSize: "20px",
                                        color: "#667085"
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Menu_Menu/* default */.Z, {
                                id: "filter-menu",
                                anchorEl: filterAnchor,
                                open: isFilterOpen,
                                onClose: handleCloseFilter,
                                sx: {
                                    width: "270px",
                                    ".MuiPaper-root": {
                                        background: "white",
                                        width: "270px",
                                        border: "1px solid #EAECF0",
                                        borderRadius: "8px"
                                    }
                                },
                                MenuListProps: {
                                    "aria-labelledby": "filter-button"
                                },
                                anchorOrigin: {
                                    vertical: "bottom",
                                    horizontal: "right"
                                },
                                transformOrigin: {
                                    vertical: "top",
                                    horizontal: "right"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuItem/* default */.Z, {
                                        id: "all",
                                        onClick: filterByStatus,
                                        children: [
                                            "Show all notes",
                                            filterState === "all" && /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                className: "fa fa-check",
                                                style: {
                                                    color: "#2055ff",
                                                    marginLeft: "auto"
                                                }
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuItem/* default */.Z, {
                                        id: "active",
                                        onClick: filterByStatus,
                                        children: [
                                            "Only Incomplete notes",
                                            filterState === "active" && /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                className: "fa fa-check",
                                                style: {
                                                    color: "#2055ff",
                                                    marginLeft: "auto"
                                                }
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuItem/* default */.Z, {
                                        id: "completed",
                                        onClick: filterByStatus,
                                        children: [
                                            "Only Completed notes",
                                            filterState === "completed" && /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                className: "fa fa-check",
                                                style: {
                                                    color: "#2055ff",
                                                    marginLeft: "auto"
                                                }
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            !filteredThreads.length && /*#__PURE__*/ (0,jsx_runtime.jsx)(NoNotesFound, {
                handleAddThread: handleAddThread,
                isCompleted: filterState === "completed",
                setFilterState: setFilterState,
                isGuest: isGuest
            }),
            Object.entries(groupedThreads()).map(function(param) {
                var _param = (0,_sliced_to_array/* default */.Z)(param, 2), group = _param[0], insideThreads = _param[1];
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default */.Z, {
                    sx: {
                        border: "1px solid #D0D5DD",
                        borderRadius: "16px",
                        background: "white",
                        backdropFilter: "none",
                        padding: "16px"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CardHeader/* default */.Z, {
                            title: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                sx: {
                                    display: "flex",
                                    alignItems: "center"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                        component: "span",
                                        sx: {
                                            marginRight: "6px",
                                            fontWeight: "700",
                                            fontSize: "16px",
                                            color: "#101828"
                                        },
                                        children: group
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                        component: "div",
                                        sx: {
                                            backgroundColor: "#F2F4F7",
                                            borderRadius: "50%",
                                            display: "inline-flex",
                                            width: "24px",
                                            height: "24px",
                                            textAlign: "center",
                                            padding: "4px",
                                            justifyContent: "center",
                                            alignItems: "center"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                            component: "span",
                                            sx: {
                                                fontSize: "14px",
                                                color: "#2055FF"
                                            },
                                            children: insideThreads.length || 0
                                        })
                                    })
                                ]
                            }),
                            sx: {
                                textAlign: rtl ? "right" : "left",
                                direction: rtl ? "rtl" : "",
                                padding: 0
                            },
                            action: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                onClick: function() {
                                    return setOpen(open === group ? null : group);
                                },
                                "aria-label": "expand",
                                size: "small",
                                sx: {
                                    marginRight: 2,
                                    marginTop: "5px"
                                },
                                children: open === group ? /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                    className: "fa-solid fa-chevron-up"
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                    className: "fa-solid fa-chevron-down"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Collapse/* default */.Z, {
                            in: open === group,
                            timeout: "auto",
                            unmountOnExit: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                                gap: 1,
                                children: insideThreads.map(function(t) {
                                    var ref, ref1;
                                    var foundUser = collaborators === null || collaborators === void 0 ? void 0 : collaborators.find(function(c) {
                                        return c.id === t.userId;
                                    });
                                    var date = dayjs_min_default()(t.createdAt);
                                    var formattedDate = date.format("MMMM D, hh:mm A");
                                    var repliesCount = (t === null || t === void 0 ? void 0 : (ref = t.messages) === null || ref === void 0 ? void 0 : ref.length) ? (t === null || t === void 0 ? void 0 : (ref1 = t.messages) === null || ref1 === void 0 ? void 0 : ref1.length) - 1 : 0;
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container_Container/* default */.Z, {
                                        sx: {
                                            position: "relative",
                                            display: "flex",
                                            gap: "10px",
                                            justifyContent: "flex-start",
                                            alignItems: "center",
                                            my: 2,
                                            lineHeight: 2,
                                            cursor: "pointer",
                                            opacity: t.isCompleted ? 0.5 : 1,
                                            padding: "16px",
                                            border: "1px solid #EAECF0",
                                            borderRadius: "12px",
                                            "&:hover": {
                                                background: "#F2F4F7"
                                            }
                                        },
                                        onClick: function() {
                                            return onThreadItemSelect(t);
                                        },
                                        onMouseEnter: function() {
                                            return setHoveredNoteId(t.id);
                                        },
                                        onMouseLeave: function() {
                                            return setHoveredNoteId(null);
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge/* default */.Z, {
                                                badgeContent: newThreadMessages[t.id] || 0,
                                                color: "error",
                                                sx: {
                                                    alignSelf: "flex-start"
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                                    sx: {
                                                        bgcolor: userId === (foundUser === null || foundUser === void 0 ? void 0 : foundUser.id) ? "#2055ff" : "white",
                                                        color: userId === (foundUser === null || foundUser === void 0 ? void 0 : foundUser.id) ? "white" : "black",
                                                        border: "1px solid #D1D1D1"
                                                    },
                                                    children: getInitials((foundUser === null || foundUser === void 0 ? void 0 : foundUser.name) || "Guest")
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                                direction: "column",
                                                width: "100%",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                        sx: {
                                                            maxWidth: "210px",
                                                            fontWeight: 600,
                                                            textAlign: rtl ? "right" : "left",
                                                            fontSize: "14px"
                                                        },
                                                        children: (t === null || t === void 0 ? void 0 : t.title) || "..."
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                        variant: "body1",
                                                        lineHeight: 2,
                                                        sx: {
                                                            textAlign: rtl ? "right" : "left",
                                                            color: "#475467",
                                                            fontWeight: "400",
                                                            fontSize: "14px"
                                                        },
                                                        children: "Created: ".concat(formattedDate)
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                        variant: "body1",
                                                        lineHeight: 2,
                                                        sx: {
                                                            textAlign: rtl ? "right" : "left",
                                                            color: "#475467",
                                                            fontWeight: "400",
                                                            fontSize: "14px"
                                                        },
                                                        children: "".concat(repliesCount, " ").concat(repliesCount === 1 ? "Reply" : "Replies")
                                                    }),
                                                    editMode && t.id === (selectedThread === null || selectedThread === void 0 ? void 0 : selectedThread.id) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                                        direction: "row",
                                                        gap: 2,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                                                variant: "outlined",
                                                                color: "primary",
                                                                onClick: function(e) {
                                                                    e.stopPropagation();
                                                                    handleCancleEditPosition(t);
                                                                },
                                                                children: "Cancel"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                                                variant: "contained",
                                                                color: "primary",
                                                                size: "small",
                                                                onClick: function(e) {
                                                                    e.stopPropagation();
                                                                    handleSavePosition(t);
                                                                },
                                                                children: "Save"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            deviceManager/* default.isMobile */.Z.isMobile() || deviceManager/* default.isTablet */.Z.isTablet() || hoveredNoteId === t.id && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                                direction: "row",
                                                justifyContent: "space-between",
                                                alignItems: "center",
                                                sx: {
                                                    position: "absolute",
                                                    right: "16px",
                                                    top: "16px"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                                        onClick: function(e) {
                                                            e.stopPropagation();
                                                            moveToTag(t.sid);
                                                        },
                                                        id: "target-button-".concat(selectedThread === null || selectedThread === void 0 ? void 0 : selectedThread.id),
                                                        sx: {
                                                            width: "36px",
                                                            height: "36px"
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                            component: "i",
                                                            className: "fa-regular fa-location-crosshairs",
                                                            sx: {
                                                                color: "#667085",
                                                                fontSize: "24px",
                                                                fontWeight: 400
                                                            }
                                                        })
                                                    }),
                                                    (t === null || t === void 0 ? void 0 : t.userId) === userId && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                                                onClick: function(e) {
                                                                    return openMenu(e, t.id);
                                                                },
                                                                id: "thread-button-".concat(t.id),
                                                                sx: {
                                                                    width: "36px",
                                                                    height: "36px"
                                                                },
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                                    component: "i",
                                                                    className: "fa-solid fa-ellipsis-vertical",
                                                                    sx: {
                                                                        color: "#667085",
                                                                        fontSize: "24px",
                                                                        fontWeight: 400
                                                                    }
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Menu_Menu/* default */.Z, {
                                                                id: "thread-menu-".concat(t.id),
                                                                anchorEl: anchorEls[t.id],
                                                                open: Boolean(anchorEls[t.id]),
                                                                onClose: handleClose,
                                                                sx: {
                                                                    ".MuiPaper-root": {
                                                                        background: "white",
                                                                        borderRadius: "8px"
                                                                    }
                                                                },
                                                                MenuListProps: {
                                                                    "aria-labelledby": "thread-button-".concat(t.id)
                                                                },
                                                                anchorOrigin: {
                                                                    vertical: "bottom",
                                                                    horizontal: "right"
                                                                },
                                                                transformOrigin: {
                                                                    vertical: "top",
                                                                    horizontal: "right"
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuItem/* default */.Z, {
                                                                        onClick: function(e) {
                                                                            e.stopPropagation();
                                                                            handleEditPosition(t);
                                                                        },
                                                                        style: {
                                                                            display: "flex",
                                                                            flexDirection: "row",
                                                                            gap: "12px",
                                                                            alignItems: "center",
                                                                            width: "100%"
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                                className: "fa-regular fa-pen-to-square",
                                                                                style: {
                                                                                    fontSize: "13px"
                                                                                }
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                                                style: {
                                                                                    fontSize: "14px"
                                                                                },
                                                                                children: "Edit Position"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    (t === null || t === void 0 ? void 0 : t.isCompleted) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuItem/* default */.Z, {
                                                                        onClick: function(e) {
                                                                            e.stopPropagation();
                                                                            selectedThreadRef.current = threads.find(function(t) {
                                                                                return t.id === openedMenuId;
                                                                            });
                                                                            setIsCompletionModalOpen(true);
                                                                            handleClose(e);
                                                                        },
                                                                        style: {
                                                                            display: "flex",
                                                                            flexDirection: "row",
                                                                            gap: "12px",
                                                                            alignItems: "center",
                                                                            width: "100%"
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                                className: "fa-solid fa-arrow-rotate-left",
                                                                                style: {
                                                                                    fontSize: "13px"
                                                                                }
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                                                style: {
                                                                                    fontSize: "14px"
                                                                                },
                                                                                children: "Mark as Incomplete"
                                                                            })
                                                                        ]
                                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuItem/* default */.Z, {
                                                                        onClick: function(e) {
                                                                            e.stopPropagation();
                                                                            selectedThreadRef.current = threads.find(function(t) {
                                                                                return t.id === openedMenuId;
                                                                            });
                                                                            setIsCompletionModalOpen(true);
                                                                            handleClose(e);
                                                                        },
                                                                        style: {
                                                                            display: "flex",
                                                                            flexDirection: "row",
                                                                            gap: "12px",
                                                                            alignItems: "center",
                                                                            width: "100%"
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                                className: "fa fa-check",
                                                                                style: {
                                                                                    color: "#12B76A",
                                                                                    fontSize: "13px"
                                                                                }
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                                                style: {
                                                                                    fontSize: "14px"
                                                                                },
                                                                                children: "Mark as Complete"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {}),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuItem/* default */.Z, {
                                                                        id: t.id,
                                                                        onClick: function(e) {
                                                                            e.stopPropagation();
                                                                            selectedThreadRef.current = threads.find(function(t) {
                                                                                return t.id === openedMenuId;
                                                                            });
                                                                            setIsDeleteNoteModalOpen(true);
                                                                        },
                                                                        style: {
                                                                            display: "flex",
                                                                            flexDirection: "row",
                                                                            gap: "12px",
                                                                            alignItems: "center",
                                                                            width: "100%",
                                                                            color: "red"
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                                className: "fa-regular fa-trash-can",
                                                                                style: {
                                                                                    fontSize: "13px"
                                                                                }
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                                                style: {
                                                                                    fontSize: "14px"
                                                                                },
                                                                                children: "Delete"
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }, "thread-menu-".concat(t.id))
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }, t.id);
                                })
                            })
                        })
                    ]
                }, group);
            }),
            isCompletionModalOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(CompleteNoteModal, {
                isCompletionModalOpen: isCompletionModalOpen,
                handleClose: function() {
                    return setIsCompletionModalOpen(false);
                },
                selectedNote: selectedThreadRef.current,
                foundUser: foundUser,
                completeNote: onCompleteNote
            }),
            isDeleteNoteModalOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(DeleteNoteModal, {
                isDeleteNoteModalOpen: isDeleteNoteModalOpen,
                setIsDeleteNoteModalOpen: setIsDeleteNoteModalOpen,
                setThreads: setThreads,
                selectedThread: selectedThreadRef.current,
                threads: threads,
                tourSlug: tourSlug,
                userId: foundUser.id,
                removeThreadFromSpace: removeThreadFromSpace
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@mui/material/esm/CircularProgress/CircularProgress.js + 1 modules
var CircularProgress = __webpack_require__(70754);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/FormControl/FormControl.js + 1 modules
var FormControl = __webpack_require__(55343);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Select/Select.js + 5 modules
var Select = __webpack_require__(46541);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/ListItemIcon/ListItemIcon.js
var ListItemIcon = __webpack_require__(29894);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/InputAdornment/InputAdornment.js + 1 modules
var InputAdornment = __webpack_require__(9041);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Tooltip/Tooltip.js
var Tooltip = __webpack_require__(17575);
;// CONCATENATED MODULE: ./components/tour/Threads/components/NoteReporterBar.tsx



var NoteReporterBar = function(param) {
    var name = param.name, editMode = param.editMode, isNewThread = param.isNewThread;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
        sx: {
            background: "white",
            width: "100%"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                gap: 2,
                sx: {
                    width: "100%",
                    paddingY: isNewThread || editMode ? "11px" : 0,
                    paddingX: isNewThread || editMode ? "18px" : 0,
                    pb: isNewThread || editMode ? undefined : "11px"
                },
                children: [
                    isNewThread && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        sx: {
                            fontWeight: "500",
                            fontSize: "14px",
                            lineHeight: "24px",
                            color: "#344054"
                        },
                        children: "Reporter:"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                        sx: {
                            // height: '40px',
                            // width: '40px',
                            height: "26px",
                            width: "26px",
                            bgcolor: "#2055ff",
                            color: "white",
                            border: "1px solid #D1D1D1",
                            fontSize: "14px"
                        },
                        children: getInitials(name || "Guest")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        sx: {
                            fontWeight: "400",
                            fontSize: "16px",
                            color: "black"
                        },
                        children: name || "Guest"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {})
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/wavesurfer.js/dist/wavesurfer.esm.js
var wavesurfer_esm = __webpack_require__(70717);
;// CONCATENATED MODULE: ./components/common/AudioPlayer/useWaveSurfer.tsx






function useWavesurferInstance(containerRef, options) {
    var ref = (0,react.useState)(null), wavesurfer = ref[0], setWavesurfer = ref[1];
    var flatOptions = (0,react.useMemo)(function() {
        return Object.entries(options).flat();
    }, [
        options
    ]);
    (0,react.useEffect)(function() {
        if (!containerRef.current) return;
        var ws = wavesurfer_esm/* default.create */.Z.create((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, options), {
            container: containerRef.current
        }));
        setWavesurfer(ws);
        return function() {
            ws.destroy();
        };
    }, [
        containerRef
    ].concat((0,_to_consumable_array/* default */.Z)(flatOptions)));
    return wavesurfer;
}
function useWavesurferState(wavesurfer) {
    var ref = (0,react.useState)(false), isReady = ref[0], setIsReady = ref[1];
    var ref1 = (0,react.useState)(false), isPlaying = ref1[0], setIsPlaying = ref1[1];
    var ref2 = (0,react.useState)(0), currentTime = ref2[0], setCurrentTime = ref2[1];
    (0,react.useEffect)(function() {
        if (!wavesurfer) return;
        var handlers = {
            load: function() {
                setIsReady(false);
                setIsPlaying(false);
                setCurrentTime(0);
            },
            ready: function() {
                setIsReady(true);
                setIsPlaying(false);
                setCurrentTime(0);
            },
            play: function() {
                return setIsPlaying(true);
            },
            pause: function() {
                return setIsPlaying(false);
            },
            timeupdate: function() {
                return setCurrentTime(wavesurfer.getCurrentTime());
            },
            destroy: function() {
                setIsReady(false);
                setIsPlaying(false);
            }
        };
        Object.entries(handlers).forEach(function(param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), event = _param[0], handler = _param[1];
            wavesurfer.on(event, handler);
        });
        return function() {
            Object.entries(handlers).forEach(function(param) {
                var _param = (0,_sliced_to_array/* default */.Z)(param, 2), event = _param[0], handler = _param[1];
                wavesurfer.un(event, handler);
            });
        };
    }, [
        wavesurfer
    ]);
    return {
        isReady: isReady,
        isPlaying: isPlaying,
        currentTime: currentTime
    };
}
var EVENT_PROP_RE = /^on([A-Z])/;
var isEventProp = function(key) {
    return EVENT_PROP_RE.test(key);
};
var getEventName = function(key) {
    return key.replace(EVENT_PROP_RE, function(_, $1) {
        return $1.toLowerCase();
    });
};
function useWavesurferProps(props) {
    return (0,react.useMemo)(function() {
        var allOptions = (0,_object_spread/* default */.Z)({}, props);
        var allEvents = (0,_object_spread/* default */.Z)({}, props);
        for(var key in allOptions){
            if (isEventProp(key)) {
                delete allOptions[key];
            } else {
                delete allEvents[key];
            }
        }
        return [
            allOptions,
            allEvents
        ];
    }, [
        props
    ]);
}
function useWavesurferEvents(wavesurfer, events) {
    var flatEvents = (0,react.useMemo)(function() {
        return Object.entries(events).flat();
    }, [
        events
    ]);
    (0,react.useEffect)(function() {
        if (!wavesurfer) return;
        var eventEntries = Object.entries(events);
        if (!eventEntries.length) return;
        var unsubscribeFns = eventEntries.map(function(param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), name = _param[0], handler = _param[1];
            var event = getEventName(name);
            return wavesurfer.on(event, function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                return handler.apply(void 0, [
                    wavesurfer
                ].concat((0,_to_consumable_array/* default */.Z)(args)));
            });
        });
        return function() {
            unsubscribeFns.forEach(function(fn) {
                return fn();
            });
        };
    }, [
        wavesurfer
    ].concat((0,_to_consumable_array/* default */.Z)(flatEvents)));
}
function useWaveSurfer(props) {
    var containerRef = (0,react.useRef)(null);
    var ref = (0,_sliced_to_array/* default */.Z)(useWavesurferProps(props), 2), options = ref[0], events = ref[1];
    var wavesurfer = useWavesurferInstance(containerRef, options);
    useWavesurferEvents(wavesurfer, events);
    var ref1 = useWavesurferState(wavesurfer), isReady = ref1.isReady, isPlaying = ref1.isPlaying, currentTime = ref1.currentTime;
    var togglePlayPause = function() {
        if (wavesurfer) {
            wavesurfer.playPause();
        }
    };
    var formatTime = function(seconds) {
        var mins = Math.floor(seconds / 60);
        var secs = Math.floor(seconds % 60);
        return "".concat(mins, ":").concat(secs < 10 ? "0" : "").concat(secs);
    };
    return {
        containerRef: containerRef,
        wavesurfer: wavesurfer,
        isReady: isReady,
        isPlaying: isPlaying,
        currentTime: currentTime,
        togglePlayPause: togglePlayPause,
        formatTime: formatTime
    };
}

;// CONCATENATED MODULE: ./components/common/AudioPlayer/WaveSurferPlayer.tsx






var defaultWaveSurferProps = {
    waveColor: "rgb(200, 0, 200)",
    progressColor: "rgb(100, 0, 100)",
    barWidth: 2,
    barGap: 2,
    barRadius: 2,
    barHeight: 5,
    containerStyles: {},
    height: 45,
    width: "100%",
    playPauseButtonSx: {},
    containerSx: {},
    wavefHeight: "auto",
    cursorWidth: 0
};
var WavesurferPlayer = /*#__PURE__*/ (0,react.memo)(function(props) {
    var mergedProps = (0,_object_spread/* default */.Z)({}, defaultWaveSurferProps, props);
    var ref = useWaveSurfer(mergedProps), containerRef = ref.containerRef, // isReady,
    isPlaying = ref.isPlaying, currentTime = ref.currentTime, togglePlayPause = ref.togglePlayPause, formatTime = ref.formatTime;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        sx: (0,_object_spread/* default */.Z)({
            display: "flex",
            alignItems: "center",
            flexDirection: "row",
            justifyContent: "flex-start"
        }, mergedProps.containerSx),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                onClick: togglePlayPause,
                sx: (0,_object_spread/* default */.Z)({}, mergedProps.playPauseButtonSx),
                children: isPlaying ? /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                    className: "fa-solid fa-pause-circle",
                    style: {
                        fontSize: "37px"
                    }
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                    className: "fa-solid fa-play-circle",
                    style: {
                        fontSize: "37px"
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: containerRef,
                style: {
                    width: "100%"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: formatTime(currentTime)
            })
        ]
    });
});
/* harmony default export */ var WaveSurferPlayer = (WavesurferPlayer);

// EXTERNAL MODULE: ./node_modules/@mui/material/esm/FormHelperText/FormHelperText.js + 1 modules
var FormHelperText = __webpack_require__(32631);
// EXTERNAL MODULE: ./node_modules/react-quilljs/lib/index.js
var react_quilljs_lib = __webpack_require__(44019);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Popover/Popover.js + 1 modules
var Popover = __webpack_require__(43963);
;// CONCATENATED MODULE: ./components/tour/Threads/components/CollaboratorsList.tsx




var CollaboratorsList = function(param) {
    var collaborators = param.collaborators, description = param.description, anchorEl = param.anchorEl, setAnchorEl = param.setAnchorEl, quill = param.quill;
    var popoverRef = (0,react.useRef)(null);
    var handleCollaboratorSelect = function(collaborator) {
        var tag = "@".concat(collaborator.name);
        var selection = quill.getSelection();
        var index = selection ? selection.index : quill.getLength();
        if (quill) {
            var currentText = quill.getText();
            var lastAtIndex = currentText.lastIndexOf("@");
            var containsAt = lastAtIndex >= 0 && index - lastAtIndex <= 1;
            if (containsAt) {
                var startIndex = lastAtIndex;
                var endIndex = index;
                quill.deleteText(startIndex, endIndex - startIndex);
                quill.clipboard.dangerouslyPasteHTML(startIndex, '<span style="color:blue">'.concat(tag, "</span>&nbsp;"));
                quill.setSelection(startIndex + tag.length + 6);
            } else {
                quill.clipboard.dangerouslyPasteHTML(index, '<span style="color:blue">'.concat(tag, "</span>&nbsp;"));
                quill.setSelection(index + tag.length + 6);
            }
            setAnchorEl(null);
        }
    };
    var open = Boolean(anchorEl);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Popover/* default */.ZP, {
            open: open,
            anchorEl: anchorEl,
            onClose: function() {
                return setAnchorEl(null);
            },
            anchorOrigin: {
                vertical: "bottom",
                horizontal: "left"
            },
            transformOrigin: {
                vertical: "top",
                horizontal: "left"
            },
            ref: popoverRef,
            sx: {
                "& .MuiPopover-paper": {
                    background: "transparent",
                    maxWidth: "30%",
                    boxShadow: "none",
                    border: "none"
                }
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                sx: {
                    border: "1px solid #D1D1D1",
                    borderRadius: "8px",
                    backgroundColor: "#F9FAFB",
                    padding: "4px",
                    display: "flex",
                    flexDirection: "column",
                    gap: "5px",
                    width: "90%",
                    maxHeight: "200px",
                    overflowY: "auto",
                    m: "0 auto"
                },
                children: collaborators.map(function(collaborator) {
                    var tag = "@".concat(collaborator.name);
                    var isTagged = description.includes(tag);
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuItem/* default */.Z, {
                        onClick: function() {
                            return handleCollaboratorSelect(collaborator);
                        },
                        sx: {
                            width: "100%"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                sx: {
                                    bgcolor: "#2055ff",
                                    color: "white",
                                    border: "1px solid #D1D1D1",
                                    height: "25px",
                                    width: "25px",
                                    fontSize: "12px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    lineHeight: 1
                                },
                                children: getInitials((collaborator === null || collaborator === void 0 ? void 0 : collaborator.name) || "Guest")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "body1",
                                sx: {
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                    marginLeft: "10px",
                                    fontSize: "16px",
                                    fontWeight: "500"
                                },
                                children: collaborator.name
                            }),
                            isTagged && /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                className: "fa fa-check",
                                style: {
                                    color: "#2055ff",
                                    marginLeft: "auto"
                                }
                            })
                        ]
                    }, collaborator.id);
                })
            })
        })
    });
};

;// CONCATENATED MODULE: ./components/tour/Threads/components/Editor.tsx







var EditorComponent = function(param) {
    var description = param.description, setDescription = param.setDescription, collaborators = param.collaborators, anchorEl = param.anchorEl, setAnchorEl = param.setAnchorEl, focused = param.focused, setFocused = param.setFocused, recording = param.recording, stopRecording = param.stopRecording, setDescriptionLength = param.setDescriptionLength, handleFileChange = param.handleFileChange, isNewThread = param.isNewThread;
    var getTextFromHTML = function getTextFromHTML(html) {
        var tempDiv = document.createElement("div");
        tempDiv.innerHTML = html;
        return tempDiv.textContent || tempDiv.innerText || "";
    };
    var ref = (0,react.useState)(false), isSettingDescription = ref[0], setIsSettingDescription = ref[1];
    var ref1 = (0,react.useState)(0), time = ref1[0], setTime = ref1[1];
    var ref2 = (0,react.useState)(null), intervalId = ref2[0], setIntervalId = ref2[1];
    var ref3 = (0,react_quilljs_lib/* useQuill */.p)({
        modules: {
            toolbar: false
        },
        placeholder: "Write a text..."
    }), quill = ref3.quill, quillRef = ref3.quillRef, Quill = ref3.Quill;
    (0,react.useEffect)(function() {
        if (Quill) {
            var Link = Quill.import("formats/link");
            Link.sanitize = function(url) {
                var protocol = url.slice(0, url.indexOf(":"));
                if (this.PROTOCOL_WHITELIST.indexOf(protocol) === -1) {
                    url = "http://" + url;
                }
                var anchor = document.createElement("a");
                anchor.href = url;
                protocol = anchor.href.slice(0, anchor.href.indexOf(":"));
                return this.PROTOCOL_WHITELIST.indexOf(protocol) > -1 ? url : this.SANITIZED_URL;
            };
            Quill.register(Link, true);
        }
    }, [
        Quill
    ]);
    (0,react.useEffect)(function() {
        if (recording) {
            var id = setInterval(function() {
                setTime(function(prevTime) {
                    return prevTime + 1;
                });
            }, 1000);
            setIntervalId(id);
        } else if (!recording && intervalId) {
            clearInterval(intervalId);
            setIntervalId(null);
        }
        return function() {
            return clearInterval(intervalId);
        };
    }, [
        recording
    ]);
    var formatTime = function(seconds) {
        var mins = Math.floor(seconds / 60);
        var secs = seconds % 60;
        return "".concat(mins, ":").concat(secs < 10 ? "0" : "").concat(secs);
    };
    var containsAt = /(^|\s)@(\s|$)/;
    var handleOpenCollaboratorList = function(position) {
        setAnchorEl(position);
    };
    (0,react.useEffect)(function() {
        if (quill) {
            var handleTextChange = function() {
                if (!isSettingDescription) {
                    var currentContent = quill.getSemanticHTML();
                    var currentText = getTextFromHTML(currentContent);
                    if (containsAt.test(currentText)) {
                        if (containsAt.test(currentText)) {
                            handleOpenCollaboratorList(quill.container);
                        }
                    }
                    if (currentContent !== description) {
                        setDescription(currentContent);
                    }
                    var textContent = quill.getText().replace(/\n/g, "");
                    if (setDescriptionLength) {
                        setDescriptionLength(textContent.length);
                    }
                }
            };
            quill.on("text-change", handleTextChange);
            quill.on("selection-change", function(range) {
                var tooltipElement = document.querySelector(".ql-tooltip ");
                if (tooltipElement && tooltipElement.classList.contains("ql-hidden")) {
                    setFocused(!!range);
                }
            });
            var handlePaste = function() {
                var _ref = (0,_async_to_generator/* default */.Z)(function(event) {
                    var ref, clipboardItems, items, file, dataTransfer, fileInputEvent;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        clipboardItems = (ref = event.clipboardData) === null || ref === void 0 ? void 0 : ref.items;
                        items = Array.from(clipboardItems).filter(function(item) {
                            return item.type.includes("image");
                        });
                        if (items.length) {
                            event.preventDefault();
                            file = items[0].getAsFile();
                            if (file) {
                                dataTransfer = new DataTransfer();
                                dataTransfer.items.add(file);
                                fileInputEvent = new Event("change", {
                                    bubbles: true
                                });
                                Object.defineProperty(fileInputEvent, "target", {
                                    writable: false,
                                    value: {
                                        files: dataTransfer.files
                                    }
                                });
                                handleFileChange(fileInputEvent);
                                setTimeout(function() {
                                    var imgElements = quill.root.querySelectorAll("img");
                                    imgElements.forEach(function(img) {
                                        return img.remove();
                                    });
                                }, 100);
                            }
                        }
                        return [
                            2
                        ];
                    });
                });
                return function handlePaste(event) {
                    return _ref.apply(this, arguments);
                };
            }();
            quill.root.addEventListener("paste", handlePaste);
            return function() {
                quill.off("text-change", handleTextChange);
                quill.off("selection-change");
                quill.root.removeEventListener("paste", handlePaste);
            };
        }
    }, [
        quill,
        description,
        setDescription,
        setFocused,
        setDescriptionLength,
        handleFileChange,
        isSettingDescription
    ]);
    var applyStyles = (0,react.useCallback)(function() {
        var editorElement = document.querySelector(".ql-editor");
        if (editorElement) {
            editorElement.style.transition = "0.3s ease-in-out";
            editorElement.style.minHeight = focused ? "90px" : "0";
        // editorElement.style.padding = '0'
        }
    }, [
        focused
    ]);
    (0,react.useEffect)(function() {
        applyStyles();
    }, [
        applyStyles
    ]);
    (0,react.useEffect)(function() {
        if (quill) {
            var handleDescriptionUpdate = function() {
                setIsSettingDescription(true);
                quill.clipboard.dangerouslyPasteHTML(description);
                var imgElements = quill.root.querySelectorAll("img");
                imgElements.forEach(function(img) {
                    return img.remove();
                });
                setIsSettingDescription(false);
            };
            if (!isSettingDescription && quill.getSemanticHTML() !== description) {
                handleDescriptionUpdate();
            }
            return function() {
                quill.off("editor-change", handleDescriptionUpdate);
            };
        }
    }, [
        description,
        quill,
        isSettingDescription
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    width: "100%",
                    minHeight: isNewThread ? "170px" : "0",
                    height: "auto",
                    border: "none",
                    opacity: recording ? 0.5 : 1,
                    pointerEvents: recording ? "none" : "auto"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        ref: quillRef,
                        style: {
                            border: "none"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CollaboratorsList, {
                        description: description,
                        collaborators: collaborators,
                        anchorEl: anchorEl,
                        setAnchorEl: setAnchorEl,
                        quill: quill
                    })
                ]
            }),
            recording && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                sx: {
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    border: "1px solid #EAECF0",
                    borderRadius: "6px",
                    background: "#F9FAFB",
                    padding: "10px",
                    height: "70px",
                    maxHeight: "70px",
                    width: "100%"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        onClick: function() {
                            setFocused(true);
                            stopRecording();
                        },
                        sx: {
                            display: "flex",
                            alignItems: "center",
                            color: "red",
                            gap: "10px",
                            cursor: "pointer"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                className: "fa-solid fa-circle-stop",
                                style: {
                                    color: "inherit",
                                    fontSize: "33px"
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                sx: {
                                    color: "#000000"
                                },
                                children: "Recording..."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        sx: {
                            width: "50px",
                            height: "30px",
                            borderRadius: "16px",
                            background: "#F2F4F7"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            children: formatTime(time)
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Editor = (EditorComponent);

;// CONCATENATED MODULE: ./components/tour/Threads/components/helpers/UploadProgress.tsx


var renderWithLoader = function(Component, isLoading) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        sx: {
            width: "60px",
            height: "60px",
            background: "#F4F5F2",
            border: "1px solid #D1D1D1",
            borderRadius: "8px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            position: "relative"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, {}),
            isLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                sx: {
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    backgroundColor: "rgba(255, 255, 255, 0.8)",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    color: "#FFFFFF"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
                    color: "inherit",
                    size: 24
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/tour/Threads/components/NoteDescriptionField.tsx
















var maxDescriptionLength = 300;
var DescriptionField = function(param) {
    var collaborators = param.collaborators, isNewThread = param.isNewThread, editMode = param.editMode, foundUser = param.foundUser, focused = param.focused, setFocused = param.setFocused, setFiles = param.setFiles, addButtonDisabled = param.addButtonDisabled, setAddButtonDisabled = param.setAddButtonDisabled, setIsLoading = param.setIsLoading, handleAdd = param.handleAdd, clearInput = param.clearInput, description = param.description, setDescription = param.setDescription, setAudioURLs = param.setAudioURLs, previewSrcs = param.previewSrcs, loadingFiles = param.loadingFiles, audioURLs = param.audioURLs, mediaUrls = param.mediaUrls, setMediaUrls = param.setMediaUrls, isLoading = param.isLoading, removeReview = param.removeReview, removeAudio = param.removeAudio, handleFileChange = param.handleFileChange, descriptionLength = param.descriptionLength, setDescriptionLength = param.setDescriptionLength, descriptionError = param.descriptionError;
    var ref = (0,react.useState)(false), recording = ref[0], setRecording = ref[1];
    var ref1 = (0,react.useState)(mediaUrls === null || mediaUrls === void 0 ? void 0 : mediaUrls.filter(function(urlObj) {
        return urlObj.src.includes(".wav");
    })), audioMedia = ref1[0], setAudioMedia = ref1[1];
    var ref2 = (0,react.useState)(mediaUrls === null || mediaUrls === void 0 ? void 0 : mediaUrls.filter(function(urlObj) {
        return !urlObj.src.includes(".wav");
    })), galleryMedia = ref2[0], setGalleryMedia = ref2[1];
    var ref3 = (0,react.useState)(null), anchorEl = ref3[0], setAnchorEl = ref3[1];
    var mediaRecorder = (0,react.useRef)(null);
    var fileInputRef = (0,react.useRef)(null);
    var textContainerRef = (0,react.useRef)(null);
    var handleDelete = function(urlObj) {
        setAudioMedia(function(prevState) {
            return prevState.map(function(state) {
                return state.src === urlObj.src ? (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    flaggedToDelete: true
                }) : state;
            });
        });
        setGalleryMedia(function(prevState) {
            return prevState.map(function(state) {
                return state.src === urlObj.src ? (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    flaggedToDelete: true
                }) : state;
            });
        });
        setMediaUrls(function(prevState) {
            return prevState.map(function(state) {
                return state.src === urlObj.src ? (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    flaggedToDelete: true
                }) : state;
            });
        });
    };
    var countSymbolsLeft = function() {
        return maxDescriptionLength - descriptionLength;
    };
    var stopRecording = function() {
        if (mediaRecorder.current) {
            mediaRecorder.current.stop();
            setRecording(false);
        }
    };
    var startRecording = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var stream;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            navigator.mediaDevices.getUserMedia({
                                audio: true
                            })
                        ];
                    case 1:
                        stream = _state.sent();
                        mediaRecorder.current = new MediaRecorder(stream);
                        mediaRecorder.current.ondataavailable = function(event) {
                            var tempaudioName = (0,lodash.uniqueId)();
                            var audioBlob = new Blob([
                                event.data
                            ], {
                                type: "audio/wav"
                            });
                            var audioFile = new File([
                                audioBlob
                            ], "".concat(tempaudioName, "recording.wav"), {
                                type: "audio/wav"
                            });
                            setFiles(function(prevUploads) {
                                return (0,_to_consumable_array/* default */.Z)(prevUploads).concat([
                                    audioFile
                                ]);
                            });
                            setAudioURLs(function(prevUrls) {
                                return (0,_to_consumable_array/* default */.Z)(prevUrls).concat([
                                    {
                                        lastModified: audioFile.lastModified,
                                        src: URL.createObjectURL(audioBlob)
                                    }
                                ]);
                            });
                        };
                        mediaRecorder.current.start();
                        setRecording(true);
                        setFocused(true);
                        return [
                            2
                        ];
                }
            });
        });
        return function startRecording() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        if (textContainerRef.current && focused) {
            textContainerRef.current.scrollIntoView({
                behavior: "smooth",
                block: "center"
            });
        }
    }, [
        focused
    ]);
    var handleFileIconClick = function() {
        fileInputRef.current.click();
    };
    var handleAtIconClick = function(event) {
        setAnchorEl(event.currentTarget);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                ref: textContainerRef,
                sx: {
                    width: "100%",
                    background: "white",
                    outline: !!descriptionError && isNewThread ? "1px solid red" : focused ? "1px solid blue" : "1px solid #D0D5DD",
                    borderRadius: "12px",
                    padding: "12px",
                    "&:hover": {
                        outlineColor: "blue"
                    }
                },
                children: [
                    !isNewThread && !editMode && focused && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        sx: {
                            maxHeight: "fit-content",
                            height: "fit-content",
                            width: "100%",
                            justifyContent: "flex-start",
                            gap: 1,
                            flexWrap: "wrap",
                            paddingTop: "10px",
                            position: "relative"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NoteReporterBar, {
                            name: foundUser === null || foundUser === void 0 ? void 0 : foundUser.name,
                            editMode: editMode,
                            isNewThread: isNewThread
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        sx: {
                            position: "relative"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Editor, {
                                setDescription: setDescription,
                                description: description,
                                collaborators: collaborators,
                                anchorEl: anchorEl,
                                setAnchorEl: setAnchorEl,
                                setFocused: setFocused,
                                focused: focused,
                                recording: recording,
                                stopRecording: stopRecording,
                                setDescriptionLength: setDescriptionLength,
                                handleFileChange: handleFileChange,
                                isNewThread: isNewThread
                            }),
                            !!descriptionError && isNewThread && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                sx: {
                                    position: "absolute",
                                    right: "0",
                                    top: "14px"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                    className: "fa-regular fa-circle-exclamation",
                                    style: {
                                        color: "red",
                                        fontSize: "16px"
                                    }
                                })
                            }),
                            (focused || isNewThread || editMode) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    (!!previewSrcs.length || !!audioURLs.length || !!(mediaUrls === null || mediaUrls === void 0 ? void 0 : mediaUrls.length)) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                        sx: {
                                            maxHeight: "fit-content",
                                            height: "fit-content",
                                            marginBottom: "14px",
                                            width: "100%",
                                            justifyContent: "flex-start",
                                            gap: 1,
                                            flexWrap: "wrap",
                                            position: "relative"
                                        },
                                        children: [
                                            !!(previewSrcs === null || previewSrcs === void 0 ? void 0 : previewSrcs.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                                                direction: "row",
                                                gap: 1,
                                                mb: "14px",
                                                width: "100%",
                                                sx: {
                                                    flexWrap: "wrap"
                                                },
                                                children: previewSrcs.map(function(preview) {
                                                    var fileExtension;
                                                    if (preview.name.endsWith(".jpg") || preview.name.endsWith(".png") || preview.name.endsWith(".gif") || preview.name.endsWith(".webp")) {
                                                        fileExtension = "image";
                                                    }
                                                    if (preview.name.endsWith(".mp4") || preview.name.endsWith(".webm") || preview.name.endsWith(".ogg")) {
                                                        fileExtension = "video";
                                                    }
                                                    if (preview.name.endsWith(".pdf")) {
                                                        fileExtension = "document";
                                                    }
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                                        position: "relative",
                                                        children: [
                                                            fileExtension === "video" && renderWithLoader(function() {
                                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                                    sx: {
                                                                        width: "60px",
                                                                        height: "60px",
                                                                        background: "#F4F5F2",
                                                                        border: "1px solid #D1D1D1",
                                                                        borderRadius: "8px",
                                                                        display: "flex",
                                                                        justifyContent: "center",
                                                                        alignItems: "center"
                                                                    },
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(units_Icon/* default.Video */.Z.Video, {
                                                                        stroke: "#000000"
                                                                    })
                                                                });
                                                            }, isLoading),
                                                            fileExtension === "document" && renderWithLoader(function() {
                                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                                    sx: {
                                                                        width: "60px",
                                                                        height: "60px",
                                                                        background: "#F4F5F2",
                                                                        border: "1px solid #D1D1D1",
                                                                        borderRadius: "8px",
                                                                        display: "flex",
                                                                        justifyContent: "center",
                                                                        alignItems: "center"
                                                                    },
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(units_Icon/* default.Document */.Z.Document, {
                                                                        stroke: "#000000"
                                                                    })
                                                                });
                                                            }, isLoading),
                                                            fileExtension === "image" && renderWithLoader(function() {
                                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                    src: preview.src,
                                                                    alt: "File Preview ".concat(preview.name),
                                                                    width: "60px",
                                                                    height: "60px",
                                                                    style: {
                                                                        border: "1px solid #D1D1D1",
                                                                        borderRadius: "8px"
                                                                    }
                                                                });
                                                            }, isLoading),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                                                onClick: function() {
                                                                    return removeReview({
                                                                        name: preview.name,
                                                                        lastModified: preview.lastModified
                                                                    });
                                                                },
                                                                style: {
                                                                    position: "absolute",
                                                                    top: "-15px",
                                                                    right: "-15px",
                                                                    cursor: "pointer",
                                                                    color: "#2055FF",
                                                                    fontSize: "32px"
                                                                },
                                                                sx: {
                                                                    "&:hover": {
                                                                        background: "none"
                                                                    }
                                                                },
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                    className: "fa-light fa-circle-xmark",
                                                                    style: {
                                                                        fontSize: "22px",
                                                                        background: "#EAECF0",
                                                                        borderRadius: "50%"
                                                                    }
                                                                })
                                                            })
                                                        ]
                                                    }, "".concat(preview.name, "_").concat(preview.lastModified));
                                                })
                                            }),
                                            audioURLs === null || audioURLs === void 0 ? void 0 : audioURLs.map(function(audioURL) {
                                                return audioURL ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                                    position: "relative",
                                                    width: "100%",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(WaveSurferPlayer, {
                                                            url: audioURL.src,
                                                            waveColor: "#D0D5DD",
                                                            progressColor: "#2055FF",
                                                            barWidth: 2,
                                                            barGap: 2,
                                                            barRadius: 4,
                                                            barHeight: 10,
                                                            wavefHeight: 33,
                                                            playPauseButtonSx: {
                                                                color: "#2055FF",
                                                                padding: 0,
                                                                height: "30px"
                                                            },
                                                            containerSx: {
                                                                padding: "10px",
                                                                height: "70px",
                                                                maxHeight: "70px",
                                                                width: "100%",
                                                                gap: "6px",
                                                                background: "#F9FAFB",
                                                                border: "1px solid #EAECF0",
                                                                borderRadius: "8px",
                                                                position: "relative"
                                                            }
                                                        }),
                                                        isLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                            sx: {
                                                                position: "absolute",
                                                                top: 0,
                                                                left: 0,
                                                                width: "100%",
                                                                height: "100%",
                                                                backgroundColor: "rgba(255, 255, 255, 0.8)",
                                                                display: "flex",
                                                                justifyContent: "center",
                                                                alignItems: "center",
                                                                color: "#FFFFFF"
                                                            },
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
                                                                color: "inherit",
                                                                size: 24
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                                            onClick: function() {
                                                                return removeAudio({
                                                                    lastModified: audioURL.lastModified
                                                                });
                                                            },
                                                            style: {
                                                                position: "absolute",
                                                                top: "-15px",
                                                                right: "-15px",
                                                                cursor: "pointer",
                                                                color: "#2055FF",
                                                                fontSize: "32px"
                                                            },
                                                            sx: {
                                                                "&:hover": {
                                                                    background: "none"
                                                                }
                                                            },
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                className: "fa-light fa-circle-xmark",
                                                                style: {
                                                                    fontSize: "22px",
                                                                    background: "#EAECF0",
                                                                    borderRadius: "50%"
                                                                }
                                                            })
                                                        })
                                                    ]
                                                }, audioURL.lastModified) : null;
                                            }),
                                            !!(audioMedia === null || audioMedia === void 0 ? void 0 : audioMedia.length) && (audioMedia === null || audioMedia === void 0 ? void 0 : audioMedia.map(function(urlObj, i) {
                                                if (urlObj.flaggedToDelete) return null;
                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                                    position: "relative",
                                                    width: "100%",
                                                    mb: 1,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(WaveSurferPlayer, {
                                                            url: "".concat("https://cdn.treedis.com", "/").concat(urlObj.src),
                                                            waveColor: "#D0D5DD",
                                                            progressColor: "#2055FF",
                                                            barWidth: 2,
                                                            barGap: 2,
                                                            barRadius: 4,
                                                            barHeight: 12,
                                                            wavefHeight: 37,
                                                            playPauseButtonSx: {
                                                                color: "#2055FF",
                                                                padding: 0,
                                                                height: "30px"
                                                            },
                                                            containerSx: {
                                                                background: "#F9FAFB",
                                                                border: "1px solid #EAECF0",
                                                                borderRadius: "8px",
                                                                padding: "10px",
                                                                height: "auto"
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                                            onClick: function() {
                                                                return handleDelete(urlObj);
                                                            },
                                                            style: {
                                                                position: "absolute",
                                                                top: "-15px",
                                                                right: "-15px",
                                                                cursor: "pointer",
                                                                color: "#2055FF",
                                                                fontSize: "32px"
                                                            },
                                                            sx: {
                                                                "&:hover": {
                                                                    background: "none"
                                                                }
                                                            },
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                className: "fa-light fa-circle-xmark",
                                                                style: {
                                                                    fontSize: "22px",
                                                                    background: "#EAECF0",
                                                                    borderRadius: "50%"
                                                                }
                                                            })
                                                        })
                                                    ]
                                                }, i);
                                            })),
                                            !!(galleryMedia === null || galleryMedia === void 0 ? void 0 : galleryMedia.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                                                direction: "row",
                                                gap: 1,
                                                width: "100%",
                                                sx: {
                                                    flexWrap: "wrap"
                                                },
                                                children: galleryMedia === null || galleryMedia === void 0 ? void 0 : galleryMedia.map(function(urlObj, i) {
                                                    if (urlObj.flaggedToDelete) return null;
                                                    var fileExtension;
                                                    if ((urlObj === null || urlObj === void 0 ? void 0 : urlObj.src.endsWith(".jpg")) || (urlObj === null || urlObj === void 0 ? void 0 : urlObj.src.endsWith(".png")) || (urlObj === null || urlObj === void 0 ? void 0 : urlObj.src.endsWith(".gif")) || (urlObj === null || urlObj === void 0 ? void 0 : urlObj.src.endsWith(".webp"))) {
                                                        fileExtension = "image";
                                                    }
                                                    if ((urlObj === null || urlObj === void 0 ? void 0 : urlObj.src.endsWith(".mp4")) || (urlObj === null || urlObj === void 0 ? void 0 : urlObj.src.endsWith(".webm")) || (urlObj === null || urlObj === void 0 ? void 0 : urlObj.src.endsWith(".ogg"))) {
                                                        fileExtension = "video";
                                                    }
                                                    if (urlObj === null || urlObj === void 0 ? void 0 : urlObj.src.endsWith(".pdf")) {
                                                        fileExtension = "document";
                                                    }
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                                        position: "relative",
                                                        children: [
                                                            fileExtension === "video" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                                sx: {
                                                                    width: "60px",
                                                                    height: "60px",
                                                                    background: "#F4F5F2",
                                                                    border: "1px solid #D1D1D1",
                                                                    borderRadius: "8px",
                                                                    display: "flex",
                                                                    justifyContent: "center",
                                                                    alignItems: "center"
                                                                },
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(units_Icon/* default.Video */.Z.Video, {
                                                                    stroke: "#000000"
                                                                })
                                                            }),
                                                            fileExtension === "document" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                                sx: {
                                                                    width: "60px",
                                                                    height: "60px",
                                                                    background: "#F4F5F2",
                                                                    border: "1px solid #D1D1D1",
                                                                    borderRadius: "8px",
                                                                    display: "flex",
                                                                    justifyContent: "center",
                                                                    alignItems: "center"
                                                                },
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(units_Icon/* default.Document */.Z.Document, {
                                                                    stroke: "#000000"
                                                                })
                                                            }),
                                                            fileExtension === "image" && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                src: "".concat("https://cdn.treedis.com", "/").concat(urlObj.src),
                                                                alt: "Preview ".concat(i),
                                                                width: "60px",
                                                                height: "60px",
                                                                style: {
                                                                    border: "1px solid #D1D1D1",
                                                                    borderRadius: "8px"
                                                                }
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                                                onClick: function() {
                                                                    return handleDelete(urlObj);
                                                                },
                                                                style: {
                                                                    position: "absolute",
                                                                    top: "-15px",
                                                                    right: "-15px",
                                                                    cursor: "pointer",
                                                                    color: "#2055FF",
                                                                    fontSize: "32px"
                                                                },
                                                                sx: {
                                                                    "&:hover": {
                                                                        background: "none"
                                                                    }
                                                                },
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                    className: "fa-light fa-circle-xmark",
                                                                    style: {
                                                                        fontSize: "22px",
                                                                        background: "#EAECF0",
                                                                        borderRadius: "50%"
                                                                    }
                                                                })
                                                            })
                                                        ]
                                                    }, i);
                                                })
                                            })
                                        ]
                                    }),
                                    !!(loadingFiles === null || loadingFiles === void 0 ? void 0 : loadingFiles.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                                        direction: "row",
                                        gap: 1,
                                        mb: "14px",
                                        width: "100%",
                                        sx: {
                                            flexWrap: "wrap"
                                        },
                                        children: loadingFiles.map(function(file) {
                                            var fileExtension = "";
                                            if (file.name.endsWith(".jpg") || file.name.endsWith(".png") || file.name.endsWith(".gif") || file.name.endsWith(".webp")) {
                                                fileExtension = "image";
                                            }
                                            if (file.name.endsWith(".mp4") || file.name.endsWith(".webm") || file.name.endsWith(".ogg")) {
                                                fileExtension = "video";
                                            }
                                            if (file.name.endsWith(".pdf")) {
                                                fileExtension = "document";
                                            }
                                            var isLoading = loadingFiles.includes(file);
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                                position: "relative",
                                                children: [
                                                    fileExtension === "video" && renderWithLoader(function() {
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                            sx: {
                                                                width: "60px",
                                                                height: "60px",
                                                                background: "#F4F5F2",
                                                                border: "1px solid #D1D1D1",
                                                                borderRadius: "8px",
                                                                display: "flex",
                                                                justifyContent: "center",
                                                                alignItems: "center"
                                                            },
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(units_Icon/* default.Video */.Z.Video, {
                                                                stroke: "#000000"
                                                            })
                                                        });
                                                    }, isLoading),
                                                    fileExtension === "document" && renderWithLoader(function() {
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                            sx: {
                                                                width: "60px",
                                                                height: "60px",
                                                                background: "#F4F5F2",
                                                                border: "1px solid #D1D1D1",
                                                                borderRadius: "8px",
                                                                display: "flex",
                                                                justifyContent: "center",
                                                                alignItems: "center"
                                                            },
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(units_Icon/* default.Document */.Z.Document, {
                                                                stroke: "#000000"
                                                            })
                                                        });
                                                    }, isLoading),
                                                    fileExtension === "image" && renderWithLoader(function() {
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                            sx: {
                                                                position: "relative",
                                                                width: "60px",
                                                                height: "60px",
                                                                border: "1px solid #D1D1D1",
                                                                backgroundColor: "rgba(0, 0, 0, 0.7)",
                                                                borderRadius: "8px",
                                                                overflow: "hidden",
                                                                display: "flex",
                                                                justifyContent: "center",
                                                                alignItems: "center"
                                                            }
                                                        });
                                                    }, isLoading),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                                        onClick: function() {
                                                            return removeReview({
                                                                name: file.name,
                                                                lastModified: file.lastModified
                                                            });
                                                        },
                                                        style: {
                                                            position: "absolute",
                                                            top: "-15px",
                                                            right: "-15px",
                                                            cursor: "pointer",
                                                            color: "#2055FF",
                                                            fontSize: "32px"
                                                        },
                                                        sx: {
                                                            "&:hover": {
                                                                background: "none"
                                                            }
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                            className: "fa-light fa-circle-xmark",
                                                            style: {
                                                                fontSize: "22px",
                                                                background: "#EAECF0",
                                                                borderRadius: "50%"
                                                            }
                                                        })
                                                    })
                                                ]
                                            }, "".concat(file.name, "_").concat(file.lastModified));
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                        direction: "row",
                                        sx: {
                                            height: "100%",
                                            width: "100%",
                                            justifyContent: "space-between",
                                            alignItems: "center"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                                direction: "row",
                                                sx: {
                                                    direction: "flex",
                                                    gap: "4px"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                                        onClick: handleFileIconClick,
                                                        sx: {
                                                            padding: "5px",
                                                            width: "30px",
                                                            height: "30px"
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                            className: "fa-regular fa-paperclip",
                                                            style: {
                                                                color: "#667085",
                                                                fontSize: "18px"
                                                            }
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                                        onClick: handleAtIconClick,
                                                        sx: {
                                                            padding: "5px",
                                                            width: "30px",
                                                            height: "30px"
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                            className: "fa-regular fa-at",
                                                            style: {
                                                                fontSize: "18px"
                                                            }
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                                        onClick: recording ? stopRecording : startRecording,
                                                        sx: {
                                                            color: recording ? "red" : "#667085",
                                                            padding: "5px",
                                                            width: "30px",
                                                            height: "30px"
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                            className: "fa-regular fa-microphone",
                                                            style: {
                                                                fontSize: "18px"
                                                            }
                                                        })
                                                    })
                                                ]
                                            }),
                                            !isNewThread && !editMode && /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                                onClick: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                                                    var result;
                                                    return (0,tslib_es6.__generator)(this, function(_state) {
                                                        switch(_state.label){
                                                            case 0:
                                                                setAddButtonDisabled(true);
                                                                setIsLoading(true);
                                                                return [
                                                                    4,
                                                                    handleAdd({
                                                                        description: description,
                                                                        messageId: null
                                                                    })
                                                                ];
                                                            case 1:
                                                                result = _state.sent();
                                                                if (result === "Success") {
                                                                    clearInput();
                                                                } else {
                                                                    react_toastify_esm/* toast.error */.Am.error("Could not send message");
                                                                    setIsLoading(false);
                                                                }
                                                                return [
                                                                    2
                                                                ];
                                                        }
                                                    });
                                                }),
                                                disabled: addButtonDisabled || recording,
                                                sx: {
                                                    mb: "5px",
                                                    color: "white",
                                                    background: "#2055FF",
                                                    height: "44px",
                                                    width: "44px",
                                                    borderRadius: "50%",
                                                    ml: "auto",
                                                    transition: "all 0.3s ease",
                                                    "&:hover": {
                                                        background: "#2055ff",
                                                        opacity: "0.75"
                                                    }
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                    className: "fa-regular fa-paper-plane-top",
                                                    style: {
                                                        fontSize: "18px"
                                                    }
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        type: "file",
                        accept: "image/jpeg, image/png, application/pdf, video/mp4, video/quicktime",
                        capture: "environment",
                        ref: fileInputRef,
                        style: {
                            display: "none"
                        },
                        onChange: handleFileChange,
                        multiple: true
                    })
                ]
            }),
            !!descriptionError && isNewThread && /*#__PURE__*/ (0,jsx_runtime.jsx)(FormHelperText/* default */.Z, {
                sx: {
                    textAlign: "left",
                    marginX: 0,
                    marginTop: "5px",
                    marginLeft: "14px",
                    color: "red"
                },
                children: descriptionError
            }),
            focused && /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormHelperText/* default */.Z, {
                sx: {
                    textAlign: "left",
                    marginX: 0,
                    marginTop: "5px",
                    marginLeft: "14px",
                    color: countSymbolsLeft() < 0 ? "red" : "inherit"
                },
                children: [
                    countSymbolsLeft(),
                    " symbols left"
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(79072);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/InputLabel/InputLabel.js + 3 modules
var InputLabel = __webpack_require__(58316);
// EXTERNAL MODULE: ./node_modules/react-datepicker/dist/react-datepicker.min.js
var react_datepicker_min = __webpack_require__(9198);
var react_datepicker_min_default = /*#__PURE__*/__webpack_require__.n(react_datepicker_min);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
;// CONCATENATED MODULE: ./components/tour/Threads/components/SAPNoteForm.tsx











var truncateText = function(text, maxLength) {
    return text.length > maxLength ? "".concat(text.substring(0, maxLength), "...") : text;
};
var priorityColors = {
    1: "red",
    2: "orange",
    3: "yellow",
    4: "blue"
};
var selectStyles = {
    background: "white",
    "& .MuiSelect-select": {
        display: "flex",
        alignItems: "center",
        maxHeight: "44px",
        height: "100%"
    },
    "& .MuiOutlinedInput-notchedOutline": {
        borderRadius: "8px",
        borderColor: "#D0D5DD",
        borderWidth: "1px"
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: "blue"
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: "blue"
    }
};
var menuProps = {
    PaperProps: {
        sx: {
            bgcolor: "#f9f9f9",
            borderRadius: "8px",
            boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)"
        }
    },
    MenuListProps: {
        sx: {
            padding: 0,
            "& .MuiMenuItem-root": {
                padding: "10px 20px",
                "&:hover": {
                    bgcolor: "#ececec"
                }
            }
        }
    }
};
var inputLabelStyles = {
    color: "#667085",
    fontSize: "16px",
    backgroundColor: "transparent",
    marginRight: "8px",
    top: "-4px"
};
var fieldLabels = {
    functionalLocation: "Functional Location",
    equipment: "Equipment",
    noteType: "Note Type",
    equipmentFailure: "Equipment Failure",
    faultSource: "Fault Source",
    priority: "Priority"
};
var priorityEndDateRules = {
    1: 1,
    2: 3,
    3: 21,
    4: 56
};
var SAPNoteForm = function(param) {
    var collaborators = param.collaborators, setAssignee = param.setAssignee, assignee = param.assignee, setSAPData = param.setSAPData, SAPData = param.SAPData, SAPFieldsData = param.SAPFieldsData;
    var ref = (0,react.useState)(null), selectedDate = ref[0], setSelectedDate = ref[1];
    var ref1 = (0,react.useState)(""), selectedLocation = ref1[0], setSelectedLocation = ref1[1];
    var ref2 = (0,react.useState)([]), filteredEquipment = ref2[0], setFilteredEquipment = ref2[1];
    // Reverse mapping of fieldLabels
    var serverFieldKeys = Object.fromEntries(Object.entries(fieldLabels).map(function(param) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], value = _param[1];
        return [
            value,
            key
        ];
    }));
    (0,react.useEffect)(function() {
        if (Object.keys(SAPData).length === 0 && SAPFieldsData.length > 0) {
            var initialSAPData = {};
            SAPFieldsData.forEach(function(field) {
                var ref;
                var serverKey = field.key;
                initialSAPData[serverKey] = ((ref = field.options[0]) === null || ref === void 0 ? void 0 : ref.value) || "";
                if (serverKey === "functionalLocation") {
                    var ref1;
                    setSelectedLocation((ref1 = field.options[0]) === null || ref1 === void 0 ? void 0 : ref1.value);
                }
            });
            setSAPData(initialSAPData);
        }
    }, [
        SAPFieldsData,
        SAPData,
        setSAPData
    ]);
    (0,react.useEffect)(function() {
        var equipmentField = SAPFieldsData.find(function(field) {
            return field.key === "equipment";
        });
        if (equipmentField && selectedLocation) {
            var equipmentOptions = equipmentField.options[selectedLocation] || [];
            setFilteredEquipment(equipmentOptions);
        }
    }, [
        selectedLocation,
        SAPFieldsData
    ]);
    (0,react.useEffect)(function() {
        var calculateEndDate = function() {
            if (SAPData["priority"]) {
                var daysToAdd = priorityEndDateRules[SAPData["priority"]] || 0;
                return moment_default()().add(daysToAdd, "days").toDate();
            }
            return null;
        };
        var newEndDate = calculateEndDate();
        if (newEndDate) {
            setSelectedDate(newEndDate);
            setSAPData(function(prevData) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevData), {
                    endDate: moment_default()(newEndDate).format("YYYYMMDD HHmm")
                });
            });
        }
    }, [
        SAPData["priority"],
        setSAPData
    ]);
    var handleAssigneeChange = function(event) {
        var selectedCollaborator = collaborators.find(function(c) {
            return c.name === event.target.value;
        });
        setAssignee(selectedCollaborator.name);
    };
    var handleFieldChange = function(label) {
        return function(event) {
            var serverKey = serverFieldKeys[label] || label;
            setSAPData(function(prevData) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevData), (0,_define_property/* default */.Z)({}, serverKey, event.target.value));
            });
        };
    };
    var handleLocationChange = function(event) {
        var location = event.target.value;
        setSelectedLocation(location);
        setSAPData(function(prevData) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevData), {
                functionalLocation: location
            });
        });
    };
    var handleDateChange = function(date) {
        setSelectedDate(date);
        setSAPData(function(prevData) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevData), {
                endDate: moment_default()(date).format("YYYYMMDD HHmm")
            });
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        display: "flex",
        flexDirection: "column",
        gap: 2,
        sx: {
            width: "100%",
            marginBottom: "25px"
        },
        children: [
            SAPFieldsData.map(function(field) {
                var label = fieldLabels[field.key] || field.key;
                var isRequired = [
                    "functionalLocation",
                    "priority",
                    "faultSource",
                    "equipmentFailure"
                ].includes(field.key);
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                    container: true,
                    alignItems: "center",
                    spacing: 2,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            xs: 6,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                variant: "body1",
                                sx: {
                                    color: "#344054",
                                    fontSize: "14px",
                                    background: "transparent",
                                    fontWeight: "500"
                                },
                                children: [
                                    label,
                                    " ",
                                    isRequired && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        style: {
                                            color: "red"
                                        },
                                        children: "*"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            xs: 6,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControl/* default */.Z, {
                                fullWidth: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Select/* default */.Z, {
                                    value: SAPData[field.key] || "",
                                    label: label,
                                    onChange: handleFieldChange(label),
                                    IconComponent: function(props) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(units_Icon/* default.ChevronDown */.Z.ChevronDown, (0,_object_spread/* default */.Z)({
                                            sx: {
                                                fontSize: "20px",
                                                marginRight: "7px"
                                            }
                                        }, props));
                                    },
                                    sx: selectStyles,
                                    MenuProps: menuProps,
                                    notched: false,
                                    renderValue: function(selected) {
                                        var selectedOption = null;
                                        if (field.key === "equipment") {
                                            var equipment = field === null || field === void 0 ? void 0 : field.options[selectedLocation];
                                            selectedOption = equipment === null || equipment === void 0 ? void 0 : equipment.find(function(item) {
                                                return item.value === selected;
                                            });
                                        } else {
                                            selectedOption = field.options.find(function(option) {
                                                return option.value === selected;
                                            });
                                        }
                                        if (field.key === "priority" && selectedOption) {
                                            var priorityColor = priorityColors[selectedOption.value];
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                style: {
                                                    display: "flex",
                                                    alignItems: "center"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        style: {
                                                            display: "inline-block",
                                                            width: "10px",
                                                            height: "10px",
                                                            borderRadius: "50%",
                                                            backgroundColor: priorityColor,
                                                            marginRight: "7px"
                                                        }
                                                    }),
                                                    truncateText(selectedOption.label, 20)
                                                ]
                                            });
                                        }
                                        return selectedOption ? truncateText(selectedOption.label, 20) : "";
                                    },
                                    children: [
                                        field.key === "functionalLocation" && field.options.map(function(option) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuItem/* default */.Z, {
                                                value: option.value,
                                                onClick: function() {
                                                    return handleLocationChange({
                                                        target: {
                                                            value: option.value
                                                        }
                                                    });
                                                },
                                                sx: {
                                                    "&.Mui-selected": {
                                                        backgroundColor: "transparent",
                                                        "&:hover": {
                                                            backgroundColor: "rgba(130, 130, 130, 0.08)"
                                                        }
                                                    }
                                                },
                                                children: [
                                                    option.label,
                                                    SAPData[field.key] === option.value && /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemIcon/* default */.Z, {
                                                        sx: {
                                                            ml: "auto"
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                            className: "fa-light fa-check",
                                                            style: {
                                                                color: "blue",
                                                                fontSize: "20px"
                                                            }
                                                        })
                                                    })
                                                ]
                                            }, option.value);
                                        }),
                                        field.key === "equipment" && filteredEquipment.map(function(option) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuItem/* default */.Z, {
                                                value: option.value,
                                                sx: {
                                                    "&.Mui-selected": {
                                                        backgroundColor: "transparent",
                                                        "&:hover": {
                                                            backgroundColor: "rgba(130, 130, 130, 0.08)"
                                                        }
                                                    }
                                                },
                                                children: [
                                                    option.label,
                                                    SAPData[field.key] === option.value && /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemIcon/* default */.Z, {
                                                        sx: {
                                                            ml: "auto",
                                                            minWidth: "0 !important"
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                            className: "fa-light fa-check",
                                                            style: {
                                                                color: "blue",
                                                                fontSize: "20px"
                                                            }
                                                        })
                                                    })
                                                ]
                                            }, option.value);
                                        }),
                                        field.key !== "functionalLocation" && field.key !== "equipment" && field.key !== "priority" && field.options.map(function(option) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuItem/* default */.Z, {
                                                value: option.value,
                                                sx: {
                                                    "&.Mui-selected": {
                                                        backgroundColor: "transparent",
                                                        "&:hover": {
                                                            backgroundColor: "rgba(130, 130, 130, 0.08)"
                                                        }
                                                    }
                                                },
                                                children: [
                                                    option.label,
                                                    SAPData[field.key] === option.value && /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemIcon/* default */.Z, {
                                                        sx: {
                                                            ml: "auto",
                                                            minWidth: "0 !important"
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                            className: "fa-light fa-check",
                                                            style: {
                                                                color: "blue",
                                                                fontSize: "20px"
                                                            }
                                                        })
                                                    })
                                                ]
                                            }, option.value);
                                        }),
                                        field.key === "priority" && field.options.map(function(option) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuItem/* default */.Z, {
                                                value: option.value,
                                                sx: {
                                                    "&.Mui-selected": {
                                                        backgroundColor: "transparent",
                                                        "&:hover": {
                                                            backgroundColor: "rgba(130, 130, 130, 0.08)"
                                                        }
                                                    }
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemIcon/* default */.Z, {
                                                        sx: {
                                                            minWidth: "0 !important"
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                            sx: {
                                                                width: "10px",
                                                                height: "10px",
                                                                borderRadius: "50%",
                                                                backgroundColor: priorityColors[option.value],
                                                                marginRight: "7px"
                                                            }
                                                        })
                                                    }),
                                                    option.label,
                                                    SAPData[field.key] === option.value && /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemIcon/* default */.Z, {
                                                        sx: {
                                                            ml: "auto",
                                                            minWidth: "0 !important"
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                            className: "fa-light fa-check",
                                                            style: {
                                                                color: "blue",
                                                                fontSize: "20px"
                                                            }
                                                        })
                                                    })
                                                ]
                                            }, option.value);
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                }, label);
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                container: true,
                alignItems: "center",
                spacing: 2,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        item: true,
                        xs: 6,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "body1",
                            sx: {
                                color: "#344054",
                                fontSize: "14px",
                                background: "transparent"
                            },
                            children: "Assignee"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        item: true,
                        xs: 6,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormControl/* default */.Z, {
                            fullWidth: true,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(InputLabel/* default */.Z, {
                                    id: "assignee-label",
                                    sx: inputLabelStyles,
                                    children: "Choose"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Select/* default */.Z, {
                                    labelId: "assignee-label",
                                    value: assignee || "",
                                    label: "Choose",
                                    onChange: handleAssigneeChange,
                                    disabled: true,
                                    renderValue: function(selected) {
                                        var collaborator = collaborators.find(function(c) {
                                            return c.name === selected;
                                        });
                                        return collaborator ? collaborator.name : "";
                                    },
                                    IconComponent: function(props) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(units_Icon/* default.ChevronDown */.Z.ChevronDown, (0,_object_spread/* default */.Z)({
                                            sx: {
                                                fontSize: "18px",
                                                marginRight: "7px"
                                            }
                                        }, props));
                                    },
                                    sx: selectStyles,
                                    MenuProps: menuProps,
                                    children: collaborators.map(function(collaborator) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuItem/* default */.Z, {
                                            value: collaborator.name,
                                            sx: {
                                                "&.Mui-selected": {
                                                    backgroundColor: "transparent",
                                                    "&:hover": {
                                                        backgroundColor: "rgba(130, 130, 130, 0.08)"
                                                    }
                                                }
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                                    sx: {
                                                        bgcolor: "#2055ff",
                                                        color: "white",
                                                        border: "1px solid #D1D1D1",
                                                        height: "25px",
                                                        width: "25px",
                                                        fontSize: "12px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        lineHeight: 1
                                                    },
                                                    children: getInitials(collaborator.name)
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemIcon/* default */.Z, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                        variant: "body2",
                                                        sx: {
                                                            ml: 1,
                                                            color: "#344054"
                                                        },
                                                        children: collaborator.name
                                                    })
                                                })
                                            ]
                                        }, collaborator.id);
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                container: true,
                alignItems: "center",
                spacing: 2,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        item: true,
                        xs: 6,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "body1",
                            sx: {
                                color: "#344054",
                                fontSize: "14px",
                                background: "transparent"
                            },
                            children: "End Date"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        item: true,
                        xs: 6,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((react_datepicker_min_default()), {
                            selected: selectedDate,
                            onChange: handleDateChange,
                            dateFormat: "dd-MM-yyyy HH:mm",
                            customInput: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControl/* default */.Z, {
                                fullWidth: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Select/* default */.Z, {
                                    value: selectedDate ? moment_default()(selectedDate).format("DD-MM-YYYY HH:mm") : "",
                                    IconComponent: function(props) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(units_Icon/* default.ChevronDown */.Z.ChevronDown, (0,_object_spread/* default */.Z)({
                                            sx: {
                                                fontSize: "20px",
                                                marginRight: "7px"
                                            }
                                        }, props));
                                    },
                                    sx: selectStyles,
                                    displayEmpty: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                                        value: selectedDate ? moment_default()(selectedDate).format("DD-MM-YYYY HH:mm") : "",
                                        children: selectedDate ? moment_default()(selectedDate).format("DD-MM-YYYY HH:mm") : "Select date"
                                    })
                                })
                            })
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/tour/Threads/components/NoteForm.tsx













var noteOptions = [
    {
        value: "message",
        label: "Leave a message"
    },
    {
        value: "SAP",
        label: "SAP report"
    }, 
];
var maxFilesSize = 20971520;
var NoteForm = function(param) {
    var noteFormat = param.noteFormat, setNoteFormat = param.setNoteFormat, files = param.files, setFiles = param.setFiles, handleAdd = param.handleAdd, editMode = param.editMode, setEditMode = param.setEditMode, mediaUrls = param.mediaUrls, setMediaUrls = param.setMediaUrls, userId = param.userId, rtl = param.rtl, isNewThread = param.isNewThread, collaborators = param.collaborators, foundUser = param.foundUser, isMainMessage = param.isMainMessage, SAPData = param.SAPData, setSAPData = param.setSAPData, onGetSAPOptions = param.onGetSAPOptions, isSAPActive = param.isSAPActive, noteTitle = param.noteTitle, currentMessage = param.currentMessage, onCloseDrawer = param.onCloseDrawer;
    var ref = (0,react.useState)(""), assignee = ref[0], setAssignee = ref[1];
    var ref1 = (0,react.useState)((currentMessage === null || currentMessage === void 0 ? void 0 : currentMessage.description) || ""), description = ref1[0], setDescription = ref1[1];
    var ref2 = (0,react.useState)(noteTitle || ""), title = ref2[0], setTitle = ref2[1];
    var ref3 = (0,react.useState)(false), focused = ref3[0], setFocused = ref3[1];
    var ref4 = (0,react.useState)([]), previewSrcs = ref4[0], setPreviewSrcs = ref4[1];
    var ref5 = (0,react.useState)([]), audioURLs = ref5[0], setAudioURLs = ref5[1];
    var ref6 = (0,react.useState)(false), isLoading = ref6[0], setIsLoading = ref6[1];
    var ref7 = (0,react.useState)(true), addButtonDisabled = ref7[0], setAddButtonDisabled = ref7[1];
    var ref8 = (0,react.useState)([]), SAPOptions = ref8[0], setSAPOptions = ref8[1];
    var ref9 = (0,react.useState)(0), descriptionLength = ref9[0], setDescriptionLength = ref9[1];
    var ref10 = (0,react.useState)([]), loadingFiles = ref10[0], setLoadingFiles = ref10[1];
    var ref11 = (0,react.useState)((currentMessage === null || currentMessage === void 0 ? void 0 : currentMessage.id) || null), messageId = ref11[0], setMessageId = ref11[1];
    var ref12 = (0,react.useState)(false), hasShownError = ref12[0], setHasShownError = ref12[1];
    var ref13 = (0,react.useState)(""), titleError = ref13[0], setTitleError = ref13[1];
    var ref14 = (0,react.useState)(""), descriptionError = ref14[0], setDescriptionError = ref14[1];
    var inputRef = (0,react.useRef)(null);
    var taggingEl = (0,react.useRef)(null);
    var clearInput = function() {
        setDescription("");
        setTitle("");
        setNoteFormat("message");
        setFocused(false);
        setFiles([]);
        setPreviewSrcs([]);
        setAudioURLs([]);
        setIsLoading(false);
        setMessageId(null);
        setHasShownError(false);
        setSAPData({});
        setAssignee(null);
        if (setEditMode) {
            setEditMode(false);
        }
    };
    var handleChangeTitle = function(e) {
        var value = e.target.value;
        if (value) {
            setTitleError("");
        }
        if (userId) {
            setTitle(value);
        }
    };
    var handleClickOutside = function(event) {
        if (inputRef.current && !inputRef.current.contains(event.target) && taggingEl.current && !taggingEl.current.contains(event.target)) {
            setFocused(false);
        }
    };
    (0,react.useEffect)(function() {
        document.addEventListener("mousedown", handleClickOutside);
        return function() {
            return document.removeEventListener("mousedown", handleClickOutside);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0,react.useEffect)(function() {
        if (description) {
            setFocused(true);
        }
        if (descriptionLength > 300 && !hasShownError) {
            react_toastify_esm/* toast.error */.Am.error("Description must be no more than 300 characters");
            setHasShownError(true);
        }
        return function() {
            return setFocused(false);
        };
    }, [
        description,
        descriptionLength,
        hasShownError
    ]);
    (0,react.useEffect)(function() {
        setAddButtonDisabled(isSubmitDisabled());
    }, [
        title,
        descriptionLength,
        mediaUrls,
        previewSrcs,
        audioURLs
    ]);
    var isSubmitDisabled = function() {
        if ((isNewThread || isMainMessage) && title === "" || (!descriptionLength || descriptionLength > 300) && !(mediaUrls === null || mediaUrls === void 0 ? void 0 : mediaUrls.length) && !(previewSrcs === null || previewSrcs === void 0 ? void 0 : previewSrcs.length) && !(audioURLs === null || audioURLs === void 0 ? void 0 : audioURLs.length)) {
            if ((isNewThread || isMainMessage) && title === "") {
                setTitleError("This field cannot be empty");
            }
            if ((!descriptionLength || descriptionLength > 300) && !(mediaUrls === null || mediaUrls === void 0 ? void 0 : mediaUrls.length) && !(previewSrcs === null || previewSrcs === void 0 ? void 0 : previewSrcs.length) && !(audioURLs === null || audioURLs === void 0 ? void 0 : audioURLs.length)) {
                setDescriptionError("This field cannot be empty");
            }
            return true;
        }
        setDescriptionError("");
        return false;
    };
    var handleFileChange = function(event) {
        var uploadedFiles = Array.from(event.target.files);
        if (uploadedFiles.length) {
            var fileReaders = uploadedFiles.map(function(file) {
                return new Promise(function(resolve, reject) {
                    var type = file.type;
                    setLoadingFiles(function(prevLoading) {
                        return (0,_to_consumable_array/* default */.Z)(prevLoading).concat([
                            {
                                name: file.name,
                                lastModified: file.lastModified
                            }
                        ]);
                    });
                    if (type === "image/png" || type === "image/jpeg" || type === "image/webp") {
                        var reader = new FileReader();
                        reader.readAsDataURL(file);
                        reader.onload = function(e) {
                            resolve({
                                name: file.name,
                                lastModified: file.lastModified,
                                src: e.target.result,
                                type: "image"
                            });
                        };
                        reader.onerror = function(e) {
                            reject(e);
                        };
                    } else if (type.startsWith("video/")) {
                        resolve({
                            name: file.name,
                            lastModified: file.lastModified,
                            src: URL.createObjectURL(file),
                            type: "video"
                        });
                    } else if (type === "application/pdf") {
                        resolve({
                            name: file.name,
                            lastModified: file.lastModified,
                            src: URL.createObjectURL(file),
                            type: "pdf"
                        });
                    } else {
                        react_toastify_esm/* toast.error */.Am.error("Unsupported file format");
                        reject(new Error("Unsupported file format"));
                    }
                });
            });
            Promise.allSettled(fileReaders).then(function(results) {
                var successfulResults = results.filter(function(result) {
                    return result.status === "fulfilled";
                }).map(function(result) {
                    return result.value;
                });
                var successfulFiles = uploadedFiles.filter(function(_, index) {
                    return results[index].status === "fulfilled";
                });
                setLoadingFiles([]);
                if (successfulResults.length) {
                    setPreviewSrcs(function(prevSrcs) {
                        return (0,_to_consumable_array/* default */.Z)(prevSrcs).concat((0,_to_consumable_array/* default */.Z)(successfulResults));
                    });
                    setFiles(function(prevUploads) {
                        return (0,_to_consumable_array/* default */.Z)(prevUploads).concat((0,_to_consumable_array/* default */.Z)(successfulFiles));
                    });
                }
            });
            event.target.value = null;
        }
    };
    var removeReview = function(param) {
        var name = param.name, lastModified = param.lastModified;
        var filteredPreviews = previewSrcs.filter(function(preview) {
            return preview.name !== name && preview.lastModified !== lastModified;
        });
        var filteredFiles = files.filter(function(file) {
            return file.name !== name && file.lastModified !== lastModified;
        });
        setPreviewSrcs(filteredPreviews);
        setFiles(filteredFiles);
    };
    var removeAudio = function(param) {
        var lastModified = param.lastModified;
        var filteredAudios = audioURLs.filter(function(audioUrl) {
            return audioUrl.lastModified !== lastModified;
        });
        var filteredFiles = files.filter(function(file) {
            return file.lastModified !== lastModified;
        });
        setAudioURLs(filteredAudios);
        setFiles(filteredFiles);
    };
    (0,react.useEffect)(function() {
        var uploadedFilesSize = files.reduce(function(acc, file) {
            return acc + file.size;
        }, 0);
        if (files.length + (mediaUrls === null || mediaUrls === void 0 ? void 0 : mediaUrls.length) > 10) {
            setAddButtonDisabled(true);
            react_toastify_esm/* toast.error */.Am.error("Too many files, max count is 10");
        } else if (uploadedFilesSize > maxFilesSize) {
            setAddButtonDisabled(true);
            react_toastify_esm/* toast.error */.Am.error("Files are too large, max is 20mb");
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        files
    ]);
    (0,react.useEffect)(function() {
        var fetchSAPOptions = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var options, error;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            setIsLoading(true);
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                4,
                                5
                            ]);
                            return [
                                4,
                                onGetSAPOptions()
                            ];
                        case 2:
                            options = _state.sent();
                            setSAPOptions(options);
                            return [
                                3,
                                5
                            ];
                        case 3:
                            error = _state.sent();
                            console.error("Error fetching SAP options:", error);
                            return [
                                3,
                                5
                            ];
                        case 4:
                            setIsLoading(false);
                            return [
                                7
                            ];
                        case 5:
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetchSAPOptions() {
                return _ref.apply(this, arguments);
            };
        }();
        if (noteFormat === "SAP") {
            fetchSAPOptions();
        }
    }, [
        noteFormat
    ]);
    (0,react.useEffect)(function() {
        return function() {
            clearInput();
        };
    }, []);
    var handleChangeType = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(event) {
            var format;
            return (0,tslib_es6.__generator)(this, function(_state) {
                format = event.target.value;
                setNoteFormat(format);
                return [
                    2
                ];
            });
        });
        return function handleChangeType(event) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormControl/* default */.Z, {
            sx: {
                height: "100%",
                paddingTop: "18px"
            },
            children: [
                (isNewThread || editMode) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        isNewThread && isSAPActive && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    marginBottom: "10px",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            variant: "body1",
                                            sx: {
                                                marginRight: 2,
                                                color: "#344054",
                                                fontSize: "14px",
                                                background: "transparent"
                                            },
                                            children: "Type"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControl/* default */.Z, {
                                            sx: {
                                                minWidth: 200
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Select/* default */.Z, {
                                                labelId: "noteOptions-label",
                                                id: "noteOptions",
                                                value: noteFormat,
                                                label: "Select Type",
                                                onChange: handleChangeType,
                                                IconComponent: function(props) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(units_Icon/* default.ChevronDown */.Z.ChevronDown, (0,_object_spread/* default */.Z)({
                                                        sx: {
                                                            fontSize: "20px",
                                                            marginRight: "7px"
                                                        }
                                                    }, props));
                                                },
                                                sx: {
                                                    outline: "1px solid #D0D5DD",
                                                    backgroundColor: "#FFF",
                                                    borderRadius: "6px",
                                                    height: "44px",
                                                    "& .MuiOutlinedInput-notchedOutline": {
                                                        borderRadius: "8px",
                                                        border: "none"
                                                    },
                                                    "&:hover .MuiOutlinedInput-notchedOutline": {
                                                        borderColor: "blue"
                                                    },
                                                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                                        borderColor: "blue"
                                                    }
                                                },
                                                MenuProps: {
                                                    PaperProps: {
                                                        style: {
                                                            backgroundColor: "#FFF"
                                                        }
                                                    }
                                                },
                                                renderValue: function(selected) {
                                                    var selectedOption = noteOptions.find(function(option) {
                                                        return option.value === selected;
                                                    });
                                                    return selectedOption ? selectedOption.label : "";
                                                },
                                                children: noteOptions.map(function(option) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuItem/* default */.Z, {
                                                        value: option.value,
                                                        sx: {
                                                            "&.Mui-selected": {
                                                                backgroundColor: "transparent",
                                                                "&:hover": {
                                                                    backgroundColor: "rgba(130, 130, 130, 0.08)"
                                                                }
                                                            }
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                                sx: {
                                                                    mr: "auto"
                                                                },
                                                                children: option.label
                                                            }),
                                                            noteFormat === option.value && /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemIcon/* default */.Z, {
                                                                sx: {
                                                                    minWidth: "0 !important"
                                                                },
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                    className: "fa-light fa-check",
                                                                    style: {
                                                                        color: "blue",
                                                                        fontSize: "20px"
                                                                    }
                                                                })
                                                            })
                                                        ]
                                                    }, option.value);
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                                    sx: {
                                        mb: "10px"
                                    }
                                })
                            ]
                        }),
                        (isNewThread || isMainMessage) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "flex-start",
                            justifyContent: "space-between",
                            marginBottom: "10px",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    sx: {
                                        color: "#344054",
                                        marginBottom: "8px",
                                        background: "transparent",
                                        fontSize: "14px"
                                    },
                                    children: "Title"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                    variant: "outlined"
                                }, editMode ? {
                                    defaultValue: title
                                } : {
                                    value: title
                                }), {
                                    placeholder: "Write a title",
                                    onChange: handleChangeTitle,
                                    inputProps: {
                                        style: {
                                            color: "black",
                                            fontFamily: "inherit",
                                            height: "100%",
                                            fontSize: "16px",
                                            lineHeight: "24px",
                                            fontWeight: 400
                                        }
                                    },
                                    InputProps: {
                                        endAdornment: !!titleError ? /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment/* default */.Z, {
                                            position: "end",
                                            style: {
                                                position: "absolute",
                                                right: "14px",
                                                bottom: "50%"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                className: "fa-regular fa-circle-exclamation",
                                                style: {
                                                    color: "red",
                                                    fontSize: "16px"
                                                }
                                            })
                                        }) : null
                                    },
                                    sx: {
                                        width: "100%",
                                        borderRadius: "8px",
                                        border: !!titleError ? "none" : "1px solid #D0D5DD",
                                        margin: 0,
                                        background: !!titleError ? "transparent" : "#FFF",
                                        "& .MuiOutlinedInput-notchedOutline legend": {
                                            display: "none"
                                        },
                                        "& fieldset": {
                                            height: "100%",
                                            top: 0
                                        },
                                        "& .MuiOutlinedInput-notchedOutline": {
                                            borderColor: "#D0D5DD",
                                            borderRadius: "8px"
                                        },
                                        "& .MuiOutlinedInput-root": {
                                            borderRadius: "8px",
                                            flexDirection: "column",
                                            "&.Mui-error": {
                                                borderColor: "red",
                                                background: "#FFF"
                                            }
                                        },
                                        fontWeight: 400
                                    },
                                    InputLabelProps: {
                                        style: {
                                            fontWeight: 400,
                                            fontSize: "16px",
                                            lineHeight: "24px",
                                            color: "#667085",
                                            opacity: 1
                                        }
                                    },
                                    error: !!titleError,
                                    helperText: titleError
                                }))
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    justifyContent: "space-between",
                    marginBottom: "10px",
                    children: [
                        (isNewThread || editMode) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                            flexDirection: "row",
                            alignItems: "center",
                            gap: 1,
                            marginBottom: 1,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    sx: {
                                        color: "#344054",
                                        fontSize: "14px",
                                        background: "transparent"
                                    },
                                    children: "Description"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                                    title: "tooltip",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        className: "fa-light fa-circle-question",
                                        style: {
                                            fontSize: "14px"
                                        }
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DescriptionField, {
                            focused: focused,
                            setFocused: setFocused,
                            foundUser: foundUser,
                            isNewThread: isNewThread,
                            editMode: editMode,
                            setFiles: setFiles,
                            addButtonDisabled: addButtonDisabled,
                            setAddButtonDisabled: setAddButtonDisabled,
                            setIsLoading: setIsLoading,
                            handleAdd: handleAdd,
                            clearInput: clearInput,
                            description: description,
                            setDescription: setDescription,
                            setAudioURLs: setAudioURLs,
                            previewSrcs: previewSrcs,
                            loadingFiles: loadingFiles,
                            audioURLs: audioURLs,
                            mediaUrls: mediaUrls,
                            isLoading: isLoading,
                            removeReview: removeReview,
                            removeAudio: removeAudio,
                            setMediaUrls: setMediaUrls,
                            handleFileChange: handleFileChange,
                            collaborators: collaborators,
                            descriptionLength: descriptionLength,
                            setDescriptionLength: setDescriptionLength,
                            descriptionError: descriptionError
                        })
                    ]
                }),
                noteFormat === "SAP" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                            sx: {
                                marginBottom: "10px"
                            }
                        }),
                        isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(SAPNoteForm, {
                            collaborators: collaborators,
                            assignee: assignee,
                            setAssignee: setAssignee,
                            SAPData: SAPData,
                            setSAPData: setSAPData,
                            SAPFieldsData: SAPOptions
                        })
                    ]
                }),
                (isNewThread || editMode) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                    direction: "row",
                    alignSelf: "flex-end",
                    paddingY: "10px",
                    marginTop: isNewThread ? "auto" : 0,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                            variant: "outlined",
                            size: "small",
                            sx: {
                                border: "1px solid #D0D5DD",
                                borderRadius: "8px",
                                paddingX: "18px",
                                paddingY: "10px",
                                color: "#101828",
                                fontWeight: "500",
                                fontSize: "16px"
                            },
                            onClick: function(e) {
                                e.stopPropagation();
                                clearInput();
                                if (isNewThread) {
                                    onCloseDrawer();
                                }
                            },
                            children: "Cancel"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                            disabled: addButtonDisabled,
                            variant: "contained",
                            color: "primary",
                            size: "small",
                            style: {
                                marginLeft: 8
                            },
                            sx: {
                                background: "#2055FF",
                                color: "white",
                                font: "Inter",
                                fontWeight: "500",
                                fontSize: "16px",
                                paddingX: "18px",
                                paddingY: "10px",
                                borderRadius: "8px"
                            },
                            onClick: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                                var result;
                                return (0,tslib_es6.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            setAddButtonDisabled(true);
                                            setIsLoading(true);
                                            return [
                                                4,
                                                handleAdd({
                                                    title: title,
                                                    description: description,
                                                    assignee: assignee,
                                                    messageId: messageId,
                                                    isMainMessage: isMainMessage
                                                })
                                            ];
                                        case 1:
                                            result = _state.sent();
                                            if (result === "Success") {
                                                setFocused(false);
                                                clearInput();
                                            } else {
                                                react_toastify_esm/* toast.error */.Am.error("Could not send message");
                                                setIsLoading(false);
                                            }
                                            return [
                                                2
                                            ];
                                    }
                                });
                            }),
                            children: !editMode ? "Create" : "Edit"
                        })
                    ]
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./node_modules/react-slick/lib/index.js
var react_slick_lib = __webpack_require__(46066);
;// CONCATENATED MODULE: ./components/common/Gallery/types.ts
var ArrowDirection;
(function(ArrowDirection) {
    ArrowDirection["Left"] = "left";
    ArrowDirection["Right"] = "right";
})(ArrowDirection || (ArrowDirection = {}));

;// CONCATENATED MODULE: ./components/common/Gallery/styles.ts

function styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 12px;\n  width: 100%;\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: transparent;\n  max-width: 100%;\n  height: ",
        ";\n  padding: ",
        ";\n  &:focus-visible {\n    border: none;\n    outline: none;\n  }\n"
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: ",
        ";\n  width: ",
        ";\n"
    ]);
    styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: ",
        ";\n  background: transparent;\n  &:focus-visible {\n    border: none;\n    outline: none;\n  }\n"
    ]);
    styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: ",
        ";\n  height: ",
        ";\n  margin-right: ",
        ";\n  outline: ",
        ";\n  background: #ffffff1a;\n  border-radius: 8px;\n  object-fit: fit;\n  cursor: pointer;\n  opacity: ",
        ";\n"
    ]);
    styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: ",
        ";\n  height: ",
        ";\n  margin-right: ",
        ";\n  outline: ",
        ";\n  background: ",
        ";\n  border-radius: 8px;\n  cursor: pointer;\n  opacity: ",
        ";\n"
    ]);
    styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  margin: auto;\n  max-width: 100%;\n  height: 100%;\n  object-fit: ",
        ";\n  border-radius: ",
        ";\n  cursor: pointer;\n"
    ]);
    styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  margin: auto;\n  max-width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: 8px;\n  cursor: pointer;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  width: 48px;\n  height: 48px;\n  background-color: #ffffff1a;\n  border-radius: 8px;\n  z-index: 10;\n  backdrop-filter: blur(2px);\n  transition-duration: 0.5s;\n  &:hover {\n    background-color: #ffffff33;\n  }\n  &:focus {\n    background-color: #ffffff33;\n  }\n  &:before {\n    content: none;\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  width: 36px;\n  height: 36px;\n  background-color: black;\n  border-radius: 50%;\n  z-index: 10;\n  transition-duration: 0.5s;\n  &:before {\n    content: none;\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 3px;\n  background: transparent;\n  cursor: pointer;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  opacity: ",
        ";\n  width: 5px;\n  height: 5px;\n  border-radius: 999rem;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}

var styles_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__Container",
    componentId: "sc-b9859579-0"
})(styles_templateObject());
var SliderItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__SliderItem",
    componentId: "sc-b9859579-1"
})(styles_templateObject1(), function(param) {
    var height = param.height;
    return typeof height === "string" ? height : "".concat(height, "px");
}, function(param) {
    var padding = param.padding;
    return typeof padding === "string" ? padding : "".concat(padding, "px");
});
SliderItem.defaultProps = {
    height: 200,
    padding: 0
};
var SliderThumbnail = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__SliderThumbnail",
    componentId: "sc-b9859579-2"
})(styles_templateObject2(), function(param) {
    var margin = param.margin;
    return margin;
}, function(param) {
    var width = param.width;
    return width;
});
SliderThumbnail.defaultProps = {
    margin: "0",
    width: "auto"
};
var SliderThumbnailItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__SliderThumbnailItem",
    componentId: "sc-b9859579-3"
})(styles_templateObject3(), function(param) {
    var thumbnailBorderWidth = param.thumbnailBorderWidth;
    return "".concat(thumbnailBorderWidth, "px");
});
SliderThumbnailItem.defaultProps = {
    thumbnailBorderWidth: 1
};
var SliderThumbnailImage = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    displayName: "styles__SliderThumbnailImage",
    componentId: "sc-b9859579-4"
})(styles_templateObject4(), function(param) {
    var thumbnailSize = param.thumbnailSize;
    return "".concat(thumbnailSize, "px");
}, function(param) {
    var thumbnailSize = param.thumbnailSize;
    return "".concat(thumbnailSize, "px");
}, function(param) {
    var marginRight = param.marginRight;
    return "".concat(marginRight, "px") || 0;
}, function(param) {
    var active = param.active, thumbnailBorderWidth = param.thumbnailBorderWidth;
    return active ? "".concat(thumbnailBorderWidth, "px solid white") : "none";
}, function(param) {
    var active = param.active;
    return !active ? "0.5" : "1";
});
SliderThumbnailImage.defaultProps = {
    active: false,
    marginRight: 10,
    thumbnailBorderWidth: 1,
    thumbnailSize: 52
};
var SliderThumbnailIcon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__SliderThumbnailIcon",
    componentId: "sc-b9859579-5"
})(styles_templateObject5(), function(param) {
    var thumbnailSize = param.thumbnailSize;
    return "".concat(thumbnailSize, "px");
}, function(param) {
    var thumbnailSize = param.thumbnailSize;
    return "".concat(thumbnailSize, "px");
}, function(param) {
    var marginRight = param.marginRight;
    return "".concat(marginRight, "px") || 0;
}, function(param) {
    var active = param.active, isNotesGallery = param.isNotesGallery, thumbnailBorderWidth = param.thumbnailBorderWidth, thumbnailBorderColor = param.thumbnailBorderColor;
    return active || isNotesGallery ? "".concat(thumbnailBorderWidth, "px solid ").concat(thumbnailBorderColor) : "none";
}, function(param) {
    var isNotesGallery = param.isNotesGallery, inFullScreen = param.inFullScreen, background = param.background;
    return isNotesGallery && inFullScreen ? "#0000001A" : background || "#ffffff1a";
}, function(param) {
    var active = param.active;
    return !active ? "0.5" : "1";
});
SliderThumbnailIcon.defaultProps = {
    active: false,
    marginRight: 10,
    thumbnailBorderWidth: 1,
    background: "#ffffff1a",
    thumbnailSize: 52,
    thumbnailBorderColor: "white"
};
var SliderImage = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    displayName: "styles__SliderImage",
    componentId: "sc-b9859579-6"
})(styles_templateObject6(), function(param) {
    var inFullScreen = param.inFullScreen;
    return inFullScreen ? "contain" : "cover";
}, function(param) {
    var isNotesGallery = param.isNotesGallery;
    return isNotesGallery ? "0" : "8px";
});
SliderImage.defaultProps = {
    inFullScreen: false
};
var SliderVideo = styled_components_browser_esm/* default.video.withConfig */.ZP.video.withConfig({
    displayName: "styles__SliderVideo",
    componentId: "sc-b9859579-7"
})(_templateObject7());
var GalleryButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    displayName: "styles__GalleryButton",
    componentId: "sc-b9859579-8"
})(_templateObject8());
var AlternativeButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    displayName: "styles__AlternativeButton",
    componentId: "sc-b9859579-9"
})(_templateObject9());
var SliderDots = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__SliderDots",
    componentId: "sc-b9859579-10"
})(_templateObject10());
var SliderDotContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__SliderDotContainer",
    componentId: "sc-b9859579-11"
})(_templateObject11());
var SliderDot = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__SliderDot",
    componentId: "sc-b9859579-12"
})(_templateObject12(), function(param) {
    var dotsColor = param.dotsColor;
    return dotsColor;
}, function(param) {
    var active = param.active;
    return active ? 1 : 0.4;
});

;// CONCATENATED MODULE: ./hooks/useDrag.ts

var useDrag = function() {
    var ref = (0,react.useState)(false), isDragging = ref[0], setIsDragging = ref[1];
    var ref1 = (0,react.useState)(false), pointerPressed = ref1[0], setPointerPressed = ref1[1];
    var ref2 = (0,react.useState)(null), startPosition = ref2[0], setStartPosition = ref2[1];
    var dragTimerRef = (0,react.useRef)(null);
    var pointerPressedRef = (0,react.useRef)(false);
    var startPositionRef = (0,react.useRef)(null);
    var handleDragStart = function(e) {
        clearTimeout(dragTimerRef.current);
        setStartPosition({
            x: e.screenX,
            y: e.screenY
        });
        setPointerPressed(true);
    };
    var handleDragEnd = function() {
        setPointerPressed(false);
        setIsDragging(false);
        setStartPosition(null);
    };
    var handleDrag = function(e) {
        if (!startPositionRef.current || !pointerPressedRef.current) return;
        if (e.screenX !== startPositionRef.current.x || e.screenY !== startPositionRef.current.y) setIsDragging(true);
    };
    (0,react.useEffect)(function() {
        startPositionRef.current = startPosition;
    }, [
        startPosition
    ]);
    (0,react.useEffect)(function() {
        pointerPressedRef.current = pointerPressed;
    }, [
        pointerPressed
    ]);
    (0,react.useEffect)(function() {
        window.addEventListener("pointerdown", handleDragStart);
        window.addEventListener("pointerup", handleDragEnd);
        window.addEventListener("pointermove", handleDrag);
        return function() {
            window.removeEventListener("pointerdown", handleDragStart);
            window.removeEventListener("pointerup", handleDragEnd);
            window.removeEventListener("pointermove", handleDrag);
        };
    }, []);
    return isDragging;
};

;// CONCATENATED MODULE: ./components/common/Gallery/GalleryItem.tsx



var GalleryItem = function(param) {
    var item = param.item, index = param.index, _onPointerUp = param.onPointerUp, onPointerUp = _onPointerUp === void 0 ? function() {} : _onPointerUp, inFullScreen = param.inFullScreen, isNotesGallery = param.isNotesGallery;
    var imageRef = (0,react.useRef)(null);
    if (item.endsWith(".jpg") || item.endsWith(".png") || item.endsWith(".gif") || item.endsWith(".webp")) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            ref: imageRef,
            style: {
                width: "100%",
                height: "100%",
                position: "relative",
                background: isNotesGallery && !inFullScreen ? "#D0D5DD" : "transparent",
                borderRadius: isNotesGallery ? "8px" : 0
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SliderImage, {
                src: item,
                onPointerUp: onPointerUp,
                inFullScreen: inFullScreen,
                isNotesGallery: isNotesGallery
            })
        });
    }
    if (item.endsWith(".mp4") || item.endsWith(".webm") || item.endsWith(".ogg")) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            ref: imageRef,
            style: {
                width: "100%",
                height: "100%",
                position: "relative"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SliderVideo, {
                controls: true,
                style: {
                    width: "100%",
                    height: "100%",
                    objectFit: "cover"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                        src: item,
                        type: "video/".concat(item.split(".").pop())
                    }),
                    "Your browser does not support the video tag."
                ]
            })
        });
    }
    if (item.includes("youtube.com") || item.includes("vimeo.com") || item.endsWith(".pdf")) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
            src: item,
            frameBorder: "0",
            allow: "autoplay; encrypted-media",
            allowFullScreen: true,
            title: "iframe-".concat(index),
            style: {
                width: "100%",
                height: "100%"
            }
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        style: {
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "gray"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
            children: "Unsupported content type"
        })
    });
};

;// CONCATENATED MODULE: ./components/common/Gallery/GalleryThumbnail.tsx




var GalleryThumbnail = function(param) {
    var item = param.item, _active = param.active, active = _active === void 0 ? false : _active, _thumbnailsGap = param.thumbnailsGap, thumbnailsGap = _thumbnailsGap === void 0 ? 0 : _thumbnailsGap, _onPointerUp = param.onPointerUp, onPointerUp = _onPointerUp === void 0 ? function() {} : _onPointerUp, thumbnailIconBackground = param.thumbnailIconBackground, thumbnailSize = param.thumbnailSize, isNotesGallery = param.isNotesGallery, _inFullScreen = param.inFullScreen, inFullScreen = _inFullScreen === void 0 ? false : _inFullScreen, thumbnailBorderColor = param.thumbnailBorderColor;
    if (item.endsWith(".jpg") || item.endsWith(".png") || item.endsWith(".gif") || item.endsWith(".webp")) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(SliderThumbnailImage, {
            src: item,
            active: active,
            marginRight: thumbnailsGap,
            onPointerUp: onPointerUp,
            thumbnailSize: thumbnailSize
        });
    }
    if (item.endsWith(".mp4") || item.endsWith(".webm") || item.endsWith(".ogg")) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(SliderThumbnailIcon, {
            active: active,
            marginRight: thumbnailsGap,
            onPointerUp: onPointerUp,
            background: thumbnailIconBackground,
            thumbnailSize: thumbnailSize,
            thumbnailBorderColor: thumbnailBorderColor,
            isNotesGallery: isNotesGallery,
            inFullScreen: inFullScreen,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(units_Icon/* default.Video */.Z.Video, (0,_object_spread/* default */.Z)({}, isNotesGallery && !inFullScreen && {
                stroke: "#000000"
            }))
        });
    }
    if (item.includes("youtube.com") || item.includes("vimeo.com") || item.endsWith(".pdf")) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(SliderThumbnailIcon, {
            active: active,
            marginRight: thumbnailsGap,
            onPointerUp: onPointerUp,
            background: thumbnailIconBackground,
            thumbnailSize: thumbnailSize,
            thumbnailBorderColor: thumbnailBorderColor,
            isNotesGallery: isNotesGallery,
            inFullScreen: inFullScreen,
            children: item.endsWith(".pdf") ? /*#__PURE__*/ (0,jsx_runtime.jsx)(units_Icon/* default.Document */.Z.Document, (0,_object_spread/* default */.Z)({}, isNotesGallery && !inFullScreen && {
                stroke: "#000000"
            })) : /*#__PURE__*/ (0,jsx_runtime.jsx)(units_Icon/* default.Video */.Z.Video, (0,_object_spread/* default */.Z)({}, isNotesGallery && !inFullScreen && {
                stroke: "#000000"
            }))
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        style: {
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "gray"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
            children: "Unsupported content type"
        })
    });
};

;// CONCATENATED MODULE: ./components/common/Gallery/Arrow.tsx






var Arrow = function(param) {
    var className = param.className, style = param.style, onClick = param.onClick, direction = param.direction;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(GalleryButton, {
        className: className,
        style: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, style), {
            margin: "50px"
        }),
        onClick: onClick,
        children: [
            direction === ArrowDirection.Left && /*#__PURE__*/ (0,jsx_runtime.jsx)(units_Icon/* default.ChevronLeft */.Z.ChevronLeft, {
                style: {
                    color: "white"
                }
            }),
            direction === ArrowDirection.Right && /*#__PURE__*/ (0,jsx_runtime.jsx)(units_Icon/* default.ChevronRight */.Z.ChevronRight, {
                style: {
                    color: "white"
                }
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/common/Gallery/AlternativeArrow.tsx






var AlternativeArrow = function(param) {
    var className = param.className, style = param.style, onClick = param.onClick, direction = param.direction;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AlternativeButton, {
        className: className,
        style: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, style), {
            marginBottom: "100px"
        }),
        onClick: onClick,
        children: [
            direction === ArrowDirection.Left && /*#__PURE__*/ (0,jsx_runtime.jsx)(units_Icon/* default.ChevronLeft */.Z.ChevronLeft, {
                style: {
                    color: "white",
                    fontSize: "18px",
                    left: "15px"
                }
            }),
            direction === ArrowDirection.Right && /*#__PURE__*/ (0,jsx_runtime.jsx)(units_Icon/* default.ChevronRight */.Z.ChevronRight, {
                style: {
                    color: "white",
                    fontSize: "18px",
                    right: "15px"
                }
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/common/Gallery/Gallery.tsx












var defaultSettings = {
    thumbnails: true,
    fullScreen: true,
    dots: true,
    imageHeight: 200,
    thumbnailSize: 52,
    thumbnailBorderWidth: 1,
    thumbnailsGap: 10,
    thumbnailsMarginRight: 0,
    dotsColor: "white",
    thumbnailIconBackground: "#ffffff",
    thumbnailBorderColor: "transparent",
    activeArrows: false,
    arrowStyle: {},
    fullscreenByClick: false,
    alternativeArrows: false,
    isNotesGallery: false
};
var Gallery = function(param) {
    var items = param.items, onGalleryItemClick = param.onGalleryItemClick, _settings = param.settings, settings = _settings === void 0 ? defaultSettings : _settings;
    var gallerySettings = (0,_object_spread/* default */.Z)({}, defaultSettings, settings);
    var ref = (0,react.useState)(0), slideIndex = ref[0], setSlideIndex = ref[1];
    var ref1 = (0,react.useState)(false), isChanging = ref1[0], setIsChanging = ref1[1];
    var isDragging = useDrag();
    var ref2 = (0,react.useState)(0), galleryWidth = ref2[0], setGalleryWidth = ref2[1];
    var ref3 = (0,react.useState)(false), inFullScreen = ref3[0], setInFullScreen = ref3[1];
    var containerRef = (0,react.useRef)(null);
    var sliderRef = (0,react.useRef)(null);
    var sliderThumbnailRef = (0,react.useRef)(null);
    var thumbnailsLength = items.length * (gallerySettings.thumbnailSize + gallerySettings.thumbnailsGap + gallerySettings.thumbnailBorderWidth * 2) - 10;
    var thumbnailsRowWidth = galleryWidth && thumbnailsLength < galleryWidth ? "".concat(thumbnailsLength, "px") : "auto";
    var setSlide = function(index) {
        if (isChanging || index === slideIndex) return;
        setSlideIndex(index);
        sliderRef.current.slickGoTo(index);
        if (sliderThumbnailRef.current && thumbnailsRowWidth === "auto") sliderThumbnailRef.current.slickGoTo(index);
    };
    var toggleFullscreen = function(ref) {
        if (!document.fullscreenElement) {
            if (ref.current.requestFullscreen) {
                ref.current.requestFullscreen().then(function() {
                    setInFullScreen(true);
                }).catch(function(err) {
                    setInFullScreen(false);
                    alert("Error attempting to enable full-screen mode: ".concat(err.message, " (").concat(err.name, ")"));
                });
            }
        } else {
            if (document.exitFullscreen) {
                setInFullScreen(false);
                document.exitFullscreen();
            }
        }
    };
    (0,react.useLayoutEffect)(function() {
        var width = containerRef.current.getBoundingClientRect().width;
        setGalleryWidth(width);
    }, [
        inFullScreen
    ]);
    var handleFullScreenExit = function() {
        if (!document.fullscreenElement) {
            setInFullScreen(false);
        }
    };
    (0,react.useEffect)(function() {
        document.addEventListener("fullscreenchange", handleFullScreenExit);
        return function() {
            document.removeEventListener("fullscreenchange", handleFullScreenExit);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_Container, {
        ref: containerRef,
        children: galleryWidth && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                gallerySettings.fullScreen && !inFullScreen && /*#__PURE__*/ (0,jsx_runtime.jsx)(GalleryButton, {
                    style: {
                        position: "absolute",
                        top: "".concat(gallerySettings.imageHeight - 20 - 48, "px"),
                        right: "20px"
                    },
                    onClick: function() {
                        return toggleFullscreen(containerRef);
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(units_Icon/* default.FullScreen */.Z.FullScreen, {})
                }),
                inFullScreen && /*#__PURE__*/ (0,jsx_runtime.jsx)(GalleryButton, {
                    style: {
                        position: "fixed",
                        top: "20px",
                        right: "20px"
                    },
                    onClick: function() {
                        return toggleFullscreen(containerRef);
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(units_Icon/* default.Close */.Z.Close, {
                        style: {
                            color: "white",
                            width: "100%",
                            height: "100%"
                        },
                        fontSize: "large"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(react_slick_lib/* default */.Z, {
                    ref: sliderRef,
                    arrows: inFullScreen || gallerySettings.activeArrows,
                    nextArrow: gallerySettings.alternativeArrows ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AlternativeArrow, {
                        direction: ArrowDirection.Right,
                        style: gallerySettings.arrowStyle
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Arrow, {
                        direction: ArrowDirection.Right,
                        style: gallerySettings.arrowStyle
                    }),
                    prevArrow: gallerySettings.alternativeArrows ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AlternativeArrow, {
                        direction: ArrowDirection.Left,
                        style: gallerySettings.arrowStyle
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Arrow, {
                        direction: ArrowDirection.Left,
                        style: gallerySettings.arrowStyle
                    }),
                    dots: false,
                    beforeChange: function() {
                        setIsChanging(true);
                    },
                    afterChange: function(i) {
                        if (slideIndex !== i) setSlideIndex(i);
                        if (sliderThumbnailRef.current && thumbnailsRowWidth === "auto") {
                            sliderThumbnailRef.current.slickGoTo(i);
                        } else {
                            setIsChanging(false);
                        }
                    },
                    children: items.map(function(item, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(SliderItem, {
                            height: inFullScreen ? "75vh" : gallerySettings.imageHeight,
                            padding: inFullScreen && gallerySettings.isNotesGallery && items.length > 1 ? "10vh 10vw 0 10vw" : 0,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GalleryItem, {
                                item: item,
                                index: index,
                                onPointerUp: function() {
                                    if (gallerySettings.fullscreenByClick && !inFullScreen) toggleFullscreen(containerRef);
                                    if (!isDragging && onGalleryItemClick) onGalleryItemClick();
                                },
                                inFullScreen: inFullScreen,
                                isNotesGallery: gallerySettings.isNotesGallery
                            })
                        }, index);
                    })
                }),
                gallerySettings.thumbnails ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SliderThumbnail, {
                    margin: thumbnailsRowWidth === "auto" ? "0 ".concat(gallerySettings.thumbnailsMarginRight, "px 0 0") : "auto",
                    width: thumbnailsRowWidth,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_slick_lib/* default */.Z, {
                        ref: sliderThumbnailRef,
                        arrows: false,
                        dots: false,
                        draggable: true,
                        swipeToSlide: true,
                        variableWidth: true,
                        infinite: false,
                        beforeChange: function() {
                            setIsChanging(true);
                        },
                        afterChange: function() {
                            setIsChanging(false);
                        },
                        children: items.map(function(item, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SliderThumbnailItem, {
                                thumbnailBorderWidth: gallerySettings.thumbnailBorderWidth,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GalleryThumbnail, {
                                    item: item,
                                    active: index === slideIndex,
                                    thumbnailsGap: gallerySettings.thumbnailsGap,
                                    onPointerUp: function() {
                                        if (!isDragging) {
                                            setSlide(index);
                                        }
                                    },
                                    thumbnailIconBackground: gallerySettings.thumbnailIconBackground,
                                    thumbnailSize: gallerySettings.thumbnailSize,
                                    thumbnailBorderColor: gallerySettings.thumbnailBorderColor,
                                    isNotesGallery: gallerySettings.isNotesGallery,
                                    inFullScreen: inFullScreen
                                })
                            }, index);
                        })
                    })
                }) : null,
                gallerySettings.dots && /*#__PURE__*/ (0,jsx_runtime.jsx)(SliderDots, {
                    style: {
                        marginBottom: inFullScreen ? "20px" : 0
                    },
                    children: items.map(function(item, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(SliderDotContainer, {
                            onPointerUp: function() {
                                setSlide(index);
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SliderDot, {
                                active: index === slideIndex,
                                dotsColor: gallerySettings.dotsColor
                            })
                        }, index);
                    })
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Accordion/Accordion.js + 1 modules
var Accordion = __webpack_require__(76992);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/AccordionSummary/AccordionSummary.js + 1 modules
var AccordionSummary = __webpack_require__(29618);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/AccordionDetails/AccordionDetails.js + 1 modules
var AccordionDetails = __webpack_require__(47028);
;// CONCATENATED MODULE: ./components/tour/Threads/components/SAPDetails.tsx






var isJSON = function(string_) {
    try {
        JSON.parse(string_);
        return true;
    } catch (e) {
        return false;
    }
};
var StyledAccordion = (0,styled_components_browser_esm/* default */.ZP)(Accordion/* default */.Z).withConfig({
    displayName: "SAPDetails__StyledAccordion",
    componentId: "sc-dbc15ac0-0"
})(function(param) {
    var theme = param.theme;
    return {
        border: "1px solid #EAECF0",
        borderRadius: "8px",
        "&.Mui-expanded": {
            border: "1px solid #EAECF0",
            borderRadius: "8px"
        },
        "& .MuiPaper-root": {
            background: "#F9F9F9"
        },
        "& .MuiAccordionSummary-root": {
            background: "#F9F9F9",
            paddingRight: "14px",
            border: "none"
        },
        "& .MuiAccordionDetails-root": {
            background: "#F9F9F9",
            border: "none"
        }
    };
});
var DetailItem = function(param) {
    var label = param.label, value = param.value;
    var getPriorityColor = function(priority) {
        if (priority === "מיידי") return "red";
        if (priority === "גבוה- תוך 3 ימים") return "orange";
        if (priority === "בינוני - תוך 3 שבועות") return "yellow";
        if (priority === "נמוך - תוך 8 שבועות") return "blue";
    };
    if (label === "Priority") {
        var priorityLabel = value;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 1,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "body1",
                    sx: {
                        color: "#344054"
                    },
                    children: label
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    display: "flex",
                    alignItems: "center",
                    children: [
                        priorityLabel && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            style: {
                                display: "inline-block",
                                width: "10px",
                                height: "10px",
                                borderRadius: "50%",
                                backgroundColor: getPriorityColor(priorityLabel),
                                marginRight: "8px"
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "body1",
                            sx: {
                                fontWeight: "500",
                                color: "#101828"
                            },
                            children: priorityLabel || "N/A"
                        })
                    ]
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        mb: 1,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "body1",
                sx: {
                    color: "#344054"
                },
                children: label
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "body1",
                sx: {
                    fontWeight: "500",
                    color: "#101828"
                },
                children: value || "N/A"
            })
        ]
    });
};
var SAPDetails = function(param) {
    var SAPFields = param.SAPFields;
    var details = isJSON(SAPFields) ? JSON.parse(SAPFields) : SAPFields;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledAccordion, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionSummary/* default */.Z, {
                expandIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(units_Icon/* default.ChevronDown */.Z.ChevronDown, {
                    sx: {
                        fontSize: "20px",
                        marginRight: "7px",
                        color: "#667085"
                    }
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "h6",
                    children: "Details"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionDetails/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    sx: {
                        padding: "14px",
                        paddingLeft: 0
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailItem, {
                            label: "Equipment",
                            value: details === null || details === void 0 ? void 0 : details.equipment
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailItem, {
                            label: "Functional location",
                            value: details === null || details === void 0 ? void 0 : details.functionalLocation
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailItem, {
                            label: "Fault type",
                            value: details === null || details === void 0 ? void 0 : details.noteType
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailItem, {
                            label: "Equipment failure",
                            value: details === null || details === void 0 ? void 0 : details.equipmentFailure
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailItem, {
                            label: "Fault Source",
                            value: details === null || details === void 0 ? void 0 : details.faultSource
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailItem, {
                            label: "End date",
                            value: dayjs_min_default()(details === null || details === void 0 ? void 0 : details.endDate).format("MMMM D, hh:mm A")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailItem, {
                            label: "Created at",
                            value: dayjs_min_default()(details === null || details === void 0 ? void 0 : details.createdAt).format("MMMM D, hh:mm A")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailItem, {
                            label: "Priority",
                            value: details === null || details === void 0 ? void 0 : details.priority
                        })
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/tour/Threads/components/EditMenu.tsx


var EditMenu = function(param) {
    var selectedThread = param.selectedThread, message = param.message, setMediaUrls = param.setMediaUrls, anchorEl = param.anchorEl, setAnchorEl = param.setAnchorEl, setOpenedMenuId = param.setOpenedMenuId, isMenuOpen = param.isMenuOpen, setEditMode = param.setEditMode, setIsDeleteNoteModalOpen = param.setIsDeleteNoteModalOpen, handleEdit = param.handleEdit;
    var openMenu = function(e, messageId) {
        setAnchorEl(e.currentTarget);
        setOpenedMenuId(messageId);
    };
    var handleClose = function() {
        setAnchorEl(null);
        setOpenedMenuId(null);
        setMediaUrls([]);
        setEditMode(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                onClick: function(e) {
                    return openMenu(e, message.id);
                },
                id: "message-button-".concat(message.id),
                "aria-controls": isMenuOpen ? "message-menu-".concat(message.id) : undefined,
                "aria-haspopup": "true",
                "aria-expanded": isMenuOpen ? "true" : undefined,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                    className: "fa-solid fa-ellipsis-vertical",
                    style: message.isMainMessage ? {
                        fontSize: "20px",
                        color: "#101828"
                    } : undefined
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Menu_Menu/* default */.Z, {
                id: "message-menu-".concat(message.id),
                anchorEl: anchorEl,
                open: isMenuOpen,
                onClose: handleClose,
                sx: {
                    ".MuiPaper-root": {
                        background: "white"
                    }
                },
                MenuListProps: {
                    "aria-labelledby": "message-button-".concat(message.id)
                },
                anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "right"
                },
                transformOrigin: {
                    vertical: "top",
                    horizontal: "right"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                        id: message.id,
                        onClick: function() {
                            return setIsDeleteNoteModalOpen(true);
                        },
                        children: "Delete"
                    }),
                    (selectedThread === null || selectedThread === void 0 ? void 0 : selectedThread.format) !== "SAP" && /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                        onClick: handleEdit,
                        children: "Edit"
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/tour/Threads/components/Thread.tsx


























var formatDate = function(dateString) {
    var date = moment_default()(dateString);
    if (!date.isValid()) {
        console.log("thread formatDate is invalid for ", dateString);
        return "";
    }
    return date.format("MMMM D, h:mm A");
};
var Thread = function(param) {
    var rtl = param.rtl, selectedThread = param.selectedThread, setSelectedThread = param.setSelectedThread, updateMessages = param.updateMessages, newThread = param.newThread, setNewThread = param.setNewThread, tour = param.tour, showcase = param.showcase, addThreadToSpace = param.addThreadToSpace, showCaseTemp = param.showCaseTemp, userId = param.userId, collaborators = param.collaborators, isTourAdmin = param.isTourAdmin, setThreads = param.setThreads, threads = param.threads, onThreadItemSelect = param.onThreadItemSelect, setIsAdding = param.setIsAdding, controls = param.controls, isSAPActive = param.isSAPActive, editMode = param.editMode, setEditMode = param.setEditMode, setAddThreadClicked = param.setAddThreadClicked, onCompleteNote = param.onCompleteNote, onCloseDrawer = param.onCloseDrawer, removeThreadFromSpace = param.removeThreadFromSpace, mediaUrls = param.mediaUrls, setMediaUrls = param.setMediaUrls, anchorEl = param.anchorEl, setAnchorEl = param.setAnchorEl, openedMenuId = param.openedMenuId, setOpenedMenuId = param.setOpenedMenuId, isDeleteNoteModalOpen = param.isDeleteNoteModalOpen, setIsDeleteNoteModalOpen = param.setIsDeleteNoteModalOpen, handleEdit = param.handleEdit, isMenuOpen = param.isMenuOpen, getLocation = param.getLocation, isRtl = param.isRtl, isGuest = param.isGuest;
    var ref = (0,react.useState)(false), isLoading = ref[0], setIsLoading = ref[1];
    var ref1 = (0,react.useState)("message"), noteFormat = ref1[0], setNoteFormat = ref1[1];
    var ref2 = (0,react.useState)([]), messages = ref2[0], setMessages = ref2[1];
    var ref3 = (0,react.useState)({}), SAPData = ref3[0], setSAPData = ref3[1];
    var ref4 = (0,react.useState)([]), files = ref4[0], setFiles = ref4[1];
    var ref5 = (0,react.useState)(false), isDialogOpen = ref5[0], setIsDialogOpen = ref5[1];
    var ref6 = (0,react.useState)(false), isCompletionModalOpen = ref6[0], setIsCompletionModalOpen = ref6[1];
    var ref7 = (0,react.useState)({}), expandedMessages = ref7[0], setExpandedMessages = ref7[1];
    var ref8 = (0,react.useState)((selectedThread === null || selectedThread === void 0 ? void 0 : selectedThread.isCompleted) || false), isCompleted = ref8[0], setIsCompleted = ref8[1];
    var handleToggle = function(id) {
        setExpandedMessages(function(prev) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), (0,_define_property/* default */.Z)({}, id, !prev[id]));
        });
    };
    var handleSAPFieldOptions = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var result;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            TreedisPublicDAO/* default.getSAPOptions */.Z.getSAPOptions(tour.id)
                        ];
                    case 1:
                        result = _state.sent();
                        if ((result === null || result === void 0 ? void 0 : result.message) === "Success") return [
                            2,
                            result.SAPFieldsOptions
                        ];
                        return [
                            2,
                            []
                        ];
                }
            });
        });
        return function handleSAPFieldOptions() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleDelete = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var messageToDelete, result;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setIsLoading(true);
                        setIsDialogOpen(false);
                        messageToDelete = messages.find(function(m) {
                            return m.id === openedMenuId;
                        });
                        if (!messageToDelete) {
                            react_toastify_esm/* toast.error */.Am.error("Could not delete message");
                        }
                        return [
                            4,
                            TreedisPublicDAO/* default.deleteThreadMessage */.Z.deleteThreadMessage({
                                data: {
                                    messageId: messageToDelete.id
                                }
                            })
                        ];
                    case 1:
                        result = _state.sent();
                        if ((result === null || result === void 0 ? void 0 : result.message) === "Success") {
                            react_toastify_esm/* toast.error */.Am.error("Message deleted");
                            socket/* default.emit */.Z.emit("message_deleted", {
                                id: messageToDelete.id,
                                threadId: messageToDelete.threadId,
                                userId: messageToDelete.userId
                            });
                        }
                        setThreads(function(prevThreads) {
                            var foundThread = prevThreads.find(function(thread) {
                                return thread.id === messageToDelete.threadId;
                            });
                            if (foundThread) {
                                var updatedThreads = prevThreads.map(function(thread) {
                                    if (thread.id === foundThread.id) {
                                        var messages = thread.messages.filter(function(message) {
                                            return message.id !== messageToDelete.id;
                                        });
                                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, thread), {
                                            messages: messages
                                        });
                                    }
                                    return thread;
                                });
                                setSelectedThread(function(prevSelectedThread) {
                                    if ((prevSelectedThread === null || prevSelectedThread === void 0 ? void 0 : prevSelectedThread.id) === messageToDelete.threadId) {
                                        var updatedMessages = prevSelectedThread.messages.filter(function(message) {
                                            return message.id !== messageToDelete.id;
                                        });
                                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevSelectedThread), {
                                            messages: updatedMessages
                                        });
                                    }
                                    return prevSelectedThread;
                                });
                                return updatedThreads;
                            }
                            return prevThreads;
                        });
                        setAnchorEl(null);
                        setOpenedMenuId(null);
                        setMediaUrls([]);
                        setIsLoading(false);
                        return [
                            2,
                            result === null || result === void 0 ? void 0 : result.message
                        ];
                }
            });
        });
        return function handleDelete() {
            return _ref.apply(this, arguments);
        };
    }();
    var foundUser = collaborators === null || collaborators === void 0 ? void 0 : collaborators.find(function(c) {
        return c.id === userId;
    });
    var threadUser = collaborators === null || collaborators === void 0 ? void 0 : collaborators.find(function(c) {
        return c.id === (selectedThread === null || selectedThread === void 0 ? void 0 : selectedThread.userId);
    });
    (0,react.useEffect)(function() {
        if (selectedThread && selectedThread.messages) {
            var threadMessages = selectedThread.messages.sort(function(a, b) {
                var dateA = new Date(a.createdAt);
                var dateB = new Date(b.createdAt);
                return dateA.getTime() - dateB.getTime();
            });
            setMessages(threadMessages);
            setIsCompleted(selectedThread === null || selectedThread === void 0 ? void 0 : selectedThread.isCompleted);
        } else {
            setMessages([]);
            setIsCompleted(false);
        }
    }, [
        selectedThread,
        selectedThread === null || selectedThread === void 0 ? void 0 : selectedThread.messages,
        selectedThread === null || selectedThread === void 0 ? void 0 : selectedThread.isCompleted
    ]);
    var handleAdd = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
            var title, description, assignee, messageId, isMainMessage, resultMessage, createdAt, timezone, mentionedUsers, tourLink, _mentionedUsers, mentionedUsernames, dataToAdd, result, savedThread, reportStatus, ref, filteredUrls, dataToAdd1, result1, savedMessage, savedTitle, updatedThread;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        title = param.title, description = param.description, assignee = param.assignee, messageId = param.messageId, isMainMessage = param.isMainMessage;
                        resultMessage = "";
                        createdAt = moment_default()().format("YYYYMMDD HHmm");
                        timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
                        description = description || "";
                        mentionedUsers = [];
                        tourLink = getTourLink();
                        if (description) {
                            ;
                            mentionedUsernames = (0,_to_consumable_array/* default */.Z)(description.matchAll(/<span[^>]*>.*?@([a-zA-Z0-9_ ]+)<\/span>/g)).map(function(match) {
                                return match[1];
                            });
                            (_mentionedUsers = mentionedUsers).push.apply(_mentionedUsers, (0,_to_consumable_array/* default */.Z)(collaborators.filter(function(collaborator) {
                                return mentionedUsernames.includes(collaborator.name);
                            })));
                        }
                        if (!newThread) return [
                            3,
                            5
                        ];
                        delete newThread.id;
                        dataToAdd = formData.create((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, newThread), {
                            files: files,
                            tourId: tour.id,
                            description: description,
                            userId: userId,
                            title: title,
                            format: noteFormat,
                            isMainMessage: true,
                            reporter: (foundUser === null || foundUser === void 0 ? void 0 : foundUser.name) || "Guest",
                            SAPFields: noteFormat === "SAP" ? JSON.stringify((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, SAPData), {
                                assignee: assignee,
                                reporter: (foundUser === null || foundUser === void 0 ? void 0 : foundUser.email) ? foundUser.email.split("@")[0] : "",
                                createdAt: createdAt,
                                description: description,
                                title: title
                            })) : {},
                            mentionedUsers: JSON.stringify(mentionedUsers),
                            tourLink: tourLink,
                            isRtl: isRtl,
                            timezone: timezone
                        }));
                        return [
                            4,
                            TreedisPublicDAO/* default.saveThread */.Z.saveThread({
                                data: dataToAdd
                            })
                        ];
                    case 1:
                        result = _state.sent();
                        resultMessage = result === null || result === void 0 ? void 0 : result.message;
                        if (!(resultMessage === "Success")) return [
                            3,
                            5
                        ];
                        savedThread = result.savedThread, reportStatus = result.reportStatus;
                        if (reportStatus === "error") {
                            react_toastify_esm/* toast.error */.Am.error("Failed to send SAP report to BAZAN");
                        }
                        if (reportStatus === "success") {
                            react_toastify_esm/* toast.success */.Am.success("SAP report sent to BAZAN successfully");
                        }
                        return [
                            4,
                            showCaseTemp.tag.remove(savedThread.sid)
                        ];
                    case 2:
                        _state.sent();
                        return [
                            4,
                            showcase.Mattertag.registerIcon("thread__".concat(savedThread.sid), savedThread.iconUrl).catch(function(e) {
                                console.error(e);
                            })
                        ];
                    case 3:
                        _state.sent();
                        savedThread.customIcon = "thread";
                        return [
                            4,
                            addThreadToSpace(savedThread)
                        ];
                    case 4:
                        _state.sent();
                        // setThreads((prevThreads) => [...prevThreads, savedThread]);
                        setNewThread(null);
                        onThreadItemSelect(savedThread);
                        setIsAdding(false);
                        setAddThreadClicked(false);
                        controls.current.inputs.selection = null;
                        socket/* default.emit */.Z.emit("thread_added", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, savedThread), {
                            room: tour.slug
                        }));
                        _state.label = 5;
                    case 5:
                        if (!selectedThread) return [
                            3,
                            7
                        ];
                        filteredUrls = (ref = mediaUrls.filter(function(urlObj) {
                            return urlObj.flaggedToDelete;
                        })) === null || ref === void 0 ? void 0 : ref.map(function(urlObj) {
                            return urlObj.src;
                        });
                        dataToAdd1 = formData.create({
                            title: title,
                            files: files,
                            threadId: selectedThread.id,
                            description: description,
                            userId: userId,
                            messageId: messageId,
                            mediaUrls: filteredUrls,
                            isMainMessage: isMainMessage,
                            mentionedUsers: JSON.stringify(mentionedUsers),
                            tourLink: tourLink,
                            isRtl: isRtl,
                            timezone: timezone
                        });
                        return [
                            4,
                            TreedisPublicDAO/* default.saveThreadMessage */.Z.saveThreadMessage({
                                data: dataToAdd1
                            })
                        ];
                    case 6:
                        result1 = _state.sent();
                        resultMessage = result1 === null || result1 === void 0 ? void 0 : result1.message;
                        if (resultMessage === "Success") {
                            savedMessage = result1.savedMessage, savedTitle = result1.savedTitle;
                            ;
                            setThreads(function(prevThreads) {
                                var foundThread = prevThreads.find(function(thread) {
                                    return thread.id === savedMessage.threadId;
                                });
                                if (foundThread) {
                                    return prevThreads.map(function(thread) {
                                        if (thread.id === foundThread.id) {
                                            var messages = updateMessages(thread, savedMessage);
                                            updatedThread = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, thread), {
                                                title: savedTitle,
                                                messages: messages
                                            });
                                            return updatedThread;
                                        }
                                        return thread;
                                    });
                                }
                                return prevThreads;
                            });
                            setSelectedThread(function(prevThread) {
                                if (updatedThread && ((updatedThread === null || updatedThread === void 0 ? void 0 : updatedThread.id) === (prevThread === null || prevThread === void 0 ? void 0 : prevThread.id) || !prevThread)) {
                                    return updatedThread;
                                }
                                return prevThread;
                            });
                            if (messageId) {
                                socket/* default.emit */.Z.emit("message_edited", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, result1.savedMessage), {
                                    savedTitle: result1.savedTitle,
                                    room: tour.slug
                                }));
                            } else {
                                socket/* default.emit */.Z.emit("message_added", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, result1.savedMessage), {
                                    room: tour.slug
                                }));
                            }
                        }
                        _state.label = 7;
                    case 7:
                        setEditMode(false);
                        setOpenedMenuId(null);
                        setMediaUrls([]);
                        setAnchorEl(null);
                        return [
                            2,
                            resultMessage
                        ];
                }
            });
        });
        return function handleAdd(_) {
            return _ref.apply(this, arguments);
        };
    }();
    var renderMessages = (0,react.useCallback)(function() {
        var renderHighlightedTextWithHTML = function(text) {
            var regex = /@([\w.]+(?:\s+[\w.]+)?)/g;
            var highlightedText = text.replace(regex, function(match, tag) {
                var isCollaborator = collaborators.some(function(collab) {
                    return collab.name === tag.trim();
                });
                if (isCollaborator) {
                    return '<span style="color: blue;">'.concat(match, "</span>");
                } else {
                    return match;
                }
            });
            return {
                __html: highlightedText
            };
        };
        return messages.map(function(m) {
            var ref, ref1;
            var isModified = new Date(m === null || m === void 0 ? void 0 : m.createdAt).getTime() !== new Date(m === null || m === void 0 ? void 0 : m.updatedAt).getTime();
            var messageAuthor = collaborators === null || collaborators === void 0 ? void 0 : collaborators.find(function(c) {
                return c.id === m.userId;
            });
            var stripHtmlTags = function(str) {
                return str.replace(/<[^>]*>/g, "");
            };
            var descriptionText = stripHtmlTags((m === null || m === void 0 ? void 0 : m.description) || "");
            var isLongText = (descriptionText === null || descriptionText === void 0 ? void 0 : descriptionText.length) > 100;
            var isDescExpanded = expandedMessages[m.id] || false;
            var repliesCount = (selectedThread === null || selectedThread === void 0 ? void 0 : (ref = selectedThread.messages) === null || ref === void 0 ? void 0 : ref.length) ? (selectedThread === null || selectedThread === void 0 ? void 0 : (ref1 = selectedThread.messages) === null || ref1 === void 0 ? void 0 : ref1.length) - 1 : 0;
            var audioMessages = [];
            var imageMessages = [];
            if (m.mediaUrls) {
                var ref2;
                (ref2 = m.mediaUrls) === null || ref2 === void 0 ? void 0 : ref2.forEach(function(url) {
                    if (url.includes(".wav")) {
                        audioMessages.push(url);
                    } else if (url.includes(".jpg") || url.includes(".png") || url.includes(".webp")) {
                        imageMessages.push("".concat("https://cdn.treedis.com", "/").concat(url));
                    } else if (url.includes(".mp4") || url.includes(".webm") || url.includes(".ogg")) {
                        imageMessages.push("".concat("https://cdn.treedis.com", "/").concat(url));
                    } else if (url.includes(".pdf")) {
                        imageMessages.push("".concat("https://cdn.treedis.com", "/").concat(url));
                    }
                });
            }
            return m.isMainMessage ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                direction: "row",
                flexWrap: "wrap",
                width: "100%",
                mt: "18px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                        gap: "10px",
                        px: "18px",
                        pb: "14px",
                        width: "100%",
                        sx: {
                            background: "white",
                            pt: "10px"
                        },
                        children: [
                            (selectedThread === null || selectedThread === void 0 ? void 0 : selectedThread.title) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                direction: "row",
                                justifyContent: "space-between",
                                alignItems: "center",
                                width: "100%",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: "h6",
                                        width: "100%",
                                        sx: {
                                            textAlign: "left",
                                            fontSize: "18px",
                                            lineHeight: "28px",
                                            color: "#000000"
                                        },
                                        children: selectedThread === null || selectedThread === void 0 ? void 0 : selectedThread.title
                                    }),
                                    m.userId === userId && /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                        onClick: function() {
                                            return setIsCompletionModalOpen(true);
                                        },
                                        id: "message-button-".concat(m.id),
                                        "aria-controls": isMenuOpen ? "message-menu-".concat(m.id) : undefined,
                                        "aria-haspopup": "true",
                                        "aria-expanded": isMenuOpen ? "true" : undefined,
                                        children: !isCompleted ? /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                            className: "fa-light fa-check",
                                            style: {
                                                color: "#12B76A",
                                                fontSize: "24px"
                                            }
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                            className: "fa-light fa-arrow-rotate-left",
                                            style: {
                                                color: "#12B76A",
                                                fontSize: "24px"
                                            }
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                width: "100%",
                                direction: "row",
                                alignItems: "center",
                                height: "24px",
                                mb: "10px",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                        direction: "row",
                                        gap: 2,
                                        alignItems: "center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                                sx: {
                                                    height: "22px",
                                                    width: "22px",
                                                    img: {
                                                        objectFit: "contain"
                                                    },
                                                    bgcolor: userId === (messageAuthor === null || messageAuthor === void 0 ? void 0 : messageAuthor.id) ? "#2055ff" : "white",
                                                    color: userId === (messageAuthor === null || messageAuthor === void 0 ? void 0 : messageAuthor.id) ? "white" : "black",
                                                    border: "1px solid #D1D1D1",
                                                    fontSize: "12px"
                                                },
                                                children: getInitials((messageAuthor === null || messageAuthor === void 0 ? void 0 : messageAuthor.name) || "Guest")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                sx: {
                                                    fontSize: "14px",
                                                    color: "#101828"
                                                },
                                                children: (messageAuthor === null || messageAuthor === void 0 ? void 0 : messageAuthor.name) || "Guest"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                                        orientation: "vertical",
                                        sx: {
                                            marginX: "5px",
                                            height: "15px"
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: "caption",
                                        sx: {
                                            fontSize: "14px",
                                            color: "#101828"
                                        },
                                        children: formatDate(m.createdAt)
                                    }),
                                    isModified && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                                                orientation: "vertical",
                                                sx: {
                                                    marginX: "5px",
                                                    height: "15px"
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                sx: {
                                                    fontSize: "14px",
                                                    color: "#101828"
                                                },
                                                children: "Edited"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            (m === null || m === void 0 ? void 0 : m.description) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                sx: {
                                    display: "inline"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        width: "100%",
                                        sx: {
                                            maxWidth: "400px",
                                            display: "inline",
                                            textAlign: rtl ? "right" : "left",
                                            color: "#000000",
                                            fontSize: "14px",
                                            lineHeight: "20px",
                                            wordBreak: "break-all",
                                            whiteSpace: "normal"
                                        },
                                        dangerouslySetInnerHTML: isDescExpanded || !isLongText ? renderHighlightedTextWithHTML((m === null || m === void 0 ? void 0 : m.description) === "null" ? "<span></span>" : m === null || m === void 0 ? void 0 : m.description) : renderHighlightedTextWithHTML((m === null || m === void 0 ? void 0 : m.description.slice(0, 100)) + "...")
                                    }),
                                    isLongText && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                        onClick: function() {
                                            return handleToggle(m.id);
                                        },
                                        sx: {
                                            display: "inline",
                                            textTransform: "none",
                                            padding: 0,
                                            minHeight: 0,
                                            minWidth: 0,
                                            fontWeight: 400,
                                            fontSize: "14px",
                                            lineHeight: "20px",
                                            color: "black",
                                            "&:hover": {
                                                color: "black",
                                                textDecoration: "underline",
                                                backgroundColor: "transparent"
                                            }
                                        },
                                        children: isDescExpanded ? "...Read less" : "Read more"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                                sx: {
                                    width: "100%"
                                }
                            }),
                            !!(audioMessages === null || audioMessages === void 0 ? void 0 : audioMessages.length) && audioMessages.map(function(url, i) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WaveSurferPlayer, {
                                        url: "".concat("https://cdn.treedis.com", "/").concat(url),
                                        waveColor: "#D0D5DD",
                                        progressColor: "#2055FF",
                                        barWidth: 2,
                                        barGap: 2,
                                        barRadius: 4,
                                        barHeight: 10,
                                        wavefHeight: 33,
                                        playPauseButtonSx: {
                                            color: "#2055FF",
                                            padding: 0,
                                            height: "30px"
                                        },
                                        containerSx: {
                                            padding: "10px",
                                            height: "70px",
                                            maxHeight: "70px",
                                            width: "100%",
                                            gap: "6px",
                                            background: "#F9FAFB",
                                            border: "1px solid #EAECF0",
                                            borderRadius: "8px"
                                        }
                                    })
                                }, (0,lodash.uniqueId)());
                            }),
                            !!(imageMessages === null || imageMessages === void 0 ? void 0 : imageMessages.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                width: "320px",
                                margin: "0 auto",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Gallery, {
                                    items: imageMessages,
                                    settings: {
                                        fullScreen: false,
                                        imageHeight: 252,
                                        dotsColor: "#D0D5DD",
                                        thumbnailIconBackground: "#F4F5F2",
                                        thumbnailBorderColor: "#D1D1D1",
                                        thumbnailSize: 70,
                                        fullscreenByClick: true,
                                        alternativeArrows: false,
                                        thumbnails: imageMessages.length > 1 ? true : false,
                                        dots: imageMessages.length > 1 ? true : false,
                                        isNotesGallery: true
                                    }
                                })
                            })
                        ]
                    }),
                    editMode && m.id === openedMenuId && userId && !isGuest && /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                        width: "100%",
                        px: "18px",
                        sx: {
                            background: "#F1F1F1"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NoteForm, {
                            rtl: rtl,
                            userId: userId,
                            handleAdd: handleAdd,
                            files: files,
                            setFiles: setFiles,
                            noteFormat: noteFormat,
                            setNoteFormat: setNoteFormat,
                            isNewThread: false,
                            editMode: editMode,
                            setEditMode: setEditMode,
                            mediaUrls: mediaUrls.filter(function(objUrl) {
                                return !objUrl.flaggedToDelete;
                            }),
                            setMediaUrls: setMediaUrls,
                            collaborators: collaborators,
                            foundUser: foundUser,
                            isMainMessage: m.isMainMessage,
                            noteTitle: selectedThread.title,
                            currentMessage: m,
                            onCloseDrawer: onCloseDrawer
                        })
                    }),
                    (selectedThread === null || selectedThread === void 0 ? void 0 : selectedThread.format) === "SAP" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                        sx: {
                            paddingX: "18px",
                            paddingBottom: "18px",
                            width: "100%",
                            background: "white"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SAPDetails, {
                            SAPFields: selectedThread.SAPFields
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        sx: {
                            background: "transparent",
                            padding: "18px",
                            paddingBottom: "0",
                            width: "100%"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            sx: {
                                fontSize: "16px",
                                fontWeight: "bold"
                            },
                            children: "".concat(repliesCount, " ").concat(repliesCount === 1 ? "Reply" : "Replies")
                        })
                    })
                ]
            }, m.id) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                direction: "row",
                flexWrap: "wrap",
                width: "100%",
                px: "18px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                        sx: {
                            display: "flex",
                            flexDirection: "column",
                            gap: "8px",
                            background: "white",
                            border: "1px solid #EAECF0",
                            borderRadius: "8px",
                            width: "100%",
                            padding: "14px"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                width: "100%",
                                direction: "row",
                                alignItems: "center",
                                gap: 1,
                                py: 1,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                        sx: {
                                            height: "40px",
                                            width: "40px",
                                            img: {
                                                objectFit: "contain"
                                            },
                                            bgcolor: userId === (messageAuthor === null || messageAuthor === void 0 ? void 0 : messageAuthor.id) ? "#2055ff" : "white",
                                            color: userId === (messageAuthor === null || messageAuthor === void 0 ? void 0 : messageAuthor.id) ? "white" : "black",
                                            border: "1px solid #D1D1D1"
                                        },
                                        children: getInitials((messageAuthor === null || messageAuthor === void 0 ? void 0 : messageAuthor.name) || "Guest")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                        direction: "column",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                sx: {
                                                    fontSize: "14px",
                                                    color: "#101828",
                                                    fontWeight: "550"
                                                },
                                                children: (messageAuthor === null || messageAuthor === void 0 ? void 0 : messageAuthor.name) || "Guest"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                                direction: "row",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                        variant: "caption",
                                                        sx: {
                                                            fontSize: "14px",
                                                            color: "#667085"
                                                        },
                                                        children: formatDate(m.updatedAt)
                                                    }),
                                                    isModified && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                                                                orientation: "vertical",
                                                                sx: {
                                                                    marginX: "5px",
                                                                    height: "15px"
                                                                }
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                                sx: {
                                                                    fontSize: "14px",
                                                                    color: "#667085"
                                                                },
                                                                children: "Edited"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                                        direction: "row",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        gap: 1,
                                        ml: "auto",
                                        children: (m === null || m === void 0 ? void 0 : m.userId) === userId && /*#__PURE__*/ (0,jsx_runtime.jsx)(EditMenu, {
                                            selectedThread: selectedThread,
                                            message: m,
                                            setMediaUrls: setMediaUrls,
                                            anchorEl: anchorEl,
                                            setAnchorEl: setAnchorEl,
                                            setOpenedMenuId: setOpenedMenuId,
                                            isMenuOpen: isMenuOpen,
                                            setEditMode: setEditMode,
                                            setIsDeleteNoteModalOpen: setIsDialogOpen,
                                            handleEdit: handleEdit
                                        })
                                    })
                                ]
                            }),
                            (m === null || m === void 0 ? void 0 : m.description) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                sx: {
                                    display: "inline"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: "body1",
                                        width: "100%",
                                        sx: {
                                            maxWidth: "400px",
                                            display: "inline",
                                            textAlign: rtl ? "right" : "left",
                                            color: "#101828",
                                            fontSize: "14px",
                                            lineHeight: "20px",
                                            wordBreak: "break-all",
                                            whiteSpace: "normal"
                                        },
                                        dangerouslySetInnerHTML: isDescExpanded || !isLongText ? renderHighlightedTextWithHTML((m === null || m === void 0 ? void 0 : m.description) === "null" ? "<span></span>" : m === null || m === void 0 ? void 0 : m.description) : renderHighlightedTextWithHTML((m === null || m === void 0 ? void 0 : m.description.slice(0, 100)) + "...")
                                    }),
                                    isLongText && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                        onClick: function() {
                                            return handleToggle(m.id);
                                        },
                                        sx: {
                                            display: "inline",
                                            textTransform: "none",
                                            padding: 0,
                                            minHeight: 0,
                                            minWidth: 0,
                                            fontWeight: 400,
                                            fontSize: "14px",
                                            lineHeight: "20px",
                                            color: "black",
                                            "&:hover": {
                                                color: "black",
                                                textDecoration: "underline",
                                                backgroundColor: "transparent"
                                            }
                                        },
                                        children: isDescExpanded ? "...Read less" : "Read more"
                                    })
                                ]
                            }),
                            !!(audioMessages === null || audioMessages === void 0 ? void 0 : audioMessages.length) && audioMessages.map(function(url, i) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WaveSurferPlayer, {
                                        url: "".concat("https://cdn.treedis.com", "/").concat(url),
                                        waveColor: "#D0D5DD",
                                        progressColor: "#2055FF",
                                        barWidth: 2,
                                        barGap: 2,
                                        barRadius: 4,
                                        barHeight: 10,
                                        wavefHeight: 33,
                                        playPauseButtonSx: {
                                            color: "#2055FF",
                                            padding: 0,
                                            height: "30px"
                                        },
                                        containerSx: {
                                            padding: "10px",
                                            height: "70px",
                                            maxHeight: "70px",
                                            width: "100%",
                                            gap: "6px",
                                            background: "#F9FAFB",
                                            border: "1px solid #EAECF0",
                                            borderRadius: "8px"
                                        }
                                    })
                                }, (0,lodash.uniqueId)());
                            }),
                            !!(imageMessages === null || imageMessages === void 0 ? void 0 : imageMessages.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                width: "320px",
                                margin: "0 auto",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Gallery, {
                                    items: imageMessages,
                                    settings: {
                                        fullScreen: false,
                                        imageHeight: 252,
                                        dotsColor: "#D0D5DD",
                                        thumbnailIconBackground: "#F4F5F2",
                                        thumbnailBorderColor: "#D1D1D1",
                                        thumbnailSize: 70,
                                        fullscreenByClick: true,
                                        alternativeArrows: false,
                                        thumbnails: imageMessages.length > 1 ? true : false,
                                        dots: imageMessages.length > 1 ? true : false,
                                        isNotesGallery: true
                                    }
                                })
                            })
                        ]
                    }),
                    editMode && m.id === openedMenuId && userId && !isGuest && /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                        width: "100%",
                        sx: {
                            background: "#F1F1F1CC"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NoteForm, {
                            rtl: rtl,
                            userId: userId,
                            handleAdd: handleAdd,
                            files: files,
                            setFiles: setFiles,
                            noteFormat: noteFormat,
                            setNoteFormat: setNoteFormat,
                            isNewThread: false,
                            editMode: editMode,
                            setEditMode: setEditMode,
                            mediaUrls: mediaUrls.filter(function(objUrl) {
                                return !objUrl.flaggedToDelete;
                            }),
                            setMediaUrls: setMediaUrls,
                            collaborators: collaborators,
                            foundUser: foundUser,
                            currentMessage: m,
                            onCloseDrawer: onCloseDrawer
                        })
                    })
                ]
            }, m.id);
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        messages,
        newThread,
        threadUser === null || threadUser === void 0 ? void 0 : threadUser.name,
        isMenuOpen,
        mediaUrls,
        files,
        isTourAdmin,
        foundUser === null || foundUser === void 0 ? void 0 : foundUser.id,
        expandedMessages,
        selectedThread === null || selectedThread === void 0 ? void 0 : selectedThread.title,
        selectedThread === null || selectedThread === void 0 ? void 0 : selectedThread.messages,
        isCompleted, 
    ]);
    var completeNote = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(noteId) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            onCompleteNote(noteId)
                        ];
                    case 1:
                        _state.sent();
                        setIsCompleted(!(selectedThread === null || selectedThread === void 0 ? void 0 : selectedThread.isCompleted));
                        return [
                            2
                        ];
                }
            });
        });
        return function completeNote(noteId) {
            return _ref.apply(this, arguments);
        };
    }();
    var getTourLink = function() {
        var linkValue = (0,util/* getBaseURL */.BS)();
        linkValue = getLocation();
        var segmants = window.location.href.split("/");
        var slug = segmants[segmants.length - 1].split("?")[0];
        if (tour.slug !== slug) {
            var params = linkValue.split("?")[1];
            linkValue = "".concat(linkValue.split("/").map(function(part, index) {
                return index === 4 ? tour.slug : part;
            }).join("/")).concat(params ? "?".concat(params) : "");
        }
        return linkValue;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
        direction: "column",
        justifyContent: !!newThread || !userId || isGuest ? "flex-start" : "center",
        flexWrap: "wrap",
        alignItems: "space-between",
        flexGrow: editMode ? 0 : 1,
        children: [
            !!newThread && /*#__PURE__*/ (0,jsx_runtime.jsx)(NoteReporterBar, {
                name: foundUser === null || foundUser === void 0 ? void 0 : foundUser.name,
                editMode: editMode,
                isNewThread: !!newThread
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                direction: "column",
                gap: 2,
                children: renderMessages()
            }),
            isLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                width: "100%",
                alignItems: "center",
                justifyContent: "center",
                height: "100%",
                position: "absolute",
                sx: {
                    backgroundColor: "rgba(255, 255, 255, 0.7)",
                    zIndex: 100
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {})
            }),
            !editMode && userId && !isGuest && /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                px: "18px",
                sx: (0,_object_spread/* default */.Z)({
                    background: "#F1F1F1",
                    marginTop: !!newThread ? 0 : "auto",
                    flexGrow: !!newThread ? 1 : 0
                }, newThread ? {} : {
                    position: "sticky",
                    bottom: 0,
                    maxHeight: "700px",
                    zIndex: "1600"
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NoteForm, {
                    rtl: rtl,
                    handleAdd: handleAdd,
                    files: files,
                    setFiles: setFiles,
                    noteFormat: noteFormat,
                    setNoteFormat: setNoteFormat,
                    isNewThread: !!newThread,
                    userId: userId,
                    collaborators: collaborators,
                    foundUser: foundUser,
                    SAPData: SAPData,
                    setSAPData: setSAPData,
                    onGetSAPOptions: handleSAPFieldOptions,
                    isSAPActive: isSAPActive,
                    onCloseDrawer: onCloseDrawer
                })
            }),
            isCompletionModalOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(CompleteNoteModal, {
                isCompletionModalOpen: isCompletionModalOpen,
                handleClose: function() {
                    return setIsCompletionModalOpen(false);
                },
                selectedNote: selectedThread,
                foundUser: foundUser,
                completeNote: completeNote
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Dialog/* default */.Z, {
                open: isDialogOpen,
                onClose: function() {
                    return setIsDialogOpen(false);
                },
                "aria-labelledby": "alert-dialog-title",
                "aria-describedby": "alert-dialog-description",
                sx: {
                    "& .MuiDialog-paper": {
                        background: "transparent",
                        borderRadius: "12px"
                    }
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                    sx: {
                        maxWidth: "400px",
                        background: "white",
                        borderRadius: "12px"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(DialogContent/* default */.Z, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                    display: "flex",
                                    alignItems: "start",
                                    justifyContent: "flex-start",
                                    paddingBottom: 2,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                        sx: {
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            width: "48px",
                                            height: "48px",
                                            borderRadius: "50%",
                                            background: "#FEF3F2"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                            sx: {
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                width: "35px",
                                                height: "35px",
                                                borderRadius: "50%",
                                                background: "#FEE4E2"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(units_Icon/* default.Delete */.Z.Delete, {
                                                style: {
                                                    color: "transparent",
                                                    fontSize: 20
                                                }
                                            })
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    variant: "h6",
                                    align: "left",
                                    children: "Delete this reply?"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    align: "left",
                                    sx: {
                                        color: "#667085",
                                        fontSize: "14px",
                                        fontWeight: "400"
                                    },
                                    children: "Are you sure you want to delete this reply? This action cannot be undone."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DialogActions/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                direction: "row",
                                spacing: 2,
                                justifyContent: "space-between",
                                width: "100%",
                                padding: 2,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                        variant: "outlined",
                                        onClick: function() {
                                            return setIsDialogOpen(false);
                                        },
                                        style: {
                                            color: "#344054",
                                            flex: 1,
                                            marginRight: 12,
                                            border: "1px solid #D0D5DD",
                                            borderRadius: 8,
                                            height: 48
                                        },
                                        children: "Cancel"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                        variant: "contained",
                                        onClick: handleDelete,
                                        color: "primary",
                                        style: {
                                            flex: 1,
                                            marginLeft: 12,
                                            borderRadius: 8,
                                            height: 48,
                                            background: "#D92D20"
                                        },
                                        children: "Delete"
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            isDeleteNoteModalOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(DeleteNoteModal, {
                isDeleteNoteModalOpen: isDeleteNoteModalOpen,
                setIsDeleteNoteModalOpen: setIsDeleteNoteModalOpen,
                setThreads: setThreads,
                selectedThread: selectedThread,
                setSelectedThread: setSelectedThread,
                threads: threads,
                tourSlug: tour.slug,
                userId: foundUser.id,
                removeThreadFromSpace: removeThreadFromSpace
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Modal/Modal.js + 4 modules
var Modal = __webpack_require__(39477);
;// CONCATENATED MODULE: ./components/tour/Threads/components/styles.ts
var createRootStyle = function() {
    return {
        background: "rgba(0, 0, 0, 0.5)",
        boxShadow: "0px 8px 11px -5px rgba(0, 0, 0, 0.2), 0px 17px 26px 2px rgba(0, 0, 0, 0.14), 0px 6px 32px 5px rgba(0, 0, 0, 0.12)",
        borderRadius: "15px",
        minWidth: {
            xs: "100%",
            md: "700px"
        },
        minHeight: {
            xs: "100%",
            md: "541px"
        },
        maxHeight: "calc(100vh - 32px)",
        width: {
            xs: "100%",
            md: "fit-content"
        },
        // eslint-disable-next-line no-nested-ternary
        height: {
            xs: "100%",
            md: "fit-content",
            lg: "fit-content"
        },
        padding: "0",
        position: "absolute",
        right: {
            xs: 0,
            md: "16px"
        },
        left: {
            xs: 0,
            md: "16px"
        },
        top: "16px",
        bottom: "16px",
        margin: "auto",
        zIndex: 3,
        textAlign: "center"
    };
};

;// CONCATENATED MODULE: ./components/tour/Threads/components/modals/ThreadLoginPopup.tsx











function getTokenData(token) {
    // Split the token into its parts
    if (!token) {
        return {
            tokenExpired: true
        };
    }
    var payloadEncoded = token.split(".")[1];
    if (!payloadEncoded) {
        return {
            tokenExpired: true
        };
    }
    // Decode the payload
    var payloadDecoded = atob(payloadEncoded);
    // Parse the payload as JSON
    var payload = JSON.parse(payloadDecoded);
    // Check if the exp property exists
    if (!payload.exp) {
        return {
            tokenExpired: true
        };
    }
    // Get the current date/time in seconds since the Unix epoch
    var currentDate = Math.floor(Date.now() / 1000);
    // Check if the current date/time is greater than the exp property
    return {
        tokenExpired: currentDate > payload.exp,
        userIdFromToken: payload.userId
    };
}
var getReCaptchaToken = function() {
    return new Promise(function(resolve, reject) {
        if (false) {}
        window.grecaptcha.ready(function() {
            window.grecaptcha.execute("6Le-bIYbAAAAAM6IlCstvx1NZFZlHEjCXoaBnpFC", {
                action: "main"
            }).then(resolve).catch(reject);
        });
    });
};
var ThreadLoginPopup = function(param) {
    var collaborators = param.collaborators, userId = param.userId, setUserId = param.setUserId, setIsGuest = param.setIsGuest, tour = param.tour;
    var ref = (0,react.useState)(!localStorage.getItem("userToken")), isOpen = ref[0], setIsOpen = ref[1];
    var ref1 = (0,react.useState)({
        email: "",
        password: ""
    }), inputs = ref1[0], setInputs = ref1[1];
    var ref2 = (0,react.useState)(false), showPassword = ref2[0], setShowPassword = ref2[1];
    var handleInputsChange = function(e) {
        var _target = e.target, id = _target.id, value = _target.value;
        setInputs(function(prevState) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevState), (0,_define_property/* default */.Z)({}, id, value));
        });
    };
    var handleSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var captchaToken, res, data;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!inputs.email || !inputs.password) {
                            react_toastify_esm/* toast.error */.Am.error("Please fill in credentials");
                            return [
                                2
                            ];
                        }
                        if (!(collaborators === null || collaborators === void 0 ? void 0 : collaborators.find(function(c) {
                            return c.email === inputs.email;
                        }))) {
                            react_toastify_esm/* toast.error */.Am.error("You are not a collaborator on this space");
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            getReCaptchaToken()
                        ];
                    case 1:
                        captchaToken = _state.sent();
                        return [
                            4,
                            TreedisPublicDAO/* default.login */.Z.login((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, inputs), {
                                captchaToken: captchaToken
                            }))
                        ];
                    case 2:
                        res = _state.sent();
                        if (res) {
                            data = res.data;
                            if (data) {
                                localStorage.setItem("userToken", data.refreshToken); // refreshToken because it's long lived
                                setUserId(Number(data.user.id));
                                setIsOpen(false);
                            } else {
                                react_toastify_esm/* toast.error */.Am.error(res.message);
                            }
                        } else {
                            react_toastify_esm/* toast.error */.Am.error("Wrong password or email");
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSubmit() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        var getSlugFromUrl = function() {
            var segments = window.location.href.split("/");
            return segments[segments.length - 1].split("?")[0];
        };
        var slug = getSlugFromUrl();
        if ((tour === null || tour === void 0 ? void 0 : tour.slug) && slug !== tour.slug) {
            var token = localStorage.getItem("userToken");
            var userIdFromToken = getTokenData(token).userIdFromToken;
            if (!collaborators.map(function(c) {
                return c.id;
            }).includes(Number(userIdFromToken))) {
                setIsOpen(true);
            }
        }
    }, [
        window.location.href,
        tour === null || tour === void 0 ? void 0 : tour.slug
    ]);
    (0,react.useEffect)(function() {
        var token = localStorage.getItem("userToken");
        var ref = getTokenData(token), tokenExpired = ref.tokenExpired, userIdFromToken = ref.userIdFromToken;
        if ((tokenExpired || !token) && !userId) {}
        if (!collaborators.map(function(c) {
            return c.id;
        }).includes(Number(userIdFromToken))) {
            setIsOpen(true);
        }
        if (!userIdFromToken) {
            setUserId(null);
        } else {
            setUserId(Number(userIdFromToken));
        }
    }, [
        userId,
        setUserId,
        collaborators
    ]);
    var handleEnterPress = function(event) {
        if (event.key === "Enter") {
            handleSubmit();
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
        open: isOpen,
        hideBackdrop: true,
        sx: {
            background: "rgba(0, 0, 0, 0.4)",
            transition: "all 0.3s ease",
            backdropFilter: "blur(15px)"
        },
        onKeyDown: handleEnterPress,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
            direction: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: {
                xs: 2,
                md: 3
            },
            sx: createRootStyle(),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                    required: true,
                    autoFocus: true,
                    id: "email",
                    type: "email",
                    label: "Email",
                    value: inputs.email,
                    onChange: handleInputsChange,
                    sx: {
                        "& .MuiInputBase-root , input": {
                            height: {
                                xs: "36px",
                                md: "56px"
                            },
                            lineHeight: {
                                xs: "36px",
                                md: "56px"
                            }
                        }
                    },
                    inputProps: {
                        style: {
                            width: "320px",
                            borderColor: "#FFFFFF",
                            borderRadius: "4px",
                            color: "white"
                        }
                    },
                    InputLabelProps: {
                        sx: {
                            top: {
                                xs: "-10px",
                                md: 0
                            },
                            "&.MuiInputLabel-shrink": {
                                top: 0
                            }
                        }
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                    required: true,
                    id: "password",
                    type: showPassword ? "text" : "password",
                    label: "Password",
                    value: inputs.password,
                    onChange: handleInputsChange,
                    sx: {
                        "& .MuiInputBase-root , input": {
                            height: {
                                xs: "36px",
                                md: "56px"
                            },
                            lineHeight: {
                                xs: "36px",
                                md: "56px"
                            },
                            width: "320px"
                        }
                    },
                    InputProps: {
                        endAdornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                            onClick: function() {
                                return setShowPassword(function(prevState) {
                                    return !prevState;
                                });
                            },
                            sx: {
                                color: "#FFF"
                            },
                            children: showPassword ? /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                className: "fa-regular fa-eye"
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                className: "fa-regular fa-eye-slash"
                            })
                        })
                    },
                    // eslint-disable-next-line react/jsx-no-duplicate-props
                    inputProps: {
                        style: {
                            borderColor: "#FFFFFF",
                            borderRadius: "4px",
                            color: "white"
                        }
                    },
                    InputLabelProps: {
                        sx: {
                            top: {
                                xs: "-10px",
                                md: 0
                            },
                            "&.MuiInputLabel-shrink": {
                                top: 0
                            }
                        }
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                    gap: 1,
                    alignItems: "center",
                    width: "320px",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                            type: "submit",
                            onClick: handleSubmit,
                            sx: {
                                backgroundColor: "#2055FF",
                                my: {
                                    xs: 0,
                                    lg: "5px"
                                },
                                height: "56px",
                                width: {
                                    xs: "100%"
                                }
                            },
                            children: "Login as Collaborator"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                            onClick: function() {
                                setIsOpen(false);
                                setIsGuest(true);
                            },
                            sx: {
                                backgroundColor: "#2055FF",
                                my: {
                                    xs: 0,
                                    lg: "5px"
                                },
                                height: "56px",
                                width: {
                                    xs: "100%"
                                }
                            },
                            children: "Enter as Guest"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "caption",
                            color: "#fff",
                            children: "Only Collaborators can add Threads and leave comments. If you don't have access as a collaborator on this space, please contact the admin."
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/tour/Threads/Threads.tsx




















var NoteEditEventType;
(function(NoteEditEventType) {
    NoteEditEventType["EditPosition"] = "editPosition";
    NoteEditEventType["EditComplition"] = "editComplition";
})(NoteEditEventType || (NoteEditEventType = {}));
var Threads = function(param) {
    var isOpen = param.isOpen, closeDrawer = param.closeDrawer, showCaseTemp = param.showCaseTemp, showcaseTag = param.showcaseTag, iframe = param.iframe, initialThreads = param.initialThreads, tour = param.tour, appState = param.appState, addThreadToSpace = param.addThreadToSpace, showcase = param.showcase, selectedThreadProp = param.selectedThreadProp, incrementNewMessagesCount = param.incrementNewMessagesCount, decrementNewMessagesCount = param.decrementNewMessagesCount, resetNewMessagesCount = param.resetNewMessagesCount, removeThreadFromSpace = param.removeThreadFromSpace, toggleThreadVisibility = param.toggleThreadVisibility, hideElements = param.hideElements, openDrawer = param.openDrawer, moveToTag = param.moveToTag, getLocation = param.getLocation, isRtl = param.isRtl;
    var ref, ref1, ref2;
    var ref3 = (0,react.useState)(null), newThread = ref3[0], setNewThread = ref3[1];
    var ref4 = (0,react.useState)(false), editMode = ref4[0], setEditMode = ref4[1];
    var ref5 = (0,react.useState)({}), newThreadMessages = ref5[0], setNewThreadMessages = ref5[1];
    var ref6 = (0,react.useState)(initialThreads), threads = ref6[0], setThreads = ref6[1];
    var ref7 = (0,react.useState)(null), selectedThread = ref7[0], setSelectedThread = ref7[1];
    var ref8 = (0,react.useState)(false), addThreadClicked = ref8[0], setAddThreadClicked = ref8[1];
    var ref9 = (0,react.useState)(1), activeStep = ref9[0], setActiveStep = ref9[1];
    var ref10 = (0,react.useState)(null), userId = ref10[0], setUserId = ref10[1];
    var ref11 = (0,react.useState)(false), isAdding = ref11[0], setIsAdding = ref11[1];
    var ref12 = (0,react.useState)(0), filteredCount = ref12[0], setFilteredCount = ref12[1];
    var ref13 = (0,react.useState)(false), isGuest = ref13[0], setIsGuest = ref13[1];
    var ref14 = (0,react.useState)(tour === null || tour === void 0 ? void 0 : tour.users), collaborators = ref14[0], setCollaborators = ref14[1];
    var isSAPActive = (0,react.useMemo)(function() {
        return tour.isSAPActive;
    }, [
        tour.isSAPActive
    ]);
    var isTourAdmin = (0,react.useMemo)(function() {
        return tour.userId === userId;
    }, [
        tour.userId,
        userId
    ]);
    var ref15 = (0,react.useState)([]), mediaUrls = ref15[0], setMediaUrls = ref15[1];
    var ref16 = (0,react.useState)(null), anchorEl = ref16[0], setAnchorEl = ref16[1];
    var ref17 = (0,react.useState)(null), openedMenuId = ref17[0], setOpenedMenuId = ref17[1];
    var ref18 = (0,react.useState)(false), isDeleteNoteModalOpen = ref18[0], setIsDeleteNoteModalOpen = ref18[1];
    var isMenuOpen = Boolean(anchorEl);
    var controls = (0,react.useRef)(null);
    var tagNode = (0,react.useRef)();
    var inputNodeComponent = (0,react.useRef)();
    var attachToCursor = (0,react.useRef)(false);
    var normal = (0,react.useRef)();
    var clickListenerRef = (0,react.useRef)();
    var contentDrawerRef = (0,react.useRef)();
    var refUserId = (0,react.useRef)();
    var initialThreadsRef = (0,react.useRef)([]);
    var updateMessages = function(thread, messageToUpdate) {
        var messages = thread.messages;
        var messageIndex = messages.findIndex(function(message) {
            return message.id === messageToUpdate.id;
        });
        if (messageIndex !== -1) {
            messages[messageIndex] = messageToUpdate;
        } else {
            messages.push(messageToUpdate);
        }
        return messages;
    };
    (0,react.useEffect)(function() {
        if (isEqual_default()(initialThreads, initialThreadsRef.current)) return;
        setThreads((0,_to_consumable_array/* default */.Z)(initialThreads));
        initialThreadsRef.current = initialThreads;
    }, [
        initialThreads
    ]);
    (0,react.useEffect)(function() {
        setCollaborators(tour.users);
        setIsGuest(false);
    }, [
        tour
    ]);
    var handleEditMessage = function() {
        var foundMessage = selectedThread === null || selectedThread === void 0 ? void 0 : selectedThread.messages.find(function(m) {
            return m.id === openedMenuId;
        });
        if (foundMessage) {
            setEditMode(true);
            setMediaUrls(foundMessage.mediaUrls.map(function(url) {
                return {
                    src: url,
                    flaggedToDelete: false
                };
            }));
        }
        setAnchorEl(null);
    };
    var handleIncrementNewMessagesCount = function(newThreadMessageUserId, newThreadMessageThreadId) {
        if (newThreadMessageUserId === refUserId.current) return;
        incrementNewMessagesCount();
        setNewThreadMessages(function(prevMessages) {
            if (prevMessages[newThreadMessageThreadId]) {
                // eslint-disable-next-line operator-assignment
                prevMessages[newThreadMessageThreadId] += 1;
            } else {
                prevMessages = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevMessages), (0,_define_property/* default */.Z)({}, newThreadMessageThreadId, 1));
            }
            return prevMessages;
        });
    };
    var handleDecrementNewMessagesCount = function(newThreadMessageUserId, newThreadMessageThreadId) {
        if (newThreadMessageUserId === refUserId.current) return;
        decrementNewMessagesCount();
        setNewThreadMessages(function(prevMessages) {
            if (prevMessages[newThreadMessageThreadId]) {
                // eslint-disable-next-line operator-assignment
                prevMessages[newThreadMessageThreadId] -= 1;
            }
            return prevMessages;
        });
    };
    var backToThreadsStep = function() {
        var ref;
        setActiveStep(1);
        setSelectedThread(null);
        setEditMode(false);
        (contentDrawerRef === null || contentDrawerRef === void 0 ? void 0 : (ref = contentDrawerRef.current) === null || ref === void 0 ? void 0 : ref.scrollTo) && contentDrawerRef.current.scrollTo(0, 0);
    };
    (0,react.useEffect)(function() {
        socket/* default.emit */.Z.emit("thread_join", {
            room: tour.slug
        });
        socket/* default.on */.Z.on("thread_added", function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
                var threadFromAnotherUser;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            threadFromAnotherUser = data.newThread;
                            threadFromAnotherUser.customIcon = "thread";
                            return [
                                4,
                                addThreadToSpace(threadFromAnotherUser)
                            ];
                        case 1:
                            _state.sent();
                            setThreads(function(prevThreads) {
                                return (0,_to_consumable_array/* default */.Z)(prevThreads).concat([
                                    threadFromAnotherUser
                                ]);
                            });
                            incrementNewMessagesCount();
                            return [
                                2
                            ];
                    }
                });
            });
            return function(data) {
                return _ref.apply(this, arguments);
            };
        }());
        socket/* default.on */.Z.on("thread_edit", function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
                var savedThread, eventType, foundThread;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            savedThread = data.savedThread, eventType = data.eventType;
                            if (!(eventType === NoteEditEventType.EditPosition)) return [
                                3,
                                4
                            ];
                            if (!data.isRecentNote) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                showCaseTemp.tag.edit(savedThread)
                            ];
                        case 1:
                            _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 2:
                            foundThread = initialThreadsRef.current.find(function(thread) {
                                return thread.defaultSid === savedThread.defaultSid || thread.sid === savedThread.defaultSid || thread.defaultSid === savedThread.sid || thread.id === savedThread.id;
                            });
                            if (!(foundThread === null || foundThread === void 0 ? void 0 : foundThread.sid)) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                showcaseTag.editPosition(foundThread.sid, {
                                    anchorPosition: {
                                        x: savedThread.positionX,
                                        y: savedThread.positionY,
                                        z: savedThread.positionZ
                                    }
                                })
                            ];
                        case 3:
                            _state.sent();
                            setThreads(function(prevThread) {
                                return prevThread.map(function(thread) {
                                    if (thread.id === savedThread.id) {
                                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, thread), {
                                            positionX: savedThread.positionX,
                                            positionY: savedThread.positionY,
                                            positionZ: savedThread.positionZ
                                        });
                                    }
                                    return thread;
                                });
                            });
                            _state.label = 4;
                        case 4:
                            if (!(eventType === NoteEditEventType.EditComplition)) return [
                                3,
                                6
                            ];
                            return [
                                4,
                                handleCompleteNote(savedThread.id, savedThread)
                            ];
                        case 5:
                            _state.sent();
                            _state.label = 6;
                        case 6:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(data) {
                return _ref.apply(this, arguments);
            };
        }());
        socket/* default.on */.Z.on("message_added", function(data) {
            var updatedThread;
            setThreads(function(prevThreads) {
                var foundThread = prevThreads.find(function(thread) {
                    return thread.id === data.newThreadMessage.threadId;
                });
                if (foundThread) {
                    return prevThreads.map(function(thread) {
                        if (thread.id === foundThread.id) {
                            var messages = updateMessages(thread, data.newThreadMessage);
                            updatedThread = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, thread), {
                                messages: messages
                            });
                            return updatedThread;
                        }
                        return thread;
                    });
                }
                return prevThreads;
            });
            setSelectedThread(function(prevThread) {
                if (updatedThread && ((updatedThread === null || updatedThread === void 0 ? void 0 : updatedThread.id) === (prevThread === null || prevThread === void 0 ? void 0 : prevThread.id) || !prevThread)) {
                    return updatedThread;
                }
                return prevThread;
            });
            handleIncrementNewMessagesCount(data.newThreadMessage.userId, data.newThreadMessage.threadId);
        });
        socket/* default.on */.Z.on("message_edited", function(data) {
            var updatedThread;
            setThreads(function(prevThreads) {
                var foundThread = prevThreads.find(function(thread) {
                    return thread.id === data.updatedMessage.threadId;
                });
                if (foundThread) {
                    return prevThreads.map(function(thread) {
                        if (thread.id === foundThread.id) {
                            var messages = updateMessages(thread, data.updatedMessage);
                            updatedThread = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, thread), {
                                title: data.updatedMessage.savedTitle,
                                messages: messages
                            });
                            return updatedThread;
                        }
                        return thread;
                    });
                }
                return prevThreads;
            });
            setSelectedThread(function(prevThread) {
                if (updatedThread && ((updatedThread === null || updatedThread === void 0 ? void 0 : updatedThread.id) === (prevThread === null || prevThread === void 0 ? void 0 : prevThread.id) || !prevThread)) {
                    return updatedThread;
                }
                return prevThread;
            });
        });
        socket/* default.on */.Z.on("message_deleted", function(data) {
            setThreads(function(prevThreads) {
                var foundThread = prevThreads.find(function(thread) {
                    return thread.id === data.data.threadId;
                });
                if (foundThread) {
                    return prevThreads.map(function(thread) {
                        if (thread.id === foundThread.id) {
                            var messages = thread.messages.filter(function(message) {
                                return message.id !== data.data.id;
                            });
                            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, thread), {
                                messages: messages
                            });
                        }
                        return thread;
                    });
                }
                return prevThreads;
            });
            setSelectedThread(function(prevThread) {
                if ((prevThread === null || prevThread === void 0 ? void 0 : prevThread.id) === data.data.threadId) {
                    var messages = prevThread.messages.filter(function(message) {
                        return message.id !== data.data.id;
                    });
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevThread), {
                        messages: messages
                    });
                }
                return prevThread;
            });
            handleDecrementNewMessagesCount(data.data.userId, data.data.threadId);
        });
        socket/* default.on */.Z.on("thread_delete", function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
                var deletedThread;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            deletedThread = data.deletedThread;
                            return [
                                4,
                                removeThreadFromSpace(deletedThread)
                            ];
                        case 1:
                            _state.sent();
                            return [
                                4,
                                setThreads(function(prevState) {
                                    var filteredThreads = prevState.filter(function(thread) {
                                        return thread.id !== deletedThread.id;
                                    });
                                    return filteredThreads;
                                })
                            ];
                        case 2:
                            _state.sent();
                            backToThreadsStep();
                            return [
                                2
                            ];
                    }
                });
            });
            return function(data) {
                return _ref.apply(this, arguments);
            };
        }());
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // find clicked thread from tag click
    (0,react.useEffect)(function() {
        if (selectedThreadProp) {
            var foundThread = threads.find(function(thread) {
                return thread.id === selectedThreadProp.id;
            });
            if (foundThread) setSelectedThread(foundThread);
        }
    }, [
        selectedThreadProp
    ]);
    var configureScene = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        showCaseTemp.tag.configureScene(controls)
                    ];
                case 1:
                    _state.sent();
                    showCaseTemp.tag.pointerIntersection(tagNode, attachToCursor);
                    return [
                        2
                    ];
            }
        });
    }), [
        showCaseTemp.tag
    ]);
    (0,react.useEffect)(function() {
        if (appState === dist/* TourLoaderEventsType.PLAYING */.$D.PLAYING) {
            configureScene();
        }
    }, [
        appState,
        configureScene
    ]);
    (0,react.useEffect)(function() {
        refUserId.current = userId;
    }, [
        userId
    ]);
    var getThree = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var THREE;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0,dist/* iTHREE */.Sc)()
                        ];
                    case 1:
                        THREE = _state.sent();
                        normal.current = new THREE.Vector3(0, 1, 0);
                        return [
                            2
                        ];
                }
            });
        });
        return function getThree() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        getThree();
    }, []);
    var addTag = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(cb) {
            var clickListener;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!showCaseTemp.tag) {
                            return [
                                2
                            ];
                        }
                        attachToCursor.current = true;
                        return [
                            4,
                            showCaseTemp.tag.initTagEditObject({
                                tagNode: tagNode,
                                inputNodeComponent: inputNodeComponent,
                                controls: controls,
                                options: {},
                                userNavigationEnabled: false
                            })
                        ];
                    case 1:
                        _state.sent();
                        showCaseTemp.mpSDK.Pointer.intersection.subscribe(function(e) {
                            var ref;
                            var _normal = e.normal, x = _normal.x, y = _normal.y, z = _normal.z;
                            if ((ref = normal.current) === null || ref === void 0 ? void 0 : ref.isVector3) normal.current.set(x, y, z);
                        });
                        clickListener = function() {
                            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                                var ref, ref1, position, stemVector;
                                return (0,tslib_es6.__generator)(this, function(_state) {
                                    iframe.contentWindow.document.removeEventListener("click", clickListener);
                                    iframe.contentWindow.document.removeEventListener("touchend", clickListener);
                                    if (inputNodeComponent.current && tagNode.current) {
                                        ;
                                        inputNodeComponent.current.inputs.userNavigationEnabled = true;
                                        inputNodeComponent.current.inputs.eventsEnabled = false;
                                        inputNodeComponent.current.inputs.unfiltered = true;
                                        position = (ref = tagNode.current.obj3D) === null || ref === void 0 ? void 0 : (ref1 = ref.position) === null || ref1 === void 0 ? void 0 : ref1.clone();
                                        stemVector = normal.current ? normal.current.clone().clampLength(0, 0.3) : {
                                            x: 0,
                                            y: 0.3,
                                            z: 0
                                        };
                                        tagNode.current.stop();
                                        tagNode.current = undefined;
                                        inputNodeComponent.current = undefined;
                                        cb(position, stemVector);
                                    }
                                    return [
                                        2
                                    ];
                                });
                            });
                            return function clickListener() {
                                return _ref.apply(this, arguments);
                            };
                        }();
                        clickListenerRef.current = clickListener;
                        iframe.contentWindow.document.addEventListener("click", clickListener, {
                            once: true,
                            capture: true
                        });
                        iframe.contentWindow.document.addEventListener("touchend", clickListener, {
                            once: true,
                            capture: true
                        });
                        return [
                            2
                        ];
                }
            });
        });
        return function(cb) {
            return _ref.apply(this, arguments);
        };
    }(), [
        iframe.contentWindow.document,
        showCaseTemp.mpSDK.Pointer.intersection,
        showCaseTemp.tag
    ]);
    var handleAddingThread = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setIsAdding(true);
                        closeDrawer();
                        return [
                            4,
                            addTag(function() {
                                var _ref = (0,_async_to_generator/* default */.Z)(function(position, stemVector) {
                                    var threadToAdd, sid;
                                    return (0,tslib_es6.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                threadToAdd = {
                                                    id: "temp-id-".concat(Math.random()),
                                                    sid: "temp-sid-".concat(Math.random()),
                                                    positionX: position.x,
                                                    positionY: position.y,
                                                    positionZ: position.z,
                                                    stemVectorX: stemVector.x,
                                                    stemVectorY: stemVector.y,
                                                    stemVectorZ: stemVector.z,
                                                    mpTitle: false,
                                                    tooltip: false,
                                                    stemVisible: true,
                                                    mpNavigation: true,
                                                    enabled: true,
                                                    iconUrl: "".concat("https://api.treedis.com" || 0, "/v1/public/icons/thread"),
                                                    description: ""
                                                };
                                                return [
                                                    4,
                                                    showCaseTemp.tag.add(threadToAdd)
                                                ];
                                            case 1:
                                                sid = _state.sent();
                                                threadToAdd.sid = sid;
                                                if (showCaseTemp.tag && controls.current) {
                                                    attachToCursor.current = false;
                                                    showCaseTemp.tag.startTranslateControls({
                                                        tag: threadToAdd,
                                                        tagNode: tagNode,
                                                        inputNodeComponent: inputNodeComponent,
                                                        controls: controls,
                                                        cb: function() {
                                                            var _position = tagNode.current.obj3D.position, x = _position.x, y = _position.y, z = _position.z;
                                                            threadToAdd.positionX = x;
                                                            threadToAdd.positionY = y;
                                                            threadToAdd.positionZ = z;
                                                            showCaseTemp.tag.edit(threadToAdd);
                                                        }
                                                    });
                                                }
                                                setNewThread(threadToAdd);
                                                setIsAdding(false);
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                });
                                return function(position, stemVector) {
                                    return _ref.apply(this, arguments);
                                };
                            }())
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function handleAddingThread() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleAddThread = (0,react.useCallback)(function() {
        if (!userId) {
            setUserId(null);
            return;
        }
        setSelectedThread(null);
        setAddThreadClicked(true);
        handleAddingThread();
    }, [
        userId,
        handleAddingThread
    ]);
    var handleCloseDrawer = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        controls.current.inputs.selection = null;
                        if (!newThread) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            showCaseTemp.tag.remove(newThread.sid)
                        ];
                    case 1:
                        _state.sent();
                        setNewThread(null);
                        return [
                            3,
                            3
                        ];
                    case 2:
                        if (tagNode.current) {
                            tagNode.current.stop();
                            tagNode.current = undefined;
                        }
                        if (inputNodeComponent.current) {
                            inputNodeComponent.current = undefined;
                        }
                        _state.label = 3;
                    case 3:
                        setSelectedThread(null);
                        setAddThreadClicked(false);
                        setIsAdding(false);
                        setEditMode(false);
                        closeDrawer();
                        return [
                            2
                        ];
                }
            });
        });
        return function handleCloseDrawer() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        if (selectedThread || newThread) {
            setActiveStep(2);
        } else {
            setActiveStep(1);
        }
        return function() {
            setActiveStep(1);
        };
    }, [
        newThread,
        selectedThread
    ]);
    var handleThreadItemSelect = function(thread) {
        setSelectedThread(thread);
        setActiveStep(2);
        setNewThreadMessages(function(prevMessages) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevMessages), (0,_define_property/* default */.Z)({}, thread.id, 0));
        });
        resetNewMessagesCount();
    };
    var mainMessage = (0,react.useMemo)(function() {
        var ref;
        return (selectedThread === null || selectedThread === void 0 ? void 0 : (ref = selectedThread.messages) === null || ref === void 0 ? void 0 : ref.find(function(message) {
            return message.isMainMessage;
        })) || null;
    }, [
        selectedThread
    ]);
    (0,react.useEffect)(function() {
        var keyDownHandler = function(event) {
            if (event.key === "Escape") {
                event.preventDefault();
                tagNode.current.stop();
                tagNode.current = undefined;
                inputNodeComponent.current = undefined;
                if (clickListenerRef === null || clickListenerRef === void 0 ? void 0 : clickListenerRef.current) {
                    iframe.contentWindow.document.removeEventListener("click", clickListenerRef.current);
                    clickListenerRef.current = null;
                }
                setIsAdding(false);
                setAddThreadClicked(false);
            }
        };
        if (isAdding) {
            document.addEventListener("keydown", keyDownHandler);
        } else {
            document.removeEventListener("keydown", keyDownHandler);
        }
        return function() {
            document.removeEventListener("keydown", keyDownHandler);
        };
    }, [
        iframe.contentWindow.document,
        isAdding
    ]);
    (0,react.useEffect)(function() {
        var token = localStorage.getItem("userToken");
        if (token) {
            var userIdFromToken = getTokenData(token).userIdFromToken;
            if (!userIdFromToken) {
                setUserId(null);
            }
            setUserId(Number(userIdFromToken));
        }
    }, [
        userId,
        setUserId
    ]);
    (0,react.useEffect)(function() {
        if (newThread) {
            openDrawer();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        newThread
    ]);
    (0,react.useEffect)(function() {
        setIsGuest(false);
    }, []);
    (0,react.useEffect)(function() {
        if (isGuest || !userId) {
            hideElements({
                hideTags: initialThreads,
                polygonsToHide: [],
                vsImagesToHide: [],
                vsVideosToHide: [],
                vsItemsToHide: []
            });
            initialThreads.forEach(function(thread) {
                toggleThreadVisibility(thread, false);
            });
        }
    }, [
        isGuest,
        userId,
        tour
    ]);
    var handleCompleteNote = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(noteId, noteFromAnotherUser) {
            var thread, dataToSave, result, savedThread, updatedThreads, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        thread = threads.find(function(t) {
                            return t.id === noteId;
                        });
                        if (!!noteFromAnotherUser) return [
                            3,
                            5
                        ];
                        delete thread.message;
                        delete thread.dummyObject;
                        dataToSave = formData.create((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, thread), {
                            isCompleted: !thread.isCompleted
                        }));
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            TreedisPublicDAO/* default.saveThread */.Z.saveThread({
                                data: dataToSave
                            })
                        ];
                    case 2:
                        result = _state.sent();
                        if (result.message === "Success") {
                            savedThread = result.savedThread;
                            toggleThreadVisibility(thread, !savedThread.isCompleted);
                            updatedThreads = threads.map(function(t) {
                                return t.id === savedThread.id ? (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, t), {
                                    isCompleted: savedThread.isCompleted
                                }) : t;
                            });
                            setThreads(updatedThreads);
                            setSelectedThread(function(prevSelectedThread) {
                                return prevSelectedThread ? (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevSelectedThread), {
                                    isCompleted: savedThread.isCompleted
                                }) : savedThread;
                            });
                            react_toastify_esm/* toast.success */.Am.success("Note marked as ".concat(savedThread.isCompleted ? "completed" : "incomplete"));
                            socket/* default.emit */.Z.emit("thread_edit", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, savedThread), {
                                room: tour.slug,
                                eventType: NoteEditEventType.EditComplition
                            }));
                        }
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        react_toastify_esm/* toast.error */.Am.error("Failed to mark Note as ".concat(!thread.isCompleted ? "completed" : "incomplete"));
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            3,
                            6
                        ];
                    case 5:
                        setThreads(function(prevThreads) {
                            var foundThread = prevThreads.find(function(thread) {
                                return thread.defaultSid === noteFromAnotherUser.defaultSid || thread.sid === noteFromAnotherUser.defaultSid || thread.defaultSid === noteFromAnotherUser.sid || thread.id === noteFromAnotherUser.id;
                            });
                            toggleThreadVisibility(foundThread.sid, noteFromAnotherUser.isCompleted);
                            return prevThreads.map(function(t) {
                                return t.id === (noteFromAnotherUser === null || noteFromAnotherUser === void 0 ? void 0 : noteFromAnotherUser.id) ? (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, t), {
                                    isCompleted: noteFromAnotherUser === null || noteFromAnotherUser === void 0 ? void 0 : noteFromAnotherUser.isCompleted
                                }) : t;
                            });
                        });
                        _state.label = 6;
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleCompleteNote(noteId, noteFromAnotherUser) {
            return _ref.apply(this, arguments);
        };
    }();
    var direction = ((ref = tour.client) === null || ref === void 0 ? void 0 : ref.rtl) ? "rtl" : "";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            !isGuest && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                className: "no-reset no-reset-list",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Drawer/* default */.ZP, {
                        open: isOpen,
                        anchor: "right",
                        variant: "persistent",
                        ModalProps: {
                            keepMounted: true
                        },
                        PaperProps: {
                            sx: {
                                maxWidth: deviceManager/* default.isMobile */.Z.isMobile() || deviceManager/* default.isTablet */.Z.isTablet() ? "416px" : "494px",
                                width: "100%",
                                background: "transparent",
                                overflowX: "hidden",
                                flexDirection: "row-reverse",
                                alignItems: "center",
                                border: "none"
                            }
                        },
                        sx: {
                            flexDirection: "row-reverse",
                            alignItems: "center"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                sx: {
                                    height: "100%",
                                    background: "#F7F7F7",
                                    maxWidth: deviceManager/* default.isMobile */.Z.isMobile() || deviceManager/* default.isTablet */.Z.isTablet() ? "394px" : "464px",
                                    width: "100%",
                                    borderLeft: "1px solid #EAECF0"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                        direction: "row",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        p: 2,
                                        sx: {
                                            direction: direction,
                                            background: "white"
                                        },
                                        children: [
                                            activeStep === 2 && selectedThread && /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                                onClick: backToThreadsStep,
                                                sx: {
                                                    gap: 1,
                                                    width: "auto"
                                                },
                                                children: direction ? /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                    className: "fa-solid fa-chevron-right"
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                    className: "fa-solid fa-chevron-left",
                                                    style: {
                                                        color: "#101828",
                                                        fontSize: "18px"
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                variant: "body1",
                                                sx: {
                                                    fontWeight: "bold",
                                                    fontSize: "18px",
                                                    font: "Inter"
                                                },
                                                children: activeStep === 1 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                    children: [
                                                        "Notes",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                            component: "div",
                                                            sx: {
                                                                backgroundColor: "#F2F4F7",
                                                                borderRadius: "50%",
                                                                display: "inline-flex",
                                                                alignItems: "center",
                                                                justifyContent: "center",
                                                                width: "24px",
                                                                height: "24px",
                                                                textAlign: "center",
                                                                marginLeft: "5px"
                                                            },
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                                component: "span",
                                                                sx: {
                                                                    color: "#2055FF",
                                                                    fontSize: "14px"
                                                                },
                                                                children: filteredCount
                                                            })
                                                        })
                                                    ]
                                                }) : !!newThread ? "New note" : ""
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                                direction: "row",
                                                justifyContent: "space-between",
                                                alignItems: "center",
                                                children: [
                                                    activeStep === 2 && selectedThread && /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                                        onClick: function() {
                                                            return moveToTag(selectedThread.sid);
                                                        },
                                                        id: "target-button-".concat(selectedThread.id),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                            className: "fa-regular fa-location-crosshairs",
                                                            style: {
                                                                fontSize: "18px",
                                                                fontWeight: 400,
                                                                color: "#101828"
                                                            }
                                                        })
                                                    }),
                                                    activeStep === 2 && selectedThread && (mainMessage === null || mainMessage === void 0 ? void 0 : mainMessage.userId) === userId && /*#__PURE__*/ (0,jsx_runtime.jsx)(EditMenu, {
                                                        selectedThread: selectedThread,
                                                        message: mainMessage,
                                                        setMediaUrls: setMediaUrls,
                                                        anchorEl: anchorEl,
                                                        setAnchorEl: setAnchorEl,
                                                        setOpenedMenuId: setOpenedMenuId,
                                                        isMenuOpen: isMenuOpen,
                                                        setEditMode: setEditMode,
                                                        setIsDeleteNoteModalOpen: setIsDeleteNoteModalOpen,
                                                        handleEdit: handleEditMessage
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                                        onClick: handleCloseDrawer,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                            className: "fa-solid fa-xmark-large",
                                                            style: {
                                                                fontSize: "18px",
                                                                fontWeight: 400,
                                                                color: "#101828"
                                                            }
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                        direction: "row",
                                        width: "200%",
                                        sx: {
                                            overflowX: "hidden",
                                            padding: "0 !important",
                                            flexGrow: 1
                                        },
                                        ref: contentDrawerRef,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                                                sx: {
                                                    transform: activeStep === 1 ? "translateX(0%)" : "translateX(-100%)",
                                                    transition: "transform 0.5s",
                                                    width: "100%",
                                                    direction: direction
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                                                    gap: 2,
                                                    p: 2,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ThreadsItems, {
                                                        rtl: (ref1 = tour.client) === null || ref1 === void 0 ? void 0 : ref1.rtl,
                                                        threads: threads,
                                                        setThreads: setThreads,
                                                        onThreadItemSelect: handleThreadItemSelect,
                                                        collaborators: collaborators,
                                                        userId: userId,
                                                        removeThreadFromSpace: removeThreadFromSpace,
                                                        tourSlug: tour === null || tour === void 0 ? void 0 : tour.slug,
                                                        showCaseTemp: showCaseTemp,
                                                        showcaseTag: showcaseTag,
                                                        isTourAdmin: isTourAdmin,
                                                        toggleThreadVisibility: toggleThreadVisibility,
                                                        hideElements: hideElements,
                                                        newThreadMessages: newThreadMessages,
                                                        controls: controls,
                                                        inputNodeComponent: inputNodeComponent,
                                                        tagNode: tagNode,
                                                        editMode: editMode,
                                                        setEditMode: setEditMode,
                                                        handleAddThread: handleAddThread,
                                                        moveToTag: moveToTag,
                                                        setFilteredCount: setFilteredCount,
                                                        onCompleteNote: handleCompleteNote,
                                                        isGuest: isGuest
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                                                gap: 2,
                                                sx: {
                                                    transform: activeStep === 1 ? "translateX(100%)" : "translateX(-100%)",
                                                    transition: "transform 0.5s",
                                                    width: "100%",
                                                    direction: direction
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Thread, {
                                                    rtl: (ref2 = tour.client) === null || ref2 === void 0 ? void 0 : ref2.rtl,
                                                    selectedThread: selectedThread,
                                                    setSelectedThread: setSelectedThread,
                                                    updateMessages: updateMessages,
                                                    newThread: newThread,
                                                    setNewThread: setNewThread,
                                                    userId: userId,
                                                    tour: tour,
                                                    closeDrawer: function() {
                                                        closeDrawer();
                                                        setAddThreadClicked(false);
                                                        setNewThread(null);
                                                        controls.current.inputs.selection = null;
                                                        showCaseTemp.tag.stopPositionUpdates({
                                                            controls: controls
                                                        });
                                                    },
                                                    setThreads: setThreads,
                                                    threads: threads,
                                                    showcase: showcase,
                                                    addThreadToSpace: addThreadToSpace,
                                                    showCaseTemp: showCaseTemp,
                                                    collaborators: collaborators,
                                                    isTourAdmin: isTourAdmin,
                                                    resetNewMessagesCount: function() {
                                                        if ((selectedThread === null || selectedThread === void 0 ? void 0 : selectedThread.id) > 0) {
                                                            setNewThreadMessages(function(prevMessages) {
                                                                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevMessages), (0,_define_property/* default */.Z)({}, selectedThread.id, 0));
                                                            });
                                                        }
                                                        resetNewMessagesCount();
                                                    },
                                                    toggleThreadVisibility: toggleThreadVisibility,
                                                    onThreadItemSelect: handleThreadItemSelect,
                                                    setIsAdding: setIsAdding,
                                                    controls: controls,
                                                    isSAPActive: isSAPActive,
                                                    editMode: editMode,
                                                    setEditMode: setEditMode,
                                                    setAddThreadClicked: setAddThreadClicked,
                                                    onCompleteNote: handleCompleteNote,
                                                    onCloseDrawer: handleCloseDrawer,
                                                    removeThreadFromSpace: removeThreadFromSpace,
                                                    mediaUrls: mediaUrls,
                                                    setMediaUrls: setMediaUrls,
                                                    anchorEl: anchorEl,
                                                    setAnchorEl: setAnchorEl,
                                                    openedMenuId: openedMenuId,
                                                    setOpenedMenuId: setOpenedMenuId,
                                                    isMenuOpen: isMenuOpen,
                                                    isDeleteNoteModalOpen: isDeleteNoteModalOpen,
                                                    setIsDeleteNoteModalOpen: setIsDeleteNoteModalOpen,
                                                    handleEdit: handleEditMessage,
                                                    getLocation: getLocation,
                                                    isRtl: isRtl,
                                                    isGuest: isGuest
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                sx: {
                                    top: "50%",
                                    left: 0,
                                    zIndex: 9999
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                    onClick: closeDrawer,
                                    sx: {
                                        width: "20px",
                                        height: "80px",
                                        background: "#ffffff",
                                        borderRadius: 0,
                                        borderTopLeftRadius: "8px",
                                        borderBottomLeftRadius: "8px",
                                        "&:hover": {
                                            background: "#f0f0f0"
                                        }
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        className: "fa-solid fa-chevron-right",
                                        style: {
                                            fontSize: "16px",
                                            color: "#000000"
                                        }
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Drawer/* default */.ZP, {
                        open: !isOpen,
                        anchor: "right",
                        variant: "persistent",
                        ModalProps: {
                            keepMounted: true
                        },
                        PaperProps: {
                            sx: {
                                maxWidth: deviceManager/* default.isMobile */.Z.isMobile() || deviceManager/* default.isTablet */.Z.isTablet() ? "416px" : "494px",
                                background: "transparent",
                                overflowX: "hidden",
                                overflowY: "scroll",
                                flexDirection: "row-reverse",
                                alignItems: "center",
                                border: "none"
                            }
                        },
                        sx: {
                            flexDirection: "row-reverse",
                            alignItems: "center"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                sx: {
                                    right: 0,
                                    width: "20px",
                                    height: "80px",
                                    background: "#ffffff",
                                    borderRadius: 0,
                                    borderTopLeftRadius: "8px",
                                    borderBottomLeftRadius: "8px",
                                    "&:hover": {
                                        background: "#f0f0f0"
                                    }
                                },
                                onClick: openDrawer,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                    className: "fa-solid fa-chevron-left",
                                    style: {
                                        fontSize: "16px",
                                        color: "#000000"
                                    }
                                })
                            })
                        })
                    }),
                    !addThreadClicked && !editMode && !selectedThread && !isGuest && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        sx: {
                            position: "absolute",
                            bottom: 20,
                            left: "50%",
                            transform: "translateX(-50%)",
                            zIndex: 1200,
                            direction: direction
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Slide/* default */.Z, {
                            id: "slide-button",
                            direction: "up",
                            in: isOpen,
                            mountOnEnter: true,
                            unmountOnExit: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                size: "large",
                                sx: {
                                    width: "60px",
                                    height: "60px",
                                    borderRadius: "50%",
                                    color: "#2055ff",
                                    background: deviceManager/* default.isMobile */.Z.isMobile() || deviceManager/* default.isTablet */.Z.isTablet() ? "#fff" : "#fff",
                                    "&:hover": {
                                        background: "#fff"
                                    },
                                    "&.Mui-disabled": {
                                        color: "#808080",
                                        background: "#fff"
                                    }
                                },
                                disabled: addThreadClicked || editMode,
                                onClick: handleAddThread,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                    className: "fa-solid fa-plus",
                                    style: {
                                        fontSize: "36px"
                                    }
                                })
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ThreadLoginPopup, {
                collaborators: collaborators,
                userId: userId,
                setUserId: setUserId,
                setIsGuest: setIsGuest,
                tour: tour
            }),
            isAdding && /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert/* default */.Z, {
                severity: "info",
                sx: {
                    zIndex: 9999,
                    position: "fixed",
                    top: 10,
                    left: 0,
                    right: 0,
                    py: 0,
                    mx: "auto",
                    maxWidth: "230px",
                    justifyContent: "center",
                    background: "rgba(0, 0, 0, 0.4)",
                    transition: "all 0.3s ease",
                    backdropFilter: "blur(15px)"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    color: "primary.main",
                    sx: {
                        color: "#fff"
                    },
                    children: "press Esc to cancel"
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/tour/regular/video/Chat/index.tsx
var Chat = __webpack_require__(39611);
;// CONCATENATED MODULE: ./components/tour/regular/avatar/chat/AvatarChat.tsx





var AvatarChat = function(param) {
    var avatar = param.avatar, chatOpen = param.chatOpen, toggleChatClick = param.toggleChatClick, setNotifications = param.setNotifications;
    var ref = (0,react.useState)([]), messages = ref[0], setMessages = ref[1];
    var ref1 = (0,react.useState)(null), currentUserId = ref1[0], setCurrentUserId = ref1[1];
    (0,react.useEffect)(function() {
        socket/* default.on */.Z.on("video_chat_receive", function(message) {
            message.timestamp = new Date();
            setMessages(function(prevMessages) {
                return (0,_to_consumable_array/* default */.Z)(prevMessages).concat([
                    message
                ]);
            });
            if (!chatOpen) {
                setNotifications();
            }
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0,react.useEffect)(function() {
        if (socket/* default */.Z && socket/* default.connected */.Z.connected) setCurrentUserId(socket/* default.id */.Z.id);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Chat/* default */.Z, {
        currentUserId: currentUserId,
        toggleChatClick: toggleChatClick,
        chatOpen: chatOpen,
        messages: messages,
        onSubmit: function(e, message) {
            socket/* default.emit */.Z.emit("video_chat_send", {
                name: avatar.name,
                text: message,
                avatarImage: avatar.imageUrl
            });
        }
    });
};

// EXTERNAL MODULE: ./components/tour/regular/bottomBar/CustomReel.tsx
var CustomReel = __webpack_require__(32847);
// EXTERNAL MODULE: ./components/tour/regular/bottomBar/Reel.tsx
var Reel = __webpack_require__(18621);
// EXTERNAL MODULE: ./components/tour/regular/bottomBar/ReelVideoBar/index.tsx + 3 modules
var ReelVideoBar = __webpack_require__(3405);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(61225);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Slider/Slider.js + 5 modules
var Slider = __webpack_require__(59248);
// EXTERNAL MODULE: ./events/index.ts + 2 modules
var events = __webpack_require__(31103);
;// CONCATENATED MODULE: ./components/tour/regular/bottomBar/TourVolume.tsx





var audioHandler = AudioModule/* AudioModule.getInstance */.w0.getInstance();
var TourVolume = function(param) {
    var mute = param.mute, setMute = param.setMute;
    var isMobile = (0,useMediaQuery/* default */.Z)("(max-width:768px)");
    var ref = (0,react.useState)(audioHandler.getVolume() || 1), volume = ref[0], setVolume = ref[1];
    (0,react.useEffect)(function() {
        events/* emitter.on */.u.on(events/* MittEvents.AUDIO_VOLUME */.s.AUDIO_VOLUME, function(e) {
            var v = e.volumeValue;
            if (Number(v)) {
                setVolume(Number(v));
            }
        });
        events/* emitter.on */.u.on(events/* MittEvents.AUDIO_MUTE */.s.AUDIO_MUTE, function(e) {
            var m = e.mute;
            setMute(m);
        });
        // Clean up on unmount
        return function() {
            events/* emitter.off */.u.off(events/* MittEvents.AUDIO_VOLUME */.s.AUDIO_VOLUME);
            events/* emitter.off */.u.off(events/* MittEvents.AUDIO_MUTE */.s.AUDIO_MUTE);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0,react.useEffect)(function() {
        audioHandler.volumeHandler(volume);
    }, [
        volume
    ]);
    (0,react.useEffect)(function() {
        audioHandler.volumeHandler(mute ? 0 : volume);
        events/* emitter.emit */.u.emit(events/* MittEvents.AUDIO_MUTE */.s.AUDIO_MUTE, {
            mute: mute
        });
    }, [
        mute,
        volume
    ]);
    var volumeIcon = volume < 0.5 ? "fa-volume-low" : "fa-volume";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        className: "data-balloon",
        mb: 1,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
            enterDelay: isMobile ? 50 : 250,
            leaveDelay: isMobile ? 1000 : 300,
            placement: "top",
            arrow: false,
            components: {
                Tooltip: Paper/* default */.Z
            },
            componentsProps: {
                tooltip: {
                    sx: {
                        background: "rgba(0,0,0,0.5)",
                        paddingY: 2,
                        borderRadius: "50px",
                        marginBottom: "10px"
                    }
                }
            },
            title: /*#__PURE__*/ (0,jsx_runtime.jsx)(Slider/* default */.ZP, {
                sx: {
                    height: "120px",
                    color: "white",
                    "& .MuiSlider-thumb:hover": {
                        boxShadow: "0px 0px 0px 6px rgba(255, 255, 255, 0.5)"
                    }
                },
                orientation: "vertical",
                value: volume * 100,
                onChange: function(e, value) {
                    if (Number(value)) {
                        setVolume(Number(value) / 100);
                        setMute(false);
                    }
                },
                min: 0,
                max: 100
            }),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                className: "actions-btn btn",
                onClick: function() {
                    return setMute(!mute);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                    className: "fas ".concat(mute ? "fa-volume-slash" : volumeIcon)
                })
            })
        })
    });
};

;// CONCATENATED MODULE: ./components/tour/regular/bottomBar/BottomBar.tsx
// eslint-disable-next-line no-use-before-define

































var MReelVideoBar = /*#__PURE__*/ (0,react.memo)(ReelVideoBar/* default */.Z);
var StyledNoteBadge = (0,styled_components_browser_esm/* default */.ZP)(Badge/* default */.Z).withConfig({
    displayName: "BottomBar__StyledNoteBadge",
    componentId: "sc-8f0b4314-0"
})(function(param) {
    var theme = param.theme;
    return {
        "& .MuiBadge-badge": {
            height: "10px",
            width: "10px",
            borderRadius: "12px",
            right: 10,
            top: 4,
            padding: "0 4px",
            backgroundColor: "#F04438",
            color: "white"
        }
    };
});
var BottomBar = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_inherits/* default */.Z)(BottomBar, Component);
    var _super = (0,_create_super/* default */.Z)(BottomBar);
    function BottomBar(props) {
        (0,_class_call_check/* default */.Z)(this, BottomBar);
        var _this;
        _this = _super.call(this, props);
        var _this1 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.getSetting = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(setting) {
                var err;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                _this1.props.showcase.Settings.get(setting)
                            ];
                        case 1:
                            return [
                                2,
                                _state.sent()
                            ];
                        case 2:
                            err = _state.sent();
                            console.error(err);
                            return [
                                3,
                                3
                            ];
                        case 3:
                            return [
                                2,
                                null
                            ];
                    }
                });
            });
            return function(setting) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this2 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.changeFloor = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(index) {
                var _all, changeFloor, err;
                var _arguments = arguments;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _all = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : false;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            changeFloor = _this2.props.changeFloor;
                            return [
                                4,
                                changeFloor(index, _all)
                            ];
                        case 2:
                            _state.sent();
                            _this2.setState({
                                showFloorsModal: false
                            });
                            setTimeout(function() {
                                var _props = _this2.props, tour = _props.tour, currentFloor = _props.currentFloor;
                                var music = tour.musics.find(function(item) {
                                    return item.floor === currentFloor;
                                });
                                _this2.props.setTourMusicState((tour.autoplayMusic || (music === null || music === void 0 ? void 0 : music.autoplay)) && !_this2.state.musicPausedByUser);
                            }, 100);
                            return [
                                3,
                                4
                            ];
                        case 3:
                            err = _state.sent();
                            console.error(err);
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(index) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this3 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.filterReel = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(categoryId) {
                var reels;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    reels = _this3.state.reels;
                    reels = reels.map(function(r) {
                        r.hide = false;
                        if (r.categoryId !== categoryId && _this3.state.activeCategory !== categoryId) {
                            r.hide = true;
                        }
                        return r;
                    });
                    _this3.setState({
                        reels: reels,
                        activeCategory: _this3.state.activeCategory !== categoryId ? categoryId : null
                    });
                    return [
                        2
                    ];
                });
            });
            return function(categoryId) {
                return _ref.apply(this, arguments);
            };
        }();
        _this.createLockScreen = function() {
            var lock = document.createElement("div");
            lock.id = "video-lock-screen";
            lock.setAttribute("style", "position: fixed; height: 100vh; width: 100vw; top: 0; left: 0; z-index: 1000");
            document.body.append(lock);
        };
        _this.removeLockScreen = function() {
            if (document.getElementById("video-lock-screen")) {
                document.getElementById("video-lock-screen").remove();
            }
        };
        _this.videoInit = function() {
            var tour = _this.state.tour;
            if (tour.videoUrl && tour.autoplayVideo) {
                _this.createLockScreen();
                _this.playVideo();
                if (deviceManager/* default.supportsTouch */.Z.supportsTouch()) {
                    _this.videoEventListener = document.addEventListener("touchstart", function() {
                        _this.playVideo();
                        _this.removeLockScreen();
                    }, {
                        once: true
                    });
                } else {
                    _this.videoEventListener = document.addEventListener("click", function() {
                        _this.playVideo();
                        _this.removeLockScreen();
                    }, {
                        once: true
                    });
                }
            }
        };
        _this.capitalizeFirstLetter = function(str) {
            if (!str) return null;
            return str.charAt(0).toUpperCase() + str.slice(1);
        };
        _this.defurnish = function() {
            _this.props.onDefurnish();
            _this.setState({
                defurnishOn: !_this.state.defurnishOn
            });
        };
        _this.playVideo = function() {
            _this.props.onStartVideo();
            _this.setState({
                youtubeOn: true
            });
        };
        _this.showVolumeControls = function() {
            var showVolumeControls = _this.state.showVolumeControls;
            _this.setState({
                showVolumeControls: !showVolumeControls
            });
        };
        _this.updatePlayOrPause = function() {
            var mainPlaying = _this.state.mainPlaying;
            _this.setState({
                mainPlaying: !mainPlaying
            });
        };
        _this.handleReelOpen = function() {
            var newReelState = !_this.props.reelOpen;
            _this.props.setReelOpen(newReelState);
            _this.setState({
                showVideoReel: newReelState
            });
        };
        _this.incrementNewMessagesCount = function() {
            _this.setState(function(prevState) {
                return {
                    newMessagesCount: prevState.newMessagesCount + 1
                };
            });
        };
        _this.resetNewMessagesCount = function() {
            _this.setState({
                newMessagesCount: 0
            });
        };
        _this.decrementNewMessagesCount = function() {
            _this.setState(function(prevState) {
                var newValue = prevState.newMessagesCount - 1;
                return {
                    newMessagesCount: newValue < 0 ? 0 : newValue
                };
            });
        };
        _this.toggleChatClick = function() {
            var ref, ref1;
            var chatOn = !_this.state.chatOpen;
            _this.setState({
                chatOpen: chatOn,
                chatNotifications: 0
            });
            (ref = _this.props) === null || ref === void 0 ? void 0 : (ref1 = ref.onToggleBottomBarActions) === null || ref1 === void 0 ? void 0 : ref1.call(ref, {
                chatOn: chatOn
            });
        };
        _this.setChatNotifications = function() {
            _this.setState(function(prevState) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevState), {
                    chatNotifications: prevState.chatNotifications + 1
                });
            });
        };
        var _props = _this.props, tour = _props.tour, audio = _props.audio, musicPausedByUser = _props.musicPausedByUser;
        _this.state = {
            musicPausedByUser: musicPausedByUser,
            audio: audio,
            tour: tour,
            floorplan: false,
            dollhouse: false,
            measurements: false,
            activeCategory: null,
            floorPlans: [],
            reels: [],
            reelCategories: [],
            showActionsModal: tour.autoplayVideo || tour.autoplayMusic && tour.music,
            showFloorsModal: false,
            duplicates: [],
            showLanguagesModal: false,
            showVolumeControls: false,
            showVideoReel: false,
            pdfList: false,
            cameraList: false,
            youtubeOn: false,
            restrictedReels: [],
            minimapVisible: tour.minimap && tour.minimapVisible && !props.room && window.innerWidth > 768,
            reel: [],
            newMessagesCount: 0,
            chatOpen: false,
            chatNotifications: 0,
            showTermsIframe: false,
            audioMute: false,
            defurnishOn: false
        };
        return _this;
    }
    var _proto = BottomBar.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var ref, _props, tour, allowedTours, reel, measurements, dollhouse, _tmp, floorplan, reelOpen, floorPlans, initialDuplicates, _tmp1, reelsRes, duplicates, reels, newrestrictedReels;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _props = _this.props, tour = _props.tour, allowedTours = _props.allowedTours, reel = _props.reel;
                        return [
                            4,
                            _this.getSetting("measurements")
                        ];
                    case 1:
                        measurements = _state.sent();
                        _tmp = !!tour.addon_dh;
                        if (!_tmp) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            _this.getSetting("dollhouse")
                        ];
                    case 2:
                        _tmp = _state.sent();
                        _state.label = 3;
                    case 3:
                        dollhouse = _tmp;
                        return [
                            4,
                            _this.getSetting("floor_plan")
                        ];
                    case 4:
                        floorplan = _state.sent();
                        reelOpen = false;
                        if (tour.addon_hl === 0 || tour.addon_hl === 1) reelOpen = true;
                        if (!tour.floorPlansEnabled) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            (0,queries/* getFloorPlans */.lB)(_this.props.tour.id)
                        ];
                    case 5:
                        floorPlans = _state.sent();
                        _this.setState({
                            floorPlans: floorPlans
                        });
                        _state.label = 6;
                    case 6:
                        _tmp1 = (ref = _this.props) === null || ref === void 0 ? void 0 : ref.initialDuplicates;
                        if (_tmp1) return [
                            3,
                            8
                        ];
                        return [
                            4,
                            (0,queries/* getDuplicates */.VB)(tour.parentId || tour.id)
                        ];
                    case 7:
                        _tmp1 = _state.sent();
                        _state.label = 8;
                    case 8:
                        initialDuplicates = _tmp1;
                        if (!tour.reel) return [
                            3,
                            10
                        ];
                        return [
                            4,
                            TreedisPublicDAO/* default.getReels */.Z.getReels(tour.id)
                        ];
                    case 9:
                        reelsRes = _state.sent();
                        _state.label = 10;
                    case 10:
                        duplicates = initialDuplicates.filter(function(d) {
                            return d === null || d === void 0 ? void 0 : d.language;
                        });
                        reels = (reelsRes === null || reelsRes === void 0 ? void 0 : reelsRes.reels) || [];
                        newrestrictedReels = [];
                        reelsRes = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, reelsRes), {
                            reels: tour.ticket === true ? reels.filter(function(r) {
                                if (r.type !== "treedis" || r.url == null) return true;
                                var reelURL = new URL(r.url);
                                var splittedPath = reelURL.pathname.split("/");
                                if (splittedPath[1] === "tour") {
                                    if (Array.isArray(allowedTours) && (0,_to_consumable_array/* default */.Z)(allowedTours).concat([
                                        tour.slug
                                    ]).includes(splittedPath[2])) return true;
                                    newrestrictedReels.push(r);
                                } else return true;
                                return false;
                            }) : reels
                        });
                        _this.setState({
                            duplicates: duplicates,
                            measurements: measurements,
                            dollhouse: dollhouse,
                            floorplan: floorplan,
                            reelOpen: reelOpen,
                            restrictedReels: newrestrictedReels,
                            reels: reelsRes === null || reelsRes === void 0 ? void 0 : reelsRes.reels,
                            reelCategories: reelsRes === null || reelsRes === void 0 ? void 0 : reelsRes.categories,
                            reel: reel
                        }, function() {
                            _this.props.setReelOpen(_this.state.reelOpen);
                            if (tour.addon_hl === 0) {
                                _this.videoInitTimeout = setTimeout(function() {
                                    _this.props.setReelOpen(false);
                                }, 4000);
                            }
                            _this.videoInit();
                        });
                        return [
                            2
                        ];
                }
            });
        })();
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var ref, ref1, ref2, _props, mainPlaying, otherPlaying, changeReel, tour, reel, threads, threadsLoaded, ref3, mpReel, reelsRes, minimap, tourHasAReel;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _props = _this.props, mainPlaying = _props.mainPlaying, otherPlaying = _props.otherPlaying, changeReel = _props.changeReel, tour = _props.tour, reel = _props.reel, threads = _props.threads, threadsLoaded = _props.threadsLoaded;
                        if (tour.isThreadsEnabled && threadsLoaded && (!prevProps.threadsLoaded || !isEqual_default()(prevProps.threads, threads))) {
                            _this.setState({
                                chatNotifications: (threads === null || threads === void 0 ? void 0 : threads.unreadCount) || 0,
                                newMessagesCount: (threads === null || threads === void 0 ? void 0 : threads.newMessagesCount) || 0
                            });
                            if (tour.id !== _this.state.tour.id) {
                                // eslint-disable-next-line react/no-did-update-set-state
                                _this.setState({
                                    tour: tour
                                });
                            }
                        }
                        if (!changeReel) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            _this.props.showcase.Tour.getData().catch(function() {
                                return [];
                            })
                        ];
                    case 1:
                        mpReel = _state.sent();
                        return [
                            4,
                            TreedisPublicDAO/* default.getReels */.Z.getReels(tour.id)
                        ];
                    case 2:
                        reelsRes = _state.sent();
                        if ((reelsRes === null || reelsRes === void 0 ? void 0 : (ref3 = reelsRes.reels) === null || ref3 === void 0 ? void 0 : ref3.length) && tour.reel && !isEqual_default()(reelsRes === null || reelsRes === void 0 ? void 0 : reelsRes.reels, _this.state.reels)) {
                            // eslint-disable-next-line react/no-did-update-set-state
                            _this.setState({
                                reels: reelsRes === null || reelsRes === void 0 ? void 0 : reelsRes.reels
                            });
                        } else if (!tour.reel && !isEqual_default()(mpReel, _this.state.reels)) {
                            // eslint-disable-next-line react/no-did-update-set-state
                            _this.setState({
                                reels: mpReel,
                                reel: []
                            });
                        }
                        if (tour.id !== _this.state.tour.id) {
                            // eslint-disable-next-line react/no-did-update-set-state
                            _this.setState({
                                tour: tour
                            });
                        }
                        _state.label = 3;
                    case 3:
                        if (prevState.tour.mpReel && reel.length !== prevState.reel.length) {
                            // eslint-disable-next-line react/no-did-update-set-state
                            _this.setState({
                                reel: reel
                            });
                        }
                        if (prevProps.mainPlaying !== mainPlaying || prevProps.otherPlaying !== otherPlaying) {
                            if (mainPlaying || otherPlaying) {
                                // eslint-disable-next-line react/no-did-update-set-state
                                _this.setState({
                                    youtubeOn: false
                                });
                                _this.props.setTourMusicState(mainPlaying);
                            }
                        }
                        minimap = document.getElementById("minimap");
                        tourHasAReel = _this.state.tour.reel || _this.state.tour.mpReel;
                        if (tourHasAReel && minimap && prevState.reelOpen !== _this.props.reelOpen) {
                            if (_this.props.reelOpen) {
                                minimap.classList.add("reel-open");
                            } else minimap.classList.remove("reel-open");
                        }
                        if (!_this.state.showVideoReel && !prevState.reelVideos && ((ref = _this.props.reelVideos) === null || ref === void 0 ? void 0 : ref.length) > 1 || !_this.state.showVideoReel && prevState.reelVideos && prevState.reelVideos.length !== ((ref1 = _this.props.reelVideos) === null || ref1 === void 0 ? void 0 : ref1.length)) {
                            _this.props.setReelOpen(true);
                            // eslint-disable-next-line react/no-did-update-set-state
                            _this.setState({
                                reelVideos: _this.props.reelVideos,
                                showVideoReel: true
                            });
                            if (_this.videoInitTimeout) {
                                clearTimeout(_this.videoInitTimeout);
                            }
                        }
                        if (_this.state.showVideoReel && _this.props.reelOpen && ((ref2 = _this.props.reelVideos) === null || ref2 === void 0 ? void 0 : ref2.length) === 0) {
                            // eslint-disable-next-line react/no-did-update-set-state
                            _this.setState({
                                showVideoReel: false,
                                reelVideos: []
                            });
                        }
                        return [
                            2
                        ];
                }
            });
        })();
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        document.removeEventListener("touchstart", this.videoEventListener);
        document.removeEventListener("click", this.videoEventListener);
        clearInterval(this.videoInitTimeout);
    };
    _proto.render = function render() {
        var _this = this;
        var ref, ref1, ref2;
        var _state = this.state, showActionsModal = _state.showActionsModal, showFloorsModal = _state.showFloorsModal, showLanguagesModal = _state.showLanguagesModal, floorPlans = _state.floorPlans, minimapVisible = _state.minimapVisible, dollhouse = _state.dollhouse, floorplan = _state.floorplan, measurements = _state.measurements, tour = _state.tour, duplicates = _state.duplicates, reels = _state.reels, reel = _state.reel, reelCategories = _state.reelCategories, restrictedReels = _state.restrictedReels, showVideoReel = _state.showVideoReel, audioMute = _state.audioMute, defurnishOn = _state.defurnishOn;
        var _props = this.props, mainPlaying = _props.mainPlaying, reelStep = _props.reelStep, onHelpClick = _props.onHelpClick, onTermsClick = _props.onTermsClick, openShare = _props.openShare, changeFull = _props.changeFull, moveToStep = _props.moveToStep, tourPlaying = _props.tourPlaying, sharePopupOn = _props.sharePopupOn, changeViewMode = _props.changeViewMode, measurementsMode = _props.measurementsMode, showPanorama = _props.showPanorama, showMinimapClick = _props.showMinimapClick, showPanoramaClick = _props.showPanoramaClick, loadModel = _props.loadModel, playTour = _props.playTour, measurementsOn = _props.measurementsOn, panoramaOn = _props.panoramaOn, whitelabel = _props.whitelabel, translation = _props.translation, vsObjects = _props.vsObjects, toggleVS = _props.toggleVS, openVR = _props.openVR, currentFloor = _props.currentFloor, isVSEnabled = _props.isVSEnabled, showTicketRestrictedAreaPopup = _props.showTicketRestrictedAreaPopup, mpFloors = _props.mpFloors, host = _props.host, onMuteClick = _props.onMuteClick, onFullscreenClick = _props.onFullscreenClick, toggleSketchfabPopup = _props.toggleSketchfabPopup, onPinClick = _props.onPinClick, activeSweepGroup = _props.activeSweepGroup, hideForWhile = _props.hideForWhile, tourMode = _props.tourMode, room = _props.room, isAudioControlEnabled = _props.isAudioControlEnabled, threadsLoaded = _props.threadsLoaded, flowIsActive = _props.flowIsActive;
        var hasVideos = Boolean((ref = this.props.reelVideos) === null || ref === void 0 ? void 0 : ref.length);
        var reelOpen = (showVideoReel || this.props.reelOpen && !measurementsOn && (reel && reel.length > 0 && tour.mpReel || tour && tour.reel && reels.length > 0)) && !flowIsActive;
        var hasReelCategories = tour.reel && reelOpen && (reelCategories === null || reelCategories === void 0 ? void 0 : reelCategories.length) > 0;
        var isHasFloorMusic = (ref1 = tour.musics) === null || ref1 === void 0 ? void 0 : ref1.find(function(item) {
            return item.floor === currentFloor;
        });
        var audioHandler = AudioModule/* AudioModule.getInstance */.w0.getInstance();
        var showMore = floorPlans.length > 0 || tour.droneUrl || tour.videoUrl || tour.screenshotEnabled && !panoramaOn || tour.music || isHasFloorMusic;
        // hide the copyright button if sketchfab models are present
        var hasSFModels = vsObjects.some(function(item) {
            var ref;
            return (0,_instanceof/* default */.Z)(item, VSObject/* TourObject */.zB) && (item === null || item === void 0 ? void 0 : (ref = item.details) === null || ref === void 0 ? void 0 : ref.copyright);
        });
        var showReelIcon = (tour.reel || this.props.reel && this.props.reel.length > 0 && tour.mpReel) && !flowIsActive;
        var showPlayIcon = tour.mpPlay && this.props.reel && this.props.reel.length > 0;
        var showDefurnishIcon = this.props.defurnishEnabled;
        var showFloorsIcon = mpFloors && mpFloors.length > 1 && tour.addon_f === true;
        var showVSIcon = tour.enableVS && (vsObjects === null || vsObjects === void 0 ? void 0 : vsObjects.length) > 0 && !flowIsActive;
        var showPanoIcon = showPanorama && tour.id !== 4450 && !flowIsActive;
        var showLangIcon = duplicates.length > 1;
        var iconsEnabled = [
            showReelIcon,
            showPlayIcon,
            dollhouse,
            floorplan,
            measurements,
            showFloorsIcon,
            showVSIcon,
            tour.minimap,
            showPanoIcon,
            showLangIcon,
            hasVideos
        ];
        var smallIconsEnabled = iconsEnabled.filter(Boolean).length > 4 && deviceManager/* default.isMobile */.Z.isMobile();
        var showChatIcon = tour.textChatEnabled && !room;
        var volumeButtonComponent = (audioHandler === null || audioHandler === void 0 ? void 0 : audioHandler.tourHasAudio()) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TourVolume, {
            mute: audioMute,
            setMute: function(m) {
                return _this.setState({
                    audioMute: m
                });
            }
        }) : null;
        var ref3, _sequence;
        var _this1 = this;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    id: "bottom-bar",
                    className: classnames_default()({
                        open: reelOpen,
                        smallIcons: smallIconsEnabled,
                        hide: hideForWhile
                    }),
                    children: [
                        showMore && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: classnames_default()("more-bar", {
                                categoriesOn: hasReelCategories
                            }),
                            children: [
                                !showActionsModal && volumeButtonComponent,
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "data-balloon",
                                    "data-balloon": translation && translation.moreTooltip,
                                    "data-balloon-pos": "right",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        className: showActionsModal ? "more-btn btn active" : "more-btn btn",
                                        onClick: function() {
                                            _this.setState({
                                                showActionsModal: !showActionsModal
                                            });
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                            className: "fas fa-ellipsis-h"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: classnames_default()("action-icons left more", {
                                        active: showActionsModal
                                    }),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            id: "more-menu",
                                            className: "more-menu",
                                            children: [
                                                volumeButtonComponent,
                                                (tour.music || isHasFloorMusic) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "data-balloon",
                                                    "data-balloon": translation && translation.musicTooltip,
                                                    "data-balloon-pos": "right",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: classnames_default()("action-icon music", mainPlaying && "active", !isAudioControlEnabled && "disabled-control"),
                                                        onClick: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                                                            return (0,tslib_es6.__generator)(this, function(_state) {
                                                                switch(_state.label){
                                                                    case 0:
                                                                        return [
                                                                            4,
                                                                            _this1.props.handleToggleMusic()
                                                                        ];
                                                                    case 1:
                                                                        _state.sent();
                                                                        _this1.props.setTourMusicState(!audioHandler.isTourMusicPaused());
                                                                        if (!_this1.props.tourAudioPlaying) {
                                                                            _this1.setState({
                                                                                musicPausedByUser: true
                                                                            });
                                                                        } else {
                                                                            _this1.setState({
                                                                                musicPausedByUser: false
                                                                            });
                                                                        }
                                                                        return [
                                                                            2
                                                                        ];
                                                                }
                                                            });
                                                        }),
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                className: classnames_default()("fas music-status fa-music")
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                className: this.props.tourAudioPlaying ? "fas fa-pause" : "fas fa-play"
                                                            })
                                                        ]
                                                    })
                                                }),
                                                tour.droneUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "data-balloon",
                                                    "data-balloon": translation && translation.droneViewTooltip,
                                                    "data-balloon-pos": "right",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "action-icon drone",
                                                        onClick: this.props.toggleExternalPopup.bind(this, tour.droneUrl),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                            className: "fad fa-drone"
                                                        })
                                                    })
                                                }),
                                                tour.screenshotEnabled && !panoramaOn && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "data-balloon",
                                                    "data-balloon": translation && translation.screenshotTooltip,
                                                    "data-balloon-pos": "right",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: this.state.cameraList ? "action-icon screenshot active" : "action-icon screenshot",
                                                        onClick: function() {
                                                            _this.setState({
                                                                cameraList: !_this.state.cameraList,
                                                                pdfList: false,
                                                                youtubeOn: false
                                                            });
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                            className: "fas fa-camera"
                                                        })
                                                    })
                                                }),
                                                floorPlans.length === 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "data-balloon",
                                                    "data-balloon": translation && translation.floorPlansTooltip,
                                                    "data-balloon-pos": "right",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        id: "pdf-list",
                                                        className: "action-icon floors",
                                                        onClick: function() {
                                                            return (0,util_all/* downloadFloorPlan */.fg)("".concat("https://cdn.treedis.com", "/tours/").concat(tour.id, "/floorplans/").concat(floorPlans[0].url), floorPlans[0]);
                                                        },
                                                        target: "_blank",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                            className: "fas fa-file-pdf"
                                                        })
                                                    })
                                                }),
                                                floorPlans.length > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "data-balloon",
                                                    "data-balloon": translation && translation.floorPlansTooltip,
                                                    "data-balloon-pos": "right",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: this.state.pdfList ? "action-icon floors active" : "action-icon floors",
                                                        onClick: function() {
                                                            _this.setState({
                                                                pdfList: !_this.state.pdfList,
                                                                youtubeOn: false,
                                                                cameraList: false
                                                            });
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                            className: "fas fa-file-pdf"
                                                        })
                                                    })
                                                }),
                                                tour.videoUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "data-balloon",
                                                    "data-balloon": translation && translation.videoTooltip,
                                                    "data-balloon-pos": "right",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: this.state.youtubeOn ? "action-icon video active" : "action-icon video",
                                                        onClick: function() {
                                                            if (!_this.state.youtubeOn) {
                                                                _this.props.onStartVideo();
                                                            } else {
                                                                _this.props.onStopVideo();
                                                            }
                                                            _this.setState({
                                                                youtubeOn: !_this.state.youtubeOn,
                                                                pdfList: false,
                                                                cameraList: false
                                                            });
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                            className: "fas fa-video"
                                                        })
                                                    })
                                                })
                                            ]
                                        }),
                                        this.state.cameraList && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "pdf-list wide",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    onClick: this.props.takeScreenshot.bind(this, {
                                                        width: 4096,
                                                        height: 3072
                                                    }),
                                                    children: "4:3 @ 4096x3072 (High)"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    onClick: this.props.takeScreenshot.bind(this, {
                                                        width: 1920,
                                                        height: 1440
                                                    }),
                                                    children: "4:3 @ 1920x1440 (Medium)"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    onClick: this.props.takeScreenshot.bind(this, {
                                                        width: 1280,
                                                        height: 960
                                                    }),
                                                    children: "4:3 @ 1280x960 (Web)"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    onClick: this.props.takeScreenshot.bind(this, {
                                                        width: 1024,
                                                        height: 768
                                                    }),
                                                    children: "4:3 @ 1024x768 (MLS)"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    onClick: this.props.takeScreenshot.bind(this, {
                                                        width: 4096,
                                                        height: 2034
                                                    }),
                                                    children: "16:9 @ 4096x2304 (Wide/HQ)"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    onClick: this.props.takeScreenshot.bind(this, {
                                                        width: 3840,
                                                        height: 2160
                                                    }),
                                                    children: "16:9 @ 3840x2160 (Wide/4K)"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    onClick: this.props.takeScreenshot.bind(this, {
                                                        width: 1920,
                                                        height: 1080
                                                    }),
                                                    children: "16:9 @ 1920x1080 (Wide/1080p)"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    onClick: this.props.takeScreenshot.bind(this, {
                                                        width: 1280,
                                                        height: 720
                                                    }),
                                                    children: "16:9 @ 1280x720 (Wide/720p)"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    onClick: this.props.takeScreenshot.bind(this, {
                                                        width: 1024,
                                                        height: 576
                                                    }),
                                                    children: "16:9 @ 1024x576 (MLS)"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    onClick: this.props.takePano.bind(this),
                                                    children: "Pano @ 4096x2048"
                                                })
                                            ]
                                        }),
                                        this.state.pdfList && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "pdf-list",
                                            children: floorPlans.map(function(plan, i) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    onClick: function() {
                                                        (0,util_all/* downloadFloorPlan */.fg)("".concat("https://cdn.treedis.com", "/tours/").concat(tour.id, "/floorplans/").concat(plan.url), plan);
                                                    },
                                                    className: "pdf_inner_link",
                                                    target: "_blank",
                                                    children: plan.name
                                                }, i);
                                            })
                                        }),
                                        tour.videoUrl && this.state.youtubeOn && /*#__PURE__*/ (0,jsx_runtime.jsxs)(units/* VideoBox.Container */.c6.Container, {
                                            width: tour.videoWidth,
                                            height: tour.videoHeight,
                                            isMobile: deviceManager/* default.isMobile */.Z.isMobile() && !deviceManager/* default.isTablet */.Z.isTablet(),
                                            landscape: deviceManager/* default.isHorizontalMobileView */.Z.isHorizontalMobileView(),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(units/* VideoBox.Icon */.c6.Icon, {
                                                    className: "fas fa-times",
                                                    onClick: function() {
                                                        _this.props.onStopVideo();
                                                        _this.setState({
                                                            youtubeOn: false
                                                        });
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(units/* VideoBox.Iframe */.c6.Iframe, {
                                                    ref: function(elem) {
                                                        _this.videoFrame = elem;
                                                    },
                                                    id: "ytplayer",
                                                    allowFullScreen: true,
                                                    allow: "autoplay; fullscreen",
                                                    src: util_all/* getVideoLink */.rp(tour.videoUrl, {
                                                        mute: tour.noAudioMode || tour.autoplayVideo
                                                    }),
                                                    frameBorder: "0"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: classnames_default()("action-icons right", {
                                categoriesOn: tour.reel && reelOpen && (reelCategories === null || reelCategories === void 0 ? void 0 : reelCategories.length) > 0
                            }),
                            children: [
                                tour.share && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "data-balloon",
                                    "data-balloon": translation && translation.shareTooltip,
                                    "data-balloon-pos": "up",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "action-icon ".concat(sharePopupOn ? "active" : ""),
                                        role: "button",
                                        tabIndex: 0,
                                        onKeyPress: function() {
                                            return null;
                                        },
                                        onClick: openShare,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                            className: "fas fa-share-alt"
                                        })
                                    })
                                }),
                                !deviceManager/* default.isMobile */.Z.isMobile() && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "data-balloon",
                                    "data-balloon": translation && translation.fullScreenTooltip,
                                    "data-balloon-pos": "up",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "action-icon",
                                        onClick: function() {
                                            return changeFull();
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                            className: this.props.isFull ? "fas fa-compress" : "fas fa-expand"
                                        })
                                    })
                                }),
                                !!tour.addon_vr && !navigator.userAgent.includes("Android") && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "data-balloon",
                                    "data-balloon": translation && translation.vrTooltip,
                                    "data-balloon-pos": "up",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "action-icon",
                                        role: "button",
                                        tabIndex: 0,
                                        onClick: openVR,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                            className: "fas fa-vr-cardboard"
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            id: "bottom-bar-help",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    className: classnames_default()("btn", "btn-auto-width"),
                                    onClick: function() {
                                        if (translation && translation.termFile || tour.termsUrl) {
                                            _this.setState({
                                                showTermsIframe: !_this.state.showTermsIframe
                                            });
                                        } else {
                                            onTermsClick();
                                        }
                                    },
                                    children: translation && translation.terms
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    className: "btn",
                                    onClick: onHelpClick,
                                    children: translation && translation.help
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: whitelabel === null || whitelabel === void 0 ? void 0 : whitelabel.website,
                                    rel: "noreferrer",
                                    target: "_blank",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: whitelabel === null || whitelabel === void 0 ? void 0 : whitelabel.logo,
                                        alt: ""
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "https://matterport.com",
                                    rel: "noreferrer",
                                    target: "_blank",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        className: "mp-logo",
                                        src: "/images/matterport.svg",
                                        alt: "matterport"
                                    })
                                }),
                                hasSFModels && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    className: "btn",
                                    onClick: toggleSketchfabPopup(true),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Sketchfab, {
                                        style: {
                                            width: "16px",
                                            height: "16px"
                                        }
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: classnames_default()("actions-bar"),
                            style: {
                                overflow: "visible"
                            },
                            children: [
                                !showMore && volumeButtonComponent,
                                activeSweepGroup && activeSweepGroup.displayTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    className: "active-sg-title mb-2 ml-5",
                                    children: activeSweepGroup.title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    style: {
                                        overflow: "visible"
                                    },
                                    className: classnames_default()("main-icons", {
                                        categoriesOn: tour.reel && reelOpen && (reelCategories === null || reelCategories === void 0 ? void 0 : reelCategories.length) > 0
                                    }),
                                    children: [
                                        showReelIcon && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "data-balloon",
                                            "data-balloon": translation && translation.highlightsTooltip,
                                            "data-balloon-pos": "up",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                className: reelOpen ? "actions-btn btn active reel" : "actions-btn btn reel",
                                                onClick: this.handleReelOpen,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                    className: "fas fa-angle-up"
                                                })
                                            })
                                        }),
                                        showPlayIcon && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "data-balloon",
                                            "data-balloon": translation && translation.playTourTooltip,
                                            "data-balloon-pos": "up",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                className: tourPlaying ? "btn active" : "btn",
                                                onClick: function() {
                                                    playTour();
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                    className: tourPlaying ? "fas fa-pause-circle" : "fas fa-play-circle"
                                                })
                                            })
                                        }),
                                        (dollhouse || floorplan) && (tourMode === Tour/* TourMode.DOLLHOUSE */.zz.DOLLHOUSE || tourMode === Tour/* TourMode.FLOORPLAN */.zz.FLOORPLAN) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "data-balloon",
                                            "data-balloon": translation && translation.backInsideTooltip,
                                            "data-balloon-pos": "up",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                className: "btn",
                                                onClick: function() {
                                                    return changeViewMode(Tour/* TourMode.INSIDE */.zz.INSIDE);
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                    className: "fas fa-walking"
                                                })
                                            })
                                        }),
                                        dollhouse && !tour.navigationWebEnabled && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "data-balloon",
                                            "data-balloon": translation && translation.dollhouseTooltip,
                                            "data-balloon-pos": "up",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                className: "btn",
                                                onClick: function() {
                                                    return changeViewMode(Tour/* TourMode.DOLLHOUSE */.zz.DOLLHOUSE);
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                    className: "mp-dollhouse"
                                                })
                                            })
                                        }),
                                        floorplan && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "data-balloon",
                                            "data-balloon": translation && translation.floorPlanTooltip,
                                            "data-balloon-pos": "up",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                className: "btn",
                                                onClick: function() {
                                                    return changeViewMode(Tour/* TourMode.FLOORPLAN */.zz.FLOORPLAN);
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                    className: "mp-floorplan"
                                                })
                                            })
                                        }),
                                        measurements && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "data-balloon",
                                            "data-balloon": translation && translation.measurementsTooltip,
                                            "data-balloon-pos": "up",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                className: "btn",
                                                onClick: function() {
                                                    if (panoramaOn) showPanoramaClick();
                                                    measurementsMode();
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                    className: "fas fa-ruler"
                                                })
                                            })
                                        }),
                                        showDefurnishIcon && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "data-balloon",
                                            "data-balloon": translation && translation.defurnishTooltip,
                                            "data-balloon-pos": "up",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                className: defurnishOn ? "btn active" : "btn",
                                                onClick: function() {
                                                    _this.defurnish();
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                    className: "fas fa-couch"
                                                })
                                            })
                                        }),
                                        showFloorsIcon && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "data-balloon",
                                            style: {
                                                overflow: "visible"
                                            },
                                            "data-balloon": translation && translation.floorsTooltip,
                                            "data-balloon-pos": "up",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                    className: "btn",
                                                    onClick: function() {
                                                        _this.setState({
                                                            showFloorsModal: !showFloorsModal
                                                        });
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                        className: "fas fa-layer-group"
                                                    })
                                                }),
                                                showFloorsModal && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "floors-modal",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                onClick: function() {
                                                                    return _this.changeFloor(0, true);
                                                                },
                                                                children: (translation === null || translation === void 0 ? void 0 : translation.floorAll) || "All"
                                                            }),
                                                            mpFloors.map(function(floor) {
                                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                    className: ((ref3 = _this.props.currentFloor === floor.sequence) !== null && ref3 !== void 0 ? ref3 : floor.id) ? "active" : "",
                                                                    onClick: function() {
                                                                        return _this.changeFloor((_sequence = floor.sequence) !== null && _sequence !== void 0 ? _sequence : floor.id);
                                                                    },
                                                                    children: floor.name
                                                                }, "".concat(floor.id, "-").concat(floor.name));
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        }),
                                        showVSIcon && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "data-balloon",
                                            "data-balloon": translation && translation.hideVSTooltip,
                                            "data-balloon-pos": "up",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                className: classnames_default()("btn", isVSEnabled && "active"),
                                                onClick: toggleVS,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                    className: "fas fa-cube"
                                                })
                                            })
                                        }),
                                        tour.minimap && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "data-balloon",
                                            "data-balloon": translation && translation.minimapTooltip,
                                            "data-balloon-pos": "up",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                className: minimapVisible ? "btn active" : "btn",
                                                onClick: function() {
                                                    _this.setState({
                                                        minimapVisible: !minimapVisible
                                                    });
                                                    showMinimapClick();
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                    className: "fas fa-map-marked"
                                                })
                                            })
                                        }),
                                        showPanoIcon && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "data-balloon",
                                            "data-balloon": translation && translation.panoramaTooltip,
                                            "data-balloon-pos": "up",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                className: panoramaOn ? "btn active" : "btn",
                                                onClick: showPanoramaClick,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    className: "panorama-icon",
                                                    src: "/images/panorama.png",
                                                    alt: "panorama"
                                                })
                                            })
                                        }),
                                        showLangIcon && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "data-balloon",
                                            "data-balloon": translation && translation.languagesTooltip,
                                            "data-balloon-pos": "up",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                    className: "btn",
                                                    onClick: function() {
                                                        _this.setState({
                                                            showLanguagesModal: !showLanguagesModal
                                                        });
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                        className: "fas fa-language"
                                                    })
                                                }),
                                                showLanguagesModal && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "languages-modal",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                        children: duplicates.map(function(duplicate) {
                                                            /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                                                                className: tour.id === duplicate.id ? "active" : "",
                                                                onClick: function() {
                                                                    return _this.setState({
                                                                        showLanguagesModal: false
                                                                    });
                                                                },
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                    href: "/tour/".concat(duplicate.slug),
                                                                    children: _this.capitalizeFirstLetter(duplicate === null || duplicate === void 0 ? void 0 : duplicate.language)
                                                                })
                                                            }, duplicate.slug);
                                                        })
                                                    })
                                                })
                                            ]
                                        }),
                                        hasVideos && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "data-balloon",
                                            "data-balloon": translation && translation.participantsTooltip,
                                            "data-balloon-pos": "up",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                className: classnames_default()("btn participant", showVideoReel && "active"),
                                                style: showVideoReel ? {
                                                    backgroundColor: "var(--color-secondary)"
                                                } : undefined,
                                                onClick: function() {
                                                    if (!showVideoReel) {
                                                        _this.props.setReelOpen(true);
                                                        _this.setState({
                                                            showVideoReel: true
                                                        });
                                                    } else {
                                                        _this.props.setReelOpen(false);
                                                        _this.setState({
                                                            showVideoReel: false
                                                        });
                                                    }
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                    className: "fas fa-users"
                                                })
                                            })
                                        }),
                                        tour.isThreadsEnabled && !room && !flowIsActive && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledNoteBadge, {
                                            badgeContent: this.state.newMessagesCount,
                                            variant: "dot",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "data-balloon",
                                                "data-balloon": "Notes",
                                                "data-balloon-pos": "up",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                    className: "btn",
                                                    onClick: function() {
                                                        _this.props.toggleThreadsDrawer();
                                                        _this.setState({
                                                            newMessagesCount: 0
                                                        });
                                                    },
                                                    disabled: !threadsLoaded,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                        className: "fa-solid fa-comment"
                                                    })
                                                })
                                            })
                                        }),
                                        showChatIcon && /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge/* default */.Z, {
                                            badgeContent: this.state.chatOpen ? 0 : this.state.chatNotifications,
                                            color: "primary",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "data-balloon",
                                                "data-balloon": translation.chatTooltip || "Chat",
                                                "data-balloon-pos": "up",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                    className: "btn",
                                                    onClick: this.toggleChatClick,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                        className: "fas fa-comments"
                                                    })
                                                })
                                            })
                                        })
                                    ]
                                }),
                                tour.reel && reelOpen && !showVideoReel && (reelCategories === null || reelCategories === void 0 ? void 0 : reelCategories.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    id: "reel-categories",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "scroll-div d-flex",
                                        children: reelCategories.map(function(c, i) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: _this.state.activeCategory === c.id ? "active" : "",
                                                onClick: _this.filterReel.bind(_this, c.id),
                                                children: c.title
                                            }, i);
                                        })
                                    })
                                })
                            ]
                        }),
                        tour.mpReel && reel && reel.length > 0 && !tour.reel && !showVideoReel && /*#__PURE__*/ (0,jsx_runtime.jsx)(Reel/* default */.Z, {
                            reel: reel,
                            reelStep: reelStep,
                            move: moveToStep
                        }),
                        tour.reel && !showVideoReel && !!reels.length && /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomReel/* default */.Z, {
                            reel: reels,
                            tourId: tour.id,
                            loadModel: loadModel,
                            restrictedReels: restrictedReels,
                            showTicketRestrictedAreaPopup: showTicketRestrictedAreaPopup,
                            onTicketingReel: this.props.onTicketingReel
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MReelVideoBar, {
                            show: showVideoReel && hasVideos,
                            host: host,
                            videos: this.props.reelVideos,
                            onMuteClick: onMuteClick,
                            onFullscreenClick: onFullscreenClick,
                            onPinClick: onPinClick,
                            audioOnly: this.props.audioOnly
                        }),
                        tour.isThreadsEnabled && !room && threadsLoaded && !flowIsActive && /*#__PURE__*/ (0,jsx_runtime.jsx)(Threads, {
                            isOpen: this.props.isThreadsDrawerOpen,
                            selectedThreadProp: this.props.selectedThread,
                            closeDrawer: function() {
                                _this.props.closeThreadsDrawer();
                            },
                            openDrawer: function() {
                                _this.props.openThreadsDrawer();
                            },
                            showCaseTemp: this.props.showCaseTemp,
                            showcaseTag: this.props.showcaseTag,
                            tour: tour,
                            iframe: this.props.iframe,
                            initialThreads: this.props.threads,
                            appState: this.props.appState,
                            addThreadToSpace: this.props.addThreadToSpace,
                            showcase: this.props.showcase,
                            incrementNewMessagesCount: this.incrementNewMessagesCount,
                            decrementNewMessagesCount: this.decrementNewMessagesCount,
                            resetNewMessagesCount: this.resetNewMessagesCount,
                            removeThreadFromSpace: this.props.removeThreadFromSpace,
                            toggleThreadVisibility: this.props.toggleThreadVisibility,
                            hideElements: this.props.hideElements,
                            moveToTag: this.props.moveToTagIO,
                            getLocation: this.props.getShareLocation,
                            isRtl: (ref2 = tour.client) === null || ref2 === void 0 ? void 0 : ref2.rtl
                        }),
                        this.state.chatOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(AvatarChat, {
                            chatOpen: this.state.chatOpen,
                            toggleChatClick: this.toggleChatClick,
                            setNotifications: this.setChatNotifications,
                            avatar: this.props.avatar
                        })
                    ]
                }),
                this.state.showTermsIframe && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* TermsDialog */.wW, {
                    open: this.state.showTermsIframe,
                    onClose: function() {
                        return _this.setState({
                            showTermsIframe: false
                        });
                    },
                    logo: whitelabel === null || whitelabel === void 0 ? void 0 : whitelabel.logo,
                    url: tour.termsUrl || "".concat("https://cdn.treedis.com", "/tours/").concat(tour.id, "/termFile.pdf").concat((0,util_all/* getVersion */.bo)(new Date()))
                })
            ]
        });
    };
    return BottomBar;
}(react.Component);


;// CONCATENATED MODULE: ./components/tour/regular/bottomBar/BottomBar/styles.ts

function BottomBar_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 14px;\n  position: absolute;\n  bottom: 0;\n  left: 50%;\n  background-color: #fff;\n  color: #222;\n  padding: 0 20px;\n  border-radius: 12px;\n  cursor: pointer;\n  z-index: 9999999;\n  opacity: 0.8;\n  transform: translateX(-50%);\n\n  &:hover {\n    opacity: 1;\n  }\n"
    ]);
    BottomBar_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var HintButton = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__HintButton",
    componentId: "sc-9884ac92-0"
})(BottomBar_styles_templateObject());

;// CONCATENATED MODULE: ./components/tour/regular/bottomBar/BottomBarWithRecoil.tsx









var BottomBarWithRecoil = function(props) {
    var ref = (0,_sliced_to_array/* default */.Z)((0,recoil/* useRecoilState */.FV)(store/* bottomBarOpenState */.DF), 2), bbIsOpen = ref[0], setBbIsOpen = ref[1];
    var condition = window.innerWidth < 1024 && props.measurements;
    var ref1 = (0,react.useState)(!condition), showBottomBar = ref1[0], setShowBottomBar = ref1[1];
    var ref2 = (0,react.useState)(condition), showHintButton = ref2[0], setShowHintButton = ref2[1];
    (0,react.useEffect)(function() {
        var handleResize = function() {
            if (window.innerWidth < 1024 && props.measurementsOn) {
                setShowBottomBar(false);
                setShowHintButton(true);
            } else {
                setShowBottomBar(true);
                setShowHintButton(false);
            }
        };
        window.addEventListener("resize", handleResize);
        handleResize();
        return function() {
            return window.removeEventListener("resize", handleResize);
        };
    }, [
        props.measurementsOn
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            showHintButton && /*#__PURE__*/ (0,jsx_runtime.jsx)(HintButton, {
                onClick: function() {
                    return setShowBottomBar(!showBottomBar);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                    className: "fas ".concat(showBottomBar ? "fa-angle-down" : "fa-angle-up")
                })
            }),
            showBottomBar && /*#__PURE__*/ (0,jsx_runtime.jsx)(BottomBar, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                reelOpen: bbIsOpen,
                setReelOpen: setBbIsOpen
            }))
        ]
    });
};
/* harmony default export */ var bottomBar_BottomBarWithRecoil = (BottomBarWithRecoil);

// EXTERNAL MODULE: ./components/tour/regular/ad-redesigned/AdRedesigned.tsx
var AdRedesigned = __webpack_require__(2520);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/DialogContentText/DialogContentText.js + 1 modules
var DialogContentText = __webpack_require__(44642);
;// CONCATENATED MODULE: ./components/tour/regular/confirm-dialog/ConfirmDialog.tsx




function ConfirmDialog(props) {
    var open = props.open, title = props.title, desc = props.desc, showInput = props.showInput, onCancel = props.onCancel, onAgree = props.onAgree;
    var inputRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(false), clicked = ref[0], setClicked = ref[1];
    var ref1 = (0,react.useState)(false), showPassword = ref1[0], setShowPassword = ref1[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dialog/* default */.Z, {
        fullWidth: true,
        open: open,
        sx: {
            "& .MuiDialog-paper": {
                maxWidth: "350px",
                borderRadius: "13px"
            }
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DialogContent/* default */.Z, {
                dividers: true,
                sx: {
                    p: 3,
                    border: "none",
                    position: "relative"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                    spacing: 2,
                    sx: {
                        textAlign: "center"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            width: "100%",
                            textAlign: "center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                width: "40",
                                height: "39",
                                viewBox: "0 0 40 39",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                        x: "0.5",
                                        width: "39",
                                        height: "39",
                                        rx: "7.8",
                                        fill: "#F0A20A"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        d: "M21.5901 13.5908L21.2946 21.5908H18.7037L18.4083 13.5908H21.5901ZM19.9992 25.409C19.5598 25.409 19.1829 25.2556 18.8685 24.9488C18.5579 24.6382 18.4045 24.2613 18.4083 23.8181C18.4045 23.3863 18.5579 23.017 18.8685 22.7101C19.1829 22.4033 19.5598 22.2499 19.9992 22.2499C20.4158 22.2499 20.7833 22.4033 21.1015 22.7101C21.4234 23.017 21.5863 23.3863 21.5901 23.8181C21.5863 24.1135 21.5087 24.3825 21.3571 24.6249C21.2094 24.8635 21.0162 25.0548 20.7776 25.1988C20.539 25.3389 20.2795 25.409 19.9992 25.409Z",
                                        fill: "white"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(DialogContentText/* default */.Z, {
                            component: Box/* default */.Z,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    variant: "h6",
                                    gutterBottom: true,
                                    sx: {
                                        color: "#fff"
                                    },
                                    children: title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    sx: {
                                        color: "#fff"
                                    },
                                    children: (0,html_react_parser/* default */.ZP)(desc || "")
                                })
                            ]
                        }),
                        showInput && /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                            inputRef: inputRef,
                            fullWidth: true,
                            type: showPassword ? "text" : "password",
                            label: "Password",
                            autoComplete: "current-password",
                            sx: {
                                "& .MuiFormLabel-root": {
                                    lineHeight: "normal"
                                },
                                "& .MuiInputBase-root": {
                                    height: "50px",
                                    color: "white"
                                },
                                "& label.Mui-focused": {
                                    color: "white"
                                }
                            },
                            onKeyDown: function(e) {
                                if (e.key === "Enter") {
                                    var ref;
                                    onAgree((ref = inputRef.current) === null || ref === void 0 ? void 0 : ref.value);
                                }
                            },
                            InputProps: {
                                endAdornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                    onClick: function() {
                                        return setShowPassword(function(prev) {
                                            return !prev;
                                        });
                                    },
                                    sx: {
                                        color: "white",
                                        fontSize: "16px"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        className: showPassword ? "fas fa-eye" : "fas fa-eye-slash"
                                    })
                                })
                            }
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DialogActions/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                    direction: "row",
                    spacing: 2,
                    width: "100%",
                    paddingX: 2,
                    paddingBottom: 2,
                    justifyContent: "center",
                    children: [
                        onCancel && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                            fullWidth: true,
                            disabled: clicked,
                            variant: "outlined",
                            color: "info",
                            onClick: onCancel,
                            sx: {
                                height: "46px",
                                color: "#fff",
                                borderColor: "#fff",
                                "&:hover": {
                                    borderColor: "#fff"
                                }
                            },
                            children: "Cancel"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                            fullWidth: true,
                            disabled: clicked,
                            variant: "contained",
                            color: "info",
                            onClick: function() {
                                var ref;
                                setClicked(true);
                                onAgree((ref = inputRef.current) === null || ref === void 0 ? void 0 : ref.value);
                            },
                            autoFocus: true,
                            sx: {
                                height: "46px",
                                color: "#000",
                                background: "#fff",
                                transition: "all 0.3s ease",
                                "&:hover": {
                                    opacity: 0.8,
                                    background: "#fff"
                                }
                            },
                            children: "Confirm"
                        })
                    ]
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./utils/isImage.ts
function isImage(url) {
    return new Promise(function(resolve) {
        var img = new Image();
        img.onload = function() {
            return resolve(true);
        };
        img.onerror = function() {
            return resolve(false);
        };
        img.src = url;
    });
}

;// CONCATENATED MODULE: ./components/tour/regular/custom-button/CustomButton.tsx






function CustomButton(param) {
    var onClick = param.onClick, tourId = param.tourId, customButtonIcon = param.customButtonIcon;
    var ref = (0,react.useState)(), buttonUrl = ref[0], setButtonUrl = ref[1];
    (0,react.useEffect)(function() {
        (0,_async_to_generator/* default */.Z)(function() {
            var url, isValidImage;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        url = "".concat("https://cdn.treedis.com", "/tours/").concat(tourId, "/").concat(customButtonIcon);
                        return [
                            4,
                            isImage(url)
                        ];
                    case 1:
                        isValidImage = _state.sent();
                        if (isValidImage) {
                            setButtonUrl(url);
                        }
                        return [
                            2
                        ];
                }
            });
        })();
    }, [
        customButtonIcon,
        tourId
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
        id: "custom-button",
        sx: {
            borderRadius: "10px 0 0 10px",
            padding: "0",
            transition: "all 0.2s ease-in-out",
            overflow: "hidden",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            color: "white",
            "&:hover": {
                opacity: 0.8,
                transform: "scale(1.1)",
                backgroundColor: "rgba(0, 0, 0, 0.7)"
            }
        },
        onClick: onClick,
        children: customButtonIcon ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            component: "img",
            sx: {
                width: "100%",
                height: "100%",
                objectFit: "cover"
            },
            src: buttonUrl
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
            className: "far fa-crown"
        })
    });
}

// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Chip/Chip.js + 2 modules
var Chip = __webpack_require__(21448);
;// CONCATENATED MODULE: ./components/tour/regular/get-in-touch-button/GetInTouchButton.tsx



function GetInTouchButton(param) {
    var onClick = param.onClick, translation = param.translation, rightOffset = param.rightOffset, tooltipOn = param.tooltipOn;
    var ref = (0,react.useState)(false), hasBeenOpened = ref[0], setHasBeenOpened = ref[1];
    var bgColor = "rgba(0, 0, 0, 0.5)";
    var bgHoverColor = "rgba(0, 0, 0, 0.7)";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
            direction: "row",
            spacing: 2,
            alignItems: "center",
            sx: {
                position: "absolute",
                top: "245px",
                transition: "all 225ms cubic-bezier(0, 0, 0.2, 1) 0ms",
                right: "".concat(rightOffset, "px"),
                zIndex: 1
            },
            children: [
                tooltipOn && !hasBeenOpened && /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
                    sx: {
                        background: bgColor,
                        height: "32px !important",
                        px: 1,
                        "@keyframes pulse": {
                            "0%": {
                                transform: "scale(1)"
                            },
                            "50%": {
                                transform: "scale(1.05)"
                            },
                            "100%": {
                                transform: "scale(1)"
                            }
                        },
                        animation: "pulse 2s infinite"
                    },
                    label: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                        direction: "row",
                        spacing: 1,
                        alignItems: "center",
                        sx: {
                            color: "white"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                sx: {
                                    color: "#ffffff"
                                },
                                children: (translation === null || translation === void 0 ? void 0 : translation.getInTouchAppointmentTooltip) || "Get in touch"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                className: "far fa-circle-arrow-right",
                                style: {
                                    fontSize: "1.2rem"
                                }
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                        sx: {
                            background: bgColor,
                            color: "white",
                            width: "40px",
                            "&:hover": {
                                background: bgHoverColor
                            },
                            borderRadius: "10px 0 0 10px"
                        },
                        onClick: function() {
                            setHasBeenOpened(true);
                            onClick();
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                            className: "fas fa-envelope"
                        })
                    })
                })
            ]
        })
    });
}

// EXTERNAL MODULE: ./node_modules/react-device-detect/dist/lib.js
var dist_lib = __webpack_require__(85518);
;// CONCATENATED MODULE: ./components/tour/regular/menu-wrapper/utils.ts
var getIoT = function(m) {
    var ref, ref1, ref2, ref3, ref4, ref5;
    var settings = {
        alwaysOpen: m === null || m === void 0 ? void 0 : m.alwaysOpen,
        tooltipOn: !(m === null || m === void 0 ? void 0 : m.disableMenuTooltip),
        search: m === null || m === void 0 ? void 0 : m.enableSearchBar,
        categoryExpand: m === null || m === void 0 ? void 0 : m.expandMenuCategories,
        transparent: m === null || m === void 0 ? void 0 : m.enableTransparentBackground,
        fullScreenMobile: m === null || m === void 0 ? void 0 : m.fullScreenMobile,
        openOnLaunch: m === null || m === void 0 ? void 0 : m.openOnLaunch
    };
    var colors = {
        bg: m === null || m === void 0 ? void 0 : (ref = m.colorSettings) === null || ref === void 0 ? void 0 : ref.menuBgColor,
        hover: m === null || m === void 0 ? void 0 : (ref1 = m.colorSettings) === null || ref1 === void 0 ? void 0 : ref1.menuActiveColor,
        text: m === null || m === void 0 ? void 0 : (ref2 = m.colorSettings) === null || ref2 === void 0 ? void 0 : ref2.menuTxtColor,
        open: m === null || m === void 0 ? void 0 : (ref3 = m.colorSettings) === null || ref3 === void 0 ? void 0 : ref3.openedMenuColor,
        search: m === null || m === void 0 ? void 0 : (ref4 = m.colorSettings) === null || ref4 === void 0 ? void 0 : ref4.searchButtonColor,
        scrollbar: m === null || m === void 0 ? void 0 : (ref5 = m.colorSettings) === null || ref5 === void 0 ? void 0 : ref5.scrollbarColor
    };
    return [
        settings,
        colors
    ];
};
var getBM = function(m) {
    var settings = {
        alwaysOpen: m === null || m === void 0 ? void 0 : m.menuAlwaysOpenDesktop,
        tooltipOn: m === null || m === void 0 ? void 0 : m.menuTooltipOn,
        search: m === null || m === void 0 ? void 0 : m.menuSearch,
        categoryExpand: m === null || m === void 0 ? void 0 : m.menuCategoryExpand,
        transparent: m === null || m === void 0 ? void 0 : m.enableTransparentBg,
        fullScreenMobile: m === null || m === void 0 ? void 0 : m.fullScreenMobile,
        openOnLaunch: m === null || m === void 0 ? void 0 : m.menuOnStart
    };
    var colors = {
        bg: m === null || m === void 0 ? void 0 : m.menuBgColor,
        hover: m === null || m === void 0 ? void 0 : m.menuActiveColor,
        text: m === null || m === void 0 ? void 0 : m.menuTxtColor,
        open: m === null || m === void 0 ? void 0 : m.openedMenuColor,
        search: m === null || m === void 0 ? void 0 : m.searchButtonColor,
        scrollbar: m === null || m === void 0 ? void 0 : m.scrollbarColor,
        btnBg: m === null || m === void 0 ? void 0 : m.bookColor,
        btnHover: m === null || m === void 0 ? void 0 : m.bookActiveColor,
        btnText: m === null || m === void 0 ? void 0 : m.bookTxtColor
    };
    return [
        settings,
        colors
    ];
};

;// CONCATENATED MODULE: ./components/tour/regular/menu-wrapper/MenuWrapper.tsx
/* eslint-disable react-hooks/exhaustive-deps */ 










/* EXPLANATION OF THE LOGIC IN THIS COMPONENT
 * This component is a wrapper for BM and IoT menus components from the tour-loader package.
 * Since the menu will overlap most of the popups in the tour (either from Matterport or from Treedis), we need to hide it if it's open and a popup is open and re-show it when the popup is closed. It's not possible to solve this problem with z-indexes. Plus, it's a better UX if the menu is hidden when a popup is open and then re-shown when the popup is closed.
 * To do this, we use MutationObservers to listen for changes in the DOM and check if the menu should be shown or hidden.
 * We have two different MutationObservers, one for Matterport popups and one for Treedis popups.
 * The Matterport MutationObserver is attached to the showcase iframe and listens for changes in the class attribute of the showcase.
 * The Treedis MutationObserver is attached to the .base-tour div and listens for changes in the childList and if the popup is added or removed.
 */ var MP_IFRAME_SELECTOR = ".showcase.showcase";
var TREEDIS_SELECTOR = ".base-tour";
// These are matterport triggers (ex: when a MP Image Tag popup is open)
// Classes
var showcaseTargets = [
    "modal-open",
    "side-panel tool-open",
    "overlay-layer attachment-overlay open",
    "panels panel-open panel-side panel-right"
];
// IDs
var baseTourTargets = [
    "tag-popup",
    "treedis-popup-container",
    "external-popup",
    "vsaction-popup",
    "showcase-modals",
    "contact-pop"
];
function MenuWrapper(props) {
    var ref, ref1;
    var menuSettings = props.menuSettings, iotMenu = props.iotMenu, tour = props.tour, tourEmail = props.tourEmail, iotDevices = props.iotDevices, toggleContactPopup = props.toggleContactPopup, toggleExternalPopup = props.toggleExternalPopup;
    var ref2 = (0,react.useState)(), openType = ref2[0], setOpenType = ref2[1];
    // Needed to keep track of the openType when the menu is closed automatically by MutationObservers
    var openTypeRef = (0,react.useRef)();
    var ref3 = (0,react.useState)(), iotGroups = ref3[0], setIotGroups = ref3[1];
    var ref4 = (0,react.useState)(), iotDevicesTypes = ref4[0], setIotDevicesTypes = ref4[1];
    var ref5 = (0,react.useState)(null), showcaseNode = ref5[0], setShowcaseNode = ref5[1];
    var ref6 = (0,react.useState)(), showcaseTrigger = ref6[0], setShowcaseTrigger = ref6[1];
    var ref7 = (0,react.useState)(), baseTourTrigger = ref7[0], setBaseTourTrigger = ref7[1];
    var ref8 = (0,react.useMemo)(function() {
        return getIoT(iotMenu);
    }, [
        iotMenu
    ]), iotSettings = ref8[0], iotColors = ref8[1];
    var ref9 = (0,react.useMemo)(function() {
        return getBM(menuSettings);
    }, [
        menuSettings
    ]), bmSettings = ref9[0], bmColors = ref9[1];
    var isBM = !openType ? true : openType === dist/* EMenuOpenType.BM */.HT.BM;
    (0,react.useEffect)(function() {
        if (bmSettings.openOnLaunch || bmSettings.alwaysOpen) {
            setOpenType(dist/* EMenuOpenType.BM */.HT.BM);
            props.onOpen();
        } else if ((iotMenu === null || iotMenu === void 0 ? void 0 : iotMenu.active) && ((iotSettings === null || iotSettings === void 0 ? void 0 : iotSettings.openOnLaunch) || (iotSettings === null || iotSettings === void 0 ? void 0 : iotSettings.alwaysOpen))) {
            setOpenType(dist/* EMenuOpenType.IoT */.HT.IoT);
            props.onOpen();
        }
    }, [
        bmSettings.alwaysOpen,
        bmSettings.openOnLaunch,
        iotMenu === null || iotMenu === void 0 ? void 0 : iotMenu.active,
        iotSettings === null || iotSettings === void 0 ? void 0 : iotSettings.alwaysOpen,
        iotSettings === null || iotSettings === void 0 ? void 0 : iotSettings.openOnLaunch
    ]);
    var fetchData = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(apiMethod, cb) {
            var res;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            apiMethod({
                                query: {
                                    tourId: tour.id
                                }
                            })
                        ];
                    case 1:
                        res = _state.sent();
                        if (res) {
                            cb(res);
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function(apiMethod, cb) {
            return _ref.apply(this, arguments);
        };
    }(), [
        tour === null || tour === void 0 ? void 0 : tour.id
    ]);
    (0,react.useEffect)(function() {
        (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(tour === null || tour === void 0 ? void 0 : tour.id) || !iotMenu.active) return [
                            2
                        ];
                        return [
                            4,
                            Promise.all([
                                fetchData(TreedisPublicDAO/* default.getIoTGroups */.Z.getIoTGroups, function(res) {
                                    return setIotGroups(res.groups);
                                }),
                                fetchData(TreedisPublicDAO/* default.getIoTDevicesTypes */.Z.getIoTDevicesTypes, function(res) {
                                    return setIotDevicesTypes(res.data);
                                })
                            ])
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        })();
    }, [
        fetchData,
        iotMenu === null || iotMenu === void 0 ? void 0 : iotMenu.active,
        tour === null || tour === void 0 ? void 0 : tour.id
    ]);
    var shouldObserveMutations = (0,react.useMemo)(function() {
        return props.open || showcaseTrigger || baseTourTrigger;
    }, [
        props.open,
        showcaseTrigger,
        baseTourTrigger
    ]);
    // Get Showcase Iframe Node
    // Since it may take some time for the showcase to load, we need to keep trying to get the showcase iframe until we get it
    (0,react.useEffect)(function() {
        var getShowcaseIframe = function() {
            var retryCount = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
            var node = document.querySelector(MP_IFRAME_SELECTOR);
            if (node) {
                setShowcaseNode(node);
            } else if (retryCount < 10) {
                setTimeout(function() {
                    return getShowcaseIframe(retryCount + 1);
                }, 1000);
            }
        };
        getShowcaseIframe();
    }, []);
    // MP SHOWCASE POPUPS LOGIC TO HIDE BM
    (0,react.useEffect)(function() {
        // Create a new instance of MutationObserver
        var observer = new MutationObserver(function(mutationsList) {
            // If we have a currentShowcaseTrigger, then we should check if the menu should be shown
            if (showcaseTrigger) {
                var shouldShowMenu = mutationsList.some(function(mutation) {
                    return showcaseTrigger === mutation.oldValue;
                });
                if (shouldShowMenu) {
                    setOpenType(openTypeRef.current || dist/* EMenuOpenType.BM */.HT.BM);
                    props.onOpen();
                    setShowcaseTrigger(undefined);
                }
            } else {
                // If we don't have a currentShowcaseTrigger, then we should check if the menu should be hidden
                var shouldHideMenu = mutationsList.some(function(mutation) {
                    // @ts-ignore
                    var target = mutation.target.className;
                    if (showcaseTargets.includes(target)) {
                        setShowcaseTrigger(target);
                        return true;
                    }
                    return false;
                });
                if (shouldHideMenu) {
                    props.onClose();
                    openTypeRef.current = openType;
                }
            }
        });
        // Start observing the target node and its descendants for DOM changes
        if (showcaseNode && showcaseNode.contentDocument && shouldObserveMutations) {
            observer.observe(showcaseNode.contentDocument, {
                attributes: true,
                attributeOldValue: true,
                subtree: true,
                attributeFilter: [
                    "class"
                ]
            });
        } else {
            observer.disconnect();
        }
        return function() {
            // Stop observing when the component unmounts
            observer.disconnect();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        showcaseNode,
        shouldObserveMutations,
        showcaseTrigger
    ]);
    // TREEDIS POPUPS LOGIC TO HIDE BM
    (0,react.useEffect)(function() {
        var node = document.querySelector(TREEDIS_SELECTOR);
        var observer = new MutationObserver(function(mutationsList) {
            // If we have a currentBaseTourTrigger, then we should check if the menu should be shown
            if (baseTourTrigger) {
                // Checking for addedNodes
                // @ts-ignore
                var shouldShowMenu = mutationsList.some(function(mutation) {
                    var ref, ref1;
                    return baseTourTrigger === ((ref = mutation.removedNodes) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.id);
                });
                if (shouldShowMenu) {
                    setOpenType(openTypeRef.current || dist/* EMenuOpenType.BM */.HT.BM);
                    props.onOpen();
                    setBaseTourTrigger(undefined);
                }
            } else {
                // If we don't have a currentBaseTourTrigger, then we should check if the menu should be hidden
                var shouldHideMenu = mutationsList.some(function(mutation) {
                    var ref, ref1;
                    // @ts-ignore
                    var target = (ref = mutation.addedNodes) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.id;
                    // Checking for removedNodes
                    if (baseTourTargets.includes(target)) {
                        setBaseTourTrigger(target);
                        return true;
                    }
                    return false;
                });
                if (shouldHideMenu) {
                    props.onClose();
                    openTypeRef.current = openType;
                }
            }
        });
        if (node && shouldObserveMutations) {
            observer.observe(node, {
                childList: true,
                subtree: true
            });
        } else {
            observer.disconnect();
        }
        return function() {
            observer.disconnect();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        baseTourTrigger,
        props.open,
        shouldObserveMutations
    ]);
    var handleAddressClick = (0,react.useCallback)(function() {
        toggleExternalPopup((tour === null || tour === void 0 ? void 0 : tour.id) === 5238 // Temporary fix for Skoda
         ? "https://www.skoda.co.il/show-rooms" : "https://www.google.com/maps/embed/v1/place?key=AIzaSyAxJYg1iR0WMy4vpFa3zB7E0Dx7lz8h5dk&q=".concat(tour === null || tour === void 0 ? void 0 : tour.address));
        (0,util/* sendToGA */.o$)("event", {
            eventCategory: "Contact",
            eventAction: "click",
            eventLabel: "map"
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        tour === null || tour === void 0 ? void 0 : tour.id,
        tour === null || tour === void 0 ? void 0 : tour.address
    ]);
    var handleOpen = (0,react.useCallback)(function(type) {
        setOpenType(type);
        props.onOpen();
    }, [
        props
    ]);
    var handleClose = (0,react.useCallback)(function() {
        // We need a short delay to avoid a bug where menu height is reduced before the menu is closed
        setTimeout(function() {
            setOpenType(undefined);
        }, 500);
        props.onClose();
    }, [
        props
    ]);
    var alwaysOpen = !dist_lib/* isMobileOnly */.UA && ((iotSettings === null || iotSettings === void 0 ? void 0 : iotSettings.alwaysOpen) || bmSettings.alwaysOpen);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* MenuWrapper */.XG, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        openType: props.open ? openType || dist/* EMenuOpenType.BM */.HT.BM : undefined,
        bmItems: props.bmItems || [],
        iotDevices: iotDevices || [],
        iotGroups: iotGroups || [],
        iotDevicesTypes: iotDevicesTypes || [],
        onBMOpen: (tour === null || tour === void 0 ? void 0 : tour.menuEnabled) ? function() {
            return handleOpen(dist/* EMenuOpenType.BM */.HT.BM);
        } : undefined,
        onIoTOpen: (iotMenu === null || iotMenu === void 0 ? void 0 : iotMenu.active) ? function() {
            return handleOpen(dist/* EMenuOpenType.IoT */.HT.IoT);
        } : undefined,
        onBMClose: alwaysOpen ? undefined : handleClose,
        onIoTClose: alwaysOpen ? undefined : handleClose,
        showBothTriggers: (tour === null || tour === void 0 ? void 0 : tour.menuEnabled) && (iotMenu === null || iotMenu === void 0 ? void 0 : iotMenu.active),
        settings: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, isBM ? bmSettings : iotSettings), {
            openOnHoverBm: menuSettings === null || menuSettings === void 0 ? void 0 : menuSettings.openOnHover,
            openOnHoverIot: iotMenu === null || iotMenu === void 0 ? void 0 : iotMenu.openOnHover,
            tooltipOnBm: menuSettings === null || menuSettings === void 0 ? void 0 : menuSettings.menuTooltipOn,
            tooltipOnIot: !(iotMenu === null || iotMenu === void 0 ? void 0 : iotMenu.disableMenuTooltip),
            fullScreenMobile: bmSettings.fullScreenMobile || (iotSettings === null || iotSettings === void 0 ? void 0 : iotSettings.fullScreenMobile)
        }),
        colors: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, isBM ? bmColors : iotColors), {
            bmBg: bmColors.bg || "#000000",
            iotBg: iotColors.bg || "#000000",
            bmText: bmColors.text || "#ffffff",
            iotText: iotColors.text || "#ffffff"
        }),
        book: {
            url: menuSettings === null || menuSettings === void 0 ? void 0 : menuSettings.bookUrl,
            label: menuSettings === null || menuSettings === void 0 ? void 0 : menuSettings.bookText
        },
        contact: (tour === null || tour === void 0 ? void 0 : tour.contactForm) ? {
            phone: (tour === null || tour === void 0 ? void 0 : (ref = tour.client) === null || ref === void 0 ? void 0 : ref.phone) || (tour === null || tour === void 0 ? void 0 : (ref1 = tour.client) === null || ref1 === void 0 ? void 0 : ref1.email) || (tourEmail === null || tourEmail === void 0 ? void 0 : tourEmail.contactPhone),
            onClick: toggleContactPopup
        } : undefined,
        address: {
            label: tour === null || tour === void 0 ? void 0 : tour.address,
            onClick: handleAddressClick
        }
    }));
}
/* harmony default export */ var menu_wrapper_MenuWrapper = (/*#__PURE__*/(0,react.memo)(MenuWrapper));

// EXTERNAL MODULE: ./components/tour/regular/mondelez-tablet-video/MondelezTabletVideo.tsx
var MondelezTabletVideo = __webpack_require__(39901);
;// CONCATENATED MODULE: ./utils/styledToast.ts

var CONFIG = {
    hideProgressBar: true,
    autoClose: 3000,
    closeOnClick: false,
    closeButton: false,
    style: {
        borderRadius: "3px",
        background: "rgba(0, 0, 0, 0.7)",
        color: "#fff",
        height: "40px"
    }
};
var styledToast = function(message, type) {
    var t = type ? react_toastify_esm/* toast */.Am[type] : react_toastify_esm/* toast */.Am;
    t(message, CONFIG);
};

;// CONCATENATED MODULE: ./components/tour/components/InteractedListener.tsx
// The idea of this component is to listen for a user click on the showcase or
// Treedis components (BurgerMenu, BottomBar, etc), and then call the setInteracted function
// As soon as 'interacted' is set to true in BaseTour, this component will be unmounted
// Currently there are other places in the codebase where interacted is set to true, but ideally in the future all interacted logic should be handled by this component


var InteractedListener = function(param) {
    var showcase = param.showcase, onInteracted = param.onInteracted;
    var eventRef = (0,react.useRef)(null);
    var isActiveRef = (0,react.useRef)(false);
    var handleClick = (0,react.useCallback)(function() {
        onInteracted();
    }, [
        onInteracted
    ]);
    (0,react.useEffect)(function() {
        // When the tour starts, it will be 'inactive' at first, but when it starts playing it will be 'active', and when it becomes 'inactive' again, it means the user has interacted with the tour
        if (showcase && !eventRef.current) {
            eventRef.current = showcase.Tour.state.subscribe(function(state) {
                if (!isActiveRef.current && state.current === "tour.active") {
                    isActiveRef.current = true;
                    return;
                }
                if (state.current === "tour.inactive" && isActiveRef.current) {
                    handleClick();
                }
            });
        }
        return function() {
            var ref;
            (ref = eventRef.current) === null || ref === void 0 ? void 0 : ref.cancel();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        showcase
    ]);
    (0,react.useEffect)(function() {
        window.addEventListener("click", handleClick);
        return function() {
            window.removeEventListener("click", handleClick);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};

// EXTERNAL MODULE: ./components/navigation/NavigationWrapper.tsx + 28 modules
var NavigationWrapper = __webpack_require__(83638);
;// CONCATENATED MODULE: ./components/tour/regular/vimeoVideo/types.ts
var VideoQuality;
(function(VideoQuality) {
    VideoQuality["Auto"] = "auto";
    VideoQuality["Adaptive"] = "adaptive";
    VideoQuality[VideoQuality["X4K"] = 2160] = "X4K";
    VideoQuality[VideoQuality["X2K"] = 1440] = "X2K";
    VideoQuality[VideoQuality["X1080"] = 1080] = "X1080";
    VideoQuality[VideoQuality["X720"] = 720] = "X720";
    VideoQuality[VideoQuality["X540"] = 540] = "X540";
    VideoQuality[VideoQuality["X360"] = 360] = "X360";
})(VideoQuality || (VideoQuality = {}));

;// CONCATENATED MODULE: ./components/tour/regular/vimeoVideo/index.ts






var VimeoVideo = /*#__PURE__*/ function() {
    "use strict";
    function VimeoVideo(videoId) {
        (0,_class_call_check/* default */.Z)(this, VimeoVideo);
        this.id = videoId;
        this.selectedQuality = VideoQuality.X720;
    }
    var _proto = VimeoVideo.prototype;
    /**
   * Load a specific video by providing a Vimeo video ID
   */ _proto.loadFromVideoId = function loadFromVideoId(clientId) {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!_this.id) {
                            throw new Error("[Vimeo] No video ID was specified");
                        }
                        if (!!_this.data) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            TreedisPublicDAO/* default.getVimeoVideo */.Z.getVimeoVideo(_this.id, clientId)
                        ];
                    case 1:
                        _this.data = _state.sent();
                        _state.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        })();
    };
    /**
   * Get the current Vimeo video file URL
   * @returns {string}
   */ _proto.getFileURL = function getFileURL() {
        if (this.isAdaptivePlayback()) {
            return this.getAdaptiveURL();
        }
        return this.getProgressiveFileURL(this.selectedQuality);
    };
    // eslint-disable-next-line consistent-return
    _proto.getAdaptiveURL = function getAdaptiveURL() {
        if (this.isDashPlayback()) {
            if (this.data) {
                return this.data.play.dash.link;
            }
        } else if (this.data) {
            return this.data.play.hls.link;
        }
    };
    // eslint-disable-next-line consistent-return
    _proto.getProgressiveFileURL = function getProgressiveFileURL(quality) {
        if (!this.isLive() && this.data) {
            if (this.data.play.progressive) {
                this.data.play.progressive.sort(function(a, b) {
                    return a.height < b.height ? 1 : -1;
                });
                var preferredQualities = [];
                // eslint-disable-next-line no-plusplus
                for(var i = 0; i < this.data.play.progressive.length; i++){
                    if (quality > this.data.play.progressive[i].height) {
                        preferredQualities.push(this.data.play.progressive[i]);
                    } else if (quality === this.data.play.progressive[i].height) {
                        return this.data.play.progressive[i].link;
                    }
                }
                if (preferredQualities.length === 0) {
                    var file = this.data.play.progressive[this.data.play.progressive.length - 1];
                    return file.link;
                }
                return preferredQualities[0].link;
            }
        }
    };
    /**
   * Query wheter the current video is a livestream
   * @returns {bool}
   */ _proto.isLive = function isLive() {
        if (this.data) {
            return this.data.live && this.data.live.status === "streaming";
        }
        return false;
    };
    /**
   * Query wheter the current video is playing back an adaptive stream
   * @returns {bool}
   */ _proto.isAdaptivePlayback = function isAdaptivePlayback() {
        return this.selectedQuality === VideoQuality.Auto || this.selectedQuality === VideoQuality.Adaptive;
    };
    /**
   * Query wheter the current video is playing back an adaptive DASH stream
   * @returns {bool}
   */ _proto.isDashPlayback = function isDashPlayback() {
        return this.isAdaptivePlayback() && !deviceManager/* default.isIOS */.Z.isIOS();
    };
    VimeoVideo.parseVideoId = function parseVideoId(url) {
        return parseInt(url.toString().match(/([0-9]+)/)[1], 10);
    };
    return VimeoVideo;
}();


;// CONCATENATED MODULE: ./components/iot/IotTourModal/IotTourModal.tsx









var IotTourModal = function(param) {
    var open = param.open, setOpen = param.setOpen, tag = param.tag, providers = param.providers, moveToTagIO = param.moveToTagIO, handleUnlock = param.handleUnlock, iotDevices = param.iotDevices, openCamera = param.openCamera, openFavouriteCameras = param.openFavouriteCameras, newDoorNotification = param.newDoorNotification, handleMoveToLock = param.handleMoveToLock, tags = param.tags;
    var ref = (0,react.useState)(Array(9).fill({
        url: "",
        id: null,
        name: ""
    })), selectedCameras = ref[0], setSelectedCameras = ref[1];
    var ref1 = (0,react.useState)(false), notificationView = ref1[0], setNotificationView = ref1[1];
    var ref2 = (0,react.useState)(null), selectedIndex = ref2[0], setSelectedIndex = ref2[1];
    var rombusProvider = (0,react.useMemo)(function() {
        return providers === null || providers === void 0 ? void 0 : providers.find(function(provider) {
            var ref;
            return (provider === null || provider === void 0 ? void 0 : (ref = provider.provider) === null || ref === void 0 ? void 0 : ref.name) === dist/* EIoTProviders.RHOMBUS */.hJ.RHOMBUS;
        });
    }, [
        providers
    ]);
    var kisiProvider = (0,react.useMemo)(function() {
        return providers === null || providers === void 0 ? void 0 : providers.find(function(provider) {
            var ref;
            return (provider === null || provider === void 0 ? void 0 : (ref = provider.provider) === null || ref === void 0 ? void 0 : ref.name) === dist/* EIoTProviders.Kisi */.hJ.Kisi;
        });
    }, [
        providers
    ]);
    var tankLogixProvider = (0,react.useMemo)(function() {
        return providers === null || providers === void 0 ? void 0 : providers.find(function(provider) {
            var ref;
            return (provider === null || provider === void 0 ? void 0 : (ref = provider.provider) === null || ref === void 0 ? void 0 : ref.name) === dist/* EIoTProviders.TANKLOGIX */.hJ.TANKLOGIX;
        });
    }, [
        providers
    ]);
    var cameras = (0,react.useMemo)(function() {
        return iotDevices === null || iotDevices === void 0 ? void 0 : iotDevices.filter(function(d) {
            return d.providerId === (rombusProvider === null || rombusProvider === void 0 ? void 0 : rombusProvider.providerId);
        });
    }, [
        iotDevices,
        rombusProvider
    ]);
    var doors = (0,react.useMemo)(function() {
        return iotDevices === null || iotDevices === void 0 ? void 0 : iotDevices.filter(function(d) {
            return d.providerId === (kisiProvider === null || kisiProvider === void 0 ? void 0 : kisiProvider.providerId);
        });
    }, [
        iotDevices,
        kisiProvider
    ]);
    var engines = (0,react.useMemo)(function() {
        return iotDevices === null || iotDevices === void 0 ? void 0 : iotDevices.filter(function(d) {
            return d.providerId === (tankLogixProvider === null || tankLogixProvider === void 0 ? void 0 : tankLogixProvider.providerId);
        });
    }, [
        tankLogixProvider,
        iotDevices
    ]);
    var unshownDevices = (0,react.useMemo)(function() {
        return cameras === null || cameras === void 0 ? void 0 : cameras.filter(function(device) {
            return !selectedCameras.find(function(camera) {
                return camera.id === device.id;
            });
        });
    }, [
        cameras,
        selectedCameras
    ]);
    var relatedTag = (0,react.useMemo)(function() {
        var ref;
        var cameraTag = openCamera === null || openCamera === void 0 ? void 0 : (ref = openCamera.relatedAssets) === null || ref === void 0 ? void 0 : ref.find(function(a) {
            return a.type === "tag";
        });
        if (cameraTag) {
            var foundTag = tags === null || tags === void 0 ? void 0 : tags.find(function(t) {
                return t.sid === (cameraTag === null || cameraTag === void 0 ? void 0 : cameraTag.id) || t.defaultSid === (cameraTag === null || cameraTag === void 0 ? void 0 : cameraTag.id);
            });
            var doorsRelatedToTag = doors === null || doors === void 0 ? void 0 : doors.filter(function(door) {
                var ref;
                return foundTag === null || foundTag === void 0 ? void 0 : (ref = foundTag.iotDevices) === null || ref === void 0 ? void 0 : ref.some(function(device) {
                    var // eslint-disable-next-line eqeqeq
                    ref;
                    return (ref = device.relatedAssets) === null || ref === void 0 ? void 0 : ref.some(function(asset) {
                        return asset.id == door.id;
                    });
                });
            });
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, foundTag), {
                iotDevices: (0,_to_consumable_array/* default */.Z)(foundTag.iotDevices).concat((0,_to_consumable_array/* default */.Z)(doorsRelatedToTag))
            });
        }
        return null;
    }, [
        tags,
        openCamera,
        doors
    ]);
    var handleCameraSelect = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(camera) {
            var ref, result, _tmp;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!!camera.videoUrl) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            TreedisPublicDAO/* default.getStream */.Z.getStream({
                                query: {
                                    providerId: camera.providerId,
                                    deviceId: camera.id,
                                    tourId: camera.tourId
                                }
                            })
                        ];
                    case 1:
                        _tmp = _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        _tmp = {
                            data: {
                                sharedLiveVideoStreamUrl: camera.videoUrl
                            }
                        };
                        _state.label = 3;
                    case 3:
                        result = _tmp;
                        if (result === null || result === void 0 ? void 0 : (ref = result.data) === null || ref === void 0 ? void 0 : ref.sharedLiveVideoStreamUrl) {
                            setSelectedCameras(function(prevCameras) {
                                return prevCameras === null || prevCameras === void 0 ? void 0 : prevCameras.map(function(prevCamera, i) {
                                    var ref;
                                    return i === selectedIndex ? {
                                        id: camera.id,
                                        url: result === null || result === void 0 ? void 0 : (ref = result.data) === null || ref === void 0 ? void 0 : ref.sharedLiveVideoStreamUrl,
                                        name: camera.name
                                    } : prevCamera;
                                });
                            });
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function(camera) {
            return _ref.apply(this, arguments);
        };
    }(), [
        selectedIndex
    ]);
    (0,react.useEffect)(function() {
        var ref;
        if (tag && !openCamera && !openFavouriteCameras && !notificationView) {
            setSelectedCameras(function(prevCameras) {
                var ref;
                var tagCameras = tag === null || tag === void 0 ? void 0 : (ref = tag.iotDevices) === null || ref === void 0 ? void 0 : ref.filter(function(d) {
                    return d.videoUrl;
                });
                return prevCameras.map(function(_, i) {
                    var ref, ref1, ref2;
                    return {
                        id: (tagCameras === null || tagCameras === void 0 ? void 0 : (ref = tagCameras[i]) === null || ref === void 0 ? void 0 : ref.id) || null,
                        url: (tagCameras === null || tagCameras === void 0 ? void 0 : (ref1 = tagCameras[i]) === null || ref1 === void 0 ? void 0 : ref1.videoUrl) || "",
                        name: (tagCameras === null || tagCameras === void 0 ? void 0 : (ref2 = tagCameras[i]) === null || ref2 === void 0 ? void 0 : ref2.name) || ""
                    };
                });
            });
            return;
        }
        if ((cameras === null || cameras === void 0 ? void 0 : cameras.length) > 0 && openCamera && !openFavouriteCameras && !notificationView) {
            setSelectedCameras(function(prevCameras) {
                return prevCameras === null || prevCameras === void 0 ? void 0 : prevCameras.map(function(prevCamera, i) {
                    if (i === 0) {
                        var cameraOpenFromMenu = cameras === null || cameras === void 0 ? void 0 : cameras.find(function(camera) {
                            return camera.id === (openCamera === null || openCamera === void 0 ? void 0 : openCamera.id);
                        });
                        return {
                            id: cameraOpenFromMenu ? cameraOpenFromMenu === null || cameraOpenFromMenu === void 0 ? void 0 : cameraOpenFromMenu.id : cameras[0].id,
                            url: cameraOpenFromMenu ? cameraOpenFromMenu === null || cameraOpenFromMenu === void 0 ? void 0 : cameraOpenFromMenu.videoUrl : cameras[0].videoUrl,
                            name: cameraOpenFromMenu ? cameraOpenFromMenu === null || cameraOpenFromMenu === void 0 ? void 0 : cameraOpenFromMenu.name : cameras[0].name
                        };
                    }
                    return prevCamera;
                });
            });
            return;
        }
        if (cameras && (cameras === null || cameras === void 0 ? void 0 : cameras.length) > 0 && (openFavouriteCameras === null || openFavouriteCameras === void 0 ? void 0 : (ref = openFavouriteCameras.cameras) === null || ref === void 0 ? void 0 : ref.length) > 0 && !openCamera && !notificationView) {
            var ref1;
            var favouriteCameras = (ref1 = cameras === null || cameras === void 0 ? void 0 : cameras.filter(function(camera) {
                var ref;
                return openFavouriteCameras === null || openFavouriteCameras === void 0 ? void 0 : (ref = openFavouriteCameras.cameras) === null || ref === void 0 ? void 0 : ref.includes(camera.id);
            })) === null || ref1 === void 0 ? void 0 : ref1.map(function(camera) {
                return {
                    id: camera.id || null,
                    url: camera.videoUrl || ""
                };
            });
            setSelectedCameras((0,_to_consumable_array/* default */.Z)(favouriteCameras).concat((0,_to_consumable_array/* default */.Z)(Array(9 - favouriteCameras.length).fill({
                url: "",
                id: null,
                name: ""
            }))));
        }
    }, [
        cameras,
        openCamera,
        openFavouriteCameras,
        notificationView,
        tag
    ]);
    var handleClose = function() {
        setOpen(false, false);
        setNotificationView(false);
        setSelectedCameras(Array(9).fill({
            url: "",
            id: null,
            name: ""
        }));
    };
    var handleOpenVideo = (0,react.useCallback)(function(camera) {
        setSelectedCameras(function(prevCameras) {
            return prevCameras.map(function(prevCamera, i) {
                return i === 0 ? {
                    id: camera.id,
                    url: camera.videoUrl,
                    name: camera.name
                } : prevCamera;
            });
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var openVideoFromNotifications = (0,react.useCallback)(function(devices) {
        setNotificationView(true);
        if (devices.length === 1) {
            setSelectedCameras(function(prevCameras) {
                return prevCameras.map(function(prevCamera, i) {
                    return i === 0 ? {
                        id: devices[0].id,
                        url: devices[0].videoUrl,
                        name: devices[0].name
                    } : prevCamera;
                });
            });
        }
        if (devices.length > 1) {
            setSelectedCameras(function(prevCameras) {
                return prevCameras.map(function(prevCamera, i) {
                    var ref, ref1, ref2;
                    return {
                        id: ((ref = devices[i]) === null || ref === void 0 ? void 0 : ref.id) || prevCamera.id,
                        url: ((ref1 = devices[i]) === null || ref1 === void 0 ? void 0 : ref1.videoUrl) || prevCamera.url,
                        name: ((ref2 = devices[i]) === null || ref2 === void 0 ? void 0 : ref2.name) || prevCamera.name
                    };
                });
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var removeCameraFromGrid = function(camera) {
        setSelectedCameras(function(prevCameras) {
            return prevCameras.map(function(prevCamera) {
                if (prevCamera.id === camera.id) {
                    return {
                        id: null,
                        url: "",
                        name: ""
                    };
                }
                return prevCamera;
            });
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* IotModal */.hj, {
        open: open,
        handleClose: handleClose,
        tag: tag || relatedTag,
        providers: providers,
        setSelectedIndex: setSelectedIndex,
        selectedCameras: selectedCameras,
        handleCameraSelect: handleCameraSelect,
        unshownDevices: unshownDevices,
        moveToTag: moveToTagIO,
        handleUnlock: handleUnlock,
        cameras: cameras,
        doors: doors,
        handleOpenVideo: handleOpenVideo,
        bottomBarWidth: undefined,
        windowWidth: undefined,
        // modalStyle={{ top: '-94px' }}
        reelStyle: {
            left: 0
        },
        favouriteView: openFavouriteCameras,
        newDoorNotification: newDoorNotification,
        handleMoveToLock: handleMoveToLock,
        openVideoFromNotifications: openVideoFromNotifications,
        removeCameraFromGrid: removeCameraFromGrid,
        engines: engines
    });
};

;// CONCATENATED MODULE: ./components/iot/IotLoginModal/IotLoginModal.tsx











function IotLoginModal_getTokenData(token) {
    // Split the token into its parts
    if (!token) {
        return {
            tokenExpired: true
        };
    }
    var payloadEncoded = token.split(".")[1];
    if (!payloadEncoded) {
        return {
            tokenExpired: true
        };
    }
    // Decode the payload
    var payloadDecoded = atob(payloadEncoded);
    // Parse the payload as JSON
    var payload = JSON.parse(payloadDecoded);
    // Check if the exp property exists
    if (!payload.exp) {
        return {
            tokenExpired: true
        };
    }
    // Get the current date/time in seconds since the Unix epoch
    var currentDate = Math.floor(Date.now() / 1000);
    // Check if the current date/time is greater than the exp property
    return {
        tokenExpired: currentDate > payload.exp,
        userIdFromToken: payload.userId
    };
}
var IotLoginModal_getReCaptchaToken = function() {
    return new Promise(function(resolve, reject) {
        if (false) {}
        window.grecaptcha.ready(function() {
            window.grecaptcha.execute("6Le-bIYbAAAAAM6IlCstvx1NZFZlHEjCXoaBnpFC", {
                action: "main"
            }).then(resolve).catch(reject);
        });
    });
};
var IotLoginModal = function(param) {
    var tour = param.tour;
    var ref = (0,react.useState)(null), userId = ref[0], setUserId = ref[1];
    var ref1 = (0,react.useState)(1), step = ref1[0], setStep = ref1[1];
    var ref2 = (0,react.useState)(!localStorage.getItem("userToken")), isOpen = ref2[0], setIsOpen = ref2[1];
    var ref3 = (0,react.useState)({
        email: "",
        password: "",
        pinTwoFA: ""
    }), inputs = ref3[0], setInputs = ref3[1];
    var ref4 = (0,react.useState)(false), showPassword = ref4[0], setShowPassword = ref4[1];
    var collaborators = (0,react.useMemo)(function() {
        return tour === null || tour === void 0 ? void 0 : tour.users;
    }, [
        tour
    ]);
    var handleInputsChange = function(e) {
        var _target = e.target, id = _target.id, value = _target.value;
        setInputs(function(prevState) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevState), (0,_define_property/* default */.Z)({}, id, id === "pinTwoFA" ? value.replace(/\s/g, "") : value));
        });
    };
    var handleSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var ref, captchaToken, res, data;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!inputs.email || !inputs.password) {
                            react_toastify_esm/* toast.error */.Am.error("Please fill in credentials");
                            return [
                                2
                            ];
                        }
                        if (!(collaborators === null || collaborators === void 0 ? void 0 : collaborators.find(function(c) {
                            var ref;
                            return c.email === ((ref = inputs.email) === null || ref === void 0 ? void 0 : ref.toLowerCase());
                        }))) {
                            react_toastify_esm/* toast.error */.Am.error("You are not a collaborator on this space");
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            IotLoginModal_getReCaptchaToken()
                        ];
                    case 1:
                        captchaToken = _state.sent();
                        return [
                            4,
                            TreedisPublicDAO/* default.loginIoT */.Z.loginIoT((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, inputs), {
                                email: (ref = inputs.email) === null || ref === void 0 ? void 0 : ref.toLowerCase(),
                                captchaToken: captchaToken
                            }))
                        ];
                    case 2:
                        res = _state.sent();
                        if (res) {
                            data = res.data;
                            if (data === null || data === void 0 ? void 0 : data.refreshToken) {
                                localStorage.setItem("userToken", data.refreshToken); // refreshToken because it's long lived
                                setUserId(Number(data.user.id));
                                setIsOpen(false);
                            } else {
                                setStep(2);
                            }
                        } else if (!res && step === 2) {
                            react_toastify_esm/* toast.error */.Am.error("Wrong pin");
                        } else {
                            react_toastify_esm/* toast.error */.Am.error("Wrong password or email");
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSubmit() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        var token = localStorage.getItem("userToken");
        var ref = IotLoginModal_getTokenData(token), tokenExpired = ref.tokenExpired, userIdFromToken = ref.userIdFromToken;
        if ((tokenExpired || !token) && !userId) {
            setIsOpen(true);
        }
        setUserId(Number(userIdFromToken));
    }, [
        userId,
        setUserId
    ]);
    var handleEnterPress = function(event) {
        if (event.key === "Enter") {
            handleSubmit();
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
        open: isOpen,
        hideBackdrop: true,
        sx: {
            background: "rgba(0, 0, 0, 0.4)",
            transition: "all 0.3s ease",
            backdropFilter: "blur(15px)"
        },
        onKeyDown: handleEnterPress,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
            direction: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: {
                xs: 2,
                md: 3
            },
            sx: createRootStyle(),
            children: [
                step === 1 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                            required: true,
                            autoFocus: true,
                            id: "email",
                            type: "email",
                            label: "Email",
                            value: inputs.email,
                            onChange: handleInputsChange,
                            sx: {
                                "& .MuiInputBase-root , input": {
                                    height: {
                                        xs: "36px",
                                        md: "56px"
                                    },
                                    lineHeight: {
                                        xs: "36px",
                                        md: "56px"
                                    }
                                }
                            },
                            inputProps: {
                                style: {
                                    width: "320px",
                                    borderColor: "#FFFFFF",
                                    borderRadius: "4px",
                                    color: "white"
                                }
                            },
                            InputLabelProps: {
                                sx: {
                                    top: {
                                        xs: "-10px",
                                        md: 0
                                    },
                                    "&.MuiInputLabel-shrink": {
                                        top: 0
                                    }
                                }
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                            required: true,
                            id: "password",
                            type: showPassword ? "text" : "password",
                            label: "Password",
                            value: inputs.password,
                            onChange: handleInputsChange,
                            sx: {
                                "& .MuiInputBase-root , input": {
                                    height: {
                                        xs: "36px",
                                        md: "56px"
                                    },
                                    lineHeight: {
                                        xs: "36px",
                                        md: "56px"
                                    },
                                    width: "320px"
                                }
                            },
                            InputProps: {
                                endAdornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                    onClick: function() {
                                        return setShowPassword(function(prevState) {
                                            return !prevState;
                                        });
                                    },
                                    sx: {
                                        color: "#FFF"
                                    },
                                    children: showPassword ? /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        className: "fa-regular fa-eye"
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        className: "fa-regular fa-eye-slash"
                                    })
                                })
                            },
                            // eslint-disable-next-line react/jsx-no-duplicate-props
                            inputProps: {
                                style: {
                                    borderColor: "#FFFFFF",
                                    borderRadius: "4px",
                                    color: "white"
                                }
                            },
                            InputLabelProps: {
                                sx: {
                                    top: {
                                        xs: "-10px",
                                        md: 0
                                    },
                                    "&.MuiInputLabel-shrink": {
                                        top: 0
                                    }
                                }
                            }
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                    required: true,
                    autoFocus: true,
                    id: "pinTwoFA",
                    type: "twoFactorCode",
                    label: "Pin Code",
                    value: inputs.pinTwoFA,
                    onChange: handleInputsChange,
                    sx: {
                        "& .MuiInputBase-root , input": {
                            height: {
                                xs: "36px",
                                md: "56px"
                            },
                            lineHeight: {
                                xs: "36px",
                                md: "56px"
                            }
                        }
                    },
                    inputProps: {
                        style: {
                            width: "320px",
                            borderColor: "#FFFFFF",
                            borderRadius: "4px",
                            color: "white"
                        }
                    },
                    InputLabelProps: {
                        sx: {
                            top: {
                                xs: "-10px",
                                md: 0
                            },
                            "&.MuiInputLabel-shrink": {
                                top: 0
                            }
                        }
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                    gap: 1,
                    alignItems: "center",
                    width: "320px",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                        type: "submit",
                        onClick: handleSubmit,
                        sx: {
                            backgroundColor: "#2055FF",
                            my: {
                                xs: 0,
                                lg: "5px"
                            },
                            height: "56px",
                            width: {
                                xs: "100%"
                            }
                        },
                        children: "Login as Collaborator"
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/util/sdk/sweep/data.ts


var getAllSweeps = function(matterSweeps, treedisSweeps) {
    var allSweeps = new Map();
    matterSweeps.forEach(function(s) {
        var ref, ref1, ref2, ref3;
        //@ts-ignore
        var index = treedisSweeps.findLastIndex(function(item) {
            return s.id === (item === null || item === void 0 ? void 0 : item.sweepId) || s.id === (item === null || item === void 0 ? void 0 : item.sweep_uuid) || s.sweep_uuid === (item === null || item === void 0 ? void 0 : item.sweep_uuid) || s.sweep_uuid === (item === null || item === void 0 ? void 0 : item.sweepId);
        });
        var found = index === -1 ? null : treedisSweeps[index];
        var sweep = {
            id: found ? found.sweepId : s.id,
            enabled: found ? found.enabled : s.tags.includes("showcase"),
            isCustom: (found === null || found === void 0 ? void 0 : found.isCustom) ? found === null || found === void 0 ? void 0 : found.isCustom : false,
            name: (found === null || found === void 0 ? void 0 : found.name) || "Sweep ".concat(+s.label + 1),
            index: found ? found.isCustom ? null : +found.name.split(" ")[1] - 1 : +s.label,
            tourId: found ? found.tourId : null,
            positionX: (found === null || found === void 0 ? void 0 : found.positionX) ? found.positionX : s === null || s === void 0 ? void 0 : (ref = s.position) === null || ref === void 0 ? void 0 : ref.x,
            positionY: (found === null || found === void 0 ? void 0 : found.positionY) ? found.positionY : s === null || s === void 0 ? void 0 : (ref1 = s.position) === null || ref1 === void 0 ? void 0 : ref1.y,
            positionZ: (found === null || found === void 0 ? void 0 : found.positionZ) ? found.positionZ : s === null || s === void 0 ? void 0 : (ref2 = s.position) === null || ref2 === void 0 ? void 0 : ref2.z,
            neighbourSweeps: (found === null || found === void 0 ? void 0 : found.neighbourSweeps) || s.neighbors,
            floor: found && found.floor !== null ? found.floor : (ref3 = s.floor) === null || ref3 === void 0 ? void 0 : ref3.sequence,
            sweepId: found ? found.sweepId : s.id,
            sweep_uuid: found ? found.sweep_uuid : s.sweep_uuid,
            treedisId: found ? found.id : null,
            createdAt: found ? found.createdAt : null,
            updatedAt: found ? found.updatedAt : null,
            title: found ? found.title : null,
            isMandatory: found ? found.isMandatory : false
        };
        allSweeps.set(sweep.id, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, sweep), {
            modifiedSweep: !!found
        }));
    });
    treedisSweeps.forEach(function(s) {
        if (s.isCustom) {
            allSweeps.set("treedis_".concat(s.id), (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, s), {
                id: "".concat(s.id).startsWith("treedis_") ? "".concat(s.id) : "treedis_".concat(s.id),
                treedisId: s.id,
                index: null,
                modifiedSweep: true
            }));
        }
    });
    return allSweeps;
};

;// CONCATENATED MODULE: ./utils/three/checkIntersection.ts

// import { addDebugLineBetweenPoints } from './helper';
function checkIntersection(point1, point2, barrier, scene, THREE) {
    var start = new THREE.Vector3(point1.positionX, point1.positionY, point1.positionZ);
    var end = new THREE.Vector3(point2.positionX, point2.positionY, point2.positionZ);
    var direction = new THREE.Vector3().subVectors(end, start).normalize();
    var distance = getEuclidianDistance(point1, point2);
    var raycaster = new THREE.Raycaster(start, direction);
    var intersects = raycaster.intersectObject(barrier, true).filter(function(i) {
        return i.distance < distance;
    });
    // Debug method, uncomment to see all sweep connections
    // Red lines represent connections blocked by barriers
    // addDebugLineBetweenPoints(
    //   point1,
    //   point2,
    //   intersects.length > 0 ? 0xff0000 : 0x0000ff,
    //   scene,
    //   THREE
    // );
    return intersects;
}

;// CONCATENATED MODULE: ./_models/virtualStaging/PathFinderLine/utils.ts
// Modify uploaded sweeps for barriers to affect them







var getPathCalculationSweeps = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(allSweeps, barriers, sceneBarrierNodes, onSweepsIntersectedByBarrier) {
        var THREE, modifiedSweeps, enabledSceneBarriers;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0,dist/* iTHREE */.Sc)()
                    ];
                case 1:
                    THREE = _state.sent();
                    if (!allSweeps) return [
                        2
                    ];
                    modifiedSweeps = new Map(allSweeps);
                    enabledSceneBarriers = new Map();
                    if (barriers) barriers.forEach(function(barrier) {
                        if (barrier.id === undefined) return;
                        var node = sceneBarrierNodes.find(function(node) {
                            return node[1].originId === barrier.id;
                        });
                        if (node && barrier.enabled) enabledSceneBarriers.set(barrier.id, node);
                    });
                    enabledSceneBarriers.forEach(function(barrierNode) {
                        barrierNode[0].obj3D.updateMatrixWorld(true);
                    });
                    modifiedSweeps.forEach(function(sweep) {
                        if (!sweep.neighbourSweeps) return;
                        var neighborSweeps = sweep.neighbourSweeps.reduce(function(acc, neighborId) {
                            var neighbor = modifiedSweeps.get(neighborId);
                            if (neighbor) return (0,_to_consumable_array/* default */.Z)(acc).concat([
                                neighbor
                            ]);
                            return acc;
                        }, []);
                        var modifiedSweep = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, sweep), {
                            neighbourSweeps: (0,_to_consumable_array/* default */.Z)(sweep.neighbourSweeps || [])
                        });
                        var idsToRemove = [];
                        neighborSweeps.forEach(function(neighborSweep) {
                            // Apply barrier changes
                            enabledSceneBarriers.forEach(function(barrierNode) {
                                var intersects = checkIntersection(sweep, neighborSweep, barrierNode[0].obj3D, barrierNode[1].context.scene, THREE);
                                if (intersects.length) {
                                    var isBarrierFront = false;
                                    intersects.every(function(i) {
                                        if (i.object.name === "barrierFront" && i.object.visible) {
                                            isBarrierFront = true;
                                            return false;
                                        }
                                        if (i.object.name === "barrierBack" && i.object.visible) {
                                            return false;
                                        }
                                        return true;
                                    });
                                    if (isBarrierFront) return;
                                    if (!neighborSweep.isCustom && !sweep.isCustom && onSweepsIntersectedByBarrier) {
                                        onSweepsIntersectedByBarrier(sweep, neighborSweep);
                                    }
                                    idsToRemove.push(neighborSweep.id);
                                }
                            });
                        });
                        modifiedSweep.neighbourSweeps = modifiedSweep.neighbourSweeps.filter(function(s) {
                            return !idsToRemove.includes(s);
                        });
                        modifiedSweeps.set(modifiedSweep.id, modifiedSweep);
                    });
                    return [
                        2,
                        modifiedSweeps
                    ];
            }
        });
    });
    return function getPathCalculationSweeps(allSweeps, barriers, sceneBarrierNodes, onSweepsIntersectedByBarrier) {
        return _ref.apply(this, arguments);
    };
}();
var getSweepSid = function(sweep) {
    return sweep.sid ? sweep.sid : sweep.sweep;
};
var getEuclidianDistance = function(point1, point2) {
    return Math.sqrt(Math.pow(point2.positionX - point1.positionX, 2) + Math.pow(point2.positionY - point1.positionY, 2) + Math.pow(point2.positionZ - point1.positionZ, 2));
};

// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Zoom/Zoom.js
var Zoom = __webpack_require__(44850);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/ButtonGroup/ButtonGroup.js + 1 modules
var ButtonGroup = __webpack_require__(62135);
// EXTERNAL MODULE: ./components/flows/types.ts
var flows_types = __webpack_require__(83065);
;// CONCATENATED MODULE: ./components/flows/utils/index.ts


function combineHiddenAssets(conditions, switchFlowConditions) {
    var tagsSet = new Set();
    var polygonsSet = new Set();
    var vsItemsSet = new Set();
    var vsObjectsSet = new Set();
    var sweepsSet = new Set();
    conditions.forEach(function(c) {
        c.tags.forEach(function(tag) {
            return tagsSet.add(tag);
        });
        c.polygons.forEach(function(polygon) {
            return polygonsSet.add(polygon);
        });
        c.vsItems.forEach(function(item) {
            return vsItemsSet.add(item);
        });
        c.vsObjects.forEach(function(obj) {
            return vsObjectsSet.add(obj);
        });
        if (c.sweeps !== null) {
            sweepsSet.add(c.sweeps);
        }
    });
    var filteredTags = Array.from(tagsSet).filter(function(tag) {
        var ref, ref1;
        return !(switchFlowConditions === null || switchFlowConditions === void 0 ? void 0 : (ref = switchFlowConditions[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.tags) === null || ref1 === void 0 ? void 0 : ref1.includes(tag));
    });
    var filteredPolygons = Array.from(polygonsSet).filter(function(polygon) {
        var ref, ref1;
        return !(switchFlowConditions === null || switchFlowConditions === void 0 ? void 0 : (ref = switchFlowConditions[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.polygons) === null || ref1 === void 0 ? void 0 : ref1.includes(polygon));
    });
    var filteredVsItems = Array.from(vsItemsSet).filter(function(item) {
        var ref, ref1;
        return !(switchFlowConditions === null || switchFlowConditions === void 0 ? void 0 : (ref = switchFlowConditions[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.vsItems) === null || ref1 === void 0 ? void 0 : ref1.includes(item));
    });
    var filteredVsObjects = Array.from(vsObjectsSet).filter(function(obj) {
        var ref, ref1;
        return !(switchFlowConditions === null || switchFlowConditions === void 0 ? void 0 : (ref = switchFlowConditions[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.vsObjects) === null || ref1 === void 0 ? void 0 : ref1.includes(obj));
    });
    var filteredSweeps = Array.from(sweepsSet).filter(function(sweep) {
        var ref, ref1;
        return !(switchFlowConditions === null || switchFlowConditions === void 0 ? void 0 : (ref = switchFlowConditions[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.sweeps) === null || ref1 === void 0 ? void 0 : ref1.includes(sweep));
    });
    var returnCondition = (0,_to_consumable_array/* default */.Z)(!!(filteredTags === null || filteredTags === void 0 ? void 0 : filteredTags.length) || !!(filteredPolygons === null || filteredPolygons === void 0 ? void 0 : filteredPolygons.length) || !!(filteredVsItems === null || filteredVsItems === void 0 ? void 0 : filteredVsItems.length) || !!(filteredVsObjects === null || filteredVsObjects === void 0 ? void 0 : filteredVsObjects.length) ? [
        {
            action: flows_types/* ActionTypes.SHOW_ASSET */.M.SHOW_ASSET,
            tags: filteredTags,
            polygons: filteredPolygons,
            vsItems: filteredVsItems,
            vsObjects: filteredVsObjects
        }, 
    ] : []).concat((0,_to_consumable_array/* default */.Z)((filteredSweeps === null || filteredSweeps === void 0 ? void 0 : filteredSweeps.length) > 0 ? [
        {
            action: flows_types/* ActionTypes.SHOW_SWEEP */.M.SHOW_SWEEP,
            sweeps: filteredSweeps
        }, 
    ] : []));
    return returnCondition;
}
function handleAssetChanges(assetType, toShowSet, toHideSet, firstCondition, currentCondition) {
    if (currentCondition[assetType] && currentCondition[assetType].length > 0) {
        currentCondition[assetType].forEach(function(asset) {
            if (currentCondition.action === "show_asset") {
                toShowSet.delete(asset);
                // Add to `hide` only if it's not already in the first condition's 'show_asset'
                if (!firstCondition.isStartStep && (firstCondition === null || firstCondition === void 0 ? void 0 : firstCondition.isStartCondition) && firstCondition.id === currentCondition.id) {
                    return;
                }
                if (firstCondition.isStartStep && firstCondition[assetType].includes(asset)) {
                    toHideSet.add(asset);
                    return;
                }
                toHideSet.add(asset);
            } else if (currentCondition.action === "hide_asset") {
                toHideSet.delete(asset);
                // Add to `show` only if it's not already in the first condition's 'hide_asset'
                if (!firstCondition.isStartStep && (firstCondition === null || firstCondition === void 0 ? void 0 : firstCondition.isStartCondition) && firstCondition.id === currentCondition.id) {
                    return;
                }
                if (firstCondition.isStartStep && firstCondition[assetType].includes(asset)) {
                    toHideSet.add(asset);
                    return;
                }
                toShowSet.add(asset);
            }
        });
    }
}
var revertConditionsByStep = function(stepConditionsMap, fromStep, toStep, startStepEdge) {
    var ref, ref1, ref2;
    var tagsToShow = new Set();
    var tagsToHide = new Set();
    var vsItemsToShow = new Set();
    var vsItemsToHide = new Set();
    var vsObjectsToShow = new Set();
    var vsObjectsToHide = new Set();
    var sweepsToShow = new Set();
    var sweepsToHide = new Set();
    var polygonsToShow = new Set();
    var polygonsToHide = new Set();
    var sortedSteps = (0,_to_consumable_array/* default */.Z)(stepConditionsMap.keys()).filter(function(step) {
        return step <= fromStep && step >= toStep;
    }).sort(function(a, b) {
        return b - a;
    });
    var firstExecutedConditionInToStep = (ref2 = (ref1 = (ref = stepConditionsMap.get(toStep)) === null || ref === void 0 ? void 0 : ref.values()) === null || ref1 === void 0 ? void 0 : ref1.next()) === null || ref2 === void 0 ? void 0 : ref2.value;
    sortedSteps.forEach(function(step) {
        var conditions = stepConditionsMap.get(step);
        if (startStepEdge.target === toStep) {
            var ref, ref1, ref2;
            // if toStep is step 1 we consider starting point the startStep
            firstExecutedConditionInToStep = (ref2 = (ref1 = (ref = stepConditionsMap.get(startStepEdge.source)) === null || ref === void 0 ? void 0 : ref.values()) === null || ref1 === void 0 ? void 0 : ref1.next()) === null || ref2 === void 0 ? void 0 : ref2.value;
            if (!firstExecutedConditionInToStep) return;
            firstExecutedConditionInToStep.isStartCondition = true;
            firstExecutedConditionInToStep.isStartStep = true;
        }
        if (!conditions) return;
        Array.from(conditions).reverse().forEach(function(c) {
            handleAssetChanges("tags", tagsToShow, tagsToHide, firstExecutedConditionInToStep, c);
            handleAssetChanges("polygons", polygonsToShow, polygonsToHide, firstExecutedConditionInToStep, c);
            handleAssetChanges("sweeps", sweepsToShow, sweepsToHide, firstExecutedConditionInToStep, c);
            handleAssetChanges("vsItems", vsItemsToShow, vsItemsToHide, firstExecutedConditionInToStep, c);
            handleAssetChanges("vsObjects", vsObjectsToShow, vsObjectsToHide, firstExecutedConditionInToStep, c);
        });
    });
    var returnConditions = [
        {
            action: flows_types/* ActionTypes.SHOW_ASSET */.M.SHOW_ASSET,
            tags: Array.from(tagsToShow),
            polygons: Array.from(polygonsToShow),
            vsItems: Array.from(vsItemsToShow),
            vsObjects: Array.from(vsObjectsToShow)
        },
        {
            action: flows_types/* ActionTypes.SHOW_SWEEP */.M.SHOW_SWEEP,
            sweeps: Array.from(sweepsToShow)
        },
        {
            action: flows_types/* ActionTypes.HIDE_ASSET */.M.HIDE_ASSET,
            tags: Array.from(tagsToHide),
            polygons: Array.from(polygonsToHide),
            vsItems: Array.from(vsItemsToHide),
            vsObjects: Array.from(vsObjectsToHide)
        },
        {
            action: flows_types/* ActionTypes.HIDE_SWEEP */.M.HIDE_SWEEP,
            sweeps: Array.from(sweepsToHide)
        }, 
    ].filter(function(c) {
        var ref, ref1, ref2, ref3, ref4;
        return !!(c === null || c === void 0 ? void 0 : (ref = c.tags) === null || ref === void 0 ? void 0 : ref.length) || !!(c === null || c === void 0 ? void 0 : (ref1 = c.polygons) === null || ref1 === void 0 ? void 0 : ref1.length) || !!(c === null || c === void 0 ? void 0 : (ref2 = c.vsItems) === null || ref2 === void 0 ? void 0 : ref2.length) || !!(c === null || c === void 0 ? void 0 : (ref3 = c.vsObjects) === null || ref3 === void 0 ? void 0 : ref3.length) || !!(c === null || c === void 0 ? void 0 : (ref4 = c.sweeps) === null || ref4 === void 0 ? void 0 : ref4.length);
    });
    return returnConditions;
};
var longestPathIncludingStep = function(allPaths, currentStepId) {
    var pathsWithCurrentStep = allPaths.filter(function(path) {
        return path.includes(currentStepId);
    });
    var longestPath = pathsWithCurrentStep.reduce(function(longest, current) {
        return current.length > longest.length ? current : longest;
    }, []);
    return longestPath;
};
var calculateStepPositionInPath = function(steps, stepsEdges, currentStep) {
    if (!currentStep) return {
        currentStepPosition: 0,
        totalStepsInPath: 0
    };
    var startingStep = steps.find(function(step) {
        return step.type === "start_step";
    });
    if (!startingStep) {
        throw new Error("No starting step found");
    }
    var buildPath = function(currentStepId) {
        var path = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], visited = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : new Set();
        if (visited.has(currentStepId)) return [];
        visited.add(currentStepId);
        path.push(currentStepId);
        var outgoingEdges = stepsEdges.filter(function(edge) {
            return edge.source === currentStepId;
        });
        if (outgoingEdges.length === 0) return [
            path
        ];
        var paths = outgoingEdges.flatMap(function(edge) {
            return buildPath(edge.target, (0,_to_consumable_array/* default */.Z)(path), new Set(visited));
        });
        return paths;
    };
    var allPaths = buildPath(startingStep.id);
    var currentPath = longestPathIncludingStep(allPaths, currentStep.id);
    if (!currentPath) {
        throw new Error("Current step is not part of any path");
    }
    var filteredPath = currentPath.filter(function(stepId) {
        var ref;
        return ![
            "start_step",
            "finish_step"
        ].includes((ref = steps.find(function(step) {
            return step.id === stepId;
        })) === null || ref === void 0 ? void 0 : ref.type);
    });
    var currentStepPosition = filteredPath.indexOf(currentStep.id) + 1;
    return {
        currentStepPosition: currentStepPosition,
        totalStepsInPath: filteredPath.length
    };
};
var calculatePathLengths = function(steps, stepsEdges) {
    var _Math, _Math1;
    var startingStep = steps.find(function(step) {
        return step.type === "start_step";
    });
    var finishingStep = steps.find(function(step) {
        return step.type === "finish_step";
    });
    if (!startingStep || !finishingStep) {
        throw new Error("Starting or finishing step not found");
    }
    var buildPaths = function(currentStepId) {
        var path = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], visited = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : new Set();
        if (visited.has(currentStepId)) return []; // 🚀 Prevent infinite recursion
        visited.add(currentStepId);
        path.push(currentStepId);
        var outgoingEdges = stepsEdges.filter(function(edge) {
            return edge.source === currentStepId;
        });
        if (outgoingEdges.length === 0) return [
            path
        ];
        var paths = outgoingEdges.flatMap(function(edge) {
            return buildPaths(edge.target, (0,_to_consumable_array/* default */.Z)(path), new Set(visited));
        });
        return paths;
    };
    var allPaths = buildPaths(startingStep.id);
    var validPaths = allPaths.filter(function(path) {
        return path[path.length - 1] === finishingStep.id;
    });
    var pathLengths = validPaths.map(function(path) {
        return path.filter(function(stepId) {
            var ref;
            return ![
                "start_step",
                "finish_step"
            ].includes((ref = steps.find(function(step) {
                return step.id === stepId;
            })) === null || ref === void 0 ? void 0 : ref.type);
        }).length;
    });
    if (pathLengths.length === 0) {
        return {
            shortestPathLength: 0,
            longestPathLength: 0
        };
    }
    return {
        shortestPathLength: (_Math = Math).min.apply(_Math, (0,_to_consumable_array/* default */.Z)(pathLengths)),
        longestPathLength: (_Math1 = Math).max.apply(_Math1, (0,_to_consumable_array/* default */.Z)(pathLengths))
    };
};

;// CONCATENATED MODULE: ./components/flows/components/FlowsMenu.tsx
/* eslint-disable react/jsx-no-duplicate-props */ 




var FlowsItem = function(param) {
    var flow = param.flow, setOpen = param.setOpen;
    var ref, ref1;
    var ref2 = (0,react.useState)(false), isHovered = ref2[0], setIsHovered = ref2[1];
    var ref3 = (0,react.useMemo)(function() {
        return calculatePathLengths(flow.steps, flow.edges);
    }, [
        flow
    ]), longestPathLength = ref3.longestPathLength, shortestPathLength = ref3.shortestPathLength;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
        direction: "row",
        alignItems: "center",
        justifyContent: "space-between",
        spacing: 2,
        width: "100%",
        height: "71px",
        p: "14px",
        onMouseEnter: function() {
            return setIsHovered(true);
        },
        onMouseLeave: function() {
            return setIsHovered(false);
        },
        onClick: function() {
            setOpen(false);
            flow === null || flow === void 0 ? void 0 : flow.handleFlowSelect(flow);
        },
        sx: {
            background: isHovered ? "rgba(255, 255, 255, 0.10)" : "transparent",
            cursor: "pointer"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                alignItems: "center",
                justifyContent: "center",
                sx: {
                    width: "37px",
                    height: "37px",
                    borderRadius: "8px",
                    background: "#FFF",
                    "& img": {
                        width: "inherit",
                        height: "inherit",
                        borderRadius: "8px"
                    }
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: (flow === null || flow === void 0 ? void 0 : (ref = flow.flowSetting) === null || ref === void 0 ? void 0 : ref.thumbnail) ? "".concat("https://cdn.treedis.com", "/tours/").concat(flow === null || flow === void 0 ? void 0 : flow.tourId, "/experience/flows/icons/").concat(flow === null || flow === void 0 ? void 0 : (ref1 = flow.flowSetting) === null || ref1 === void 0 ? void 0 : ref1.thumbnail) : "/flow.png",
                    alt: "flow-thumbnail"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                width: "100%",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        fontSize: "16px",
                        lineHeight: "21px",
                        fontWeight: 500,
                        children: flow.name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        fontSize: "14px",
                        lineHeight: "normal",
                        fontWeight: 400,
                        color: "rgba(255, 255, 255, 0.60)",
                        children: !flow.started ? "Not started" : "".concat(longestPathLength !== shortestPathLength ? "".concat(shortestPathLength, " - ").concat(longestPathLength, " steps") : "".concat(longestPathLength, " steps"))
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Zoom/* default */.Z, {
                in: isHovered,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                    className: "fa-solid fa-arrow-right",
                    style: {
                        color: "#fff"
                    }
                })
            })
        ]
    });
};
var FlowsMenu = function(param) {
    var flows = param.flows, tourCustomButton = param.tourCustomButton;
    var ref = (0,react.useState)(false), open = ref[0], setOpen = ref[1];
    var ref1 = (0,react.useState)(""), searchText = ref1[0], setSearchText = ref1[1];
    var filteredFlows = (0,react.useMemo)(function() {
        return flows.filter(function(f) {
            var ref, ref1, ref2;
            return ((ref1 = f === null || f === void 0 ? void 0 : (ref = f.name) === null || ref === void 0 ? void 0 : ref.toLowerCase()) === null || ref1 === void 0 ? void 0 : ref1.includes(searchText.toLowerCase())) || !!((ref2 = JSON.parse(f === null || f === void 0 ? void 0 : f.keywords)) === null || ref2 === void 0 ? void 0 : ref2.find(function(keyword) {
                return keyword === null || keyword === void 0 ? void 0 : keyword.includes(searchText.toLowerCase());
            }));
        });
    }, [
        flows,
        searchText
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonGroup/* default */.Z, {
                orientation: "vertical",
                sx: {
                    position: "absolute",
                    top: tourCustomButton ? "145px" : "195px",
                    right: 0,
                    backdropFilter: " blur(8.14285659790039px)",
                    background: "rgba(0, 0, 0, 0.80)",
                    borderRadius: "10px 0px 0px 10px"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                    onClick: function() {
                        return setOpen(function(prev) {
                            return !prev;
                        });
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                        className: "fa-solid fa-atom-simple",
                        style: {
                            color: "#FFF"
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Slide/* default */.Z, {
                in: open,
                direction: "left",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                    direction: "column",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    flexWrap: "wrap",
                    sx: {
                        position: "fixed",
                        top: "100px",
                        right: "50px",
                        width: "100%",
                        maxWidth: "334px",
                        height: "auto",
                        minHeight: "max(30vh, 350px)",
                        zIndex: 999,
                        color: "white",
                        transition: "all 225ms cubic-bezier(0, 0, 0.2, 1) 0ms !important",
                        borderRadius: "12px",
                        background: "rgba(13, 13, 13, 0.75)",
                        backdropFilter: "blur(20px)"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                            direction: "row",
                            alignItems: "center",
                            justifyContent: "space-between",
                            width: "100%",
                            height: "58px",
                            p: "10px 14px",
                            sx: {
                                background: "#0D0D0D",
                                borderRadius: "12px 12px 0px 0px"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                    direction: "row",
                                    spacing: 1,
                                    alignItems: "center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                                            sx: {
                                                borderRadius: "8px",
                                                background: "rgba(255, 255, 255, 0.10)"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                className: "fa-solid fa-atom-simple",
                                                style: {
                                                    color: "#FFF"
                                                }
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            lineHeight: "24px",
                                            fontSize: "16px",
                                            fontWeight: 600,
                                            children: "Flows list"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                    onClick: function() {
                                        return setOpen(false);
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        className: "fa fa-times",
                                        style: {
                                            color: "#FFF"
                                        }
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                            mt: "10px",
                            width: "100%",
                            p: "0 14px",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                                variant: "standard",
                                fullWidth: true,
                                placeholder: "Search",
                                sx: {
                                    background: "#0D0D0D",
                                    padding: "0px 10px",
                                    borderRadius: "8px"
                                },
                                value: searchText,
                                inputProps: {
                                    style: {
                                        color: "#fff",
                                        height: 45
                                    }
                                },
                                onChange: function(e) {
                                    return setSearchText(e.target.value);
                                },
                                InputProps: (0,_object_spread/* default */.Z)({
                                    sx: {
                                        "&:before": {
                                            borderBottom: "none !important"
                                        },
                                        "&:after": {
                                            borderBottom: "none !important"
                                        }
                                    },
                                    startAdornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment/* default */.Z, {
                                        position: "start",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                            className: "fa fa-search",
                                            style: {
                                                color: "lightgray"
                                            }
                                        })
                                    })
                                }, searchText && {
                                    endAdornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment/* default */.Z, {
                                        position: "end",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                            sx: {
                                                color: "lightgray"
                                            },
                                            onClick: function() {
                                                setSearchText("");
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                className: "fas fa-times"
                                            })
                                        })
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                            mt: "10px",
                            width: "100%",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    p: "0 14px",
                                    lineHeight: "24px",
                                    fontSize: "16px",
                                    fontWeight: 500,
                                    children: "Results"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                                    maxHeight: "434px",
                                    sx: {
                                        overflowY: "scroll"
                                    },
                                    children: filteredFlows === null || filteredFlows === void 0 ? void 0 : filteredFlows.map(function(flow) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(FlowsItem, {
                                            flow: flow,
                                            setOpen: setOpen
                                        }, flow === null || flow === void 0 ? void 0 : flow.id);
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/flows/icons/TeleportBtnIcon.tsx

var TeleportBtnIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M5.54069 11.998C5.54069 8.43063 8.43259 5.53874 11.9999 5.53874M5.54069 11.998C5.54069 15.5653 8.43259 18.4572 11.9999 18.4572M5.54069 11.998L3.69519 11.998M11.9999 5.53874C15.5673 5.53874 18.4592 8.43064 18.4592 11.998M11.9999 5.53874L11.9999 3.69324M11.9999 18.4572C15.5673 18.4572 18.4592 15.5653 18.4592 11.998M11.9999 18.4572L11.9999 20.3027M18.4592 11.998L20.3047 11.998M9.23169 11.998C9.23169 10.4691 10.471 9.22974 11.9999 9.22974C13.5288 9.22974 14.7682 10.4691 14.7682 11.998C14.7682 13.5269 13.5288 14.7662 11.9999 14.7662C10.471 14.7662 9.23169 13.5269 9.23169 11.998Z",
            stroke: "#2055FF",
            strokeWidth: "1.81195",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};

;// CONCATENATED MODULE: ./components/flows/components/styles.ts
var FlowbarWrapperStyle = {
    maxWidth: "800px",
    minWidth: "300px",
    // width: { xs: 'auto', sm: 'fit-content' },
    position: "absolute",
    left: 0,
    right: 0,
    bottom: {
        xs: "80px",
        sm: "50px"
    },
    marginLeft: {
        xs: "10px",
        sm: "auto"
    },
    marginRight: {
        xs: "10px",
        sm: "auto"
    },
    color: "#FFF",
    fontFamily: "Inter",
    transition: "max-width 225ms cubic-bezier(0, 0, 0.2, 1)"
};
var ExitSliderStyle = {
    position: "absolute",
    top: 20,
    left: 0,
    right: 0,
    marginLeft: "auto",
    marginRight: "auto",
    maxWidth: "310px",
    width: "100%",
    padding: "8px 10px 8px 14px",
    alignItems: "center",
    borderRadius: "12px",
    justifyContent: "space-between",
    background: "rgba(0, 0, 0, 0.75)",
    boxShadow: "0px 5px 6px -3px rgba(0, 0, 0, 0.25)",
    backdropFilter: "blur(7.5px)",
    height: "43px",
    p: "14px",
    color: "#FFF"
};
var ActionsWrapperStyle = {
    borderRadius: "10px 10px 0px 0px",
    background: "rgba(0, 0, 0, 0.40)",
    height: "29px",
    maxWidth: "235px",
    alignSelf: "flex-end",
    alignItems: "center",
    overflow: "hidden"
};
var ActionSectionStyle = {
    p: "0 8px",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
    "&:hover": {
        background: " linear-gradient(0deg, rgba(0, 0, 0, 0.20) 0%, rgba(0, 0, 0, 0.20) 100%), rgba(0, 0, 0, 0.40)"
    }
};
var FlowbarBodyStyle = {
    alignItems: "center",
    justifyContent: "flex-start",
    background: "rgba(0, 0, 0, 0.7)",
    boxShadow: "0px 12px 16px -4px rgba(16, 24, 40, 0.08), 0px 4px 6px -2px rgba(16, 24, 40, 0.03)",
    backdropFilter: "blur(20px)",
    p: "12px",
    flexWrap: "wrap"
};
var ImageContainerStyle = {
    alignItems: "center",
    justifyContent: "center",
    width: "50px",
    height: "50px",
    borderRadius: "8px",
    background: "transparent",
    "& img": {
        width: "inherit",
        height: "inherit",
        borderRadius: "8px"
    }
};
var PrevButtonStyle = {
    height: "42px",
    borderRadius: "35px",
    border: "1px solid rgba(0, 0, 0, 0.10)",
    background: "#FFF",
    alignItems: "center",
    justifyContent: "center",
    "&:hover": {
        background: "linear-gradient(0deg, rgba(0, 0, 0, 0.10) 0%, rgba(0, 0, 0, 0.10) 100%), radial-gradient(551.97% 120.63% at 92.59% 11.9%, rgba(255, 255, 255, 0.20) 0%, rgba(255, 255, 255, 0.00) 100%), var(--White, #FFF)"
    }
};
var TPButtonStyle = {
    height: "42px",
    borderRadius: "35px",
    border: "1px solid #2055FF",
    background: "#FFF",
    alignItems: "center",
    justifyContent: "center",
    "&:hover": {
        background: "#FFF"
    }
};
var TriggerButtonStyle = {
    borderRadius: "35px",
    height: "42px",
    // maxWidth: { xs: 'unset', sm: '168px' },
    minWidth: {
        xs: "unset",
        sm: "140px"
    },
    maxWidth: {
        xs: "unset",
        sm: "fit-content"
    },
    width: "auto",
    padding: "0 20px",
    background: "#2055FF",
    "&:hover": {
        background: "linear-gradient(0deg, rgba(0, 0, 0, 0.20) 0%, rgba(0, 0, 0, 0.20) 100%), radial-gradient(551.97% 120.63% at 92.59% 11.9%, rgba(255, 255, 255, 0.20) 0%, rgba(255, 255, 255, 0.00) 100%), var(--Blue-Main, #2055FF)"
    }
};

// EXTERNAL MODULE: ./components/flows/utils/getClosestSweep.ts
var getClosestSweep = __webpack_require__(22932);
// EXTERNAL MODULE: ./utils/three/getHorizontalRotationBetweenPoints.ts
var getHorizontalRotationBetweenPoints = __webpack_require__(1098);
;// CONCATENATED MODULE: ./components/flows/utils/rotateCameraToObject.ts




var rotateCameraToObject = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var showCaseTemp, currentPoint, nextPoint, pos1, pos2, yawDegrees, pitchDegrees;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    showCaseTemp = param.showCaseTemp, currentPoint = param.currentPoint, nextPoint = param.nextPoint;
                    pos1 = new three_module/* Vector3 */.Pa4(currentPoint.data.position.x, currentPoint.data.position.y, currentPoint.data.position.z);
                    pos2 = new three_module/* Vector3 */.Pa4(nextPoint.data.position.x, nextPoint.data.position.y, nextPoint.data.position.z);
                    yawDegrees = (0,getHorizontalRotationBetweenPoints/* getHorizontalRotationBetweenPoints */.Qm)(pos1, pos2);
                    pitchDegrees = (0,getHorizontalRotationBetweenPoints/* getVerticalRotationBetweenPoints */.bP)(pos1, pos2); //* 0.75;
                    return [
                        4,
                        showCaseTemp.showcase.Camera.setRotation({
                            x: pitchDegrees,
                            y: yawDegrees
                        }, 75)
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return function rotateCameraToObject(_) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./components/flows/hooks/useConditions.tsx














var useConditions_audioHandler = AudioModule/* AudioModule.getInstance */.w0.getInstance();
var movementTypesMap = {
    flyover: "FLY",
    instant: "INSTANT",
    fadeout: "FADEOUT"
};
var tagMoveMap = {
    instant: "transition.instant",
    flyover: "transition.fly",
    fadeout: "transition.fade"
};
var mapConditoinAssetToMusicObjectKey = {
    polygon: AudioModule/* MusicObjectKey.POLYGONS */.NO.POLYGONS,
    tag: AudioModule/* MusicObjectKey.TAGS */.NO.TAGS,
    image: AudioModule/* MusicObjectKey.VSIMAGES */.NO.VSIMAGES
};
var useConditions = function(param) {
    var showCaseTemp = param.showCaseTemp, showcase = param.showcase, tags = param.tags, showElements = param.showElements, hideElements = param.hideElements, moveToSweep = param.moveToSweep, flow = param.flow, setFlows = param.setFlows, polygons = param.polygons, vsObjects = param.vsObjects, navigationManager = param.navigationManager, allSweeps = param.allSweeps, currentFloor = param.currentFloor, flowsVisibleAssets = param.flowsVisibleAssets;
    var ref = (0,react.useState)([]), steps = ref[0], setSteps = ref[1];
    var ref1 = (0,react.useState)([]), stepsEdges = ref1[0], setStepsEdges = ref1[1];
    var ref2 = (0,react.useState)(null), currentStep = ref2[0], setCurrentStep = ref2[1];
    var ref3 = (0,react.useState)(null), distance = ref3[0], setDistance = ref3[1];
    var ref4 = (0,react.useState)(null), conditionToHold = ref4[0], setConditionToHold = ref4[1];
    var startingStep = (0,react.useMemo)(function() {
        return steps === null || steps === void 0 ? void 0 : steps.find(function(s) {
            return s.type === "start_step";
        });
    }, [
        steps
    ]);
    var ref5 = (0,react.useState)(false), showFlowBar = ref5[0], setShowFlowBar = ref5[1];
    var ref6 = (0,react.useState)([]), nextButtons = ref6[0], setNextButtons = ref6[1];
    var executedConditions = (0,react.useRef)(new Map());
    var videoStartedPlayingRef = (0,react.useRef)(false);
    (0,react.useEffect)(function() {
        (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                setCurrentStep(null);
                setSteps([]);
                setStepsEdges([]);
                setShowFlowBar(false);
                if (!flow) {
                    return [
                        2
                    ];
                }
                setSteps(flow === null || flow === void 0 ? void 0 : flow.steps);
                setStepsEdges(flow === null || flow === void 0 ? void 0 : flow.edges);
                return [
                    2
                ];
            });
        })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        flow === null || flow === void 0 ? void 0 : flow.id
    ]);
    (0,react.useEffect)(function() {
        var ref, ref1;
        if (startingStep && !currentStep && (flow === null || flow === void 0 ? void 0 : (ref = flow.steps) === null || ref === void 0 ? void 0 : ref.every(function(step) {
            return !step.completed;
        })) || !currentStep && (flow === null || flow === void 0 ? void 0 : flow.restart)) {
            setCurrentStep(startingStep);
        }
        if (!currentStep && (flow === null || flow === void 0 ? void 0 : (ref1 = flow.steps) === null || ref1 === void 0 ? void 0 : ref1.some(function(step) {
            return step.completed;
        })) && !(flow === null || flow === void 0 ? void 0 : flow.restart)) {
            var ref2;
            var lastUnfinishedStep = flow === null || flow === void 0 ? void 0 : (ref2 = flow.steps) === null || ref2 === void 0 ? void 0 : ref2.filter(function(step) {
                return step.type === "regular_step";
            }).find(function(step) {
                return !step.completed;
            });
            var stepWithFullData = steps === null || steps === void 0 ? void 0 : steps.find(function(step) {
                return step.id === lastUnfinishedStep.id;
            });
            setCurrentStep(stepWithFullData);
        }
    }, [
        startingStep,
        currentStep,
        flow,
        steps
    ]);
    (0,react.useEffect)(function() {
        if (!navigationManager || !navigationManager.component) return;
        navigationManager.component.inputs.onDistanceChanged = function(d) {
            setDistance(d);
        };
        // eslint-disable-next-line consistent-return
        return function() {
            navigationManager.reset();
            setDistance(null);
        };
    }, [
        navigationManager,
        currentStep
    ]);
    var handleTeleportToStep = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(step) {
            var shouldReset, urlParams, s, x, y, tag, transition, mapTargetByAssetType, target, closestSweep, transition1, cameraPose;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        shouldReset = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : true;
                        if (!((step === null || step === void 0 ? void 0 : step.deepLink) && (step === null || step === void 0 ? void 0 : step.deepLink) !== "null" && !(step === null || step === void 0 ? void 0 : step.posAssetType))) return [
                            3,
                            2
                        ];
                        urlParams = new URLSearchParams(step === null || step === void 0 ? void 0 : step.deepLink.replace(/(.+\?)/, "?"));
                        s = urlParams.get("s");
                        x = urlParams.get("x");
                        y = urlParams.get("y");
                        return [
                            4,
                            moveToSweep(s, {
                                x: parseFloat(x),
                                y: parseFloat(y)
                            }, movementTypesMap[step === null || step === void 0 ? void 0 : step.webMovement] || "FLY", false)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            8
                        ];
                    case 2:
                        if (!((step === null || step === void 0 ? void 0 : step.posAssetType) === "tag")) return [
                            3,
                            4
                        ];
                        tag = tags.find(function(t) {
                            return t.id === (step === null || step === void 0 ? void 0 : step.posAssetId);
                        });
                        transition = tagMoveMap[step === null || step === void 0 ? void 0 : step.webMovement] || "transition.fly";
                        return [
                            4,
                            showCaseTemp.showcase.Mattertag.navigateToTag(tag.sid, transition, true)
                        ];
                    case 3:
                        _state.sent();
                        return [
                            3,
                            8
                        ];
                    case 4:
                        mapTargetByAssetType = {
                            polygon: polygons.find(function(p) {
                                return p.id === (step === null || step === void 0 ? void 0 : step.posAssetId);
                            }),
                            image: vsObjects.find(function(obj) {
                                return (0,_instanceof/* default */.Z)(obj, VSObject/* TourImage */.oP) && obj.id === (step === null || step === void 0 ? void 0 : step.posAssetId);
                            }),
                            video: vsObjects.find(function(obj) {
                                return (0,_instanceof/* default */.Z)(obj, VSObject/* TourVideo */.Up) && obj.id === (step === null || step === void 0 ? void 0 : step.posAssetId);
                            }),
                            html: vsObjects.find(function(obj) {
                                return (0,_instanceof/* default */.Z)(obj, VSObject/* TourVSHtml */.q8) && obj.id === (step === null || step === void 0 ? void 0 : step.posAssetId);
                            }),
                            vsObject: vsObjects.find(function(obj) {
                                return (0,_instanceof/* default */.Z)(obj, VSObject/* TourObject */.zB) && obj.id === (step === null || step === void 0 ? void 0 : step.posAssetId);
                            })
                        };
                        target = mapTargetByAssetType[step === null || step === void 0 ? void 0 : step.posAssetType];
                        if (!target) return [
                            3,
                            8
                        ];
                        closestSweep = (0,getClosestSweep/* getClosestSweepFromObject */.e)({
                            allSweeps: allSweeps,
                            target: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, target), {
                                floor: currentFloor || 0
                            })
                        }).closestSweep;
                        if (!closestSweep) return [
                            3,
                            8
                        ];
                        transition1 = movementTypesMap[step === null || step === void 0 ? void 0 : step.webMovement] || "FLY";
                        return [
                            4,
                            moveToSweep(closestSweep === null || closestSweep === void 0 ? void 0 : closestSweep.id, {
                                x: 0,
                                y: 0
                            }, transition1, false)
                        ];
                    case 5:
                        _state.sent();
                        return [
                            4,
                            showcase.Camera.getPose()
                        ];
                    case 6:
                        cameraPose = _state.sent();
                        return [
                            4,
                            rotateCameraToObject({
                                showCaseTemp: showCaseTemp,
                                currentPoint: {
                                    data: {
                                        position: {
                                            x: cameraPose === null || cameraPose === void 0 ? void 0 : cameraPose.position.x,
                                            y: cameraPose === null || cameraPose === void 0 ? void 0 : cameraPose.position.y,
                                            z: cameraPose === null || cameraPose === void 0 ? void 0 : cameraPose.position.z
                                        }
                                    }
                                },
                                nextPoint: {
                                    data: {
                                        position: {
                                            x: target.positionX,
                                            y: target === null || target === void 0 ? void 0 : target.positionY,
                                            z: target.positionZ
                                        }
                                    }
                                }
                            })
                        ];
                    case 7:
                        _state.sent();
                        _state.label = 8;
                    case 8:
                        if (shouldReset) navigationManager.reset();
                        return [
                            2
                        ];
                }
            });
        });
        return function handleTeleportToStep(step) {
            return _ref.apply(this, arguments);
        };
    }();
    var renderPathToCurrentStep = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(step) {
            var ref, urlParams, s, target, tag, closestSweep, mapTargetByAssetType, target1, closestSweep1;
            return (0,tslib_es6.__generator)(this, function(_state) {
                if ((step === null || step === void 0 ? void 0 : step.deepLink) && (step === null || step === void 0 ? void 0 : step.deepLink) !== "null" && !(step === null || step === void 0 ? void 0 : step.posAssetType)) {
                    ;
                    urlParams = new URLSearchParams(step === null || step === void 0 ? void 0 : step.deepLink.replace(/(.+\?)/, "?"));
                    s = urlParams.get("s");
                    target = (ref = Array.from(allSweeps, function(param) {
                        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), value = _param[1];
                        return value;
                    })) === null || ref === void 0 ? void 0 : ref.find(function(item) {
                        return item.sweep_uuid === s || item.id === s;
                    });
                    if (target) {
                        navigationManager.renderPath(navigationManager.currentSID, target === null || target === void 0 ? void 0 : target.id);
                    }
                } else if ((step === null || step === void 0 ? void 0 : step.posAssetType) === "tag") {
                    tag = tags.find(function(t) {
                        return t.id === (step === null || step === void 0 ? void 0 : step.posAssetId);
                    });
                    closestSweep = (0,getClosestSweep/* getClosestSweepFromObject */.e)({
                        allSweeps: allSweeps,
                        target: tag
                    }).closestSweep;
                    if (closestSweep && (closestSweep === null || closestSweep === void 0 ? void 0 : closestSweep.id) !== navigationManager.currentSID) {
                        navigationManager.renderPath(navigationManager.currentSID, closestSweep === null || closestSweep === void 0 ? void 0 : closestSweep.id, undefined, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, tag), {
                            enableNavBar: false,
                            enableTeleportBtn: false,
                            autoNavigation: false
                        }));
                    }
                } else {
                    mapTargetByAssetType = {
                        polygon: polygons.find(function(p) {
                            return p.id === (step === null || step === void 0 ? void 0 : step.posAssetId);
                        }),
                        image: vsObjects.find(function(obj) {
                            return (0,_instanceof/* default */.Z)(obj, VSObject/* TourImage */.oP) && obj.id === (step === null || step === void 0 ? void 0 : step.posAssetId);
                        }),
                        video: vsObjects.find(function(obj) {
                            return (0,_instanceof/* default */.Z)(obj, VSObject/* TourVideo */.Up) && obj.id === (step === null || step === void 0 ? void 0 : step.posAssetId);
                        }),
                        html: vsObjects.find(function(obj) {
                            return (0,_instanceof/* default */.Z)(obj, VSObject/* TourVSHtml */.q8) && obj.id === (step === null || step === void 0 ? void 0 : step.posAssetId);
                        }),
                        vsObject: vsObjects.find(function(obj) {
                            return (0,_instanceof/* default */.Z)(obj, VSObject/* TourObject */.zB) && obj.id === (step === null || step === void 0 ? void 0 : step.posAssetId);
                        })
                    };
                    target1 = mapTargetByAssetType[step === null || step === void 0 ? void 0 : step.posAssetType];
                    if (target1) {
                        closestSweep1 = (0,getClosestSweep/* getClosestSweepFromObject */.e)({
                            allSweeps: allSweeps,
                            target: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, target1), {
                                floor: currentFloor || 0
                            })
                        }).closestSweep;
                        if (closestSweep1 && (closestSweep1 === null || closestSweep1 === void 0 ? void 0 : closestSweep1.id) !== navigationManager.currentSID) {
                            navigationManager.renderPath(navigationManager.currentSID, closestSweep1 === null || closestSweep1 === void 0 ? void 0 : closestSweep1.id, undefined, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, target1), {
                                enableNavBar: false,
                                enableTeleportBtn: false,
                                autoNavigation: false
                            }));
                        }
                    }
                }
                return [
                    2
                ];
            });
        });
        return function renderPathToCurrentStep(step) {
            return _ref.apply(this, arguments);
        };
    }();
    // Function to execute each condition
    var executeCondition = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(condition) {
            var currentConditions, _, ref, ref1, ref2, vsImagesToReveal, vsVideosToReveal, vsHTMLsToReveal, vsItemsToReveal, ref3, ref4, ref5, vsImagesToHide, vsVideosToHide, vsHTMLsToHide, vsItemsToHide;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if ((condition === null || condition === void 0 ? void 0 : condition.action) !== flows_types/* ActionTypes.DELAY_FLOWBAR */.M.DELAY_FLOWBAR || (condition === null || condition === void 0 ? void 0 : condition.action) !== flows_types/* ActionTypes.DELAY */.M.DELAY) {
                            currentConditions = executedConditions.current.get(currentStep === null || currentStep === void 0 ? void 0 : currentStep.id) || new Set();
                            // Add the condition to the set
                            currentConditions.add(condition);
                            // Update the map with the new set of conditions
                            executedConditions.current.set(currentStep === null || currentStep === void 0 ? void 0 : currentStep.id, currentConditions);
                        }
                        _ = condition.action;
                        switch(_){
                            case flows_types/* ActionTypes.DELAY_FLOWBAR */.M.DELAY_FLOWBAR:
                                return [
                                    3,
                                    1
                                ];
                            case flows_types/* ActionTypes.DELAY */.M.DELAY:
                                return [
                                    3,
                                    3
                                ];
                            case flows_types/* ActionTypes.SHOW_ASSET */.M.SHOW_ASSET:
                                return [
                                    3,
                                    5
                                ];
                            case flows_types/* ActionTypes.HIDE_ASSET */.M.HIDE_ASSET:
                                return [
                                    3,
                                    7
                                ];
                            case flows_types/* ActionTypes.SHOW_SWEEP */.M.SHOW_SWEEP:
                                return [
                                    3,
                                    9
                                ];
                            case flows_types/* ActionTypes.HIDE_SWEEP */.M.HIDE_SWEEP:
                                return [
                                    3,
                                    11
                                ];
                            case flows_types/* ActionTypes.POSITION_TO */.M.POSITION_TO:
                                return [
                                    3,
                                    13
                                ];
                        }
                        return [
                            3,
                            14
                        ];
                    case 1:
                        return [
                            4,
                            new Promise(function(resolve) {
                                return setTimeout(resolve, condition.delay * 1000);
                            })
                        ];
                    case 2:
                        _state.sent();
                        setShowFlowBar(true);
                        return [
                            3,
                            15
                        ];
                    case 3:
                        return [
                            4,
                            new Promise(function(resolve) {
                                return setTimeout(resolve, condition.delay * 1000);
                            })
                        ];
                    case 4:
                        _state.sent();
                        return [
                            3,
                            15
                        ];
                    case 5:
                        vsImagesToReveal = condition === null || condition === void 0 ? void 0 : (ref = condition.vsItems) === null || ref === void 0 ? void 0 : ref.filter(function(item) {
                            return item.includes("image");
                        }).map(function(item) {
                            return item.replace("image_", "");
                        });
                        vsVideosToReveal = condition === null || condition === void 0 ? void 0 : (ref1 = condition.vsItems) === null || ref1 === void 0 ? void 0 : ref1.filter(function(item) {
                            return item.includes("video");
                        }).map(function(item) {
                            return item.replace("video_", "");
                        });
                        vsHTMLsToReveal = condition === null || condition === void 0 ? void 0 : (ref2 = condition.vsItems) === null || ref2 === void 0 ? void 0 : ref2.filter(function(item) {
                            return item.includes("html");
                        }).map(function(item) {
                            return item.replace("html_", "");
                        });
                        vsItemsToReveal = condition === null || condition === void 0 ? void 0 : condition.vsObjects;
                        return [
                            4,
                            showElements({
                                tagsToReveal: condition === null || condition === void 0 ? void 0 : condition.tags,
                                polygonsToReveal: condition === null || condition === void 0 ? void 0 : condition.polygons,
                                vsImagesToReveal: vsImagesToReveal,
                                vsVideosToReveal: vsVideosToReveal,
                                vsHTMLsToReveal: vsHTMLsToReveal,
                                vsItemsToReveal: vsItemsToReveal
                            })
                        ];
                    case 6:
                        _state.sent();
                        return [
                            3,
                            15
                        ];
                    case 7:
                        vsImagesToHide = condition === null || condition === void 0 ? void 0 : (ref3 = condition.vsItems) === null || ref3 === void 0 ? void 0 : ref3.filter(function(item) {
                            return item.includes("image");
                        }).map(function(item) {
                            return item.replace("image_", "");
                        });
                        vsVideosToHide = condition === null || condition === void 0 ? void 0 : (ref4 = condition.vsItems) === null || ref4 === void 0 ? void 0 : ref4.filter(function(item) {
                            return item.includes("video");
                        }).map(function(item) {
                            return item.replace("video_", "");
                        });
                        vsHTMLsToHide = condition === null || condition === void 0 ? void 0 : (ref5 = condition.vsItems) === null || ref5 === void 0 ? void 0 : ref5.filter(function(item) {
                            return item.includes("html");
                        }).map(function(item) {
                            return item.replace("html_", "");
                        });
                        vsItemsToHide = condition === null || condition === void 0 ? void 0 : condition.vsObjects;
                        return [
                            4,
                            hideElements({
                                hideTags: condition === null || condition === void 0 ? void 0 : condition.tags,
                                polygonsToHide: condition === null || condition === void 0 ? void 0 : condition.polygons,
                                vsImagesToHide: vsImagesToHide,
                                vsVideosToHide: vsVideosToHide,
                                vsHTMLsToHide: vsHTMLsToHide,
                                vsItemsToHide: vsItemsToHide
                            }, true)
                        ];
                    case 8:
                        _state.sent();
                        return [
                            3,
                            15
                        ];
                    case 9:
                        return [
                            4,
                            showElements({
                                sweepsToReveal: condition === null || condition === void 0 ? void 0 : condition.sweeps
                            })
                        ];
                    case 10:
                        _state.sent();
                        return [
                            3,
                            15
                        ];
                    case 11:
                        return [
                            4,
                            hideElements({
                                sweepsToHide: condition === null || condition === void 0 ? void 0 : condition.sweeps
                            })
                        ];
                    case 12:
                        _state.sent();
                        return [
                            3,
                            15
                        ];
                    case 13:
                        if (condition.webMovement !== "navigationPath") {
                            handleTeleportToStep({
                                deepLink: condition.positionUrl,
                                posAssetType: condition.posAssetType,
                                posAssetId: condition.posAssetId,
                                webMovement: condition.webMovement
                            }, false);
                        } else {
                            renderPathToCurrentStep({
                                deepLink: condition.positionUrl,
                                posAssetType: condition.posAssetType,
                                posAssetId: condition.posAssetId,
                                webMovement: condition.webMovement
                            });
                        }
                        return [
                            3,
                            15
                        ];
                    case 14:
                        return [
                            3,
                            15
                        ];
                    case 15:
                        return [
                            2
                        ];
                }
            });
        });
        return function(condition) {
            return _ref.apply(this, arguments);
        };
    }(), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        currentStep
    ]);
    var enableTriggers = (0,react.useCallback)(function(param) {
        var assetType = param.assetType, assetId = param.assetId;
        var ref, ref1;
        var currentStepDisabledTriggersIds = (ref1 = currentStep === null || currentStep === void 0 ? void 0 : (ref = currentStep.triggers) === null || ref === void 0 ? void 0 : ref.filter(function(t) {
            var ref, ref1;
            return (t === null || t === void 0 ? void 0 : (ref = t.condition) === null || ref === void 0 ? void 0 : ref.unlockAsset) === assetType && (t === null || t === void 0 ? void 0 : (ref1 = t.condition) === null || ref1 === void 0 ? void 0 : ref1.unlockAssetId) === assetId;
        })) === null || ref1 === void 0 ? void 0 : ref1.map(function(t) {
            return t.id;
        });
        if ((currentStepDisabledTriggersIds === null || currentStepDisabledTriggersIds === void 0 ? void 0 : currentStepDisabledTriggersIds.length) > 0) {
            setNextButtons(function(prev) {
                return prev.map(function(t) {
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, t), {
                        disabled: t.disabled ? !(currentStepDisabledTriggersIds === null || currentStepDisabledTriggersIds === void 0 ? void 0 : currentStepDisabledTriggersIds.includes(t.id)) : t.disabled
                    });
                });
            });
        }
    }, [
        currentStep
    ]);
    var executeConditionsInOrder = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(conditions) {
            var executeNext;
            return (0,tslib_es6.__generator)(this, function(_state) {
                executeNext = function() {
                    var _ref = (0,_async_to_generator/* default */.Z)(function(index) {
                        var condition;
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    if (index >= (conditions === null || conditions === void 0 ? void 0 : conditions.length)) {
                                        enableTriggers({
                                            assetType: "condition",
                                            assetId: conditions[0].conditionId
                                        });
                                        return [
                                            2,
                                            Promise.resolve()
                                        ];
                                    }
                                    condition = conditions[index];
                                    return [
                                        4,
                                        executeCondition(condition)
                                    ];
                                case 1:
                                    _state.sent();
                                    return [
                                        2,
                                        executeNext(index + 1)
                                    ];
                            }
                        });
                    });
                    return function executeNext(index) {
                        return _ref.apply(this, arguments);
                    };
                }();
                return [
                    2,
                    executeNext(0)
                ];
            });
        });
        return function executeConditionsInOrder(conditions) {
            return _ref.apply(this, arguments);
        };
    }();
    var executeNextStepTrigger = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(trigger) {
            var nextStepEdge, ref, ref1, nextStep, ref2;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        nextStepEdge = stepsEdges === null || stepsEdges === void 0 ? void 0 : stepsEdges.find(function(edge) {
                            return edge.trigger === trigger.id;
                        });
                        if (!nextStepEdge) return [
                            3,
                            3
                        ];
                        nextStep = steps === null || steps === void 0 ? void 0 : steps.find(function(step) {
                            return step.id === (nextStepEdge === null || nextStepEdge === void 0 ? void 0 : nextStepEdge.target);
                        });
                        if (!((trigger === null || trigger === void 0 ? void 0 : (ref = trigger.condition) === null || ref === void 0 ? void 0 : (ref1 = ref.rows) === null || ref1 === void 0 ? void 0 : ref1.length) > 0)) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            executeConditionsInOrder(trigger === null || trigger === void 0 ? void 0 : (ref2 = trigger.condition) === null || ref2 === void 0 ? void 0 : ref2.rows)
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        setCurrentStep((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, nextStep), {
                            triggeredBy: trigger.id
                        }));
                        setSteps(function(prev) {
                            return prev.map(function(s) {
                                return s.id === nextStep.id ? (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, s), {
                                    triggeredBy: trigger.id
                                }) : s;
                            });
                        });
                        setFlows(function(prev) {
                            return prev.map(function(f) {
                                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, f), {
                                    steps: f.steps.map(function(s) {
                                        return s.id === trigger.stepId ? (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, s), {
                                            completed: true
                                        }) : s;
                                    })
                                });
                            });
                        });
                        _state.label = 3;
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function executeNextStepTrigger(trigger) {
            return _ref.apply(this, arguments);
        };
    }();
    // step conditions
    (0,react.useEffect)(function() {
        (0,_async_to_generator/* default */.Z)(function() {
            var ref, ref1, ref2, stepConditions, currentStepHasDelayFlowbar, sortedConditions, nextStepEdge, nextStep;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!currentStep) return [
                            3,
                            5
                        ];
                        if (!(currentStep.type === "regular_step" && currentStep.webMovement === "navigationPath")) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            renderPathToCurrentStep(currentStep)
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        stepConditions = (ref1 = currentStep === null || currentStep === void 0 ? void 0 : (ref = currentStep.conditions) === null || ref === void 0 ? void 0 : ref.find(function(c) {
                            return c.action === "start";
                        })) === null || ref1 === void 0 ? void 0 : ref1.rows;
                        currentStepHasDelayFlowbar = currentStep === null || currentStep === void 0 ? void 0 : (ref2 = currentStep.conditions) === null || ref2 === void 0 ? void 0 : ref2.find(function(c) {
                            var ref;
                            return (ref = c.rows) === null || ref === void 0 ? void 0 : ref.find(function(r) {
                                return r.action === flows_types/* ActionTypes.DELAY_FLOWBAR */.M.DELAY_FLOWBAR;
                            });
                        });
                        if (currentStep.type === "regular_step" && !currentStepHasDelayFlowbar) {
                            setShowFlowBar(true);
                        }
                        if (!(stepConditions && stepConditions.length > 0)) return [
                            3,
                            4
                        ];
                        sortedConditions = (0,_to_consumable_array/* default */.Z)(stepConditions).sort(function(a, b) {
                            return a.order - b.order;
                        }).map(function(c) {
                            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, c), {
                                isStartCondition: true
                            });
                        });
                        return [
                            4,
                            executeConditionsInOrder(sortedConditions)
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        if ((currentStep === null || currentStep === void 0 ? void 0 : currentStep.type) === "start_step") {
                            nextStepEdge = stepsEdges === null || stepsEdges === void 0 ? void 0 : stepsEdges.find(function(edge) {
                                return edge.source === currentStep.id;
                            });
                            nextStep = steps === null || steps === void 0 ? void 0 : steps.find(function(step) {
                                return step.id === (nextStepEdge === null || nextStepEdge === void 0 ? void 0 : nextStepEdge.target);
                            });
                            setCurrentStep(nextStep);
                        }
                        _state.label = 5;
                    case 5:
                        return [
                            2
                        ];
                }
            });
        })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        currentStep
    ]);
    // reload audio
    var reloadAudio = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(condition) {
            var ref, ref1, ref2, audioId, audio;
            return (0,tslib_es6.__generator)(this, function(_state) {
                audioId = (condition === null || condition === void 0 ? void 0 : condition.asset) === "polygon" ? (ref2 = (ref = polygons.find(function(p) {
                    return p.id === (condition === null || condition === void 0 ? void 0 : condition.assetId);
                })) === null || ref === void 0 ? void 0 : (ref1 = ref.polygonsActions) === null || ref1 === void 0 ? void 0 : ref1.find(function(a) {
                    return a.type === "music";
                })) === null || ref2 === void 0 ? void 0 : ref2.id : condition === null || condition === void 0 ? void 0 : condition.assetId;
                if (!audioId) {
                    console.warn("Audio id not found");
                }
                audio = useConditions_audioHandler.getAudio(mapConditoinAssetToMusicObjectKey[condition === null || condition === void 0 ? void 0 : condition.asset], audioId);
                if (audio && audio.readyState === 0) {
                    audio.load();
                }
                return [
                    2,
                    audio
                ];
            });
        });
        return function(condition) {
            return _ref.apply(this, arguments);
        };
    }(), [
        polygons
    ]);
    var handleAssetClick = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(assetType, assetId) {
            var ref, ref1, ref2, ref3, ref4, ref5, clickConditions, assetClickConditions, trigger, holdCondition, triggerHold, actionsStart, triggerActionsStart, combinedStartObj, combinedHoldObj, ref6;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        clickConditions = currentStep === null || currentStep === void 0 ? void 0 : (ref = currentStep.conditions) === null || ref === void 0 ? void 0 : ref.filter(function(c) {
                            return c.action === "click";
                        });
                        assetClickConditions = (ref1 = clickConditions === null || clickConditions === void 0 ? void 0 : clickConditions.find(function(c) {
                            return c.asset === assetType && c.assetId === assetId;
                        })) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.rows) === null || ref2 === void 0 ? void 0 : ref2.sort(function(a, b) {
                            return a.order - b.order;
                        });
                        trigger = currentStep === null || currentStep === void 0 ? void 0 : (ref3 = currentStep.triggers) === null || ref3 === void 0 ? void 0 : ref3.find(function(t) {
                            return t.asset === assetType && t.assetId === assetId;
                        });
                        holdCondition = clickConditions === null || clickConditions === void 0 ? void 0 : clickConditions.find(function(c) {
                            return c.assetId === assetId && c.after === "actionFinished";
                        });
                        triggerHold = (trigger === null || trigger === void 0 ? void 0 : (ref4 = trigger.condition) === null || ref4 === void 0 ? void 0 : ref4.after) === "actionFinished" && (trigger === null || trigger === void 0 ? void 0 : trigger.condition);
                        actionsStart = clickConditions === null || clickConditions === void 0 ? void 0 : clickConditions.find(function(c) {
                            return c.assetId === assetId && c.after === "actionsStart";
                        });
                        triggerActionsStart = (trigger === null || trigger === void 0 ? void 0 : (ref5 = trigger.condition) === null || ref5 === void 0 ? void 0 : ref5.after) === "actionsStart" && (trigger === null || trigger === void 0 ? void 0 : trigger.condition);
                        enableTriggers({
                            assetType: assetType,
                            assetId: assetId
                        });
                        if (!(actionsStart || triggerActionsStart)) return [
                            3,
                            2
                        ];
                        combinedStartObj = (0,_object_spread/* default */.Z)({}, actionsStart || {}, triggerActionsStart || {});
                        return [
                            4,
                            reloadAudio(combinedStartObj)
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        if (holdCondition || triggerHold) {
                            combinedHoldObj = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, holdCondition || {}, triggerHold || {}), {
                                rows: (0,_to_consumable_array/* default */.Z)((holdCondition === null || holdCondition === void 0 ? void 0 : holdCondition.rows) || []).concat((0,_to_consumable_array/* default */.Z)((triggerHold === null || triggerHold === void 0 ? void 0 : triggerHold.rows) || [])),
                                trigger: trigger
                            });
                            assetClickConditions = assetClickConditions === null || assetClickConditions === void 0 ? void 0 : assetClickConditions.filter(function(c) {
                                return c.conditionId !== combinedHoldObj.id;
                            });
                            setConditionToHold(combinedHoldObj);
                        }
                        if (!assetClickConditions) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            executeConditionsInOrder(assetClickConditions)
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        if (!(trigger && !holdCondition && !triggerHold)) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            executeNextStepTrigger((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, trigger), {
                                condition: {
                                    rows: (0,_to_consumable_array/* default */.Z)(assetClickConditions || []).concat((0,_to_consumable_array/* default */.Z)(trigger === null || trigger === void 0 ? void 0 : (ref6 = trigger.condition) === null || ref6 === void 0 ? void 0 : ref6.rows))
                                }
                            }))
                        ];
                    case 5:
                        _state.sent();
                        _state.label = 6;
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return function(assetType, assetId) {
            return _ref.apply(this, arguments);
        };
    }(), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        currentStep
    ]);
    var handleTagClick = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(tagId) {
            var tag;
            return (0,tslib_es6.__generator)(this, function(_state) {
                tag = tags.find(function(t) {
                    return t.sid === tagId || t.defaultSid === tagId;
                });
                handleAssetClick(flows_types/* ClickAssetTypes.Tag */.n.Tag, tag === null || tag === void 0 ? void 0 : tag.id);
                return [
                    2
                ];
            });
        });
        return function(tagId) {
            return _ref.apply(this, arguments);
        };
    }(), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        tags,
        currentStep
    ]);
    var assetEventMap = (0,react.useMemo)(function() {
        return {
            scenePolygon: {
                assetType: flows_types/* ClickAssetTypes.Polygon */.n.Polygon,
                eventType: dist/* NodeEventsTypes.POLYGON_CLICK */.cA.POLYGON_CLICK,
                onClick: function(param) {
                    var assetId = param.assetId;
                    return handleAssetClick(flows_types/* ClickAssetTypes.Polygon */.n.Polygon, assetId);
                }
            },
            sceneObject: {
                assetType: flows_types/* ClickAssetTypes.VsObject */.n.VsObject,
                eventType: dist/* NodeEventsTypes.OBJECT_CLICK */.cA.OBJECT_CLICK,
                onClick: function(param) {
                    var data = param.data;
                    return handleAssetClick(flows_types/* ClickAssetTypes.VsObject */.n.VsObject, data.id);
                }
            },
            sceneImage: {
                asssetType: flows_types/* ClickAssetTypes.Image */.n.Image,
                eventType: dist/* NodeEventsTypes.IMAGE_CLICK */.cA.IMAGE_CLICK,
                onClick: function(param) {
                    var data = param.data;
                    return handleAssetClick(flows_types/* ClickAssetTypes.Image */.n.Image, data.id);
                }
            },
            sceneVideo: {
                assetType: flows_types/* ClickAssetTypes.Video */.n.Video,
                eventType: dist/* NodeEventsTypes.VIDEO_CLICK */.cA.VIDEO_CLICK,
                onClick: function(param) {
                    var data = param.data;
                    return handleAssetClick(flows_types/* ClickAssetTypes.Video */.n.Video, data.id);
                }
            },
            sceneHTML: {
                assetType: flows_types/* ClickAssetTypes.HTML */.n.HTML,
                eventType: dist/* NodeEventsTypes.HTML_CLICK */.cA.HTML_CLICK,
                onClick: function(param) {
                    var data = param.data;
                    return handleAssetClick(flows_types/* ClickAssetTypes.HTML */.n.HTML, data.id);
                }
            }
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        currentStep
    ]);
    var handleVideoButtonClick = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
            var data, component, btnComponent, ref, ref1, videoStartPlayingConditions;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        data = param.data, component = param.component, btnComponent = param.btnComponent;
                        component.video.addEventListener("play", function() {
                            videoStartedPlayingRef.current = true;
                        });
                        if (!(btnComponent.inputs.type === "play" && !videoStartedPlayingRef.current)) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            handleAssetClick(flows_types/* ClickAssetTypes.Video */.n.Video, data.id)
                        ];
                    case 1:
                        _state.sent();
                        videoStartPlayingConditions = (ref1 = currentStep === null || currentStep === void 0 ? void 0 : (ref = currentStep.conditions) === null || ref === void 0 ? void 0 : ref.find(function(c) {
                            return c.assetId === data.id && c.action === "start_playing";
                        })) === null || ref1 === void 0 ? void 0 : ref1.rows;
                        if (!(videoStartPlayingConditions === null || videoStartPlayingConditions === void 0 ? void 0 : videoStartPlayingConditions.length)) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            executeConditionsInOrder(videoStartPlayingConditions)
                        ];
                    case 2:
                        _state.sent();
                        _state.label = 3;
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleVideoButtonClick(_) {
            return _ref.apply(this, arguments);
        };
    }();
    // click conditions
    (0,react.useEffect)(function() {
        if (!showCaseTemp || !showcase || !currentStep) return;
        showcase.on(showcase.Mattertag.Event.CLICK, handleTagClick);
        showCaseTemp.scene.sceneVideo.on(dist/* NodeEventsTypes.VIDEO_BUTTON_CLICK */.cA.VIDEO_BUTTON_CLICK, handleVideoButtonClick);
        Object.entries(assetEventMap).forEach(function(param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], value = _param[1];
            showCaseTemp.scene[key].on(value.eventType, value.onClick);
        });
        // eslint-disable-next-line consistent-return
        return function() {
            showcase.off(showcase.Mattertag.Event.CLICK, handleTagClick);
            Object.entries(assetEventMap).forEach(function(param) {
                var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], value = _param[1];
                showCaseTemp.scene[key].off(value.eventType, value.onClick);
            });
            showCaseTemp.scene.sceneVideo.off(dist/* NodeEventsTypes.VIDEO_BUTTON_CLICK */.cA.VIDEO_BUTTON_CLICK, handleVideoButtonClick);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        showCaseTemp,
        showcase,
        currentStep
    ]);
    // check for music action type delay
    (0,react.useEffect)(function() {
        var checkForAudioData = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(condition) {
                var audio;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                reloadAudio(condition)
                            ];
                        case 1:
                            audio = _state.sent();
                            audio.addEventListener("ended", /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                                return (0,tslib_es6.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            if (!condition.trigger) return [
                                                3,
                                                2
                                            ];
                                            return [
                                                4,
                                                executeNextStepTrigger((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, condition.trigger), {
                                                    condition: {
                                                        rows: condition === null || condition === void 0 ? void 0 : condition.rows
                                                    }
                                                }))
                                            ];
                                        case 1:
                                            _state.sent();
                                            return [
                                                3,
                                                4
                                            ];
                                        case 2:
                                            return [
                                                4,
                                                executeConditionsInOrder(condition === null || condition === void 0 ? void 0 : condition.rows)
                                            ];
                                        case 3:
                                            _state.sent();
                                            _state.label = 4;
                                        case 4:
                                            setConditionToHold(null);
                                            audio.pause();
                                            audio.currentTime = 0;
                                            return [
                                                2
                                            ];
                                    }
                                });
                            }));
                            return [
                                2
                            ];
                    }
                });
            });
            return function checkForAudioData(condition) {
                return _ref.apply(this, arguments);
            };
        }();
        if (conditionToHold) {
            checkForAudioData(conditionToHold);
        }
        return function() {
            setConditionToHold(null);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        conditionToHold
    ]);
    var executeFinishPlayingConditions = (0,react.useCallback)(function(obj, type) {
        /*#__PURE__*/ return (0,_async_to_generator/* default */.Z)(function() {
            var ref, ref1, finishPlayingConditions;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        finishPlayingConditions = (ref1 = currentStep === null || currentStep === void 0 ? void 0 : (ref = currentStep.conditions) === null || ref === void 0 ? void 0 : ref.find(function(c) {
                            return c.asset === type && c.assetId === obj.id && c.action === "finish_playing";
                        })) === null || ref1 === void 0 ? void 0 : ref1.rows;
                        videoStartedPlayingRef.current = false;
                        if (!(finishPlayingConditions === null || finishPlayingConditions === void 0 ? void 0 : finishPlayingConditions.length)) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            executeConditionsInOrder(finishPlayingConditions)
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        currentStep
    ]);
    (0,react.useEffect)(function() {
        var videos = flowsVisibleAssets.videos, objects = flowsVisibleAssets.objects;
        if (!currentStep) return;
        if (videos === null || videos === void 0 ? void 0 : videos.length) {
            videos.forEach(function(video) {
                var ref;
                if (video === null || video === void 0 ? void 0 : (ref = video.node) === null || ref === void 0 ? void 0 : ref.video) {
                    video.node.video.addEventListener("ended", executeFinishPlayingConditions(video, "video"));
                }
            });
        }
        if (objects === null || objects === void 0 ? void 0 : objects.length) {
            objects.forEach(function(obj) {
                var ref;
                if (obj === null || obj === void 0 ? void 0 : (ref = obj.node) === null || ref === void 0 ? void 0 : ref.mixer) {
                    obj.node.mixer.addEventListener("finished", executeFinishPlayingConditions(obj, "vsObject"));
                }
            });
        }
        // eslint-disable-next-line consistent-return
        return function() {
            if (videos === null || videos === void 0 ? void 0 : videos.length) {
                videos.forEach(function(video) {
                    var ref;
                    if (video === null || video === void 0 ? void 0 : (ref = video.node) === null || ref === void 0 ? void 0 : ref.video) {
                        video.node.video.removeEventListener("ended", executeFinishPlayingConditions(video, "video"));
                    }
                });
            }
            if (objects === null || objects === void 0 ? void 0 : objects.length) {
                objects.forEach(function(obj) {
                    var ref;
                    if (obj === null || obj === void 0 ? void 0 : (ref = obj.node) === null || ref === void 0 ? void 0 : ref.mixer) {
                        obj.node.mixer.removeEventListener("finished", executeFinishPlayingConditions(obj, "vsObject"));
                    }
                });
            }
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        flowsVisibleAssets,
        currentStep,
        executeFinishPlayingConditions
    ]);
    (0,react.useEffect)(function() {
        if (currentStep) {
            var ref, ref1;
            var triggers = (ref1 = currentStep === null || currentStep === void 0 ? void 0 : (ref = currentStep.triggers) === null || ref === void 0 ? void 0 : ref.filter(function(t) {
                return t.type === flows_types/* ClickAssetTypes.Button */.n.Button;
            })) === null || ref1 === void 0 ? void 0 : ref1.map(function(t) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, t), {
                    disabled: !!(t === null || t === void 0 ? void 0 : t.condition) && !!t.condition.unlockAsset && !!t.condition.unlockAssetId
                });
            });
            setNextButtons(triggers);
        }
    }, [
        currentStep
    ]);
    return {
        stepsEdges: stepsEdges,
        currentStep: currentStep,
        steps: steps,
        setCurrentStep: setCurrentStep,
        executeNextStepTrigger: executeNextStepTrigger,
        distance: distance,
        handleTeleportToStep: handleTeleportToStep,
        executeConditionsInOrder: executeConditionsInOrder,
        executedConditions: executedConditions,
        showFlowBar: showFlowBar,
        setShowFlowBar: setShowFlowBar,
        nextButtons: nextButtons
    };
};

;// CONCATENATED MODULE: ./components/flows/components/Exitbar.tsx



var Exitbar = function(param) {
    var currentStep = param.currentStep, flow = param.flow, handleCloseFlowbar = param.handleCloseFlowbar, showFlowBar = param.showFlowBar;
    var ref, ref1;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Slide/* default */.Z, {
        style: {
            top: 20
        },
        direction: "down",
        in: !!(showFlowBar && currentStep && (currentStep === null || currentStep === void 0 ? void 0 : currentStep.type) === "regular_step"),
        mountOnEnter: true,
        unmountOnExit: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
            sx: ExitSliderStyle,
            direction: "row",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                    alignItems: "center",
                    justifyContent: "center",
                    sx: {
                        width: "24px",
                        height: "24px",
                        borderRadius: "24px",
                        background: "#FFF",
                        border: "1px solid #fff",
                        "& img": {
                            width: "inherit",
                            height: "inherit",
                            borderRadius: "24px"
                        }
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: (flow === null || flow === void 0 ? void 0 : (ref = flow.flowSetting) === null || ref === void 0 ? void 0 : ref.thumbnail) ? "".concat("https://cdn.treedis.com", "/tours/").concat(flow === null || flow === void 0 ? void 0 : flow.tourId, "/experience/flows/icons/").concat(flow === null || flow === void 0 ? void 0 : (ref1 = flow.flowSetting) === null || ref1 === void 0 ? void 0 : ref1.thumbnail) : "/flow.png",
                        alt: "flow-thumbnail"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    fontSize: "16px",
                    lineHeight: "'normal'",
                    fontWeight: 500,
                    children: flow === null || flow === void 0 ? void 0 : flow.name
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(IconButton/* default */.Z, {
                    sx: {
                        width: "69px",
                        height: "27px",
                        p: "4px 6px 4px 10px",
                        gap: 1,
                        borderRadius: "130px",
                        color: "#fff",
                        background: "rgba(255, 255, 255, 0.10)"
                    },
                    onClick: handleCloseFlowbar,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            fontSize: "16px",
                            lineHeight: "'normal'",
                            fontWeight: 500,
                            children: "Exit"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                            className: "fa fa-times",
                            style: {
                                color: "#fff",
                                fontSize: "19px"
                            }
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/flows/components/types.ts
var TFlowFinishCondition;
(function(TFlowFinishCondition) {
    TFlowFinishCondition["ReturnToTour"] = "returnToTour";
    TFlowFinishCondition["NextFlow"] = "nextFlow";
    TFlowFinishCondition["FinishScreen"] = "finishScreen";
})(TFlowFinishCondition || (TFlowFinishCondition = {}));

;// CONCATENATED MODULE: ./components/flows/components/FlowCloseDialog.tsx


var FlowCloseDialog = function(param) {
    var open = param.open, onAgree = param.onAgree, onCancel = param.onCancel;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dialog/* default */.Z, {
        fullWidth: true,
        open: open,
        onClose: onCancel,
        sx: {
            "& .MuiDialog-paper": {
                maxWidth: "400px",
                borderRadius: "13px",
                background: "var(--White, #FFF)"
            }
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DialogContent/* default */.Z, {
                dividers: true,
                sx: {
                    p: 3,
                    border: "none",
                    position: "relative"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                    spacing: 2,
                    sx: {
                        textAlign: "center"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "/alert-triangle.png",
                            alt: "alert-triangle",
                            style: {
                                margin: "auto"
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DialogContentText/* default */.Z, {
                            component: Box/* default */.Z,
                            sx: {
                                "& > p": {
                                    fontWeight: "bolder"
                                }
                            },
                            children: "Are you sure you want to exit the current Flow?"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DialogActions/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                    direction: "row",
                    spacing: 2,
                    width: "100%",
                    paddingX: 2,
                    paddingBottom: 2,
                    justifyContent: "center",
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                            fullWidth: true,
                            variant: "outlined",
                            color: "info",
                            onClick: onCancel,
                            sx: {
                                height: "46px"
                            },
                            children: "No"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                            fullWidth: true,
                            variant: "contained",
                            color: "info",
                            onClick: onAgree,
                            autoFocus: true,
                            sx: {
                                height: "46px"
                            },
                            children: "Yes"
                        })
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/flows/components/FlowSwitchDialog.tsx





var FlowSwitchDialog = function(param) {
    var open = param.open, onAgree = param.onAgree, onCancel = param.onCancel, flow = param.flow;
    var hasStepsInProgress = (0,react.useMemo)(function() {
        return flow === null || flow === void 0 ? void 0 : flow.steps.some(function(step) {
            return step.completed;
        });
    }, [
        flow
    ]);
    var allStepsCompleted = (0,react.useMemo)(function() {
        var ref, ref1;
        return (ref1 = flow === null || flow === void 0 ? void 0 : (ref = flow.steps) === null || ref === void 0 ? void 0 : ref.filter(function(s) {
            return s.type === "regular_step";
        })) === null || ref1 === void 0 ? void 0 : ref1.every(function(step) {
            return step.completed;
        });
    }, [
        flow
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dialog/* default */.Z, {
        fullWidth: true,
        open: open,
        onClose: onCancel,
        sx: {
            "& .MuiDialog-paper": {
                maxWidth: "400px",
                borderRadius: "13px",
                background: "var(--White, #FFF)"
            }
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DialogContent/* default */.Z, {
                dividers: true,
                sx: {
                    p: 3,
                    border: "none",
                    position: "relative"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                    spacing: 2,
                    sx: {
                        textAlign: "center"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "/alert-triangle.png",
                            alt: "alert-triangle",
                            style: {
                                margin: "auto"
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DialogContentText/* default */.Z, {
                            component: Box/* default */.Z,
                            sx: {
                                "& > p": {
                                    fontWeight: "bolder"
                                }
                            },
                            children: hasStepsInProgress ? "It seems like you have progress in the new flow. Continue from where you left off or start from the beginning?" : "By clicking ‘Switch’, you will switch to another flow. Your progress will be saved, allowing you to continue from where you left off."
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DialogActions/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                    direction: hasStepsInProgress ? "column" : "row",
                    spacing: 2,
                    width: "100%",
                    paddingX: 2,
                    paddingBottom: 2,
                    justifyContent: "center",
                    alignItems: "center",
                    children: hasStepsInProgress ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            !allStepsCompleted && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                fullWidth: true,
                                variant: "contained",
                                color: "info",
                                onClick: function() {
                                    return onAgree(flow);
                                },
                                autoFocus: true,
                                sx: {
                                    height: "46px"
                                },
                                children: "Switch and Continue"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                fullWidth: true,
                                variant: "contained",
                                color: "info",
                                onClick: function() {
                                    return onAgree((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, flow), {
                                        restart: true
                                    }));
                                },
                                autoFocus: true,
                                sx: {
                                    height: "46px"
                                },
                                children: "Switch and Restart"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                fullWidth: true,
                                variant: "outlined",
                                color: "info",
                                onClick: onCancel,
                                sx: {
                                    height: "46px"
                                },
                                children: "Cancel"
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                fullWidth: true,
                                variant: "outlined",
                                color: "info",
                                onClick: onCancel,
                                sx: {
                                    height: "46px"
                                },
                                children: "Cancel"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                fullWidth: true,
                                variant: "contained",
                                color: "info",
                                onClick: function() {
                                    return onAgree(flow);
                                },
                                autoFocus: true,
                                sx: {
                                    height: "46px"
                                },
                                children: "Switch"
                            })
                        ]
                    })
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/tour/game/FinishScreen/styled/index.ts + 22 modules
var styled = __webpack_require__(66183);
;// CONCATENATED MODULE: ./components/flows/components/FlowsFinishScreen.tsx


var FlowsFinishScreen = function(param) {
    var title = param.title, finishScreenImage = param.finishScreenImage, backgroundImagePath = param.backgroundImagePath;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* Root */.fC, {
        backgroundImage: backgroundImagePath,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* BackgroundFilter */.Ad, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "col-md-6 offset-md-3 pt-5",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* Icon */.JO, {
                        finishScreenImage: finishScreenImage
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* Title */.Dx, {
                        children: title
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./components/flows/components/Flowbar.tsx




















var Flowbar = function(param) {
    var flow = param.flow, flows = param.flows, selectedFlow = param.selectedFlow, handleCloseFlowbar = param.handleCloseFlowbar, moveToSweep = param.moveToSweep, hideElements = param.hideElements, showElements = param.showElements, showCaseTemp = param.showCaseTemp, showcase = param.showcase, tags = param.tags, setFlows = param.setFlows, polygons = param.polygons, vsObjects = param.vsObjects, navigationManager = param.navigationManager, allSweeps = param.allSweeps, currentFloor = param.currentFloor, closeSwitchDialog = param.closeSwitchDialog, isSwitchDialogOpen = param.isSwitchDialogOpen, handleSwitchAgree = param.handleSwitchAgree, flowsVisibleAssets = param.flowsVisibleAssets, tour = param.tour, flowsBarMeshComponent = param.flowsBarMeshComponent, flowsMenuMeshComponent = param.flowsMenuMeshComponent, vrEventManager = param.vrEventManager;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14;
    var innerSettings = (0,react.useMemo)(function() {
        return flow === null || flow === void 0 ? void 0 : flow.flowSetting;
    }, [
        flow
    ]);
    var ref15 = (0,react.useState)(false), isCloseDialogOpen = ref15[0], setIsCloseDialogOpen = ref15[1];
    var ref16 = (0,react.useState)(false), showFinishScreen = ref16[0], setShowFinishScreen = ref16[1];
    var ref17 = (0,react.useState)(false), isExpanded = ref17[0], setIsExpanded = ref17[1];
    var ref18 = useConditions({
        flow: flow,
        hideElements: hideElements,
        moveToSweep: moveToSweep,
        showcase: showcase,
        showCaseTemp: showCaseTemp,
        tags: tags,
        showElements: showElements,
        setFlows: setFlows,
        polygons: polygons,
        vsObjects: vsObjects,
        navigationManager: navigationManager,
        allSweeps: allSweeps,
        currentFloor: currentFloor,
        flowsVisibleAssets: flowsVisibleAssets
    }), steps = ref18.steps, stepsEdges = ref18.stepsEdges, currentStep = ref18.currentStep, setCurrentStep = ref18.setCurrentStep, executeNextStepTrigger = ref18.executeNextStepTrigger, distance = ref18.distance, handleTeleportToStep = ref18.handleTeleportToStep, executeConditionsInOrder = ref18.executeConditionsInOrder, executedConditions = ref18.executedConditions, showFlowBar = ref18.showFlowBar, setShowFlowBar = ref18.setShowFlowBar, nextButtons = ref18.nextButtons;
    var ref19 = (currentStep === null || currentStep === void 0 ? void 0 : currentStep.finishStepSettings) || {}, _finishScreenTitle = ref19.finishScreenTitle, finishScreenTitle = _finishScreenTitle === void 0 ? "" : _finishScreenTitle;
    var hasAtLeastOneAction = (0,react.useMemo)(function() {
        return (innerSettings === null || innerSettings === void 0 ? void 0 : innerSettings.enableStepsView) || (innerSettings === null || innerSettings === void 0 ? void 0 : innerSettings.enableDistanceFromTheDistination) || (innerSettings === null || innerSettings === void 0 ? void 0 : innerSettings.enableExitButton);
    }, [
        innerSettings
    ]);
    var ref20 = (0,react.useMemo)(function() {
        var ref = calculateStepPositionInPath(steps, stepsEdges, currentStep), currentStepPosition = ref.currentStepPosition, totalStepsInPath = ref.totalStepsInPath;
        return {
            currentStepIndex: currentStepPosition,
            pathLength: totalStepsInPath
        };
    }, [
        steps,
        currentStep,
        stepsEdges
    ]), currentStepIndex = ref20.currentStepIndex, pathLength = ref20.pathLength;
    var moveToPrevStep = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var ref, ref1, ref2, prevStepEdge, startStepEdge, prevStep, revertConditions, prevStepDelay;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    prevStepEdge = stepsEdges === null || stepsEdges === void 0 ? void 0 : stepsEdges.find(function(edge) {
                        return edge.target === currentStep.id && edge.trigger === currentStep.triggeredBy;
                    });
                    startStepEdge = stepsEdges === null || stepsEdges === void 0 ? void 0 : stepsEdges.find(function(edge) {
                        var ref;
                        return edge.source === ((ref = steps === null || steps === void 0 ? void 0 : steps.find(function(step) {
                            return step.type === "start_step";
                        })) === null || ref === void 0 ? void 0 : ref.id);
                    });
                    prevStep = steps === null || steps === void 0 ? void 0 : steps.find(function(step) {
                        return step.id === prevStepEdge.source;
                    });
                    revertConditions = revertConditionsByStep(executedConditions.current, currentStep.id, prevStep.id, startStepEdge);
                    if (!revertConditions.length) return [
                        3,
                        2
                    ];
                    executedConditions === null || executedConditions === void 0 ? void 0 : executedConditions.current.delete(currentStep.id);
                    executedConditions === null || executedConditions === void 0 ? void 0 : executedConditions.current.delete(prevStep.id);
                    return [
                        4,
                        executeConditionsInOrder(revertConditions)
                    ];
                case 1:
                    _state.sent();
                    _state.label = 2;
                case 2:
                    prevStepDelay = (ref1 = prevStep === null || prevStep === void 0 ? void 0 : (ref = prevStep.conditions) === null || ref === void 0 ? void 0 : ref.find(function(c) {
                        return c.action === "start";
                    })) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.rows) === null || ref2 === void 0 ? void 0 : ref2.find(function(r) {
                        return r.action === flows_types/* ActionTypes.DELAY_FLOWBAR */.M.DELAY_FLOWBAR;
                    });
                    if (prevStepDelay) {
                        setShowFlowBar(false);
                    }
                    if (prevStep) setCurrentStep(prevStep);
                    setIsExpanded(false);
                    return [
                        2
                    ];
            }
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }), [
        currentStep,
        steps,
        stepsEdges
    ]);
    var moveToStep = (0,react.useCallback)(function() {
        handleTeleportToStep(currentStep);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        currentStep
    ]);
    var description = currentStep === null || currentStep === void 0 ? void 0 : currentStep.description;
    var openCloseDialog = function() {
        return setIsCloseDialogOpen(true);
    };
    var revertAllConditions = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(switchFlowHideConditions) {
            var ref, allHiddenConditions;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        allHiddenConditions = (ref = Array.from(executedConditions.current.values()).flatMap(function(set) {
                            return Array.from(set);
                        })) === null || ref === void 0 ? void 0 : ref.filter(function(c) {
                            return c.action === flows_types/* ActionTypes.HIDE_ASSET */.M.HIDE_ASSET || c.action === flows_types/* ActionTypes.HIDE_SWEEP */.M.HIDE_SWEEP;
                        });
                        // if the flow that is being switched into has hide conditions that were already executed in current flow, we don't need to revert
                        allHiddenConditions = combineHiddenAssets(allHiddenConditions, switchFlowHideConditions);
                        if (!(allHiddenConditions === null || allHiddenConditions === void 0 ? void 0 : allHiddenConditions.length)) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            executeConditionsInOrder(allHiddenConditions)
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        executedConditions.current.clear();
                        navigationManager.reset();
                        return [
                            2
                        ];
                }
            });
        // eslint-disable-next-line react-hooks/exhaustive-deps
        });
        return function(switchFlowHideConditions) {
            return _ref.apply(this, arguments);
        };
    }(), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        executedConditions
    ]);
    var onCloseAgree = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        revertAllConditions()
                    ];
                case 1:
                    _state.sent();
                    return [
                        4,
                        handleCloseFlowbar()
                    ];
                case 2:
                    _state.sent();
                    setIsCloseDialogOpen(false);
                    navigationManager.reset();
                    setCurrentStep(null);
                    return [
                        2
                    ];
            }
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }), [
        executedConditions
    ]);
    var onSwitchAgree = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(switchFlow) {
            var ref, ref1, ref2, ref3, switchFlowHideConditions;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        switchFlowHideConditions = (ref2 = (ref1 = switchFlow === null || switchFlow === void 0 ? void 0 : (ref = switchFlow.steps) === null || ref === void 0 ? void 0 : ref.find(function(step) {
                            return step.type === "start_step";
                        })) === null || ref1 === void 0 ? void 0 : ref1.conditions[0]) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.rows) === null || ref3 === void 0 ? void 0 : ref3.filter(function(r) {
                            return r.action === "hide_asset";
                        });
                        return [
                            4,
                            revertAllConditions(switchFlowHideConditions)
                        ];
                    case 1:
                        _state.sent();
                        handleSwitchAgree(switchFlow);
                        return [
                            2
                        ];
                }
            });
        // eslint-disable-next-line react-hooks/exhaustive-deps
        });
        return function(switchFlow) {
            return _ref.apply(this, arguments);
        };
    }(), []);
    (0,react.useEffect)(function() {
        (0,_async_to_generator/* default */.Z)(function() {
            var nextFlowId, nextFlow, ref;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(currentStep && currentStep.type === "finish_step")) return [
                            3,
                            5
                        ];
                        nextFlowId = currentStep.finishCondition === TFlowFinishCondition.NextFlow ? currentStep.nextFlowId : null;
                        if (!nextFlowId) return [
                            3,
                            2
                        ];
                        nextFlow = flows.find(function(f) {
                            return f.id === nextFlowId;
                        });
                        if (!nextFlow) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            onSwitchAgree((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, nextFlow), {
                                restart: nextFlow === null || nextFlow === void 0 ? void 0 : (ref = nextFlow.steps) === null || ref === void 0 ? void 0 : ref.filter(function(s) {
                                    return s.type === "regular_step";
                                }).every(function(s) {
                                    return s.completed;
                                })
                            }))
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                    case 2:
                        if (currentStep.finishCondition === TFlowFinishCondition.FinishScreen) {
                            setShowFinishScreen(true);
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            revertAllConditions()
                        ];
                    case 3:
                        _state.sent();
                        return [
                            4,
                            handleCloseFlowbar()
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        return [
                            2
                        ];
                }
            });
        })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        currentStep,
        flows
    ]);
    var handleVRNextButtonClick = function() {
        if (flowsMenuMeshComponent.inputs.visible) return;
        executeNextStepTrigger(nextButtons[0]);
    };
    var handleVRPositionButtonClick = function() {
        if (flowsMenuMeshComponent.inputs.visible) return;
        moveToStep();
    };
    (0,react.useEffect)(function() {
        if (currentStep && flowsBarMeshComponent && vrEventManager) {
            vrEventManager.addEventListener({
                type: "pointerdown",
                button: 4,
                controller: types/* ControllerType.GamepadL */.C.GamepadL
            }, handleVRNextButtonClick);
            vrEventManager.addEventListener({
                type: "pointerdown",
                button: 5,
                controller: types/* ControllerType.GamepadL */.C.GamepadL
            }, handleVRPositionButtonClick);
            var html = flowsBarMeshComponent.inputs.html;
            html.querySelector(".flows-bar-title").innerHTML = currentStep.title;
            html.querySelector(".flows-bar-description").innerHTML = currentStep.description;
            flowsBarMeshComponent.inputs.itemRefArr[0].style.display = innerSettings.enablePreviousButton && currentStepIndex > 1 && (nextButtons === null || nextButtons === void 0 ? void 0 : nextButtons.length) <= 1 ? "flex" : "none";
            flowsBarMeshComponent.inputs.itemRefArr[1].style.display = innerSettings.enableNextButton && (nextButtons === null || nextButtons === void 0 ? void 0 : nextButtons.length) ? "flex" : "none";
            flowsBarMeshComponent.inputs.itemRefArr[2].style.display = innerSettings.enableTeleportButton && !(currentStep === null || currentStep === void 0 ? void 0 : currentStep.hidePosBtn) ? "flex" : "none";
            flowsBarMeshComponent.inputs.itemRefArr[0].addEventListener("click", moveToPrevStep);
            flowsBarMeshComponent.inputs.itemRefArr[1].addEventListener("click", handleVRNextButtonClick);
            flowsBarMeshComponent.inputs.itemRefArr[2].addEventListener("click", moveToStep);
        }
        return function() {
            if (flowsBarMeshComponent && vrEventManager) {
                vrEventManager.removeEventListener({
                    type: "pointerdown",
                    button: 4,
                    controller: types/* ControllerType.GamepadL */.C.GamepadL
                }, handleVRNextButtonClick);
                vrEventManager.removeEventListener({
                    type: "pointerdown",
                    button: 5,
                    controller: types/* ControllerType.GamepadL */.C.GamepadL
                }, handleVRPositionButtonClick);
                flowsBarMeshComponent.inputs.itemRefArr[0].removeEventListener("click", moveToPrevStep);
                flowsBarMeshComponent.inputs.itemRefArr[1].removeEventListener("click", handleVRNextButtonClick);
                flowsBarMeshComponent.inputs.itemRefArr[2].removeEventListener("click", moveToStep);
            }
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        currentStep,
        nextButtons
    ]);
    (0,react.useEffect)(function() {
        if (flowsBarMeshComponent && !selectedFlow) flowsBarMeshComponent.setVisible(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        selectedFlow
    ]);
    var backgroundImagePath = ((ref = tour.introScreen) === null || ref === void 0 ? void 0 : ref.backgroundImage) ? "".concat("https://cdn.treedis.com", "/tours/").concat(tour.id, "/images/").concat((ref1 = tour.introScreen) === null || ref1 === void 0 ? void 0 : ref1.backgroundImage).concat((0,util/* getVersion */.bo)(tour.updatedAt)) : "".concat("https://cdn.treedis.com", "/tours/").concat(tour.id, "/images/").concat(tour.mainImage).concat((0,util/* getVersion */.bo)(tour.updatedAt));
    var secondaryButtonExpanded = (0,react.useMemo)(function() {
        return !(nextButtons === null || nextButtons === void 0 ? void 0 : nextButtons.length) && !(currentStep === null || currentStep === void 0 ? void 0 : currentStep.title) && !description || deviceManager/* default.isMobile */.Z.isMobile() && (nextButtons === null || nextButtons === void 0 ? void 0 : nextButtons.length) >= 2;
    }, [
        nextButtons,
        currentStep,
        description
    ]);
    var hexToRgbA = function(hex, opacity) {
        var c;
        if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
            c = hex.substring(1).split("");
            if (c.length === 3) {
                c = [
                    c[0],
                    c[0],
                    c[1],
                    c[1],
                    c[2],
                    c[2]
                ];
            }
            c = "0x".concat(c.join(""));
            // eslint-disable-next-line no-bitwise
            return "rgba(".concat([
                c >> 16 & 255,
                c >> 8 & 255,
                c & 255
            ].join(","), ",").concat(opacity, ")");
        }
        return "rgba(255,255,255,0.25)";
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            showFinishScreen && /*#__PURE__*/ (0,jsx_runtime.jsx)(FlowsFinishScreen, {
                title: finishScreenTitle,
                finishScreenImage: (currentStep === null || currentStep === void 0 ? void 0 : currentStep.url) ? "".concat("https://cdn.treedis.com", "/tours/").concat(flow === null || flow === void 0 ? void 0 : flow.tourId, "/experience/steps/").concat(currentStep === null || currentStep === void 0 ? void 0 : currentStep.url) : null,
                backgroundImagePath: backgroundImagePath
            }),
            (innerSettings === null || innerSettings === void 0 ? void 0 : innerSettings.enableExitButton) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Exitbar, {
                showFlowBar: showFlowBar,
                flow: flow,
                currentStep: currentStep,
                handleCloseFlowbar: openCloseDialog
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Slide/* default */.Z, {
                direction: "up",
                in: !!(showFlowBar && currentStep && (currentStep === null || currentStep === void 0 ? void 0 : currentStep.type) === "regular_step"),
                mountOnEnter: true,
                unmountOnExit: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                    sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, FlowbarWrapperStyle), {
                        width: {
                            xs: "auto",
                            sm: "fit-content",
                            md: (currentStep === null || currentStep === void 0 ? void 0 : currentStep.title) || description ? "800px" : "fit-content"
                        }
                    }),
                    children: [
                        hasAtLeastOneAction && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                            direction: "row",
                            sx: ActionsWrapperStyle,
                            children: [
                                (innerSettings === null || innerSettings === void 0 ? void 0 : innerSettings.enableStepsView) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                                    direction: "row",
                                    spacing: 1,
                                    sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, ActionSectionStyle), {
                                        borderRight: (innerSettings === null || innerSettings === void 0 ? void 0 : innerSettings.enableDistanceFromTheDistination) && !(currentStep === null || currentStep === void 0 ? void 0 : currentStep.hidePosBtn) || (innerSettings === null || innerSettings === void 0 ? void 0 : innerSettings.enableExitButton) ? "1px solid rgba(255, 255, 255, 0.15)" : "none"
                                    }),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        fontSize: "14px",
                                        lineHeight: "13.65px",
                                        fontWeight: 500,
                                        textAlign: "center",
                                        whiteSpace: "nowrap",
                                        children: "Step ".concat(currentStepIndex, "/")// steps?.filter((step) => step.type === 'regular_step').length
                                        .concat(pathLength)
                                    })
                                }),
                                (innerSettings === null || innerSettings === void 0 ? void 0 : innerSettings.enableDistanceFromTheDistination) && !(currentStep === null || currentStep === void 0 ? void 0 : currentStep.hidePosBtn) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                                    spacing: 1,
                                    sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, ActionSectionStyle), {
                                        borderLeft: (innerSettings === null || innerSettings === void 0 ? void 0 : innerSettings.enableStepsView) ? "1px solid rgba(255, 255, 255, 0.15);" : "none",
                                        borderRight: (innerSettings === null || innerSettings === void 0 ? void 0 : innerSettings.enableExitButton) ? "1px solid rgba(255, 255, 255, 0.15);" : "none"
                                    }),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        fontSize: "14px",
                                        lineHeight: "13.65px",
                                        fontWeight: 500,
                                        textAlign: "center",
                                        whiteSpace: "nowrap",
                                        children: distance && "".concat(distance, "m to go")
                                    })
                                }),
                                (innerSettings === null || innerSettings === void 0 ? void 0 : innerSettings.enableExitButton) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                                    spacing: 1,
                                    sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, ActionSectionStyle), {
                                        borderLeft: (innerSettings === null || innerSettings === void 0 ? void 0 : innerSettings.enableDistanceFromTheDistination) && !(currentStep === null || currentStep === void 0 ? void 0 : currentStep.hidePosBtn) || (innerSettings === null || innerSettings === void 0 ? void 0 : innerSettings.enableStepsView) ? "1px solid rgba(255, 255, 255, 0.15)" : "none"
                                    }),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                        sx: {
                                            width: "28px"
                                        },
                                        onClick: openCloseDialog,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                            className: "fa fa-times",
                                            style: {
                                                color: "#fff",
                                                fontSize: "19px"
                                            }
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                            direction: "row",
                            gap: 2,
                            sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, FlowbarBodyStyle), {
                                borderRadius: hasAtLeastOneAction ? "20px 0px 20px 20px" : "20px",
                                backgroundColor: (flow === null || flow === void 0 ? void 0 : (ref2 = flow.flowSetting) === null || ref2 === void 0 ? void 0 : ref2.displayBarColors) === "preset" ? FlowbarBodyStyle.background : hexToRgbA(flow === null || flow === void 0 ? void 0 : (ref3 = flow.flowSetting) === null || ref3 === void 0 ? void 0 : ref3.backgroundColor, flow === null || flow === void 0 ? void 0 : (ref4 = flow.flowSetting) === null || ref4 === void 0 ? void 0 : ref4.backgroundOpacity)
                            }),
                            children: [
                                ((currentStep === null || currentStep === void 0 ? void 0 : currentStep.url) || (currentStep === null || currentStep === void 0 ? void 0 : currentStep.title) || description) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                    direction: "row",
                                    spacing: 2,
                                    flex: "1 1 auto",
                                    children: [
                                        (currentStep === null || currentStep === void 0 ? void 0 : currentStep.url) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                                            sx: ImageContainerStyle,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "".concat("https://cdn.treedis.com", "/tours/").concat(flow === null || flow === void 0 ? void 0 : flow.tourId, "/experience/steps/").concat(currentStep === null || currentStep === void 0 ? void 0 : currentStep.url),
                                                alt: "flow-thumbnail"
                                            })
                                        }),
                                        ((currentStep === null || currentStep === void 0 ? void 0 : currentStep.title) || description) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                            children: [
                                                (currentStep === null || currentStep === void 0 ? void 0 : currentStep.title) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    fontSize: "16px",
                                                    lineHeight: "21px",
                                                    fontWeight: 500,
                                                    sx: {
                                                        color: (flow === null || flow === void 0 ? void 0 : (ref5 = flow.flowSetting) === null || ref5 === void 0 ? void 0 : ref5.displayBarColors) === "preset" ? "" : flow === null || flow === void 0 ? void 0 : (ref6 = flow.flowSetting) === null || ref6 === void 0 ? void 0 : ref6.textColor
                                                    },
                                                    children: currentStep === null || currentStep === void 0 ? void 0 : currentStep.title
                                                }),
                                                description && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    fontSize: "14px",
                                                    lineHeight: "normal",
                                                    fontWeight: 400,
                                                    color: "rgba(255, 255, 255, 0.60)",
                                                    dangerouslySetInnerHTML: {
                                                        __html: description
                                                    },
                                                    sx: {
                                                        color: (flow === null || flow === void 0 ? void 0 : (ref7 = flow.flowSetting) === null || ref7 === void 0 ? void 0 : ref7.displayBarColors) === "preset" ? "" : flow === null || flow === void 0 ? void 0 : (ref8 = flow.flowSetting) === null || ref8 === void 0 ? void 0 : ref8.textColor
                                                    }
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                    direction: "row",
                                    gap: 1,
                                    flexWrap: "wrap",
                                    flex: "1 1 auto",
                                    justifyContent: (nextButtons === null || nextButtons === void 0 ? void 0 : nextButtons.length) <= 1 ? "flex-end" : "initial",
                                    children: [
                                        (innerSettings === null || innerSettings === void 0 ? void 0 : innerSettings.enablePreviousButton) && currentStepIndex > 1 && (deviceManager/* default.isDesktop */.Z.isDesktop() || deviceManager/* default.isMobile */.Z.isMobile() && (nextButtons === null || nextButtons === void 0 ? void 0 : nextButtons.length) <= 1) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(IconButton/* default */.Z, {
                                            sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, PrevButtonStyle), {
                                                width: secondaryButtonExpanded ? "auto" : "42px",
                                                gap: 1,
                                                flex: secondaryButtonExpanded ? {
                                                    xs: "1 1 45%",
                                                    sm: "1 1 auto"
                                                } : "unset",
                                                p: secondaryButtonExpanded ? "0 20px" : "8px"
                                            }),
                                            onClick: moveToPrevStep,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                    className: "fa-solid fa-arrow-left",
                                                    style: {
                                                        fontSize: "20px",
                                                        color: "#2055FF"
                                                    }
                                                }),
                                                secondaryButtonExpanded && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    fontSize: "16px",
                                                    lineHeight: "24px",
                                                    fontWeight: 600,
                                                    color: "#2055FF",
                                                    children: "Back"
                                                })
                                            ]
                                        }),
                                        deviceManager/* default.isMobile */.Z.isMobile() && (nextButtons === null || nextButtons === void 0 ? void 0 : nextButtons.length) >= 3 && !isExpanded ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(IconButton/* default */.Z, {
                                            onClick: function() {
                                                return setIsExpanded(true);
                                            },
                                            sx: TriggerButtonStyle,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    fontSize: "16px",
                                                    lineHeight: "26px",
                                                    fontWeight: 500,
                                                    color: "#FFF",
                                                    children: "Choose"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                    className: "fa-solid fa-chevron-down",
                                                    style: {
                                                        color: "#fff",
                                                        fontSize: "16px",
                                                        marginLeft: "10px"
                                                    }
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                                            direction: "row",
                                            gap: 1,
                                            flexWrap: "wrap",
                                            justifyContent: "flex-start",
                                            flex: {
                                                xs: "1 1 70%",
                                                sm: (nextButtons === null || nextButtons === void 0 ? void 0 : nextButtons.length) >= 3 ? 1 : "unset"
                                            },
                                            display: !(nextButtons === null || nextButtons === void 0 ? void 0 : nextButtons.length) ? "none" : "flex",
                                            children: nextButtons === null || nextButtons === void 0 ? void 0 : nextButtons.map(function(nb, i) {
                                                var ref, ref1, ref2, ref3, ref4, ref5;
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                                    disabled: nb === null || nb === void 0 ? void 0 : nb.disabled,
                                                    onClick: function() {
                                                        return executeNextStepTrigger(nb);
                                                    },
                                                    sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, TriggerButtonStyle), {
                                                        background: (flow === null || flow === void 0 ? void 0 : (ref = flow.flowSetting) === null || ref === void 0 ? void 0 : ref.displayBarColors) === "preset" ? TriggerButtonStyle.background : flow === null || flow === void 0 ? void 0 : (ref1 = flow.flowSetting) === null || ref1 === void 0 ? void 0 : ref1.nextButtonColor,
                                                        "&:hover": {
                                                            background: (flow === null || flow === void 0 ? void 0 : (ref2 = flow.flowSetting) === null || ref2 === void 0 ? void 0 : ref2.displayBarColors) === "preset" ? TriggerButtonStyle["&:hover"].background : flow === null || flow === void 0 ? void 0 : (ref3 = flow.flowSetting) === null || ref3 === void 0 ? void 0 : ref3.nextButtonColor
                                                        },
                                                        flex: {
                                                            xs: deviceManager/* default.isMobile */.Z.isMobile && (nextButtons.length === 3 && i === 2 || nextButtons.length === 5 && i === 4) ? "1 1 100%" : "1 1 45%",
                                                            sm: 1
                                                        },
                                                        "&:disabled": {
                                                            background: "#ccc"
                                                        }
                                                    }),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                        fontSize: "16px",
                                                        lineHeight: "26px",
                                                        fontWeight: 500,
                                                        sx: {
                                                            color: (flow === null || flow === void 0 ? void 0 : (ref4 = flow.flowSetting) === null || ref4 === void 0 ? void 0 : ref4.displayBarColors) === "preset" ? "#FFF" : flow === null || flow === void 0 ? void 0 : (ref5 = flow.flowSetting) === null || ref5 === void 0 ? void 0 : ref5.nextButtonTextColor
                                                        },
                                                        children: nb === null || nb === void 0 ? void 0 : nb.buttonName
                                                    })
                                                }, nb === null || nb === void 0 ? void 0 : nb.id);
                                            })
                                        }),
                                        (innerSettings === null || innerSettings === void 0 ? void 0 : innerSettings.enablePreviousButton) && currentStepIndex > 0 && deviceManager/* default.isMobile */.Z.isMobile() && (nextButtons === null || nextButtons === void 0 ? void 0 : nextButtons.length) >= 2 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(IconButton/* default */.Z, {
                                            sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, PrevButtonStyle), {
                                                width: secondaryButtonExpanded ? "auto" : "42px",
                                                gap: 1,
                                                flex: secondaryButtonExpanded ? {
                                                    xs: "1 1 45%",
                                                    sm: "1 1 auto"
                                                } : "unset",
                                                p: secondaryButtonExpanded ? "0 20px" : "8px"
                                            }),
                                            onClick: moveToPrevStep,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                    className: "fa-solid fa-arrow-left",
                                                    style: {
                                                        fontSize: "20px",
                                                        color: "#2055FF"
                                                    }
                                                }),
                                                secondaryButtonExpanded && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    fontSize: "16px",
                                                    lineHeight: "24px",
                                                    fontWeight: 600,
                                                    color: "#2055FF",
                                                    children: "Back"
                                                })
                                            ]
                                        }),
                                        (innerSettings === null || innerSettings === void 0 ? void 0 : innerSettings.enableTeleportButton) && !(currentStep === null || currentStep === void 0 ? void 0 : currentStep.hidePosBtn) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(IconButton/* default */.Z, {
                                            sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, TPButtonStyle), {
                                                border: (flow === null || flow === void 0 ? void 0 : (ref9 = flow.flowSetting) === null || ref9 === void 0 ? void 0 : ref9.displayBarColors) === "preset" ? TPButtonStyle.border : "1px solid ".concat(flow === null || flow === void 0 ? void 0 : (ref10 = flow.flowSetting) === null || ref10 === void 0 ? void 0 : ref10.nextButtonColor),
                                                background: (flow === null || flow === void 0 ? void 0 : (ref11 = flow.flowSetting) === null || ref11 === void 0 ? void 0 : ref11.displayBarColors) === "preset" ? TPButtonStyle.background : flow === null || flow === void 0 ? void 0 : (ref12 = flow.flowSetting) === null || ref12 === void 0 ? void 0 : ref12.nextButtonTextColor,
                                                "&:hover": {
                                                    background: (flow === null || flow === void 0 ? void 0 : (ref13 = flow.flowSetting) === null || ref13 === void 0 ? void 0 : ref13.displayBarColors) === "preset" ? TPButtonStyle["&:hover"].background : flow === null || flow === void 0 ? void 0 : (ref14 = flow.flowSetting) === null || ref14 === void 0 ? void 0 : ref14.nextButtonTextColor
                                                },
                                                width: secondaryButtonExpanded ? "auto" : "42px",
                                                gap: 1,
                                                flex: secondaryButtonExpanded ? {
                                                    xs: "1 1 45%",
                                                    sm: "1 1 auto"
                                                } : "unset",
                                                p: secondaryButtonExpanded ? "0 20px" : "8px"
                                            }),
                                            onClick: moveToStep,
                                            children: [
                                                secondaryButtonExpanded && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    fontSize: "16px",
                                                    lineHeight: "24px",
                                                    fontWeight: 600,
                                                    color: "#2055FF",
                                                    children: deviceManager/* default.isMobile */.Z.isMobile() ? "Position" : "Position me"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TeleportBtnIcon, {})
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FlowCloseDialog, {
                open: isCloseDialogOpen,
                onCancel: function() {
                    return setIsCloseDialogOpen(false);
                },
                onAgree: onCloseAgree
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FlowSwitchDialog, {
                flow: selectedFlow,
                open: isSwitchDialogOpen,
                onAgree: onSwitchAgree,
                onCancel: closeSwitchDialog
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/flows/FlowsContainer.tsx





// import { getFlowsData } from '@/api/queries';



var FlowsContainer = function(param) {
    var moveToSweep = param.moveToSweep, hideElements = param.hideElements, showElements = param.showElements, showCaseTemp = param.showCaseTemp, showcase = param.showcase, tags = param.tags, setFlowsObjects = param.setFlowsObjects, polygons = param.polygons, vsObjects = param.vsObjects, navigationManager = param.navigationManager, sweeps = param.sweeps, allSweeps = param.allSweeps, currentFloor = param.currentFloor, setFlowActive = param.setFlowActive, appState = param.appState, flowsProps = param.flowsProps, mainFlow = param.mainFlow, flowsVisibleAssets = param.flowsVisibleAssets, tourCustomButton = param.tourCustomButton, flowsMenuMeshComponent = param.flowsMenuMeshComponent, flowsBarMeshComponent = param.flowsBarMeshComponent, vrEventManager = param.vrEventManager, tour = param.tour, startFlowFromAsset = param.startFlowFromAsset, setSelectedFlowAsset = param.setSelectedFlowAsset;
    var ref = (0,react.useState)([]), flows = ref[0], setFlows = ref[1];
    var ref1 = (0,react.useState)(null), activeFlow = ref1[0], setActiveFlow = ref1[1];
    var ref2 = (0,react.useState)(false), isDialogOpen = ref2[0], setIsDialogOpen = ref2[1];
    var ref3 = (0,react.useState)(null), selectedFlow = ref3[0], setSelectedFlow = ref3[1];
    var ref4 = (0,react.useState)(false), isMainFlowActive = ref4[0], setIsMainFlowActive = ref4[1];
    var assetsWithClick = (0,react.useRef)(null);
    var handleAgree = (0,react.useCallback)(function(flow) {
        setSelectedFlowAsset(null);
        if (flow === null || flow === void 0 ? void 0 : flow.restart) {
            setFlows(function(prev) {
                return prev.map(function(f) {
                    var ref;
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, f), {
                        steps: f.id === flow.id ? (ref = f.steps) === null || ref === void 0 ? void 0 : ref.map(function(s) {
                            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, s), {
                                completed: false
                            });
                        }) : f.steps
                    });
                });
            });
        } else {
            setFlows(function(prev) {
                return prev.map(function(f) {
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, f), {
                        started: f.id === flow.id ? true : f.started
                    });
                });
            });
        }
        setActiveFlow(flow);
        setIsDialogOpen(false);
        setSelectedFlow(null);
        setFlowActive(true);
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    var handleFlowSelect = function(flow) {
        if (flow.started && !(base/* asyncStore */.k6 === null || base/* asyncStore */.k6 === void 0 ? void 0 : base/* asyncStore.vrIsOn */.k6.vrIsOn)) {
            setIsDialogOpen(true);
            setSelectedFlow(flow);
            return;
        }
        setSelectedFlowAsset(null);
        setActiveFlow((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, flow), {
            started: true
        }));
        setFlowActive(true);
        setFlows(function(prev) {
            return prev.map(function(f) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, f), {
                    started: f.id === flow.id ? true : f.started
                });
            });
        });
    };
    var closeDialog = function() {
        setIsDialogOpen(false);
        setSelectedFlow(null);
        setSelectedFlowAsset(null);
    };
    (0,react.useEffect)(function() {
        if ((flowsProps === null || flowsProps === void 0 ? void 0 : flowsProps.length) && !(flows === null || flows === void 0 ? void 0 : flows.length)) {
            // You can await here
            setFlows(flowsProps === null || flowsProps === void 0 ? void 0 : flowsProps.map(function(f) {
                var ref;
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, f), {
                    handleFlowSelect: handleFlowSelect,
                    started: false,
                    steps: (ref = f.steps) === null || ref === void 0 ? void 0 : ref.map(function(s) {
                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, s), {
                            completed: false
                        });
                    })
                });
            }));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        flowsProps
    ]);
    (0,react.useEffect)(function() {
        if (flows === null || flows === void 0 ? void 0 : flows.length) {
            var allAssetsWithClicks = new Map();
            flows.forEach(function(flow) {
                var ref;
                var flowId = flow === null || flow === void 0 ? void 0 : flow.id;
                if (!flowId) return; // Skip if flowId is not available
                var flowAssets = [];
                flow === null || flow === void 0 ? void 0 : (ref = flow.steps) === null || ref === void 0 ? void 0 : ref.forEach(function(step) {
                    if (step === null || step === void 0 ? void 0 : step.conditions) {
                        var _flowAssets;
                        var ref;
                        (_flowAssets = flowAssets).push.apply(_flowAssets, (0,_to_consumable_array/* default */.Z)((ref = step.conditions) === null || ref === void 0 ? void 0 : ref.filter(function(c) {
                            return c.asset !== "button" && c.action === "click";
                        })));
                    }
                    if (step === null || step === void 0 ? void 0 : step.triggers) {
                        var _flowAssets1;
                        var ref1;
                        (_flowAssets1 = flowAssets).push.apply(_flowAssets1, (0,_to_consumable_array/* default */.Z)((ref1 = step.triggers) === null || ref1 === void 0 ? void 0 : ref1.filter(function(t) {
                            return t.condition.asset !== "button" && t.condition.action === "click";
                        })));
                    }
                });
                if (flowAssets.length > 0) {
                    allAssetsWithClicks.set(flowId, flowAssets);
                }
            });
            assetsWithClick.current = allAssetsWithClicks;
        }
    }, [
        flows
    ]);
    (0,react.useEffect)(function() {
        if (activeFlow && assetsWithClick.current) {
            var activeFlowAssets = assetsWithClick.current.get(activeFlow === null || activeFlow === void 0 ? void 0 : activeFlow.id);
            if (activeFlowAssets) {
                var assetsToDisableAction = activeFlowAssets.filter(function(a) {
                    var ref;
                    return (a === null || a === void 0 ? void 0 : (ref = a.condition) === null || ref === void 0 ? void 0 : ref.after) === "notActive" || a.after === "notActive";
                });
                setFlowsObjects({
                    flowAssetsToDisableAction: assetsToDisableAction || []
                });
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        activeFlow
    ]);
    (0,react.useEffect)(function() {
        if (!showCaseTemp || !showcase || !mainFlow || appState !== "playing" || activeFlow || isMainFlowActive) return;
        if (mainFlow) {
            setFlows(function(prev) {
                return prev.map(function(f) {
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, f), {
                        started: f.id === mainFlow.id ? true : f.started
                    });
                });
            });
            setActiveFlow(mainFlow);
            setIsMainFlowActive(true);
            setFlowActive(true);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        mainFlow,
        showCaseTemp,
        showcase,
        appState,
        activeFlow,
        isMainFlowActive
    ]);
    var handleCloseFlowbar = (0,react.useCallback)(function() {
        return new Promise(function(resolve) {
            setActiveFlow(null);
            setFlowActive(false);
            setFlowsObjects({
                flowAssetsToDisableAction: []
            });
            resolve(true); // Resolve the promise when done
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var handleVRItemSelect = function(e) {
        handleFlowSelect(flows[e.target.dataset.indexNumber]);
    };
    (0,react.useEffect)(function() {
        if (flowsMenuMeshComponent) {
            flowsMenuMeshComponent.inputs.itemRefArr.forEach(function(menu) {
                menu.addEventListener("click", handleVRItemSelect);
            });
            flowsMenuMeshComponent.triggerCallback = function() {
                if (flowsMenuMeshComponent.inputs.visible) {
                    handleFlowSelect(flows[flowsMenuMeshComponent.selectedItemIndex]);
                    flowsMenuMeshComponent.setVisible(false);
                    setTimeout(function() {
                        var _Sweep;
                        (_Sweep = showCaseTemp.showcase.Sweep).enable.apply(_Sweep, (0,_to_consumable_array/* default */.Z)(sweeps.map(function(s) {
                            return s.sid;
                        })));
                    }, 500);
                }
            };
        }
        return function() {
            if (flowsMenuMeshComponent) {
                flowsMenuMeshComponent.inputs.itemRefArr.forEach(function(menu) {
                    menu.removeEventListener("click", handleVRItemSelect);
                });
            }
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        flows,
        sweeps
    ]);
    (0,react.useEffect)(function() {
        if (startFlowFromAsset && (flows === null || flows === void 0 ? void 0 : flows.length)) {
            var flow = flows.find(function(f) {
                return f.id === startFlowFromAsset;
            });
            if (flow && (base/* asyncStore */.k6 === null || base/* asyncStore */.k6 === void 0 ? void 0 : base/* asyncStore.vrIsOn */.k6.vrIsOn)) {
                handleFlowSelect(flow);
                return;
            }
            if (flow && !activeFlow) {
                handleFlowSelect(flow);
            } else {
                setIsDialogOpen(true);
                setSelectedFlow(flow);
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        startFlowFromAsset,
        flows,
        activeFlow
    ]);
    return (flows === null || flows === void 0 ? void 0 : flows.length) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FlowsMenu, {
                flows: flows,
                tourCustomButton: tourCustomButton
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flowbar, {
                flow: activeFlow,
                flows: flows,
                selectedFlow: selectedFlow,
                handleCloseFlowbar: handleCloseFlowbar,
                moveToSweep: moveToSweep,
                hideElements: hideElements,
                showElements: showElements,
                showCaseTemp: showCaseTemp,
                showcase: showcase,
                tags: tags,
                polygons: polygons,
                setFlows: setFlows,
                vsObjects: vsObjects,
                navigationManager: navigationManager,
                allSweeps: allSweeps,
                currentFloor: currentFloor,
                closeSwitchDialog: closeDialog,
                isSwitchDialogOpen: isDialogOpen,
                handleSwitchAgree: handleAgree,
                flowsVisibleAssets: flowsVisibleAssets,
                tour: tour,
                flowsBarMeshComponent: flowsBarMeshComponent,
                flowsMenuMeshComponent: flowsMenuMeshComponent,
                vrEventManager: vrEventManager
            })
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};
/* harmony default export */ var flows_FlowsContainer = (FlowsContainer);

// EXTERNAL MODULE: ./utils/removeHTMLTagsFromString.ts
var removeHTMLTagsFromString = __webpack_require__(98765);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/styles/useTheme.js
var useTheme = __webpack_require__(62097);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/ImageList/ImageList.js + 1 modules
var ImageList = __webpack_require__(30530);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/ImageListItem/ImageListItem.js + 1 modules
var ImageListItem = __webpack_require__(80412);
// EXTERNAL MODULE: ./node_modules/react-player/lib/index.js
var react_player_lib = __webpack_require__(22004);
// EXTERNAL MODULE: ./node_modules/react-intersection-observer/dist/index.mjs
var react_intersection_observer_dist = __webpack_require__(18357);
// EXTERNAL MODULE: ./components-new/common/icon/Icon.tsx
var icon_Icon = __webpack_require__(96858);
// EXTERNAL MODULE: ./components-new/index.ts + 3 modules
var components_new = __webpack_require__(48517);
;// CONCATENATED MODULE: ./components/tour/components/GalleryDialog/index.tsx










var GalleryDialog = function(param) {
    var open = param.open, setOpen = param.setOpen, gallery = param.gallery, title = param.title;
    var ref = (0,react.useState)(false), openSlider = ref[0], setOpenSlider = ref[1];
    var ref1 = (0,react.useState)(0), currentIndex = ref1[0], setCurrentIndex = ref1[1];
    var sliderRef = (0,react.useRef)(null);
    var ref2 = (0,react_intersection_observer_dist/* useInView */.YD)({
        triggerOnce: true,
        threshold: 0.1
    }), ref3 = ref2.ref, inView = ref2.inView;
    var theme = (0,useTheme/* default */.Z)();
    var isMobile = (0,useMediaQuery/* default */.Z)(theme.breakpoints.down("sm"));
    var handleOpenSlider = function(index) {
        setCurrentIndex(index);
        setOpenSlider(true);
    };
    var handleKeyDown = function(e) {
        if (openSlider) {
            if (e.key === "ArrowRight") {
                sliderRef.current.slickNext();
            } else if (e.key === "ArrowLeft") {
                sliderRef.current.slickPrev();
            }
        }
    };
    (0,react.useEffect)(function() {
        window.addEventListener("keydown", handleKeyDown);
        return function() {
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, [
        handleKeyDown,
        openSlider
    ]);
    (0,react.useEffect)(function() {
        if (sliderRef.current) {
            sliderRef.current.slickGoTo(currentIndex);
        }
    }, [
        currentIndex,
        gallery
    ]);
    var handleBeforeChange = function(_, newIndex) {
        setCurrentIndex(newIndex);
        var thumbId = "thumbnail-".concat(newIndex);
        var thumb = document.getElementById(thumbId);
        if (thumb) {
            thumb.scrollIntoView({
                behavior: "smooth",
                block: "center",
                inline: "center"
            });
        }
    };
    var settings = (0,react.useMemo)(function() {
        return {
            dots: true,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            initialSlide: currentIndex,
            autoplay: false,
            customPaging: function(i) {
                return gallery[i].dataType === "video" || gallery[i].dataType === "galleryVideo" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    id: "thumbnail-".concat(i),
                    style: {
                        width: 50,
                        height: 50,
                        padding: 5,
                        cursor: "pointer",
                        opacity: currentIndex === i ? 1 : 0.5,
                        position: "relative",
                        border: currentIndex === i ? "1px solid #FFFFFF" : "2px solid transparent",
                        borderRadius: "8px"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(react_player_lib/* default */.Z, {
                            style: {
                                position: "relative",
                                width: "100%",
                                height: "100%"
                            },
                            url: gallery[i].dataType === "video" ? "".concat("https://cdn.treedis.com", "/").concat(gallery[i].filePath) : gallery[i].filePath,
                            controls: false,
                            width: "-webkit-fill-available",
                            height: isMobile ? "300px" : "730px",
                            playing: false,
                            light: true,
                            muted: true,
                            config: {
                                file: {
                                    attributes: {
                                        controlsList: "nofullscreen noremoteplayback nodownload",
                                        disablePictureInPicture: true,
                                        startTime: 1,
                                        onLoadedMetadata: function(e) {
                                            e.target.currentTime = 1; // Start at the first second
                                        }
                                    }
                                }
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_Icon/* default */.Z, {
                            icon: "fa-solid fa-video",
                            sx: {
                                position: "absolute",
                                top: "50%",
                                left: "50%",
                                transform: "translate(-50%, -50%)",
                                zIndex: 1,
                                color: "#ffff"
                            }
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                    id: "thumbnail-".concat(i),
                    style: {
                        padding: 5,
                        cursor: "pointer",
                        opacity: currentIndex === i ? 1 : 0.5,
                        position: "relative",
                        width: "40px !important",
                        height: "40px !important"
                    },
                    children: inView && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_new/* Image */.Ee, {
                        loading: "lazy",
                        src: gallery[i].url ? "".concat("https://cdn.treedis.com", "/tours/").concat(gallery[i].tourId, "/images/").concat(gallery[i].url) : gallery[i].dataType === "galleryImage" ? gallery[i].filePath : "".concat("https://cdn.treedis.com", "/").concat(gallery[i].filePath),
                        alt: gallery[i].url ? "".concat(gallery[i].url) : "".concat(gallery[i].filePath),
                        objectFit: "cover",
                        sx: {
                            width: "42px",
                            height: "42px",
                            borderRadius: "8px",
                            border: currentIndex === i ? "1px solid #FFFFFF" : "2px solid transparent"
                        }
                    })
                });
            },
            appendDots: function(dots) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    ref: ref3,
                    style: {
                        position: "fixed",
                        left: 0,
                        width: "100%",
                        height: "100px",
                        overflowX: "auto",
                        msOverflowStyle: "none",
                        scrollbarWidth: "none",
                        background: "#00000099"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        style: {
                            margin: "0 auto",
                            display: "flex",
                            whiteSpace: "nowrap",
                            gap: "15px",
                            padding: "10px 2px",
                            userSelect: "none",
                            width: "fit-content"
                        },
                        children: dots
                    })
                });
            },
            beforeChange: function(oldIndex, newIndex) {
                handleBeforeChange(oldIndex, newIndex);
            }
        };
    }, [
        currentIndex,
        gallery
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: openSlider ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dialog/* default */.Z, {
            open: openSlider,
            fullScreen: true,
            PaperProps: {
                style: {
                    overflow: "hidden"
                }
            },
            onKeyDown: function(e) {
                return handleKeyDown(e);
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                    direction: "row",
                    spacing: 2,
                    px: 3,
                    py: 1,
                    alignItems: "center",
                    justifyContent: "flex-end",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                        onClick: function() {
                            return setOpen(!open);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_Icon/* default */.Z, {
                            icon: "fa fa-times"
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                    sx: {
                        maxWidth: isMobile ? "300px" : "1300px",
                        margin: "auto",
                        padding: 2
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_slick_lib/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        ref: sliderRef
                    }, settings), {
                        children: gallery.map(function(g, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                                sx: {
                                    overflow: "hidden"
                                },
                                ref: ref3,
                                children: g.dataType === "video" || g.dataType === "galleryVideo" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: inView && /*#__PURE__*/ (0,jsx_runtime.jsx)(react_player_lib/* default */.Z, {
                                        url: g.dataType === "video" ? "".concat("https://cdn.treedis.com", "/").concat(g.filePath) : g.filePath,
                                        controls: true,
                                        width: "-webkit-fill-available",
                                        height: isMobile ? "300px" : "730px",
                                        playing: gallery[currentIndex].dataType === "video" && currentIndex === index || gallery[currentIndex].dataType === "galleryVideo" && currentIndex === index,
                                        muted: true,
                                        config: {
                                            file: {
                                                attributes: {
                                                    controlsList: "nofullscreen noremoteplayback nodownload",
                                                    disablePictureInPicture: true
                                                }
                                            }
                                        }
                                    })
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: inView && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_new/* Image */.Ee, {
                                        loading: "lazy",
                                        alt: g.url ? "".concat(g.url) : "".concat(g.filePath),
                                        src: g.url ? "".concat("https://cdn.treedis.com", "/tours/").concat(g.tourId, "/images/").concat(g.url) : g.dataType === "galleryImage" ? g.additionalInformation.fullsizeUrl : "".concat("https://cdn.treedis.com", "/").concat(g.filePath),
                                        objectFit: "contain",
                                        sx: {
                                            width: isMobile ? "300px" : "1300px",
                                            height: isMobile ? "300px" : "730px",
                                            margin: "auto",
                                            borderRadius: "10px",
                                            marginBottom: "100px"
                                        }
                                    })
                                })
                            }, g.url ? g.url : g.filePath);
                        })
                    }))
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dialog/* default */.Z, {
            open: open,
            fullWidth: true,
            maxWidth: "lg",
            PaperProps: {
                style: {
                    overflowY: "hidden",
                    height: "100%"
                }
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                    direction: "row",
                    spacing: 2,
                    px: 3,
                    py: 2,
                    alignItems: "center",
                    justifyContent: "space-between",
                    sx: {
                        backgroundColor: "#000000CC"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            sx: {
                                fontSize: "18px",
                                fontWeight: 700,
                                color: "#FFFFFF"
                            },
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                            onClick: function() {
                                return setOpen(!open);
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_Icon/* default */.Z, {
                                icon: "fa fa-times"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageList/* default */.Z, {
                    variant: "masonry",
                    cols: isMobile ? 2 : 5,
                    gap: 8,
                    sx: {
                        p: 3,
                        overflowY: "auto",
                        scrollbarWidth: "none"
                    },
                    ref: ref3,
                    children: gallery.map(function(g, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: inView && /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageListItem/* default */.Z, {
                                onClick: function() {
                                    return handleOpenSlider(index);
                                },
                                sx: {
                                    cursor: "pointer",
                                    minHeight: "125px"
                                },
                                children: g.dataType === "video" || g.dataType === "galleryVideo" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(react_player_lib/* default */.Z, {
                                    url: g.dataType === "video" ? "".concat("https://cdn.treedis.com", "/").concat(g.filePath) : g.filePath,
                                    controls: false,
                                    width: "-webkit-fill-available",
                                    height: "auto",
                                    muted: true,
                                    style: {
                                        borderRadius: "12px",
                                        overflow: "hidden"
                                    },
                                    config: {
                                        // File player (HTML5 video/audio) configuration
                                        file: {
                                            attributes: {
                                                controlsList: "nofullscreen noremoteplayback nodownload",
                                                disablePictureInPicture: true,
                                                startTime: 1,
                                                onLoadedMetadata: function(e) {
                                                    e.target.currentTime = 1; // Start at the first second
                                                }
                                            }
                                        }
                                    }
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(components_new/* Image */.Ee, {
                                    loading: "lazy",
                                    alt: g.url ? "".concat(g.url) : "".concat(g.filePath),
                                    src: g.url ? "".concat("https://cdn.treedis.com", "/tours/").concat(g.tourId, "/images/").concat(g.url) : g.dataType === "galleryImage" ? g.filePath : "".concat("https://cdn.treedis.com", "/").concat(g.filePath),
                                    objectFit: "cover",
                                    sx: {
                                        width: "100%",
                                        height: "auto",
                                        borderRadius: "12px"
                                    }
                                })
                            }, g.url ? g.url : g.filePath)
                        });
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var components_GalleryDialog = (GalleryDialog);

;// CONCATENATED MODULE: ./components/tour/components/MarkerPopup/styles.tsx

function MarkerPopup_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-direction: column;\n  background-color: rgb(22, 22, 21);\n  padding: 10px;\n  border-radius: 10px;\n  width: 400px;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 100;\n  gap: 20px;\n  ",
        "\n"
    ]);
    MarkerPopup_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function MarkerPopup_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  font-size: 24px;\n  color: white;\n  cursor: pointer;\n"
    ]);
    MarkerPopup_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function MarkerPopup_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: white;\n  font-size: 24px;\n"
    ]);
    MarkerPopup_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function MarkerPopup_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n"
    ]);
    MarkerPopup_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function MarkerPopup_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: var(--color-primary);\n  color: white;\n  border: none;\n  padding: 5px 15px;\n  border-radius: 20px;\n  cursor: pointer;\n  margin: 0 5px;\n  &:hover {\n    opacity: 0.7;\n  }\n"
    ]);
    MarkerPopup_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function MarkerPopup_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: var(--color-secondary);\n  //background-color: #444;\n  color: white;\n  border: none;\n  padding: 5px 15px;\n  border-radius: 20px;\n  cursor: pointer;\n  margin: 0 5px;\n  &:hover {\n    opacity: 0.7;\n  }\n"
    ]);
    MarkerPopup_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}

var PopupContainerMarker = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__PopupContainerMarker",
    componentId: "sc-82d74fba-0"
})(MarkerPopup_styles_templateObject(), function(param) {
    var theme = param.theme;
    return theme.device.mobile && !theme.device.landscape && "width:90%";
});
var CloseButton = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__CloseButton",
    componentId: "sc-82d74fba-1"
})(MarkerPopup_styles_templateObject1());
var Title = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__Title",
    componentId: "sc-82d74fba-2"
})(MarkerPopup_styles_templateObject2());
var Controls = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__Controls",
    componentId: "sc-82d74fba-3"
})(MarkerPopup_styles_templateObject3());
var ButtonPrimary = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    displayName: "styles__ButtonPrimary",
    componentId: "sc-82d74fba-4"
})(MarkerPopup_styles_templateObject4());
var ButtonSecondary = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    displayName: "styles__ButtonSecondary",
    componentId: "sc-82d74fba-5"
})(MarkerPopup_styles_templateObject5());

;// CONCATENATED MODULE: ./components/tour/components/MarkerPopup/index.tsx



var MarkerPopup = function(props) {
    var primaryAction = props.primaryAction, secondaryAction = props.secondaryAction, onClose = props.onClose;
    var popupRef = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        var handleClickOutside = function(event) {
            if (popupRef.current && !popupRef.current.contains(event.target)) {
                onClose();
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return function() {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        onClose
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(PopupContainerMarker, {
        ref: popupRef,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                children: "What do you want to do?"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Controls, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonPrimary, {
                        onClick: primaryAction,
                        children: "Open Autodesk Viewer"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonSecondary, {
                        onClick: secondaryAction,
                        children: "Move to this point"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseButton, {
                onClick: onClose,
                children: "\xd7"
            })
        ]
    });
};
/* harmony default export */ var components_MarkerPopup = (MarkerPopup);

;// CONCATENATED MODULE: ./_models/virtualStaging/VREventManager/index.ts






var VREventManager = /*#__PURE__*/ function(SceneComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(VREventManager, SceneComponent);
    var _super = (0,_create_super/* default */.Z)(VREventManager);
    function VREventManager() {
        (0,_class_call_check/* default */.Z)(this, VREventManager);
        var _this;
        _this = _super.apply(this, arguments);
        _this.root = null;
        _this.pivot = null;
        _this.eventListeners = [];
        _this.activeButtons = {
            gamepadL: new Map(),
            gamepadR: new Map()
        };
        _this.activeAxes = {
            gamepadL: new Map(),
            gamepadR: new Map()
        };
        _this.inputs = {
            visible: false
        };
        _this.outputs = {
            loadingState: VSObject/* LoadingState.Loaded */.Gu.Loaded
        };
        return _this;
    }
    var _proto = VREventManager.prototype;
    _proto.onInit = function onInit() {
        this.getXRController();
    };
    _proto.getXRController = function getXRController() {
        var _this = this;
        var xr = this.context.renderer.xr;
        this.controllers = [
            xr.getController(0),
            xr.getController(1)
        ];
        this.controllers.forEach(function(controller) {
            controller.addEventListener("connected", function(event) {
                var inputSource = event.data;
                var handedness = inputSource.handedness;
                if (handedness === "left") {
                    _this.controllerL = controller;
                    _this.gamepadL = inputSource.gamepad;
                } else if (handedness === "right") {
                    _this.controllerR = controller;
                    _this.gamepadR = inputSource.gamepad;
                }
            });
        });
    };
    _proto.onInputsUpdated = function onInputsUpdated(previousInputs) {
        this.root.visible = this.inputs.visible;
    };
    _proto.addEventListener = function addEventListener(event, callback) {
        this.eventListeners.push({
            event: event,
            callback: callback
        });
    };
    _proto.removeEventListener = function removeEventListener(event, callback) {
        var listenerToRemove = this.eventListeners.find(function(listener) {
            return listener.callback === callback;
        });
        if (listenerToRemove) this.eventListeners.splice(this.eventListeners.indexOf(listenerToRemove), 1);
    };
    _proto.cycleVR = function cycleVR(_session) {
        var _this = this;
        if (this.gamepadL) {
            this.gamepadL.buttons.forEach(function(button, index) {
                if (button.pressed && !_this.activeButtons.gamepadL.get(index)) {
                    var listeners = _this.eventListeners.filter(function(listener) {
                        return listener.event.controller === types/* ControllerType.GamepadL */.C.GamepadL && listener.event.button === index && listener.event.type === "pointerdown";
                    });
                    listeners.forEach(function(listener) {
                        return listener.callback(button);
                    });
                }
                if (!button.pressed && _this.activeButtons.gamepadL.get(index)) {
                    var listeners1 = _this.eventListeners.filter(function(listener) {
                        return listener.event.controller === types/* ControllerType.GamepadL */.C.GamepadL && listener.event.button === index && listener.event.type === "pointerup";
                    });
                    listeners1.forEach(function(listener) {
                        return listener.callback(button);
                    });
                }
                _this.activeButtons.gamepadL.set(index, button.pressed);
            });
            this.gamepadL.axes.forEach(function(axis, index) {
                if (!_this.activeAxes.gamepadL.get(index) && (axis < -0.5 || axis > 0.5)) {
                    _this.activeAxes.gamepadL.set(index, true);
                    var listeners = _this.eventListeners.filter(function(listener) {
                        return listener.event.controller === types/* ControllerType.GamepadL */.C.GamepadL && listener.event.button === index && listener.event.type === "thumbstickthreshholddown";
                    });
                    listeners.forEach(function(listener) {
                        return listener.callback(axis);
                    });
                }
                if (_this.activeAxes.gamepadL.get(index) && axis >= -0.5 && axis <= 0.5) {
                    _this.activeAxes.gamepadL.set(index, false);
                    var listeners1 = _this.eventListeners.filter(function(listener) {
                        return listener.event.controller === types/* ControllerType.GamepadL */.C.GamepadL && listener.event.button === index && listener.event.type === "thumbstickthreshholdup";
                    });
                    listeners1.forEach(function(listener) {
                        return listener.callback(axis);
                    });
                }
            });
        }
        if (this.gamepadR) {
            this.gamepadR.buttons.forEach(function(button, index) {
                if (button.pressed && !_this.activeButtons.gamepadR.get(index)) {
                    var listeners = _this.eventListeners.filter(function(listener) {
                        return listener.event.controller === types/* ControllerType.GamepadR */.C.GamepadR && listener.event.button === index && listener.event.type === "pointerdown";
                    });
                    listeners.forEach(function(listener) {
                        return listener.callback(button);
                    });
                }
                if (!button.pressed && _this.activeButtons.gamepadR.get(index)) {
                    var listeners1 = _this.eventListeners.filter(function(listener) {
                        return listener.event.controller === types/* ControllerType.GamepadR */.C.GamepadR && listener.event.button === index && listener.event.type === "pointerup";
                    });
                    listeners1.forEach(function(listener) {
                        return listener.callback(button);
                    });
                }
                _this.activeButtons.gamepadR.set(index, button.pressed);
            });
            this.gamepadR.axes.forEach(function(axis, index) {
                if (!_this.activeAxes.gamepadR.get(index) && (axis < -0.5 || axis > 0.5)) {
                    _this.activeAxes.gamepadR.set(index, true);
                    var listeners = _this.eventListeners.filter(function(listener) {
                        return listener.event.controller === types/* ControllerType.GamepadR */.C.GamepadR && listener.event.button === index && listener.event.type === "thumbstickthreshholddown";
                    });
                    listeners.forEach(function(listener) {
                        return listener.callback(axis);
                    });
                }
                if (_this.activeAxes.gamepadR.get(index) && axis >= -0.5 && axis <= 0.5) {
                    _this.activeAxes.gamepadR.set(index, false);
                    var listeners1 = _this.eventListeners.filter(function(listener) {
                        return listener.event.controller === types/* ControllerType.GamepadR */.C.GamepadR && listener.event.button === index && listener.event.type === "thumbstickthreshholdup";
                    });
                    listeners1.forEach(function(listener) {
                        return listener.callback(axis);
                    });
                }
            });
        }
    };
    _proto.onTick = function onTick() {
        var _this = this;
        var ref, ref1, ref2;
        if ((ref = this.context) === null || ref === void 0 ? void 0 : (ref1 = ref.renderer) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.xr) === null || ref2 === void 0 ? void 0 : ref2.isPresenting) {
            var _session = this.context.renderer.xr.getSession();
            _session.requestAnimationFrame(function() {
                return _this.cycleVR(_session);
            });
        }
    };
    return VREventManager;
}(Scene_component/* SceneComponent */.Ad);
var VREventManagerComponentType = "mp.VRPointerComponent";
var makeVREventManagerComponent = function() {
    return new VREventManager();
};

;// CONCATENATED MODULE: ./components/tour/BaseTour.tsx
/* eslint-disable no-return-await */ /* eslint-disable react/jsx-no-bind */ /* eslint-disable class-methods-use-this */ /* eslint-disable no-unused-expressions */ /* eslint-disable @typescript-eslint/no-shadow */ /* eslint-disable radix */ /* eslint-disable no-nested-ternary */ /* eslint-disable no-empty */ /* eslint-disable consistent-return */ /* eslint-disable @typescript-eslint/no-unused-vars */ /* eslint-disable @typescript-eslint/no-empty-function */ /* eslint-disable no-console */ /* eslint-disable react/no-unused-state */ 





















































































































// import { TagTooltipCustom } from '@/components/tour/components/TagTooltipCustom/TagTooltipCustom';
// import { IotTagTooltip } from '@/components/iot/IotTagTooltip/IotTagTooltip';











// import { jsonSafeParse } from '@/utils/json';
var ExperiencePopUp = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1606).then(__webpack_require__.bind(__webpack_require__, 61606));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(61606)
            ];
        }
    },
    ssr: false
});
var IntroScreen = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 70).then(__webpack_require__.bind(__webpack_require__, 30070));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(30070)
            ];
        }
    },
    ssr: false
});
var Sweep = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 934).then(__webpack_require__.bind(__webpack_require__, 30934));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(30934)
            ];
        }
    },
    ssr: false
});
var Share = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 5290).then(__webpack_require__.bind(__webpack_require__, 95290));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(95290)
            ];
        }
    },
    ssr: false
});
var DebugWindow = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9617).then(__webpack_require__.bind(__webpack_require__, 99617));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(99617)
            ];
        }
    },
    ssr: false
});
var Terms = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 117).then(__webpack_require__.bind(__webpack_require__, 90117));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(90117)
            ];
        }
    },
    ssr: false
});
var Help = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9493).then(__webpack_require__.bind(__webpack_require__, 49493));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(49493)
            ];
        }
    },
    ssr: false
});
var RenderTicketingContent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1449).then(__webpack_require__.bind(__webpack_require__, 31449));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(31449)
            ];
        }
    },
    ssr: false
});
var IntroPopup = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6941).then(__webpack_require__.bind(__webpack_require__, 26941)).then(function(res) {
        return res.IntroPopup;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(26941)
            ];
        }
    },
    ssr: false
});
var TicketingRouter = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(1607), __webpack_require__.e(4762), __webpack_require__.e(7361)]).then(__webpack_require__.bind(__webpack_require__, 17361));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(17361)
            ];
        }
    },
    ssr: false
});
var SketchfabPopup = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(7441), __webpack_require__.e(378)]).then(__webpack_require__.bind(__webpack_require__, 10378));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(10378)
            ];
        }
    },
    ssr: false
});
var Minimap = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(6126), __webpack_require__.e(7268)]).then(__webpack_require__.bind(__webpack_require__, 7268));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(7268)
            ];
        }
    },
    ssr: false
});
var Panorama = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9991).then(__webpack_require__.bind(__webpack_require__, 29991));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(29991)
            ];
        }
    },
    ssr: false
});
var ContactPopup = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1055).then(__webpack_require__.bind(__webpack_require__, 11055));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(11055)
            ];
        }
    },
    ssr: false
});
var ExternalPopup = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 3777).then(__webpack_require__.bind(__webpack_require__, 93777));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(93777)
            ];
        }
    },
    ssr: false
});
var PanoPopup = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6484).then(__webpack_require__.bind(__webpack_require__, 66484));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(66484)
            ];
        }
    },
    ssr: false
});
var PathFinderPopup = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4889).then(__webpack_require__.bind(__webpack_require__, 4889));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(4889)
            ];
        }
    },
    ssr: false
});
var TagsPopup = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4584).then(__webpack_require__.bind(__webpack_require__, 24584));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(24584)
            ];
        }
    },
    ssr: false
});
var VSActionsPopup = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7691).then(__webpack_require__.bind(__webpack_require__, 67691));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(67691)
            ];
        }
    },
    ssr: false
});
var Countdown = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 5360).then(__webpack_require__.bind(__webpack_require__, 45360));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(45360)
            ];
        }
    },
    ssr: false
});
var MessengerCustomerChat = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9538).then(__webpack_require__.bind(__webpack_require__, 89538));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(89538)
            ];
        }
    },
    ssr: false
});
var MemoizedVideo = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(1607), __webpack_require__.e(6937), __webpack_require__.e(1922)]).then(__webpack_require__.bind(__webpack_require__, 71922));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(71922)
            ];
        }
    },
    ssr: false
});
var Appointment = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9424).then(__webpack_require__.bind(__webpack_require__, 59424));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(59424)
            ];
        }
    },
    ssr: false
});
var ActionPathNavbarWithRecoil = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 943).then(__webpack_require__.bind(__webpack_require__, 60943));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(60943)
            ];
        }
    },
    ssr: false
});
var DEFAULT_VS_SENSOR_RADIUS = deviceManager/* default.isMobile */.Z.isMobile() ? 25 : 25;
var defaultLogo = (0,utils/* getAsset */.Nh)("logo-white.svg");
var BaseTour_audioHandler = AudioModule/* AudioModule.getInstance */.w0.getInstance();
var BaseTour = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(BaseTour, PureComponent);
    var _super = (0,_create_super/* default */.Z)(BaseTour);
    function BaseTour(props, tourType) {
        (0,_class_call_check/* default */.Z)(this, BaseTour);
        var _this;
        _this = _super.call(this, props);
        _this.ticketValidSweepsHistory = [];
        _this.ticketTimeout = null;
        _this.messengerQ = (0,util_all/* getQueryVariable */.Dv)(window.location.href, "messenger");
        _this.currentSweep = null;
        _this.defaultSweep = null;
        _this.prevSweep = null;
        _this.avatarNodes = new Map();
        _this.playAudioTimeout = null;
        _this.mainContainerWaitingForPlay = false;
        _this.pose = {};
        _this.floor = new FRFloor({
            floor: 0,
            position: null
        });
        _this.messenger = parseInt(_this.messengerQ === false ? "1" : _this.messengerQ, 10);
        _this.visibleTags = {};
        _this.hiddenTags = {};
        _this.modelNodes = [];
        _this.vsObjects = [];
        _this.barriers = [];
        _this.customSweeps = [];
        _this.teleportPoints = [];
        _this.isMobile = deviceManager/* default.isMobile */.Z.isMobile();
        _this.avatarDegree = null;
        _this.connectedAvatarsLastSweep = [] // previous sweep for all other avatars in tour
        ;
        _this.connectedAvatarsTweens = [] // amount of active animations for all other avatars in tour
        ;
        _this.camera = null;
        _this.isShadowEnabled = false;
        _this.gameAnalytic = null;
        _this.matterTagMeshComponents = [];
        _this.VRPointer = {
            component: null,
            target: null
        };
        _this.backpack = {
            items: []
        };
        _this.deselectTagTimeout = undefined;
        _this.isGeorgiaPacificTour = false;
        _this.showcaseAppSubscriber = null;
        _this.showcaseSubscribers = [];
        _this.animate = function() {
            requestAnimationFrame(_this.animate);
            tween_module_min/* TWEEN.update */.w.update();
        };
        _this.didAvatarSweepChange = function(avatarId, newSweepId) {
            var shouldAnimationPlay;
            var avatarLastSweepIndex = _this.connectedAvatarsLastSweep.findIndex(function(obj) {
                return obj && obj.id === avatarId;
            });
            if (avatarLastSweepIndex !== -1) {
                var targetAvatarLastSweep = _this.connectedAvatarsLastSweep[avatarLastSweepIndex];
                shouldAnimationPlay = targetAvatarLastSweep.sweepId !== newSweepId;
                _this.connectedAvatarsLastSweep[avatarLastSweepIndex].sweepId = newSweepId;
            } else {
                shouldAnimationPlay = true;
                _this.connectedAvatarsLastSweep.push({
                    id: avatarId,
                    sweepId: newSweepId
                });
            }
            return shouldAnimationPlay;
        };
        var _this1 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.getCameraRotation = /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            var ref, ref1;
            return (0,tslib_es6.__generator)(this, function(_state) {
                // TODO: pass in props this.camera, not the function
                return [
                    2,
                    {
                        rotation: (ref = _this1.camera) === null || ref === void 0 ? void 0 : ref.rotation,
                        quaternion: (ref1 = _this1.camera) === null || ref1 === void 0 ? void 0 : ref1.quaternion
                    }
                ];
            });
        });
        _this.renderCrashScreen = function() {
            var ref, ref1;
            /*#__PURE__*/ return (0,jsx_runtime.jsx)(components_CrashScreen, {
                show: _this.state.crashScreen,
                backgroundImage: "".concat("https://cdn.treedis.com", "/tours/").concat((ref = _this.state.tour) === null || ref === void 0 ? void 0 : ref.id, "/images/").concat((ref1 = _this.state.tour) === null || ref1 === void 0 ? void 0 : ref1.mainImage)
            });
        };
        _this.showTicketTimeIsOutPopup = function() {
            _this.setState({
                infoModalData: {
                    mode: InfoModal/* EInfoModal.timeIsUp */.Y.timeIsUp,
                    onRequestClose: function() {
                        stopApp();
                    }
                }
            });
        };
        _this.showTicketRestrictedAreaPopup = function(param) {
            var sweepThatCauseTicketRestriction = param.sweepThatCauseTicketRestriction, reelThatCauseTicketRestriction = param.reelThatCauseTicketRestriction;
            _this.setState({
                infoModalData: {
                    mode: InfoModal/* EInfoModal.restrictedArea */.Y.restrictedArea,
                    onRequestClose: function() {
                        if (sweepThatCauseTicketRestriction) _this.goToPreviousValidSweep();
                    },
                    sweepThatCauseTicketRestriction: sweepThatCauseTicketRestriction,
                    reelThatCauseTicketRestriction: reelThatCauseTicketRestriction
                }
            });
        };
        _this.setPathfinderDataState = function(data) {
            _this.setState({
                pathfinderDataState: data
            });
        };
        var _this2 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.goToPreviousValidSweep = /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            var ref, THREE;
            return (0,tslib_es6.__generator)(this, function(_state) {
                if ((ref = _this2.ticketValidSweepsHistory) === null || ref === void 0 ? void 0 : ref.length) {
                    THREE = _this2.THREE;
                    _this2.moveToSweep(_this2.ticketValidSweepsHistory[_this2.ticketValidSweepsHistory.length - 1], new THREE.Euler());
                } else {
                    stopApp();
                }
                return [
                    2
                ];
            });
        });
        _this.ticketUpdateSweepLoc = function(nextSweep) {
            var ref, ref1, ref2, ref3;
            if (((ref = _this.state.tour) === null || ref === void 0 ? void 0 : ref.ticket) && ((ref1 = _this.state) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.ticketing) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.ticketingOrderedTicket) === null || ref3 === void 0 ? void 0 : ref3.ticketType) === "tourByYourself") {
                var ref4;
                var ticketingTourTicket = _this.state.ticketing.ticketingTourTicket;
                var allowedSweeps = ticketingTourTicket.selectedSweeps ? ticketingTourTicket.selectedSweeps[(ref4 = _this.state.tour) === null || ref4 === void 0 ? void 0 : ref4.slug] : [];
                if (allowedSweeps.includes(nextSweep)) {
                    _this.ticketValidSweepsHistory.push(nextSweep);
                } else {
                    _this.showTicketRestrictedAreaPopup({
                        sweepThatCauseTicketRestriction: nextSweep
                    });
                }
            }
        };
        _this.handleLogin = function(password) {
            var tour = _this.state.tour;
            if (tour.password === password) {
                styledToast("Login successful", "success");
                _this.setState({
                    tour: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, tour), {
                        password: null
                    }),
                    interacted: true
                });
                return true;
            }
            styledToast("Wrong password", "error");
            return false;
        };
        var _this3 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.onPlayClick = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
                var _state, tour, game, _$tourType, showIntro, tourEmail, hasIC, loginSuccess, ref, err;
                return (0,tslib_es6.__generator)(this, function(_state1) {
                    switch(_state1.label){
                        case 0:
                            _state = _this3.state, tour = _state.tour, game = _state.game, _$tourType = _state.tourType, showIntro = _state.showIntro, tourEmail = _state.tourEmail;
                            _state1.label = 1;
                        case 1:
                            _state1.trys.push([
                                1,
                                ,
                                9,
                                10
                            ]);
                            hasIC = (game === null || game === void 0 ? void 0 : game.introClip) && ((game === null || game === void 0 ? void 0 : game.introClipUrl) || (game === null || game === void 0 ? void 0 : game.uploadedIntroUrl));
                            if (data.password) {
                                loginSuccess = _this3.handleLogin(data.password);
                                if (!loginSuccess) return [
                                    2
                                ];
                                if (!hasIC) {
                                    _this3.showcaseLoad();
                                } else if (!tour.introScreen) {
                                    _this3.setState({
                                        showIntro: true
                                    });
                                }
                                if (!tour.introScreen && (tour.mpPasswordActive || !hasIC)) {
                                    _this3.onIntroScreenFinished();
                                }
                                return [
                                    2
                                ];
                            }
                            if (!showIntro && hasIC) {
                                _this3.setState({
                                    showIntro: hasIC
                                });
                            }
                            if (!((tour === null || tour === void 0 ? void 0 : tour.id) && (tour === null || tour === void 0 ? void 0 : tour.collectLeads))) return [
                                3,
                                7
                            ];
                            _state1.label = 2;
                        case 2:
                            _state1.trys.push([
                                2,
                                5,
                                ,
                                6
                            ]);
                            (0,analytic/* sendToGA */.o$)("event", {
                                eventCategory: "Lead",
                                eventAction: "submit",
                                eventLabel: "entry"
                            });
                            return [
                                4,
                                (0,util_all/* fetchData */.rQ)("public/setTourLead", "POST", (0,_object_spread/* default */.Z)({
                                    tourId: tour.id
                                }, data))
                            ];
                        case 3:
                            _state1.sent();
                            return [
                                4,
                                TreedisPublicDAO/* default.sendEmail */.Z.sendEmail({
                                    data: {
                                        to: tourEmail && tourEmail.leadForms || tour.client && tour.client.email,
                                        params: Object.assign(data, {
                                            tour: tour.title,
                                            userId: tour.userId,
                                            link: window.location.href,
                                            clientId: tour === null || tour === void 0 ? void 0 : (ref = tour.client) === null || ref === void 0 ? void 0 : ref.id
                                        })
                                    }
                                })
                            ];
                        case 4:
                            _state1.sent();
                            return [
                                3,
                                6
                            ];
                        case 5:
                            err = _state1.sent();
                            console.error(err.message);
                            return [
                                3,
                                6
                            ];
                        case 6:
                            return [
                                3,
                                8
                            ];
                        case 7:
                            if (Tour/* TourType.Game */.v.Game === _$tourType) {
                                _this3.handleGameStartOnIntroModal(data === null || data === void 0 ? void 0 : data.name);
                            }
                            _state1.label = 8;
                        case 8:
                            (0,analytic/* sendToGA */.o$)("event", {
                                eventCategory: "IntroScreen",
                                eventAction: "click",
                                eventLabel: "introButton"
                            });
                            return [
                                3,
                                10
                            ];
                        case 9:
                            return [
                                7
                            ];
                        case 10:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(data) {
                return _ref.apply(this, arguments);
            };
        }();
        _this.onIntroScreenFinished = function() {
            var _state = _this.state, showIntro = _state.showIntro, showcaseLoaded = _state.showcaseLoaded;
            if (showIntro) {
                var _this1 = (0,_assert_this_initialized/* default */.Z)(_this);
                _this.setState({
                    startScreenOn: false
                }, /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!showcaseLoaded) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this1.playTourAudio().catch(function() {})
                                ];
                            case 1:
                                _state.sent();
                                _state.label = 2;
                            case 2:
                                return [
                                    2
                                ];
                        }
                    });
                }));
            } else {
                var _this2 = (0,_assert_this_initialized/* default */.Z)(_this);
                _this.setState({
                    startScreenOn: false,
                    forcePlayGameIntro: true
                }, /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!showcaseLoaded) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this2.processTourMusic(true)
                                ];
                            case 1:
                                _state.sent();
                                _state.label = 2;
                            case 2:
                                return [
                                    2
                                ];
                        }
                    });
                }));
            }
            if (_this.state.tourType === Tour/* TourType.Game */.v.Game) {
                _this.setState({
                    gameStatus: components_types/* GameStatus.Started */.XI.Started
                });
            }
        };
        _this.onIntroScreenUnmount = function() {
            _this.hideLoadingScreenIfExists();
            var alreadyPlaying = false;
            // Forcing autoplay for vsVideos (TB-3663)
            _this.vsObjects.forEach(function(vsObject) {
                if (!(0,_instanceof/* default */.Z)(vsObject, VSObject/* TourVideo */.Up) || !vsObject.isVisible || !(vsObject === null || vsObject === void 0 ? void 0 : vsObject.node)) return;
                var video = vsObject.node.video;
                if (vsObject.autoplay) {
                    video.play();
                }
                // isDefaultMuted Only for videos with hidden mute button
                if (vsObject.hideMuteButton && !vsObject.isDefaultMuted && !alreadyPlaying) {
                    video.muted = false;
                    alreadyPlaying = true;
                }
            });
        };
        _this.onTicketLoginSuccess = function(tour, ticketing) {
            var ticketingOrderedTicket = ticketing.ticketingOrderedTicket, ticketingTourTicket = ticketing.ticketingTourTicket;
            var ticketLimitMs = ticketingTourTicket.duration * 60 * 1000;
            var ticketSpentFromLogin = Number(new Date(ticketingOrderedTicket.loginDate)) ? Date.now() - Number(new Date(ticketingOrderedTicket.loginDate)) : 0;
            var ticketTimeLeft = ticketLimitMs - ticketSpentFromLogin;
            // set time is up timeout with popup
            if (ticketTimeLeft > 0) {
                react_toastify_esm/* toast.success */.Am.success("logged in");
                setTimeout(_this.showTicketTimeIsOutPopup, ticketTimeLeft);
                _this.setState({
                    ticketTimeLeftMs: ticketTimeLeft,
                    ticketingOpen: false,
                    tour: tour,
                    ticketing: ticketing
                });
                _this.loadData(tour);
                _this.setWhiteLabel(tour);
                socket/* default.emit */.Z.emit("ticketing_login", {
                    ticketingOrderedTicket: ticketingOrderedTicket,
                    deviceId: (0,utils/* getDeviceFingerprint */.UI)(),
                    reel: tour.slug
                });
            } else {
                react_toastify_esm/* toast.error */.Am.error("wrong ticket time left");
                _this.showTicketTimeIsOutPopup();
            }
        };
        _this.handleTicketingReel = function(reel) {
            try {
                if (_this.state.ticketing && reel.type === "treedis") {
                    var url = new URL(reel.url);
                    var urlPathnameArr = url.pathname.split("/");
                    if (urlPathnameArr[1] === "tour") socket/* default.emit */.Z.emit("ticketing_reel", {
                        reel: urlPathnameArr[2]
                    });
                }
            } catch (err) {
                console.warn("handleTicketingReel", err);
            }
        };
        _this.updateIotState = function(iotState) {
            _this.setState(function(prevState) {
                return {
                    iot: (0,_object_spread/* default */.Z)({}, prevState.iot, iotState)
                };
            });
        };
        var _this4 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.getTour = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
                var slug, _changeMenu, changeMenu, _changeMinimap, changeMinimap, _changePanorama, changePanorama, _url, url, _hideIntroScreen, hideIntroScreen, tourData, bypassCookieCheck, _changeReel, changeReel, ref, ref1, ref2, urlParams, ref3, ref4, ref5, ref6, ref7, ref8, ref9, data, _tmp, menuResponse, menuRes, ref10, ref11, tour, tGen, ticket, iframeId, s, x, y, menuOpenForDevice, err;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            slug = param.slug, _changeMenu = param.changeMenu, changeMenu = _changeMenu === void 0 ? true : _changeMenu, _changeMinimap = param.changeMinimap, changeMinimap = _changeMinimap === void 0 ? true : _changeMinimap, _changePanorama = param.changePanorama, changePanorama = _changePanorama === void 0 ? true : _changePanorama, _url = param.url, url = _url === void 0 ? null : _url, _hideIntroScreen = param.hideIntroScreen, hideIntroScreen = _hideIntroScreen === void 0 ? false : _hideIntroScreen, tourData = param.tourData, bypassCookieCheck = param.bypassCookieCheck, _changeReel = param.changeReel, changeReel = _changeReel === void 0 ? false : _changeReel;
                            // If the user has not yet accepted cookies, and loadTourAfterCookie is true, do not load tour in background (it will be loaded after cookie is accepted)
                            if ((tourData === null || tourData === void 0 ? void 0 : (ref = tourData.tour) === null || ref === void 0 ? void 0 : ref.cookieIsMandatory) && (tourData === null || tourData === void 0 ? void 0 : (ref1 = tourData.tour) === null || ref1 === void 0 ? void 0 : ref1.loadTourAfterCookie) && !(0,CookieConsent/* allowUsesCookie */.q7)() && !bypassCookieCheck) {
                                ;
                                _this4.setState({
                                    tour: tourData === null || tourData === void 0 ? void 0 : tourData.tour
                                });
                                // Doing this here because we need translations for the cookie popup
                                _this4.initTourInfo(tourData === null || tourData === void 0 ? void 0 : (ref2 = tourData.tour) === null || ref2 === void 0 ? void 0 : ref2.id);
                                return [
                                    2
                                ];
                            }
                            urlParams = new URLSearchParams(window.location.search);
                            _this4.setState({
                                showcaseLoaded: !changeMenu
                            });
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                13,
                                ,
                                14
                            ]);
                            _this4.loadingQueue.setLoadingQueueProgress(10);
                            _tmp = tourData;
                            if (_tmp) return [
                                3,
                                3
                            ];
                            return [
                                4,
                                TreedisPublicDAO/* default.getTour */.Z.getTour({
                                    data: {
                                        slug: slug,
                                        mode: _this4.state.tourType,
                                        excludeTranslation: true,
                                        pmeToken: urlParams.get("pmeToken")
                                    }
                                })
                            ];
                        case 2:
                            _tmp = _state.sent();
                            _state.label = 3;
                        case 3:
                            data = _tmp;
                            _this4.loadingQueue.setLoadingQueueProgress(15);
                            if (!data || !data.tour) {
                                react_toastify_esm/* toast.error */.Am.error("Couldn't find this tour in our databases");
                                return [
                                    2
                                ];
                            }
                            if (bypassCookieCheck) {
                                // when tour was embedded into website cookie does not work, so react-cookie-consent can not detect it
                                data.tour.hideCookie = true;
                            }
                            window.localStorage.setItem("userCountry", data === null || data === void 0 ? void 0 : (ref3 = data.tour) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.user) === null || ref4 === void 0 ? void 0 : ref4.country);
                            if (data.tour.fontFamily) {
                                document.documentElement.style.setProperty("--custom-font-family", "".concat(data.tour.fontFamily));
                            }
                            _this4.setWhiteLabel(data.tour);
                            _this4.initTourInfo(data.tour.id);
                            if (!(data.tour.menuEnabled && changeMenu)) return [
                                3,
                                5
                            ];
                            return [
                                4,
                                TreedisPublicDAO/* default.getMenu */.Z.getMenu({
                                    data: {
                                        id: data.tour.id
                                    }
                                })
                            ];
                        case 4:
                            menuResponse = _state.sent();
                            _this4.setState({
                                menuSettings: menuResponse === null || menuResponse === void 0 ? void 0 : menuResponse.menuSettings,
                                menus: menuResponse === null || menuResponse === void 0 ? void 0 : menuResponse.menus
                            });
                            _state.label = 5;
                        case 5:
                            if (!data.tour.enableIot) return [
                                3,
                                7
                            ];
                            return [
                                4,
                                TreedisPublicDAO/* default.getIoTMenu */.Z.getIoTMenu({
                                    query: {
                                        tourId: data.tour.id
                                    }
                                })
                            ];
                        case 6:
                            menuRes = _state.sent();
                            if (menuRes === null || menuRes === void 0 ? void 0 : menuRes.data) {
                                ;
                                _this4.updateIotState({
                                    menuSettings: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, menuRes.data), {
                                        colorSettings: JSON.parse(((ref10 = menuRes.data) === null || ref10 === void 0 ? void 0 : ref10.colorSettings) || "{}")
                                    })
                                });
                            }
                            _state.label = 7;
                        case 7:
                            if ((data === null || data === void 0 ? void 0 : (ref5 = data.tour) === null || ref5 === void 0 ? void 0 : ref5.languageCode) === 51 || (data === null || data === void 0 ? void 0 : (ref6 = data.tour) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.initialDuplicates) === null || ref7 === void 0 ? void 0 : ref7.length) > 0 && ((ref9 = data === null || data === void 0 ? void 0 : (ref8 = data.tour) === null || ref8 === void 0 ? void 0 : ref8.initialDuplicates[0]) === null || ref9 === void 0 ? void 0 : ref9.languageCode) === "fr") {
                                window.localStorage.setItem("rightPriceSymbol", "1");
                            } else {
                                window.localStorage.removeItem("rightPriceSymbol");
                            }
                            if (!(data.ticketing && !_this4.state.iframeUrl)) return [
                                3,
                                8
                            ];
                            tour = new Tour/* Tour */.Oj(data.tour);
                            tGen = data === null || data === void 0 ? void 0 : (ref11 = data.ticketing) === null || ref11 === void 0 ? void 0 : ref11.ticketingGeneral;
                            // if (this.state.game) this.loadData(data.tour);
                            _this4.setState({
                                tour: tour,
                                ticketingOpen: true,
                                ticketing: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data.ticketing), {
                                    ticketingGeneral: (tGen === null || tGen === void 0 ? void 0 : tGen.length) ? tGen[0] : tGen
                                }),
                                tourLoaded: true
                            });
                            return [
                                3,
                                12
                            ];
                        case 8:
                            if (!url) return [
                                3,
                                11
                            ];
                            if (data.ticketing && _this4.state.iframeUrl) {
                                ticket = new URLSearchParams(window.location.search).get("ticket");
                                if (!ticket || ticket.length === 0) window.location.href = window.location.href.replace(/tour.*/, "tour/".concat(data.tour.slug));
                            }
                            iframeId = (0,util_all/* getQueryVariable */.Dv)(_this4.state.iframeUrl, "m");
                            s = (0,util_all/* getQueryVariable */.Dv)(url, "s");
                            x = (0,util_all/* getQueryVariable */.Dv)(url, "x");
                            y = (0,util_all/* getQueryVariable */.Dv)(url, "y");
                            if (iframeId !== data.tour.matterId) {
                                _this4.setState({
                                    isChangeIframe: true
                                });
                                // Setting vsObjects to empty if we load another tour
                                _this4.vsObjects = [];
                            }
                            if (hideIntroScreen) {
                                data.tour.introScreen = null;
                            }
                            if (!(iframeId == data.tour.matterId && s && x && y)) return [
                                3,
                                11
                            ];
                            menuOpenForDevice = _this4.state.tourType === Tour/* TourType.Regular */.v.Regular && !!(deviceManager/* default.isMobile */.Z.isMobile() ? data.tour.menuEnabled && data.tour.menuAlwaysOpenMobile : data.tour.menuEnabled && data.tour.menuAlwaysOpenDesktop);
                            _this4.setState({
                                menuOpen: changeMenu ? menuOpenForDevice : _this4.state.menuOpen,
                                showcaseLoaded: true
                            });
                            if (!_this4.showcase.App.Phase.PLAYING.includes(_this4.state.appState)) return [
                                3,
                                10
                            ];
                            return [
                                4,
                                _this4.moveToSweep(String(s), {
                                    x: parseFloat(x),
                                    y: parseFloat(y)
                                })
                            ];
                        case 9:
                            _state.sent();
                            _state.label = 10;
                        case 10:
                            return [
                                2
                            ];
                        case 11:
                            return [
                                2,
                                _this4.loadData(data.tour, changeMenu, changeMinimap, changePanorama, url, changeReel)
                            ];
                        case 12:
                            return [
                                3,
                                14
                            ];
                        case 13:
                            err = _state.sent();
                            console.error(err.message);
                            return [
                                3,
                                14
                            ];
                        case 14:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }();
        _this.initTourInfo = function(id) {
            (0,util_all/* fetchData */.rQ)("public/getTranslations/".concat(id), "GET").then(function(data) {
                _this.setState({
                    translation: data.translations
                });
            }).catch(function(err) {
                console.error(err.message);
            });
            (0,util_all/* fetchData */.rQ)("public/getEmails/".concat(id), "GET").then(function(data) {
                _this.setState({
                    tourEmail: data.emails
                });
            }).catch(function(err) {
                console.error(err.message);
            });
        };
        _this.getTagIconId = function(tag) {
            if (tag.isThread) {
                return "thread";
            }
            var iconName = tag.iconFile || (tag.customIcon === "null" || tag.customIcon === null ? null : tag.customIcon);
            var iconSid = tag.sid;
            if (iconName && iconSid) {
                return "".concat(iconName, "__").concat(iconSid);
            }
            return null;
        };
        var _this5 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.addMattertag = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(tag) {
                var sid, iconId, rgb, addDetails, addRes, err;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            sid = null;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                5,
                                ,
                                6
                            ]);
                            iconId = _this5.getTagIconId(tag);
                            rgb = util_all/* hexToRgb */.oo(tag.iconColor);
                            addDetails = {
                                label: tag.title || "",
                                description: tag.description || "",
                                anchorPosition: {
                                    x: tag.positionX,
                                    y: tag.positionY,
                                    z: tag.positionZ
                                },
                                stemVector: {
                                    x: tag.stemVectorX || 0,
                                    y: tag.stemVectorY == null ? 0.3 : tag.stemVectorY,
                                    z: tag.stemVectorZ || 0
                                },
                                color: {
                                    r: rgb.r / 255,
                                    g: rgb.g / 255,
                                    b: rgb.b / 255
                                },
                                stemVisible: typeof tag.stemVisible === "boolean" ? tag.stemVisible : true
                            };
                            if (iconId) addDetails.iconId = iconId;
                            return [
                                4,
                                _this5.showcase.Tag.add(addDetails).catch(function(e) {
                                    console.error(e);
                                })
                            ];
                        case 2:
                            addRes = _state.sent();
                            if (!(addRes && addRes[0])) return [
                                3,
                                4
                            ];
                            // eslint-disable-next-line prefer-destructuring
                            tag.sid = addRes[0];
                            return [
                                4,
                                _this5.editTagMedia(tag)
                            ];
                        case 3:
                            _state.sent();
                            return [
                                2,
                                tag.sid
                            ];
                        case 4:
                            return [
                                3,
                                6
                            ];
                        case 5:
                            err = _state.sent();
                            console.error(err);
                            return [
                                3,
                                6
                            ];
                        case 6:
                            return [
                                2,
                                sid
                            ];
                    }
                });
            });
            return function(tag) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this6 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.registerIcon = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
                var iconId, url;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            iconId = param.iconId, url = param.url;
                            console.log("URL", url);
                            return [
                                4,
                                _this6.showcase.Asset.registerTexture(iconId, url).catch(function(e) {
                                    console.error(e);
                                })
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            });
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this7 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.editTagMedia = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(tag) {
                var ref, label, description, t, _t, sandboxId, attachments, e;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!tag) return [
                                2
                            ];
                            return [
                                4,
                                _this7.setTagAllowAction(tag)
                            ];
                        case 1:
                            _state.sent();
                            if (!(tag.opacity !== null && typeof tag.opacity === "number")) return [
                                3,
                                3
                            ];
                            return [
                                4,
                                _this7.showcase.Tag.editOpacity(tag.sid, tag.opacity / 100).catch(function(e) {
                                    console.error(e);
                                })
                            ];
                        case 2:
                            _state.sent();
                            _state.label = 3;
                        case 3:
                            if (tag.treedisStyle) return [
                                2
                            ];
                            label = tag.mpTitle ? tag.title : "";
                            description = tag.description;
                            if (!tag.videoUrl) return [
                                3,
                                5
                            ];
                            return [
                                4,
                                _this7.tagManager.addAttachment({
                                    originName: tag.videoUrl,
                                    url: tag.videoUrl
                                }, tag.sid).catch(console.error)
                            ];
                        case 4:
                            _state.sent();
                            _state.label = 5;
                        case 5:
                            if (!(tag.type === Tag/* TagType.Iframe */.Qy.Iframe)) return [
                                3,
                                9
                            ];
                            return [
                                4,
                                _this7.showcase.Tag.registerSandbox('\n        <style>\n          body {\n            overflow-x: hidden;\n            margin: 0;\n            padding: 0 10px;\n          }\n          .container {\n            display: flex;\n            width: 100%;\n            height: 100%;\n            flex-direction: column;\n            background: white;\n          }\n          .item {\n            border: none;\n            margin: 0;\n            padding: 0;\n          }\n          ::-webkit-scrollbar {\n              width: 0px;\n              height: 0px;\n          }\n        </style>\n        <div class="container">\n            <iframe allow="accelerometer; encrypted-media; gyroscope; picture-in-picture; autoplay; fullscreen; camera; microphone; clipboard-read; clipboard-write; display-capture; geolocation; xr-spatial-tracking" class="item" src='.concat(tag.url, " ></iframe>\n        </div>\n      ")).catch(console.error)
                            ];
                        case 6:
                            t = _state.sent();
                            if (!t) return [
                                3,
                                8
                            ];
                            _t = (0,_sliced_to_array/* default */.Z)(t, 1), sandboxId = _t[0];
                            return [
                                4,
                                _this7.showcase.Tag.attach(tag.sid, sandboxId).catch(console.error)
                            ];
                        case 7:
                            _state.sent();
                            _state.label = 8;
                        case 8:
                            return [
                                3,
                                13
                            ];
                        case 9:
                            if (!((ref = tag.tagGalleries) === null || ref === void 0 ? void 0 : ref.length)) return [
                                3,
                                13
                            ];
                            _state.label = 10;
                        case 10:
                            _state.trys.push([
                                10,
                                12,
                                ,
                                13
                            ]);
                            attachments = tag.tagGalleries.filter(function(param) {
                                var url = param.url;
                                return !url.includes("mp4") && !url.includes("pdf");
                            }).map(function(gallery) {
                                return {
                                    originName: gallery.name,
                                    url: "".concat("https://cdn.treedis.com").concat(gallery.url)
                                };
                            });
                            return [
                                4,
                                _this7.tagManager.addAttachments(attachments, tag.sid).catch(console.error)
                            ];
                        case 11:
                            _state.sent();
                            return [
                                3,
                                13
                            ];
                        case 12:
                            e = _state.sent();
                            console.error(e.message);
                            return [
                                3,
                                13
                            ];
                        case 13:
                            return [
                                4,
                                _this7.showcase.Tag.editBillboard(tag.sid, {
                                    label: label,
                                    description: tag.treedisStyle ? description : (0,removeHTMLTagsFromString/* extractContentFromHTML */.D)(description)
                                }).catch(console.error)
                            ];
                        case 14:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            });
            return function(tag) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this8 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.editMattertag = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(tag) {
                var iconId, rgb, err;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                9,
                                ,
                                10
                            ]);
                            iconId = _this8.getTagIconId(tag);
                            if (!iconId) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                _this8.showcase.Tag.editIcon(tag.sid, iconId).catch(function(e) {
                                    console.error(e);
                                })
                            ];
                        case 1:
                            _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 2:
                            return [
                                4,
                                _this8.showcase.Tag.resetIcon(tag.sid).catch(function(e) {
                                    console.error(e);
                                })
                            ];
                        case 3:
                            _state.sent();
                            _state.label = 4;
                        case 4:
                            return [
                                4,
                                _this8.showcase.Tag.editPosition(tag.sid, {
                                    anchorPosition: {
                                        x: tag.positionX,
                                        y: tag.positionY,
                                        z: tag.positionZ
                                    },
                                    stemVector: {
                                        x: tag.stemVectorX || 0,
                                        y: tag.stemVectorY == null ? 0.3 : tag.stemVectorY,
                                        z: tag.stemVectorZ || 0
                                    },
                                    stemVisible: typeof tag.stemVisible === "boolean" ? tag.stemVisible : true
                                })
                            ];
                        case 5:
                            _state.sent();
                            if (!(tag.iconColor && /#\w*/i.test(tag.iconColor))) return [
                                3,
                                7
                            ];
                            rgb = util_all/* hexToRgb */.oo(tag.iconColor);
                            return [
                                4,
                                _this8.showcase.Tag.editColor(tag.sid, {
                                    r: rgb.r / 255,
                                    g: rgb.g / 255,
                                    b: rgb.b / 255
                                }).catch(console.error)
                            ];
                        case 6:
                            _state.sent();
                            _state.label = 7;
                        case 7:
                            return [
                                4,
                                _this8.editTagMedia(tag)
                            ];
                        case 8:
                            _state.sent();
                            return [
                                3,
                                10
                            ];
                        case 9:
                            err = _state.sent();
                            console.error(err);
                            return [
                                3,
                                10
                            ];
                        case 10:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(tag) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this9 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.processTags = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(_tags) {
                var loadedMattertags, allTags, models, promises;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            loadedMattertags = _this9.tagManager.getMatterTags();
                            allTags = _this9.state.allTags;
                            return [
                                4,
                                _this9.showCaseTemp.showcase.Scene.query([
                                    "model"
                                ])
                            ];
                        case 1:
                            models = _state.sent();
                            promises = _tags.map(function() {
                                var _ref = (0,_async_to_generator/* default */.Z)(function(tag) {
                                    var ref, ref1, ref2, ref3, ref4, ref5, geometry, material, helperSphere, editedTag, foundAddTag;
                                    return (0,tslib_es6.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                geometry = new _this9.THREE.SphereGeometry(0.1, 32, 16);
                                                material = new _this9.THREE.MeshBasicMaterial({
                                                    color: 0xffff00
                                                });
                                                helperSphere = new _this9.THREE.Mesh(geometry, material);
                                                helperSphere.position.set(tag.positionX + tag.stemVectorX, tag.positionY + tag.stemVectorY, tag.positionZ + tag.stemVectorZ);
                                                helperSphere.visible = false;
                                                models === null || models === void 0 ? void 0 : (ref = models[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.parent) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.add) === null || ref2 === void 0 ? void 0 : ref2.call(ref1, helperSphere);
                                                editedTag = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, tag), {
                                                    dummyObject: helperSphere
                                                });
                                                if (!(editedTag.modifiedTag && loadedMattertags.has(tag.sid) || (tag === null || tag === void 0 ? void 0 : (ref3 = tag.media) === null || ref3 === void 0 ? void 0 : ref3.type) === Tag/* TagType.Popup */.Qy.Popup && (tag === null || tag === void 0 ? void 0 : (ref4 = tag.media) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.src) === null || ref5 === void 0 ? void 0 : ref5.includes("yout")))) return [
                                                    3,
                                                    2
                                                ];
                                                // modified mp tag
                                                return [
                                                    4,
                                                    _this9.editMattertag(editedTag)
                                                ];
                                            case 1:
                                                _state.sent();
                                                allTags.set(editedTag.sid, editedTag);
                                                return [
                                                    2
                                                ];
                                            case 2:
                                                if (!(!editedTag.modifiedTag && !loadedMattertags.has(tag.sid))) return [
                                                    3,
                                                    4
                                                ];
                                                foundAddTag = Array.from(allTags, function(param) {
                                                    var _param = (0,_sliced_to_array/* default */.Z)(param, 2), value = _param[1];
                                                    return value;
                                                }).find(function(item) {
                                                    return item.id === tag.id && item.added;
                                                });
                                                if (!!foundAddTag) return [
                                                    3,
                                                    4
                                                ];
                                                editedTag.defaultSid = editedTag.sid;
                                                allTags.delete(editedTag.sid);
                                                return [
                                                    4,
                                                    _this9.addMattertag(editedTag)
                                                ];
                                            case 3:
                                                editedTag.sid = _state.sent();
                                                editedTag.added = true;
                                                _state.label = 4;
                                            case 4:
                                                allTags.set(editedTag.sid, editedTag);
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                });
                                return function(tag) {
                                    return _ref.apply(this, arguments);
                                };
                            }());
                            return [
                                4,
                                Promise.all(promises)
                            ];
                        case 2:
                            _state.sent();
                            return [
                                2,
                                allTags
                            ];
                    }
                });
            });
            return function(_tags) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this10 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.initTags = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(_tags) {
                var _loop, tagsSize, i, registerIconsPromises, updatedTags, err;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                3,
                                ,
                                4
                            ]);
                            _loop = function(i) {
                                var tag = _tags[i];
                                var iconId = _this10.getTagIconId(tag);
                                if (iconId && !_this10.tagIcons.some(function(icon) {
                                    return (icon === null || icon === void 0 ? void 0 : icon.iconId) === iconId;
                                })) {
                                    var tagIconUrl = void 0;
                                    if (tag.iconFile) {
                                        if (tag.iconFile.startsWith("http")) {
                                            tagIconUrl = "".concat(tag.iconFile);
                                        } else {
                                            tagIconUrl = "".concat("https://cdn.treedis.com", "/tours/").concat(tag.tourId, "/tags/icons/").concat(tag.iconFile);
                                        }
                                    } else if (tag.customIcon) {
                                        var baseUrl = "".concat("https://api.treedis.com" || 0, "/v1/public/icons/").concat(tag.customIcon);
                                        if (iconId === "thread") {
                                            tagIconUrl = tag.iconColor ? "".concat(baseUrl, "?hex=").concat(encodeURIComponent(tag.iconColor), "&circle=").concat(tag.whiteCircle) : baseUrl;
                                        } else {
                                            tagIconUrl = tag.iconColor ? "".concat(baseUrl, "?hex=").concat(encodeURIComponent(tag.iconColor), "&circle=").concat(tag.whiteCircle, "&size=64") : "".concat(baseUrl, "?size=64");
                                        }
                                    }
                                    _this10.tagIcons.push({
                                        iconId: iconId,
                                        url: tagIconUrl
                                    });
                                }
                            };
                            if (!_tags.length) {
                                _this10.setState({
                                    loadingTags: false
                                });
                                return [
                                    2,
                                    _tags
                                ];
                            }
                            tagsSize = _tags.length;
                            _this10.tagIcons = [];
                            for(i = 0; i < tagsSize; i += 1)_loop(i);
                            registerIconsPromises = _this10.tagIcons.map(_this10.registerIcon);
                            return [
                                4,
                                Promise.all(registerIconsPromises)
                            ];
                        case 1:
                            _state.sent();
                            return [
                                4,
                                _this10.processTags(_tags)
                            ];
                        case 2:
                            updatedTags = _state.sent();
                            // This is gonna block the thread:
                            // const promises = _tags.map(processTags);
                            // const mappedTags = await Promise.all(promises);
                            return [
                                2,
                                updatedTags
                            ];
                        case 3:
                            err = _state.sent();
                            console.error(err);
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(_tags) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this11 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.addThreadToSpace = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(thread) {
                var updatedTags;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            updatedTags = new Map(_this11.state.allTags);
                            thread.defaultSid = thread.sid;
                            updatedTags.delete(thread.sid);
                            return [
                                4,
                                _this11.addMattertag(thread)
                            ];
                        case 1:
                            thread.sid = _state.sent();
                            thread.isThread = true;
                            thread.messages = [
                                thread.message
                            ];
                            updatedTags.set(thread.sid, thread);
                            _this11.setState({
                                allTags: updatedTags
                            });
                            return [
                                2
                            ];
                    }
                });
            });
            return function(thread) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this12 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.removeThreadFromSpace = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(thread) {
                var ref, allTags, foundThreadKey;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            allTags = _this12.state.allTags;
                            foundThreadKey = (ref = Array.from(allTags.entries()).find(function(param) {
                                var _param = (0,_sliced_to_array/* default */.Z)(param, 2), value = _param[1];
                                return value.defaultSid === thread.defaultSid || value.sid === thread.defaultSid || value.defaultSid === thread.sid;
                            })) === null || ref === void 0 ? void 0 : ref[0];
                            if (!foundThreadKey) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                _this12.showcase.Tag.remove(foundThreadKey)
                            ];
                        case 1:
                            _state.sent();
                            _this12.setState(function(prevState) {
                                var updatedTags = new Map(prevState.allTags);
                                updatedTags.delete(foundThreadKey);
                                return {
                                    allTags: updatedTags
                                };
                            });
                            _state.label = 2;
                        case 2:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(thread) {
                return _ref.apply(this, arguments);
            };
        }();
        _this.toggleVisibleTags = function(tags, isVisible) {
            var _this1 = (0,_assert_this_initialized/* default */.Z)(_this);
            tags.forEach(function() {
                var _ref = (0,_async_to_generator/* default */.Z)(function(_tag) {
                    var sid, isThread, _tmp;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                sid = _tag.sid, isThread = _tag.isThread;
                                if (!sid) return [
                                    2
                                ];
                                // We shouldn't re-toggle tags that are already visible, waste of sources.
                                if (isVisible && _this1.visibleTags[sid]) return [
                                    2
                                ];
                                if (isVisible) _this1.visibleTags[sid] = true;
                                else _this1.visibleTags[sid] = false;
                                if (!isVisible && _this1.hiddenTags[sid]) return [
                                    2
                                ];
                                if (!isVisible) _this1.hiddenTags[sid] = true;
                                else _this1.hiddenTags[sid] = false;
                                if (!(_tag.type === Tag/* TagType.Music */.Qy.Music && !isVisible)) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    BaseTour_audioHandler.pauseAudio(_tag.id)
                                ];
                            case 1:
                                _state.sent();
                                _state.label = 2;
                            case 2:
                                if (!!isThread) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    _this1.showcase.Tag.editOpacity(sid, isVisible ? _tag.opacity / 100 : 0).catch(function(e) {
                                        return console.error(e);
                                    })
                                ];
                            case 3:
                                _tmp = _state.sent();
                                return [
                                    3,
                                    6
                                ];
                            case 4:
                                return [
                                    4,
                                    _this1.showcase.Tag.editOpacity(sid, isVisible ? 1 : 0).catch(function(e) {
                                        return console.error(e);
                                    })
                                ];
                            case 5:
                                _tmp = _state.sent();
                                _state.label = 6;
                            case 6:
                                _tmp;
                                return [
                                    4,
                                    _this1.showcase.Tag.editPosition(sid, {
                                        anchorPosition: {
                                            x: _tag.positionX,
                                            y: _tag.positionY,
                                            z: _tag.positionZ
                                        },
                                        stemVector: {
                                            x: isVisible ? _tag.stemVectorX || 0 : 0,
                                            y: isVisible ? _tag.stemVectorY == null ? 0.3 : _tag.stemVectorY : 0,
                                            z: isVisible ? _tag.stemVectorZ || 0 : 0
                                        },
                                        floorIndex: _tag.floor
                                    }).catch(function(e) {
                                        console.error("Error edit position with sid: ".concat(sid));
                                        console.error(e);
                                    })
                                ];
                            case 7:
                                _state.sent();
                                return [
                                    4,
                                    _this1.setTagAllowAction(_tag)
                                ];
                            case 8:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function(_tag) {
                    return _ref.apply(this, arguments);
                };
            }());
        };
        _this.getSweepGroupPolygonIdsToHide = function() {
            var _state = _this.state, activeSweepGroup = _state.activeSweepGroup, sweepGroups = _state.sweepGroups, polygons = _state.polygons;
            if (!activeSweepGroup) return [];
            var activeSweepGroupObj = sweepGroups.filter(function(item) {
                return (item === null || item === void 0 ? void 0 : item.id) === activeSweepGroup;
            })[0];
            var activeSweepGroupVsElements = (activeSweepGroupObj === null || activeSweepGroupObj === void 0 ? void 0 : activeSweepGroupObj.vsElements) || [];
            var hidePolygons = activeSweepGroupObj.hidePolygons;
            var polygonIds = activeSweepGroupVsElements.reduce(function(acc, item) {
                if ((item === null || item === void 0 ? void 0 : item.type) === "vsPolygon") {
                    acc.push(item === null || item === void 0 ? void 0 : item.elementId);
                }
                return acc;
            }, []);
            if (!polygonIds.length && !hidePolygons) {
                return [];
            }
            return (polygons || []).reduce(function(acc, item) {
                if (hidePolygons || !polygonIds.includes(item.id) && polygonIds.length) {
                    acc.push(item.id);
                }
                return acc;
            }, []);
        };
        _this.filterPolygon = function() {
            var _state = _this.state, _$tourType = _state.tourType, polygons = _state.polygons, isVSVisible = _state.isVSVisible;
            if (Tour/* TourType.Game */.v.Game === _$tourType) return;
            var sweepGroupElementIdsToHide = _this.getSweepGroupPolygonIdsToHide();
            polygons.forEach(function(polygon) {
                var isVisible = !sweepGroupElementIdsToHide.includes(polygon.id) && !polygon.isHiddenAfterClick && isVSVisible;
                polygon.active = isVisible;
            });
            var _this1 = (0,_assert_this_initialized/* default */.Z)(_this);
            _this.setState({
                polygons: polygons
            }, /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                _this1.renderPolygons()
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            }));
        };
        _this.filterTags = function() {
            var _state = _this.state, activeSweepGroup = _state.activeSweepGroup, sweepGroups = _state.sweepGroups, allTags = _state.allTags, _$tourType = _state.tourType, loadingTags = _state.loadingTags;
            if (Tour/* TourType.Game */.v.Game === _$tourType) return; // we skip filtering if it's game
            if (loadingTags || !sweepGroups.length) return;
            var activeGroup = Array.isArray(sweepGroups) ? sweepGroups.find(function(sg) {
                return sg.id === activeSweepGroup;
            }) : false;
            var tagsToRemove = [];
            var tagsToInit = [];
            if (allTags && allTags.size) {
                allTags.forEach(function(tag) {
                    var ref;
                    if (!activeGroup || activeGroup.showAllTags) {
                        tagsToInit.push(tag);
                    } else if (((ref = activeGroup.tags) === null || ref === void 0 ? void 0 : ref.length) === 0) {
                        tagsToRemove.push(tag);
                    } else {
                        var ref1;
                        var found = activeGroup === null || activeGroup === void 0 ? void 0 : (ref1 = activeGroup.tags) === null || ref1 === void 0 ? void 0 : ref1.find(function(item) {
                            return item.tagSid === tag.sid || item.tagSid === tag.defaultSid;
                        });
                        if (found) {
                            tagsToInit.push(tag);
                        } else {
                            tagsToRemove.push(tag);
                        }
                    }
                });
            }
            _this.toggleVisibleTags(tagsToRemove, false);
            _this.toggleVisibleTags(tagsToInit, true);
        };
        var _this13 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.handleToggleMusic = /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            var _state, tour, tourAudioPlaying, currentFloor, playAudio, pauseAllMusic, isTourMusicPaused, stopTourMusic, ref, music, e;
            return (0,tslib_es6.__generator)(this, function(_state1) {
                switch(_state1.label){
                    case 0:
                        _state1.trys.push([
                            0,
                            10,
                            ,
                            11
                        ]);
                        _state = _this13.state, tour = _state.tour, tourAudioPlaying = _state.tourAudioPlaying, currentFloor = _state.currentFloor;
                        playAudio = BaseTour_audioHandler.playAudio, pauseAllMusic = BaseTour_audioHandler.pauseAllMusic, isTourMusicPaused = BaseTour_audioHandler.isTourMusicPaused, stopTourMusic = BaseTour_audioHandler.stopTourMusic;
                        if (!_this13.isTourReadyForAudio()) {
                            return [
                                2
                            ];
                        }
                        pauseAllMusic();
                        if (_this13.state.vsAudio) {
                            _this13.muteVSVideo(_this13.state.vsAudio.component);
                            _this13.setState({
                                vsAudio: null
                            });
                        }
                        if (!!tourAudioPlaying) return [
                            3,
                            7
                        ];
                        if (!(((ref = tour.musics) === null || ref === void 0 ? void 0 : ref.length) > 0 && !tour.sameMusicForAllFloors)) return [
                            3,
                            5
                        ];
                        music = tour.musics.find(function(item) {
                            return item.floor === currentFloor;
                        });
                        if (!(!music || !music.isActive)) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            playAudio({
                                type: AudioModule/* MusicObj.TOUR */.nR.TOUR,
                                id: _this13.state.tour.id
                            }).then(function() {
                                _this13.setState({
                                    tourAudioPlaying: !isTourMusicPaused()
                                });
                            })
                        ];
                    case 1:
                        _state1.sent();
                        return [
                            2
                        ];
                    case 2:
                        if (!(music && !tour.sameMusicForAllFloors && music.isActive)) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            playAudio({
                                type: AudioModule/* MusicObj.FLOORS */.nR.FLOORS,
                                id: music.id
                            }).then(function() {
                                _this13.setState({
                                    tourAudioPlaying: !isTourMusicPaused()
                                });
                            })
                        ];
                    case 3:
                        _state1.sent();
                        _state1.label = 4;
                    case 4:
                        return [
                            2
                        ];
                    case 5:
                        return [
                            4,
                            playAudio({
                                type: AudioModule/* MusicObj.TOUR */.nR.TOUR,
                                id: _this13.state.tour.id
                            }).then(function() {
                                _this13.setState({
                                    tourAudioPlaying: !isTourMusicPaused()
                                });
                            })
                        ];
                    case 6:
                        _state1.sent();
                        return [
                            3,
                            9
                        ];
                    case 7:
                        return [
                            4,
                            stopTourMusic()
                        ];
                    case 8:
                        _state1.sent();
                        _state1.label = 9;
                    case 9:
                        return [
                            3,
                            11
                        ];
                    case 10:
                        e = _state1.sent();
                        return [
                            3,
                            11
                        ];
                    case 11:
                        return [
                            2
                        ];
                }
            });
        });
        var _this14 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.changeFloor = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(floorIndex) {
                var _$all, err;
                var _arguments = arguments;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _$all = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : false;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            _this14.setState({
                                panoramaOn: false
                            });
                            return [
                                4,
                                _this14.showCaseTemp.floor.changeFloor(floorIndex, _this14.state.tourPlaying, _$all)
                            ];
                        case 2:
                            _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 3:
                            err = _state.sent();
                            console.error(err);
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(floorIndex) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this15 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.playTour = /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            var err;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        _this15.setState({
                            panoramaOn: false
                        });
                        return [
                            4,
                            _this15.showCaseTemp.tour.playTour(_this15.state.tourPlaying, _this15.state.reelStep)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        err = _state.sent();
                        console.error(err);
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        var _this16 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.changeViewMode = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(mode) {
                var err;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            _this16.setState({
                                panoramaOn: false
                            });
                            return [
                                4,
                                _this16.showCaseTemp.tour.changeViewMode(mode, _this16.state.tourPlaying)
                            ];
                        case 1:
                            _state.sent();
                            return [
                                3,
                                3
                            ];
                        case 2:
                            err = _state.sent();
                            console.error(err);
                            return [
                                3,
                                3
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(mode) {
                return _ref.apply(this, arguments);
            };
        }();
        _this.trySwitchLoadIndicatorMode = function(delays) {
            var index = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
            setTimeout(function() {
                var ref, ref1, ref2, ref3;
                var loaderByMeasurementsOffElement = (ref = _this.iframe) === null || ref === void 0 ? void 0 : (ref1 = ref.contentWindow) === null || ref1 === void 0 ? void 0 : ref1.document.querySelector(".load-indicator");
                if (loaderByMeasurementsOffElement === null || loaderByMeasurementsOffElement === void 0 ? void 0 : (ref2 = loaderByMeasurementsOffElement.classList) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.contains) === null || ref3 === void 0 ? void 0 : ref3.call(ref2, "fade-in")) {
                    loaderByMeasurementsOffElement.classList.remove("fade-in");
                    loaderByMeasurementsOffElement.classList.add("fade-out");
                }
                if (index < delays.length - 1) {
                    _this.trySwitchLoadIndicatorMode(delays, index + 1);
                }
            }, delays[index]);
        };
        var _this17 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.measurementsMode = /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            var modeOn, err;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        modeOn = !_this17.state.measurementsOn;
                        return [
                            4,
                            _this17.showcase.Measurements.toggleMode(modeOn)
                        ];
                    case 1:
                        _state.sent();
                        if (!modeOn) {
                            // Manually switch mode from .fade-in to .fade-out for .load-indicator in showcase
                            _this17.trySwitchLoadIndicatorMode([
                                0,
                                300,
                                500
                            ]);
                        }
                        return [
                            3,
                            3
                        ];
                    case 2:
                        err = _state.sent();
                        console.error("Failed to change mode.");
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        _this.takePosition = function(event) {
            // ctrl+y
            if (event.ctrlKey && event.keyCode === 89) {
                var _state = _this.state, _tour = _state.tour, slug = _tour.slug, matterId = _tour.matterId;
                takePositionData({
                    slug: slug,
                    matterId: matterId,
                    sweep: _this.pose.sweep,
                    rotation: _this.pose.rotation
                });
            }
        };
        var _this18 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.closeTagPop = /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            var ref, ref1, _state, showcaseLoaded, host, room;
            return (0,tslib_es6.__generator)(this, function(_state1) {
                switch(_state1.label){
                    case 0:
                        _state = _this18.state, showcaseLoaded = _state.showcaseLoaded, host = _state.host, room = _state.room;
                        if (showcaseLoaded && room && socket/* default */.Z && socket/* default.connected */.Z.connected && host) {
                            socket/* default.emit */.Z.emit("close-tag");
                        }
                        if (!(((ref = _this18.state.openedTag) === null || ref === void 0 ? void 0 : ref.type) === Tag/* TagType.Music */.Qy.Music || ((ref1 = _this18.state.openedTag) === null || ref1 === void 0 ? void 0 : ref1.type) === Tag/* TagType.Popup */.Qy.Popup)) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            BaseTour_audioHandler.resumeMusic()
                        ];
                    case 1:
                        _state1.sent();
                        _state1.label = 2;
                    case 2:
                        _this18.setState({
                            tagPopOn: false,
                            openedTag: null,
                            closedElementPopup: true
                        });
                        return [
                            2
                        ];
                }
            });
        });
        _this.closeConditionPopUp = function() {
            _this.setState({
                conditionPopUp: null
            });
        };
        _this.closeGameLockPop = function(isCorrect) {};
        var _this19 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.changeTagIconAndColor = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(tag, icon, color) {
                var iconId, iconUrl;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            iconId = "".concat(icon, "__").concat(Math.random());
                            iconUrl = "".concat("https://api.treedis.com" || 0, "/v1/public/icons/").concat(icon, "?hex=").concat(encodeURIComponent(color));
                            return [
                                4,
                                _this19.registerIcon({
                                    iconId: iconId,
                                    url: iconUrl
                                }).catch(function(e) {
                                    console.error(e);
                                })
                            ];
                        case 1:
                            _state.sent();
                            return [
                                4,
                                _this19.showcase.Tag.editIcon(tag.sid, iconId).catch(function(e) {
                                    console.error(e);
                                })
                            ];
                        case 2:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            });
            return function(tag, icon, color) {
                return _ref.apply(this, arguments);
            };
        }();
        _this.closePanoPop = function() {
            var _state = _this.state, showcaseLoaded = _state.showcaseLoaded, host = _state.host, room = _state.room;
            if (showcaseLoaded && room && socket/* default */.Z && socket/* default.connected */.Z.connected && host) {
                socket/* default.emit */.Z.emit("close-pano-pop");
            }
            _this.setState({
                panoPopOn: false,
                openedPanoHotspot: null
            });
        };
        var _this20 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.closeActionPop = /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            var _state, showcaseLoaded, room, host, openedVSAction, vsActionPopOn, vsActionIframeInterupt, vsActionMedia;
            return (0,tslib_es6.__generator)(this, function(_state1) {
                switch(_state1.label){
                    case 0:
                        _state = _this20.state, showcaseLoaded = _state.showcaseLoaded, room = _state.room, host = _state.host, openedVSAction = _state.openedVSAction, vsActionPopOn = _state.vsActionPopOn;
                        vsActionIframeInterupt = openedVSAction.type === VSObject/* TourActionType.Iframe */.mI.Iframe && !(openedVSAction === null || openedVSAction === void 0 ? void 0 : openedVSAction.dontInterruptBgAudio);
                        vsActionMedia = [
                            VSObject/* TourActionType.Music */.mI.Music,
                            VSObject/* TourActionType.Video */.mI.Video
                        ].includes(openedVSAction.type);
                        if (showcaseLoaded && room && socket/* default */.Z && socket/* default.connected */.Z.connected && host) {
                            socket/* default.emit */.Z.emit("close-polygon");
                        }
                        if (!(_this20.state.tourType === Tour/* TourType.Game */.v.Game)) return [
                            3,
                            2
                        ];
                        if (!(vsActionPopOn && (vsActionMedia || vsActionIframeInterupt))) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            BaseTour_audioHandler.resumeMusic()
                        ];
                    case 1:
                        _state1.sent();
                        _state1.label = 2;
                    case 2:
                        _this20.setState({
                            vsActionPopOn: false,
                            closedElementPopup: true
                        });
                        return [
                            2
                        ];
                }
            });
        });
        _this.closePathFinderPop = function() {
            _this.setState({
                showPathFinderPopup: false
            });
        };
        _this.showcaseLoad = function() {
            var ref, ref1;
            _this.cleanupIframeResources();
            var search = _this.getValueOnWindowLocationObject("search");
            var iframeContentWindowUrlParams = new URLSearchParams(search);
            var iframeSrcUrl = new URL("https://my.treedis.com".concat(_this.state.iframeUrl));
            var iframeSrcUrlParams = new URLSearchParams(iframeSrcUrl === null || iframeSrcUrl === void 0 ? void 0 : iframeSrcUrl.search);
            var m = iframeContentWindowUrlParams.get("m");
            if (m && m !== iframeSrcUrlParams.get("m")) {
                _this.setState({
                    iframeUrl: _this.state.iframeUrl.replace(/(m=).*?(&)/, "$1".concat(m, "$2"))
                });
                return;
            }
            _this.unsubsribeShowcaseAppSubscriber();
            _this.showcaseLoader((ref = _this.state.tour) === null || ref === void 0 ? void 0 : (ref1 = ref.user) === null || ref1 === void 0 ? void 0 : ref1.mpSDK);
        };
        var _this21 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.moveModel = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(url) {
                var keepRotation, instant, THREE, ref, id, iframeId, linkData, rand, linkDataShort, q, quaternion, euler, rotation, xr, yr, zr, mode, position, euler1, rotation1, ref1, scan, err;
                var _arguments = arguments;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            keepRotation = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : false, instant = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : false;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                13,
                                ,
                                14
                            ]);
                            THREE = _this21.THREE;
                            ref = getUrlVariables(url, _this21.state.iframeUrl), id = ref.id, iframeId = ref.iframeId, linkData = ref.linkData, rand = ref.rand, linkDataShort = ref.linkDataShort;
                            if (!linkData) return [
                                3,
                                5
                            ];
                            q = linkData.camera_quaternion;
                            quaternion = new THREE.Quaternion(q.x, q.y, q.z, q.w);
                            euler = new THREE.Euler().setFromQuaternion(quaternion, "YXZ");
                            rotation = new THREE.Vector3(euler.x, euler.y, euler.z).multiplyScalar(180 / Math.PI); // @ts-ignore
                            if (keepRotation || linkData.showcase_sweep) {
                                rotation = _this21.pose.rotation;
                            }
                            if (!(id && iframeId && (id === null || id === void 0 ? void 0 : id.toLowerCase()) != (iframeId === null || iframeId === void 0 ? void 0 : iframeId.toLowerCase()))) return [
                                3,
                                2
                            ];
                            _this21.startShowcaseLoad();
                            _this21.setState({
                                iframeUrl: "".concat(url, "&qs=").concat(instant ? "1" : "0", "&play=1&newtags=1&refreshid=").concat(rand),
                                panoramaOn: false
                            }, function() {
                                if (_this21.state.room && _this21.state.host) {
                                    socket/* default.emit */.Z.emit("tour_load", {
                                        id: id,
                                        mp: true
                                    });
                                }
                            });
                            return [
                                3,
                                4
                            ];
                        case 2:
                            return [
                                4,
                                _this21.moveToSweep(linkData.scan_id, rotation, instant ? "INSTANT" : "FLY")
                            ];
                        case 3:
                            _state.sent();
                            _state.label = 4;
                        case 4:
                            return [
                                3,
                                12
                            ];
                        case 5:
                            if (!linkDataShort) return [
                                3,
                                11
                            ];
                            xr = parseFloat(linkDataShort.sr[0] || "0");
                            yr = parseFloat(linkDataShort.sr[1] || "0");
                            zr = parseFloat(linkDataShort.sr[2] || "0");
                            mode = linkDataShort.sm === 2 ? _this21.showCaseTemp.showcase.Mode.Mode.DOLLHOUSE : linkDataShort.sm === 3 ? _this21.showCaseTemp.showcase.Mode.Mode.FLOORPLAN : null;
                            position = null;
                            if (linkDataShort.sp) {
                                position = {
                                    x: parseFloat(linkDataShort.sp[0] || "0"),
                                    y: parseFloat(linkDataShort.sp[1] || "0"),
                                    z: parseFloat(linkDataShort.sp[2] || "0")
                                };
                            }
                            euler1 = new THREE.Euler().set(xr, yr, zr, "XYZ").reorder("YXZ");
                            rotation1 = new THREE.Vector3(euler1.x, euler1.y, euler1.z).multiplyScalar(180 / Math.PI); // @ts-ignore
                            rotation1.z = 0;
                            if (keepRotation) rotation1 = _this21.pose.rotation;
                            if (!(id && iframeId && id.toLowerCase() != iframeId.toLowerCase())) return [
                                3,
                                6
                            ];
                            _this21.startShowcaseLoad();
                            _this21.setState({
                                iframeUrl: "".concat(url, "&qs=").concat(instant ? "1" : "0", "&newtags=1&play=1&refreshid=").concat(rand),
                                panoramaOn: false,
                                activePano: null
                            }, function() {
                                if (_this21.state.room && _this21.state.host) {
                                    socket/* default.emit */.Z.emit("tour_load", {
                                        id: id,
                                        mp: true
                                    });
                                }
                            });
                            return [
                                3,
                                10
                            ];
                        case 6:
                            if (!linkDataShort.ss) return [
                                3,
                                8
                            ];
                            scan = (ref1 = _this21.state.sweeps) === null || ref1 === void 0 ? void 0 : ref1.find(function(sweep) {
                                return sweep.index === linkDataShort.ss - 1;
                            });
                            if (!scan) {
                                console.error("Scan not found", linkDataShort.ss, _this21.state.sweeps);
                                return [
                                    2
                                ];
                            }
                            return [
                                4,
                                _this21.moveToSweep(scan.id, rotation1, instant ? "INSTANT" : "FLY")
                            ];
                        case 7:
                            _state.sent();
                            return [
                                3,
                                10
                            ];
                        case 8:
                            if (!(linkDataShort.sm && position)) return [
                                3,
                                10
                            ];
                            // move to dollhouse
                            return [
                                4,
                                _this21.showCaseTemp.showcase.Mode.moveTo(mode, (0,_object_spread/* default */.Z)({
                                    position: position,
                                    rotation: rotation1,
                                    transition: instant ? _this21.showCaseTemp.showcase.Mode.TransitionType.INSTANT : _this21.showCaseTemp.showcase.Mode.TransitionType.FLY
                                }, linkDataShort.sz && {
                                    zoom: linkDataShort.sz
                                }))
                            ];
                        case 9:
                            _state.sent();
                            _state.label = 10;
                        case 10:
                            return [
                                3,
                                12
                            ];
                        case 11:
                            if (id && iframeId && id.toLowerCase() != iframeId.toLowerCase()) {
                                _this21.startShowcaseLoad();
                                // for no link data, just simple links
                                _this21.setState({
                                    iframeUrl: "".concat(url, "&qs=1&newtags=1&play=1&refreshid=").concat(rand),
                                    panoramaOn: false,
                                    activePano: null
                                }, function() {
                                    if (_this21.state.room && _this21.state.host) {
                                        socket/* default.emit */.Z.emit("tour_load", {
                                            id: id,
                                            mp: true
                                        });
                                    }
                                });
                            }
                            _state.label = 12;
                        case 12:
                            _this21.setState({
                                overlayOn: false,
                                markerPopupOn: false,
                                panoramaOn: false,
                                isTagHovered: false,
                                lastTagHovered: null,
                                selectedTag: null
                            });
                            return [
                                3,
                                14
                            ];
                        case 13:
                            err = _state.sent();
                            console.error(err);
                            return [
                                3,
                                14
                            ];
                        case 14:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(url) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this22 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.handleClickDescriptionLink = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(url) {
                var s, x, y;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    if (url.includes("/tour/")) {
                        s = (0,util_all/* getQueryVariable */.Dv)(url, "s");
                        x = (0,util_all/* getQueryVariable */.Dv)(url, "x");
                        y = (0,util_all/* getQueryVariable */.Dv)(url, "y");
                        _this22.moveToSweep(String(s), {
                            x: parseFloat(String(x)),
                            y: parseFloat(String(y))
                        }).catch(function(err) {
                            return console.error(err);
                        });
                    } else if (url.includes("/my.matterport.com/")) {
                        _this22.moveModel(url, false, true).catch(function(err) {
                            return console.error(err);
                        });
                    } else {
                        window.open(url, "_blank");
                    }
                    return [
                        2
                    ];
                });
            });
            return function(url) {
                return _ref.apply(this, arguments);
            };
        }();
        _this.markerClick = function(hotspot) {
            _this.setState({
                minimapOn: false
            }, function() {
                if (hotspot.type === "panorama") {
                    var _state = _this.state, minimaps = _state.minimaps, selectedMinimap = _state.selectedMinimap;
                    minimaps[selectedMinimap].hotspots.map(function(h) {
                        hotspot.active = h.id === hotspot.id;
                        return hotspot;
                    });
                    _this.setState({
                        panoramaOn: true,
                        minimaps: minimaps,
                        activePano: hotspot.panoramaId,
                        mapWalkerX: hotspot.x,
                        mapWalkerY: hotspot.y
                    });
                    return;
                }
                if (!hotspot.external) {
                    _this.setState({
                        overlayOn: false
                    });
                    if (hotspot.url) {
                        var whiteLabelData = _this.state.whiteLabelData;
                        var url = hotspot.url;
                        var type = [
                            "my.treedis.com",
                            "test.treedis.com",
                            whiteLabelData === null || whiteLabelData === void 0 ? void 0 : whiteLabelData.domainUrl,
                            "localhost:"
                        ].find(function(item) {
                            return url.includes(item);
                        }) ? Menu/* MenuType.Treedis */.o.Treedis : Menu/* MenuType.Matterport */.o.Matterport;
                        _this.loadModel(null, url, type);
                    } else {
                        var ref, ref1;
                        var start = encodeURIComponent(JSON.stringify({
                            camera_mode: 1,
                            scan_id: hotspot.scanId,
                            showcase_sweep: hotspot.showcaseSweep,
                            camera_position: {
                                x: hotspot.positionX,
                                y: hotspot.positionY,
                                z: hotspot.positionZ
                            },
                            camera_quaternion: {
                                x: hotspot.rotationX,
                                y: hotspot.rotationY,
                                z: hotspot.rotationZ,
                                w: hotspot.rotationW
                            }
                        }));
                        _this.moveModel("/mp-sdk/".concat("24.11.2", "/showcase.html?applicationKey=").concat((ref = _this.state.tour) === null || ref === void 0 ? void 0 : (ref1 = ref.user) === null || ref1 === void 0 ? void 0 : ref1.mpSDK, "&m=").concat(_this.state.tour.matterId, "&start=").concat(start));
                    }
                } else {
                    _this.setState({
                        selectedMarker: {
                            url: hotspot.url,
                            external: hotspot.external
                        },
                        markerPopupOn: true,
                        overlayOn: true
                    });
                }
            });
        };
        _this.releaseLock = function() {
            _this.setState({
                lock: false
            });
        };
        _this.toggleAppointmentsModal = function() {
            _this.setState({
                appointmentsModal: !_this.state.appointmentsModal,
                appointmentsHintOn: false
            });
            _this.toggleExternalPopup();
        };
        _this.handleCustomButton = function() {
            var _state = _this.state, tour = _state.tour, externalPopupOn = _state.externalPopupOn;
            if (tour.customButtonOpenAs === Tour/* CustomButtonTypeOpenAsType.Tab */.Bg.Tab) {
                _this.openNewTab(tour.customButtonUrl);
                return;
            }
            if (externalPopupOn) return;
            _this.setState({
                externalPopupUrl: tour.customButtonUrl,
                externalPopupOn: true
            });
        };
        _this.toggleNav = function() {
            var _state = _this.state, menuOpen = _state.menuOpen, _tour = _state.tour, menuEnabled = _tour.menuEnabled, menuAlwaysOpenMobile = _tour.menuAlwaysOpenMobile, menuAlwaysOpenDesktop = _tour.menuAlwaysOpenDesktop, _$tourType = _state.tourType;
            var menuOpenForDevice = _$tourType === Tour/* TourType.Regular */.v.Regular && !!(deviceManager/* default.isMobile */.Z.isMobile() ? menuEnabled && menuAlwaysOpenMobile : menuEnabled && menuAlwaysOpenDesktop);
            _this.setState({
                menuOpen: menuOpenForDevice || !menuOpen,
                menuOpened: true,
                activeMenu: null,
                MenuHintOn: false
            });
        };
        _this.setBaseState = function(obj) {
            _this.setState(obj);
        };
        _this.disableContext = function(e) {
            e.preventDefault();
        };
        var _this23 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.processTourMusic = /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            var initPlay, _state, currentFloor, tour, music, ref, ref1, ref2, ref3;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state1) {
                switch(_state1.label){
                    case 0:
                        initPlay = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : false;
                        _state = _this23.state, currentFloor = _state.currentFloor, tour = _state.tour;
                        music = tour.musics.find(function(item) {
                            return item.floor === currentFloor;
                        });
                        if (!initPlay && BaseTour_audioHandler.isTourMusicPaused() && !(music === null || music === void 0 ? void 0 : music.autoplay)) {
                            return [
                                2
                            ];
                        }
                        if (!(music && !tour.sameMusicForAllFloors && (music === null || music === void 0 ? void 0 : music.isActive))) return [
                            3,
                            4
                        ];
                        if (!music.autoplay) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            _this23.setState({
                                tourAudioPlaying: !!music.autoplay
                            })
                        ];
                    case 1:
                        _state1.sent();
                        return [
                            4,
                            BaseTour_audioHandler.playAudio({
                                type: AudioModule/* MusicObj.FLOORS */.nR.FLOORS,
                                id: music.id
                            })
                        ];
                    case 2:
                        _state1.sent();
                        _state1.label = 3;
                    case 3:
                        return [
                            2
                        ];
                    case 4:
                        if ((!music || tour.sameMusicForAllFloors) && tour.music) {
                            music = {
                                autoplay: tour.autoplayMusic
                            };
                        }
                        if (!music) return [
                            3,
                            13
                        ];
                        if (!!tour.music) return [
                            3,
                            5
                        ];
                        BaseTour_audioHandler.pauseAllMusic();
                        return [
                            3,
                            7
                        ];
                    case 5:
                        return [
                            4,
                            BaseTour_audioHandler.stopAudioByType(AudioModule/* MusicObjectKey.FLOORS */.NO.FLOORS)
                        ];
                    case 6:
                        _state1.sent();
                        _state1.label = 7;
                    case 7:
                        if (!(music.autoplay && !(tour.noAudioMode && _this23.state.room) && // in case of Intro Screen is enables, the music
                        // should play after user clicks on play button
                        !_this23.state.startScreenOn)) return [
                            3,
                            13
                        ];
                        if (!(((ref = _this23.props.renderer) === null || ref === void 0 ? void 0 : (ref1 = ref.xr) === null || ref1 === void 0 ? void 0 : ref1.enabled) && ((ref2 = _this23.props.renderer) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.xr) === null || ref3 === void 0 ? void 0 : ref3.isPresenting))) return [
                            3,
                            9
                        ];
                        return [
                            4,
                            _this23.playTourAudio().catch(function() {})
                        ];
                    case 8:
                        _state1.sent();
                        return [
                            3,
                            13
                        ];
                    case 9:
                        if (!deviceManager/* default.supportsTouch */.Z.supportsTouch()) return [
                            3,
                            10
                        ];
                        // we force touch to play music
                        _this23.setState({
                            interacted: false
                        });
                        document.addEventListener("touchstart", /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                            return (0,tslib_es6.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _this23.setState({
                                            interacted: true
                                        });
                                        return [
                                            4,
                                            _this23.playTourAudio().catch(function() {})
                                        ];
                                    case 1:
                                        _state.sent();
                                        return [
                                            2
                                        ];
                                }
                            });
                        }), {
                            once: true
                        });
                        return [
                            3,
                            13
                        ];
                    case 10:
                        if (!(!_this23.state.interacted || deviceManager/* default.isMobile */.Z.isMobile())) return [
                            3,
                            11
                        ];
                        _this23.setState({
                            interacted: false
                        });
                        document.addEventListener("click", /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                            return (0,tslib_es6.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _this23.setState({
                                            interacted: true
                                        });
                                        return [
                                            4,
                                            _this23.playTourAudio().catch(function() {})
                                        ];
                                    case 1:
                                        _state.sent();
                                        return [
                                            2
                                        ];
                                }
                            });
                        }), {
                            once: true
                        });
                        return [
                            3,
                            13
                        ];
                    case 11:
                        return [
                            4,
                            _this23.playTourAudio().catch(function() {})
                        ];
                    case 12:
                        _state1.sent();
                        _state1.label = 13;
                    case 13:
                        return [
                            2
                        ];
                }
            });
        });
        var _this24 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.loadData = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(tourData) {
                var changeMenu, changeMinimap, changePanorama, url, changeReel, ref, tour, stateTour, _$tourType, matterStartLocation, importAudioData, s, x, y, target, ss, sr, m, matterId, addons, menuOpenForDevice, initialDuplicates, _tmp, menuOpen, china;
                var _arguments = arguments;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            changeMenu = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : true, changeMinimap = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : true, changePanorama = _arguments.length > 3 && _arguments[3] !== void 0 ? _arguments[3] : true, url = _arguments.length > 4 && _arguments[4] !== void 0 ? _arguments[4] : null, changeReel = _arguments.length > 5 && _arguments[5] !== void 0 ? _arguments[5] : false;
                            tour = new Tour/* Tour */.Oj(tourData);
                            stateTour = _this24.state.tour;
                            _$tourType = _this24.state.tourType;
                            matterStartLocation = "";
                            importAudioData = BaseTour_audioHandler.importAudioData;
                            if (!url) return [
                                3,
                                3
                            ];
                            s = (0,util_all/* getQueryVariable */.Dv)(url, "s");
                            x = (0,util_all/* getQueryVariable */.Dv)(url, "x");
                            y = (0,util_all/* getQueryVariable */.Dv)(url, "y");
                            target = (0,util_all/* getQueryVariable */.Dv)(url, "target");
                            if (!(s && x && y)) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                (0,queries/* getSweepIndex */.QM)(tour.matterId, tour.slug, s)
                            ];
                        case 1:
                            ss = _state.sent();
                            sr = "".concat(Number(x) * (Math.PI / 180), ",").concat(Number(y) * (Math.PI / 180));
                            if (sr && ss >= 0) {
                                matterStartLocation = "&ss=".concat(ss, "&sr=").concat(sr);
                            }
                            // window.history.replaceState(null, '', this.buildLink(s, { x, y }));
                            window.history.replaceState(null, "", _this24.buildLink(s, {
                                x: x,
                                y: y
                            }, null, target));
                            _this24.setState({
                                navigationStartPosition: {
                                    s: s,
                                    x: x,
                                    y: y
                                }
                            });
                            if (target) {
                                tour.navigationWebEnabled = true;
                            }
                            _state.label = 2;
                        case 2:
                            return [
                                3,
                                4
                            ];
                        case 3:
                            if (tour.ss && tour.sr) {
                                matterStartLocation = "&ss=".concat(tour.ss, "&sr=").concat(tour.sr);
                            }
                            _state.label = 4;
                        case 4:
                            if (!changeMenu && stateTour) {
                                tour.reel = stateTour.reel;
                                tour.menuEnabled = stateTour.menuEnabled;
                                tour.menuAlwaysOpenMobile = stateTour.menuAlwaysOpenMobile;
                                tour.menuAlwaysOpenDesktop = stateTour.menuAlwaysOpenDesktop;
                            }
                            if (!changePanorama && stateTour) tour.panorama = stateTour.panorama;
                            if (!changeMinimap && (stateTour === null || stateTour === void 0 ? void 0 : stateTour.customMinimap)) {
                                tour.customMinimap = stateTour.customMinimap;
                                tour.minimap = true;
                            }
                            tour.reel = tourData.reel;
                            m = (0,util_all/* getQueryVariable */.Dv)(window.location.href, "m");
                            matterId = m || tour.matterId;
                            if (_this24.state.room) {
                                if (_this24.state.host) {
                                    socket/* default.emit */.Z.emit("tour_load", {
                                        id: matterId,
                                        mp: false
                                    });
                                } else if (matterId !== tour.matterId) {
                                    // if host uses a Tour Link, matterId should be updated with id of next tour
                                    matterId = tour.matterId;
                                }
                            }
                            addons = tour.getAddonsUrl();
                            if (tour.introScreen) {
                                addons = addons.replace(/qs=0/g, "qs=1");
                            }
                            if (tour.navigationWebEnabled) {
                                addons = addons.replace(/dh=1/g, "dh=0");
                            }
                            menuOpenForDevice = _$tourType === Tour/* TourType.Regular */.v.Regular && !!(deviceManager/* default.isMobile */.Z.isMobile() ? tour.menuEnabled && tour.menuAlwaysOpenMobile : tour.menuEnabled && tour.menuAlwaysOpenDesktop);
                            if (!(tourData === null || tourData === void 0 ? void 0 : tourData.initialDuplicates)) return [
                                3,
                                5
                            ];
                            _tmp = tourData.initialDuplicates;
                            return [
                                3,
                                7
                            ];
                        case 5:
                            return [
                                4,
                                (ref = TreedisPublicDAO/* default.getDuplicates */.Z.getDuplicates(tour.parentId || tour.id)) === null || ref === void 0 ? void 0 : ref.duplicates
                            ];
                        case 6:
                            _tmp = _state.sent();
                            _state.label = 7;
                        case 7:
                            initialDuplicates = _tmp;
                            menuOpen = changeMenu ? _this24.state.room && !_this24.state.host ? false : tour.menuEnabled && tour.menuOnStart || menuOpenForDevice || false : _this24.state.menuOpen;
                            china = util_all/* getQueryVariable */.Dv(window.location.href, "china");
                            // disable some features for web navigation test
                            if (tour.navigationWebEnabled) {
                                tour.menuEnabled = false;
                                tour.reel = false;
                                tour.mpReel = false;
                                tour.panorama = false;
                                tour.minimap = false;
                            }
                            return [
                                2,
                                new Promise(function(resolve) {
                                    var ref;
                                    return _this24.setState({
                                        initialDuplicates: initialDuplicates,
                                        menuOpen: menuOpen,
                                        changeMenu: changeMenu,
                                        tour: tour,
                                        isVSEnabled: tour.enableVS,
                                        allowGuestBeforeHost: tour.allowGuestBeforeHost,
                                        minimapVisible: tour.minimapVisible && !_this24.state.room && window.innerWidth > 768,
                                        iframeUrl: "/mp-sdk/".concat("24.11.2", "/showcase").concat(china ? "-china" : "", ".html?applicationKey=").concat(tour === null || tour === void 0 ? void 0 : (ref = tour.user) === null || ref === void 0 ? void 0 : ref.mpSDK, "&m=").concat(matterId).concat(addons).concat(matterStartLocation),
                                        appointmentsHintOn: tour.appointmentTooltipOn,
                                        MenuHintOn: tour.menuTooltipOn,
                                        changeReel: changeReel
                                    }, /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                                        return (0,tslib_es6.__generator)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    if (!tour.gameId) return [
                                                        3,
                                                        2
                                                    ];
                                                    return [
                                                        4,
                                                        (0,util_all/* fetchData */.rQ)("public/getGame", "POST", {
                                                            id: tour.gameId
                                                        }).then(function(data) {
                                                            var ref;
                                                            var game = new Game/* Game */.lA(data === null || data === void 0 ? void 0 : data.game);
                                                            _this24.gameAnalytic = new GameAnalyticService(game.id, tour.slug);
                                                            var showIntro = (game === null || game === void 0 ? void 0 : game.introClip) && ((game === null || game === void 0 ? void 0 : game.introClipUrl) || (game === null || game === void 0 ? void 0 : game.uploadedIntroUrl));
                                                            // showIntro is for IntroClip
                                                            // startScreenOn is for IntroScreen
                                                            _this24.setState({
                                                                gameLoaded: true,
                                                                showIntro: showIntro && !(tour.introScreen || tour.password) && !_this24.isGameTour(),
                                                                startScreenOn: _this24.isGameTour() || !!tour.introScreen || !!tour.password,
                                                                game: game,
                                                                showBook: (game === null || game === void 0 ? void 0 : game.gameBookOn) && (game === null || game === void 0 ? void 0 : (ref = game.book) === null || ref === void 0 ? void 0 : ref.openByDefault)
                                                            });
                                                            if (!showIntro && !tour.password) {
                                                                _this24.showcaseLoad();
                                                            }
                                                        }).catch(function(err) {
                                                            var ref, ref1, ref2, ref3, ref4;
                                                            if (err === null || err === void 0 ? void 0 : (ref = err.response) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.message) === null || ref2 === void 0 ? void 0 : ref2.includes("trial")) _this24.setState({
                                                                gameTrialErr: err === null || err === void 0 ? void 0 : (ref3 = err.response) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.data) === null || ref4 === void 0 ? void 0 : ref4.message
                                                            });
                                                            console.error(err.message);
                                                        })
                                                    ];
                                                case 1:
                                                    _state.sent();
                                                    return [
                                                        3,
                                                        4
                                                    ];
                                                case 2:
                                                    return [
                                                        4,
                                                        _this24.startShowcaseLoad()
                                                    ];
                                                case 3:
                                                    _state.sent();
                                                    _this24.setState({
                                                        game: null,
                                                        startScreenOn: !!tour.introScreen || !!tour.password
                                                    });
                                                    _state.label = 4;
                                                case 4:
                                                    if (tour.disableContext) {
                                                        document.addEventListener("contextmenu", _this24.disableContext);
                                                    }
                                                    (0,util_all/* fetchData */.rQ)("public/getAgentsContactForm/".concat(tour.id), "GET").then(function(data) {
                                                        var agents = data.agents.map(function(a) {
                                                            return new Agent/* Agent */.P(a.agent);
                                                        });
                                                        if (agents && agents.length) _this24.setState({
                                                            agents: agents
                                                        });
                                                    }).catch(function(err) {
                                                        console.error(err.message);
                                                    });
                                                    if (tour.minimap && changeMinimap) {
                                                        (0,util_all/* fetchData */.rQ)("public/getMinimaps", "POST", {
                                                            id: tour.id
                                                        }).then(function(data) {
                                                            var minimaps = data.minimaps;
                                                            _this24.setState({
                                                                minimaps: minimaps,
                                                                selectedMinimap: 0
                                                            });
                                                        }).catch(function(err) {
                                                            console.error(err.message);
                                                        });
                                                    }
                                                    if (tour.panorama) {
                                                        (0,util_all/* fetchData */.rQ)("public/getPanoramas", "POST", {
                                                            id: tour.id
                                                        }).then(function(data) {
                                                            var panoramas = data.panoramas;
                                                            var pano = (0,util_all/* getQueryVariable */.Dv)(window.location.href, "pano");
                                                            var pitch = parseInt(String((0,util_all/* getQueryVariable */.Dv)(window.location.href, "panoPitch"))) || 0;
                                                            var yaw = parseInt(String((0,util_all/* getQueryVariable */.Dv)(window.location.href, "panoYaw"))) || 0;
                                                            var hfov = parseInt(String((0,util_all/* getQueryVariable */.Dv)(window.location.href, "panoHfov"))) || 0;
                                                            // accumulate panoramas by user transitions through tours
                                                            _this24.setState(function(prevState) {
                                                                var ref;
                                                                var defaultPanoForTour = (panoramas || []).find(function(pano) {
                                                                    return pano.default;
                                                                });
                                                                if (!defaultPanoForTour) {
                                                                    defaultPanoForTour = (prevState.panoramas || []).find(function(pano) {
                                                                        return pano.default;
                                                                    });
                                                                }
                                                                var newPanoramas = (panoramas || []).reduce(function(acc, value) {
                                                                    if (acc.find(function(param) {
                                                                        var id = param.id;
                                                                        return id === value.id;
                                                                    }) === undefined) {
                                                                        acc.push(value);
                                                                    }
                                                                    return acc;
                                                                }, prevState.panoramas || []);
                                                                newPanoramas.forEach(function(pano) {
                                                                    pano.default = pano.id === (defaultPanoForTour === null || defaultPanoForTour === void 0 ? void 0 : defaultPanoForTour.id);
                                                                });
                                                                return (0,_object_spread/* default */.Z)({
                                                                    panoramas: newPanoramas,
                                                                    activePano: pano && parseInt(String(pano)) || (defaultPanoForTour === null || defaultPanoForTour === void 0 ? void 0 : defaultPanoForTour.id) || ((ref = newPanoramas[0]) === null || ref === void 0 ? void 0 : ref.id),
                                                                    panoPose: {
                                                                        pitch: pitch,
                                                                        yaw: yaw,
                                                                        hfov: hfov
                                                                    }
                                                                }, changePanorama ? {
                                                                    panoramaOn: !_this24.isGameTour() ? tour.panoramaStart || Boolean(pano) : false
                                                                } : {});
                                                            });
                                                            (panoramas || []).forEach(function(panorama) {
                                                                var _$data = ((panorama === null || panorama === void 0 ? void 0 : panorama.hotspots) || []).map(function(hotspot) {
                                                                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, hotspot), {
                                                                        tourId: panorama.tourId,
                                                                        panoramaUrl: panorama.url
                                                                    });
                                                                }).filter(function(hotspot) {
                                                                    return hotspot.type === "panorama" || hotspot.type === "music";
                                                                });
                                                                importAudioData(AudioModule/* MusicObjectKey.PANORAMAS */.NO.PANORAMAS, _$data);
                                                            });
                                                        }).catch(function(err) {
                                                            console.error(err.message);
                                                        });
                                                    }
                                                    // Sweeps page is locked for free users
                                                    if (!_this24.isFreeUser) {
                                                        TreedisPublicDAO/* default.getGroups */.Z.getGroups({
                                                            id: tour.id
                                                        }).then(function(groupsData) {
                                                            var ref;
                                                            if (groupsData === null || groupsData === void 0 ? void 0 : (ref = groupsData.groups) === null || ref === void 0 ? void 0 : ref.length) _this24.setState({
                                                                sweepGroups: groupsData === null || groupsData === void 0 ? void 0 : groupsData.groups
                                                            });
                                                            importAudioData(AudioModule/* MusicObjectKey.SWEEPGROUPS */.NO.SWEEPGROUPS, groupsData === null || groupsData === void 0 ? void 0 : groupsData.groups);
                                                        });
                                                    }
                                                    return [
                                                        2,
                                                        resolve(true)
                                                    ];
                                            }
                                        });
                                    }));
                                })
                            ];
                    }
                });
            });
            return function(tourData) {
                return _ref.apply(this, arguments);
            };
        }();
        _this.getProducts = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(tourId, userId) {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    return [
                        2,
                        []
                    ];
                });
            });
            return function(tourId, userId) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this25 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.setTourBackground = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(models, threeInstance) {
                var tour, background, url, texture;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            tour = _this25.state.tour;
                            background = null;
                            if (!((tour === null || tour === void 0 ? void 0 : tour.background) && utils/* color.isHex */.$_.isHex(tour.background))) return [
                                3,
                                1
                            ];
                            background = new threeInstance.Color(tour.background);
                            return [
                                3,
                                3
                            ];
                        case 1:
                            if (!(tour === null || tour === void 0 ? void 0 : tour.backgroundImage)) return [
                                3,
                                3
                            ];
                            url = "".concat("https://cdn.treedis.com", "/tours/").concat(tour.id, "/").concat(tour.backgroundImage);
                            return [
                                4,
                                new threeInstance.TextureLoader().load(url)
                            ];
                        case 2:
                            texture = _state.sent();
                            texture.wrapS = threeInstance.RepeatWrapping;
                            texture.wrapT = threeInstance.RepeatWrapping;
                            texture.repeat.set(1, 1);
                            background = texture;
                            _state.label = 3;
                        case 3:
                            if (background) {
                                models[0].parent.children[1].material = new threeInstance.ShadowMaterial();
                                models[0].parent.background = background;
                            }
                            return [
                                2
                            ];
                    }
                });
            });
            return function(models, threeInstance) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this26 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.initVRSettings = /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            var ref, ref1, ref2, ref3, models;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            _this26.showCaseTemp.showcase.Scene.query([
                                "model"
                            ])
                        ];
                    case 1:
                        models = _state.sent();
                        _this26.camera = models === null || models === void 0 ? void 0 : (ref = models[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.parent) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.children) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[0]) === null || ref3 === void 0 ? void 0 : ref3.camera;
                        return [
                            4,
                            _this26.showCaseTemp.scene.configureThreeInstance()
                        ];
                    case 2:
                        _state.sent();
                        return [
                            4,
                            (0,dist/* iTHREE */.Sc)()
                        ];
                    case 3:
                        _this26.THREE = _state.sent();
                        _this26.showCaseTemp.mpSDK.Scene.configure(function(renderer) {
                            var ref, ref1, ref2, ref3;
                            _this26.renderer = renderer;
                            _this26.rendererRef.current = renderer;
                            _this26.renderer.domElement = _this26.iframe.contentWindow.document.getElementsByClassName("webgl-canvas")[0];
                            (ref = _this26.renderer) === null || ref === void 0 ? void 0 : (ref1 = ref.xr) === null || ref1 === void 0 ? void 0 : ref1.addEventListener("sessionstart", function() {
                                var ref;
                                base/* asyncStore.vrIsOn */.k6.vrIsOn = true;
                                if (!_this26.SceneVRCameraController) _this26.SceneVRCameraController = new VRCameraController(_this26.THREE, _this26.renderer, _this26.camera, _this26.cameraPose);
                                if (_this26.matterTagMeshComponents.length) _this26.matterTagMeshComponents.forEach(function(tag) {
                                    tag.inputs.visible = true;
                                });
                                if ((ref = _this26.renderer) === null || ref === void 0 ? void 0 : ref.xr) {
                                    var controllers = [
                                        _this26.renderer.xr.getController(0),
                                        _this26.renderer.xr.getController(1)
                                    ];
                                    controllers.forEach(function(controller) {
                                        controller.addEventListener("connected", function(event) {
                                            var inputSource = event.data;
                                            var handedness = inputSource.handedness;
                                            if (handedness === "left") {
                                                _this26.gamepadLRef.current = event.data.gamepad;
                                            } else if (handedness === "right") {
                                                _this26.gamepadRRef.current = event.data.gamepad;
                                            }
                                        });
                                    });
                                }
                            });
                            (ref2 = _this26.renderer) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.xr) === null || ref3 === void 0 ? void 0 : ref3.addEventListener("sessionend", function() {
                                base/* asyncStore.vrIsOn */.k6.vrIsOn = false;
                                if (_this26.matterTagMeshComponents.length) _this26.matterTagMeshComponents.forEach(function(tag) {
                                    tag.inputs.visible = false;
                                });
                            });
                        });
                        _this26.setTourBackground(models, _this26.THREE);
                        return [
                            2
                        ];
                }
            });
        });
        _this.getShowcaseElement = function(element) {
            switch(element){
                case components_types/* ShowcaseElement.TagPanel */.o2.TagPanel:
                    {
                        var ref, ref1;
                        return (ref = _this.iframe) === null || ref === void 0 ? void 0 : (ref1 = ref.contentWindow) === null || ref1 === void 0 ? void 0 : ref1.document.body.getElementsByClassName("panels")[1];
                    }
                case components_types/* ShowcaseElement.TagPanelHeader */.o2.TagPanelHeader:
                    {
                        var ref2, ref3;
                        return (ref2 = _this.iframe) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.contentWindow) === null || ref3 === void 0 ? void 0 : ref3.document.querySelector(".tag-view-panel-header");
                    }
                case components_types/* ShowcaseElement.LoaderPowerBy */.o2.LoaderPowerBy:
                    {
                        var ref4, ref5;
                        return (ref4 = _this.iframe) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.contentWindow) === null || ref5 === void 0 ? void 0 : ref5.document.getElementById("loading-powered-by");
                    }
                case components_types/* ShowcaseElement.LoaderPresentedBy */.o2.LoaderPresentedBy:
                    {
                        var ref6, ref7;
                        return (ref6 = _this.iframe) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.contentWindow) === null || ref7 === void 0 ? void 0 : ref7.document.getElementById("loading-presented-by");
                    }
                case components_types/* ShowcaseElement.TagEmbedMedia */.o2.TagEmbedMedia:
                    {
                        var ref8, ref9;
                        return (ref8 = _this.iframe) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.contentWindow) === null || ref9 === void 0 ? void 0 : ref9.document.body.querySelector(".annotations-preview-layer");
                    }
                case components_types/* ShowcaseElement.ErrorContainer */.o2.ErrorContainer:
                    {
                        var ref10, ref11, ref12, ref13;
                        return (ref10 = _this.iframe) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.contentWindow) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.document) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.body) === null || ref13 === void 0 ? void 0 : ref13.querySelector("#error-container");
                    }
                case components_types/* ShowcaseElement.VRLayer */.o2.VRLayer:
                    {
                        var ref14, ref15, ref16;
                        return (ref14 = _this.iframe) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.contentWindow) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.document) === null || ref16 === void 0 ? void 0 : ref16.getElementById("vr-overlay-layer");
                    }
                default:
                    var ref17, ref18;
                    return (ref17 = _this.iframe) === null || ref17 === void 0 ? void 0 : (ref18 = ref17.contentWindow) === null || ref18 === void 0 ? void 0 : ref18.document.body;
            }
        };
        _this.hideLoadingScreenIfExists = function() {
            var tour = _this.state.tour;
            if (tour === null || tour === void 0 ? void 0 : tour.mpPasswordActive) {
                var ref, ref1;
                (ref = document === null || document === void 0 ? void 0 : document.getElementById("loading-screen")) === null || ref === void 0 ? void 0 : ref.setAttribute("style", "display: none");
                // Hiding Loading Spinner when there's a MP password screen because we have a loading screen
                (ref1 = document === null || document === void 0 ? void 0 : document.getElementById("loading-spinner")) === null || ref1 === void 0 ? void 0 : ref1.setAttribute("style", "display: none");
            }
        };
        var _this27 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.showcaseLoader = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(applicationKey) {
                var ref, ref1, ref2, ref3, mpLoader, mpPresenter, search, urlParams, newModelSID, tour, config, introScreenDomEl, auth, showcase, ref4, observerMPPassword, onShowcasePhaseLoading, starting, onShowcasePhaseStarting, onShowcasePhasePlaying, e;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                3,
                                ,
                                4
                            ]);
                            mpLoader = _this27.getShowcaseElement(components_types/* ShowcaseElement.LoaderPowerBy */.o2.LoaderPowerBy);
                            mpPresenter = _this27.getShowcaseElement(components_types/* ShowcaseElement.LoaderPresentedBy */.o2.LoaderPresentedBy);
                            if (mpLoader) mpLoader.style.display = "none";
                            if (mpPresenter) mpPresenter.style.display = "none";
                            search = _this27.getValueOnWindowLocationObject("search");
                            urlParams = new URLSearchParams(search);
                            newModelSID = urlParams.get("m");
                            if (newModelSID && newModelSID != (0,util_all/* getQueryVariable */.Dv)(_this27.state.iframeUrl, "m")) {
                                _this27.setState({
                                    iframeUrl: _this27.state.iframeUrl.replace(/(m=).*?(&)/, "$1".concat(newModelSID, "$2"))
                                });
                                console.log("iframeUrl", _this27.state.iframeUrl);
                                return [
                                    2
                                ];
                            }
                            tour = _this27.state.tour;
                            config = {
                                applicationKey: window.location.hostname === "my.treedis.com" ? "295ba0c0f04541318359a8e75af33043" : applicationKey || "295ba0c0f04541318359a8e75af33043",
                                appDomain: "https://api.treedis.com" || 0,
                                version: "24.11.2",
                                logoUrl: ((ref = _this27.state.whiteLabelData) === null || ref === void 0 ? void 0 : ref.active) ? (ref1 = _this27.state.whiteLabelData) === null || ref1 === void 0 ? void 0 : ref1.logo : defaultLogo,
                                appAws: "https://cdn.treedis.com",
                                matterId: tour.matterId,
                                rtl: (ref2 = tour.client) === null || ref2 === void 0 ? void 0 : ref2.rtl
                            };
                            introScreenDomEl = null;
                            if (tour === null || tour === void 0 ? void 0 : tour.mpPasswordActive) {
                                introScreenDomEl = document.querySelector("#intro-screen");
                                introScreenDomEl === null || introScreenDomEl === void 0 ? void 0 : introScreenDomEl.setAttribute("style", "display: none");
                            }
                            _this27.hideLoadingScreenIfExists();
                            auth = (0,util_all/* getQueryVariable */.Dv)(window.location.href, "auth");
                            if (((ref3 = tour.user) === null || ref3 === void 0 ? void 0 : ref3.oauth) && tour.oauthAccess) {
                                config.auth = tour.user.oauthToken;
                            } else if (auth) {
                                config.auth = auth;
                            }
                            return [
                                4,
                                (0,dist/* GetSDK */.xe)(_this27.iframe, config)
                            ];
                        case 1:
                            showcase = _state.sent();
                            // Showing again after MP password screen
                            if (tour === null || tour === void 0 ? void 0 : tour.mpPasswordActive) {
                                if (introScreenDomEl) {
                                    introScreenDomEl.setAttribute("style", "display: none");
                                } else {
                                    ;
                                    (ref4 = document === null || document === void 0 ? void 0 : document.getElementById("loading-screen")) === null || ref4 === void 0 ? void 0 : ref4.setAttribute("style", "display: block");
                                }
                            }
                            // to make the "copy position" work if focus is on the iframe
                            return [
                                4,
                                _this27.iframe.contentWindow.document.addEventListener("keydown", _this27.takePosition)
                            ];
                        case 2:
                            _state.sent();
                            observerMPPassword = (0,util/* setMPPasswordFormObserver */.v2)(_this27.getShowcaseElement(), function() {
                                _this27.iframe.style.zIndex = 999999;
                            }, /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                                return (0,tslib_es6.__generator)(this, function(_state) {
                                    _this27.setState({
                                        waitLoadingPolygons: true
                                    });
                                    _this27.iframe.style.zIndex = "inherit";
                                    return [
                                        2
                                    ];
                                });
                            }));
                            _this27.showcase = showcase.showcase;
                            _this27.showCaseTemp = showcase;
                            _this27.tagManager = new TagManager(_this27.showcase);
                            _this27.loadedShowcaseHandler();
                            onShowcasePhaseLoading = function() {
                                var _ref = (0,_async_to_generator/* default */.Z)(function() {
                                    return (0,tslib_es6.__generator)(this, function(_state) {
                                        _this27.loadingQueue.setLoadingQueueProgress(50);
                                        observerMPPassword && observerMPPassword.disconnect();
                                        return [
                                            2
                                        ];
                                    });
                                });
                                return function onShowcasePhaseLoading() {
                                    return _ref.apply(this, arguments);
                                };
                            }();
                            starting = false;
                            onShowcasePhaseStarting = function() {
                                var _ref = (0,_async_to_generator/* default */.Z)(function() {
                                    return (0,tslib_es6.__generator)(this, function(_state) {
                                        starting = true;
                                        _this27.initStarting();
                                        return [
                                            2
                                        ];
                                    });
                                });
                                return function onShowcasePhaseStarting() {
                                    return _ref.apply(this, arguments);
                                };
                            }();
                            onShowcasePhasePlaying = function() {
                                var _ref = (0,_async_to_generator/* default */.Z)(function() {
                                    var ref, ref1, ref2, ref3, watchErrorElem, watchTagPanelElem;
                                    return (0,tslib_es6.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                if (!!starting) return [
                                                    3,
                                                    2
                                                ];
                                                // Some tours don't have starting mode
                                                return [
                                                    4,
                                                    _this27.initStarting()
                                                ];
                                            case 1:
                                                _state.sent();
                                                _state.label = 2;
                                            case 2:
                                                _this27.loadingQueue.setLoadingQueueProgress(90);
                                                if (tour.hideMPTagDock) {
                                                    _this27.showcase.Tag.toggleDocking(false);
                                                }
                                                if (tour.hideMPTagSwitcher) {
                                                    _this27.showcase.Tag.toggleNavControls(false);
                                                }
                                                return [
                                                    4,
                                                    _this27.initSweep()
                                                ];
                                            case 3:
                                                _state.sent();
                                                return [
                                                    4,
                                                    _this27.initPlaying()
                                                ];
                                            case 4:
                                                _state.sent();
                                                _this27.initScene();
                                                if (!(!deviceManager/* default.isMobile */.Z.isMobile() && (((ref = _this27.state.tour) === null || ref === void 0 ? void 0 : (ref1 = ref.user) === null || ref1 === void 0 ? void 0 : ref1.enterprise) || ((ref2 = _this27.state.tour) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.user) === null || ref3 === void 0 ? void 0 : ref3.subscription) === (User/* UserSubscription.Business */.MX.Business || User/* UserSubscription.Enterprise */.MX.Enterprise)))) return [
                                                    3,
                                                    6
                                                ];
                                                return [
                                                    4,
                                                    _this27.initVRPointer()
                                                ];
                                            case 5:
                                                _state.sent();
                                                _this27.initPathFinderMesh();
                                                _state.label = 6;
                                            case 6:
                                                watchErrorElem = _this27.getShowcaseElement(components_types/* ShowcaseElement.ErrorContainer */.o2.ErrorContainer);
                                                (0,util/* setErrorObserver */.D2)(watchErrorElem, function(pageCrashed, observer) {
                                                    _this27.setState({
                                                        crashScreen: pageCrashed
                                                    });
                                                    observer.disconnect();
                                                });
                                                watchTagPanelElem = _this27.getShowcaseElement(components_types/* ShowcaseElement.TagPanel */.o2.TagPanel);
                                                if (_this27.state.tour.mpTagDockSide === (Tour/* TagDockSideType */.tP === null || Tour/* TagDockSideType */.tP === void 0 ? void 0 : Tour/* TagDockSideType.Left */.tP.Left)) {
                                                    watchTagPanelElem.style.transition = "none";
                                                }
                                                (0,util/* setTagPanelObserver */.p$)(watchTagPanelElem, function(isTagPanelOpen, observer) {
                                                    if (!deviceManager/* default.isMobile */.Z.isMobile() && _this27.state.tour.mpTagDockSide === (Tour/* TagDockSideType */.tP === null || Tour/* TagDockSideType */.tP === void 0 ? void 0 : Tour/* TagDockSideType.Left */.tP.Left)) {
                                                        var hasStyle = _this27.iframe.contentWindow.document.head.querySelector("#override-matterport");
                                                        if (isTagPanelOpen && !hasStyle) {
                                                            var style = document.createElement("style");
                                                            style.id = "override-matterport";
                                                            style.innerHTML = "\n                .webgl-canvas {\n                  left: 375px !important;\n                }\n                .panel-right {\n                  position: absolute !important;\n                }\n              ";
                                                            _this27.iframe.contentWindow.document.head.appendChild(style);
                                                            _this27.setState({
                                                                hideLogo: true
                                                            });
                                                        } else if (hasStyle) {
                                                            var style1 = _this27.iframe.contentWindow.document.head.querySelector("#override-matterport");
                                                            style1.innerHTML = "\n                .webgl-canvas {\n                  transition: left .5s !important;\n                  left: 0 !important;\n                }\n                .panel-right {\n                  position: absolute !important;\n                }\n              ";
                                                            _this27.setState({
                                                                hideLogo: false
                                                            });
                                                            setTimeout(function() {
                                                                style1.remove();
                                                            }, 500); // closing animation duration is .5s
                                                        }
                                                    }
                                                    var bottomBar = document.getElementById("bottom-bar");
                                                    var eBottomBar = document.getElementById("ecommerce-bottom-bar");
                                                    var volumeBtn = document.getElementById("volume-button");
                                                    if (bottomBar) {
                                                        bottomBar.style.display = isTagPanelOpen ? "none" : "block";
                                                    }
                                                    if (eBottomBar) {
                                                        eBottomBar.style.display = isTagPanelOpen ? "none" : "block";
                                                    }
                                                    if (volumeBtn) {
                                                        volumeBtn.style.display = isTagPanelOpen ? "none" : "block";
                                                    }
                                                });
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                });
                                return function onShowcasePhasePlaying() {
                                    return _ref.apply(this, arguments);
                                };
                            }();
                            _this27.showcaseAppSubscriber = _this27.showcase.App.state.subscribe(function(appState) {
                                switch(appState.phase){
                                    case showcase.showcase.App.Phase.LOADING:
                                        onShowcasePhaseLoading();
                                        break;
                                    case showcase.showcase.App.Phase.STARTING:
                                        onShowcasePhaseStarting();
                                        break;
                                    case showcase.showcase.App.Phase.PLAYING:
                                        onShowcasePhasePlaying();
                                        break;
                                    case showcase.showcase.App.Phase.UNINITIALIZED:
                                    case showcase.showcase.App.Phase.WAITING:
                                    case showcase.showcase.App.Phase.ERROR:
                                        break;
                                    default:
                                        break;
                                }
                            });
                            return [
                                3,
                                4
                            ];
                        case 3:
                            e = _state.sent();
                            console.error(e);
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(applicationKey) {
                return _ref.apply(this, arguments);
            };
        }();
        _this.unsubsribeShowcaseAppSubscriber = function() {
            var ref, ref1;
            (ref = _this.showcaseAppSubscriber) === null || ref === void 0 ? void 0 : (ref1 = ref.cancel) === null || ref1 === void 0 ? void 0 : ref1.call(ref);
        };
        _this.unsubsribeShowcaseSubscribers = function() {
            var ref;
            (ref = _this.showcaseSubscribers) === null || ref === void 0 ? void 0 : ref.forEach(function(off) {
                return off === null || off === void 0 ? void 0 : off();
            });
            _this.showcaseSubscribers.length = 0;
        };
        _this.filterSweepGroupVsElementsByTourVsElement = function(vsElements, vsElement) {
            var ref;
            if ((0,_instanceof/* default */.Z)(vsElement, VSObject/* TourImage */.oP)) {
                var ref1;
                var vsImageIds = vsElements.filter(function(item) {
                    return item.type === "vsImage";
                }).map(function(param) {
                    var elementId = param.elementId;
                    return elementId;
                });
                if (!vsImageIds.length) return true;
                return !!vsImageIds.includes(vsElement === null || vsElement === void 0 ? void 0 : (ref1 = vsElement.details) === null || ref1 === void 0 ? void 0 : ref1.id);
            }
            if ((0,_instanceof/* default */.Z)(vsElement, VSObject/* TourVideo */.Up)) {
                var ref2;
                var vsVideoIds = vsElements.filter(function(item) {
                    return item.type === "vsVideo";
                }).map(function(param) {
                    var elementId = param.elementId;
                    return elementId;
                });
                if (!vsVideoIds.length) return true;
                return !!vsVideoIds.includes(vsElement === null || vsElement === void 0 ? void 0 : (ref2 = vsElement.details) === null || ref2 === void 0 ? void 0 : ref2.id);
            }
            var vsObjectsIds = vsElements.filter(function(item) {
                return item.type === "vsObject";
            }).map(function(param) {
                var elementId = param.elementId;
                return elementId;
            });
            if (!vsObjectsIds.length) return true;
            return !!vsObjectsIds.includes(vsElement === null || vsElement === void 0 ? void 0 : (ref = vsElement.details) === null || ref === void 0 ? void 0 : ref.id);
        };
        _this.isGameTour = function() {
            var _state = _this.state, _$tourType = _state.tourType, tour = _state.tour, flows = _state.flows;
            return _$tourType === Tour/* TourType.Game */.v.Game && !!(tour === null || tour === void 0 ? void 0 : tour.gameId) && !(flows === null || flows === void 0 ? void 0 : flows.length);
        };
        _this.isSweepGroupVsVisible = function(vsElement, sweepGroupElementIdsToHide) {
            var ref;
            var _state = _this.state, activeSweepGroup = _state.activeSweepGroup, sweepGroups = _state.sweepGroups;
            if (sweepGroupElementIdsToHide.includes(vsElement === null || vsElement === void 0 ? void 0 : (ref = vsElement.details) === null || ref === void 0 ? void 0 : ref.id)) return false;
            var response = (sweepGroups || []).find(function(item) {
                return item.id === activeSweepGroup;
            });
            return _this.filterSweepGroupVsElementsByTourVsElement((response === null || response === void 0 ? void 0 : response.vsElements) || [], vsElement);
        };
        _this.hasSweepGroupElements = function() {
            var sweepGroups = _this.state.sweepGroups;
            var elementIds = sweepGroups.reduce(function(acc, param) {
                var _vsElements = param.vsElements, vsElements = _vsElements === void 0 ? [] : _vsElements;
                return acc.concat(vsElements);
            }, []).map(function(item) {
                return item === null || item === void 0 ? void 0 : item.elementId;
            });
            return elementIds.length > 0;
        };
        _this.sortVsItemsByType = function(vsItems) {
            var images = [];
            var videos = [];
            var objects = [];
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                // eslint-disable-next-line no-restricted-syntax
                for(var _iterator = vsItems[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var item = _step.value;
                    if ((item === null || item === void 0 ? void 0 : item.type) === "vsVideo") {
                        videos.push(item === null || item === void 0 ? void 0 : item.elementId);
                    }
                    if ((item === null || item === void 0 ? void 0 : item.type) === "vsImage") {
                        images.push(item === null || item === void 0 ? void 0 : item.elementId);
                    }
                    if ((item === null || item === void 0 ? void 0 : item.type) === "vsObject") {
                        objects.push(item === null || item === void 0 ? void 0 : item.elementId);
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return [
                images,
                videos,
                objects
            ];
        };
        _this.getSweepGroupElementIdsToHide = function() {
            var _state = _this.state, sweepGroups = _state.sweepGroups, activeSweepGroup = _state.activeSweepGroup;
            if (!activeSweepGroup) return [];
            var activeSweepGroupObj = sweepGroups.filter(function(item) {
                return (item === null || item === void 0 ? void 0 : item.id) === activeSweepGroup;
            })[0];
            var activeSweepGroupVsElements = activeSweepGroupObj === null || activeSweepGroupObj === void 0 ? void 0 : activeSweepGroupObj.vsElements;
            var hideVSImages = activeSweepGroupObj.hideVSImages, hideVSVideos = activeSweepGroupObj.hideVSVideos, hideVSObjects = activeSweepGroupObj.hideVSObjects;
            var ref = (0,_sliced_to_array/* default */.Z)(_this.sortVsItemsByType(activeSweepGroupVsElements), 3), tmp = ref[0], imageIds = tmp === void 0 ? [] : tmp, tmp1 = ref[1], videoIds = tmp1 === void 0 ? [] : tmp1, tmp2 = ref[2], objectIds = tmp2 === void 0 ? [] : tmp2;
            if (!imageIds.length && !videoIds.length && !objectIds.length && !hideVSImages && !hideVSVideos && !hideVSObjects) {
                return [];
            }
            return _this.vsObjects.map(function(item) {
                if ((0,_instanceof/* default */.Z)(item, VSObject/* TourVideo */.Up) && (hideVSVideos || !videoIds.includes(item.vsVideoId) && videoIds.length)) {
                    return item.vsVideoId;
                }
                if ((0,_instanceof/* default */.Z)(item, VSObject/* TourImage */.oP) && (hideVSImages || !imageIds.includes(item.vsImageId) && imageIds.length)) {
                    return item.vsImageId;
                }
                if ((0,_instanceof/* default */.Z)(item, VSObject/* TourObject */.zB) && (hideVSObjects || !objectIds.includes(item.vsObjectId) && objectIds.length)) {
                    return item.vsObjectId;
                }
            }).filter(function(item) {
                return !!item;
            });
        };
        // 0 - current item, 1 forward, -1 backward, 2 not found
        _this.pathHasElement = function(id, type) {
            var ref, ref1, ref2;
            var paths = (((ref = _this.state) === null || ref === void 0 ? void 0 : ref.game) || {}).paths;
            var currentPathItem = base/* asyncStore */.k6 === null || base/* asyncStore */.k6 === void 0 ? void 0 : base/* asyncStore.currentPathStep */.k6.currentPathStep;
            if (!(base/* asyncStore */.k6 === null || base/* asyncStore */.k6 === void 0 ? void 0 : base/* asyncStore.regularActivePath */.k6.regularActivePath) && !paths) return;
            var activePathLock = paths[base/* asyncStore */.k6 === null || base/* asyncStore */.k6 === void 0 ? void 0 : base/* asyncStore.regularActivePath */.k6.regularActivePath];
            var searchingPathItem = activePathLock === null || activePathLock === void 0 ? void 0 : (ref1 = activePathLock.paths) === null || ref1 === void 0 ? void 0 : ref1.find(function(e) {
                return e.locationType === type && e.locationItem === id;
            });
            if (!currentPathItem || currentPathItem.locationItem === id && currentPathItem.locationType === type) {
                return [
                    0,
                    searchingPathItem
                ];
            }
            var pathItemsArray = [];
            var nextItem = activePathLock === null || activePathLock === void 0 ? void 0 : activePathLock.paths.find(function(e) {
                return !e.triggerType || e.triggerType === -1 || e.triggerType === "-1";
            });
            var cyclesLeft = (activePathLock === null || activePathLock === void 0 ? void 0 : (ref2 = activePathLock.paths) === null || ref2 === void 0 ? void 0 : ref2.length) || 0;
            while(nextItem && !!cyclesLeft){
                pathItemsArray.push(nextItem);
                nextItem = activePathLock === null || activePathLock === void 0 ? void 0 : activePathLock.paths.find(function(e) {
                    return e.triggerType === (nextItem === null || nextItem === void 0 ? void 0 : nextItem.locationType) && e.triggerItem === (nextItem === null || nextItem === void 0 ? void 0 : nextItem.locationItem);
                });
                cyclesLeft--;
            }
            var pathItemsArrayIds = pathItemsArray.map(function(e) {
                return "".concat(e.locationItem).concat(e.locationType);
            });
            var currentItemIndex = pathItemsArrayIds.indexOf("".concat(currentPathItem.locationItem).concat(currentPathItem.locationType));
            var itemsAfter = pathItemsArrayIds.splice(currentItemIndex + 1, pathItemsArrayIds.length - currentItemIndex);
            var itemsBefore = pathItemsArrayIds.splice(0, currentItemIndex);
            if (itemsBefore.includes("".concat(id).concat(type))) {
                return [
                    -1,
                    searchingPathItem
                ];
            }
            if (itemsAfter.includes("".concat(id).concat(type))) {
                return [
                    1,
                    searchingPathItem
                ];
            }
            return [
                2,
                searchingPathItem
            ];
        };
        _this.vsObjectHiddenByPathLock = function(vsObject) {
            var ref, ref1;
            var paths = (((ref = _this.state) === null || ref === void 0 ? void 0 : ref.game) || {}).paths;
            if (!(base/* asyncStore */.k6 === null || base/* asyncStore */.k6 === void 0 ? void 0 : base/* asyncStore.regularActivePath */.k6.regularActivePath) && !paths) return;
            var activePathLock = paths[base/* asyncStore */.k6 === null || base/* asyncStore */.k6 === void 0 ? void 0 : base/* asyncStore.regularActivePath */.k6.regularActivePath];
            var sId = (ref1 = vsObject.id) === null || ref1 === void 0 ? void 0 : ref1.toString();
            var type = (0,_instanceof/* default */.Z)(vsObject, VSObject/* TourObject */.zB) ? "vsObject" : (0,_instanceof/* default */.Z)(vsObject, VSObject/* TourVideo */.Up) ? "vsVideo" : (0,_instanceof/* default */.Z)(vsObject, VSObject/* TourImage */.oP) ? "vsImage" : null;
            var ref2 = (0,_sliced_to_array/* default */.Z)(_this.pathHasElement(sId, type), 2), elementPosition = ref2[0], pathElement = ref2[1];
            if ((activePathLock === null || activePathLock === void 0 ? void 0 : activePathLock.hideItems) && elementPosition === 1 || (pathElement === null || pathElement === void 0 ? void 0 : pathElement.hideStep) && elementPosition === -1) {
                return true;
            }
            return false;
        };
        _this.polygonHiddenByPathLock = function(polygon) {
            var ref, ref1, ref2;
            var paths = (((ref = _this.state) === null || ref === void 0 ? void 0 : ref.game) || {}).paths;
            var pathItemsMap = {}; // id: {type, hideStep}
            if (!(base/* asyncStore */.k6 === null || base/* asyncStore */.k6 === void 0 ? void 0 : base/* asyncStore.regularActivePath */.k6.regularActivePath) && !paths) return;
            var activePathLock = paths[base/* asyncStore */.k6 === null || base/* asyncStore */.k6 === void 0 ? void 0 : base/* asyncStore.regularActivePath */.k6.regularActivePath];
            activePathLock === null || activePathLock === void 0 ? void 0 : (ref1 = activePathLock.paths) === null || ref1 === void 0 ? void 0 : ref1.forEach(function(l) {
                pathItemsMap[l.locationItem] = {
                    type: l.locationType,
                    hideStep: l.hideStep
                };
            });
            var sId = (ref2 = polygon.id) === null || ref2 === void 0 ? void 0 : ref2.toString();
            if (pathItemsMap[sId] && pathItemsMap[sId].type === "polygon" && (pathItemsMap[sId].hideStep === true || (activePathLock === null || activePathLock === void 0 ? void 0 : activePathLock.hideItems))) {
                return true;
            }
            return false;
        };
        _this.addVisibleObjectToFlows = function(vsObject) {
            if ((0,_instanceof/* default */.Z)(vsObject, VSObject/* TourObject */.zB)) {
                _this.setState(function(prev) {
                    return {
                        flowsVisibleAssets: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev.flowsVisibleAssets), {
                            objects: (0,_to_consumable_array/* default */.Z)(prev.flowsVisibleAssets.objects).concat([
                                vsObject
                            ])
                        })
                    };
                });
            }
            if ((0,_instanceof/* default */.Z)(vsObject, VSObject/* TourVideo */.Up)) {
                _this.setState(function(prev) {
                    return {
                        flowsVisibleAssets: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev.flowsVisibleAssets), {
                            videos: (0,_to_consumable_array/* default */.Z)(prev.flowsVisibleAssets.videos).concat([
                                vsObject
                            ])
                        })
                    };
                });
            }
        };
        var _this28 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.subscribeToStartTriggerVSAfterAnimation = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(vsObject) {
                var ref, ref1, flows, activateSubscriber, activateSubscriber1;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    flows = _this28.state.flows;
                    if (flows === null || flows === void 0 ? void 0 : flows.length) {
                        _this28.addVisibleObjectToFlows(vsObject);
                    }
                    if ((ref = vsObject.node) === null || ref === void 0 ? void 0 : ref.mixer) {
                        activateSubscriber = (vsObject === null || vsObject === void 0 ? void 0 : vsObject.active) && (vsObject === null || vsObject === void 0 ? void 0 : vsObject.animated) && !(vsObject === null || vsObject === void 0 ? void 0 : vsObject.loop);
                        if (!activateSubscriber) return [
                            2
                        ];
                        vsObject.node.mixer.addEventListener("finished", /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                            var flowIsActive;
                            return (0,tslib_es6.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        flowIsActive = _this28.state.flowIsActive;
                                        if (!!flowIsActive) return [
                                            3,
                                            2
                                        ];
                                        return [
                                            4,
                                            _this28.renderVSAfterAnimation(vsObject)
                                        ];
                                    case 1:
                                        _state.sent();
                                        _state.label = 2;
                                    case 2:
                                        if (!(vsObject.node.inputs.hideOnAnimationFinished && !flowIsActive)) return [
                                            3,
                                            4
                                        ];
                                        return [
                                            4,
                                            _this28.setVSVisible(vsObject, false)
                                        ];
                                    case 3:
                                        _state.sent();
                                        vsObject.videoPlayedOnce = true;
                                        _state.label = 4;
                                    case 4:
                                        return [
                                            2
                                        ];
                                }
                            });
                        }));
                    } else if ((ref1 = vsObject.node) === null || ref1 === void 0 ? void 0 : ref1.video) {
                        activateSubscriber1 = (vsObject === null || vsObject === void 0 ? void 0 : vsObject.active) && !(vsObject === null || vsObject === void 0 ? void 0 : vsObject.loop);
                        if (!activateSubscriber1) return [
                            2
                        ];
                        vsObject.node.video.addEventListener("ended", /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                            var flowIsActive;
                            return (0,tslib_es6.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        flowIsActive = _this28.state.flowIsActive;
                                        if (!!flowIsActive) return [
                                            3,
                                            2
                                        ];
                                        return [
                                            4,
                                            _this28.renderVSAfterAnimation(vsObject)
                                        ];
                                    case 1:
                                        _state.sent();
                                        _state.label = 2;
                                    case 2:
                                        if (!(vsObject.node.inputs.hideOnAnimationFinished && !flowIsActive)) return [
                                            3,
                                            4
                                        ];
                                        return [
                                            4,
                                            _this28.setVSVisible(vsObject, false)
                                        ];
                                    case 3:
                                        _state.sent();
                                        vsObject.videoPlayedOnce = true;
                                        _state.label = 4;
                                    case 4:
                                        return [
                                            2
                                        ];
                                }
                            });
                        }));
                    }
                    return [
                        2
                    ];
                });
            });
            return function(vsObject) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this29 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.renderVSAfterAnimation = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(animatedVSObject) {
                var filteredVsObjects;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    filteredVsObjects = _this29.vsObjects;
                    filteredVsObjects.forEach(function(vsObject) {
                        if ((0,_instanceof/* default */.Z)(vsObject, VSObject/* TourImage */.oP)) {
                            var afterAnimationId = null;
                            if ((0,_instanceof/* default */.Z)(animatedVSObject, VSObject/* TourObject */.zB)) {
                                afterAnimationId = vsObject.toursVSObjectIdAfterAnimation;
                            } else if ((0,_instanceof/* default */.Z)(animatedVSObject, VSObject/* TourVideo */.Up)) {
                                afterAnimationId = vsObject.toursVSVideoIdAfterAnimation;
                            }
                            if (afterAnimationId === animatedVSObject.id) {
                                _this29.setVSVisible(vsObject, true);
                            }
                        }
                    });
                    return [
                        2
                    ];
                });
            });
            return function(animatedVSObject) {
                return _ref.apply(this, arguments);
            };
        }();
        // Add this method to clean up resources when unloading the iframe
        _this.cleanupIframeResources = function() {
            if (!_this.state.isChangeIframe) return; //clear iframe only when it is changed
            // Stop any audio playing from the iframe
            if (_this.iframe && _this.iframe.contentWindow) {
                try {
                    // Remove event listeners
                    _this.iframe.contentWindow.document.removeEventListener("keydown", _this.takePosition);
                    // Clean up any WebGL contexts
                    var canvases = _this.iframe.contentWindow.document.querySelectorAll("canvas");
                    canvases.forEach(function(canvas) {
                        var gl = canvas.getContext("webgl") || canvas.getContext("webgl2");
                        if (gl) {
                            var ref;
                            (ref = gl.getExtension("WEBGL_lose_context")) === null || ref === void 0 ? void 0 : ref.loseContext();
                        }
                    });
                } catch (e) {
                    console.warn("Error cleaning up iframe resources:", e);
                }
            }
            // Clean up Matterport SDK resources
            if (_this.showCaseTemp && _this.showCaseTemp.showcase) {
                try {
                    _this.showCaseTemp.showcase.disconnect();
                } catch (e1) {
                    console.warn("Error disconnecting showcase:", e1);
                }
            }
            // Reset important state variables
            _this.showCaseTemp = null;
            _this.showcase = null;
            _this.vsObjects = [];
            // Force garbage collection if possible
            if (window.gc) {
                try {
                    window.gc();
                } catch (e2) {
                    console.warn("Unable to force garbage collection:", e2);
                }
            }
        };
        var _this30 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.renderVS = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(currentSweep) {
                var ref, ref1, ref2, ref3, ref4, ref5, ref6, _state, isVSVisible, tour, flowIsActive, blockRender, THREE, pose, sweepGroupElementIdsToHide, filteredVsObjects, ref7, vsImagesToHide, vsItemsToHide, vsVideosToHide, vsHTMLsToHide;
                return (0,tslib_es6.__generator)(this, function(_state1) {
                    _state = _this30.state, isVSVisible = _state.isVSVisible, tour = _state.tour, flowIsActive = _state.flowIsActive;
                    blockRender = _this30.state.tourMode === _this30.showCaseTemp.showcase.Mode.Mode.OUTSIDE || currentSweep.mode === _this30.showCaseTemp.showcase.Mode.Mode.OUTSIDE || currentSweep.mode === _this30.showCaseTemp.showcase.Mode.Mode.TRANSITIONING || _this30.state.tourMode === _this30.showCaseTemp.showcase.Mode.Mode.TRANSITIONING;
                    if (!currentSweep || blockRender) {
                        return [
                            2
                        ];
                    }
                    if (!isVSVisible) {
                        return [
                            2
                        ];
                    }
                    if (flowIsActive) {
                        return [
                            2
                        ];
                    }
                    THREE = _this30.THREE;
                    if (!THREE) return [
                        2
                    ];
                    pose = new THREE.Vector3(currentSweep === null || currentSweep === void 0 ? void 0 : (ref = currentSweep.position) === null || ref === void 0 ? void 0 : ref.x, currentSweep === null || currentSweep === void 0 ? void 0 : (ref1 = currentSweep.position) === null || ref1 === void 0 ? void 0 : ref1.y, currentSweep === null || currentSweep === void 0 ? void 0 : (ref2 = currentSweep.position) === null || ref2 === void 0 ? void 0 : ref2.z);
                    sweepGroupElementIdsToHide = _this30.getSweepGroupElementIdsToHide();
                    filteredVsObjects = _this30.vsObjects; //this.vsObjects;
                    if (_this30.isGameTour()) {
                        ref7 = _this30.filterVsElementsByGameCondition(), vsImagesToHide = ref7.vsImagesToHide, vsItemsToHide = ref7.vsItemsToHide, vsVideosToHide = ref7.vsVideosToHide, vsHTMLsToHide = ref7.vsHTMLsToHide;
                        filteredVsObjects = _this30.vsObjects.filter(function(item) {
                            return (0,_instanceof/* default */.Z)(item, VSObject/* TourImage */.oP) && !vsImagesToHide.includes(item.id) || (0,_instanceof/* default */.Z)(item, VSObject/* TourObject */.zB) && !vsItemsToHide.includes(item.id) || (0,_instanceof/* default */.Z)(item, VSObject/* TourVideo */.Up) && !vsVideosToHide.includes(item.id) || (0,_instanceof/* default */.Z)(item, VSObject/* TourVSHtml */.q8) && !vsHTMLsToHide.includes(item.id);
                        });
                    }
                    (ref3 = _this30.pathFinderMeshComponent) === null || ref3 === void 0 ? void 0 : ref3.setVisible(false);
                    (ref4 = _this30.menuMeshComponent) === null || ref4 === void 0 ? void 0 : ref4.setVisible(false);
                    (ref5 = _this30.flowsMenuMeshComponent) === null || ref5 === void 0 ? void 0 : ref5.setVisible(false);
                    (ref6 = _this30.flowsBarMeshComponent) === null || ref6 === void 0 ? void 0 : ref6.setVisible(false);
                    // if its a game we load everything regardless of radius or sensor.=
                    filteredVsObjects.forEach(function(vsObject) {
                        var ref;
                        if (_this30.vsObjectHiddenByPathLock(vsObject)) return;
                        if (vsObject.hiddenFromFlows) return;
                        var assetPose = new THREE.Vector3(vsObject.positionX, vsObject.positionY, vsObject.positionZ);
                        // Multiply by 0.2 because 1 three.js unit is approximately 20cm
                        var distance = pose.distanceTo(assetPose) * 0.2;
                        var inRange = distance <= ((vsObject === null || vsObject === void 0 ? void 0 : vsObject.renderRange) || ((ref = _this30.state.tour) === null || ref === void 0 ? void 0 : ref.vsRenderRange) || DEFAULT_VS_SENSOR_RADIUS);
                        var startAnimationDistance = (vsObject === null || vsObject === void 0 ? void 0 : vsObject.startAnimationDistance) || tour.vsAnimationDistance;
                        var isVisibleVsItems = _this30.isSweepGroupVsVisible(vsObject, sweepGroupElementIdsToHide);
                        if ((vsObject === null || vsObject === void 0 ? void 0 : vsObject.toursVSObjectIdAfterAnimation) || (vsObject === null || vsObject === void 0 ? void 0 : vsObject.toursVSVideoIdAfterAnimation)) {
                            // skip it here, renderVSAfterAnimation will render it when time comes...
                            return;
                        }
                        if (inRange && isVisibleVsItems) {
                            _this30.loadingQueue.enqueue(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                                var ref, ref1, err;
                                return (0,tslib_es6.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            _state.trys.push([
                                                0,
                                                2,
                                                ,
                                                3
                                            ]);
                                            return [
                                                4,
                                                _this30.setVSVisible(vsObject, true)
                                            ];
                                        case 1:
                                            _state.sent();
                                            if ((vsObject === null || vsObject === void 0 ? void 0 : vsObject.node) && (0,_instanceof/* default */.Z)(vsObject, VSObject/* TourVideo */.Up) && vsObject.node.video) {
                                                if (distance <= startAnimationDistance && vsObject.node.video.autoplay) {
                                                    if ((vsObject.node.video.paused || !vsObject.node.isLoaded) && !_this30.state.startScreenOn) {
                                                        if (!_this30.isGeorgiaPacificTour) vsObject.node.play();
                                                    }
                                                } else if (distance > startAnimationDistance && vsObject.node.isLoaded && !vsObject.node.video.paused) {
                                                    ;
                                                    (ref1 = vsObject.node) === null || ref1 === void 0 ? void 0 : ref1.pause();
                                                }
                                            } else if ((vsObject === null || vsObject === void 0 ? void 0 : vsObject.node) && (((ref = vsObject.details) === null || ref === void 0 ? void 0 : ref.isGLTF) || (0,_instanceof/* default */.Z)(vsObject, VSObject/* TourImage */.oP))) {
                                                vsObject.node.animate = distance <= startAnimationDistance;
                                            }
                                            _this30.loadingQueue.dequeue();
                                            return [
                                                3,
                                                3
                                            ];
                                        case 2:
                                            err = _state.sent();
                                            console.error(err);
                                            _this30.loadingQueue.dequeue();
                                            return [
                                                3,
                                                3
                                            ];
                                        case 3:
                                            return [
                                                2
                                            ];
                                    }
                                });
                            }));
                        } else if (vsObject.node) {
                            _this30.setVSVisible(vsObject, false);
                        }
                    });
                    return [
                        2
                    ];
                });
            });
            return function(currentSweep) {
                return _ref.apply(this, arguments);
            };
        }();
        _this.handleShowNearestProduct = function(state) {
            _this.setState({
                isShowNearestProducts: state,
                nearestProducts: []
            });
        };
        _this.fixMatterportTagScrollBug = function() {
            // Matterport text tags don't scroll until the end on iOS Chrome
            setTimeout(function() {
                if (deviceManager/* default.isMobile */.Z.isMobile() && deviceManager/* default.isIOS */.Z.isIOS() && deviceManager/* default.isChrome */.Z.isChrome()) {
                    var tagPanel = _this.getShowcaseElement(components_types/* ShowcaseElement.TagPanelHeader */.o2.TagPanelHeader);
                    tagPanel === null || tagPanel === void 0 ? void 0 : tagPanel.style.setProperty("padding-bottom", "120px");
                }
            }, 500);
        };
        var _this31 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.setTagAllowAction = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(tag) {
                var ref;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!tag) return [
                                2
                            ];
                            return [
                                4,
                                _this31.showcase.Tag.allowAction(tag.sid, {
                                    // allow opening: true/false
                                    opening: !tag.tourId || tag.tooltip && !((ref = tag.iotDevices) === null || ref === void 0 ? void 0 : ref.length) && !tag.treedisStyle && tag.hoverTooltip,
                                    navigating: tag.mpNavigation && tag.type !== Tag/* TagType.Treedis */.Qy.Treedis && tag.type !== Tag/* TagType.Matterport */.Qy.Matterport && tag.type !== Tag/* TagType.MatterportInstant */.Qy.MatterportInstant,
                                    docking: !_this31.state.tour.hideMPTagDock && !tag.treedisStyle
                                }).catch(console.error)
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            });
            return function(tag) {
                return _ref.apply(this, arguments);
            };
        }();
        _this.handleTagHoverEvent = function(tagId, isHovered) {
            try {
                var ref, ref1;
                var _state = _this.state, isClickedTag = _state.isClickedTag, iot = _state.iot;
                var tags = Array.from(_this.state.allTags.values());
                var tag = tags.find(function(t) {
                    return t.sid === tagId || t.defaultSid === tagId;
                });
                if (((ref = tag.media) === null || ref === void 0 ? void 0 : ref.type) === "video" || tag.type === "video" || tag.mediaType === "video") {
                    if (!isHovered) {
                        var ref2;
                        var vsVideos = (ref2 = _this.vsObjects) === null || ref2 === void 0 ? void 0 : ref2.filter(function(obj) {
                            var ref;
                            return ((ref = obj.node) === null || ref === void 0 ? void 0 : ref.componentType) === VideoRenderer_component/* videoRendererType */.Im;
                        });
                        vsVideos === null || vsVideos === void 0 ? void 0 : vsVideos.forEach(function(obj) {
                            var _node = obj.node, vsVideo = _node.video, muteBtn = _node.muteBtn;
                            if (muteBtn && !muteBtn.active) {
                                vsVideo.muted = true;
                                muteBtn.active = true;
                                muteBtn.makeBtn(muteBtn.inputs.src);
                            }
                        });
                        BaseTour_audioHandler.pauseAllMusic();
                    } else {
                        if (!isClickedTag) {
                            var ref3;
                            if (((ref3 = _this.state.openedTag) === null || ref3 === void 0 ? void 0 : ref3.type) !== Tag/* TagType.Popup */.Qy.Popup) {
                                BaseTour_audioHandler.resumeMusic();
                            }
                        }
                        _this.setState({
                            isClickedTag: false
                        });
                    }
                }
                if ((ref1 = tag.iotDevices) === null || ref1 === void 0 ? void 0 : ref1.length) {
                    var ref4, ref5, ref6;
                    var devicesBelongingToTag = iot === null || iot === void 0 ? void 0 : (ref4 = iot.devices) === null || ref4 === void 0 ? void 0 : ref4.filter(function(device) {
                        var ref;
                        return device === null || device === void 0 ? void 0 : (ref = device.relatedAssets) === null || ref === void 0 ? void 0 : ref.find(// eslint-disable-next-line eqeqeq
                        function(asset) {
                            return asset.id == tag.sid || asset.id == tag.defaultSid;
                        });
                    });
                    var doors = iot === null || iot === void 0 ? void 0 : (ref5 = iot.devices) === null || ref5 === void 0 ? void 0 : ref5.filter(function(device) {
                        var ref, ref1, ref2;
                        return device.providerId === ((ref1 = (ref = iot.providers) === null || ref === void 0 ? void 0 : ref.find(function(provider) {
                            var ref;
                            return (provider === null || provider === void 0 ? void 0 : (ref = provider.provider) === null || ref === void 0 ? void 0 : ref.name) === dist/* EIoTProviders.Kisi */.hJ.Kisi;
                        })) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.provider) === null || ref2 === void 0 ? void 0 : ref2.id);
                    });
                    // Find doors related to devices belonging to the tag
                    var doorsRelatedToTag = doors === null || doors === void 0 ? void 0 : doors.filter(function(door) {
                        return devicesBelongingToTag === null || devicesBelongingToTag === void 0 ? void 0 : devicesBelongingToTag.some(function(device) {
                            var // eslint-disable-next-line eqeqeq
                            ref;
                            return (ref = device.relatedAssets) === null || ref === void 0 ? void 0 : ref.some(function(asset) {
                                return asset.id == door.id;
                            });
                        });
                    });
                    var tagWithIot = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, tag), {
                        iotDevices: (0,_to_consumable_array/* default */.Z)(devicesBelongingToTag || []).concat((0,_to_consumable_array/* default */.Z)(doorsRelatedToTag || [])) || (tag === null || tag === void 0 ? void 0 : tag.iotDevices)
                    });
                    _this.setState({
                        isTagHovered: isHovered,
                        tagHovered: isHovered ? tagWithIot : null,
                        lastTagHovered: tagWithIot,
                        selectedTag: isHovered && (tag === null || tag === void 0 ? void 0 : tag.id) !== ((ref6 = _this.state.selectedTag) === null || ref6 === void 0 ? void 0 : ref6.id) ? null : _this.state.selectedTag
                    });
                } else {
                    var ref7;
                    _this.setState({
                        isTagHovered: isHovered,
                        tagHovered: isHovered ? tag : null,
                        lastTagHovered: tag,
                        selectedTag: isHovered && (tag === null || tag === void 0 ? void 0 : tag.id) !== ((ref7 = _this.state.selectedTag) === null || ref7 === void 0 ? void 0 : ref7.id) ? null : _this.state.selectedTag
                    });
                }
                if (!tag) return;
                _this.setTagAllowAction(tag);
                _this.emitTagChangesFromHost(tag, "hover");
            } catch (err) {
                console.error(err.message);
            }
        };
        _this.resetTagHoverAndPopupView = function() {
            _this.setState({
                lastTagClicked: null,
                tagPopupOpen: false,
                selectedTag: false,
                isTagHovered: false
            });
        };
        var _this32 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.handleTagClickEvent = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(tagId) {
                var ref, ref1, ref2, ref3, ref4, ref5, _state, iot, lastTagClicked, tags, tag, safeTag, ref6, ref7, devicesBelongingToTag, doors, doorsRelatedToTag, ref8, ref9, ref10, camera, ref11, ref12, ref13, hasPath, watchTagPanelElem;
                return (0,tslib_es6.__generator)(this, function(_state1) {
                    switch(_state1.label){
                        case 0:
                            _state = _this32.state, iot = _state.iot, lastTagClicked = _state.lastTagClicked;
                            if (lastTagClicked === tagId) {
                                _this32.resetTagHoverAndPopupView();
                                return [
                                    2
                                ];
                            }
                            _this32.setState({
                                isClickedTag: true,
                                lastTagClicked: tagId
                            });
                            tags = Array.from(_this32.state.allTags.values());
                            tag = tags.find(function(t) {
                                return t.sid === tagId || t.defaultSid === tagId;
                            });
                            if (!tag) return [
                                2
                            ];
                            if (window.parent) {
                                try {
                                    safeTag = {
                                        sid: tag.sid,
                                        defaultSid: tag.defaultSid,
                                        id: tag.id,
                                        title: tag.title,
                                        url: tag.url,
                                        type: tag.type,
                                        description: tag.description,
                                        position: {
                                            x: tag.positionX,
                                            y: tag.positionY,
                                            z: tag.positionZ
                                        }
                                    };
                                    // Use window.parent to ensure we're targeting the correct window
                                    window.parent.postMessage({
                                        type: "tagClicked",
                                        tag: safeTag
                                    }, "*");
                                } catch (err) {
                                    console.error("Error sending tagClicked message:", err);
                                }
                            }
                            _this32.setTagAllowAction(tag);
                            if (tag.type === Tag/* TagType.None */.Qy.None) {
                                // Opening the tag Billboard on Mobile if there's no Action Type
                                _this32.showCaseTemp.showcase.Tag.open(tagId);
                            }
                            _this32.emitTagChangesFromHost(tag, "click");
                            if ((ref = tag.iotDevices) === null || ref === void 0 ? void 0 : ref.length) {
                                ;
                                devicesBelongingToTag = iot === null || iot === void 0 ? void 0 : (ref6 = iot.devices) === null || ref6 === void 0 ? void 0 : ref6.filter(function(device) {
                                    var ref;
                                    return device === null || device === void 0 ? void 0 : (ref = device.relatedAssets) === null || ref === void 0 ? void 0 : ref.find(// eslint-disable-next-line eqeqeq
                                    function(asset) {
                                        return asset.id == tag.sid || asset.id == tag.defaultSid;
                                    });
                                });
                                doors = iot === null || iot === void 0 ? void 0 : (ref7 = iot.devices) === null || ref7 === void 0 ? void 0 : ref7.filter(function(device) {
                                    var ref, ref1, ref2;
                                    return device.providerId === ((ref1 = (ref = iot.providers) === null || ref === void 0 ? void 0 : ref.find(function(provider) {
                                        var ref;
                                        return (provider === null || provider === void 0 ? void 0 : (ref = provider.provider) === null || ref === void 0 ? void 0 : ref.name) === dist/* EIoTProviders.Kisi */.hJ.Kisi;
                                    })) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.provider) === null || ref2 === void 0 ? void 0 : ref2.id);
                                });
                                doorsRelatedToTag = doors === null || doors === void 0 ? void 0 : doors.filter(function(door) {
                                    return devicesBelongingToTag === null || devicesBelongingToTag === void 0 ? void 0 : devicesBelongingToTag.some(function(device) {
                                        var // eslint-disable-next-line eqeqeq
                                        ref;
                                        return (ref = device.relatedAssets) === null || ref === void 0 ? void 0 : ref.some(function(asset) {
                                            return asset.id == door.id;
                                        });
                                    });
                                });
                                _this32.setState({
                                    selectedTag: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, tag), {
                                        iotDevices: (0,_to_consumable_array/* default */.Z)(devicesBelongingToTag || []).concat((0,_to_consumable_array/* default */.Z)(doorsRelatedToTag || [])) || (tag === null || tag === void 0 ? void 0 : tag.iotDevices)
                                    })
                                });
                            } else if (tag.type !== Tag/* TagType.Matterport */.Qy.Matterport && tag.type !== Tag/* TagType.MatterportInstant */.Qy.MatterportInstant && tag.type !== Tag/* TagType.Treedis */.Qy.Treedis && tag.type !== Tag/* TagType.Flow */.Qy.Flow) _this32.setState({
                                selectedTag: tag
                            });
                            else {
                                _this32.setState({
                                    selectedTag: null
                                });
                            }
                            if ((ref1 = tag.iotDevices) === null || ref1 === void 0 ? void 0 : ref1.length) {
                                ;
                                camera = (ref10 = (ref8 = _this32.state.lastTagHovered) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.iotDevices) === null || ref9 === void 0 ? void 0 : ref9.filter(function(d) {
                                    return d.videoUrl;
                                })) === null || ref10 === void 0 ? void 0 : ref10[0];
                                if (camera) {
                                    ;
                                    _this32.setIotModalOpen(true, false);
                                    _this32.updateIotState({
                                        openCamera: (ref13 = (ref11 = _this32.state.lastTagHovered) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.iotDevices) === null || ref12 === void 0 ? void 0 : ref12.filter(function(d) {
                                            return d.videoUrl;
                                        })) === null || ref13 === void 0 ? void 0 : ref13[0],
                                        openFavouriteCameras: null
                                    });
                                }
                            }
                            if ((tag.mpNavigation || ((ref2 = tag.iotDevices) === null || ref2 === void 0 ? void 0 : ref2.length)) && tag.type !== Tag/* TagType.Treedis */.Qy.Treedis) {
                                _this32.moveToTagIO(tag, tag.action === "click");
                            }
                            if (!!((ref3 = tag.iotDevices) === null || ref3 === void 0 ? void 0 : ref3.length)) return [
                                3,
                                2
                            ];
                            _this32.setState({
                                clickedTag: false
                            });
                            return [
                                4,
                                _this32.openTagIframe(tagId)
                            ];
                        case 1:
                            _state1.sent();
                            _this32.setState({
                                clickedTag: true
                            });
                            _state1.label = 2;
                        case 2:
                            hasPath = ((ref4 = _this32.state.game) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.paths) === null || ref5 === void 0 ? void 0 : ref5.length) > 0;
                            watchTagPanelElem = _this32.getShowcaseElement(components_types/* ShowcaseElement.TagPanel */.o2.TagPanel);
                            if (!tag.tooltip && deviceManager/* default.isMobile */.Z.isMobile()) {
                                (0,util/* closeTagPanelObserver */.zx)(watchTagPanelElem);
                            } else if ((tag.tooltip || hasPath) && deviceManager/* default.isMobile */.Z.isMobile()) {
                                (0,util/* setTagPanelObserver */.p$)(watchTagPanelElem, function(isTagPanelOpen, observer) {
                                    if (tag.tooltip) {
                                        _this32.setState({
                                            hideBottomBarForWhile: isTagPanelOpen
                                        });
                                    }
                                    if (hasPath) {
                                        var pathModal = document.getElementsByClassName("path-lock-panel-wrap")[0];
                                        if (pathModal) {
                                            pathModal.style.display = isTagPanelOpen ? "none" : "block";
                                        }
                                    }
                                    if (!isTagPanelOpen) {
                                        observer.disconnect();
                                    }
                                });
                            }
                            if (tag && tag.title && !tag.isThread) {
                                (0,analytic/* sendToGA */.o$)("event", {
                                    eventCategory: "Mattertag",
                                    eventAction: "click",
                                    eventLabel: tag.title,
                                    eventType: tag.type
                                });
                            }
                            if (tag.isThread) {
                                _this32.setState({
                                    isThreadsDrawerOpen: true,
                                    selectedThread: (0,_object_spread/* default */.Z)({}, tag)
                                });
                            }
                            _this32.fixMatterportTagScrollBug();
                            return [
                                2
                            ];
                    }
                });
            });
            return function(tagId) {
                return _ref.apply(this, arguments);
            };
        }();
        _this.registerShowcaseSubscribers = function() {
            _this.unsubsribeShowcaseSubscribers();
            var _obj;
            var events = (_obj = {}, (0,_define_property/* default */.Z)(_obj, _this.showcase.Mattertag.Event.CLICK, _this.handleTagClickEvent), (0,_define_property/* default */.Z)(_obj, _this.showcase.Mattertag.Event.HOVER, _this.handleTagHoverEvent), _obj);
            Object.entries(events).forEach(function(param) {
                var _param = (0,_sliced_to_array/* default */.Z)(param, 2), event = _param[0], handler = _param[1];
                var _$emitter = _this.showcase.on(event, handler);
                _this.showcaseSubscribers.push(function() {
                    return _$emitter.off(event, handler);
                });
            });
        };
        var _this33 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.initPlaying = /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            var _state, tour, iframeUrl, vrOverlay, iframeVrButton, matterId, url, s, x, y, ref, models, navigationSweeps, ref1, barrierData, teleportGroupsRes, sweepsWithBarriersApplied, customSweeps, newState;
            return (0,tslib_es6.__generator)(this, function(_state1) {
                switch(_state1.label){
                    case 0:
                        _state = _this33.state, tour = _state.tour, iframeUrl = _state.iframeUrl;
                        if (deviceManager/* default.isMobile */.Z.isMobile() && !deviceManager/* default.isDesktop */.Z.isDesktop()) {
                            vrOverlay = _this33.getShowcaseElement(components_types/* ShowcaseElement.VRLayer */.o2.VRLayer);
                            if (vrOverlay) {
                                iframeVrButton = vrOverlay.querySelector('[role="button"]');
                                if (iframeVrButton) iframeVrButton.style.display = "none";
                            }
                        }
                        matterId = (0,util_all/* getQueryVariable */.Dv)(iframeUrl, "m");
                        url = window.location.href;
                        s = (0,util_all/* getQueryVariable */.Dv)(url, "s");
                        x = (0,util_all/* getQueryVariable */.Dv)(url, "x");
                        y = (0,util_all/* getQueryVariable */.Dv)(url, "y");
                        if (!!_this33.camera) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            _this33.showCaseTemp.showcase.Scene.query([
                                "model"
                            ])
                        ];
                    case 1:
                        models = _state1.sent();
                        _this33.camera = (ref = models[0]) === null || ref === void 0 ? void 0 : ref.parent.children[0].camera;
                        _state1.label = 2;
                    case 2:
                        return [
                            4,
                            (0,queries/* getNavigationSweeps */.$K)(tour.id)
                        ];
                    case 3:
                        navigationSweeps = _state1.sent() || [];
                        navigationSweeps.map(function(sweep) {
                            if (!sweep.enabled) {
                                _this33.showcase.Sweep.disable(sweep.sweep_uuid);
                            }
                        });
                        _this33.setState({
                            navigationSweeps: navigationSweeps
                        });
                        return [
                            4,
                            Promise.all([
                                _this33.initBarriers(tour),
                                TreedisAdminDAO/* default.getTeleportGroups */.Z.getTeleportGroups({
                                    query: {
                                        id: tour.id
                                    }
                                })
                            ])
                        ];
                    case 4:
                        ref1 = _sliced_to_array/* default.apply */.Z.apply(void 0, [
                            _state1.sent(),
                            2
                        ]), barrierData = ref1[0], teleportGroupsRes = ref1[1];
                        return [
                            4,
                            getPathCalculationSweeps(_this33.state.allSweeps, barrierData.barriers, barrierData.barrierNodes)
                        ];
                    case 5:
                        sweepsWithBarriersApplied = _state1.sent();
                        customSweeps = navigationSweeps.filter(function(s) {
                            return s.isCustom;
                        });
                        return [
                            4,
                            _this33.initCustomSweeps(customSweeps)
                        ];
                    case 6:
                        _state1.sent();
                        if (!(teleportGroupsRes === null || teleportGroupsRes === void 0 ? void 0 : teleportGroupsRes.teleportGroups)) return [
                            3,
                            8
                        ];
                        return [
                            4,
                            _this33.initTeleports(teleportGroupsRes.teleportGroups)
                        ];
                    case 7:
                        _state1.sent();
                        _state1.label = 8;
                    case 8:
                        if (s && x && y && _this33.state.tourType !== Tour/* TourType.Kiosk */.v.Kiosk && !tour.navigationWebEnabled) {
                            // We move inside the tour
                            _this33.moveToSweep(String(s), {
                                x: parseFloat(x),
                                y: parseFloat(y)
                            });
                        }
                        return [
                            4,
                            _this33.showCaseTemp.navigationManager.initialize({
                                iframe: _this33.iframe,
                                pathCalculationSweeps: sweepsWithBarriersApplied,
                                currentSweep: _this33.currentSweep,
                                pathArrowRef: _this33.isGameTour() ? null : _this33.pathArrowRefBaseTour,
                                moveToSweep: _this33.moveToSweep,
                                teleportGroups: (teleportGroupsRes === null || teleportGroupsRes === void 0 ? void 0 : teleportGroupsRes.teleportGroups) || [],
                                tourId: tour.id,
                                teleportPoints: _this33.teleportPoints,
                                requestFn: queries/* getPath */.DW,
                                handleTeleportClick: _this33.handleTeleportClick
                            })
                        ];
                    case 9:
                        _state1.sent();
                        _this33.showCaseTemp.navigationManager.on(dist/* NodeEventsTypes.NAVIGATION_PATH_RENDER_COMPLETE */.cA.NAVIGATION_PATH_RENDER_COMPLETE, function(data) {
                            var ref, ref1, ref2, ref3;
                            var visible = ((ref = data.targetObjectData) === null || ref === void 0 ? void 0 : ref.enableNavBar) || ((ref1 = data.targetObjectData) === null || ref1 === void 0 ? void 0 : ref1.enableTeleportBtn) || ((ref2 = data.targetObjectData) === null || ref2 === void 0 ? void 0 : ref2.autoNavigation) || ((ref3 = data.targetObjectData) === null || ref3 === void 0 ? void 0 : ref3.sweepId);
                            _this33.setActionPathNavbarVisible(visible);
                        });
                        _this33.showCaseTemp.navigationManager.on(dist/* NodeEventsTypes.NAVIGATION_PATH_RESET */.cA.NAVIGATION_PATH_RESET, function(data) {
                            if (data.pathFinished) {
                                _this33.setActionPathFinished(true);
                            }
                            _this33.setActionPathNavbarVisible(false);
                        });
                        _this33.showCaseTemp.navigationManager.on(dist/* NodeEventsTypes.NAVIGATION_COMPLETE */.cA.NAVIGATION_COMPLETE, function(data) {
                            _this33.setActionPathFinished(true);
                            _this33.onPathNavigationFinished(data);
                        });
                        _this33.showCaseTemp.navigationManager.on(dist/* NodeEventsTypes.NAVIGATION_TELEPORT_RESUME_AUTOMOVE */.cA.NAVIGATION_TELEPORT_RESUME_AUTOMOVE, function(data) {
                            _this33.setActionPathNavbarPlayButtonType("Pause");
                        });
                        _this33.showCaseTemp.navigationManager.on(dist/* NodeEventsTypes.NAVIGATION_PATH_RENDER_FAIL */.cA.NAVIGATION_PATH_RENDER_FAIL, function(data) {
                            console.log("NAVIGATION_PATH_RENDER_FAIL", data);
                        });
                        _this33.initPathDistanceUpdates();
                        _this33.setState({
                            appState: "playing"
                        });
                        newState = {
                            loadedOnce: true
                        };
                        // TODO:: Remove when Matterport will fix problem with current floor
                        if (matterId === "VE4rJCNFfba") newState.currentFloor = 1;
                        _this33.setState(newState, /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                            var ref, hash, polygons, err;
                            return (0,tslib_es6.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        if (tour.addon_ts >= 0 && tour.mpPlay) {
                                            setTimeout(function() {
                                                _this33.playTour();
                                            }, tour.addon_ts * 1000);
                                        }
                                        _state.label = 1;
                                    case 1:
                                        _state.trys.push([
                                            1,
                                            4,
                                            ,
                                            5
                                        ]);
                                        hash = window.location.hash.substring(1);
                                        if (hash) {
                                            _this33.loadModel(null, null, Menu/* MenuType.Product */.o.Product, hash, null);
                                        }
                                        if (!_this33.isTourReadyForAudio()) return [
                                            3,
                                            3
                                        ];
                                        return [
                                            4,
                                            _this33.processTourMusic(true)
                                        ];
                                    case 2:
                                        _state.sent();
                                        _state.label = 3;
                                    case 3:
                                        polygons = _this33.state.polygons;
                                        if (((ref = _this33.vsObjects) === null || ref === void 0 ? void 0 : ref.length) > 0 || (polygons === null || polygons === void 0 ? void 0 : polygons.length) > 0 || (tour === null || tour === void 0 ? void 0 : tour.enableAvatar)) {
                                            _this33.setState({
                                                isVSReady: true
                                            }, /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                                                var ref, ref1, ref2, ref3, ref4, ref5, ref6;
                                                return (0,tslib_es6.__generator)(this, function(_state) {
                                                    switch(_state.label){
                                                        case 0:
                                                            return [
                                                                4,
                                                                _this33.showCaseTemp.showcase.Scene.register(virtualStaging_avatar/* avatarComponentType */.bB, virtualStaging_avatar/* makeAvatarComponent */.Sr)
                                                            ];
                                                        case 1:
                                                            _state.sent();
                                                            if (!((polygons === null || polygons === void 0 ? void 0 : polygons.length) || ((ref = _this33.vsObjects) === null || ref === void 0 ? void 0 : ref.length))) return [
                                                                3,
                                                                5
                                                            ];
                                                            if (!(polygons === null || polygons === void 0 ? void 0 : polygons.length)) return [
                                                                3,
                                                                3
                                                            ];
                                                            return [
                                                                4,
                                                                _this33.initPolygons()
                                                            ];
                                                        case 2:
                                                            _state.sent();
                                                            _state.label = 3;
                                                        case 3:
                                                            if (!((ref5 = _this33.vsObjects) === null || ref5 === void 0 ? void 0 : ref5.length)) return [
                                                                3,
                                                                5
                                                            ];
                                                            return [
                                                                4,
                                                                _this33.initVS()
                                                            ];
                                                        case 4:
                                                            _state.sent();
                                                            _state.label = 5;
                                                        case 5:
                                                            return [
                                                                4,
                                                                _this33.initAvatar()
                                                            ];
                                                        case 6:
                                                            _state.sent();
                                                            if (!(!deviceManager/* default.isMobile */.Z.isMobile() && _this33.isGameTour() && (((ref1 = _this33.state.tour) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.user) === null || ref2 === void 0 ? void 0 : ref2.enterprise) || ((ref3 = _this33.state.tour) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.user) === null || ref4 === void 0 ? void 0 : ref4.subscription) === (User/* UserSubscription.Business */.MX.Business || User/* UserSubscription.Enterprise */.MX.Enterprise)))) return [
                                                                3,
                                                                10
                                                            ];
                                                            if (!((ref6 = _this33.state.game) === null || ref6 === void 0 ? void 0 : ref6.backpackOn)) return [
                                                                3,
                                                                8
                                                            ];
                                                            return [
                                                                4,
                                                                _this33.initBackpackMesh()
                                                            ];
                                                        case 7:
                                                            _state.sent();
                                                            _state.label = 8;
                                                        case 8:
                                                            return [
                                                                4,
                                                                _this33.initPathFinderMesh()
                                                            ];
                                                        case 9:
                                                            _state.sent();
                                                            _state.label = 10;
                                                        case 10:
                                                            return [
                                                                4,
                                                                _this33.initVRPointer()
                                                            ];
                                                        case 11:
                                                            _state.sent();
                                                            if (!_this33.getValueOnWindowLocationObject("href").includes("m=y9vZoA57wQs")) return [
                                                                3,
                                                                13
                                                            ];
                                                            return [
                                                                4,
                                                                initPipes(_this33.showCaseTemp, _this33.modelNodes, _this33.state.polygons, _this33.renderer)
                                                            ];
                                                        case 12:
                                                            _this33.pipesData = _state.sent();
                                                            _state.label = 13;
                                                        case 13:
                                                            if (!_this33.getValueOnWindowLocationObject("href").includes("m=cKEUCfKQmHn")) return [
                                                                3,
                                                                15
                                                            ];
                                                            return [
                                                                4,
                                                                initPipesAmericanWater(_this33.showCaseTemp, _this33.modelNodes, _this33.state.polygons, _this33.renderer)
                                                            ];
                                                        case 14:
                                                            _this33.pipesData = _state.sent();
                                                            _state.label = 15;
                                                        case 15:
                                                            if (_this33.state.tour.slug === "05417693") _this33.buildPipes();
                                                            _this33.loadingQueue.setLoadingQueueProgress(100);
                                                            return [
                                                                2
                                                            ];
                                                    }
                                                });
                                            }));
                                        } else {
                                            _this33.loadingQueue.setLoadingQueueProgress(100);
                                        }
                                        return [
                                            3,
                                            5
                                        ];
                                    case 4:
                                        err = _state.sent();
                                        console.error(err);
                                        return [
                                            3,
                                            5
                                        ];
                                    case 5:
                                        return [
                                            2
                                        ];
                                }
                            });
                        }));
                        return [
                            2
                        ];
                }
            });
        });
        _this.setActionPathNavbarVisible = function(visible) {
            _this.setState({
                showActionPathBar: visible
            });
        };
        _this.setActionPathNavbarPlayButtonType = function(type) {
            _this.setState({
                actionPathNavbarPlayButtonType: type
            });
        };
        _this.setActionPathNavbarData = function(data) {
            _this.setState({
                actionPathNavbarData: data
            });
        };
        _this.setActionPathFinished = function(val) {
            _this.setState({
                actionPathFinished: val
            });
        };
        _this.setTeleportFinished = function(data) {
            _this.onPathNavigationFinished(data);
        };
        _this.onPathNavigationFinished = function(data) {
            var targetObjectData = data.targetObjectData;
            if (targetObjectData === null || targetObjectData === void 0 ? void 0 : targetObjectData.sid) {
                _this.handleTagHoverEvent(targetObjectData.sid, true);
            }
        };
        _this.resetNavigationByCloseButton = function(value) {
            _this.setState({
                shouldNavReset: value
            });
        };
        var _this34 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.initStarting = /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            var ref, ref1, _state, tour, _$tourType, showcaseLoaded, isChangeIframe, iframeUrl, isHideTags, condition, matterId, importAudioData, volumeHandler, auth, tagsRes, _tmp, traneData, iotDevices, _tmp1, iotProviders, _tmp2, iotDevicesWithTags, mpTags, treedisTags, threads, isMatterportLink, ref2, polygons, vsObjects, vsSettings, _tmp3, ref3, fetchedFlows, objectsWithClick, foundMainFlow, polygonsAudioData, err;
            return (0,tslib_es6.__generator)(this, function(_state1) {
                switch(_state1.label){
                    case 0:
                        _state1.trys.push([
                            0,
                            18,
                            ,
                            19
                        ]);
                        _this34.loadingQueue.setLoadingQueueProgress(70);
                        _this34.setState({
                            appState: "starting"
                        });
                        _state = _this34.state, tour = _state.tour, _$tourType = _state.tourType, showcaseLoaded = _state.showcaseLoaded, isChangeIframe = _state.isChangeIframe, iframeUrl = _state.iframeUrl;
                        if (iframeUrl.includes("m=mEMx41aqAaq")) _this34.isGeorgiaPacificTour = true;
                        isHideTags = tour.addon_hidetags;
                        (0,analytic/* startGA */.Rj)(tour, true);
                        condition = _$tourType === Tour/* TourType.Game */.v.Game ? true : !showcaseLoaded || isChangeIframe;
                        matterId = (0,util_all/* getQueryVariable */.Dv)(iframeUrl, "m");
                        return [
                            4,
                            _this34.initVRSettings()
                        ];
                    case 1:
                        _state1.sent();
                        importAudioData = BaseTour_audioHandler.importAudioData, volumeHandler = BaseTour_audioHandler.volumeHandler;
                        if (!condition) return [
                            2
                        ];
                        volumeHandler(tour.audioVolume);
                        _this34.yAxisVec3 = new _this34.THREE.Vector3(0, 1, 0);
                        auth = (0,util_all/* getQueryVariable */.Dv)(window.location.href, "auth");
                        if (((ref = tour.user) === null || ref === void 0 ? void 0 : ref.oauth) && tour.oauthAccess) {
                            auth = null; // disregard auth if oauth is enabled on tour
                        }
                        if (!!isHideTags) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            TreedisPublicDAO/* default.getTags */.Z.getTags({
                                matterId: matterId,
                                slug: matterId === tour.matterId ? tour.slug : null,
                                auth: auth
                            })
                        ];
                    case 2:
                        _tmp = _state1.sent();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        _tmp = {};
                        _state1.label = 4;
                    case 4:
                        tagsRes = _tmp;
                        if (!(tour.slug == "trane-demo")) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            TreedisPublicDAO/* default.getTraneDemo */.Z.getTraneDemo()
                        ];
                    case 5:
                        traneData = _state1.sent();
                        _this34.setState({
                            traneData: traneData
                        });
                        _state1.label = 6;
                    case 6:
                        if (!tour.enableIot) return [
                            3,
                            8
                        ];
                        return [
                            4,
                            TreedisPublicDAO/* default.getIoTDevices */.Z.getIoTDevices({
                                query: {
                                    tourId: tour.id
                                }
                            })
                        ];
                    case 7:
                        _tmp1 = _state1.sent();
                        return [
                            3,
                            9
                        ];
                    case 8:
                        _tmp1 = {};
                        _state1.label = 9;
                    case 9:
                        iotDevices = _tmp1;
                        if (!tour.enableIot) return [
                            3,
                            11
                        ];
                        return [
                            4,
                            TreedisPublicDAO/* default.getIoTProviders */.Z.getIoTProviders({
                                query: {
                                    tourId: tour.id
                                }
                            })
                        ];
                    case 10:
                        _tmp2 = _state1.sent();
                        return [
                            3,
                            12
                        ];
                    case 11:
                        _tmp2 = {};
                        _state1.label = 12;
                    case 12:
                        iotProviders = _tmp2;
                        _this34.updateIotState({
                            devices: iotDevices === null || iotDevices === void 0 ? void 0 : iotDevices.data,
                            providers: iotProviders === null || iotProviders === void 0 ? void 0 : iotProviders.data
                        });
                        iotDevicesWithTags = iotDevices === null || iotDevices === void 0 ? void 0 : (ref1 = iotDevices.data) === null || ref1 === void 0 ? void 0 : ref1.filter(function(device) {
                            return device.relatedAssets;
                        });
                        // TODO check with MP!!!
                        // const mpTags = !isHideTags? await new Promise((resolve) => {
                        //   this.showcase.Tag.data.subscribe({
                        //     onCollectionUpdated(collection) {
                        //       const modifiedCollection = {}
                        //       Object.keys(collection).map((item) => {
                        //         const tag = collection[item]
                        //         modifiedCollection[tag.id] = {
                        //           newColor: tag.color,
                        //           color: tag.color.r? rgbToHex(tag.color.r, tag.color.g, tag.color.b) : tag.color, //rgb is decimal numbers??? Why??
                        //           description: tag.description,
                        //           sid: tag.id,
                        //           label: tag.label,
                        //           position: tag.anchorPosition,
                        //           stem: {
                        //             direction: tag.stemVector,
                        //             enabled: tag.stemEnabled
                        //           }
                        //         }
                        //       })
                        //       return resolve(modifiedCollection);
                        //     }
                        //   });
                        // }) : {};
                        // console.log("MP Tags loaded showcase vs legacy API", mpTags, tagsRes.matterTags)
                        if (isHideTags) {
                            _this34.setState({
                                loadingTags: false
                            });
                        }
                        mpTags = tagsRes === null || tagsRes === void 0 ? void 0 : tagsRes.matterTags;
                        treedisTags = tagsRes === null || tagsRes === void 0 ? void 0 : tagsRes.tags;
                        threads = (tour === null || tour === void 0 ? void 0 : tour.isThreadsEnabled) ? tagsRes === null || tagsRes === void 0 ? void 0 : tagsRes.threads : [];
                        _this34.loadingQueue.setLoadingQueueProgress(40);
                        isMatterportLink = (0,util_all/* getQueryVariable */.Dv)(_this34.state.iframeUrl, "m") !== tour.matterId;
                        if (!_this34.isFreeUser) return [
                            3,
                            13
                        ];
                        _tmp3 = {
                            polygons: [],
                            vsObjects: [],
                            vsSettings: _this34.state.vsSettings
                        };
                        return [
                            3,
                            15
                        ];
                    case 13:
                        return [
                            4,
                            (0,queries/* getVSItems */.BZ)(isMatterportLink, {
                                slug: tour.slug,
                                userId: tour.userId,
                                id: tour.id,
                                tourType: _$tourType
                            })
                        ];
                    case 14:
                        _tmp3 = _state1.sent();
                        _state1.label = 15;
                    case 15:
                        ref2 = _tmp3, polygons = ref2.polygons, vsObjects = ref2.vsObjects, vsSettings = ref2.vsSettings;
                        return [
                            4,
                            (0,queries/* getFlowsData */.Y4)(tour.id)
                        ];
                    case 16:
                        ref3 = _state1.sent(), fetchedFlows = ref3.flows, objectsWithClick = ref3.objectsWithClick;
                        foundMainFlow = fetchedFlows.find(function(f) {
                            return f.isMain;
                        });
                        _this34.vsObjects = vsObjects// Filtering IoT devices. Those are rendered in the IotLogic component
                        .filter(function(o) {
                            return o.actionType !== "iot";
                        }).filter(function(obj) {
                            return obj.active;
                        });
                        return [
                            4,
                            _this34.showCaseTemp.scene.configureScene({
                                settings: vsSettings,
                                onShadowEnabled: function(value) {
                                    _this34.isShadowEnabled = value;
                                },
                                onShadowNodeCreated: function(shadowNode) {
                                    _this34.shadowNode = shadowNode;
                                }
                            })
                        ];
                    case 17:
                        _state1.sent();
                        if (tour.patchIconEnabled && tour.patchIcon) {
                            _this34.initPatch("".concat("https://cdn.treedis.com", "/tours/").concat(tour.id, "/").concat(tour.patchIcon));
                        }
                        importAudioData(AudioModule/* MusicObjectKey.VSIMAGES */.NO.VSIMAGES, vsObjects.filter(function(item) {
                            return (0,_instanceof/* default */.Z)(item, VSObject/* TourImage */.oP);
                        }).map(function(el) {
                            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, el), {
                                tourId: tour.id
                            });
                        }));
                        polygonsAudioData = [];
                        polygons.forEach(function(p) {
                            var ref;
                            if ((ref = p.polygonsActions) === null || ref === void 0 ? void 0 : ref.find(function(a) {
                                return a.type === "music";
                            })) {
                                polygonsAudioData.push({
                                    id: p.polygonsActions[0].id,
                                    tourId: tour.id,
                                    actionType: "music",
                                    url: p.polygonsActions[0].url
                                });
                            }
                        });
                        importAudioData(AudioModule/* MusicObjectKey.TAGS */.NO.TAGS, treedisTags);
                        importAudioData(AudioModule/* MusicObjectKey.TOUR */.NO.TOUR, [
                            tour
                        ]);
                        importAudioData(AudioModule/* MusicObjectKey.FLOORS */.NO.FLOORS, tour.musics);
                        if (polygonsAudioData === null || polygonsAudioData === void 0 ? void 0 : polygonsAudioData.length) {
                            importAudioData(AudioModule/* MusicObjectKey.POLYGONS */.NO.POLYGONS, polygonsAudioData);
                        }
                        _this34.setState({
                            allAudio: BaseTour_audioHandler.getAllMusicData()
                        });
                        _this34.setState({
                            allTags: new Map(),
                            polygons: polygons,
                            vsSettings: vsSettings,
                            flows: fetchedFlows,
                            mainFlow: foundMainFlow,
                            flowsObjects: objectsWithClick
                        }, function() {
                            _this34.tagManager.subscribe({
                                mpTags: mpTags,
                                treedisTags: treedisTags,
                                threads: threads,
                                iotDevicesWithTags: iotDevicesWithTags
                            }, function(allTags) {
                                console.log("Setting tags...", allTags.size);
                                _this34.setState({
                                    allTags: allTags,
                                    threadsLoaded: true
                                }, /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                                    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, _$allTags, tags, isBusinessOrEnterprise;
                                    return (0,tslib_es6.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                _$allTags = _this34.state.allTags;
                                                return [
                                                    4,
                                                    _this34.initTags(Array.from(_$allTags.values()))
                                                ];
                                            case 1:
                                                tags = _state.sent();
                                                isBusinessOrEnterprise = ((ref = _this34.state.tour) === null || ref === void 0 ? void 0 : (ref1 = ref.user) === null || ref1 === void 0 ? void 0 : ref1.enterprise) || ((ref2 = _this34.state.tour) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.user) === null || ref3 === void 0 ? void 0 : ref3.subscription) === User/* UserSubscription.Business */.MX.Business || ((ref4 = _this34.state.tour) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.user) === null || ref5 === void 0 ? void 0 : ref5.subscription) === User/* UserSubscription.Enterprise */.MX.Enterprise;
                                                if (!deviceManager/* default.isMobile */.Z.isMobile() && !deviceManager/* default.isDesktop */.Z.isDesktop() && ((ref6 = _this34.renderer) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.xr) === null || ref7 === void 0 ? void 0 : ref7.enabled) && isBusinessOrEnterprise) {
                                                    _this34.initVRTags(tags);
                                                    _this34.initVREventManager();
                                                    if (_this34.state.menus.length) {
                                                        _this34.initMenuMesh();
                                                    }
                                                    if (!_this34.state.menus.length && fetchedFlows) _this34.initFlowsMenuMesh(fetchedFlows);
                                                    _this34.initFlowsBarMesh();
                                                }
                                                _this34.setState({
                                                    loadingTags: false,
                                                    allTags: tags
                                                }, /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                                                    var ref, iot, twinmakerProvider, ref1, ref2, ref3, tmConfig, alarms, rules, liveTags, ref4, ref5, ref6, ref7, ref8, ref9, THREE, pose, isVisibleAsset, err;
                                                    return (0,tslib_es6.__generator)(this, function(_state) {
                                                        switch(_state.label){
                                                            case 0:
                                                                _state.trys.push([
                                                                    0,
                                                                    8,
                                                                    ,
                                                                    9
                                                                ]);
                                                                _this34.hiddenTags = {};
                                                                _this34.visibleTags = {};
                                                                _this34.filterTags();
                                                                iot = _this34.state.iot;
                                                                twinmakerProvider = iot === null || iot === void 0 ? void 0 : (ref = iot.providers) === null || ref === void 0 ? void 0 : ref.find(function(provider) {
                                                                    var ref;
                                                                    return (provider === null || provider === void 0 ? void 0 : (ref = provider.provider) === null || ref === void 0 ? void 0 : ref.name) === dist/* EIoTProviders.TWINMAKER */.hJ.TWINMAKER;
                                                                });
                                                                if (!(twinmakerProvider && false)) return [
                                                                    3,
                                                                    7
                                                                ];
                                                                return [
                                                                    4,
                                                                    TreedisPublicDAO/* default.getTwinMakerConfig */.Z.getTwinMakerConfig(tour.slug)
                                                                ];
                                                            case 1:
                                                                ref3 = _state.sent(), tmConfig = ref3.data;
                                                                alarms = {};
                                                                rules = tmConfig.data.rules;
                                                                liveTags = [];
                                                                return [
                                                                    4,
                                                                    Promise.all((ref1 = tmConfig.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.nodes) === null || ref2 === void 0 ? void 0 : ref2.map(function() {
                                                                        var _ref = (0,_async_to_generator/* default */.Z)(function(node) {
                                                                            var ref, ref1, ref2, ref3, ref4, ref5, tagComponent, overlayComponent, tag, ruleId;
                                                                            return (0,tslib_es6.__generator)(this, function(_state) {
                                                                                switch(_state.label){
                                                                                    case 0:
                                                                                        tagComponent = (ref = node.components) === null || ref === void 0 ? void 0 : ref.filter(function(component) {
                                                                                            return component.type === "Tag";
                                                                                        })[0];
                                                                                        overlayComponent = (ref1 = node.components) === null || ref1 === void 0 ? void 0 : ref1.filter(function(component) {
                                                                                            return component.type === "DataOverlay";
                                                                                        })[0];
                                                                                        if (!tagComponent || !tagComponent.valueDataBinding || tagComponent.valueDataBinding.length === 0) return [
                                                                                            2
                                                                                        ]; // not a live tag
                                                                                        if (!overlayComponent || !overlayComponent.valueDataBindings || overlayComponent.valueDataBindings.length === 0) return [
                                                                                            2
                                                                                        ]; // not a live tag with overlay
                                                                                        tag = {
                                                                                            title: node.name,
                                                                                            enabled: true,
                                                                                            mpTitle: true,
                                                                                            tooltip: true,
                                                                                            mpNavigation: true,
                                                                                            iconColor: "#0000FF",
                                                                                            positionX: (ref2 = node.transform) === null || ref2 === void 0 ? void 0 : ref2.position[0],
                                                                                            positionY: (ref3 = node.transform) === null || ref3 === void 0 ? void 0 : ref3.position[1],
                                                                                            positionZ: (ref4 = node.transform) === null || ref4 === void 0 ? void 0 : ref4.position[2],
                                                                                            description: (ref5 = overlayComponent === null || overlayComponent === void 0 ? void 0 : overlayComponent.dataRows[0]) === null || ref5 === void 0 ? void 0 : ref5.content.replace(/#/g, "").replace(/\*\*/g, "")
                                                                                        };
                                                                                        return [
                                                                                            4,
                                                                                            _this34.addMattertag(tag)
                                                                                        ];
                                                                                    case 1:
                                                                                        tag.sid = _state.sent();
                                                                                        _this34.showcase.Tag.editStem(tag.sid, {
                                                                                            stemVisible: false
                                                                                        }).catch(console.error);
                                                                                        tag.component = tagComponent;
                                                                                        tag.overlay = overlayComponent.valueDataBindings;
                                                                                        liveTags.push(tag);
                                                                                        console.log("liveTag added", tag);
                                                                                        ruleId = tagComponent.ruleBasedMapId;
                                                                                        if (ruleId) alarms[tag.sid] = ruleId;
                                                                                        return [
                                                                                            2
                                                                                        ];
                                                                                }
                                                                            });
                                                                        });
                                                                        return function(node) {
                                                                            return _ref.apply(this, arguments);
                                                                        };
                                                                    }()))
                                                                ];
                                                            case 2:
                                                                _state.sent();
                                                                return [
                                                                    4,
                                                                    _this34.registerIcon({
                                                                        iconId: "stopped__treedis",
                                                                        url: "https://treedis-public.s3.eu-central-1.amazonaws.com/iot/stopped.png"
                                                                    })
                                                                ];
                                                            case 3:
                                                                _state.sent();
                                                                return [
                                                                    4,
                                                                    _this34.registerIcon({
                                                                        iconId: "idle__treedis",
                                                                        url: "https://treedis-public.s3.eu-central-1.amazonaws.com/iot/idle.png"
                                                                    })
                                                                ];
                                                            case 4:
                                                                _state.sent();
                                                                return [
                                                                    4,
                                                                    _this34.registerIcon({
                                                                        iconId: "running__treedis",
                                                                        url: "https://treedis-public.s3.eu-central-1.amazonaws.com/iot/running.png"
                                                                    })
                                                                ];
                                                            case 5:
                                                                _state.sent();
                                                                return [
                                                                    4,
                                                                    _this34.registerIcon({
                                                                        iconId: "fault__treedis",
                                                                        url: "https://treedis-public.s3.eu-central-1.amazonaws.com/iot/fault.png"
                                                                    })
                                                                ];
                                                            case 6:
                                                                _state.sent();
                                                                _this34.requestTwinMakerData(liveTags, rules, alarms, tour);
                                                                setInterval(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                                                                    return (0,tslib_es6.__generator)(this, function(_state) {
                                                                        _this34.requestTwinMakerData(liveTags, rules, alarms, tour);
                                                                        return [
                                                                            2
                                                                        ];
                                                                    });
                                                                }), 60000);
                                                                _state.label = 7;
                                                            case 7:
                                                                // @ts-ignore
                                                                _this34.updateIotState({
                                                                    sceneAssets: vsObjects.filter(function(o) {
                                                                        return o.actionType === "iot";
                                                                    })
                                                                });
                                                                // if no VS objects, Media Images of Media Videos found - loadingQueueProgress is set to 100%
                                                                // to do not display the loading indicator for VS
                                                                //Added gametour check as this is legacy stuff from https://treedis.atlassian.net/browse/TB-3235
                                                                //We don't need renderVS to be loaded again otherwise.
                                                                if (_this34.isGameTour() && _this34.vsObjects.length && _this34.pose && _this34.pose.mode === _this34.showCaseTemp.showcase.Mode.Mode.INSIDE) {
                                                                    ;
                                                                    THREE = _this34.THREE;
                                                                    pose = new THREE.Vector3((ref4 = _this34.pose) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.position) === null || ref5 === void 0 ? void 0 : ref5.x, (ref6 = _this34.pose) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.position) === null || ref7 === void 0 ? void 0 : ref7.y, (ref8 = _this34.pose) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.position) === null || ref9 === void 0 ? void 0 : ref9.z);
                                                                    isVisibleAsset = _this34.vsObjects.find(function(asset) {
                                                                        var assetPose = new THREE.Vector3(asset.positionX, asset.positionY, asset.positionZ);
                                                                        // Multiply by 0.2 because 1 three.js unit is approximately 20cm
                                                                        var distance = pose.distanceTo(assetPose) * 0.2;
                                                                        return distance <= (tour.vsRenderRange || DEFAULT_VS_SENSOR_RADIUS);
                                                                    });
                                                                    if (isVisibleAsset) _this34.renderVS(_this34.pose);
                                                                }
                                                                return [
                                                                    3,
                                                                    9
                                                                ];
                                                            case 8:
                                                                err = _state.sent();
                                                                console.error(err);
                                                                return [
                                                                    3,
                                                                    9
                                                                ];
                                                            case 9:
                                                                return [
                                                                    2
                                                                ];
                                                        }
                                                    });
                                                }));
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                }));
                            });
                            _this34.setState({
                                isChangeIframe: false,
                                showcaseLoaded: true
                            });
                        });
                        return [
                            3,
                            19
                        ];
                    case 18:
                        err = _state1.sent();
                        console.error(err);
                        return [
                            3,
                            19
                        ];
                    case 19:
                        return [
                            2
                        ];
                }
            });
        });
        _this.extractAWSRule = function(statement) {
            // Extracting the attribute name
            var attributeNameRegex = /^([a-zA-Z0-9_]+)\s/;
            var attributeNameMatch = statement.match(attributeNameRegex);
            var attribute = attributeNameMatch ? attributeNameMatch[1] : null;
            // Extracting the numerical value and comparison operator
            var comparisonRegex = /[<>=!]=?\s?(['a-zA-Z0-9.]+)/;
            var comparisonMatch = statement.match(comparisonRegex);
            var comparisonOperator = comparisonMatch ? statement.match(/[<>=!]=?/)[0] : null;
            var numericalValue = comparisonMatch ? comparisonMatch[1] : null;
            // Convert comparisonOperator to an actual comparator
            var comparator;
            switch(comparisonOperator){
                case ">":
                    comparator = function(a, b) {
                        return a > b;
                    };
                    break;
                case ">=":
                    comparator = function(a, b) {
                        return a >= b;
                    };
                    break;
                case "<":
                    comparator = function(a, b) {
                        return a < b;
                    };
                    break;
                case "<=":
                    comparator = function(a, b) {
                        return a <= b;
                    };
                    break;
                case "==":
                    comparator = function(a, b) {
                        return a === b;
                    };
                    break;
                case "!=":
                    comparator = function(a, b) {
                        return a !== b;
                    };
                    break;
                default:
                    console.error("Invalid comparison operator:", comparisonOperator);
                    break;
            }
            return {
                attribute: attribute,
                comparator: comparator,
                value: parseFloat(numericalValue)
            };
        };
        _this.initSweep = function() {
            var _this1 = (0,_assert_this_initialized/* default */.Z)(_this);
            return new Promise(function() {
                var _ref = (0,_async_to_generator/* default */.Z)(function(resolve, reject) {
                    var _state, tour, iframeUrl, _tour, slug, matterId, actualMatterId, sweeps, navigationSweeps, allSweeps, floors, isMatterportLink, frFloorsRes, _tmp, err;
                    return (0,tslib_es6.__generator)(this, function(_state1) {
                        switch(_state1.label){
                            case 0:
                                _state1.trys.push([
                                    0,
                                    7,
                                    ,
                                    8
                                ]);
                                _state = _this1.state, tour = _state.tour, iframeUrl = _state.iframeUrl;
                                _tour = _this1.state.tour, slug = _tour.slug, matterId = _tour.matterId;
                                actualMatterId = (0,util_all/* getQueryVariable */.Dv)(iframeUrl, "m") || matterId;
                                return [
                                    4,
                                    (0,queries/* getSweeps */.Uv)(String(actualMatterId), slug)
                                ];
                            case 1:
                                sweeps = _state1.sent();
                                return [
                                    4,
                                    (0,queries/* getNavigationSweeps */.$K)(tour.id)
                                ];
                            case 2:
                                navigationSweeps = _state1.sent() || [];
                                allSweeps = getAllSweeps(sweeps, navigationSweeps);
                                floors = [];
                                if (!(sweeps === null || sweeps === void 0 ? void 0 : sweeps.length)) return [
                                    3,
                                    6
                                ];
                                isMatterportLink = (0,util_all/* getQueryVariable */.Dv)(iframeUrl, "m") !== matterId;
                                if (!!isMatterportLink) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    TreedisAdminDAO/* default.getFRFloors */.Z.getFRFloors(slug)
                                ];
                            case 3:
                                _tmp = _state1.sent();
                                return [
                                    3,
                                    5
                                ];
                            case 4:
                                _tmp = {
                                    data: []
                                };
                                _state1.label = 5;
                            case 5:
                                frFloorsRes = _tmp;
                                // using sweep.floor_position to get the floor height position
                                sweeps.forEach(function(sweep) {
                                    var ref;
                                    if (!floors[sweep.floor_index]) {
                                        var frFloor = frFloorsRes === null || frFloorsRes === void 0 ? void 0 : frFloorsRes.data.find(function(i) {
                                            return i.floor === sweep.floor_index;
                                        });
                                        var floor = {
                                            floor: sweep.floor_index,
                                            position: sweep.floor_position
                                        };
                                        floors[sweep.floor_index] = frFloor ? new FRFloor((0,_object_spread/* default */.Z)({}, frFloor, floor)) : new FRFloor(floor);
                                    }
                                    (ref = floors[sweep.floor_index].sweeps) === null || ref === void 0 ? void 0 : ref.push(sweep);
                                });
                                _state1.label = 6;
                            case 6:
                                _this1.setState({
                                    sweeps: sweeps,
                                    allSweeps: allSweeps,
                                    floors: floors,
                                    sweepsLoaded: true
                                }, function() {
                                    var s = (0,util_all/* getQueryVariable */.Dv)(window.location.href, "s");
                                    var x = (0,util_all/* getQueryVariable */.Dv)(window.location.href, "x");
                                    var y = (0,util_all/* getQueryVariable */.Dv)(window.location.href, "y");
                                    if (_this1.pose.mode === _this1.showCaseTemp.showcase.Mode.Mode.INSIDE && s && x && y && _this1.state.tourType !== Tour/* TourType.Kiosk */.v.Kiosk && !_this1.state.tour.navigationWebEnabled) {
                                        if (_this1.state.sweeps.some(function(sweep) {
                                            return s === sweep.sweep_uuid || s === sweep.id;
                                        })) {
                                            _this1.moveToSweep(String(s), {
                                                x: parseFloat(x),
                                                y: parseFloat(y)
                                            });
                                        }
                                    }
                                });
                                return [
                                    2,
                                    resolve(true)
                                ];
                            case 7:
                                err = _state1.sent();
                                return [
                                    2,
                                    reject(err)
                                ];
                            case 8:
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function(resolve, reject) {
                    return _ref.apply(this, arguments);
                };
            }());
        };
        _this.initScene = function() {
            var ref, ref1;
            _this.showCaseTemp.tag.on(dist/* TagEventsType.OpenTagIframe */.Gc.OpenTagIframe, function(data) {
                var event = data.event, tagId = data.tagId;
                if (event === _this.showCaseTemp.tags.matterTag.Event.CLICK) {
                    _this.setState({
                        clickedElement: {
                            id: tagId,
                            type: Game/* EntityType.Tag */.py.Tag
                        }
                    });
                }
            });
            (ref = _this.showCaseTemp.scene) === null || ref === void 0 ? void 0 : ref.sceneObject.on(dist/* NodeEventsTypes.OBJECT_HOVER */.cA.OBJECT_HOVER, function(param) {
                var data = param.data, eventData = param.eventData;
                if (_this.VRPointer.component) {
                    var ref;
                    var isLockSolution = false;
                    if ((ref = _this.state.game) === null || ref === void 0 ? void 0 : ref.locks) {
                        _this.state.game.locks.forEach(function(lock) {
                            var ref;
                            if (lock.locationType === Game/* LockLocationType.vsItem */.A.vsItem && ((ref = lock.solution) === null || ref === void 0 ? void 0 : ref.split("|").find(function(id) {
                                return +id === data.id;
                            }))) {
                                isLockSolution = true;
                            }
                        });
                    }
                    if ((data.actionType !== VSObject/* TourActionType.None */.mI.None || isLockSolution) && eventData.hover) {
                        _this.VRPointer.component.setVisible(true);
                        _this.VRPointer.target = data.node;
                    } else _this.VRPointer.component.setVisible(false);
                }
            });
            (ref1 = _this.showCaseTemp.scene) === null || ref1 === void 0 ? void 0 : ref1.sceneObject.on(dist/* NodeEventsTypes.OBJECT_CLICK */.cA.OBJECT_CLICK, function(param) {
                var data = param.data, eventData = param.eventData;
                var ref, ref1, ref2, ref3;
                var isLockSolution = false;
                if ((ref = _this.state.game) === null || ref === void 0 ? void 0 : ref.locks) {
                    _this.state.game.locks.forEach(function(lock) {
                        var ref;
                        if (lock.locationType === Game/* LockLocationType.vsItem */.A.vsItem && ((ref = lock.solution) === null || ref === void 0 ? void 0 : ref.split("|").find(function(id) {
                            return +id === data.id;
                        }))) {
                            isLockSolution = true;
                        }
                    });
                }
                if ((data.actionType !== VSObject/* TourActionType.None */.mI.None || isLockSolution) && ((ref1 = _this.gamepadRRef.current) === null || ref1 === void 0 ? void 0 : ref1.hapticActuators)) _this.gamepadRRef.current.hapticActuators[0].pulse(0.8, 100);
                _this.setState({
                    isClickedElement: true
                });
                _this.emitVSChangesFromHost({
                    data: data,
                    eventData: eventData,
                    type: VSObject/* VSInteractionType.CLICK */.IG.CLICK
                });
                if (_this.state.tourType === Tour/* TourType.Game */.v.Game) {
                    _this.openVsObjectIframe(data) && _this.handleVSAction(data);
                } else if (_this.state.tourType === Tour/* TourType.ECommerce */.v.ECommerce && (data === null || data === void 0 ? void 0 : (ref2 = data.details) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.products) === null || ref3 === void 0 ? void 0 : ref3.length)) {
                    _this.handleVSProduct && _this.handleVSProduct(data.details);
                } else {
                    _this.handleVSAction(data);
                }
                (0,analytic/* sendToGA */.o$)("event", {
                    eventCategory: "vsObject",
                    eventAction: "click",
                    eventLabel: data.details.title,
                    eventId: data.sweepUuid
                });
                _this.setState({
                    clickedElement: {
                        id: data.id,
                        type: Game/* EntityType.VSItem */.py.VSItem
                    }
                });
            });
            _this.showCaseTemp.scene.sceneImage.on(dist/* NodeEventsTypes.IMAGE_HOVER */.cA.IMAGE_HOVER, function(param) {
                var eventData = param.eventData, data = param.data;
                if (_this.VRPointer.component) {
                    var ref, ref1;
                    var ref2 = ((ref = _this.state.game) === null || ref === void 0 ? void 0 : (ref1 = ref.locks) === null || ref1 === void 0 ? void 0 : ref1.reduce(function(acc, lock) {
                        var ref;
                        if (lock.locationType === Game/* LockLocationType.vsImage */.A.vsImage && ((ref = lock.solution) === null || ref === void 0 ? void 0 : ref.split("|").includes("".concat(data.id)))) {
                            acc.isLockSolution = true;
                        }
                        if (lock.type === Game/* LockType.Genially */.Gn.Genially && lock.locationItem === "".concat(data.id)) {
                            acc.isGeniallySolution = true;
                        }
                        if (lock.type === Game/* LockType.PopUpTrivia */.Gn.PopUpTrivia && lock.locationItem === "".concat(data.id)) {
                            acc.isPopUpTriviaSolution = true;
                        }
                        if (lock.type === Game/* LockType.Code */.Gn.Code && lock.locationItem === "".concat(data.id)) {
                            acc.isCodeSolution = true;
                        }
                        if (lock.type === Game/* LockType.Keyboard */.Gn.Keyboard && lock.locationItem === "".concat(data.id)) {
                            acc.isKeyboardSolution = true;
                        }
                        return acc;
                    }, {
                        isLockSolution: false,
                        isGeniallySolution: false,
                        isPopUpTriviaSolution: false,
                        isCodeSolution: false,
                        isKeyboardSolution: false
                    })) || {}, isLockSolution = ref2.isLockSolution, isGeniallySolution = ref2.isGeniallySolution, isPopUpTriviaSolution = ref2.isPopUpTriviaSolution, isCodeSolution = ref2.isCodeSolution, isKeyboardSolution = ref2.isKeyboardSolution;
                    if (data.actionType !== VSObject/* TourActionType.None */.mI.None || isLockSolution || isGeniallySolution || isPopUpTriviaSolution || isCodeSolution || isKeyboardSolution) {
                        _this.iframe.contentWindow.document.body.style.cursor = eventData.hover ? "pointer" : "auto";
                    }
                    if ((data.actionType !== VSObject/* TourActionType.None */.mI.None || isLockSolution || isGeniallySolution) && eventData.hover) {
                        _this.VRPointer.component.setVisible(true);
                        _this.VRPointer.target = data.node;
                    } else _this.VRPointer.component.setVisible(false);
                }
                if (data.actionType === VSObject/* TourActionType.None */.mI.None) {
                    return;
                }
                _this.emitVSChangesFromHost({
                    data: data,
                    eventData: eventData,
                    type: VSObject/* VSInteractionType.HOVER */.IG.HOVER
                });
                _this.iframe.contentWindow.document.body.style.cursor = eventData.hover ? "pointer" : "auto";
                if (data.action === VSObject/* TourAction.Hover */.b2.Hover && eventData.hover) {
                    _this.handleVSAction(data);
                }
            });
            var _this1 = (0,_assert_this_initialized/* default */.Z)(_this);
            _this.showCaseTemp.scene.sceneImage.on(dist/* NodeEventsTypes.IMAGE_CLICK */.cA.IMAGE_CLICK, function() {
                var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
                    var eventData, data, ref, ref1, isLockSolution, triggerVSAnimation;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                eventData = param.eventData, data = param.data;
                                isLockSolution = false;
                                if ((ref = _this1.state.game) === null || ref === void 0 ? void 0 : ref.locks) {
                                    _this1.state.game.locks.forEach(function(lock) {
                                        var ref;
                                        if (lock.locationType === Game/* LockLocationType.vsImage */.A.vsImage && ((ref = lock.solution) === null || ref === void 0 ? void 0 : ref.split("|").find(function(id) {
                                            return +id === data.id;
                                        }))) {
                                            isLockSolution = true;
                                        }
                                    });
                                }
                                if ((data.actionType !== VSObject/* TourActionType.None */.mI.None || isLockSolution) && ((ref1 = _this1.gamepadRRef.current) === null || ref1 === void 0 ? void 0 : ref1.hapticActuators)) _this1.gamepadRRef.current.hapticActuators[0].pulse(0.8, 100);
                                _this1.setState({
                                    clickedElement: {
                                        id: data.id,
                                        type: Game/* EntityType.VSImage */.py.VSImage
                                    }
                                });
                                _this1.emitVSChangesFromHost({
                                    data: data,
                                    eventData: eventData,
                                    type: VSObject/* VSInteractionType.CLICK */.IG.CLICK
                                });
                                if (_this1.state.tourType === Tour/* TourType.Game */.v.Game) {
                                    _this1.openVsImageIframe(data);
                                }
                                (0,analytic/* sendToGA */.o$)("event", {
                                    eventCategory: "vsImage",
                                    eventAction: "click",
                                    eventLabel: data.details.title,
                                    eventId: data.sweepUuid
                                });
                                triggerVSAnimation = function() {
                                    // handle trigger VS animation event
                                    if (data.toursVSObjectId) {
                                        var ref, ref1;
                                        (ref = _this1.showCaseTemp.scene) === null || ref === void 0 ? void 0 : (ref1 = ref.sceneObject) === null || ref1 === void 0 ? void 0 : ref1.assets.forEach(function(param) {
                                            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), assetKey = _param[0], node = _param[1];
                                            if (assetKey.id === data.toursVSObjectId) {
                                                var _node = (0,_sliced_to_array/* default */.Z)(node, 2), component = _node[1];
                                                component.toggleClipAnimation(!component.clipAction.isRunning());
                                            }
                                        });
                                    }
                                };
                                // handle trigger VS video event
                                if (data.toursVSVideoId) {
                                    _this1.showCaseTemp.scene.sceneVideo.assets.forEach(function(param) {
                                        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), assetKey = _param[0], node = _param[1];
                                        if (assetKey.id === data.toursVSVideoId) {
                                            var ref;
                                            var _node = (0,_sliced_to_array/* default */.Z)(node, 2), _ = _node[0], component = _node[1];
                                            var btn = component.muteBtn;
                                            if (component.isMuted()) {
                                                BaseTour_audioHandler.pauseAllMusic();
                                                _this1.setState({
                                                    vsAudio: {
                                                        component: component,
                                                        btn: btn
                                                    }
                                                });
                                                btn.setActive(!btn.isActive());
                                                component.toggleMute();
                                            }
                                            if (component.video.autoplay) {
                                                if (btn.isActive()) {
                                                    var ref1;
                                                    var vsVideos = (ref1 = _this1.vsObjects) === null || ref1 === void 0 ? void 0 : ref1.filter(function(obj) {
                                                        var ref, ref1, ref2, ref3;
                                                        return ((ref = obj.node) === null || ref === void 0 ? void 0 : ref.components) && ((ref2 = (ref1 = obj.node) === null || ref1 === void 0 ? void 0 : ref1.components[0]) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.instance) === null || ref3 === void 0 ? void 0 : ref3.componentType) === VideoRenderer_component/* videoRendererType */.Im;
                                                    });
                                                    vsVideos === null || vsVideos === void 0 ? void 0 : vsVideos.forEach(function(obj) {
                                                        var ref;
                                                        var ref1 = (0,_sliced_to_array/* default */.Z)((ref = obj.node) === null || ref === void 0 ? void 0 : ref.components, 2), vsVideo = ref1[0], muteBtn = ref1[1];
                                                        if (!muteBtn.instance.active) {
                                                            vsVideo.instance.video.muted = true;
                                                            muteBtn.instance.active = true;
                                                            muteBtn.instance.makeBtn(muteBtn.instance.inputs.src);
                                                        }
                                                    });
                                                }
                                            } else if (component.video.paused) {
                                                component.video.play();
                                                component.video.muted = false;
                                                btn.setActive(!btn.isActive());
                                            }
                                            if (!((ref = component.video) === null || ref === void 0 ? void 0 : ref.hasEndListener)) {
                                                component.video.hasEndListener = true;
                                                component.video.addEventListener("ended", function() {
                                                    if (_this1.state.restoreAudio) {
                                                        BaseTour_audioHandler.resumeMusic();
                                                        _this1.setState({
                                                            restoreAudio: null
                                                        });
                                                    }
                                                    btn.setActive(true);
                                                    component.video.muted = true;
                                                // component.toggleMute(true);
                                                });
                                            }
                                        // else {
                                        //   component.video.pause();
                                        //   component.video.muted = true;
                                        // }
                                        }
                                    });
                                }
                                if (!data.actionType || data.actionType === VSObject/* TourActionType.None */.mI.None) {
                                    // do not wait when the action starts playing, if the is no action
                                    triggerVSAnimation();
                                    return [
                                        2
                                    ];
                                }
                                if (!(data.action === VSObject/* TourAction.Click */.b2.Click)) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this1.handleVSAction(data)
                                ];
                            case 1:
                                _state.sent();
                                // waiting for the action to start playing
                                triggerVSAnimation();
                                _state.label = 2;
                            case 2:
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function(_) {
                    return _ref.apply(this, arguments);
                };
            }());
            _this.showCaseTemp.scene.sceneImage.on(dist/* NodeEventsTypes.AVATAR_BUTTON_HOVER */.cA.AVATAR_BUTTON_HOVER, function(param) {
                var eventData = param.eventData;
                _this.iframe.contentWindow.document.body.style.cursor = eventData.hover ? "pointer" : "auto";
            });
            _this.showCaseTemp.scene.scenePolygon.on(dist/* NodeEventsTypes.POLYGON_CLICK */.cA.POLYGON_CLICK, function(param) {
                var assetId = param.assetId, eventData = param.eventData;
                _this.emitPolygonChangesFromHost({
                    type: VSObject/* VSInteractionType.CLICK */.IG.CLICK,
                    assetId: assetId,
                    eventData: eventData
                });
            });
            _this.showCaseTemp.scene.scenePolygon.on(dist/* NodeEventsTypes.POLYGON_HOVER */.cA.POLYGON_HOVER, function(param) {
                var assetId = param.assetId, eventData = param.eventData;
                _this.emitPolygonChangesFromHost({
                    type: VSObject/* VSInteractionType.HOVER */.IG.HOVER,
                    assetId: assetId,
                    eventData: eventData
                });
            });
            _this.showCaseTemp.scene.scenePolygon.on(dist/* NodeEventsTypes.POLYGON_EVENTS */.cA.POLYGON_EVENTS, function(param) {
                var type = param.type, component = param.component, eventData = param.eventData, data = param.data;
                var handleAction = function(action, eventType, eventData) {
                    if (!action) {
                        return;
                    }
                    if (action.type === Polygon/* PolygonActionType.None */.zS.None) {
                        return;
                    }
                    if (action.action === Polygon/* PolygonActionAction.Hover */.IW.Hover && eventType === VSObject/* VSInteractionType.HOVER */.IG.HOVER && eventData.hover) {
                        _this.handlePolygonAction(action);
                    }
                    if (action.action === Polygon/* PolygonActionAction.Click */.IW.Click && eventType === VSObject/* VSInteractionType.CLICK */.IG.CLICK) {
                        _this.handlePolygonAction(action);
                    }
                };
                var isECommerceTour = _this.state.tourType === Tour/* TourType.ECommerce */.v.ECommerce;
                if (type === VSObject/* VSInteractionType.HOVER */.IG.HOVER) {
                    _this.iframe.contentWindow.document.body.style.cursor = eventData.hover ? "pointer" : "auto";
                    if (_this.VRPointer.component) {
                        var ref;
                        var isLockSolution = false;
                        if ((ref = _this.state.game) === null || ref === void 0 ? void 0 : ref.locks) {
                            _this.state.game.locks.forEach(function(lock) {
                                var ref;
                                if (lock.locationType === "transparentBox" && ((ref = lock.solution) === null || ref === void 0 ? void 0 : ref.split("|").find(function(id) {
                                    return +id === data.id;
                                }))) {
                                    isLockSolution = true;
                                }
                            });
                        }
                        if ((data.actionType !== VSObject/* TourActionType.None */.mI.None || isLockSolution) && eventData.hover) {
                            _this.VRPointer.component.setVisible(true);
                            _this.VRPointer.target = component;
                        } else _this.VRPointer.component.setVisible(false);
                    }
                }
                if (type === VSObject/* VSInteractionType.CLICK */.IG.CLICK) {
                    var ref1, ref2;
                    var isLockSolution1 = false;
                    if ((ref1 = _this.state.game) === null || ref1 === void 0 ? void 0 : ref1.locks) {
                        _this.state.game.locks.forEach(function(lock) {
                            var ref;
                            if (lock.locationType === "transparentBox" && ((ref = lock.solution) === null || ref === void 0 ? void 0 : ref.split("|").find(function(id) {
                                return +id === data.id;
                            }))) {
                                isLockSolution1 = true;
                            }
                        });
                    }
                    if ((data.actionType !== VSObject/* TourActionType.None */.mI.None || isLockSolution1) && ((ref2 = _this.gamepadRRef.current) === null || ref2 === void 0 ? void 0 : ref2.hapticActuators)) _this.gamepadRRef.current.hapticActuators[0].pulse(0.8, 100);
                    var polygons = _this.state.polygons;
                    var updatedPolygons = (0,_to_consumable_array/* default */.Z)(polygons);
                    var action = data.polygonsActions.find(function(i) {
                        return i.mode === Polygon/* PolygonActionMode.VS */.l3.VS;
                    });
                    var polygonAction = new Polygon/* PolygonAction */.fD(action);
                    var foundPolygon = polygons.find(function(p) {
                        return p.id === polygonAction.polygonId && p.hideAfterClick;
                    });
                    if (foundPolygon) {
                        var nodeIndex = _this.modelNodes.findIndex(function(node) {
                            var ref, ref1;
                            return ((ref = node[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.obj3D) === null || ref1 === void 0 ? void 0 : ref1.uuid) === foundPolygon.uuid;
                        });
                        if (nodeIndex >= 0) {
                            _this.modelNodes[nodeIndex][0].stop();
                            foundPolygon.uuid = null;
                            foundPolygon.isHiddenAfterClick = true;
                            _this.modelNodes.splice(nodeIndex, 1);
                            updatedPolygons = polygons.map(function(polygon) {
                                if (polygon.id === polygonAction.polygonId) {
                                    return foundPolygon;
                                }
                                return polygon;
                            });
                        }
                    }
                    _this.setState({
                        clickedElement: {
                            id: (data === null || data === void 0 ? void 0 : data.id) || (data === null || data === void 0 ? void 0 : data.id),
                            type: Game/* EntityType.Polygon */.py.Polygon,
                            polygons: updatedPolygons
                        }
                    });
                    (0,analytic/* sendToGA */.o$)("event", {
                        eventCategory: "Polygon",
                        eventAction: "click",
                        eventLabel: data.title,
                        eventId: data.sweep_uuid
                    });
                }
                if (_this.isGameTour()) {
                    if (type === VSObject/* VSInteractionType.CLICK */.IG.CLICK) {
                        var action1 = data.polygonsActions.find(function(i) {
                            return i.mode === Polygon/* PolygonActionMode.VS */.l3.VS;
                        });
                        var polygonAction1 = new Polygon/* PolygonAction */.fD(action1);
                        handleAction(polygonAction1, type, eventData);
                        // @ts-ignore
                        var result = _this.handlePolygonLock && _this.handlePolygonLock(data.id);
                        _this.unlockChapter && _this.unlockChapter(data, GameBook/* ChapterType.Polygon */._U.Polygon);
                        if (result) {
                            if (polygonAction1.gameBackpack && !_this.state.polygonsBackpack.find(function(param) {
                                var id = param.id;
                                return data.id === id;
                            })) {
                                _this.setState({
                                    polygonsBackpack: [
                                        data
                                    ].concat((0,_to_consumable_array/* default */.Z)(_this.state.polygonsBackpack))
                                });
                            }
                        } else if (result === undefined) {
                            component.setSelection();
                        }
                    }
                } else if (isECommerceTour && data.products.length && type === VSObject/* VSInteractionType.CLICK */.IG.CLICK) {
                    _this.handlePolygonProduct && _this.handlePolygonProduct(data);
                } else {
                    var action2 = data.polygonsActions.find(function(i) {
                        return i.mode === Polygon/* PolygonActionMode.VS */.l3.VS;
                    });
                    handleAction(new Polygon/* PolygonAction */.fD(action2), type, eventData);
                }
            });
            _this.showCaseTemp.scene.sceneVideo.on(dist/* NodeEventsTypes.VIDEO_HOVER */.cA.VIDEO_HOVER, function(param) {
                var data = param.data, eventData = param.eventData;
                _this.emitVSChangesFromHost({
                    data: data,
                    eventData: eventData,
                    type: VSObject/* VSInteractionType.HOVER */.IG.HOVER
                });
            });
            _this.showCaseTemp.scene.sceneVideo.on(dist/* NodeEventsTypes.VIDEO_CLICK */.cA.VIDEO_CLICK, function(param) {
                var data = param.data, eventData = param.eventData;
                var flowIsActive = _this.state.flowIsActive;
                _this.emitVSChangesFromHost({
                    data: data,
                    eventData: eventData,
                    type: VSObject/* VSInteractionType.CLICK */.IG.CLICK
                });
                (0,analytic/* sendToGA */.o$)("event", {
                    eventCategory: "vsVideo",
                    eventAction: "click",
                    eventLabel: data.details.title,
                    eventId: data.sweepUuid
                });
                if (data.effectHide && !flowIsActive) {
                    _this.setVSVisible(data, false);
                }
                _this.subscribeToStartTriggerVSAfterAnimation(data);
                if (_this.state.tourType === Tour/* TourType.Game */.v.Game) {
                    _this.openVsVideoIframe(data);
                }
                _this.setState({
                    clickedElement: {
                        id: data.id,
                        type: Game/* EntityType.VSVideo */.py.VSVideo
                    }
                });
            });
            _this.showCaseTemp.scene.sceneTeleport.on(dist/* NodeEventsTypes.TELEPORT_CLICK */.cA.TELEPORT_CLICK, function(param) {
                var assetId = param.assetId, data = param.data, eventData = param.eventData, component = param.component;
                _this.handleTeleportClick(data.sweep);
            });
            _this.showCaseTemp.scene.sceneTeleport.on(dist/* NodeEventsTypes.TELEPORT_HOVER */.cA.TELEPORT_HOVER, function(param) {
                var assetId = param.assetId, data = param.data, eventData = param.eventData, component = param.component;
                _this.iframe.contentWindow.document.body.style.cursor = eventData.hover ? "pointer" : "auto";
            });
            _this.showCaseTemp.scene.sceneVideo.on(dist/* NodeEventsTypes.VIDEO_BUTTON_HOVER */.cA.VIDEO_BUTTON_HOVER, function(param) {
                var eventData = param.eventData, data = param.data;
                _this.iframe.contentWindow.document.body.style.cursor = eventData.hover ? "pointer" : "auto";
                if (_this.VRPointer.component) {
                    if (data.actionType !== VSObject/* TourActionType.None */.mI.None && eventData.hover) {
                        _this.VRPointer.component.setVisible(true);
                        _this.VRPointer.target = data.node;
                    } else _this.VRPointer.component.setVisible(false);
                }
            });
            _this.showCaseTemp.scene.sceneVideo.on(dist/* NodeEventsTypes.VIDEO_BUTTON_CLICK */.cA.VIDEO_BUTTON_CLICK, _this.handleVideoButtonClick);
            _this.showCaseTemp.scene.sceneVideo.on(dist/* NodeEventsTypes.UNMUTE_AFTER_START */.cA.UNMUTE_AFTER_START, _this.handleUnmuteAfterStart);
        };
        _this.handleUnmuteAfterStart = function(param) {
            var eventData = param.eventData, data = param.data, component = param.component, btnComponent = param.btnComponent;
            if (_this.isTourReadyForAudio()) {
                // delay to let other audio code run before for proper interaction
                setTimeout(function() {
                    return _this.handleVideoLoaded({
                        eventData: eventData,
                        data: data,
                        component: component,
                        btnComponent: btnComponent
                    });
                }, 500);
            } else {
                setTimeout(function() {
                    return _this.handleUnmuteAfterStart({
                        eventData: eventData,
                        data: data,
                        component: component,
                        btnComponent: btnComponent
                    });
                }, 500);
            }
        };
        _this.muteVSVideo = function(node) {
            var video = node.video, muteBtn = node.muteBtn;
            if (video && muteBtn) {
                video.muted = true;
                muteBtn.active = true;
                muteBtn.makeBtn(muteBtn.inputs.src);
            }
        };
        _this.muteAllVsVideos = function(currentVideoId) {
            var ref;
            var vsVideos = (ref = _this.vsObjects) === null || ref === void 0 ? void 0 : ref.filter(function(obj) {
                var ref;
                return ((ref = obj.node) === null || ref === void 0 ? void 0 : ref.componentType) === VideoRenderer_component/* videoRendererType */.Im;
            });
            vsVideos === null || vsVideos === void 0 ? void 0 : vsVideos.forEach(function(obj) {
                if (currentVideoId && obj.id === currentVideoId) return;
                _this.muteVSVideo(obj.node);
            });
        };
        _this.handleVideoButtonClick = function(param) {
            var eventData = param.eventData, data = param.data, component = param.component, btnComponent = param.btnComponent;
            var ref, ref1;
            if ((ref = _this.gamepadRRef.current) === null || ref === void 0 ? void 0 : ref.hapticActuators) _this.gamepadRRef.current.hapticActuators[0].pulse(0.8, 100);
            if (component.isMuted()) {
                BaseTour_audioHandler.pauseAllMusic();
                _this.setState({
                    vsAudio: {
                        component: component,
                        btn: btnComponent
                    }
                });
            }
            if (btnComponent.inputs.type === "mute") {
                var video = data.node.video;
                // This logic was muting all videos when one video was un-muted, but since now videos are paused when another video is played, this logic is not needed anymore
                // Keeping it commented out until we refactor the Music logic
                // if (btnComponent.isActive()) {
                //   const vsVideos = this.vsObjects?.filter((obj) => obj.node?.componentType === videoRendererType);
                //   vsVideos?.forEach((obj) => {
                //     const { video: vsVideo, muteBtn } = obj.node;
                //     if (muteBtn && !muteBtn.active) {
                //       vsVideo.muted = true;
                //       muteBtn.active = true;
                //       muteBtn.makeBtn(muteBtn.inputs.src);
                //     }
                //   });
                // }
                if (!video.paused) {
                    component.toggleMute();
                    _this.muteAllVsVideos(data.id);
                    events/* emitter.emit */.u.emit(events/* MittEvents.AUDIO_MUTE */.s.AUDIO_MUTE, {
                        mute: false
                    });
                }
            }
            if (btnComponent.inputs.type === "play") {
                var _node = data.node, video1 = _node.video, muteBtn = _node.muteBtn;
                // Play vsVideo
                if (video1.paused) {
                    // If a video has been played, mute all other videos
                    BaseTour_audioHandler.pauseAllMusic();
                    _this.muteAllVsVideos(data.id);
                    video1.play();
                    video1.muted = false;
                    video1.volume = BaseTour_audioHandler.getVolume();
                    muteBtn.setActive(false);
                } else {
                    // Pause vsVideo
                    video1.pause();
                    if (deviceManager/* default.isIOS */.Z.isIOS()) component.muteBtn.setActive(true);
                }
            }
            if (!((ref1 = component.video) === null || ref1 === void 0 ? void 0 : ref1.hasEndListener)) {
                component.video.hasEndListener = true;
                component.video.addEventListener("ended", function(event) {
                    if (_this.state.restoreAudio) {
                        BaseTour_audioHandler.resumeMusic();
                        _this.setState({
                            restoreAudio: null
                        });
                    }
                    btnComponent.setActive(true);
                    component.video.muted = true;
                // component.toggleMute(true);
                });
            }
            btnComponent.setActive(!btnComponent.isActive());
        };
        var _this35 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.initObjectNode = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(asset) {
                var node, showAssetAfterAnimation;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!(0,_instanceof/* default */.Z)(asset, VSObject/* TourImage */.oP)) return [
                                3,
                                2
                            ];
                            showAssetAfterAnimation = (asset === null || asset === void 0 ? void 0 : asset.toursVSObjectIdAfterAnimation) || (asset === null || asset === void 0 ? void 0 : asset.toursVSVideoIdAfterAnimation);
                            return [
                                4,
                                _this35.initImageNode(asset)
                            ];
                        case 1:
                            node = _state.sent();
                            node[1].animate = true;
                            if ((_this35.isGameTour() || showAssetAfterAnimation) && node && node.length === 2) node[1].animate = true;
                            return [
                                3,
                                8
                            ];
                        case 2:
                            if (!(0,_instanceof/* default */.Z)(asset, VSObject/* TourVideo */.Up)) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                _this35.initVideoNode(asset)
                            ];
                        case 3:
                            node = _state.sent();
                            // TODO Hardcoded pipes for TB-2112
                            if (_this35.getValueOnWindowLocationObject("href").includes("m=y9vZoA57wQs") && _this35.pipesData) {
                                if (asset.details.title === "Pressure.mp4") initPolygonUpdateFromVideo(asset, node, _this35.pipesData, _this35.THREE, _this35.renderer, 1);
                            }
                            if (_this35.getValueOnWindowLocationObject("href").includes("m=cKEUCfKQmHn") && _this35.pipesData) {
                                if (asset.details.title === "Pressure.mp4") initPolygonUpdateFromVideo(asset, node, _this35.pipesData, _this35.THREE, _this35.renderer, 0);
                                if (asset.details.title === "Pressure2.mp4") initPolygonUpdateFromVideo(asset, node, _this35.pipesData, _this35.THREE, _this35.renderer, 1);
                                if (asset.details.title === "Pressure3.mp4") initPolygonUpdateFromVideo(asset, node, _this35.pipesData, _this35.THREE, _this35.renderer, 2);
                            }
                            return [
                                3,
                                8
                            ];
                        case 4:
                            if (!(0,_instanceof/* default */.Z)(asset, VSObject/* TourVSHtml */.q8)) return [
                                3,
                                6
                            ];
                            return [
                                4,
                                _this35.initVSHtmlNode(asset)
                            ];
                        case 5:
                            node = _state.sent();
                            return [
                                3,
                                8
                            ];
                        case 6:
                            return [
                                4,
                                _this35.initNode(asset)
                            ];
                        case 7:
                            node = _state.sent();
                            if (_this35.isGameTour() && node && node.length === 2) node[1].animate = true;
                            _state.label = 8;
                        case 8:
                            if (node && node.length === 2) {
                                return [
                                    2,
                                    node[1]
                                ];
                            }
                            return [
                                2,
                                null
                            ];
                    }
                });
            });
            return function(asset) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this36 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.setVSVisible = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(vsObject, visible) {
                var trigger, isVideo, flowIsActive, index, ref, vsObjectType, ref1, ref2, e;
                var _arguments = arguments;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            trigger = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : components_types/* vsTriggerType.default */.QB["default"];
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                7,
                                ,
                                8
                            ]);
                            isVideo = (0,_instanceof/* default */.Z)(vsObject, VSObject/* TourVideo */.Up);
                            flowIsActive = _this36.state.flowIsActive;
                            // isVisible is needed to know which videos to play on IS unmount
                            if (isVideo) {
                                index = _this36.vsObjects.findIndex(function(item) {
                                    return item.id === vsObject.id;
                                });
                                if (index !== -1) _this36.vsObjects[index].isVisible = visible;
                            }
                            if ((vsObject === null || vsObject === void 0 ? void 0 : vsObject.videoPlayedOnce) && visible && !flowIsActive) {
                                return [
                                    2
                                ];
                            }
                            if (!(visible && !vsObject.started)) return [
                                3,
                                5
                            ];
                            if (!(trigger === components_types/* vsTriggerType.revealCondition */.QB.revealCondition && vsObject.delay)) return [
                                3,
                                2
                            ];
                            setTimeout(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                                var ref;
                                return (0,tslib_es6.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            vsObject.started = true; // we do it here because initObjectNode can take time
                                            return [
                                                4,
                                                _this36.initObjectNode(vsObject)
                                            ];
                                        case 1:
                                            vsObject.node = _state.sent();
                                            if (((ref = vsObject.node) === null || ref === void 0 ? void 0 : ref.video) && vsObject.node.inputs.autoplay) {
                                                vsObject.node.play();
                                            }
                                            _this36.subscribeToStartTriggerVSAfterAnimation(vsObject);
                                            _this36.deferVisibilityVSObjectRef.current.filter(function(item) {
                                                return item.id !== vsObject.id;
                                            });
                                            return [
                                                2
                                            ];
                                    }
                                });
                            }), vsObject.delay * 1000);
                            _this36.deferVisibilityVSObjectRef.current = (0,_to_consumable_array/* default */.Z)(_this36.deferVisibilityVSObjectRef.current).concat([
                                vsObject
                            ]);
                            return [
                                3,
                                4
                            ];
                        case 2:
                            vsObject.started = true; // we do it here because initObjectNode can take time
                            return [
                                4,
                                _this36.initObjectNode(vsObject)
                            ];
                        case 3:
                            vsObject.node = _state.sent();
                            if (((ref = vsObject.node) === null || ref === void 0 ? void 0 : ref.video) && vsObject.node.inputs.autoplay && !_this36.state.startScreenOn) {
                                vsObject.node.play();
                            }
                            _this36.subscribeToStartTriggerVSAfterAnimation(vsObject);
                            _state.label = 4;
                        case 4:
                            return [
                                3,
                                6
                            ];
                        case 5:
                            if (!visible && (vsObject === null || vsObject === void 0 ? void 0 : vsObject.started) && vsObject.node) {
                                vsObject.started = false;
                                vsObjectType = dist/* SceneInitEventsTypes.Object */.PS.Object;
                                if ((0,_instanceof/* default */.Z)(vsObject, VSObject/* TourImage */.oP)) {
                                    vsObjectType = dist/* SceneInitEventsTypes.Image */.PS.Image;
                                } else if ((0,_instanceof/* default */.Z)(vsObject, VSObject/* TourVideo */.Up)) {
                                    if (vsObject.hideOnAnimationFinished) {
                                        vsObject.videoPlayedOnce = true;
                                    }
                                    vsObjectType = dist/* SceneInitEventsTypes.Video */.PS.Video;
                                } else if ((0,_instanceof/* default */.Z)(vsObject, VSObject/* TourVSHtml */.q8)) {
                                    vsObjectType = dist/* SceneInitEventsTypes.HTML */.PS.HTML;
                                }
                                if (vsObjectType && vsObject) {
                                    ;
                                    (ref1 = _this36.showCaseTemp) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.scene) === null || ref2 === void 0 ? void 0 : ref2.remove(vsObjectType, vsObject);
                                }
                            }
                            _state.label = 6;
                        case 6:
                            return [
                                3,
                                8
                            ];
                        case 7:
                            e = _state.sent();
                            console.error(e.message);
                            return [
                                3,
                                8
                            ];
                        case 8:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(vsObject, visible) {
                return _ref.apply(this, arguments);
            };
        }();
        _this.changeGameCondition = function(id, key, state) {
            var condition = _this.state.game.conditions.find(function(condition) {
                return condition.id === id;
            });
            var filteredConditions = _this.state.game.conditions.filter(function(condition) {
                return condition.id !== id;
            });
            var game = _this.state.game;
            if (!condition) return;
            condition[key] = state;
            game.conditions = (0,_to_consumable_array/* default */.Z)(filteredConditions).concat([
                condition
            ]);
            _this.setState({
                game: game
            });
        };
        _this.filterVsElementsByGameCondition = function() {
            var startGameHideConditions = _this.state.game.conditions.filter(function(condition) {
                return !condition.lock_ids.length && condition.conditionType === Game/* ConditionType.HIDE */.CP.HIDE;
            });
            var gameHideConditions = _this.state.game.conditions.filter(function(condition) {
                return condition.isHidden && condition.conditionType === Game/* ConditionType.HIDE */.CP.HIDE;
            });
            var gameRevealConditions = _this.state.game.conditions.filter(function(condition) {
                return condition.isRevealed && condition.conditionType === Game/* ConditionType.REVEAL */.CP.REVEAL;
            }).reduce(function(acc, condition, currentIndex, items) {
                var itemsEntityIds = _this.state.game.conditions.filter(function(item) {
                    return item.entity_type === condition.entity_type && item.isHidden && item.lock_ids.length && item.conditionType === Game/* ConditionType.HIDE */.CP.HIDE;
                }).reduce(function(acc, item) {
                    return (0,_to_consumable_array/* default */.Z)(acc).concat((0,_to_consumable_array/* default */.Z)(item.entity_ids));
                }, []);
                return (0,_to_consumable_array/* default */.Z)(acc).concat([
                    (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, condition), {
                        entity_ids: condition.entity_ids.filter(function(entityId) {
                            return !itemsEntityIds.includes(entityId);
                        })
                    }), 
                ]);
            }, []);
            var vsItemsToHide = [];
            var vsVideosToHide = [];
            var vsImagesToHide = [];
            var vsHTMLsToHide = [];
            var polygonsToHide = [];
            startGameHideConditions.forEach(function(condition) {
                if (!condition.entity_ids) return;
                if (condition.entity_type === Game/* EntityType.Polygon */.py.Polygon) {
                    polygonsToHide = (0,_to_consumable_array/* default */.Z)(polygonsToHide).concat((0,_to_consumable_array/* default */.Z)(condition.entity_ids));
                } else if (condition.entity_type === Game/* EntityType.VSItem */.py.VSItem) {
                    vsItemsToHide = (0,_to_consumable_array/* default */.Z)(vsItemsToHide).concat((0,_to_consumable_array/* default */.Z)(condition.entity_ids)).map(function(item) {
                        return +item;
                    });
                } else if (condition.entity_type === Game/* EntityType.VSVideo */.py.VSVideo) {
                    vsVideosToHide = (0,_to_consumable_array/* default */.Z)(vsVideosToHide).concat((0,_to_consumable_array/* default */.Z)(condition.entity_ids)).map(function(item) {
                        return +item;
                    });
                } else if (condition.entity_type === Game/* EntityType.VSImage */.py.VSImage) {
                    vsImagesToHide = (0,_to_consumable_array/* default */.Z)(vsImagesToHide).concat((0,_to_consumable_array/* default */.Z)(condition.entity_ids)).map(function(item) {
                        return +item;
                    });
                } else if (condition.entity_type === Game/* EntityType.VSHTML */.py.VSHTML) {
                    vsHTMLsToHide = (0,_to_consumable_array/* default */.Z)(vsHTMLsToHide).concat((0,_to_consumable_array/* default */.Z)(condition.entity_ids)).map(function(item) {
                        return +item;
                    });
                }
            });
            gameHideConditions.forEach(function(condition) {
                if (!condition.entity_ids) return;
                if (condition.entity_type === Game/* EntityType.Polygon */.py.Polygon) {
                    polygonsToHide = (0,_to_consumable_array/* default */.Z)(polygonsToHide).concat((0,_to_consumable_array/* default */.Z)(condition.entity_ids));
                } else if (condition.entity_type === Game/* EntityType.VSItem */.py.VSItem) {
                    vsItemsToHide = (0,_to_consumable_array/* default */.Z)(vsItemsToHide).concat((0,_to_consumable_array/* default */.Z)(condition.entity_ids)).map(function(item) {
                        return +item;
                    });
                } else if (condition.entity_type === Game/* EntityType.VSVideo */.py.VSVideo) {
                    vsVideosToHide = (0,_to_consumable_array/* default */.Z)(vsVideosToHide).concat((0,_to_consumable_array/* default */.Z)(condition.entity_ids)).map(function(item) {
                        return +item;
                    });
                } else if (condition.entity_type === Game/* EntityType.VSImage */.py.VSImage) {
                    vsImagesToHide = (0,_to_consumable_array/* default */.Z)(vsImagesToHide).concat((0,_to_consumable_array/* default */.Z)(condition.entity_ids)).map(function(item) {
                        return +item;
                    });
                } else if (condition.entity_type === Game/* EntityType.VSHTML */.py.VSHTML) {
                    vsHTMLsToHide = (0,_to_consumable_array/* default */.Z)(vsHTMLsToHide).concat((0,_to_consumable_array/* default */.Z)(condition.entity_ids)).map(function(item) {
                        return +item;
                    });
                }
            });
            gameRevealConditions.forEach(function(condition) {
                if (!condition.entity_ids) return;
                if (condition.entity_type === Game/* EntityType.Polygon */.py.Polygon) {
                    polygonsToHide = polygonsToHide.filter(function(el) {
                        return !condition.entity_ids.includes(el);
                    });
                } else if (condition.entity_type === Game/* EntityType.VSItem */.py.VSItem) {
                    vsItemsToHide = vsItemsToHide.filter(function(el) {
                        return !condition.entity_ids.includes("".concat(el));
                    });
                } else if (condition.entity_type === Game/* EntityType.VSVideo */.py.VSVideo) {
                    vsVideosToHide = vsVideosToHide.filter(function(el) {
                        return !condition.entity_ids.includes("".concat(el));
                    });
                } else if (condition.entity_type === Game/* EntityType.VSImage */.py.VSImage) {
                    vsImagesToHide = vsImagesToHide.filter(function(el) {
                        return !condition.entity_ids.includes("".concat(el));
                    });
                } else if (condition.entity_type === Game/* EntityType.VSHTML */.py.VSHTML) {
                    vsHTMLsToHide = vsHTMLsToHide.filter(function(el) {
                        return !condition.entity_ids.includes("".concat(el));
                    });
                }
            });
            _this.deferVisibilityVSObjectRef.current.forEach(function(param) {
                var id = param.id, isVSImage = param.isVSImage, isVSVideo = param.isVSVideo, isVSHtml = param.isVSHtml;
                if (isVSImage) {
                    vsImagesToHide.push(id);
                } else if (isVSVideo) {
                    vsVideosToHide.push(id);
                } else if (isVSHtml) {
                    vsHTMLsToHide.push(id);
                }
            });
            return {
                startGameHideConditions: startGameHideConditions,
                vsItemsToHide: vsItemsToHide,
                vsVideosToHide: vsVideosToHide,
                vsImagesToHide: vsImagesToHide,
                vsHTMLsToHide: vsHTMLsToHide
            };
        };
        var _this37 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.initVS = /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            var _state, isVSReady, flows, mainFlow, ref, vsImagesToHide, vsItemsToHide, vsVideosToHide, vsHTMLsToHide, filteredVsObjects, startStep, condition, filteredVsObjects1, ref1, ref2, ref3, ref4, ref5, ref6, ref7, vsImagesToHide1, vsVideosToHide1, vsHTMLsToHide1, vsItemsToHide1;
            return (0,tslib_es6.__generator)(this, function(_state1) {
                _state = _this37.state, isVSReady = _state.isVSReady, flows = _state.flows, mainFlow = _state.mainFlow;
                if (!isVSReady) return [
                    2
                ]; // VS should be initialized for using!
                if (_this37.isGameTour()) {
                    ref = _this37.filterVsElementsByGameCondition(), vsImagesToHide = ref.vsImagesToHide, vsItemsToHide = ref.vsItemsToHide, vsVideosToHide = ref.vsVideosToHide, vsHTMLsToHide = ref.vsHTMLsToHide;
                    filteredVsObjects = _this37.vsObjects.filter(function(item) {
                        return (0,_instanceof/* default */.Z)(item, VSObject/* TourImage */.oP) && !vsImagesToHide.includes(item.id) || (0,_instanceof/* default */.Z)(item, VSObject/* TourObject */.zB) && !vsItemsToHide.includes(item.id) || (0,_instanceof/* default */.Z)(item, VSObject/* TourVideo */.Up) && !vsVideosToHide.includes(item.id) || (0,_instanceof/* default */.Z)(item, VSObject/* TourVSHtml */.q8) && !vsHTMLsToHide.includes(item.id);
                    });
                    filteredVsObjects.forEach(function(obj) {
                        _this37.loadingQueue.enqueue(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                            var o1, o2, ref, ref1, ref2, ref3, ref4, ref5, ref6, pose, assetPose, distance, inRange, err;
                            return (0,tslib_es6.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _state.trys.push([
                                            0,
                                            11,
                                            ,
                                            12
                                        ]);
                                        if (!((obj === null || obj === void 0 ? void 0 : obj.toursVSObjectIdAfterAnimation) || (obj === null || obj === void 0 ? void 0 : obj.toursVSVideoIdAfterAnimation))) return [
                                            3,
                                            6
                                        ];
                                        if (!obj.toursVSObjectIdAfterAnimation) return [
                                            3,
                                            2
                                        ];
                                        o1 = filteredVsObjects.find(function(item) {
                                            return item.id === obj.toursVSObjectIdAfterAnimation;
                                        });
                                        return [
                                            4,
                                            _this37.setVSVisible(o1, o1 != undefined)
                                        ];
                                    case 1:
                                        _state.sent(); // if o1 is not in filteredVsObjects, it means that it was hidden by game condition, so should not be showned
                                        _state.label = 2;
                                    case 2:
                                        if (!obj.toursVSVideoIdAfterAnimation) return [
                                            3,
                                            4
                                        ];
                                        o2 = filteredVsObjects.find(function(item) {
                                            return item.id === obj.toursVSVideoIdAfterAnimation;
                                        });
                                        return [
                                            4,
                                            _this37.setVSVisible(o2, o2 != undefined)
                                        ];
                                    case 3:
                                        _state.sent(); // if o2 is not in filteredVsObjects, it means that it was hidden by game condition, so should not be showned
                                        _state.label = 4;
                                    case 4:
                                        return [
                                            4,
                                            _this37.setVSVisible(obj, false)
                                        ];
                                    case 5:
                                        _state.sent();
                                        return [
                                            3,
                                            10
                                        ];
                                    case 6:
                                        if (!_this37.THREE) return [
                                            3,
                                            10
                                        ];
                                        pose = new _this37.THREE.Vector3((ref = _this37.pose) === null || ref === void 0 ? void 0 : (ref1 = ref.position) === null || ref1 === void 0 ? void 0 : ref1.x, (ref2 = _this37.pose) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.position) === null || ref3 === void 0 ? void 0 : ref3.y, (ref4 = _this37.pose) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.position) === null || ref5 === void 0 ? void 0 : ref5.z);
                                        assetPose = new _this37.THREE.Vector3(obj.positionX, obj.positionY, obj.positionZ);
                                        distance = pose.distanceTo(assetPose) * 0.2;
                                        inRange = distance <= ((obj === null || obj === void 0 ? void 0 : obj.renderRange) || ((ref6 = _this37.state.tour) === null || ref6 === void 0 ? void 0 : ref6.vsRenderRange) || DEFAULT_VS_SENSOR_RADIUS);
                                        if (!inRange) return [
                                            3,
                                            8
                                        ];
                                        return [
                                            4,
                                            _this37.setVSVisible(obj, true)
                                        ];
                                    case 7:
                                        _state.sent();
                                        return [
                                            3,
                                            10
                                        ];
                                    case 8:
                                        return [
                                            4,
                                            _this37.setVSVisible(obj, false)
                                        ];
                                    case 9:
                                        _state.sent();
                                        _state.label = 10;
                                    case 10:
                                        // Hardcoded for Georgia Pacific TB-2219
                                        if (_this37.isGeorgiaPacificTour) {
                                            _this37.processGeorgiaPacificTour();
                                        }
                                        _this37.loadingQueue.dequeue();
                                        return [
                                            3,
                                            12
                                        ];
                                    case 11:
                                        err = _state.sent();
                                        console.error(err);
                                        _this37.loadingQueue.dequeue();
                                        return [
                                            3,
                                            12
                                        ];
                                    case 12:
                                        return [
                                            2
                                        ];
                                }
                            });
                        }));
                    });
                } else if (flows.length && mainFlow) {
                    startStep = mainFlow.steps.find(function(step) {
                        return step.type === "start_step";
                    });
                    condition = startStep.conditions.find(function(condition) {
                        return condition.action === "start";
                    });
                    filteredVsObjects1 = _this37.vsObjects;
                    if (condition) {
                        ;
                        vsImagesToHide1 = (ref1 = condition === null || condition === void 0 ? void 0 : condition.rows[0]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.vsItems) === null || ref2 === void 0 ? void 0 : ref2.filter(function(item) {
                            return item.includes("image");
                        }).map(function(item) {
                            return parseInt(item.replace("image_", ""));
                        });
                        vsVideosToHide1 = (ref3 = condition === null || condition === void 0 ? void 0 : condition.rows[0]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.vsItems) === null || ref4 === void 0 ? void 0 : ref4.filter(function(item) {
                            return item.includes("video");
                        }).map(function(item) {
                            return parseInt(item.replace("video_", ""));
                        });
                        vsHTMLsToHide1 = (ref5 = condition === null || condition === void 0 ? void 0 : condition.rows[0]) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.vsItems) === null || ref6 === void 0 ? void 0 : ref6.filter(function(item) {
                            return item.includes("html");
                        }).map(function(item) {
                            return parseInt(item.replace("html_", ""));
                        });
                        vsItemsToHide1 = (ref7 = condition === null || condition === void 0 ? void 0 : condition.rows[0]) === null || ref7 === void 0 ? void 0 : ref7.vsObjects;
                        filteredVsObjects1 = _this37.vsObjects.filter(function(item) {
                            return (0,_instanceof/* default */.Z)(item, VSObject/* TourImage */.oP) && !vsImagesToHide1.includes(item.id) || (0,_instanceof/* default */.Z)(item, VSObject/* TourObject */.zB) && !vsItemsToHide1.includes(String(item.id)) || (0,_instanceof/* default */.Z)(item, VSObject/* TourVideo */.Up) && !vsVideosToHide1.includes(item.id) || (0,_instanceof/* default */.Z)(item, VSObject/* TourVSHtml */.q8) && !vsHTMLsToHide1.includes(item.id);
                        });
                    }
                    filteredVsObjects1.forEach(function(obj) {
                        _this37.loadingQueue.enqueue(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                            var err;
                            return (0,tslib_es6.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _state.trys.push([
                                            0,
                                            3,
                                            ,
                                            4
                                        ]);
                                        if (!_this37.THREE) return [
                                            3,
                                            2
                                        ];
                                        return [
                                            4,
                                            _this37.setVSVisible(obj, true)
                                        ];
                                    case 1:
                                        _state.sent(); //we show VS Object regardless of distance because flows said so!
                                        _state.label = 2;
                                    case 2:
                                        // Hardcoded for Georgia Pacific TB-2219
                                        if (_this37.isGeorgiaPacificTour) {
                                            _this37.processGeorgiaPacificTour();
                                        }
                                        _this37.loadingQueue.dequeue();
                                        return [
                                            3,
                                            4
                                        ];
                                    case 3:
                                        err = _state.sent();
                                        console.error(err);
                                        _this37.loadingQueue.dequeue();
                                        return [
                                            3,
                                            4
                                        ];
                                    case 4:
                                        return [
                                            2
                                        ];
                                }
                            });
                        }));
                    });
                } else {
                    _this37.renderVS(_this37.pose);
                }
                return [
                    2
                ];
            });
        });
        var _this38 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.stopVS = /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                try {
                    _this38.vsObjects.map(function(asset) {
                        _this38.setVSVisible(asset, false);
                    });
                } catch (e) {
                    console.error(e);
                }
                return [
                    2
                ];
            });
        });
        var _this39 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.initPolygons = /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                _this39.loadingQueue.enqueue(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                    var promises, polygons, err;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                promises = _this39.state.polygons.map(function() {
                                    var _ref = (0,_async_to_generator/* default */.Z)(function(item) {
                                        var node;
                                        return (0,tslib_es6.__generator)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    if (!item.active || item.hiddenFromFlows) {
                                                        return [
                                                            2,
                                                            item
                                                        ];
                                                    }
                                                    if (!!item.uuid) return [
                                                        3,
                                                        2
                                                    ];
                                                    return [
                                                        4,
                                                        _this39.initPolygonNode(item)
                                                    ];
                                                case 1:
                                                    node = _state.sent();
                                                    console.log("push node");
                                                    _this39.modelNodes.push(node);
                                                    item.uuid = node[0].obj3D.uuid;
                                                    return [
                                                        2,
                                                        item
                                                    ];
                                                case 2:
                                                    return [
                                                        2,
                                                        item
                                                    ];
                                            }
                                        });
                                    });
                                    return function(item) {
                                        return _ref.apply(this, arguments);
                                    };
                                }());
                                return [
                                    4,
                                    Promise.all(promises)
                                ];
                            case 1:
                                polygons = _state.sent();
                                if (_this39.state.waitLoadingPolygons) {
                                    _this39.setState({
                                        gameStatus: components_types/* GameStatus.Started */.XI.Started
                                    });
                                }
                                if (!isEqual_default()(polygons, _this39.state.polygons)) {
                                    _this39.setState({
                                        polygons: polygons
                                    });
                                }
                                _this39.loadingQueue.dequeue();
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                err = _state.sent();
                                console.error(err);
                                _this39.loadingQueue.dequeue();
                                return [
                                    3,
                                    3
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                }));
                return [
                    2
                ];
            });
        });
        _this.showTeleportLoading = function(name) {
            _this.setState({
                showTeleportLoading: true,
                endTeleportName: name
            });
        };
        var _this40 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.handleTeleportClick = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(sweep) {
                var resumeAfter, setStep, ref, ref1, ref2, path, nextPoint, endTp;
                var _arguments = arguments;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            resumeAfter = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : false, setStep = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : function() {};
                            path = _this40.showCaseTemp.navigationManager.getAutonavigationPath();
                            path.some(function(point) {
                                _this40.teleportPoints.forEach(function(tp) {
                                    return tp.pointNodes.forEach(function(pn) {
                                        if (pn.sweep === point.data.id && pn.sweep !== sweep) {
                                            endTp = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, pn), {
                                                type: tp.type
                                            });
                                            nextPoint = point;
                                        }
                                    });
                                });
                                return !!endTp;
                            });
                            // this.teleportPoints.forEach(tp => tp.pointNodes.forEach((pn) => {
                            //   if(pn.sweep === nextPoint.data.id){
                            //     endTp = { ...pn, type: tp.type }
                            //   }
                            // }));
                            if (!endTp) return [
                                2
                            ];
                            _this40.setState({
                                showTeleportLoading: true,
                                endTeleportName: (endTp === null || endTp === void 0 ? void 0 : endTp.name) || "",
                                endTpType: (endTp === null || endTp === void 0 ? void 0 : endTp.type) || NavigationWrapper/* TeleportGroupType.Elevator */.A.Elevator
                            });
                            return [
                                4,
                                _this40.moveToSweep(nextPoint.data.sweepId, {
                                    x: 0,
                                    y: 0
                                }, "INSTANT")
                            ];
                        case 1:
                            _state.sent();
                            if (((ref = path[path.length - 1]) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.id) !== (nextPoint === null || nextPoint === void 0 ? void 0 : (ref2 = nextPoint.data) === null || ref2 === void 0 ? void 0 : ref2.id)) {
                                setTimeout(function() {
                                    _this40.showCaseTemp.navigationManager.rotateCameraToPathDirection();
                                    if (resumeAfter) {
                                        _this40.setActionPathNavbarPlayButtonType("Pause");
                                        _this40.showCaseTemp.navigationManager.autoNavigateCurrentPath(setStep, function() {}, function() {});
                                    }
                                }, 3000);
                            }
                            return [
                                2
                            ];
                    }
                });
            });
            return function(sweep) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this41 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.initNode = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
                var ref, ref1, ref2, enableCollider, res;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            enableCollider = ((ref = _this41.state.game) === null || ref === void 0 ? void 0 : (ref1 = ref.locks) === null || ref1 === void 0 ? void 0 : ref1.some(function(lock) {
                                return lock.locationType === Game/* LockLocationType.vsItem */.A.vsItem && lock.solution === data.id.toString();
                            })) || ((ref2 = _this41.state.flowsObjects) === null || ref2 === void 0 ? void 0 : ref2.some(function(obj) {
                                return obj.assetId === data.id;
                            }));
                            return [
                                4,
                                _this41.showCaseTemp.scene.create(dist/* SceneInitEventsTypes.Object */.PS.Object, data, undefined, enableCollider)
                            ];
                        case 1:
                            res = _state.sent();
                            return [
                                2,
                                res.length ? res : []
                            ];
                    }
                });
            });
            return function(data) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this42 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.initImageNode = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
                var res;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                _this42.showCaseTemp.scene.create(dist/* SceneInitEventsTypes.Image */.PS.Image, data)
                            ];
                        case 1:
                            res = _state.sent();
                            if (!res.length) {
                                return [
                                    2,
                                    []
                                ];
                            }
                            return [
                                2,
                                res
                            ];
                    }
                });
            });
            return function(data) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this43 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.initVideoNode = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
                var options, elementType, vimeoVideo, isValidVideoURL, updatedData, res, res1, videoNode;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            options = {
                                vimeoURL: "",
                                hideMuteButton: data.autoplay && data.hideMuteButton,
                                isDefaultMuted: data.hideMuteButton && data.isDefaultMuted,
                                autoplay: data.autoplay,
                                // end, mute, pause
                                onSoundStop: function() {
                                    // set timeout is important to give vsVideos in audioHandler time to update their state
                                    setTimeout(function() {
                                        if (!BaseTour_audioHandler.isTourMusicPaused() && BaseTour_audioHandler.allPlayingVideosAreMuted()) {
                                            BaseTour_audioHandler.playAudio({
                                                type: AudioModule/* MusicObj.TOUR */.nR.TOUR,
                                                id: _this43.state.tour.id
                                            }).then(function() {
                                                _this43.setState({
                                                    tourAudioPlaying: !BaseTour_audioHandler.isTourMusicPaused()
                                                });
                                            });
                                        }
                                    }, 100);
                                },
                                withButton: (0,_object_spread/* default */.Z)({
                                    mute: "/images/mute_icon.png",
                                    unMute: "/images/unmute_icon.png"
                                }, !data.autoplay && {
                                    play: "/images/play_icon.png",
                                    pause: "/images/pause_icon.png"
                                })
                            };
                            elementType = data.details.type;
                            if (!(elementType === VSObject/* VSVideoType.Vimeo */.OV.Vimeo && _this43.state.tour.clientId)) return [
                                3,
                                3
                            ];
                            vimeoVideo = new VimeoVideo(VimeoVideo.parseVideoId(data.getVideoURL()));
                            return [
                                4,
                                vimeoVideo.loadFromVideoId(_this43.state.tour.clientId)
                            ];
                        case 1:
                            _state.sent();
                            return [
                                4,
                                TreedisPublicDAO/* default.getVimeoVideoUrl */.Z.getVimeoVideoUrl(vimeoVideo.getFileURL())
                            ];
                        case 2:
                            options.vimeoURL = _state.sent();
                            return [
                                3,
                                5
                            ];
                        case 3:
                            return [
                                4,
                                file/* default.existFile */.Z.existFile("".concat("https://cdn.treedis.com").concat(data.details.url))
                            ];
                        case 4:
                            isValidVideoURL = _state.sent();
                            if (!isValidVideoURL && !options.vimeoURL) {
                                return [
                                    2,
                                    []
                                ];
                            }
                            _state.label = 5;
                        case 5:
                            if (!_this43.getValueOnWindowLocationObject("href").includes("m=mEMx41aqAaq")) return [
                                3,
                                7
                            ];
                            if (data.details.title === "Under curl bar reversed.mp4" || data.details.title === "Under curl bar.mp4") {
                                options.autoplay = true;
                                options.hideMuteButton = true;
                                options.isDefaultMuted = true;
                                data.autoplay = true;
                                data.hideMuteButton = true;
                                data.isDefaultMuted = true;
                            }
                            if (!(data.details.title === "Under curl bar reversed.mp4" || data.details.title === "Under curl bar.mp4" || data.details.title === "plates_early" || data.details.title === "plates_late" || data.details.title === "plates_ok")) return [
                                3,
                                7
                            ];
                            updatedData = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data), {
                                hasExternalController: true
                            });
                            return [
                                4,
                                _this43.showCaseTemp.scene.create(dist/* SceneInitEventsTypes.Video */.PS.Video, updatedData, options)
                            ];
                        case 6:
                            res = _state.sent();
                            if (!res.length || res.length === 1) {
                                return [
                                    2,
                                    []
                                ];
                            }
                            _state.label = 7;
                        case 7:
                            data.hideOnAnimationFinished = data.hideOnAnimationFinished;
                            return [
                                4,
                                _this43.showCaseTemp.scene.create(dist/* SceneInitEventsTypes.Video */.PS.Video, data, options)
                            ];
                        case 8:
                            res1 = _state.sent();
                            if (!res1.length || res1.length === 1) {
                                return [
                                    2,
                                    []
                                ];
                            }
                            videoNode = res1[1];
                            videoNode.video.volume = BaseTour_audioHandler.getVolume();
                            BaseTour_audioHandler.addMusicToVolumeControl(videoNode);
                            return [
                                2,
                                res1
                            ];
                    }
                });
            });
            return function(data) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this44 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.initVSHtmlNode = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
                var ref, isFlowsHtml, res;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            isFlowsHtml = (ref = _this44.state.flowsObjects) === null || ref === void 0 ? void 0 : ref.some(function(obj) {
                                return obj.assetId === data.id;
                            });
                            return [
                                4,
                                _this44.showCaseTemp.scene.create(dist/* SceneInitEventsTypes.HTML */.PS.HTML, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data), {
                                    isFlowsHtml: isFlowsHtml
                                }))
                            ];
                        case 1:
                            res = _state.sent();
                            if (!res.length || res.length === 1) {
                                return [
                                    2,
                                    []
                                ];
                            }
                            // On mobile, instead of interacting with HTML, open a popup with iframe
                            if (deviceManager/* default.isMobile */.Z.isMobile()) res[1].onEvent = function(type, eventData) {
                                if (type === Scene_component/* ComponentInteractionType.CLICK */.td.CLICK) {
                                    _this44.setState({
                                        vsHTMLPopup: {
                                            show: true,
                                            src: res[1].inputs.url
                                        }
                                    });
                                }
                            };
                            return [
                                2,
                                res
                            ];
                    }
                });
            });
            return function(data) {
                return _ref.apply(this, arguments);
            };
        }();
        _this.setVsHTMLPopupShow = function(show) {
            _this.setState({
                vsHTMLPopup: {
                    show: show,
                    src: _this.state.vsHTMLPopup.src
                }
            });
        };
        var _this45 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.initPolygonNode = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                _this45.showCaseTemp.scene.create(dist/* SceneInitEventsTypes.Polygon */.PS.Polygon, data)
                            ];
                        case 1:
                            return [
                                2,
                                _state.sent()
                            ];
                    }
                });
            });
            return function(data) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this46 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.initAvatarNode = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
                var avatar;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                _this46.showCaseTemp.scene.create(dist/* SceneInitEventsTypes.Avatar */.PS.Avatar, data, {
                                    host: _this46.state.host,
                                    withButton: {
                                        mute: "/images/mute_icon.png",
                                        unMute: "/images/unmute_icon.png"
                                    }
                                })
                            ];
                        case 1:
                            avatar = _state.sent();
                            avatar[1].inputs.bodyType = data.bodyType;
                            return [
                                2,
                                avatar
                            ];
                    }
                });
            });
            return function(data) {
                return _ref.apply(this, arguments);
            };
        }();
        _this.openNewTab = function(url) {
            var popupWindow = window.open(url);
            if (popupWindow === null || typeof popupWindow === "undefined") {
                // Some browsers have 'Block pop-up windows' set to true by default and in these cases we show a notification for the user to turn this setting off
                react_toastify_esm/* toast.info */.Am.info("Please allow pop-ups for this site in order to view this content");
            }
        };
        var _this47 = (0,_assert_this_initialized/* default */.Z)(_this);
        // Works for VS Images and VS Objects Action Types for now
        _this.handleVSAction = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(data, isObject) {
                var _tour, noAudioMode, tourId, flowAssetsToDisableAction, pauseAllMusic, stopTourMusic, assetType, disableActionForFlow, _, ref, ref1, ref2, ref3, ref4, ref5, clipAction, currentSID, targetSID, allSweeps, target, segments, slug, windowSegmants, windowId, tour, changeMinimap, menuData, ref6, menuData1;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _tour = _this47.state.tour, noAudioMode = _tour.noAudioMode, tourId = _tour.id;
                            flowAssetsToDisableAction = _this47.state.flowAssetsToDisableAction;
                            pauseAllMusic = BaseTour_audioHandler.pauseAllMusic, stopTourMusic = BaseTour_audioHandler.stopTourMusic;
                            assetType = (0,_instanceof/* default */.Z)(data, VSObject/* TourImage */.oP) ? "image" : "vsObject";
                            disableActionForFlow = !!(flowAssetsToDisableAction === null || flowAssetsToDisableAction === void 0 ? void 0 : flowAssetsToDisableAction.find(function(a) {
                                return a.asset === assetType && a.assetId === data.id;
                            }));
                            _ = data.actionType;
                            switch(_){
                                case VSObject/* TourActionType.IoT */.mI.IoT:
                                    return [
                                        3,
                                        1
                                    ];
                                case VSObject/* TourActionType.Tab */.mI.Tab:
                                    return [
                                        3,
                                        2
                                    ];
                                case VSObject/* TourActionType.Music */.mI.Music:
                                    return [
                                        3,
                                        3
                                    ];
                                case VSObject/* TourActionType.Video */.mI.Video:
                                    return [
                                        3,
                                        10
                                    ];
                                case VSObject/* TourActionType.NavigationPath */.mI.NavigationPath:
                                    return [
                                        3,
                                        14
                                    ];
                                case VSObject/* TourActionType.Treedis */.mI.Treedis:
                                    return [
                                        3,
                                        15
                                    ];
                                case VSObject/* TourActionType.Menu */.mI.Menu:
                                    return [
                                        3,
                                        18
                                    ];
                                case VSObject/* TourActionType.Panorama */.mI.Panorama:
                                    return [
                                        3,
                                        19
                                    ];
                                case VSObject/* TourActionType.ExperiencePopUp */.mI.ExperiencePopUp:
                                    return [
                                        3,
                                        20
                                    ];
                                case VSObject/* TourActionType.Matterport */.mI.Matterport:
                                    return [
                                        3,
                                        21
                                    ];
                                case VSObject/* TourActionType.MatterportInstant */.mI.MatterportInstant:
                                    return [
                                        3,
                                        22
                                    ];
                                case VSObject/* TourActionType.Flow */.mI.Flow:
                                    return [
                                        3,
                                        23
                                    ];
                            }
                            return [
                                3,
                                24
                            ];
                        case 1:
                            if (data.action === VSObject/* TourAction.Click */.b2.Click) {
                                _this47.updateIotState({
                                    lockDeviceId: data.id
                                });
                            }
                            return [
                                2
                            ];
                        case 2:
                            if (data.action === VSObject/* TourAction.Hover */.b2.Hover) {
                                _this47.openNewTab(data.actionURL);
                            } else if (data.action === VSObject/* TourAction.Click */.b2.Click) {
                                _this47.openNewTab(data.actionURL);
                            }
                            return [
                                2
                            ];
                        case 3:
                            if (noAudioMode && _this47.state.room || disableActionForFlow) return [
                                2
                            ];
                            if (data.action === VSObject/* TourAction.Hover */.b2.Hover) {
                                return [
                                    2
                                ];
                            }
                            if (!data.toursVSObjectId) return [
                                3,
                                7
                            ];
                            clipAction = (ref3 = (ref = _this47.showCaseTemp.scene) === null || ref === void 0 ? void 0 : (ref1 = ref.sceneObject) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.assets) === null || ref2 === void 0 ? void 0 : ref2.find(function(param) {
                                var _param = (0,_sliced_to_array/* default */.Z)(param, 2), assetKey = _param[0], node = _param[1];
                                return assetKey.id === data.toursVSObjectId;
                            })) === null || ref3 === void 0 ? void 0 : (ref4 = ref3[1]) === null || ref4 === void 0 ? void 0 : (ref5 = ref4[1]) === null || ref5 === void 0 ? void 0 : ref5.clipAction;
                            if (!clipAction) return [
                                3,
                                6
                            ];
                            if (!(clipAction.time === 0)) return [
                                3,
                                5
                            ];
                            return [
                                4,
                                BaseTour_audioHandler.playAudio({
                                    type: AudioModule/* MusicObj.VSIMAGES */.nR.VSIMAGES,
                                    id: data.id
                                })
                            ];
                        case 4:
                            _state.sent();
                            return [
                                3,
                                6
                            ];
                        case 5:
                            if (clipAction.paused) {
                                BaseTour_audioHandler.resumeAudio(data.id);
                            } else {
                                BaseTour_audioHandler.pauseAudio(data.id);
                            }
                            _state.label = 6;
                        case 6:
                            return [
                                3,
                                9
                            ];
                        case 7:
                            return [
                                4,
                                BaseTour_audioHandler.playAudio({
                                    type: AudioModule/* MusicObj.VSIMAGES */.nR.VSIMAGES,
                                    id: data.id
                                })
                            ];
                        case 8:
                            _state.sent();
                            _state.label = 9;
                        case 9:
                            return [
                                2
                            ];
                        case 10:
                            data.actionURL = (0,util_all/* getVideoLink */.rp)(data.actionURL, {
                                mute: noAudioMode && _this47.state.room
                            });
                            if (!(_this47.state.tourType === Tour/* TourType.Game */.v.Game)) return [
                                3,
                                12
                            ];
                            return [
                                4,
                                stopTourMusic
                            ];
                        case 11:
                            _state.sent();
                            return [
                                3,
                                13
                            ];
                        case 12:
                            pauseAllMusic();
                            _state.label = 13;
                        case 13:
                            return [
                                3,
                                24
                            ];
                        case 14:
                            currentSID = _this47.state.currentSweep.sid || _this47.state.currentSweep.sweep;
                            targetSID = (0,extractSweepIdFromURL/* extractSweepIdFromURL */.D)(data.actionURL);
                            if (!currentSID) {
                                react_toastify_esm/* toast.error */.Am.error("Current sweep not found");
                                return [
                                    2
                                ];
                            }
                            if (!targetSID) {
                                react_toastify_esm/* toast.error */.Am.error("Target sweep not found");
                                return [
                                    2
                                ];
                            }
                            if (_this47.showCaseTemp.navigationManager) {
                                if (_this47.showCaseTemp.navigationManager.targetSID !== targetSID) {
                                    allSweeps = Array.from(_this47.state.allSweeps, function(param) {
                                        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), value = _param[1];
                                        return value;
                                    });
                                    target = allSweeps === null || allSweeps === void 0 ? void 0 : allSweeps.find(function(item) {
                                        return item.sweep_uuid === targetSID || item.sweepId === targetSID;
                                    });
                                    // TODO test changes
                                    _this47.showCaseTemp.navigationManager.renderPath(currentSID, target === null || target === void 0 ? void 0 : target.id);
                                } else {
                                    _this47.showCaseTemp.navigationManager.reset();
                                }
                            }
                            return [
                                3,
                                24
                            ];
                        case 15:
                            segments = data.actionURL.split("/");
                            slug = segments[segments.length - 1].split("?")[0];
                            windowSegmants = window.location.href.split("/");
                            windowId = windowSegmants[windowSegmants.length - 1].split("?")[0];
                            if (!(window.top !== window.self)) return [
                                3,
                                17
                            ];
                            window.top.postMessage({
                                type: "tourLink",
                                url: data.actionURL
                            }, "*");
                            // so the parent window can handle the link
                            return [
                                4,
                                new Promise(function(resolve) {
                                    return setTimeout(resolve, 100);
                                })
                            ];
                        case 16:
                            _state.sent();
                            _state.label = 17;
                        case 17:
                            if (slug !== windowId && window.location.href.includes("/experience/")) {
                                window.location.href = data.actionURL;
                                return [
                                    2
                                ];
                            }
                            if ((0,util_all/* getQueryVariable */.Dv)(data.actionURL, "m")) {
                                react_toastify_esm/* toast.error */.Am.error("Cannot use this link. To copy location in the tour, please use 'CTRL+Y'");
                                return [
                                    2
                                ];
                            }
                            tour = _this47.state.tour;
                            changeMinimap = tour && !tour.customMinimap;
                            _this47.setState({
                                panoramaOn: false,
                                activePano: null
                            }, function() {
                                // false = dont change the menu/panorama
                                _this47.getTour({
                                    slug: slug,
                                    changeMenu: false,
                                    changeMinimap: changeMinimap,
                                    changePanorama: false,
                                    url: data.actionURL,
                                    hideIntroScreen: true
                                });
                            });
                            return [
                                2
                            ];
                        case 18:
                            menuData = data; // This case is only for TourImage
                            _this47.setState({
                                menuOpen: false,
                                activeMenu: null
                            }, function() {
                                _this47.setState({
                                    menuOpen: true,
                                    menuOpened: true,
                                    activeMenu: {
                                        menuId: menuData.menuId,
                                        subMenuId: menuData.subMenuId,
                                        subSubMenuId: menuData.subSubMenuId
                                    }
                                });
                            });
                            return [
                                2
                            ];
                        case 19:
                            _this47.setState({
                                activePano: data.panoramaId,
                                panoramaOn: true
                            });
                            return [
                                2
                            ];
                        case 20:
                            {
                                ;
                                menuData1 = data; // This case is only for TourImage
                                BaseTour_audioHandler.pauseAllMusic();
                                _this47.setState({
                                    experiencePopUpIsOpen: true,
                                    closedElementPopup: false,
                                    experiencePopUpData: {
                                        title: menuData1.popupTitle,
                                        url: menuData1.actionURL,
                                        description: menuData1.text,
                                        defaultImageUrl: menuData1 === null || menuData1 === void 0 ? void 0 : (ref6 = menuData1.details) === null || ref6 === void 0 ? void 0 : ref6.url,
                                        prefixImageUrl: "/tours/".concat(tourId, "/vsimages/"),
                                        rotation: menuData1.rotation,
                                        backgroundColor: menuData1.backgroundColor,
                                        backgroundOpacity: menuData1.backgroundOpacity,
                                        textColor: menuData1.textColor,
                                        buttonColor: menuData1.buttonColor
                                    }
                                });
                                return [
                                    2
                                ];
                            }
                            _state.label = 21;
                        case 21:
                            {
                                _this47.setState({
                                    isChangeIframe: _this47.state.iframeUrl.matterId !== (0,util_all/* getQueryVariable */.Dv)(data.actionURL, "m")
                                }, function() {
                                    var ref, ref1;
                                    _this47.moveModel("/mp-sdk/".concat("24.11.2", "/showcase.html?applicationKey=").concat((ref = _this47.state.tour) === null || ref === void 0 ? void 0 : (ref1 = ref.user) === null || ref1 === void 0 ? void 0 : ref1.mpSDK).concat(util_all/* getAllQueryVariables */.i1(data.actionURL)), false, false);
                                });
                                return [
                                    2
                                ];
                            }
                            _state.label = 22;
                        case 22:
                            {
                                _this47.setState({
                                    isChangeIframe: _this47.state.iframeUrl.matterId !== (0,util_all/* getQueryVariable */.Dv)(data.actionURL, "m")
                                }, function() {
                                    var ref, ref1;
                                    _this47.moveModel("/mp-sdk/".concat("24.11.2", "/showcase.html?applicationKey=").concat((ref = _this47.state.tour) === null || ref === void 0 ? void 0 : (ref1 = ref.user) === null || ref1 === void 0 ? void 0 : ref1.mpSDK).concat(util_all/* getAllQueryVariables */.i1(data.actionURL)), false, true);
                                });
                                return [
                                    2
                                ];
                            }
                            _state.label = 23;
                        case 23:
                            {
                                _this47.setState({
                                    startFlowFromAsset: data.flowId
                                });
                                return [
                                    2
                                ];
                            }
                            _state.label = 24;
                        case 24:
                            if (data.actionType !== VSObject/* TourActionType.NavigationPath */.mI.NavigationPath) _this47.setState({
                                vsActionPopOn: true,
                                openedVSAction: data,
                                closedElementPopup: false
                            });
                            return [
                                2
                            ];
                    }
                });
            });
            return function(data, isObject) {
                return _ref.apply(this, arguments);
            };
        }();
        _this.emitVSChangesFromHost = function(param) {
            var data = param.data, eventData = param.eventData, type = param.type;
            var _state = _this.state, showcaseLoaded = _state.showcaseLoaded, room = _state.room, host = _state.host;
            if (showcaseLoaded && room && socket/* default */.Z && socket/* default.connected */.Z.connected && host && _this.pose.mode === _this.showcase.Mode.Mode.INSIDE) {
                var key = data.vsImageId ? "vsImageId" : data.vsVideoId ? "vsVideoId" : data.vsObjectId ? "vsObjectId" : "";
                if (!key) return;
                var _obj;
                socket/* default.emit */.Z.emit("vs", (_obj = {}, (0,_define_property/* default */.Z)(_obj, key, data.id), (0,_define_property/* default */.Z)(_obj, "eventData", eventData), (0,_define_property/* default */.Z)(_obj, "type", type), _obj));
            }
        };
        _this.emitPolygonChangesFromHost = function(param) {
            var type = param.type, assetId = param.assetId, eventData = param.eventData;
            var _state = _this.state, showcaseLoaded = _state.showcaseLoaded, room = _state.room, host = _state.host;
            if (showcaseLoaded && room && socket/* default */.Z && socket/* default.connected */.Z.connected && host && _this.pose.mode === _this.showcase.Mode.Mode.INSIDE) {
                socket/* default.emit */.Z.emit("polygon", {
                    type: type,
                    assetId: assetId,
                    eventData: eventData
                });
            }
        };
        _this.emitTagChangesFromHost = function(tag, action) {
            var _state = _this.state, showcaseLoaded = _state.showcaseLoaded, room = _state.room, host = _state.host;
            if (tag && showcaseLoaded && room && socket/* default */.Z && socket/* default.connected */.Z.connected && host && _this.pose.mode === _this.showcase.Mode.Mode.INSIDE) {
                if (action === "hover") {
                    socket/* default.emit */.Z.emit("tag_hover", {
                        tag: {
                            sid: tag.defaultSid || tag.sid,
                            action: action
                        }
                    });
                } else if (action === "click") {
                    socket/* default.emit */.Z.emit("tag_click", {
                        tag: {
                            sid: tag.defaultSid || tag.sid,
                            action: action
                        }
                    });
                }
                if (tag.embedMedia) {
                    var watchTagContentElem = _this.getShowcaseElement(components_types/* ShowcaseElement.TagEmbedMedia */.o2.TagEmbedMedia);
                    (0,util/* closeTagEmbedTagObserver */.hH)(watchTagContentElem, function() {
                        socket/* default.emit */.Z.emit("close-embed-tag");
                    });
                }
            }
        };
        var _this48 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.handlePolygonAction = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
                var _state, tour, flowAssetsToDisableAction, polygons, noAudioMode, disableActionForFlow, _, segments, slug, windowSegmants, windowId, tour1, changeMinimap, ref, ref1, ref2, ref3, ref4;
                return (0,tslib_es6.__generator)(this, function(_state1) {
                    switch(_state1.label){
                        case 0:
                            _state = _this48.state, tour = _state.tour, flowAssetsToDisableAction = _state.flowAssetsToDisableAction, polygons = _state.polygons;
                            noAudioMode = tour.noAudioMode;
                            disableActionForFlow = !!(flowAssetsToDisableAction === null || flowAssetsToDisableAction === void 0 ? void 0 : flowAssetsToDisableAction.find(function(a) {
                                return a.asset === "polygon" && (polygons === null || polygons === void 0 ? void 0 : polygons.find(function(p) {
                                    return p.id === a.assetId;
                                }));
                            }));
                            if (disableActionForFlow) {
                                return [
                                    2
                                ];
                            }
                            _ = data.type;
                            switch(_){
                                case Polygon/* PolygonActionType.Tab */.zS.Tab:
                                    return [
                                        3,
                                        1
                                    ];
                                case Polygon/* PolygonActionType.Music */.zS.Music:
                                    return [
                                        3,
                                        2
                                    ];
                                case Polygon/* PolygonActionType.Video */.zS.Video:
                                    return [
                                        3,
                                        4
                                    ];
                                case Polygon/* PolygonActionType.Treedis */.zS.Treedis:
                                    return [
                                        3,
                                        5
                                    ];
                                case Polygon/* PolygonActionType.Menu */.zS.Menu:
                                    return [
                                        3,
                                        8
                                    ];
                                case Polygon/* PolygonActionType.Panorama */.zS.Panorama:
                                    return [
                                        3,
                                        9
                                    ];
                                case Polygon/* PolygonActionType.Matterport */.zS.Matterport:
                                    return [
                                        3,
                                        10
                                    ];
                                case Polygon/* PolygonActionType.MatterportInstant */.zS.MatterportInstant:
                                    return [
                                        3,
                                        11
                                    ];
                                case Polygon/* PolygonActionType.ExperiencePopUp */.zS.ExperiencePopUp:
                                    return [
                                        3,
                                        12
                                    ];
                                case Polygon/* PolygonActionType.Flow */.zS.Flow:
                                    return [
                                        3,
                                        13
                                    ];
                            }
                            return [
                                3,
                                14
                            ];
                        case 1:
                            if (data.action !== Polygon/* PolygonActionAction.Hover */.IW.Hover) {
                                _this48.openNewTab(data.url);
                            }
                            return [
                                2
                            ];
                        case 2:
                            if (noAudioMode && _this48.state.room) return [
                                2
                            ];
                            if (data.action === Polygon/* PolygonActionAction.Hover */.IW.Hover) {
                                return [
                                    2
                                ];
                            }
                            return [
                                4,
                                BaseTour_audioHandler.playAudio({
                                    type: AudioModule/* MusicObj.POLYGONS */.nR.POLYGONS,
                                    id: data.id
                                })
                            ];
                        case 3:
                            _state1.sent();
                            return [
                                2
                            ];
                        case 4:
                            data.url = (0,util_all/* getVideoLink */.rp)(data.url, {
                                mute: noAudioMode && _this48.state.room,
                                autoplay: data.autoPlay ? 1 : 0
                            });
                            BaseTour_audioHandler.pauseAllMusic();
                            return [
                                3,
                                14
                            ];
                        case 5:
                            segments = data.url.split("/");
                            slug = segments[segments.length - 1].split("?")[0];
                            windowSegmants = window.location.href.split("/");
                            windowId = windowSegmants[windowSegmants.length - 1].split("?")[0];
                            if (!(window.top !== window.self)) return [
                                3,
                                7
                            ];
                            window.top.postMessage({
                                type: "tourLink",
                                url: data.url
                            }, "*");
                            // so the parent window can handle the link
                            return [
                                4,
                                new Promise(function(resolve) {
                                    return setTimeout(resolve, 100);
                                })
                            ];
                        case 6:
                            _state1.sent();
                            _state1.label = 7;
                        case 7:
                            // if current tour is experience and moving to a different tour, we should change the whole location to release some memory
                            if (slug !== windowId && window.location.href.includes("/experience/")) {
                                window.location.href = data.url;
                                return [
                                    2
                                ];
                            }
                            if ((0,util_all/* getQueryVariable */.Dv)(data.url, "m")) {
                                react_toastify_esm/* toast.error */.Am.error("Cannot use this link. To copy location in the tour, please use 'CTRL+Y'");
                                return [
                                    2
                                ];
                            }
                            tour1 = _this48.state.tour;
                            changeMinimap = tour1 && !tour1.customMinimap;
                            _this48.setState({
                                panoramaOn: false,
                                activePano: null
                            }, function() {
                                // false = dont change the menu/panorama
                                _this48.getTour({
                                    slug: slug,
                                    changeMenu: false,
                                    changeMinimap: changeMinimap,
                                    changePanorama: false,
                                    url: data.url,
                                    hideIntroScreen: true
                                });
                            });
                            return [
                                2
                            ];
                        case 8:
                            _this48.setState({
                                menuOpen: false,
                                activeMenu: {
                                    menuId: null,
                                    subMenuId: null,
                                    subSubMenuId: null
                                }
                            }, function() {
                                _this48.setState({
                                    menuOpen: true,
                                    menuOpened: true,
                                    activeMenu: {
                                        menuId: data.menuId,
                                        subMenuId: data.subMenuId,
                                        subSubMenuId: data.subSubMenuId
                                    }
                                });
                            });
                            return [
                                2
                            ];
                        case 9:
                            _this48.setState({
                                activePano: data.panoramaId,
                                panoramaOn: true
                            });
                            return [
                                2
                            ];
                        case 10:
                            _this48.moveModel("/mp-sdk/".concat("24.11.2", "/showcase.html?applicationKey=").concat((ref = _this48.state.tour) === null || ref === void 0 ? void 0 : (ref1 = ref.user) === null || ref1 === void 0 ? void 0 : ref1.mpSDK).concat(util_all/* getAllQueryVariables */.i1(data.url)), false, false);
                            return [
                                2
                            ];
                        case 11:
                            _this48.moveModel("/mp-sdk/".concat("24.11.2", "/showcase.html?applicationKey=").concat((ref2 = _this48.state.tour) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.user) === null || ref3 === void 0 ? void 0 : ref3.mpSDK).concat(util_all/* getAllQueryVariables */.i1(data.url)), false, true);
                            return [
                                2
                            ];
                        case 12:
                            _this48.setState({
                                experiencePopUpIsOpen: true,
                                closedElementPopup: false,
                                experiencePopUpData: {
                                    title: data.popupTitle,
                                    url: data.actionURL,
                                    description: data.text,
                                    defaultImageUrl: "",
                                    prefixImageUrl: "/tours/".concat((ref4 = _this48.state.tour) === null || ref4 === void 0 ? void 0 : ref4.id, "/polygons/"),
                                    rotation: data.rotation,
                                    backgroundColor: data.backgroundColor,
                                    backgroundOpacity: data.backgroundOpacity,
                                    textColor: data.textColor,
                                    buttonColor: data.buttonColor
                                }
                            });
                            return [
                                2
                            ];
                        case 13:
                            _this48.setState({
                                startFlowFromAsset: data.flowId
                            });
                            return [
                                2
                            ];
                        case 14:
                            _this48.setState({
                                vsActionPopOn: true,
                                closedElementPopup: false,
                                openedVSAction: new Polygon/* PolygonAction */.fD(data)
                            });
                            return [
                                2
                            ];
                    }
                });
            });
            return function(data) {
                return _ref.apply(this, arguments);
            };
        }();
        _this.updateSweepLoc = function(nextSweep) {
            _this.ticketUpdateSweepLoc(nextSweep.sid);
            // if (this.pose?.mode && this.pose?.mode !== this.showCaseTemp.showcase.Mode.Mode.INSIDE) return;
            var _state = _this.state, tour = _state.tour, sweepGroups = _state.sweepGroups;
            (0,analytic/* sendToGA */.o$)("event", {
                eventCategory: "Sweep",
                eventAction: "move",
                eventLabel: nextSweep.sid
            });
            var activeSweepGroup = null;
            sweepGroups.forEach(function(group, i) {
                var ref;
                (ref = group.sweeps) === null || ref === void 0 ? void 0 : ref.forEach(function(sweep) {
                    if (sweep.uuid === nextSweep.sid) {
                        activeSweepGroup = group.id;
                    }
                });
            });
            _this.setState({
                activeSweepGroup: activeSweepGroup
            }, function() {
                _this.filterTags();
                _this.filterPolygon();
            });
            if (tour.minimap) {
                var ref;
                // find nextSweep in this.state.sweeps, so we can use the old sweep.sweep_uuid which is not included anymore on SDK Sweeps..
                var nextSweepObj = (ref = _this.state.sweeps) === null || ref === void 0 ? void 0 : ref.find(function(sweep) {
                    return sweep.id === nextSweep.sid || sweep.sweep_uuid === nextSweep.sid;
                });
                var loc = _this.calculateLocation(nextSweepObj || nextSweep);
                if (!loc) return;
                _this.setState({
                    mapWalkerX: loc.px,
                    mapWalkerY: loc.py,
                    minimaps: loc.minimaps
                });
            }
        };
        _this.markMinimap = function(p) {
            var _state = _this.state, minimaps = _state.minimaps, selectedMinimap = _state.selectedMinimap;
            if (!minimaps || minimaps.length === 0 || selectedMinimap === null) return;
            minimaps[selectedMinimap].hotspots.forEach(function(h) {
                if (h.type === "panorama" && h.panoramaId === p.id) {
                    _this.setState({
                        mapWalkerX: h.x,
                        mapWalkerY: h.y,
                        activePano: null
                    });
                }
            });
        };
        _this.isTourReadyForAudio = function() {
            var _state = _this.state, showIntro = _state.showIntro, startScreenOn = _state.startScreenOn, gameStatus = _state.gameStatus, _$tourType = _state.tourType, avatar = _state.avatar, tour = _state.tour, showcaseLoaded = _state.showcaseLoaded, room = _state.room;
            var isReady = !(!showcaseLoaded || // video tour, before avatar select
            room && (tour === null || tour === void 0 ? void 0 : tour.enableAvatar) && !(avatar === null || avatar === void 0 ? void 0 : avatar.imageUrl) || // regular tour, before avatar select
            !room && (tour === null || tour === void 0 ? void 0 : tour.enableAvatar) && !(avatar === null || avatar === void 0 ? void 0 : avatar.url) || showIntro || startScreenOn || _$tourType === Tour/* TourType.Game */.v.Game && gameStatus === components_types/* GameStatus.NotStarted */.XI.NotStarted);
            return isReady;
        };
        var _this49 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.playTourAudio = /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            var ignoreTimeout, videoPlaying, isTourMusicPaused;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        ignoreTimeout = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : false;
                        videoPlaying = _this49.state.videoPlaying;
                        isTourMusicPaused = BaseTour_audioHandler.isTourMusicPaused;
                        if (!ignoreTimeout && _this49.playAudioTimeout) return [
                            2
                        ];
                        _this49.playAudioTimeout = null;
                        if (videoPlaying) {
                            return [
                                2
                            ];
                        }
                        if (!_this49.isTourReadyForAudio()) {
                            _this49.mainContainerWaitingForPlay = true;
                            _this49.playAudioTimeout = setTimeout(function() {
                                return _this49.playTourAudio(true).catch(function() {});
                            }, 500);
                            return [
                                2,
                                _this49.playAudioTimeout
                            ];
                        }
                        if (!isTourMusicPaused()) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            _this49.handleToggleMusic()
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        _this49.mainContainerWaitingForPlay = false;
                        return [
                            2
                        ];
                }
            });
        });
        var _this50 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.moveToSweep = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(s, rotation) {
                var transition, changeUrl, ref, ref1, sweep, ref2, sweepId;
                var _arguments = arguments;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    transition = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : "INSTANT", changeUrl = _arguments.length > 3 && _arguments[3] !== void 0 ? _arguments[3] : true;
                    sweep = (ref = _this50.state) === null || ref === void 0 ? void 0 : (ref1 = ref.sweeps) === null || ref1 === void 0 ? void 0 : ref1.find(function(sweep) {
                        return sweep.id === s || sweep.sweep_uuid === s;
                    });
                    if (!sweep) {
                        ;
                        console.trace();
                        console.error("Sweep not found in  list: ", s, (ref2 = _this50.state) === null || ref2 === void 0 ? void 0 : ref2.sweeps);
                    }
                    sweepId = (sweep === null || sweep === void 0 ? void 0 : sweep.id) || s;
                    if (_this50.showCaseTemp) {
                        return [
                            2,
                            _this50.showCaseTemp.showcase.Sweep.moveTo(sweepId, {
                                rotation: rotation,
                                transition: _this50.showCaseTemp.showcase.Sweep.Transition[transition]
                            }).then(function() {
                                if (base/* asyncStore.vrIsOn */.k6.vrIsOn) {
                                    if (!_this50.SceneVRCameraController) {
                                        console.error("Error: SceneVRCameraController not initialized");
                                        return;
                                    }
                                    var targetSweep = _this50.state.sweeps.find(function(sweep) {
                                        return sweep.uuid === sweepId || sweep.id === sweepId || sweep.sid === sweepId;
                                    });
                                    _this50.SceneVRCameraController.rotateVRViewByCameraRotation(targetSweep, rotation);
                                }
                                if (_this50.state.tourType !== Tour/* TourType.Game */.v.Game && _this50.state.tourType !== Tour/* TourType.Kiosk */.v.Kiosk && !_this50.state.tour.navigationWebEnabled && changeUrl) {
                                    window.history.replaceState(null, "", _this50.buildLink(sweepId, rotation));
                                }
                            }).catch(function(err) {
                                console.error(err.toString());
                            })
                        ];
                    }
                    react_toastify_esm/* toast.error */.Am.error("Wait for the model to load");
                    return [
                        2
                    ];
                });
            });
            return function(s, rotation) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this51 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.moveToStep = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(step) {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!_this51.showCaseTemp) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                _this51.showCaseTemp.showcase.Tour.step(step).catch(function(err) {
                                    console.error(err.toString());
                                })
                            ];
                        case 1:
                            _state.sent();
                            return [
                                3,
                                3
                            ];
                        case 2:
                            react_toastify_esm/* toast.error */.Am.error("Wait for the model to load");
                            _state.label = 3;
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(step) {
                return _ref.apply(this, arguments);
            };
        }();
        _this.closeMenu = function() {
            _this.setState({
                menuOpen: false
            });
        };
        _this.openMenu = function() {
            _this.setState({
                menuOpen: true
            });
        };
        _this.loadModelMenu = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            _this.setState({
                lastTagHovered: null,
                activeMenu: null
            }, function() {
                _this.loadModel.apply(_this, (0,_to_consumable_array/* default */.Z)(args));
            });
        };
        _this.changeWidthMenu = function(width) {
            _this.setState({
                menuWidth: width
            });
        };
        _this.handleLockMenu = function(d) {
            _this.updateIotState({
                lockDeviceId: d.id
            });
        };
        _this.handleMoveToLockMenu = function(d) {
            _this.updateIotState({
                moveToDevice: d
            });
        };
        _this.handleOpenCameraMenu = function(param) {
            var openCamera = param.openCamera, multiCams = param.multiCams;
            _this.updateIotState({
                openCamera: openCamera || null,
                openFavouriteCameras: multiCams || null
            });
            _this.setIotModalOpen(true, false);
            _this.setState({
                menuOpen: false
            });
        };
        var _this52 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.stopPolygons = /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            var polygons, _, _tmp, e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        polygons = _this52.state.polygons;
                        _ = _this52.setState;
                        _tmp = {};
                        return [
                            4,
                            Promise.all(polygons.map(function() {
                                var _ref = (0,_async_to_generator/* default */.Z)(function(item) {
                                    var nodeIndex;
                                    return (0,tslib_es6.__generator)(this, function(_state) {
                                        if (!item.active) return [
                                            2,
                                            item
                                        ];
                                        nodeIndex = _this52.modelNodes.findIndex(function(node) {
                                            var ref, ref1;
                                            return ((ref = node[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.obj3D) === null || ref1 === void 0 ? void 0 : ref1.uuid) === item.uuid;
                                        });
                                        if (nodeIndex >= 0) {
                                            _this52.modelNodes[nodeIndex][0].stop();
                                            item.uuid = null;
                                            _this52.modelNodes.splice(nodeIndex, 1);
                                        }
                                        return [
                                            2,
                                            item
                                        ];
                                    });
                                });
                                return function(item) {
                                    return _ref.apply(this, arguments);
                                };
                            }()))
                        ];
                    case 1:
                        _.apply(_this52, [
                            (_tmp.polygons = _state.sent(), _tmp)
                        ]);
                        return [
                            3,
                            3
                        ];
                    case 2:
                        e = _state.sent();
                        console.error(e);
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        var _this53 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.renderPolygons = /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            var polygons, e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        polygons = _this53.state.polygons;
                        return [
                            4,
                            Promise.all(polygons.map(function() {
                                var _ref = (0,_async_to_generator/* default */.Z)(function(item) {
                                    var node, nodeIndex;
                                    return (0,tslib_es6.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                if (item.hiddenFromFlows) return [
                                                    2
                                                ];
                                                if (!!_this53.polygonHiddenByPathLock(item)) return [
                                                    3,
                                                    4
                                                ];
                                                if (!item.active) return [
                                                    3,
                                                    3
                                                ];
                                                if (!!item.uuid) return [
                                                    3,
                                                    2
                                                ];
                                                return [
                                                    4,
                                                    _this53.initPolygonNode(item)
                                                ];
                                            case 1:
                                                node = _state.sent();
                                                _this53.modelNodes.push(node);
                                                item.uuid = node[0].obj3D.uuid;
                                                return [
                                                    2,
                                                    item
                                                ];
                                            case 2:
                                                return [
                                                    3,
                                                    4
                                                ];
                                            case 3:
                                                nodeIndex = _this53.modelNodes.findIndex(function(node) {
                                                    var ref, ref1;
                                                    return ((ref = node[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.obj3D) === null || ref1 === void 0 ? void 0 : ref1.uuid) === item.uuid;
                                                });
                                                if (nodeIndex >= 0) {
                                                    _this53.modelNodes[nodeIndex][0].stop();
                                                    item.uuid = null;
                                                    _this53.modelNodes.splice(nodeIndex, 1);
                                                }
                                                _state.label = 4;
                                            case 4:
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                });
                                return function(item) {
                                    return _ref.apply(this, arguments);
                                };
                            }()))
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        e = _state.sent();
                        console.error(e);
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        var _this54 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.toggleVS = /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            var ref, _state, isVSEnabled, isVSVisible;
            return (0,tslib_es6.__generator)(this, function(_state1) {
                if (!((ref = _this54.vsObjects) === null || ref === void 0 ? void 0 : ref.length)) {
                    react_toastify_esm/* toast.error */.Am.error("There is no vsObjects to hide");
                    return [
                        2
                    ];
                }
                _state = _this54.state, isVSEnabled = _state.isVSEnabled, isVSVisible = _state.isVSVisible;
                _this54.setState({
                    isVSEnabled: !isVSEnabled,
                    isVSVisible: !isVSVisible
                }, /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(isVSEnabled && isVSVisible)) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    _this54.stopVS()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    _this54.stopPolygons()
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    3,
                                    6
                                ];
                            case 3:
                                return [
                                    4,
                                    _this54.initVS()
                                ];
                            case 4:
                                _state.sent();
                                return [
                                    4,
                                    _this54.initPolygons()
                                ];
                            case 5:
                                _state.sent();
                                _state.label = 6;
                            case 6:
                                return [
                                    2
                                ];
                        }
                    });
                }));
                return [
                    2
                ];
            });
        });
        var _this55 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.resumeTourMusic = /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!_this55.isTourReadyForAudio()) return [
                            2
                        ];
                        if (!BaseTour_audioHandler.isTourMusicPaused()) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            _this55.handleToggleMusic()
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        });
        _this.openVR = function() {
            var vrOverlay = _this.getShowcaseElement(components_types/* ShowcaseElement.VRLayer */.o2.VRLayer);
            var iframeVrButton = vrOverlay.querySelector('[role="button"]');
            iframeVrButton.click();
        };
        var _this56 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.handleTogglePano = /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            var _state, panoramaOn, showcaseLoaded, room, host, tourPlaying, data;
            return (0,tslib_es6.__generator)(this, function(_state1) {
                switch(_state1.label){
                    case 0:
                        _state = _this56.state, panoramaOn = _state.panoramaOn, showcaseLoaded = _state.showcaseLoaded, room = _state.room, host = _state.host, tourPlaying = _state.tourPlaying;
                        if (!(!panoramaOn && tourPlaying)) return [
                            3,
                            2
                        ];
                        // We pause the tour if the user wants the pano
                        return [
                            4,
                            _this56.showCaseTemp.showcase.Tour.stop()
                        ];
                    case 1:
                        _state1.sent();
                        _state1.label = 2;
                    case 2:
                        data = {
                            interacted: true,
                            panoramaOn: !panoramaOn,
                            activePano: panoramaOn ? null : _this56.state.activePano
                        };
                        if (showcaseLoaded && room && socket/* default */.Z && socket/* default.connected */.Z.connected && host) {
                            socket/* default.emit */.Z.emit("toggle-pano", data);
                        }
                        if (!_this56.state.lock) {
                            _this56.setState(data);
                        }
                        return [
                            2
                        ];
                }
            });
        });
        _this.getShareLocation = function() {
            var location = sdk/* getLocation.call */.k$.call((0,_assert_this_initialized/* default */.Z)(_this));
            var _state = _this.state, panoramaOn = _state.panoramaOn, panoramas = _state.panoramas;
            if (panoramaOn && (panoramas === null || panoramas === void 0 ? void 0 : panoramas.length) > 0 && _this.currentPanorama) {
                var pano = "pano=".concat(_this.currentPanorama.id);
                var panoPitch = "panoPitch=".concat(_this.panoPose.pitch);
                var panoYaw = "panoYaw=".concat(_this.panoPose.yaw);
                var panoHfov = "panoHfov=".concat(_this.panoPose.hfov);
                var query = "".concat(pano, "&").concat(panoPitch, "&").concat(panoYaw, "&").concat(panoHfov);
                if (location.split("?")[1]) {
                    location += "&".concat(query);
                } else {
                    location += "?".concat(query);
                }
            }
            return location;
        };
        _this.updatePanoRotation = function(north, pos, scene) {
            var _state = _this.state, room = _state.room, host = _state.host, lock = _state.lock, panoramas = _state.panoramas;
            if (room && socket/* default */.Z && socket/* default.connected */.Z.connected) {
                if (host) {
                    var pano = panoramas.find(function(p) {
                        return p.name === scene;
                    });
                    if ((pano === null || pano === void 0 ? void 0 : pano.id) === _this.currentPanorama.id) {
                        socket/* default.emit */.Z.emit("move-pano", {
                            panoPose: pos,
                            currentPanorama: _this.currentPanorama
                        });
                    }
                    util_all/* updatePanoRotation.call */.k.call((0,_assert_this_initialized/* default */.Z)(_this), north, pos);
                } else if (!lock) {
                    util_all/* updatePanoRotation.call */.k.call((0,_assert_this_initialized/* default */.Z)(_this), north, pos);
                }
            } else {
                util_all/* updatePanoRotation.call */.k.call((0,_assert_this_initialized/* default */.Z)(_this), north, pos);
            }
        };
        _this.handlePanoSceneChange = function(scene) {
            _this.currentPanorama = scene;
            var _state = _this.state, room = _state.room, showcaseLoaded = _state.showcaseLoaded, host = _state.host;
            if (showcaseLoaded && room && socket/* default */.Z && socket/* default.connected */.Z.connected && host) {
                socket/* default.emit */.Z.emit("move-pano", {
                    panoPose: {
                        pitch: 0,
                        yaw: 0,
                        hfov: 100
                    },
                    currentPanorama: scene
                });
            }
        };
        _this.handleGameStartOnIntroModal = function(username) {
            _this.handleGameStart(username, true);
        };
        var _this57 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.addAvatar = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
                var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, myX, myZ, ref21, x, z, json, modelId, response;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            ref20 = (0,_sliced_to_array/* default */.Z)(pointsOnCircle2D(virtualStaging_avatar/* AVATAR_CIRCLE_RADIUS */.iG, 180 + _this57.avatarDegree, data === null || data === void 0 ? void 0 : (ref = data.pose) === null || ref === void 0 ? void 0 : (ref1 = ref.position) === null || ref1 === void 0 ? void 0 : ref1.x, data === null || data === void 0 ? void 0 : (ref2 = data.pose) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.position) === null || ref3 === void 0 ? void 0 : ref3.z), 2), myX = ref20[0], myZ = ref20[1];
                            ref21 = (0,_sliced_to_array/* default */.Z)(pointsOnCircle2D(virtualStaging_avatar/* AVATAR_CIRCLE_RADIUS */.iG, data.degree, myX, myZ), 2), x = ref21[0], z = ref21[1];
                            if (!(data.avatarUrl && !data.avatarUrl.includes("base64"))) return [
                                3,
                                3
                            ];
                            modelId = getRPMModelId(data.avatarUrl);
                            return [
                                4,
                                fetch("https://models.readyplayer.me/".concat(modelId, ".json"))
                            ];
                        case 1:
                            response = _state.sent();
                            return [
                                4,
                                response.json()
                            ];
                        case 2:
                            json = _state.sent();
                            _state.label = 3;
                        case 3:
                            return [
                                4,
                                _this57.onAddAvatar(new virtualStaging_avatar/* Avatar */.qE({
                                    uuid: data.avatarId,
                                    bodyType: (json === null || json === void 0 ? void 0 : json.bodyType) || "image",
                                    name: data === null || data === void 0 ? void 0 : data.name,
                                    url: data.avatarUrl || null,
                                    positionX: _this57.defaultSweep && _this57.defaultSweep.sid === _this57.state.currentSweep.sid ? x : _this57.defaultSweep.position.x,
                                    positionY: (ref4 = data.pose) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.position) === null || ref5 === void 0 ? void 0 : ref5.y,
                                    positionZ: _this57.defaultSweep && _this57.defaultSweep.sid === _this57.state.currentSweep.sid ? z : _this57.defaultSweep.position.z,
                                    rotationX: (ref6 = data.pose) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.rotation) === null || ref7 === void 0 ? void 0 : ref7._x,
                                    rotationY: (ref8 = data.pose) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.rotation) === null || ref9 === void 0 ? void 0 : ref9._y,
                                    rotationZ: (ref10 = data.pose) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.rotation) === null || ref11 === void 0 ? void 0 : ref11._z,
                                    quaternionX: (ref12 = data.pose) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.quaternion) === null || ref13 === void 0 ? void 0 : ref13._x,
                                    quaternionY: (ref14 = data.pose) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.quaternion) === null || ref15 === void 0 ? void 0 : ref15._y,
                                    quaternionZ: (ref16 = data.pose) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.quaternion) === null || ref17 === void 0 ? void 0 : ref17._z,
                                    quaternionW: (ref18 = data.pose) === null || ref18 === void 0 ? void 0 : (ref19 = ref18.quaternion) === null || ref19 === void 0 ? void 0 : ref19._w,
                                    degree: data.degree
                                }))
                            ];
                        case 4:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            });
            return function(data) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this58 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.onAddAvatar = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
                var ref, avatarNode;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!!_this58.avatarNodes.has(data.uuid)) return [
                                3,
                                2
                            ];
                            if (!data.positionX && !data.positionY && !data.positionZ) {
                                data.positionX = _this58.pose.position.x;
                                data.positionY = _this58.pose.position.y;
                                data.positionZ = _this58.pose.position.z;
                            }
                            return [
                                4,
                                _this58.initAvatarNode(data)
                            ];
                        case 1:
                            avatarNode = _state.sent();
                            avatarNode[0].obj3D.position.set(data.positionX, data.positionY, data.positionZ);
                            avatarNode[0].obj3D.rotation.set(data.rotationX, data.rotationY, data.rotationZ);
                            avatarNode[0].obj3D.quaternion.set(data.quaternionX, data.quaternionY, data.quaternionZ, data.quaternionW);
                            (ref = avatarNode[0].obj3D.children[0]) === null || ref === void 0 ? void 0 : ref.rotation.set(0, Math.PI, 0);
                            if (avatarNode === null || avatarNode === void 0 ? void 0 : avatarNode.length) {
                                if (!(data === null || data === void 0 ? void 0 : data.muted)) {
                                    if (avatarNode[2]) {
                                        // changing state to !active if video is not muted
                                        avatarNode[2].setActive(!avatarNode[2].isActive());
                                    }
                                }
                                _this58.avatarNodes.set(data.uuid, avatarNode);
                            }
                            return [
                                2,
                                avatarNode
                            ];
                        case 2:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(data) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this59 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.onRemoveAvatar = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(uuid) {
                var ref, avatar;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    if (_this59.avatarNodes.size) {
                        ref = (0,_sliced_to_array/* default */.Z)(_this59.avatarNodes.get(uuid), 1), avatar = ref[0];
                        if (avatar) {
                            avatar.stop();
                            _this59.avatarNodes.delete(uuid);
                        }
                    }
                    return [
                        2
                    ];
                });
            });
            return function(uuid) {
                return _ref.apply(this, arguments);
            };
        }();
        _this.videoEndCall = function() {
            socket/* default.close */.Z.close();
            _this.setState({
                reelVideos: []
            });
        };
        _this.videoChangeTour = function(data) {
            var tour = _this.state.tour;
            var m = (0,util_all/* getQueryVariable */.Dv)(_this.state.iframeUrl, "m");
            if (data.id && data.id !== m) {
                if (data.mp) {
                    var ref;
                    _this.moveModel("/mp-sdk/".concat("24.11.2", "/showcase.html?applicationKey=").concat(tour === null || tour === void 0 ? void 0 : (ref = tour.user) === null || ref === void 0 ? void 0 : ref.mpSDK, "&m=").concat(data.id));
                } else {
                    _this.getTour({
                        slug: data.id,
                        changeMenu: false,
                        changeMinimap: true,
                        changePanorama: false
                    });
                }
            }
        };
        _this.changeMuteStatus = function(name, muted) {
            var _state = _this.state, fullscreenVideo = _state.fullscreenVideo, pinnedVideos = _state.pinnedVideos, reelVideos = _state.reelVideos;
            var isReeled = reelVideos.findIndex(function(i) {
                return i.name === name;
            });
            var isPinned = pinnedVideos.findIndex(function(i) {
                return i.name === name;
            });
            var isFullscreen = (fullscreenVideo === null || fullscreenVideo === void 0 ? void 0 : fullscreenVideo.name) === name;
            if (isFullscreen) {
                fullscreenVideo.muted = muted;
            } else if (isPinned >= 0) {
                pinnedVideos[isPinned].muted = muted;
                _this.addPinnedVideo(pinnedVideos[isPinned]);
            } else if (isReeled >= 0) {
                reelVideos[isReeled].muted = muted;
                _this.addVideoReel(reelVideos[isReeled]);
            }
        };
        var _this60 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.addTrack = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(p) {
                var ref, ref1, _state, fullscreenVideo, pinnedVideos, audioEl, isFullscreen, isPinned;
                return (0,tslib_es6.__generator)(this, function(_state1) {
                    try {
                        ;
                        _state = _this60.state, fullscreenVideo = _state.fullscreenVideo, pinnedVideos = _state.pinnedVideos;
                        if (((ref = p.track) === null || ref === void 0 ? void 0 : ref.kind) === "audio" && !p.self) {
                            audioEl = new Audio();
                            audioEl.append(p.track.attach());
                            audioEl.setAttribute("data-cy-audio-track-name", p.track.name);
                            audioEl.setAttribute("data-cy-audio-track-sid", p.sid);
                            document.body.appendChild(audioEl);
                            if (!p.enabled) {
                                audioEl.pause();
                                _this60.changeMuteStatus(p.name, true);
                            } else {
                                _this60.changeMuteStatus(p.name, false);
                            }
                        } else if (((ref1 = p.track) === null || ref1 === void 0 ? void 0 : ref1.kind) === "video") {
                            isFullscreen = (fullscreenVideo === null || fullscreenVideo === void 0 ? void 0 : fullscreenVideo.sid) === p.sid;
                            isPinned = pinnedVideos.findIndex(function(i) {
                                return i.sid === p.sid;
                            });
                            if (p.dominant) {
                                _this60.setState({
                                    dominantSpeaker: p
                                });
                            } else if (isFullscreen) {
                                _this60.setState({
                                    fullscreenVideo: p
                                });
                            } else if (isPinned >= 0) {
                                // || p.track.name.includes('-screen')
                                // we pin screen shares
                                _this60.addPinnedVideo(p);
                            } else {
                                _this60.addVideoReel(p);
                            }
                        }
                    } catch (e) {
                        console.error(e);
                    }
                    return [
                        2
                    ];
                });
            });
            return function(p) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this61 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.removeTrack = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(sid) {
                var _state, fullscreenVideo, pinnedVideos, audioOnly, isFullscreen, isPinned;
                return (0,tslib_es6.__generator)(this, function(_state1) {
                    try {
                        _state = _this61.state, fullscreenVideo = _state.fullscreenVideo, pinnedVideos = _state.pinnedVideos, audioOnly = _state.audioOnly;
                        isFullscreen = (fullscreenVideo === null || fullscreenVideo === void 0 ? void 0 : fullscreenVideo.sid) === sid;
                        isPinned = pinnedVideos.findIndex(function(i) {
                            return i.sid === sid;
                        });
                        if (isFullscreen) {
                            _this61.setState({
                                fullscreenVideo: null
                            });
                        } else if (isPinned >= 0) {
                            _this61.removePinnedVideo(sid);
                            if (audioOnly) _this61.removePinnedVideo("".concat(sid, "_video"));
                        } else {
                            _this61.removeVideoReel(sid);
                            if (audioOnly) _this61.removeVideoReel("".concat(sid, "_video"));
                        }
                    } catch (e) {
                        console.error(e);
                    }
                    return [
                        2
                    ];
                });
            });
            return function(sid) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this62 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.updateAvatarsInList = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(name, avatarImage) {
                var reelVideos, index;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    try {
                        if (!avatarImage) return [
                            2
                        ];
                        reelVideos = (0,_to_consumable_array/* default */.Z)(_this62.state.reelVideos);
                        index = reelVideos.findIndex(function(i) {
                            return i.name === name;
                        });
                        if (index >= 0 && !reelVideos[index].avatarImage) {
                            reelVideos[index] = Object.assign(reelVideos[index], {
                                avatarImage: avatarImage
                            });
                            _this62.setState({
                                reelVideos: reelVideos
                            });
                        }
                    } catch (e) {
                        console.error(e);
                    }
                    return [
                        2
                    ];
                });
            });
            return function(name, avatarImage) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this63 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.addVideoReel = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(p) {
                var ref;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    try {
                        ;
                        if (((ref = p.track) === null || ref === void 0 ? void 0 : ref.kind) === "video") {
                            _this63.setState(function(prevState) {
                                var reelVideos = (0,_to_consumable_array/* default */.Z)(prevState.reelVideos);
                                var index = reelVideos.findIndex(function(i) {
                                    return i.sid === p.sid;
                                });
                                if (index >= 0) {
                                    reelVideos[index] = Object.assign(reelVideos[index], p);
                                } else {
                                    reelVideos.push(p);
                                }
                                return {
                                    reelVideos: reelVideos
                                };
                            });
                        }
                    } catch (e) {
                        console.error(e);
                    }
                    return [
                        2
                    ];
                });
            });
            return function(p) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this64 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.removeVideoReel = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(sid) {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    console.log("Removing ".concat(sid, " from reel"));
                    _this64.setState(function(prevState) {
                        return {
                            reelVideos: prevState.reelVideos.filter(function(i) {
                                return i.sid !== sid;
                            })
                        };
                    });
                    return [
                        2
                    ];
                });
            });
            return function(sid) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this65 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.addPinnedVideo = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(p) {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    addPinnedVideoFunc(p, _this65.state.pinnedVideos, function(pinnedVideos) {
                        _this65.setState({
                            pinnedVideos: pinnedVideos
                        }, function() {
                            if (!p.pinned) _this65.removeVideoReel(p.sid);
                        });
                    });
                    return [
                        2
                    ];
                });
            });
            return function(p) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this66 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.removePinnedVideo = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(sid) {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    _this66.setState({
                        pinnedVideos: _this66.state.pinnedVideos.filter(function(i) {
                            return i.sid !== sid;
                        })
                    });
                    return [
                        2
                    ];
                });
            });
            return function(sid) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this67 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.toggleFullscreenVideo = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(participant) {
                var pinned, _state, fullscreenVideo, pinnedVideos, newPinnedVideos;
                var _arguments = arguments;
                return (0,tslib_es6.__generator)(this, function(_state1) {
                    pinned = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : false;
                    _state = _this67.state, fullscreenVideo = _state.fullscreenVideo, pinnedVideos = _state.pinnedVideos;
                    if ((fullscreenVideo === null || fullscreenVideo === void 0 ? void 0 : fullscreenVideo.sid) === participant.sid) {
                        // close fullscreen video
                        if (fullscreenVideo.pinned) {
                            _this67.addPinnedVideo((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, fullscreenVideo), {
                                pinned: pinned
                            }));
                        } else {
                            _this67.addVideoReel(fullscreenVideo);
                        }
                        _this67.setState({
                            fullscreenVideo: null
                        });
                        document.removeEventListener("keydown", _this67.exitFullscreenVideo);
                    } else {
                        // open fullscreen video
                        _this67.setState({
                            fullscreenVideo: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, participant), {
                                pinned: pinned
                            })
                        });
                        if (fullscreenVideo) {
                            // first close old one, then add the new one
                            if (fullscreenVideo.pinned) {
                                newPinnedVideos = (0,_to_consumable_array/* default */.Z)(pinnedVideos.filter(function(p) {
                                    return p.sid !== participant.sid;
                                })).concat([
                                    (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, fullscreenVideo), {
                                        pinned: false
                                    })
                                ]);
                                _this67.setState({
                                    pinnedVideos: newPinnedVideos
                                });
                            } else {
                                _this67.addVideoReel(fullscreenVideo);
                            }
                        } else {
                            _this67.removePinnedVideo(participant.sid);
                        }
                        _this67.removeVideoReel(participant.sid);
                        document.addEventListener("keydown", _this67.exitFullscreenVideo);
                    }
                    return [
                        2
                    ];
                });
            });
            return function(participant) {
                return _ref.apply(this, arguments);
            };
        }();
        _this.exitFullscreenVideo = function(event) {
            if (event.key === "Escape") {
                event.preventDefault();
                if (_this.state.fullscreenVideo) {
                    _this.toggleFullscreenVideo(_this.state.fullscreenVideo);
                }
            }
        };
        var _this68 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.initAvatar = /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            var _state, tour, room, avatar, e;
            return (0,tslib_es6.__generator)(this, function(_state1) {
                switch(_state1.label){
                    case 0:
                        _state = _this68.state, tour = _state.tour, room = _state.room;
                        if (!tour.enableAvatar) return [
                            2
                        ];
                        _state1.label = 1;
                    case 1:
                        _state1.trys.push([
                            1,
                            5,
                            ,
                            6
                        ]);
                        avatar = (0,storage/* storage */.t)("avatar").get();
                        if (!!avatar) return [
                            3,
                            2
                        ];
                        _this68.setState({
                            avatar: null,
                            chatParticipant: null
                        });
                        return [
                            3,
                            4
                        ];
                    case 2:
                        if (!!room) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            _this68.setAvatar(avatar)
                        ];
                    case 3:
                        _state1.sent();
                        _state1.label = 4;
                    case 4:
                        return [
                            3,
                            6
                        ];
                    case 5:
                        e = _state1.sent();
                        return [
                            3,
                            6
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        var _this69 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.toggleMuteParticipants = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(sid) {
                var audioEl, mute;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    audioEl = document.querySelectorAll("[data-cy-audio-track-sid=".concat(sid, "]"));
                    mute = false;
                    if (audioEl && audioEl.length > 0) {
                        if (audioEl[0].playing) {
                            audioEl[0].pause();
                            mute = true;
                        } else {
                            audioEl[0].play();
                            mute = false;
                        }
                        if (_this69.state.host) {
                            socket/* default.emit */.Z.emit("mute_participant", {
                                participantId: sid,
                                mute: mute
                            });
                        }
                    }
                    return [
                        2
                    ];
                });
            });
            return function(sid) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this70 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.getAvatarImage = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(url) {
                var id, response, json, err;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                4,
                                ,
                                5
                            ]);
                            if (!url.includes(".glb")) throw new Error("No GLB");
                            id = url.split("/").pop().split(".glb")[0];
                            return [
                                4,
                                fetch("https://models.readyplayer.me/".concat(id, ".json"))
                            ];
                        case 1:
                            response = _state.sent();
                            return [
                                4,
                                response.json()
                            ];
                        case 2:
                            json = _state.sent();
                            return [
                                4,
                                new Promise(function(resolve) {
                                    var imageUrl = "https://api.readyplayer.me/v1/avatars/".concat(id, ".png?scene=").concat(json.bodyType, "-portrait-v1-transparent");
                                    _this70.setState({
                                        avatarImage: imageUrl
                                    }, function() {
                                        return resolve(imageUrl);
                                    });
                                })
                            ];
                        case 3:
                            return [
                                2,
                                _state.sent()
                            ];
                        case 4:
                            err = _state.sent();
                            console.log(err);
                            return [
                                2,
                                ""
                            ];
                        case 5:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(url) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this71 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.setAvatarImage = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(url) {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    _this71.setState({
                        avatarImage: url
                    });
                    return [
                        2
                    ];
                });
            });
            return function(url) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this72 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.setAvatar = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
                var ref, ref1, _state, tour, room, avatarImage, _, _tmp, _1, _tmp1, _tmp2, _tmp3, avatarId, avatar, user;
                return (0,tslib_es6.__generator)(this, function(_state1) {
                    switch(_state1.label){
                        case 0:
                            _state = _this72.state, tour = _state.tour, room = _state.room, avatarImage = _state.avatarImage;
                            _ = _this72.setState;
                            _tmp = {};
                            _1 = Object.assign;
                            _tmp1 = [
                                data
                            ];
                            _tmp2 = {};
                            _tmp3 = avatarImage;
                            if (_tmp3) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                _this72.getAvatarImage(data.url)
                            ];
                        case 1:
                            _tmp3 = _state1.sent();
                            _state1.label = 2;
                        case 2:
                            _.apply(_this72, [
                                (_tmp.chatParticipant = _1.apply(Object, _tmp1.concat((_tmp2.imageUrl = _tmp3, _tmp2))), _tmp)
                            ]);
                            if (!tour.enableAvatar) return [
                                2
                            ];
                            avatarId = (0,v4/* default */.Z)();
                            avatar = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data), {
                                uuid: avatarId,
                                imageUrl: avatarImage
                            });
                            (0,storage/* storage */.t)("avatar").set(avatar);
                            _this72.setState({
                                avatar: avatar
                            });
                            user = {
                                name: data === null || data === void 0 ? void 0 : data.name,
                                room: room || tour.id,
                                avatarUrl: data.url,
                                avatarId: avatarId,
                                avatarImage: avatarImage,
                                model: data.model,
                                pose: {
                                    rotation: (ref = _this72.camera) === null || ref === void 0 ? void 0 : ref.rotation,
                                    quaternion: (ref1 = _this72.camera) === null || ref1 === void 0 ? void 0 : ref1.quaternion,
                                    position: _this72.pose.position
                                },
                                sweep: _this72.pose.sweep
                            };
                            socket/* default.emit */.Z.emit("user_joining", user);
                            console.log("Joining avatar to room ".concat(room));
                            return [
                                2
                            ];
                    }
                });
            });
            return function(data) {
                return _ref.apply(this, arguments);
            };
        }();
        _this.toggleSketchfabPopup = function(state) {
            return function() {
                _this.setState({
                    showSketchfabPopup: state
                });
            };
        };
        _this.startShowcaseLoad = function() {
            return new Promise(function(resolve, reject) {
                if (_this.iframe) {
                    if (_this.loadShowcaseFrameAbortController) {
                        _this.loadShowcaseFrameAbortController.abort();
                    }
                    _this.loadShowcaseFrameAbortController = new AbortController();
                    var signal = _this.loadShowcaseFrameAbortController.signal;
                    _this.iframe.addEventListener("load", function() {
                        _this.showcaseLoad();
                        resolve(true);
                    }, {
                        once: false,
                        signal: signal
                    }); // once: false for TB-3129
                } else {
                    reject(new Error("Iframe is not defined"));
                }
            });
        };
        _this.onCloseIntro = function() {
            var _state = _this.state, tour = _state.tour, startScreenOn = _state.startScreenOn, _$tourType = _state.tourType;
            var _this1 = (0,_assert_this_initialized/* default */.Z)(_this);
            _this.setState({
                showIntro: false,
                startScreenOn: _$tourType === Tour/* TourType.Game */.v.Game || tour.introScreen ? startScreenOn : false
            }, /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _this1.showcaseLoad();
                            if (!(tour === null || tour === void 0 ? void 0 : tour.autoplayMusic)) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                _this1.playTourAudio().catch(function() {})
                            ];
                        case 1:
                            _state.sent();
                            _state.label = 2;
                        case 2:
                            return [
                                2
                            ];
                    }
                });
            }));
        };
        _this.getCurrentLanguage = function() {
            var ref;
            return (ref = _this.state.initialDuplicates) === null || ref === void 0 ? void 0 : ref.find(function(duplicate) {
                var ref, ref1;
                return duplicate.slug === ((ref = _this.state) === null || ref === void 0 ? void 0 : (ref1 = ref.tour) === null || ref1 === void 0 ? void 0 : ref1.slug);
            });
        };
        _this.unlockChapter = function(targetObj, type) {
            var _state = _this.state, _game = _state.game, book = _game.book, gameBookOn = _game.gameBookOn, unlockedChapterIds = _state.unlockedChapterIds, clickedElements = _state.clickedElements;
            var value = targetObj === null || targetObj === void 0 ? void 0 : targetObj.id;
            _this.setState({
                clickedElements: (0,_to_consumable_array/* default */.Z)(clickedElements).concat([
                    {
                        type: type,
                        value: value,
                        sid: targetObj === null || targetObj === void 0 ? void 0 : targetObj.sid,
                        defaultSid: targetObj === null || targetObj === void 0 ? void 0 : targetObj.defaultSid
                    }, 
                ])
            });
            if (!gameBookOn || !book) return;
            var chapters = sortBy_default()(book === null || book === void 0 ? void 0 : book.chapters, "order");
            var chapter = chapters.find(function(item) {
                return item.order === unlockedChapterIds.length + 1;
            });
            var unblock = false;
            switch(type){
                case GameBook/* ChapterType.Tag */._U.Tag:
                    {
                        var tag = targetObj;
                        unblock = chapter && chapter.type === GameBook/* ChapterType.Tag */._U.Tag && (chapter.value === String(tag.id) || chapter.value === tag.sid);
                        break;
                    }
                case GameBook/* ChapterType.Polygon */._U.Polygon:
                    var polygon = targetObj;
                    unblock = chapter && chapter.type === GameBook/* ChapterType.Polygon */._U.Polygon && chapter.value === String(polygon.id);
                    break;
                case GameBook/* ChapterType.VSItem */._U.VSItem:
                    var vsItem = targetObj;
                    unblock = chapter && chapter.type === GameBook/* ChapterType.VSItem */._U.VSItem && chapter.value === String(vsItem.id);
                    break;
                case GameBook/* ChapterType.VSImage */._U.VSImage:
                    var vsImage = targetObj;
                    unblock = chapter && chapter.type === GameBook/* ChapterType.VSImage */._U.VSImage && chapter.value === String(vsImage.id);
                    break;
                case GameBook/* ChapterType.VSVideo */._U.VSVideo:
                    var vsVideo = targetObj;
                    unblock = chapter && chapter.type === GameBook/* ChapterType.VSVideo */._U.VSVideo && chapter.value === String(vsVideo.id);
                    break;
                default:
                    break;
            }
            if (unblock) {
                _this.tryButtonPlaySound();
                _this.setState({
                    unlockedChapterIds: (0,_to_consumable_array/* default */.Z)(unlockedChapterIds).concat([
                        chapter.id
                    ])
                });
            }
        };
        var _this73 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.onPathAction = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(element, type) {
                var data;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!(type === GameBook/* ChapterType.Tag */._U.Tag)) return [
                                3,
                                1
                            ];
                            _this73.openTagIframe(element.sid);
                            return [
                                3,
                                7
                            ];
                        case 1:
                            if (!(type === GameBook/* ChapterType.VSItem */._U.VSItem)) return [
                                3,
                                2
                            ];
                            _this73.openVsObjectIframe(element);
                            return [
                                3,
                                7
                            ];
                        case 2:
                            if (!(type === GameBook/* ChapterType.VSVideo */._U.VSVideo)) return [
                                3,
                                3
                            ];
                            _this73.openVsVideoIframe(element);
                            return [
                                3,
                                7
                            ];
                        case 3:
                            if (!(type === GameBook/* ChapterType.Polygon */._U.Polygon)) return [
                                3,
                                5
                            ];
                            data = (element === null || element === void 0 ? void 0 : element.polygonsActions) ? element.polygonsActions[0] : element;
                            return [
                                4,
                                _this73.handlePolygonAction(data)
                            ];
                        case 4:
                            _state.sent();
                            return [
                                3,
                                7
                            ];
                        case 5:
                            if (!(type === GameBook/* ChapterType.VSImage */._U.VSImage)) return [
                                3,
                                7
                            ];
                            return [
                                4,
                                _this73.handleVSAction(element)
                            ];
                        case 6:
                            _state.sent();
                            _state.label = 7;
                        case 7:
                            _this73.setState({
                                clickedElement: {
                                    id: element.id,
                                    type: type
                                }
                            });
                            return [
                                2
                            ];
                    }
                });
            });
            return function(element, type) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this74 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.__hideConditions = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(conditions) {
                var _Sweep, ref, _state, polygons, allTags, availableSweeps, _tags, polygonsToHide, vsItemsToHide, vsVideosToHide, vsImagesToHide, sweeps, currentRevealedConditions, uniqueCondSweeps, availableCondSweeps, allTagsArray, tagsToHide;
                return (0,tslib_es6.__generator)(this, function(_state1) {
                    switch(_state1.label){
                        case 0:
                            // mattertag - editOpacity and make it 0 |  mpSdk.Mattertag.getData(); mpSdk.Mattertag.editOpacity(mattertagData[0].sid, 0);
                            if (!conditions.length) return [
                                2
                            ];
                            console.debug("__hideConditions", conditions);
                            _state = _this74.state, polygons = _state.polygons, allTags = _state.allTags;
                            availableSweeps = (ref = _this74.state.sweeps) === null || ref === void 0 ? void 0 : ref.map(function(s) {
                                return s.sid;
                            });
                            _tags = [];
                            polygonsToHide = [];
                            vsItemsToHide = [];
                            vsVideosToHide = [];
                            vsImagesToHide = [];
                            sweeps = [];
                            currentRevealedConditions = [];
                            conditions.forEach(function(condition) {
                                if (!condition.entity_ids) return;
                                if (condition.entity_type === Game/* EntityType.Tag */.py.Tag) {
                                    _tags = (0,_to_consumable_array/* default */.Z)(_tags).concat((0,_to_consumable_array/* default */.Z)(condition.entity_ids));
                                } else if (condition.entity_type === Game/* EntityType.Polygon */.py.Polygon) {
                                    polygonsToHide = (0,_to_consumable_array/* default */.Z)(polygonsToHide).concat((0,_to_consumable_array/* default */.Z)(condition.entity_ids));
                                } else if (condition.entity_type === Game/* EntityType.VSItem */.py.VSItem) {
                                    vsItemsToHide = (0,_to_consumable_array/* default */.Z)(vsItemsToHide).concat((0,_to_consumable_array/* default */.Z)(condition.entity_ids));
                                } else if (condition.entity_type === Game/* EntityType.VSVideo */.py.VSVideo) {
                                    vsVideosToHide = (0,_to_consumable_array/* default */.Z)(vsVideosToHide).concat((0,_to_consumable_array/* default */.Z)(condition.entity_ids));
                                } else if (condition.entity_type === Game/* EntityType.VSImage */.py.VSImage) {
                                    vsImagesToHide = (0,_to_consumable_array/* default */.Z)(vsImagesToHide).concat((0,_to_consumable_array/* default */.Z)(condition.entity_ids));
                                } else if (condition.entity_type === Game/* EntityType.Sweep */.py.Sweep) {
                                    sweeps = (0,_to_consumable_array/* default */.Z)(sweeps).concat((0,_to_consumable_array/* default */.Z)(condition.entity_ids));
                                }
                                currentRevealedConditions.push(condition.id);
                            });
                            console.debug("-----------disabling sweeps-----------", sweeps);
                            uniqueCondSweeps = new Set(sweeps);
                            availableCondSweeps = Array.from(uniqueCondSweeps).filter(function(s) {
                                return availableSweeps.includes(s);
                            });
                            (_Sweep = _this74.showcase.Sweep).disable.apply(_Sweep, (0,_to_consumable_array/* default */.Z)(availableCondSweeps)).catch(function(err) {
                                return console.error(err);
                            });
                            allTagsArray = Array.from(allTags, function(param) {
                                var _param = (0,_sliced_to_array/* default */.Z)(param, 2), value = _param[1];
                                return value;
                            });
                            tagsToHide = _tags.map(function(tag) {
                                return allTagsArray.find(function(allTagItem) {
                                    return allTagItem.id === Number(tag) || allTagItem.sid === tag || allTagItem.defaultSid === tag;
                                });
                            });
                            console.debug("-----------disabling tags-----------", tagsToHide);
                            tagsToHide.forEach(function(_tag) {
                                return _tag && _this74._changeTagPos(_tag, false);
                            });
                            if (!(polygons && polygons.map)) return [
                                3,
                                2
                            ];
                            console.debug("Polygons to hide", polygonsToHide, polygons);
                            return [
                                4,
                                Promise.all(polygons.map(function() {
                                    var _ref = (0,_async_to_generator/* default */.Z)(function(item) {
                                        var ref, nodeIndex;
                                        return (0,tslib_es6.__generator)(this, function(_state) {
                                            if (polygonsToHide.indexOf(item === null || item === void 0 ? void 0 : (ref = item.id) === null || ref === void 0 ? void 0 : ref.toString()) !== -1 || polygonsToHide.indexOf(item === null || item === void 0 ? void 0 : item.id) !== -1) {
                                                if (!(item === null || item === void 0 ? void 0 : item.active)) {
                                                    console.debug("-----------not hiding polygon (inactive) ----------", item);
                                                }
                                                nodeIndex = _this74.modelNodes.findIndex(function(node) {
                                                    var ref, ref1;
                                                    return (node === null || node === void 0 ? void 0 : (ref = node[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.obj3D) === null || ref1 === void 0 ? void 0 : ref1.uuid) === item.uuid;
                                                });
                                                if (nodeIndex >= 0 && item.uuid) {
                                                    console.debug("-----------hiding polygon ----------", item);
                                                    _this74.modelNodes[nodeIndex][0].stop();
                                                    item.uuid = null;
                                                    _this74.modelNodes.splice(nodeIndex, 1);
                                                }
                                            }
                                            return [
                                                2
                                            ];
                                        });
                                    });
                                    return function(item) {
                                        return _ref.apply(this, arguments);
                                    };
                                }()))
                            ];
                        case 1:
                            _state1.sent();
                            _state1.label = 2;
                        case 2:
                            return [
                                4,
                                Promise.all((_this74.vsObjects || []).map(function() {
                                    var _ref = (0,_async_to_generator/* default */.Z)(function(item) {
                                        var ref, targetObjToHide;
                                        return (0,tslib_es6.__generator)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    if ((0,_instanceof/* default */.Z)(item, VSObject/* TourImage */.oP)) {
                                                        targetObjToHide = vsImagesToHide;
                                                    } else if ((0,_instanceof/* default */.Z)(item, VSObject/* TourVideo */.Up)) {
                                                        targetObjToHide = vsVideosToHide;
                                                    } else {
                                                        targetObjToHide = vsItemsToHide;
                                                    }
                                                    if (!(targetObjToHide && (targetObjToHide.indexOf(item === null || item === void 0 ? void 0 : (ref = item.id) === null || ref === void 0 ? void 0 : ref.toString()) !== -1 || targetObjToHide.indexOf(item === null || item === void 0 ? void 0 : item.id) !== -1))) return [
                                                        3,
                                                        2
                                                    ];
                                                    if (item && !item.active) return [
                                                        2,
                                                        item
                                                    ];
                                                    console.debug("-----------hiding vs ----------", item);
                                                    return [
                                                        4,
                                                        _this74.setVSVisible(item, false)
                                                    ];
                                                case 1:
                                                    _state.sent();
                                                    return [
                                                        2,
                                                        (0,_object_spread/* default */.Z)({}, item)
                                                    ];
                                                case 2:
                                                    return [
                                                        2
                                                    ];
                                            }
                                        });
                                    });
                                    return function(item) {
                                        return _ref.apply(this, arguments);
                                    };
                                }()))
                            ];
                        case 3:
                            _state1.sent();
                            return [
                                2
                            ];
                    }
                });
            });
            return function(conditions) {
                return _ref.apply(this, arguments);
            };
        }();
        _this._changeTagPos = function(_tag, isVisible) {
            var sid = _tag.sid;
            console.debug("-----------".concat(isVisible ? "revealing" : "hiding", " tag ----------"), _tag);
            _this.showcase.Tag.editOpacity(sid, isVisible ? 1 : 0).catch(function(e) {
                return console.error(e);
            });
            _this.showcase.Tag.editPosition(sid, {
                anchorPosition: {
                    x: isVisible ? _tag.positionX : 0,
                    y: isVisible ? _tag.positionY : 0,
                    z: isVisible ? _tag.positionZ : 0
                },
                stemVector: {
                    x: isVisible ? _tag.stemVectorX : 0,
                    y: isVisible ? _tag.stemVectorY : 0,
                    z: isVisible ? _tag.stemVectorZ : 0
                },
                // floorIndex: isVisible ? _tag.floor : 0,
                floorIndex: _tag.floor
            }).catch(function(e) {
                return console.error(e);
            });
        };
        var _this75 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.__revealConditions = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(conditions) {
                var _Sweep, ref, _state, polygons, allTags, availableSweeps, _tags, polygonsToReveal, vsItemsToReveal, vsVideosToReveal, vsImagesToReveal, sweeps, _$popups, currentRevealedConditions, uniqueCondSweeps, availableCondSweeps, allTagsArray, tagsToShow;
                return (0,tslib_es6.__generator)(this, function(_state1) {
                    switch(_state1.label){
                        case 0:
                            // this.showcase.Sweep.disable(sweep.uuid, sweep2.uuid,...)
                            // mattertag - editOpacity and make it 0 |  mpSdk.Mattertag.getData(); mpSdk.Mattertag.editOpacity(mattertagData[0].sid, 0);
                            if (!conditions.length) return [
                                2
                            ];
                            console.debug("__revealConditions", conditions);
                            _state = _this75.state, polygons = _state.polygons, allTags = _state.allTags;
                            availableSweeps = (ref = _this75.state.sweeps) === null || ref === void 0 ? void 0 : ref.map(function(s) {
                                return s.sid;
                            });
                            _tags = [];
                            polygonsToReveal = [];
                            vsItemsToReveal = [];
                            vsVideosToReveal = [];
                            vsImagesToReveal = [];
                            sweeps = [];
                            _$popups = [];
                            currentRevealedConditions = [];
                            conditions.forEach(function(condition) {
                                if (!condition.entity_ids) return;
                                if (condition.entity_type === Game/* EntityType.Tag */.py.Tag) {
                                    _tags = (0,_to_consumable_array/* default */.Z)(_tags).concat((0,_to_consumable_array/* default */.Z)(condition.entity_ids));
                                } else if (condition.entity_type === Game/* EntityType.Polygon */.py.Polygon) {
                                    polygonsToReveal = (0,_to_consumable_array/* default */.Z)(polygonsToReveal).concat((0,_to_consumable_array/* default */.Z)(condition.entity_ids));
                                } else if (condition.entity_type === Game/* EntityType.VSItem */.py.VSItem) {
                                    vsItemsToReveal = (0,_to_consumable_array/* default */.Z)(vsItemsToReveal).concat((0,_to_consumable_array/* default */.Z)(condition.entity_ids));
                                } else if (condition.entity_type === Game/* EntityType.VSVideo */.py.VSVideo) {
                                    vsVideosToReveal = (0,_to_consumable_array/* default */.Z)(vsVideosToReveal).concat((0,_to_consumable_array/* default */.Z)(condition.entity_ids));
                                } else if (condition.entity_type === Game/* EntityType.VSImage */.py.VSImage) {
                                    vsImagesToReveal = (0,_to_consumable_array/* default */.Z)(vsImagesToReveal).concat((0,_to_consumable_array/* default */.Z)(condition.entity_ids));
                                } else if (condition.entity_type === Game/* EntityType.Sweep */.py.Sweep) {
                                    sweeps = (0,_to_consumable_array/* default */.Z)(sweeps).concat((0,_to_consumable_array/* default */.Z)(condition.entity_ids));
                                } else if (condition.entity_type === Game/* EntityType.Popup */.py.Popup) {
                                    _$popups = (0,_to_consumable_array/* default */.Z)(_$popups).concat([
                                        condition
                                    ]);
                                }
                                currentRevealedConditions.push(condition.id);
                            });
                            console.debug("-----------enabling sweeps-----------", sweeps);
                            uniqueCondSweeps = new Set(sweeps);
                            availableCondSweeps = Array.from(uniqueCondSweeps).filter(function(s) {
                                return availableSweeps.includes(s);
                            });
                            (_Sweep = _this75.showcase.Sweep).enable.apply(_Sweep, (0,_to_consumable_array/* default */.Z)(availableCondSweeps)).catch(function(err) {
                                return console.error(err);
                            });
                            allTagsArray = Array.from(allTags, function(param) {
                                var _param = (0,_sliced_to_array/* default */.Z)(param, 2), value = _param[1];
                                return value;
                            });
                            tagsToShow = _tags.map(function(tag) {
                                return allTagsArray.find(function(allTagItem) {
                                    return allTagItem.id === Number(tag) || allTagItem.sid === tag || allTagItem.defaultSid === tag;
                                });
                            });
                            tagsToShow.forEach(function(_tag) {
                                return _tag && _this75._changeTagPos(_tag, true);
                            });
                            if (!(polygons && polygons.map)) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                Promise.all(polygons.map(function() {
                                    var _ref = (0,_async_to_generator/* default */.Z)(function(item) {
                                        var ref, node;
                                        return (0,tslib_es6.__generator)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    if (!(polygonsToReveal.indexOf(item === null || item === void 0 ? void 0 : (ref = item.id) === null || ref === void 0 ? void 0 : ref.toString()) !== -1 || polygonsToReveal.indexOf(item === null || item === void 0 ? void 0 : item.id) !== -1)) return [
                                                        3,
                                                        2
                                                    ];
                                                    if (!item.active) {
                                                        console.debug("-----------not revealing polygons (inactive)----------", item);
                                                    }
                                                    console.debug("-----------revealing polygons ----------", item);
                                                    if (!!item.uuid) return [
                                                        3,
                                                        2
                                                    ];
                                                    return [
                                                        4,
                                                        _this75.initPolygonNode(item)
                                                    ];
                                                case 1:
                                                    node = _state.sent();
                                                    _this75.modelNodes.push(node);
                                                    item.uuid = node[0].obj3D.uuid;
                                                    _state.label = 2;
                                                case 2:
                                                    return [
                                                        2
                                                    ];
                                            }
                                        });
                                    });
                                    return function(item) {
                                        return _ref.apply(this, arguments);
                                    };
                                }()))
                            ];
                        case 1:
                            _state1.sent();
                            _state1.label = 2;
                        case 2:
                            return [
                                4,
                                Promise.all((_this75.vsObjects || []).map(function() {
                                    var _ref = (0,_async_to_generator/* default */.Z)(function(item) {
                                        var ref, targetObjToReveal;
                                        return (0,tslib_es6.__generator)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    if ((0,_instanceof/* default */.Z)(item, VSObject/* TourImage */.oP)) {
                                                        targetObjToReveal = vsImagesToReveal;
                                                    } else if ((0,_instanceof/* default */.Z)(item, VSObject/* TourVideo */.Up)) {
                                                        targetObjToReveal = vsVideosToReveal;
                                                    } else {
                                                        targetObjToReveal = vsItemsToReveal;
                                                    }
                                                    if (!(targetObjToReveal && (targetObjToReveal.indexOf(item === null || item === void 0 ? void 0 : (ref = item.id) === null || ref === void 0 ? void 0 : ref.toString()) !== -1 || targetObjToReveal.indexOf(item === null || item === void 0 ? void 0 : item.id) !== -1))) return [
                                                        3,
                                                        2
                                                    ];
                                                    // console.log('game item, item.active', item, item.active);
                                                    if (item && !item.active) return [
                                                        2,
                                                        item
                                                    ];
                                                    console.debug("-----------revealing vsItem ----------", item);
                                                    return [
                                                        4,
                                                        _this75.setVSVisible(item, true, components_types/* vsTriggerType.revealCondition */.QB.revealCondition)
                                                    ];
                                                case 1:
                                                    _state.sent();
                                                    return [
                                                        2,
                                                        (0,_object_spread/* default */.Z)({}, item)
                                                    ];
                                                case 2:
                                                    return [
                                                        2
                                                    ];
                                            }
                                        });
                                    });
                                    return function(item) {
                                        return _ref.apply(this, arguments);
                                    };
                                }()))
                            ];
                        case 3:
                            _state1.sent();
                            return [
                                2
                            ];
                    }
                });
            });
            return function(conditions) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this76 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.showElements = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
                var tagsToReveal, polygonsToReveal, vsImagesToReveal, vsVideosToReveal, vsHTMLsToReveal, vsItemsToReveal, sweepsToReveal, _state, allTags, polygons, sweeps, _Sweep, availableSweeps, uniqueCondSweeps, availableCondSweeps, allTagsArray, tagsToShow, currentObjUuid;
                return (0,tslib_es6.__generator)(this, function(_state1) {
                    switch(_state1.label){
                        case 0:
                            tagsToReveal = param.tagsToReveal, polygonsToReveal = param.polygonsToReveal, vsImagesToReveal = param.vsImagesToReveal, vsVideosToReveal = param.vsVideosToReveal, vsHTMLsToReveal = param.vsHTMLsToReveal, vsItemsToReveal = param.vsItemsToReveal, sweepsToReveal = param.sweepsToReveal;
                            _state = _this76.state, allTags = _state.allTags, polygons = _state.polygons, sweeps = _state.sweeps;
                            if (sweepsToReveal && (sweepsToReveal === null || sweepsToReveal === void 0 ? void 0 : sweepsToReveal.length) > 0) {
                                ;
                                availableSweeps = sweeps === null || sweeps === void 0 ? void 0 : sweeps.map(function(s) {
                                    return s.sid;
                                });
                                uniqueCondSweeps = new Set(sweepsToReveal);
                                availableCondSweeps = Array.from(uniqueCondSweeps).filter(function(s) {
                                    return availableSweeps.includes(s);
                                });
                                (_Sweep = _this76.showcase.Sweep).enable.apply(_Sweep, (0,_to_consumable_array/* default */.Z)(availableCondSweeps)).catch(function(err) {
                                    return console.error(err);
                                });
                            }
                            allTagsArray = Array.from(allTags, function(param) {
                                var _param = (0,_sliced_to_array/* default */.Z)(param, 2), value = _param[1];
                                return value;
                            });
                            tagsToShow = tagsToReveal === null || tagsToReveal === void 0 ? void 0 : tagsToReveal.map(function(tag) {
                                return allTagsArray.find(function(allTagItem) {
                                    return allTagItem.id === Number(tag) || allTagItem.sid === tag || allTagItem.defaultSid === tag;
                                });
                            });
                            tagsToShow === null || tagsToShow === void 0 ? void 0 : tagsToShow.forEach(function(_tag) {
                                return _tag && _this76._changeTagPos(_tag, true);
                            });
                            currentObjUuid = null;
                            if (!(polygons && polygons.map && polygonsToReveal)) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                Promise.all(polygons.map(function() {
                                    var _ref = (0,_async_to_generator/* default */.Z)(function(item) {
                                        var ref, node;
                                        return (0,tslib_es6.__generator)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    if (!((polygonsToReveal === null || polygonsToReveal === void 0 ? void 0 : polygonsToReveal.indexOf(item === null || item === void 0 ? void 0 : (ref = item.id) === null || ref === void 0 ? void 0 : ref.toString())) !== -1)) return [
                                                        3,
                                                        2
                                                    ];
                                                    if (!(item.active && !item.uuid)) return [
                                                        3,
                                                        2
                                                    ];
                                                    return [
                                                        4,
                                                        _this76.initPolygonNode(item)
                                                    ];
                                                case 1:
                                                    node = _state.sent();
                                                    _this76.modelNodes.push(node);
                                                    item.uuid = node[0].obj3D.uuid;
                                                    item.hiddenFromFlows = false;
                                                    currentObjUuid = item.uuid;
                                                    _state.label = 2;
                                                case 2:
                                                    return [
                                                        2
                                                    ];
                                            }
                                        });
                                    });
                                    return function(item) {
                                        return _ref.apply(this, arguments);
                                    };
                                }()))
                            ];
                        case 1:
                            _state1.sent();
                            _state1.label = 2;
                        case 2:
                            return [
                                4,
                                Promise.all((_this76.vsObjects || []).map(function() {
                                    var _ref = (0,_async_to_generator/* default */.Z)(function(item) {
                                        var ref, targetObjToReveal;
                                        return (0,tslib_es6.__generator)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    if ((0,_instanceof/* default */.Z)(item, VSObject/* TourImage */.oP)) {
                                                        targetObjToReveal = vsImagesToReveal;
                                                    } else if ((0,_instanceof/* default */.Z)(item, VSObject/* TourVideo */.Up)) {
                                                        targetObjToReveal = vsVideosToReveal;
                                                    } else if ((0,_instanceof/* default */.Z)(item, VSObject/* TourVSHtml */.q8)) {
                                                        targetObjToReveal = vsHTMLsToReveal;
                                                    } else {
                                                        targetObjToReveal = vsItemsToReveal;
                                                    }
                                                    if (!(targetObjToReveal && (targetObjToReveal === null || targetObjToReveal === void 0 ? void 0 : targetObjToReveal.indexOf(item === null || item === void 0 ? void 0 : (ref = item.id) === null || ref === void 0 ? void 0 : ref.toString())) !== -1)) return [
                                                        3,
                                                        2
                                                    ];
                                                    if (item && !item.active) return [
                                                        2,
                                                        item
                                                    ];
                                                    item.hiddenFromFlows = false;
                                                    return [
                                                        4,
                                                        _this76.setVSVisible(item, true)
                                                    ];
                                                case 1:
                                                    _state.sent();
                                                    _state.label = 2;
                                                case 2:
                                                    return [
                                                        2
                                                    ];
                                            }
                                        });
                                    });
                                    return function(item) {
                                        return _ref.apply(this, arguments);
                                    };
                                }()))
                            ];
                        case 3:
                            _state1.sent();
                            return [
                                2,
                                currentObjUuid
                            ];
                    }
                });
            });
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }();
        _this.sendTagToGA = function(sid) {
            var allTags = _this.state.allTags;
            var allTagsArray = Array.from(allTags, function(param) {
                var _param = (0,_sliced_to_array/* default */.Z)(param, 2), value = _param[1];
                return value;
            });
            var foundTag = allTagsArray.find(function(tag) {
                return tag.sid === sid || tag.defaultSid === sid;
            });
            (0,analytic/* sendToGA */.o$)("event", {
                eventCategory: "Mattertag",
                eventAction: "click",
                eventLabel: foundTag.title,
                eventType: foundTag.type
            });
        };
        var _this77 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.hideElements = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
                var hideTags, polygonsToHide, vsImagesToHide, vsVideosToHide, vsHTMLsToHide, vsItemsToHide, sweepsToHide, hiddenFromFlows, _state, allTags, polygons, sweeps, _Sweep, availableSweeps, uniqueCondSweeps, availableCondSweeps, allTagsArray, tagsToHide, res;
                var _arguments = arguments;
                return (0,tslib_es6.__generator)(this, function(_state1) {
                    switch(_state1.label){
                        case 0:
                            hideTags = param.hideTags, polygonsToHide = param.polygonsToHide, vsImagesToHide = param.vsImagesToHide, vsVideosToHide = param.vsVideosToHide, vsHTMLsToHide = param.vsHTMLsToHide, vsItemsToHide = param.vsItemsToHide, sweepsToHide = param.sweepsToHide, hiddenFromFlows = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : false;
                            _state = _this77.state, allTags = _state.allTags, polygons = _state.polygons, sweeps = _state.sweeps;
                            if (sweepsToHide && (sweepsToHide === null || sweepsToHide === void 0 ? void 0 : sweepsToHide.length) > 0) {
                                ;
                                availableSweeps = sweeps === null || sweeps === void 0 ? void 0 : sweeps.map(function(s) {
                                    return s.sid;
                                });
                                uniqueCondSweeps = new Set(sweepsToHide);
                                availableCondSweeps = Array.from(uniqueCondSweeps).filter(function(s) {
                                    return availableSweeps.includes(s);
                                });
                                (_Sweep = _this77.showcase.Sweep).disable.apply(_Sweep, (0,_to_consumable_array/* default */.Z)(availableCondSweeps)).catch(function(err) {
                                    return console.error(err);
                                });
                            }
                            allTagsArray = Array.from(allTags, function(param) {
                                var _param = (0,_sliced_to_array/* default */.Z)(param, 2), value = _param[1];
                                return value;
                            });
                            tagsToHide = hideTags === null || hideTags === void 0 ? void 0 : hideTags.map(function(tag) {
                                return allTagsArray.find(function(allTagItem) {
                                    return allTagItem.id === Number(tag) || allTagItem.sid === tag || allTagItem.defaultSid === tag;
                                });
                            });
                            console.debug("-----------disabling tags-----------", tagsToHide);
                            tagsToHide === null || tagsToHide === void 0 ? void 0 : tagsToHide.forEach(function(_tag) {
                                return _tag && _this77._changeTagPos(_tag, false);
                            });
                            if (!(polygons && polygons.map)) return [
                                3,
                                2
                            ];
                            console.debug("(hideElements) Polygons to hide", polygonsToHide, polygons);
                            return [
                                4,
                                Promise.all(polygons.map(function() {
                                    var _ref = (0,_async_to_generator/* default */.Z)(function(item) {
                                        var ref, nodeIndex;
                                        return (0,tslib_es6.__generator)(this, function(_state) {
                                            if ((polygonsToHide === null || polygonsToHide === void 0 ? void 0 : polygonsToHide.indexOf(item === null || item === void 0 ? void 0 : (ref = item.id) === null || ref === void 0 ? void 0 : ref.toString())) !== -1) {
                                                if (!(item === null || item === void 0 ? void 0 : item.active)) {
                                                    console.debug("-----------not hiding polygon (inactive) ----------", item);
                                                }
                                                console.debug("-----------hiding polygon ----------", item);
                                                nodeIndex = _this77.modelNodes.findIndex(function(node) {
                                                    var ref, ref1;
                                                    return (node === null || node === void 0 ? void 0 : (ref = node[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.obj3D) === null || ref1 === void 0 ? void 0 : ref1.uuid) === item.uuid;
                                                });
                                                if (nodeIndex >= 0) {
                                                    _this77.modelNodes[nodeIndex][0].stop();
                                                    item.uuid = null;
                                                    item.hiddenFromFlows = hiddenFromFlows;
                                                    _this77.modelNodes.splice(nodeIndex, 1);
                                                }
                                            }
                                            return [
                                                2,
                                                item
                                            ];
                                        });
                                    });
                                    return function(item) {
                                        return _ref.apply(this, arguments);
                                    };
                                }()))
                            ];
                        case 1:
                            res = _state1.sent();
                            _this77.setState({
                                polygons: res
                            });
                            _state1.label = 2;
                        case 2:
                            return [
                                4,
                                Promise.all((_this77.vsObjects || []).map(function() {
                                    var _ref = (0,_async_to_generator/* default */.Z)(function(item) {
                                        var ref, targetObjToHide;
                                        return (0,tslib_es6.__generator)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    if ((0,_instanceof/* default */.Z)(item, VSObject/* TourImage */.oP)) {
                                                        targetObjToHide = vsImagesToHide;
                                                    } else if ((0,_instanceof/* default */.Z)(item, VSObject/* TourVideo */.Up)) {
                                                        targetObjToHide = vsVideosToHide;
                                                    } else if ((0,_instanceof/* default */.Z)(item, VSObject/* TourVSHtml */.q8)) {
                                                        targetObjToHide = vsHTMLsToHide;
                                                    } else {
                                                        targetObjToHide = vsItemsToHide;
                                                    }
                                                    if (!(targetObjToHide && (targetObjToHide === null || targetObjToHide === void 0 ? void 0 : targetObjToHide.indexOf(item === null || item === void 0 ? void 0 : (ref = item.id) === null || ref === void 0 ? void 0 : ref.toString())) !== -1)) return [
                                                        3,
                                                        2
                                                    ];
                                                    if (item && !item.active) return [
                                                        2,
                                                        item
                                                    ];
                                                    console.debug("-----------hiding setVSVisible vs ----------", item);
                                                    return [
                                                        4,
                                                        _this77.setVSVisible(item, false)
                                                    ];
                                                case 1:
                                                    _state.sent();
                                                    item.hiddenFromFlows = hiddenFromFlows;
                                                    return [
                                                        2,
                                                        (0,_object_spread/* default */.Z)({}, item)
                                                    ];
                                                case 2:
                                                    return [
                                                        2
                                                    ];
                                            }
                                        });
                                    });
                                    return function(item) {
                                        return _ref.apply(this, arguments);
                                    };
                                }()))
                            ];
                        case 3:
                            _state1.sent();
                            return [
                                2
                            ];
                    }
                });
            });
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }();
        _this.updateCssMenuWidth = function(width) {
            var menuWidth = _this.state.menuOpen ? width || _this.state.menuWidth : 0;
            document.documentElement.style.setProperty("--menu-width", "".concat(menuWidth, "px"));
            document.documentElement.style.setProperty("--pano-close-btn-width", "".concat(_this.state.panoramaOn ? 60 : 0, "px"));
        };
        _this.handleUserVideoActions = function(param) {
            var chatOn = param.chatOn;
            _this.setState((0,_object_spread/* default */.Z)({}, chatOn !== undefined ? {
                videoChatOn: chatOn
            } : {}));
        };
        _this.handleUserBottomBarActions = function(param) {
            var chatOn = param.chatOn;
            _this.setState((0,_object_spread/* default */.Z)({}, chatOn !== undefined ? {
                bottomBarChatOn: chatOn
            } : {}));
        };
        _this.hideTreedisTagTooltip = function(event) {
            var forceClose = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
            if (forceClose) {
                _this.resetTagHoverAndPopupView();
                return;
            }
            var tagTooltip = document.getElementById("base-tag-tooltip");
            if (!(0,_instanceof/* default */.Z)(event.target, Node)) return;
            if (tagTooltip && !tagTooltip.contains(event.target)) {
                _this.resetTagHoverAndPopupView();
            }
        };
        _this.state = {
            isTagHovered: false,
            tagHovered: null,
            lastTagHovered: null,
            selectedTag: null,
            allAudio: null,
            iframeId: "iframe_".concat((0,randomNumberId/* randomNumberId */._)()),
            showcaseLoaded: false,
            showSketchfabPopup: false,
            tour: null,
            floors: [],
            allowGuestBeforeHost: false,
            changeMenu: false,
            pathfinderDataState: {},
            menus: [],
            menuSettings: {},
            iot: {
                devices: [],
                newDoorNotification: null,
                sceneAssets: [],
                lockDeviceId: null,
                moveToDevice: null,
                openCamera: null,
                menuSettings: {},
                providers: [],
                favouriteCameras: [],
                openFavouriteCameras: null
            },
            reelVideos: [],
            pinnedVideos: [],
            reel: [],
            changeReel: false,
            sweeps: [],
            mpFloors: [],
            mpLabels: [],
            translation: {},
            tourEmail: null,
            sweepGroups: [],
            host: props.rule === "host",
            audioOnly: props.videoType === "audio",
            minimaps: [],
            clickedTag: false,
            allTags: new Map(),
            interacted: false,
            selectedMinimap: 0,
            menuOpened: false,
            iframeUrl: null,
            menuOpen: false,
            musicPausedByUser: false,
            tourAudioPlaying: false,
            vsHTMLPopup: {
                show: false,
                src: null
            },
            overlayOn: false,
            videoPlaying: false,
            externalPopupOn: false,
            contactPopupOn: false,
            panoramas: [],
            polygons: [],
            agents: [],
            tagPopOn: false,
            panoPopOn: false,
            gameLockPopOn: false,
            openedLock: null,
            userAnswerForGameLock: null,
            videoChatTagPopOn: false,
            vsActionPopOn: false,
            panoramaOn: false,
            openedTag: null,
            openedPanoHotspot: null,
            openedVSAction: new VSObject/* TourImage */.oP(),
            externalPopupUrl: null,
            minimapOn: false,
            minimapVisible: false,
            measurementsOn: false,
            markerPopupOn: false,
            sharePopupOn: false,
            tourPlaying: false,
            mapWalkerRotation: 0,
            reelStep: 0,
            mapWalkerX: null,
            mapWalkerY: null,
            activeSweepGroup: null,
            dominantSpeaker: null,
            // user: null,
            selectedMarker: {
                url: null,
                external: null
            },
            tokenRemainingTime: -1,
            tokenExpiresAt: null,
            // createdAt: null,
            // clock: false,
            ticketingOpen: false,
            activePano: null,
            appointmentsModal: false,
            appointmentsHintOn: true,
            getInTouchHintOn: true,
            MenuHintOn: true,
            lock: false,
            room: props.room,
            whiteLabelData: null,
            showHelpModal: false,
            showTermsModal: false,
            activeMenu: null,
            products: [],
            tourType: tourType,
            vsSettings: new VSSettings/* VSSettings */.E(),
            isVSReady: false,
            containerId: "public",
            loadingTags: true,
            game: null,
            currentFloor: null,
            panoPose: {
                yaw: 0,
                pitch: 0,
                hfov: 0
            },
            isVSEnabled: true,
            isVSVisible: true,
            loadedOnce: false,
            showPathFinderPopup: false,
            ticketTimeLeftMs: null,
            tourMode: null,
            experiencePopUpIsOpen: false,
            onExperienceCloseCallback: function() {
                return undefined;
            },
            currentSweep: null,
            experiencePopUpData: null,
            closedElementPopup: true,
            isEnableNextPathLock: true,
            initialDuplicates: null,
            isChangeIframe: false,
            avatar: {},
            isClickedTag: false,
            chatParticipant: {},
            infoModalData: null,
            gameTrialErr: null,
            crashScreen: false,
            unlockedChapterIds: [],
            clickedElements: [],
            hideSubtitlesGroupId: null,
            showBottomBar: true,
            hideBottomBarForWhile: false,
            isShowNearestProducts: true,
            nearestProducts: [],
            waitLoadingPolygons: false,
            isClickedElement: false,
            isShowProducts: false,
            isShowProduct: false,
            startScreenOn: false,
            showCookieFullScreen: false,
            hideLogo: false,
            // Needed for sepecific NYT tours
            isSubtitleVisible: false,
            mondelezTabletVideo: {
                videoId: undefined,
                sweepsHistory: []
            },
            menuWidth: 0,
            actionPathNavbarData: {
                enableNavBar: false,
                destinationTitle: null,
                icon: null,
                autoNavigation: false,
                enableTeleportBtn: false
            },
            showActionPathBar: false,
            actionPathNavbarPlayButtonType: "Play",
            actionPathNavbarDistance: null,
            closeBurgerMenuFromThreads: false,
            isThreadsDrawerOpen: false,
            threadsLoaded: false,
            confirmDialog: {
                open: false,
                title: "",
                desc: "",
                showInput: false,
                onAgree: function() {},
                onCancel: function() {}
            },
            actionPathFinished: false,
            navigationStartPosition: null,
            navigationTarget: null,
            isNavigationBackgroundVisible: true,
            shouldNavReset: false,
            showTeleportLoading: false,
            endTeleportName: "",
            endTpType: NavigationWrapper/* TeleportGroupType.Elevator */.A.Elevator,
            iotModalOpen: false,
            iotModalShowDescription: false,
            tagPopupOpen: false,
            tagPopupShowDescription: false,
            // flows
            flowIsActive: false,
            mainFlow: null,
            flows: [],
            flowsObjects: [],
            flowAssetsToDisableAction: [],
            flowsVisibleAssets: {
                videos: [],
                objects: []
            },
            startFlowFromAsset: null
        };
        _this.loadingQueue = LoadingQueue/* default.getInstance */.Z.getInstance();
        _this.loadingQueue.subscribe(function(loaded) {
            if (loaded === true) {
                // commented untill find good solution for youtube embed scroll fix for windows that will not affect other attachments
                // const style = document.createElement('style');
                // style.innerText = '.tag-media .attachment-carousel .attachment-carousel-view .attachment {height: 205px;}';
                // this.iframe.contentDocument.head.appendChild(style);
                _this.setState({
                    loaded: true
                });
            }
        });
        _this.rendererRef = /*#__PURE__*/ react.createRef();
        _this.gamepadLRef = /*#__PURE__*/ react.createRef();
        _this.gamepadRRef = /*#__PURE__*/ react.createRef();
        _this.cameraPose = /*#__PURE__*/ react.createRef();
        _this.pathArrowRefBaseTour = /*#__PURE__*/ react.createRef();
        _this.deferVisibilityVSObjectRef = /*#__PURE__*/ react.createRef();
        _this.deferVisibilityVSObjectRef.current = [];
        _this.calculateLocation = calculateLocation.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.buildLink = util_all/* buildLink.bind */.DF.bind((0,_assert_this_initialized/* default */.Z)(_this)); // need this code ??
        _this.openTagIframe = sdk/* openTagIframe.bind */.$O.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.openVsObjectIframe = sdk/* openVsObjectIframe.bind */.BY.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.openVsImageIframe = sdk/* openVsImageIframe.bind */.IW.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.openVsVideoIframe = sdk/* openVsVideoIframe.bind */.O7.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.loadModel = sdk/* loadModel.bind */.u7.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.moveToMPLabels = sdk/* moveToMPLabels.bind */.QO.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.setWhiteLabel = util_all/* setWhiteLabel.bind */.Jw.bind((0,_assert_this_initialized/* default */.Z)(_this));
        document.addEventListener("keydown", _this.takePosition);
        _this.toggleExternalPopup = popups/* toggleExternalPopup.bind */.J.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.toggleExternalPopupNull = popups/* toggleExternalPopup.bind */.J.bind((0,_assert_this_initialized/* default */.Z)(_this), null);
        _this.toggleContactPopup = popups/* toggleContactPopup.bind */.O.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.takeScreenshot = sdk/* takeScreenshot.bind */.ss.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.takePano = sdk/* takePano.bind */.Zy.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.openedPanoHotspot = sdk/* openedPanoHotspot.bind */.Z4.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.setNavigationDestination = navigation/* setNavigationDestination.bind */.No.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.moveToNavigationStartingPoint = navigation/* moveToStartingPoint.bind */.bO.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.buildPipes = buildPipes.bind((0,_assert_this_initialized/* default */.Z)(_this));
        var room = _this.state.room;
        _this.prevPathFinderData = {
            isEnablePreviousStep: false,
            description: ""
        };
        _this.animate();
        socket/* default.on */.Z.on("move_avatar", function(data) {
            var ref, ref1, ref2, ref3;
            var tour = _this.state.tour;
            var THREE = (0,_assert_this_initialized/* default */.Z)(_this).THREE;
            if (!(tour === null || tour === void 0 ? void 0 : tour.enableAvatar)) return;
            var avatar = _this.avatarNodes.get(data.avatarId);
            // Is the avatar moving into my sweep? (sweep id...)
            // if it does, use relative position, avatar.relative
            var ref4 = (0,_sliced_to_array/* default */.Z)(pointsOnCircle2D(virtualStaging_avatar/* AVATAR_CIRCLE_RADIUS */.iG, 180 + _this.avatarDegree, data === null || data === void 0 ? void 0 : (ref = data.pose) === null || ref === void 0 ? void 0 : (ref1 = ref.position) === null || ref1 === void 0 ? void 0 : ref1.x, (ref2 = data.pose) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.position) === null || ref3 === void 0 ? void 0 : ref3.z), 2), myX = ref4[0], myZ = ref4[1];
            var ref5 = (0,_sliced_to_array/* default */.Z)(pointsOnCircle2D(virtualStaging_avatar/* AVATAR_CIRCLE_RADIUS */.iG, data.degree, myX, myZ), 2), x = ref5[0], z = ref5[1];
            if (avatar && avatar[1] && avatar[1].outputs.loadingState === VSObject/* LoadingState.Loaded */.Gu.Loaded) {
                console.log(avatar[1].inputs.bodyType);
                if (avatar[1].inputs.bodyType === "fullbody") {
                    if (data.pose.sweep.sid !== "") {
                        // check if avatar sweep has changed
                        var shouldAnimationPlay = _this.didAvatarSweepChange(avatar[1].id, data.pose.sweep.id);
                        if (shouldAnimationPlay) {
                            var targetPosVec3 = new THREE.Vector3(data.degree && _this.avatarDegree ? x : data.pose.sweep.position.x, data.pose.sweep.position.y, data.degree && _this.avatarDegree ? z : data.pose.sweep.position.z);
                            _this.moveAvatarToPoint(avatar, targetPosVec3, THREE);
                        }
                        avatar[0].obj3D.children[0].children[0].rotation.set(-Math.PI / 2, 0, 0);
                    }
                    var vec3 = new THREE.Vector3(0, 0, 1);
                    var quaternion = new THREE.Quaternion(data.pose.quaternion[0], data.pose.quaternion[1], data.pose.quaternion[2], data.pose.quaternion[3]);
                    vec3.applyQuaternion(quaternion);
                    var vec3Projected = vec3.clone();
                    vec3Projected.projectOnPlane(_this.yAxisVec3);
                    vec3Projected.negate().normalize();
                    var mx = new THREE.Matrix4().lookAt(vec3Projected, new THREE.Vector3(0, 0, 0), new THREE.Vector3(0, 1, 0));
                    var qt = new THREE.Quaternion().setFromRotationMatrix(mx);
                    avatar[1].rotateTo(qt, function(tween) {
                        // If there is active tween, stops it. Replaces/adds this tween to avatarId
                        var avatarTweenData = _this.connectedAvatarsTweens.find(function(el) {
                            return el.avatarId === avatar[1].id;
                        });
                        if (avatarTweenData) {
                            if (avatarTweenData.activeRotationTween) avatarTweenData.activeRotationTween.stop();
                            if (avatarTweenData.activeTween) tween.stop();
                            avatarTweenData.activeRotationTween = tween;
                        } else _this.connectedAvatarsTweens.push({
                            avatarId: avatar[1].id,
                            activeTween: null,
                            activeRotationTween: tween
                        });
                    }, function() {
                        var avatarTweenData = _this.connectedAvatarsTweens.find(function(el) {
                            return el.avatarId === avatar[1].id;
                        });
                        avatarTweenData.activeRotationTween = null;
                    });
                // uncomment if performance is bad due to rotation smoothing
                // avatar[0].obj3D.children[0].quaternion.set(qt.x, qt.y, qt.z, qt.w);
                // avatar[0].obj3D.children[0].rotateX(-Math.PI / 2);
                }
                if (avatar[1].inputs.bodyType === "halfbody") {
                    var ref6;
                    avatar[1].avatarHasMoved = true;
                    avatar[1].root.visible = true;
                    avatar[0].obj3D.position.set(data.degree && _this.avatarDegree ? x : data.pose.sweep.position.x, data.pose.position.y, data.degree && _this.avatarDegree ? z : data.pose.sweep.position.z);
                    avatar[0].obj3D.children[0].position.set(0, -0.6, 0);
                    avatar[0].obj3D.quaternion.set(data.pose.quaternion[0], data.pose.quaternion[1], data.pose.quaternion[2], data.pose.quaternion[3]);
                    (ref6 = avatar[0].obj3D.children[0]) === null || ref6 === void 0 ? void 0 : ref6.rotation.set(0, Math.PI, 0);
                }
                if (avatar[1].inputs.bodyType === "image") {
                    avatar[1].avatarHasMoved = true;
                    avatar[1].root.visible = true;
                    avatar[0].obj3D.position.set(// data.degree && this.avatarDegree ? x : data.pose.sweep.position.x,
                    x || data.pose.sweep.position.x, data.pose.position.y, z || data.pose.sweep.position.z);
                // avatar[0].obj3D.children[0].position.set(0, -0.6, 0);
                }
            }
        });
        socket/* default.on */.Z.on("move_avatar_face", function(data) {
            var tour = _this.state.tour;
            if (!(tour === null || tour === void 0 ? void 0 : tour.enableAvatar)) return;
            var avatar = _this.avatarNodes.get(data.avatarId);
            if (avatar) {
                avatar[1].updateFromResults(data.pose);
            }
        });
        socket/* default.on */.Z.on("all_users", function(users) {
            var tour = _this.state.tour;
            if (tour.enableAvatar) {
                // first we set our degree
                if (_this.avatarDegree === null) {
                    var myself = users.find(function(user) {
                        return user.socketId === socket/* default.id */.Z.id;
                    });
                    _this.avatarDegree = myself.degree;
                    console.log("Assigned degree", _this.avatarDegree);
                }
                // then we add all avatars
                users.forEach(function(user, i) {
                    if (user.socketId !== socket/* default.id */.Z.id) {
                        // user.degree = (i+1)*7;
                        _this.addAvatar(user);
                    }
                });
            }
        });
        var _this78 = (0,_assert_this_initialized/* default */.Z)(_this);
        socket/* default.on */.Z.on("user_leave", function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
                var tour;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            tour = _this78.state.tour;
                            if (!(tour === null || tour === void 0 ? void 0 : tour.enableAvatar)) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                _this78.onRemoveAvatar(data.avatarId)
                            ];
                        case 1:
                            _state.sent();
                            _state.label = 2;
                        case 2:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(data) {
                return _ref.apply(this, arguments);
            };
        }());
        socket/* default.on */.Z.on("move", function(pose) {
            if (_this.state.lock) {
                _this.moveToSweepIO(pose);
            }
        });
        if (room) {
            socket/* default.on */.Z.on("menu", function(menu) {
                _this.loadModel(menu.name, menu.url, menu.type);
            });
            socket/* default.on */.Z.on("tag_click", function(tag) {
                if (_this.state.lock) {
                    _this.moveToTagIO(tag, tag.action === "click");
                }
            });
            socket/* default.on */.Z.on("tag_hover", function(tag) {});
            socket/* default.on */.Z.on("vs", function(data) {
                if (_this.state.lock) {
                    var vsImageId = data.vsImageId, vsVideoId = data.vsVideoId, vsObjectId = data.vsObjectId, eventData = data.eventData, type = data.type;
                    var instance = null;
                    var searchId = vsImageId;
                    if (vsImageId) {
                        var ref;
                        instance = (ref = _this.showCaseTemp.scene) === null || ref === void 0 ? void 0 : ref.sceneImage;
                        searchId = vsImageId;
                    } else if (vsVideoId) {
                        var ref1;
                        instance = (ref1 = _this.showCaseTemp.scene) === null || ref1 === void 0 ? void 0 : ref1.sceneVideo;
                        searchId = vsVideoId;
                    } else if (vsObjectId) {
                        var ref2;
                        instance = (ref2 = _this.showCaseTemp.scene) === null || ref2 === void 0 ? void 0 : ref2.sceneObject;
                        searchId = vsObjectId;
                    }
                    if (instance && (instance === null || instance === void 0 ? void 0 : instance.assets)) {
                        instance.assets.forEach(function(param) {
                            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), assetKey = _param[0], node = _param[1];
                            if (assetKey.id === searchId) {
                                var _node = (0,_sliced_to_array/* default */.Z)(node, 2), component = _node[1];
                                component.onEvent(type, eventData);
                            }
                        });
                    }
                }
            });
            socket/* default.on */.Z.on("polygon", function(data) {
                if (_this.state.lock) {
                    var type = data.type, assetId = data.assetId, eventData = data.eventData;
                    var ref = (0,_sliced_to_array/* default */.Z)(_this.showCaseTemp.scene.scenePolygon.assets.get(assetId), 2), component = ref[1];
                    if (component && type) {
                        component.onEvent(type, eventData);
                    }
                }
            });
            socket/* default.on */.Z.on("lock", function(_lock) {
                if (_this.state.lock !== _lock) {
                    _this.setState({
                        lock: _lock
                    });
                }
            });
            socket/* default.on */.Z.on("close-tag", function() {
                _this.setState({
                    tagPopOn: false
                });
            });
            socket/* default.on */.Z.on("close-embed-tag", debounce_default()(function() {
                var embedTagContentElem = _this.getShowcaseElement(components_types/* ShowcaseElement.TagEmbedMedia */.o2.TagEmbedMedia);
                if (embedTagContentElem === null || embedTagContentElem === void 0 ? void 0 : embedTagContentElem.firstChild) {
                    setTimeout(function() {
                        embedTagContentElem.firstChild.click();
                    }, 500);
                }
            }, 100));
            socket/* default.on */.Z.on("close-polygon", function() {
                _this.closeActionPop();
            });
            socket/* default.on */.Z.on("close-pano-pop", function() {
                _this.setState({
                    panoPopOn: false
                });
            });
            socket/* default.on */.Z.on("toggle-pano", function(data) {
                _this.setState(data);
            });
            socket/* default.on */.Z.on("move-pano", function(data) {
                _this.setState({
                    panoPose: data.panoPose,
                    activePano: data.currentPanorama.id
                });
            });
            socket/* default.on */.Z.on("pano-hotspot-click", function(data) {
                _this.setState({
                    panoramaOn: false,
                    activePano: null
                }, function() {
                    _this.getTour({
                        slug: data.id,
                        changeMenu: data.changeMenu,
                        changeMinimap: data.changeMinimap,
                        changePanorama: data.changePanorama,
                        url: data.url,
                        tourData: props.tourData
                    });
                });
            });
        }
        socket/* default.on */.Z.on("disconnect", function(reason) {
            console.error("Socket disconnected", reason);
        });
        socket/* default.io.on */.Z.io.on("reconnect", function() {
            console.log("Reconnecting socket.. enabling avatar again");
            _this.initAvatar().catch(function(e) {
                console.error("Error enabling avatar", e);
            });
        });
        // @ts-ignore
        window.startTime = Date.now();
        window.addEventListener("beforeunload", function() {
            var ref, ref1, ref2;
            // Make sure window has tourInfo!
            // @ts-ignore
            if (!window.tourId) {
                // @ts-ignore
                window.tourId = props.tourData.id;
            }
            (0,analytic/* sendToGA */.o$)("event", {
                // @ts-ignore
                tourId: window.tourId,
                eventCategory: "TourTime",
                eventAction: "timeTrack",
                eventLabel: "timeTrack",
                time: {
                    // @ts-ignore
                    startTime: window.startTime,
                    endTime: Date.now()
                }
            }, true // skip google analytics
            ).catch(function(err) {
                console.error(err);
            });
            logoutHandler({
                ticket: (ref = _this.state) === null || ref === void 0 ? void 0 : (ref1 = ref.tour) === null || ref1 === void 0 ? void 0 : ref1.ticket,
                ticketingOrderedTicket: (ref2 = _this.state.ticketing) === null || ref2 === void 0 ? void 0 : ref2.ticketingOrderedTicket
            }).catch(function(err) {
                console.error(err);
            });
        });
        (0,styles/* calculateMobileHeight */.U_)();
        window.addEventListener("resize", styles/* calculateMobileHeight */.U_);
        document.addEventListener("click", _this.hideTreedisTagTooltip);
        document.addEventListener("touchstart", _this.hideTreedisTagTooltip);
        events/* emitter.on */.u.on(events/* MittEvents.AUDIO_MUTE */.s.AUDIO_MUTE, function(e) {
            var mute = e.mute;
            if (mute) _this.muteAllVsVideos();
        });
        events/* emitter.on */.u.on(events/* MittEvents.TOUR_AUDIO_PLAY */.s.TOUR_AUDIO_PLAY, function(e) {
            var play = e.isTourMusic;
            _this.setState({
                tourAudioPlaying: play
            });
        });
        return _this;
    }
    var _proto = BaseTour.prototype;
    _proto.moveAvatarToPoint = function moveAvatarToPoint(avatar, targetPosVec3, THREE) {
        var _this = this;
        // Make avatar look at direction of target sweep while in animation
        var qt = getProjectedQuaternion(avatar[0].obj3D.position, targetPosVec3, this.yAxisVec3, THREE);
        avatar[1].moveToPos(targetPosVec3, qt, function(tween) {
            // If there is active tween, stops it. Replaces/adds this tween to avatarId
            var avatarTweenData = _this.connectedAvatarsTweens.find(function(el) {
                return el.avatarId === avatar[1].id;
            });
            if (avatarTweenData) {
                if (avatarTweenData.activeTween) avatarTweenData.activeTween.stop();
                avatarTweenData.activeTween = tween;
            } else _this.connectedAvatarsTweens.push({
                avatarId: avatar[1].id,
                activeTween: tween,
                activeRotationTween: null
            });
        }, function() {
            var avatarTweenData = _this.connectedAvatarsTweens.find(function(el) {
                return el.avatarId === avatar[1].id;
            });
            avatarTweenData.activeTween = null;
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        window.removeEventListener("resize", styles/* calculateMobileHeight */.U_);
        document.removeEventListener("click", this.hideTreedisTagTooltip);
        document.removeEventListener("touchstart", this.hideTreedisTagTooltip);
        events/* emitter.off */.u.off(events/* MittEvents.AUDIO_MUTE */.s.AUDIO_MUTE);
    };
    _proto.setParentState = function setParentState(attr, val) {
        this.setState((0,_define_property/* default */.Z)({}, attr, val));
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState, snapshot) {
        var _this = this;
        var ref;
        // Hide MP VR button after closing tag popup
        if (this.state.hideBottomBarForWhile !== prevState.hideBottomBarForWhile) {
            if (deviceManager/* default.isMobile */.Z.isMobile() && !deviceManager/* default.isDesktop */.Z.isDesktop()) {
                setTimeout(function() {
                    var vrOverlay = _this.getShowcaseElement(components_types/* ShowcaseElement.VRLayer */.o2.VRLayer);
                    if (vrOverlay) {
                        var iframeVrButton = vrOverlay.querySelector('[role="button"]');
                        if (iframeVrButton) iframeVrButton.style.display = "none";
                    }
                }, 100);
            }
        }
        if ((ref = this.state.game) === null || ref === void 0 ? void 0 : ref.backpackOn) {
            this.updateBackpackMesh();
        }
        this.updatePathFinderMeshHtml();
        this.updateCssMenuWidth();
    };
    _proto.updatePathFinderMeshHtml = function updatePathFinderMeshHtml() {
        var ref;
        var hasData = hasPathFinderData(this.state.pathfinderDataState);
        if (!this.pathFinderMeshComponent || !this.pathFinderMeshComponent.inputs.refs || !hasData) return;
        this.pathFinderMeshComponent.inputs.hasPathFinderData = hasData;
        if (!this.pathFinderMeshComponent.hostPose) (ref = this.pathFinderMeshComponent) === null || ref === void 0 ? void 0 : ref.setHostPose(this.pose);
        updateStylesAndContent({
            pathFinderMeshComponent: this.pathFinderMeshComponent,
            pathfinderDataState: this.state.pathfinderDataState,
            game: this.state.game,
            prevPathFinderData: this.prevPathFinderData
        });
    };
    _proto.initVRTags = function initVRTags(tags) {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            _this.showCaseTemp.showcase.Scene.register(matterTagMeshComponentType, makeMatterTagMeshComponent)
                        ];
                    case 1:
                        _state.sent();
                        tags.forEach(function(tag) {
                            _this.initTagMesh(tag);
                        });
                        return [
                            2
                        ];
                }
            });
        })();
    };
    _proto.updateBackpackMesh = function updateBackpackMesh() {
        var ref;
        var items = (ref = this.state.game) === null || ref === void 0 ? void 0 : ref.locks.filter(function(lock) {
            return lock.type === "collectItems";
        });
        if (items === null || items === void 0 ? void 0 : items.length) {
            this.backpack = {
                items: items
            };
            if (this.backpackMeshComponent) {
                var itemElements = this.backpackMeshComponent.inputs.refs.itemElements;
                items.forEach(function(item) {
                    var itemElement = itemElements.find(function(el) {
                        return el.name === item.name;
                    });
                    if (!itemElement) {
                        console.error("Tour backpack and VR backpack items mismatch");
                        return;
                    }
                    itemElement.ref.textContent = "".concat(item.name, " ").concat(item.collected.length, "/").concat(item.solution.split("|").length);
                });
            }
        }
    };
    _proto.initTagMesh = function initTagMesh(tagData) {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var tour, media, dimensions, ref, html, imageContainer, modelNode, component, err;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            6,
                            ,
                            7
                        ]);
                        tour = _this.state.tour;
                        media = null;
                        if (tagData.url) media = tagData.type === "image" ? "".concat("https://cdn.treedis.com", "/tours/").concat(tour === null || tour === void 0 ? void 0 : tour.id, "/tags/").concat(tagData.url) : null;
                        dimensions = {
                            width: media ? 400 : 360
                        };
                        ref = createMatterTagHTML(tagData, media, dimensions), html = ref.html, imageContainer = ref.imageContainer;
                        if (!imageContainer) return [
                            3,
                            2
                        ];
                        imageContainer.src = media;
                        return [
                            4,
                            imageContainer.decode().catch(function(e) {
                                console.error("An error occurred when decoding media of tag ".concat(tagData.id), e);
                            })
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            _this.showCaseTemp.mpSDK.Scene.createNode()
                        ];
                    case 3:
                        modelNode = _state.sent();
                        return [
                            4,
                            modelNode.addComponent(matterTagMeshComponentType, {
                                html: html,
                                tagData: tagData,
                                media: media,
                                dimensions: dimensions,
                                scale: 0.08,
                                visible: typeof base/* asyncStore.vrIsOn */.k6.vrIsOn === "boolean" ? base/* asyncStore.vrIsOn */.k6.vrIsOn : false,
                                popupScale: 10
                            })
                        ];
                    case 4:
                        component = _state.sent();
                        return [
                            4,
                            modelNode.start()
                        ];
                    case 5:
                        _state.sent();
                        _this.matterTagMeshComponents.push(component);
                        component.onEvent = function(type, eventData) {
                            if (type === Scene_component/* ComponentInteractionType.CLICK */.td.CLICK) {
                                var ref, ref1;
                                if (((ref = eventData.collider) === null || ref === void 0 ? void 0 : ref.name) === "tag") {
                                    if (_this.openedVRTag && tagData.id !== _this.openedVRTag) {
                                        var openedTag = _this.matterTagMeshComponents.find(function(tag) {
                                            return tag.tagId === _this.openedVRTag;
                                        });
                                        if (openedTag) openedTag.inputs.popupVisible = false;
                                    }
                                    component.inputs.popupVisible = !component.inputs.popupVisible;
                                }
                                if (((ref1 = eventData.collider) === null || ref1 === void 0 ? void 0 : ref1.name) === "closeBtn") component.inputs.popupVisible = false;
                                _this.openedVRTag = component.inputs.popupVisible ? tagData.id : null;
                            }
                            if (type === Scene_component/* ComponentInteractionType.HOVER */.td.HOVER && _this.VRPointer.component) {
                                if (eventData.hover) {
                                    _this.VRPointer.component.setVisible(true);
                                    _this.VRPointer.target = component;
                                } else _this.VRPointer.component.setVisible(false);
                            }
                        };
                        return [
                            3,
                            7
                        ];
                    case 6:
                        err = _state.sent();
                        console.error(err);
                        return [
                            3,
                            7
                        ];
                    case 7:
                        return [
                            2
                        ];
                }
            });
        })();
    };
    _proto.initVRPointer = function initVRPointer() {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var modelNode, component;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            _this.showCaseTemp.showcase.Scene.register(VRPointerComponentType, makeVRPointerComponent)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            4,
                            _this.showCaseTemp.mpSDK.Scene.createNode()
                        ];
                    case 2:
                        modelNode = _state.sent();
                        return [
                            4,
                            modelNode.addComponent(VRPointerComponentType, {})
                        ];
                    case 3:
                        component = _state.sent();
                        component.hostPose = _this.camera;
                        return [
                            4,
                            modelNode.start()
                        ];
                    case 4:
                        _state.sent();
                        _this.VRPointer.component = component;
                        _this.showCaseTemp.mpSDK.Pointer.intersection.subscribe(function(intersectionData) {
                            if (component.root && _this.VRPointer.target) {
                                var _position = intersectionData.position, x = _position.x, y = _position.y, z = _position.z;
                                component.root.position.set(x, y, z);
                            }
                        });
                        return [
                            2
                        ];
                }
            });
        })();
    };
    _proto.initPathFinderMesh = function initPathFinderMesh() {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var ref, ref1, html, refs, modelNode, component;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        ref1 = createPathFinderHTML(), html = ref1.html, refs = ref1.refs;
                        refs.buttonBack.addEventListener("click", function() {
                            try {
                                var ref, ref1;
                                (ref = _this.state.pathfinderDataState) === null || ref === void 0 ? void 0 : ref.handlePreviousStep();
                                (ref1 = _this.pathFinderMeshComponent) === null || ref1 === void 0 ? void 0 : ref1.setVisible(false);
                            } catch (error) {
                                console.error();
                                console.error("Starting sweep not found, error: ", error);
                            }
                        });
                        refs.buttonNext.addEventListener("click", function() {
                            try {
                                var ref, ref1;
                                (ref = _this.state.pathfinderDataState) === null || ref === void 0 ? void 0 : ref.handleNextStep();
                                (ref1 = _this.pathFinderMeshComponent) === null || ref1 === void 0 ? void 0 : ref1.setVisible(false);
                            } catch (error) {
                                console.error("Starting sweep not found, error: ", error);
                            }
                        });
                        return [
                            4,
                            _this.showCaseTemp.showcase.Scene.register(pathFinderMeshComponentType, makePathFinderMeshComponent)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            4,
                            _this.showCaseTemp.mpSDK.Scene.createNode()
                        ];
                    case 2:
                        modelNode = _state.sent();
                        return [
                            4,
                            modelNode.addComponent(pathFinderMeshComponentType, {
                                html: html,
                                visible: false,
                                scale: 0.5,
                                refs: refs,
                                hasPathFinderData: false
                            })
                        ];
                    case 3:
                        component = _state.sent();
                        return [
                            4,
                            modelNode.start()
                        ];
                    case 4:
                        _state.sent();
                        _this.pathFinderMeshComponent = component;
                        (ref = _this.pathFinderMeshComponent) === null || ref === void 0 ? void 0 : ref.setHostPose(_this.pose);
                        component.onEvent = function(type, eventData) {
                            if (type === Scene_component/* ComponentInteractionType.HOVER */.td.HOVER && _this.VRPointer.component) {
                                if (eventData.hover) {
                                    _this.VRPointer.component.setVisible(true);
                                    _this.VRPointer.target = component;
                                } else _this.VRPointer.component.setVisible(false);
                            }
                        };
                        _this.updatePathFinderMeshHtml();
                        return [
                            2
                        ];
                }
            });
        })();
    };
    _proto.moveToMenuItem = function moveToMenuItem(menu) {
        var ref = this, moveToMPLabels = ref.moveToMPLabels, loadModel = ref.loadModel;
        if (menu.type === Menu/* MenuType.MatterportLabel */.o.MatterportLabel || menu.type === Menu/* MenuType.MatterportFloor */.o.MatterportFloor) {
            moveToMPLabels(menu);
        } else {
            loadModel(menu.title, menu.url, menu.type, menu.tag, menu.panoramaId, menu.changeMinimap, menu.changePanorama, menu.iframeSettings);
        }
    };
    _proto.initMenuMesh = function initMenuMesh() {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var ref, html, itemRefArr, modelNode, component, e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            5,
                            ,
                            6
                        ]);
                        ref = createMenuHTML(_this.state.menus), html = ref.html, itemRefArr = ref.itemRefArr;
                        itemRefArr.forEach(function(menu, index) {
                            menu.addEventListener("click", function() {
                                _this.moveToMenuItem(_this.state.menus[index]);
                                _this.menuMeshComponent.setVisible(false);
                            });
                        });
                        return [
                            4,
                            _this.showCaseTemp.showcase.Scene.register(menuMeshComponentType, makeMenuMeshComponent)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            4,
                            _this.showCaseTemp.mpSDK.Scene.createNode()
                        ];
                    case 2:
                        modelNode = _state.sent();
                        return [
                            4,
                            modelNode.addComponent(menuMeshComponentType, {
                                html: html,
                                visible: false,
                                scale: 0.5,
                                itemRefArr: itemRefArr,
                                controller: types/* ControllerType.GamepadL */.C.GamepadL,
                                controllerButtonIndex: 1
                            })
                        ];
                    case 3:
                        component = _state.sent();
                        return [
                            4,
                            modelNode.start()
                        ];
                    case 4:
                        _state.sent();
                        _this.menuMeshComponent = component;
                        component.onEvent = function(type, eventData) {
                            if (type === Scene_component/* ComponentInteractionType.HOVER */.td.HOVER && _this.VRPointer.component) {
                                if (eventData.hover) {
                                    _this.VRPointer.component.setVisible(true);
                                    _this.VRPointer.target = component;
                                } else _this.VRPointer.component.setVisible(false);
                            }
                        };
                        return [
                            3,
                            6
                        ];
                    case 5:
                        e = _state.sent();
                        console.error(e);
                        return [
                            3,
                            6
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        })();
    };
    _proto.initFlowsMenuMesh = function initFlowsMenuMesh(flows) {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var ref, html, itemRefArr, modelNode, component;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        ref = createFlowsMenuHTML(flows), html = ref.html, itemRefArr = ref.itemRefArr;
                        return [
                            4,
                            _this.showCaseTemp.showcase.Scene.register(menuMeshComponentType, makeMenuMeshComponent)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            4,
                            _this.showCaseTemp.mpSDK.Scene.createNode()
                        ];
                    case 2:
                        modelNode = _state.sent();
                        return [
                            4,
                            modelNode.addComponent(menuMeshComponentType, {
                                html: html,
                                visible: false,
                                scale: 0.5,
                                itemRefArr: itemRefArr,
                                controller: types/* ControllerType.GamepadL */.C.GamepadL,
                                controllerButtonIndex: 1
                            })
                        ];
                    case 3:
                        component = _state.sent();
                        return [
                            4,
                            modelNode.start()
                        ];
                    case 4:
                        _state.sent();
                        _this.flowsMenuMeshComponent = component;
                        component.onEvent = function(type, eventData) {
                            if (type === Scene_component/* ComponentInteractionType.HOVER */.td.HOVER && _this.VRPointer.component) {
                                if (eventData.hover) {
                                    _this.VRPointer.component.setVisible(true);
                                    _this.VRPointer.target = component;
                                } else _this.VRPointer.component.setVisible(false);
                            }
                        };
                        component.gamepadButtonCallback = function() {
                            _this.setAllSweepsEnabled(!component.inputs.visible);
                        };
                        component.onVisibleChange = function() {
                            if (_this.flowsBarMeshComponent && component.inputs.visible) _this.flowsBarMeshComponent.setVisible(false);
                        };
                        return [
                            2
                        ];
                }
            });
        })();
    };
    _proto.initFlowsBarMesh = function initFlowsBarMesh() {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var ref, html, itemRefArr, modelNode, component;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        ref = createFlowsBarHTML(), html = ref.html, itemRefArr = ref.itemRefArr;
                        return [
                            4,
                            _this.showCaseTemp.showcase.Scene.register(menuMeshComponentType, makeMenuMeshComponent)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            4,
                            _this.showCaseTemp.mpSDK.Scene.createNode()
                        ];
                    case 2:
                        modelNode = _state.sent();
                        return [
                            4,
                            modelNode.addComponent(menuMeshComponentType, {
                                html: html,
                                visible: false,
                                scale: 0.5,
                                itemRefArr: itemRefArr,
                                controller: types/* ControllerType.GamepadR */.C.GamepadR,
                                controllerButtonIndex: 4
                            })
                        ];
                    case 3:
                        component = _state.sent();
                        return [
                            4,
                            modelNode.start()
                        ];
                    case 4:
                        _state.sent();
                        _this.flowsBarMeshComponent = component;
                        component.onEvent = function(type, eventData) {
                            if (type === Scene_component/* ComponentInteractionType.HOVER */.td.HOVER && _this.VRPointer.component) {
                                if (eventData.hover) {
                                    _this.VRPointer.component.setVisible(true);
                                    _this.VRPointer.target = component;
                                } else _this.VRPointer.component.setVisible(false);
                            }
                        };
                        return [
                            2
                        ];
                }
            });
        })();
    };
    _proto.initVREventManager = function initVREventManager() {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var modelNode, component;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            _this.showCaseTemp.showcase.Scene.register(VREventManagerComponentType, makeVREventManagerComponent)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            4,
                            _this.showCaseTemp.mpSDK.Scene.createNode()
                        ];
                    case 2:
                        modelNode = _state.sent();
                        return [
                            4,
                            modelNode.addComponent(VREventManagerComponentType, {})
                        ];
                    case 3:
                        component = _state.sent();
                        return [
                            4,
                            modelNode.start()
                        ];
                    case 4:
                        _state.sent();
                        _this.vrEventManager = component;
                        _this.vrEventManager.addEventListener({
                            type: "thumbstickthreshholddown",
                            button: 3,
                            controller: types/* ControllerType.GamepadL */.C.GamepadL
                        }, function(axis) {
                            var ref;
                            if (!((ref = _this.flowsMenuMeshComponent) === null || ref === void 0 ? void 0 : ref.inputs.visible)) _this.showCaseTemp.showcase.Camera.moveInDirection(axis > 0.5 ? _this.showCaseTemp.showcase.Camera.Direction.BACK : _this.showCaseTemp.showcase.Camera.Direction.FORWARD);
                        });
                        return [
                            2
                        ];
                }
            });
        })();
    };
    _proto.initBackpackMesh = function initBackpackMesh() {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var ref, items, ref1, html, refs, modelNode, component, e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        items = (ref = _this.state.game) === null || ref === void 0 ? void 0 : ref.locks.filter(function(lock) {
                            return lock.type === "collectItems";
                        });
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            6,
                            ,
                            7
                        ]);
                        _this.backpackMeshState = "loading";
                        ref1 = createBackpackhtml(items), html = ref1.html, refs = ref1.refs;
                        return [
                            4,
                            _this.showCaseTemp.showcase.Scene.register(backpackMeshComponentType, makeBackpackMeshComponent)
                        ];
                    case 2:
                        _state.sent();
                        return [
                            4,
                            _this.showCaseTemp.mpSDK.Scene.createNode()
                        ];
                    case 3:
                        modelNode = _state.sent();
                        return [
                            4,
                            modelNode.addComponent(backpackMeshComponentType, {
                                html: html,
                                visible: false,
                                scale: 0.5,
                                refs: refs
                            })
                        ];
                    case 4:
                        component = _state.sent();
                        return [
                            4,
                            modelNode.start()
                        ];
                    case 5:
                        _state.sent();
                        _this.backpackMeshComponent = component;
                        _this.backpackMeshState = "loaded";
                        return [
                            3,
                            7
                        ];
                    case 6:
                        e = _state.sent();
                        console.error(e);
                        _this.backpackMeshState = "error";
                        return [
                            3,
                            7
                        ];
                    case 7:
                        return [
                            2
                        ];
                }
            });
        })();
    };
    _proto.loadedShowcaseHandler = function loadedShowcaseHandler() {
        var cb = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : function() {};
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var ref, ref1, ref2, ref3, _state, tour, room, changeReel, isEcommerceTour, isOpticalCenter, auth, ref4, access_token, expires_in, fetcher, reel, videoMediaType;
            return (0,tslib_es6.__generator)(this, function(_state1) {
                switch(_state1.label){
                    case 0:
                        _state = _this.state, tour = _state.tour, room = _state.room, changeReel = _state.changeReel;
                        isEcommerceTour = tour.mode === Tour/* TourType.ECommerce */.v.ECommerce;
                        isOpticalCenter = _this.state.externalProvider === components_types/* ExternalProvider.OPTICAL_CENTER */.FX.OPTICAL_CENTER;
                        // TODO revert back
                        if ((tour === null || tour === void 0 ? void 0 : tour.enableAvatar) || room || (tour === null || tour === void 0 ? void 0 : tour.isThreadsEnabled)) {
                            socket/* default.open */.Z.open();
                        }
                        auth = (0,util_all/* getQueryVariable */.Dv)(window.location.href, "auth");
                        if (!(((ref = tour.user) === null || ref === void 0 ? void 0 : ref.oauth) && (auth || tour.oauthAccess))) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            TreedisPublicDAO/* default.refreshOAuth */.Z.refreshOAuth({
                                id: tour.userId
                            })
                        ];
                    case 1:
                        ref4 = _state1.sent(), access_token = ref4.access_token, expires_in = ref4.expires_in;
                        fetcher = {
                            fetch: function fetch1(oldToken) {
                                return (0,_async_to_generator/* default */.Z)(function() {
                                    return (0,tslib_es6.__generator)(this, function(_state) {
                                        console.log("OAuth Token Expired, refreshing...");
                                        return [
                                            2,
                                            TreedisPublicDAO/* default.refreshOAuth */.Z.refreshOAuth({
                                                id: tour.userId
                                            })
                                        ];
                                    });
                                })();
                            }
                        };
                        _this.showCaseTemp.showcase.OAuth.createTokenRefresher({
                            access_token: access_token,
                            expires_in: expires_in
                        }, fetcher);
                        _state1.label = 2;
                    case 2:
                        return [
                            4,
                            _this.showCaseTemp.showcase.Tour.getData().catch(function() {
                                return [];
                            })
                        ];
                    case 3:
                        reel = _state1.sent();
                        if ((reel === null || reel === void 0 ? void 0 : reel.length) && !changeReel) {
                            _this.setState({
                                reel: reel
                            });
                        }
                        _this.showCaseTemp.showcase.Settings.update("highlight_reel", false);
                        _this.showCaseTemp.showcase.Settings.update("tour_buttons", false);
                        return [
                            4,
                            _this.showCaseTemp.showcase.Link.setShareLinkPolicy(_this.showCaseTemp.showcase.Link.CreationPolicy.REFERRER).catch(function() {
                                return [];
                            })
                        ];
                    case 4:
                        _state1.sent();
                        if (tour.hidePucks) {
                            _this.showCaseTemp.showcase.Settings.update("features/sweep_pucks", false);
                        }
                        _this.showCaseTemp.showcase.Mode.current.subscribe(function(mode) {
                            var ref, ref1, ref2, ref3, ref4, ref5;
                            if (mode === _this.showCaseTemp.showcase.Mode.Mode.OUTSIDE) {
                                _this.stopVS();
                            }
                            _this.setState({
                                tourMode: mode
                            });
                            // hide models from other floors on view change
                            if (((ref = _this.showCaseTemp) === null || ref === void 0 ? void 0 : (ref1 = ref.scene) === null || ref1 === void 0 ? void 0 : ref1.sceneObject) && ((ref2 = _this.showCaseTemp) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.scene) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.sceneObject) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.assets) === null || ref5 === void 0 ? void 0 : ref5.length)) {
                                var ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14;
                                if (mode === ((ref6 = _this.showCaseTemp) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.showcase) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.Mode) === null || ref8 === void 0 ? void 0 : ref8.Mode.FLOORPLAN) || ((ref9 = _this.showCaseTemp) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.showcase) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.Mode) === null || ref11 === void 0 ? void 0 : ref11.Mode.TRANSITIONING)) {
                                    _this.showCaseTemp.scene.sceneObject.assets.forEach(function(asset) {
                                        if (asset[0].floor !== _this.state.currentFloor) asset[0].node.pivot.visible = false;
                                    });
                                }
                                if (mode === ((ref12 = _this.showCaseTemp) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.showcase) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.Mode) === null || ref14 === void 0 ? void 0 : ref14.Mode.INSIDE)) {
                                    var ref15, ref16, ref17;
                                    (ref15 = _this.showCaseTemp) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.scene) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.sceneObject) === null || ref17 === void 0 ? void 0 : ref17.assets.forEach(function(asset) {
                                        asset[0].node.pivot.visible = true;
                                    });
                                }
                            }
                        });
                        _this.showCaseTemp.showcase.Camera.pose.subscribe(debounce_default()(function(p) {
                            _this.pose = (0,_object_spread/* default */.Z)({}, p);
                            cb();
                        }, 50));
                        _this.showCaseTemp.showcase.Sweep.current.subscribe(function() {
                            var _ref = (0,_async_to_generator/* default */.Z)(function(currentSweep) {
                                var ref, openedTag;
                                return (0,tslib_es6.__generator)(this, function(_state) {
                                    _this.currentSweep = currentSweep;
                                    if (isEcommerceTour) {
                                        _this.handleShowNearestProduct(false);
                                    }
                                    if (!_this.deselectTagTimeout && !_this.state.tagPopupOpen) _this.setState({
                                        selectedTag: null
                                    });
                                    if (currentSweep.sid !== "") {
                                        // This line was causing the music to stop when changing sweeps. Ely said it's a bug. Remove this line in a month if everything is fine without it.
                                        // await audioHandler.stopAudioByPriority(PriorityNumbers.FIRST);
                                        if (!_this.defaultSweep) _this.defaultSweep = structuredClone(currentSweep);
                                        _this.prevSweep = structuredClone(currentSweep);
                                        _this.updateSweepLoc(currentSweep);
                                        if (_this.state.currentSweep) {
                                            //call renderVS only if previous sweep was set (this.state.currentSweep === null in the beginning)
                                            //if previus sweep was not set, we are on the first sweep load, and we call this function anyway in initVS.
                                            _this.renderVS(currentSweep);
                                        }
                                        currentSweep.uuid = currentSweep.sid;
                                        _this.setState({
                                            currentSweep: currentSweep
                                        }, function() {
                                            if (isEcommerceTour && !isOpticalCenter) {
                                                _this.handleShowNearestProduct(true);
                                            }
                                        });
                                    }
                                    (ref = _this.pathFinderMeshComponent) === null || ref === void 0 ? void 0 : ref.setVisible(false);
                                    if (base/* asyncStore.vrIsOn */.k6.vrIsOn && _this.openedVRTag) {
                                        openedTag = _this.matterTagMeshComponents.find(function(tag) {
                                            return tag.tagId === _this.openedVRTag;
                                        });
                                        if (openedTag) {
                                            openedTag.inputs.popupVisible = false;
                                            _this.openedVRTag = null;
                                        }
                                    }
                                    return [
                                        2
                                    ];
                                });
                            });
                            return function(currentSweep) {
                                return _ref.apply(this, arguments);
                            };
                        }());
                        _this.showCaseTemp.showcase.on(_this.showCaseTemp.showcase.Camera.Event.MOVE, function() {
                            var _ref = (0,_async_to_generator/* default */.Z)(function(p) {
                                var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, _state, showcaseLoaded, host, room, tour, panoramaOn, ref10, ref11, pose;
                                return (0,tslib_es6.__generator)(this, function(_state1) {
                                    _this.cameraPose.current = p;
                                    _state = _this.state, showcaseLoaded = _state.showcaseLoaded, host = _state.host, room = _state.room, tour = _state.tour, panoramaOn = _state.panoramaOn;
                                    if (!showcaseLoaded) return [
                                        2
                                    ];
                                    if (!((ref = _this.menuMeshComponent) === null || ref === void 0 ? void 0 : ref.hostPose)) (ref1 = _this.menuMeshComponent) === null || ref1 === void 0 ? void 0 : ref1.setHostPose(_this.pose);
                                    if (!((ref2 = _this.flowsMenuMeshComponent) === null || ref2 === void 0 ? void 0 : ref2.hostPose)) (ref3 = _this.flowsMenuMeshComponent) === null || ref3 === void 0 ? void 0 : ref3.setHostPose(_this.pose);
                                    if (!((ref4 = _this.flowsBarMeshComponent) === null || ref4 === void 0 ? void 0 : ref4.hostPose)) (ref5 = _this.flowsBarMeshComponent) === null || ref5 === void 0 ? void 0 : ref5.setHostPose(_this.pose);
                                    if (!((ref6 = _this.pathFinderMeshComponent) === null || ref6 === void 0 ? void 0 : ref6.hostPose)) (ref7 = _this.pathFinderMeshComponent) === null || ref7 === void 0 ? void 0 : ref7.setHostPose(_this.pose);
                                    if (!((ref8 = _this.backpackMeshComponent) === null || ref8 === void 0 ? void 0 : ref8.hostPose)) (ref9 = _this.backpackMeshComponent) === null || ref9 === void 0 ? void 0 : ref9.setHostPose(_this.pose);
                                    _this.matterTagMeshComponents.forEach(function(tag) {
                                        if (!tag.hostPose) tag.setHostPose(p);
                                    });
                                    if (socket/* default */.Z && socket/* default.connected */.Z.connected && (room || tour.enableAvatar)) {
                                        ;
                                        pose = {
                                            walking: p.mode === _this.showCaseTemp.showcase.Mode.Mode.INSIDE,
                                            position: p.position,
                                            rotation: (ref10 = _this.camera) === null || ref10 === void 0 ? void 0 : ref10.rotation,
                                            quaternion: (ref11 = _this.camera) === null || ref11 === void 0 ? void 0 : ref11.quaternion,
                                            mode: p.mode,
                                            degree: _this.avatarDegree,
                                            sweep: _this.state.currentSweep
                                        };
                                        _this.lastAvatarCameraPose = pose;
                                        if (room) {
                                            if (host) {
                                                socket/* default.emit */.Z.emit("move", {
                                                    pose: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, p), {
                                                        walking: p.mode === _this.showCaseTemp.showcase.Mode.Mode.INSIDE
                                                    })
                                                });
                                            }
                                        }
                                        if (tour === null || tour === void 0 ? void 0 : tour.enableAvatar) {
                                            socket/* default.emit */.Z.emit("move_avatar", {
                                                pose: pose
                                            });
                                        }
                                    }
                                    if (tour.minimap) {
                                        if (p.mode === _this.showCaseTemp.showcase.Mode.Mode.INSIDE && !panoramaOn) {
                                            _this.setState({
                                                mapWalkerRotation: p.rotation.y * -1
                                            });
                                        }
                                    }
                                    return [
                                        2
                                    ];
                                });
                            });
                            return function(p) {
                                return _ref.apply(this, arguments);
                            };
                        }());
                        _this.showCaseTemp.showcase.Sweep.current.subscribe(function(sweep) {
                            var pose = _this.lastAvatarCameraPose;
                            if (pose) socket/* default.emit */.Z.emit("move_avatar", {
                                pose: pose
                            });
                        });
                        _this.showCaseTemp.showcase.Floor.current.subscribe(function(floor) {
                            var ref, ref1, ref2, ref3, ref4;
                            // hide models from other floors on floor change
                            if (floor && typeof floor.sequence === "number" && ((ref = _this.showCaseTemp) === null || ref === void 0 ? void 0 : (ref1 = ref.scene) === null || ref1 === void 0 ? void 0 : ref1.sceneObject) && ((ref2 = _this.showCaseTemp.scene) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.sceneObject) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.assets) === null || ref4 === void 0 ? void 0 : ref4.length)) {
                                if (_this.state.tourMode === _this.showCaseTemp.showcase.Mode.Mode.FLOORPLAN) {
                                    var ref5, ref6, ref7;
                                    (ref5 = _this.showCaseTemp) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.scene) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.sceneObject) === null || ref7 === void 0 ? void 0 : ref7.assets.forEach(function(asset) {
                                        asset[0].node.pivot.visible = asset[0].floor === floor.sequence;
                                    });
                                }
                                if (_this.state.tourMode === _this.showCaseTemp.showcase.Mode.Mode.INSIDE || _this.state.tourMode === _this.showCaseTemp.showcase.Mode.Mode.DOLLHOUSE) {
                                    var ref8, ref9, ref10;
                                    (ref8 = _this.showCaseTemp) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.scene) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.sceneObject) === null || ref10 === void 0 ? void 0 : ref10.assets.forEach(function(asset) {
                                        asset[0].node.pivot.visible = true;
                                    });
                                }
                            }
                            if (floor.sequence !== -1 && floor.sequence !== undefined && floor.sequence !== _this.state.selectedMinimap) {
                                var minimaps = _this.state.minimaps;
                                if (minimaps.length > 0 && minimaps[floor.sequence]) {
                                    _this.setState({
                                        selectedMinimap: floor.sequence
                                    });
                                }
                            }
                            if (floor.sequence !== -1 && floor.sequence !== undefined && _this.state.currentFloor !== floor.sequence) {
                                _this.setState({
                                    currentFloor: floor.sequence
                                }, function() {
                                    if (!_this.state.showIntro && !_this.state.startScreenOn && _this.state.showcaseLoaded) {
                                        _this.processTourMusic();
                                    }
                                });
                            }
                        });
                        _this.showCaseTemp.showcase.Measurements.mode.subscribe(function(measurementModeState) {
                            _this.setState({
                                measurementsOn: measurementModeState.active
                            });
                        });
                        _this.showCaseTemp.showcase.on(_this.showCaseTemp.showcase.Tour.Event.STEPPED, function(i) {
                            _this.setState({
                                reelStep: i,
                                panoramaOn: false
                            });
                        });
                        _this.showCaseTemp.showcase.on(_this.showCaseTemp.showcase.Tour.Event.STARTED, function() {
                            _this.setState({
                                tourPlaying: true,
                                panoramaOn: false,
                                tourMode: _this.pose.mode
                            });
                        });
                        _this.showCaseTemp.showcase.on(_this.showCaseTemp.showcase.Tour.Event.STOPPED, function() {
                            _this.setState({
                                tourPlaying: false,
                                panoramaOn: false
                            });
                        });
                        _this.showCaseTemp.showcase.on(_this.showCaseTemp.showcase.Tour.Event.ENDED, function() {
                            _this.setState({
                                tourPlaying: false,
                                panoramaOn: false,
                                reelStep: 0
                            });
                        });
                        // On mobile devices we need to hide the path if the tag is docked
                        if (deviceManager/* default.isMobile */.Z.isMobile() && ((ref1 = _this.state) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.game) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.paths) === null || ref3 === void 0 ? void 0 : ref3.length) > 0) {
                            _this.showcase.Tag.openTags.subscribe({
                                onChanged: function onChanged(tag) {
                                    var pathWrap = document.querySelector(".path-lock-panel-wrap");
                                    if (tag.docked) {
                                        pathWrap === null || pathWrap === void 0 ? void 0 : pathWrap.classList.add("hide-path");
                                    } else {
                                        pathWrap === null || pathWrap === void 0 ? void 0 : pathWrap.classList.remove("hide-path");
                                    }
                                }
                            });
                        }
                        _this.registerShowcaseSubscribers();
                        _this.showCaseTemp.showcase.Floor.data.subscribe({
                            // Get floor data
                            onCollectionUpdated: function(collection) {
                                var mpFloors = [];
                                Object.keys(collection).forEach(function(o) {
                                    var floor = collection[o];
                                    if (!floor.name || floor.name.length === 0) return;
                                    mpFloors.unshift(floor);
                                });
                                _this.setState({
                                    mpFloors: mpFloors
                                });
                            }
                        });
                        _this.showCaseTemp.showcase.Label.getData().then(function(labels) {
                            if (labels === null || labels === void 0 ? void 0 : labels.length) _this.setState({
                                mpLabels: labels
                            });
                        }).catch(function() {
                            return console.error("Error to load MP labels");
                        });
                        videoMediaType = _this.showCaseTemp.showcase.Mattertag.MediaType.VIDEO;
                        _this.showCaseTemp.showcase.Tag.data.subscribe({
                            onAdded: function() {
                                var _ref = (0,_async_to_generator/* default */.Z)(function(sid, item) {
                                    var ref, room, clone, urlC;
                                    return (0,tslib_es6.__generator)(this, function(_state) {
                                        if (tour === null || tour === void 0 ? void 0 : tour.addon_hidetags) {
                                            _this.showCaseTemp.showcase.Tag.remove(sid);
                                            return [
                                                2
                                            ];
                                        }
                                        room = _this.state.room;
                                        if (room && (item === null || item === void 0 ? void 0 : (ref = item.media) === null || ref === void 0 ? void 0 : ref.type) === videoMediaType) {
                                            clone = cloneDeep_default()(item);
                                            urlC = clone.media.src.split("https://vimeo.com/");
                                            clone.media.src += urlC.length > 1 ? "?muted=1" : "&muted=1";
                                            _this.showCaseTemp.showcase.Tag.editBillboard(sid, clone);
                                            _this.tagManager.replaceAttachment({
                                                originName: item.media.src,
                                                url: item.media.src
                                            }, clone.media.src, sid).catch(console.error);
                                        }
                                        return [
                                            2
                                        ];
                                    });
                                });
                                return function(sid, item) {
                                    return _ref.apply(this, arguments);
                                };
                            }()
                        });
                        return [
                            2
                        ];
                }
            });
        })();
    };
    _proto.requestTwinMakerData = function requestTwinMakerData(liveTags, rules, alarms, tour) {
        var _this = this;
        liveTags.map(function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(tag) {
                var ref, ref1, ref2, ref3, entities, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, entity, res, data, description;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            entities = [
                                {
                                    bindingName: "tagInfo_treedis_reserved",
                                    id: (ref = tag.component) === null || ref === void 0 ? void 0 : ref.valueDataBinding.dataBindingContext.entityId,
                                    componentName: (ref1 = tag.component) === null || ref1 === void 0 ? void 0 : ref1.valueDataBinding.dataBindingContext.componentName,
                                    propertyName: (ref2 = tag.component) === null || ref2 === void 0 ? void 0 : ref2.valueDataBinding.dataBindingContext.propertyName
                                }
                            ];
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            try {
                                for(_iterator = tag.overlay[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    entity = _step.value;
                                    entities.push({
                                        bindingName: entity.bindingName,
                                        id: entity.valueDataBinding.dataBindingContext.entityId,
                                        componentName: entity.valueDataBinding.dataBindingContext.componentName,
                                        propertyName: entity.valueDataBinding.dataBindingContext.propertyName
                                    });
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                            return [
                                4,
                                TreedisPublicDAO/* default.getTwinMakerData */.Z.getTwinMakerData(tour.slug, {
                                    entities: entities
                                })
                            ];
                        case 1:
                            res = _state.sent();
                            if (!(res === null || res === void 0 ? void 0 : res.data)) return [
                                2
                            ];
                            data = res.data;
                            description = tag.description;
                            Object.keys(data).map(function(bindingName) {
                                var value = data[bindingName];
                                var replacedValue = description.replace("${".concat(bindingName, "}"), value.doubleValue);
                                description = replacedValue;
                            });
                            // replace overlay
                            _this.showcase.Tag.editBillboard(tag.sid, {
                                label: tag.title,
                                description: description
                            }).catch(console.error);
                            (ref3 = rules[alarms[tag.sid]]) === null || ref3 === void 0 ? void 0 : ref3.statements.map(function() {
                                var _ref = (0,_async_to_generator/* default */.Z)(function(statement) {
                                    var ref, ref1, comparator, value;
                                    return (0,tslib_es6.__generator)(this, function(_state) {
                                        ref1 = _this.extractAWSRule(statement.expression), comparator = ref1.comparator, value = ref1.value;
                                        if (comparator((ref = data.tagInfo_treedis_reserved) === null || ref === void 0 ? void 0 : ref.doubleValue, value)) {
                                            if (value == 100) {
                                                _this.showcase.Tag.editIcon(tag.sid, "stopped__treedis").catch(function(e) {
                                                    console.error(e);
                                                });
                                            }
                                            if (value == 200) {
                                                _this.showcase.Tag.editIcon(tag.sid, "idle__treedis").catch(function(e) {
                                                    console.error(e);
                                                });
                                            }
                                            if (value == 300) {
                                                _this.showcase.Tag.editIcon(tag.sid, "running__treedis").catch(function(e) {
                                                    console.error(e);
                                                });
                                            }
                                            if (value == 400) {
                                                _this.showcase.Tag.editIcon(tag.sid, "fault__treedis").catch(function(e) {
                                                    console.error(e);
                                                });
                                            }
                                        }
                                        return [
                                            2
                                        ];
                                    });
                                });
                                return function(statement) {
                                    return _ref.apply(this, arguments);
                                };
                            }());
                            return [
                                2
                            ];
                    }
                });
            });
            return function(tag) {
                return _ref.apply(this, arguments);
            };
        }());
    };
    _proto.handleVideoLoaded = function handleVideoLoaded(param) {
        var eventData = param.eventData, data = param.data, component = param.component;
        var ref;
        // unmute if mute button is hidden
        if (((ref = component.muteBtn) === null || ref === void 0 ? void 0 : ref.inputs.size) === 0) component.toggleMute(component.inputs.isDefaultMuted);
        if (!component.inputs.autoplay) {
            component.toggleMute(false);
            if (component.muteBtn.button) {
                component.muteBtn.button.visible = true;
                if (!deviceManager/* default.isIOS */.Z.isIOS()) component.muteBtn.setActive(false);
            }
        } else {
            component.play();
        }
    };
    _proto.processGeorgiaPacificTour = function processGeorgiaPacificTour() {
        var _this = this;
        var ref;
        // If all required assets are present, init ControllerNode
        if (this.state.gameStatus === "started" && !this.hasController) {
            var ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11;
            var titlesToKeys = {
                "Under curl bar reversed.mp4": "targetDecrease",
                "Under curl bar.mp4": "targetIncrease",
                "plates_ok.png": "resultOk",
                "q_early.png": "qEarly",
                "q_early_success.png": "qEarlySuccess",
                "q_early_fail.png": "qEarlyFail",
                "q_late.png": "qLate",
                "q_late_success.png": "qLateSuccess",
                "q_late_fail.png": "qLateFail",
                "q1.png": "q1",
                "q1_success.png": "q1Success",
                "q1_fail.png": "q1Fail",
                "Paper rolling": "paperRolling",
                "Front of plates": "frontOfPlates",
                "Front of plates squished": "frontOfPlatesSquished",
                "completed.png": "completedImage",
                "Up Curl - Bad": "upCurlBad",
                "Good Curl": "upCurlGood"
            };
            var results = this.vsObjects.reduce(function(acc, obj) {
                var ref;
                var key = titlesToKeys[(ref = obj.details) === null || ref === void 0 ? void 0 : ref.title];
                if (key) acc[key] = obj;
                return acc;
            }, {});
            var allKeysExist = Object.values(titlesToKeys).every(function(key) {
                var ref;
                return (ref = results[key]) === null || ref === void 0 ? void 0 : ref.node;
            });
            // hiding early because GP component is initialized after tour is loaded and interactable
            if ((ref1 = results.qEarly.node) === null || ref1 === void 0 ? void 0 : ref1.pivot) results.qEarly.node.pivot.visible = false;
            if ((ref2 = results.qEarlySuccess.node) === null || ref2 === void 0 ? void 0 : ref2.pivot) results.qEarlySuccess.node.pivot.visible = false;
            if ((ref3 = results.qEarlyFail.node) === null || ref3 === void 0 ? void 0 : ref3.pivot) results.qEarlyFail.node.pivot.visible = false;
            if ((ref4 = results.q1Success.node) === null || ref4 === void 0 ? void 0 : ref4.pivot) results.q1Success.node.pivot.visible = false;
            if ((ref5 = results.q1Fail.node) === null || ref5 === void 0 ? void 0 : ref5.pivot) results.q1Fail.node.pivot.visible = false;
            if ((ref6 = results.qLate.node) === null || ref6 === void 0 ? void 0 : ref6.pivot) results.qLate.node.pivot.visible = false;
            if ((ref7 = results.qLateSuccess.node) === null || ref7 === void 0 ? void 0 : ref7.pivot) results.qLateSuccess.node.pivot.visible = false;
            if ((ref8 = results.qLateFail.node) === null || ref8 === void 0 ? void 0 : ref8.pivot) results.qLateFail.node.pivot.visible = false;
            if ((ref9 = results.resultOk.node) === null || ref9 === void 0 ? void 0 : ref9.root) results.resultOk.node.root.visible = false;
            if ((ref10 = results.completedImage.node) === null || ref10 === void 0 ? void 0 : ref10.pivot) results.completedImage.node.pivot.visible = false;
            if ((ref11 = results.frontOfPlates.node) === null || ref11 === void 0 ? void 0 : ref11.root) results.frontOfPlates.node.root.visible = false;
            if (allKeysExist) {
                this.initGeorgiaPacificGameTour(results);
                this.hasController = true;
            }
        }
        // If Quiz1 is completed, overwrite 'Q1_show' polygon onClick event to show plate status instead of quiz
        if (((ref = this.state.lockSolved) === null || ref === void 0 ? void 0 : ref.lock.name) === "q1_complete" && this.showCaseTemp.scene.sceneController && !this.showCaseTemp.scene.sceneController.active) {
            this.showCaseTemp.scene.sceneController.active = true;
            var polygonShow = this.state.polygons.find(function(polygon) {
                return polygon.title === "Q1_show";
            });
            this.showCaseTemp.scene.scenePolygon.assets.get(polygonShow.id)[1].onEvent = function(type, eventData) {
                if (type === Scene_component/* ComponentInteractionType.CLICK */.td.CLICK && _this.showCaseTemp.scene.sceneController.active) {
                    _this.showCaseTemp.scene.sceneController.result.early.node.pivot.visible = true;
                    _this.showCaseTemp.scene.sceneController.result.ok.node.pivot.visible = true;
                    _this.showCaseTemp.scene.sceneController.result.late.node.pivot.visible = true;
                }
            };
        }
    };
    _proto.initGeorgiaPacificGameTour = function initGeorgiaPacificGameTour(results) {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var targetIncrease, targetDecrease, resultOk, qEarly, qEarlySuccess, qEarlyFail, qLate, qLateSuccess, qLateFail, q1, q1Success, q1Fail, paperRolling, frontOfPlates, frontOfPlatesSquished, completedImage, upCurlBad, upCurlGood, getPolygonArr, q1Polygons, qEarlyPolygons, qLatePolygons, completePolygon, asset;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        targetIncrease = results.targetIncrease, targetDecrease = results.targetDecrease, resultOk = results.resultOk, qEarly = results.qEarly, qEarlySuccess = results.qEarlySuccess, qEarlyFail = results.qEarlyFail, qLate = results.qLate, qLateSuccess = results.qLateSuccess, qLateFail = results.qLateFail, q1 = results.q1, q1Success = results.q1Success, q1Fail = results.q1Fail, paperRolling = results.paperRolling, frontOfPlates = results.frontOfPlates, frontOfPlatesSquished = results.frontOfPlatesSquished, completedImage = results.completedImage, upCurlBad = results.upCurlBad, upCurlGood = results.upCurlGood;
                        getPolygonArr = function(str) {
                            var keys = _this.state.polygons.filter(function(polygon) {
                                return polygon.title.includes(str);
                            }).sort(function(a, b) {
                                var numA = parseInt(a.title.match(/\d+$/)[0], 10);
                                var numB = parseInt(b.title.match(/\d+$/)[0], 10);
                                return numA - numB;
                            }).map(function(el) {
                                return el.id;
                            });
                            // Convert map keys to an array
                            var mapKeysArray = Array.from(_this.showCaseTemp.scene.scenePolygon.assets.keys());
                            // Filter keysArray based on mapKeysArray
                            var filteredKeys = keys.filter(function(key) {
                                return mapKeysArray.includes(key);
                            });
                            // Then map filteredKeys to values in the map
                            return filteredKeys.map(function(key) {
                                return _this.showCaseTemp.scene.scenePolygon.assets.get(key)[1];
                            });
                        };
                        q1Polygons = getPolygonArr("Q1_option");
                        qEarlyPolygons = getPolygonArr("Q_early_option");
                        qLatePolygons = getPolygonArr("Q_late_option");
                        completePolygon = getPolygonArr("complete_polygon");
                        asset = {
                            scaleX: 1,
                            scaleY: 1,
                            scaleZ: 1,
                            positionX: 0,
                            positionY: 0,
                            positionZ: 0,
                            rotationX: 0,
                            rotationY: 0,
                            rotationZ: 0,
                            targetDecrease: targetDecrease,
                            targetIncrease: targetIncrease,
                            q1: {
                                default: q1,
                                success: q1Success,
                                fail: q1Fail,
                                polygons: q1Polygons,
                                solutionIndex: 0
                            },
                            q_early: {
                                default: qEarly,
                                success: qEarlySuccess,
                                fail: qEarlyFail,
                                polygons: qEarlyPolygons,
                                solutionIndex: 1
                            },
                            q_late: {
                                default: qLate,
                                success: qLateSuccess,
                                fail: qLateFail,
                                polygons: qLatePolygons,
                                solutionIndex: 1
                            },
                            result: {
                                ok: resultOk
                            },
                            paperMachineVideoAssets: [
                                paperRolling,
                                frontOfPlates,
                                frontOfPlatesSquished,
                                upCurlBad,
                                upCurlGood
                            ],
                            startOutroVideo: _this.startOutroVideo.bind(_this),
                            completed: {
                                image: completedImage,
                                polygons: completePolygon
                            },
                            context: {
                                showcase: _this.showCaseTemp,
                                camera: _this.camera,
                                renderer: _this.renderer,
                                iframe: _this.iframe
                            }
                        };
                        return [
                            4,
                            _this.showCaseTemp.scene.create(dist/* SceneInitEventsTypes.Controller */.PS.Controller, asset)
                        ];
                    case 1:
                        _state.sent();
                        _this.showCaseTemp.scene.sceneController.on(dist/* NodeEventsTypes.CONTROLLER_MODEL_CLICK */.cA.CONTROLLER_MODEL_CLICK, function() {
                            var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
                                var data;
                                return (0,tslib_es6.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            data = param.data;
                                            return [
                                                4,
                                                _this.moveToSweep("c1c38440428f485d9487045fa0ba9cf4", {
                                                    x: 60,
                                                    y: 180
                                                }, "FLY")
                                            ];
                                        case 1:
                                            _state.sent();
                                            return [
                                                2
                                            ];
                                    }
                                });
                            });
                            return function(_) {
                                return _ref.apply(this, arguments);
                            };
                        }());
                        return [
                            2
                        ];
                }
            });
        })();
    };
    _proto.startOutroVideo = function startOutroVideo() {
        this.setState({
            gameStatus: components_types/* GameStatus.OutroClip */.XI.OutroClip
        });
    };
    _proto.initPatch = function initPatch(url) {
        this.showCaseTemp.scene.create(dist/* SceneInitEventsTypes.Patch */.PS.Patch, {
            url: url,
            opacity: 0.6
        });
    };
    _proto.initBarriers = function initBarriers(tour) {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var barriers, barrierNodes;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0,queries/* getBarriers */.dt)(tour.id)
                        ];
                    case 1:
                        barriers = _state.sent();
                        if (!(barriers === null || barriers === void 0 ? void 0 : barriers.length)) return [
                            2,
                            {
                                barriers: [],
                                barrierNodes: []
                            }
                        ];
                        return [
                            4,
                            Promise.all(barriers.filter(function(barrier) {
                                return barrier.enabled;
                            }).map(function() {
                                var _ref = (0,_async_to_generator/* default */.Z)(function(barrier) {
                                    var node;
                                    return (0,tslib_es6.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                return [
                                                    4,
                                                    _this.showCaseTemp.scene.create(dist/* SceneInitEventsTypes.Barrier */.PS.Barrier, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, barrier), {
                                                        colorDefault: "#ea475c",
                                                        colorHover: "#ea475c",
                                                        colorClick: "#ea475c",
                                                        opacityDefault: 0,
                                                        opacityHover: 0,
                                                        opacityClick: 0
                                                    }))
                                                ];
                                            case 1:
                                                node = _state.sent();
                                                return [
                                                    2,
                                                    node
                                                ];
                                        }
                                    });
                                });
                                return function(barrier) {
                                    return _ref.apply(this, arguments);
                                };
                            }()))
                        ];
                    case 2:
                        barrierNodes = _state.sent();
                        return [
                            2,
                            {
                                barriers: barriers,
                                barrierNodes: barrierNodes
                            }
                        ];
                }
            });
        })();
    };
    _proto.initCustomSweeps = function initCustomSweeps(customSweeps) {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                if (customSweeps === null || customSweeps === void 0 ? void 0 : customSweeps.length) {
                    customSweeps.forEach(function() {
                        var _ref = (0,_async_to_generator/* default */.Z)(function(customSweep) {
                            var res;
                            return (0,tslib_es6.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        return [
                                            4,
                                            _this.showCaseTemp.scene.create(dist/* SceneInitEventsTypes.CustomSweep */.PS.CustomSweep, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, customSweep), {
                                                rotationX: 0,
                                                rotationY: 0,
                                                rotationZ: 0,
                                                scaleX: 0.4,
                                                scaleY: 0.4,
                                                scaleZ: 0.4,
                                                opacityDefault: 0,
                                                opacityHover: 0,
                                                opacityClick: 0
                                            }))
                                        ];
                                    case 1:
                                        res = _state.sent();
                                        _this.customSweeps.push(res);
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                        return function(customSweep) {
                            return _ref.apply(this, arguments);
                        };
                    }());
                }
                return [
                    2,
                    _this.customSweeps
                ];
            });
        })();
    };
    _proto.initTeleports = function initTeleports(teleportGroups) {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                if (teleportGroups === null || teleportGroups === void 0 ? void 0 : teleportGroups.length) {
                    teleportGroups.forEach(function() {
                        var _ref = (0,_async_to_generator/* default */.Z)(function(group) {
                            var pointNodes;
                            return (0,tslib_es6.__generator)(this, function(_state) {
                                pointNodes = [];
                                group.points.forEach(function() {
                                    var _ref = (0,_async_to_generator/* default */.Z)(function(point) {
                                        var ref, res;
                                        return (0,tslib_es6.__generator)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    return [
                                                        4,
                                                        _this.showCaseTemp.scene.create(dist/* SceneInitEventsTypes.Teleport */.PS.Teleport, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, point), {
                                                            opacityDefault: 0.65,
                                                            opacityHover: 0.85,
                                                            colorDefault: "#2055FF",
                                                            rotationX: point.rotationX || 0,
                                                            rotationY: point.rotationY || 0,
                                                            rotationZ: point.rotationZ || 0,
                                                            scaleX: 0.5,
                                                            scaleY: 0.5,
                                                            scaleZ: 0.5,
                                                            type: group.type
                                                        }))
                                                    ];
                                                case 1:
                                                    res = _state.sent();
                                                    res[0].obj3D.visible = false;
                                                    pointNodes.push((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, res), {
                                                        sweep: point.sweep,
                                                        name: point.name
                                                    }));
                                                    if ((ref = _this.state.currentSweep) === null || ref === void 0 ? void 0 : ref.position) {
                                                        res[1].pivot.lookAt(_this.state.currentSweep.position.x, res[0].obj3D.position.y, _this.state.currentSweep.position.z);
                                                    }
                                                    return [
                                                        2
                                                    ];
                                            }
                                        });
                                    });
                                    return function(point) {
                                        return _ref.apply(this, arguments);
                                    };
                                }());
                                _this.teleportPoints.push({
                                    id: group.id,
                                    pointNodes: pointNodes,
                                    type: group.type
                                });
                                return [
                                    2
                                ];
                            });
                        });
                        return function(group) {
                            return _ref.apply(this, arguments);
                        };
                    }());
                }
                return [
                    2,
                    _this.teleportPoints
                ];
            });
        })();
    };
    _proto.getPolygons = function getPolygons() {
        return this.state.polygons;
    };
    _proto.handlePolygonProduct = function handlePolygonProduct(polygon) {};
    _proto.handleVSProduct = function handleVSProduct(vsObject) {};
    _proto.moveToSweepIO = function moveToSweepIO(p) {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                if (_this.state.showcaseLoaded) {
                    setTimeout(function() {
                        if (!p.walking) {
                            _this.showCaseTemp.showcase.Mode.moveTo(p.mode, {
                                position: p.position,
                                rotation: p.rotation,
                                transition: _this.showCaseTemp.showcase.Mode.TransitionType.FLY
                            }).catch(function(e) {});
                        } else {
                            _this.showcase.Sweep.moveTo(p.sweep, {
                                position: p.position,
                                rotation: p.rotation,
                                transition: _this.showCaseTemp.showcase.Sweep.Transition.FLY
                            }).catch(function(e) {});
                        }
                    }, 100);
                }
                return [
                    2
                ];
            });
        })();
    };
    _proto.moveToTagIO = function moveToTagIO(tag) {
        var doOpenTag = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
        var _this = this;
        if (this.state.showcaseLoaded) {
            this.deselectTagTimeout = setTimeout(function() {
                _this.deselectTagTimeout = undefined;
            }, 2000);
            setTimeout(function() {
                var tags = Array.from(_this.state.allTags.values());
                var foundTag = tags.find(function(t) {
                    return tag.sid && (t.sid === tag.sid || t.defaultSid === tag.sid);
                });
                if (!foundTag) {
                    return;
                }
                if (_this.pose.mode !== _this.showCaseTemp.showcase.Mode.Mode.OUTSIDE) {
                    _this.showCaseTemp.showcase.Mattertag.navigateToTag(foundTag.sid, _this.showCaseTemp.showcase.Mattertag.Transition.FLY).then(function() {
                        if (doOpenTag) {
                            _this.openTagIframe(tag.sid);
                        }
                    }).catch(function(err) {
                        console.error(err.toString());
                    });
                } else if (doOpenTag) {
                    _this.openTagIframe(foundTag.sid);
                }
            }, 100);
        }
    };
    _proto.getLogoUrl = function getLogoUrl() {
        var ref;
        var tour = this.state.tour;
        return tour && (tour === null || tour === void 0 ? void 0 : tour.client) ? "".concat("https://cdn.treedis.com", "/clients/").concat(tour === null || tour === void 0 ? void 0 : (ref = tour.client) === null || ref === void 0 ? void 0 : ref.id, "/logo.png").concat(util_all/* getVersion */.bo(tour.client.updatedAt)) : "";
    };
    _proto.injectBottomBg = function injectBottomBg() {};
    _proto.hideIframeButtons = function hideIframeButtons() {
        try {
            if (this.iframe) {
                var ref, ref1, ref2;
                var iframeButtons = (ref = this.iframe) === null || ref === void 0 ? void 0 : (ref1 = ref.contentWindow) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.document) === null || ref2 === void 0 ? void 0 : ref2.querySelector("#bottom-ui");
                if (iframeButtons && iframeButtons.style.display !== "none") {
                    iframeButtons.style.display = "none";
                }
            }
        } catch (err) {
            console.error(err);
        }
    };
    _proto.renderPanorama = function renderPanorama() {
        var _state = this.state, tour = _state.tour, panoramaOn = _state.panoramaOn, showcaseLoaded = _state.showcaseLoaded, panoramas = _state.panoramas, flowIsActive = _state.flowIsActive, room = _state.room, host = _state.host, openedPanoHotspot = _state.openedPanoHotspot;
        var showPanorama = panoramaOn && (panoramas === null || panoramas === void 0 ? void 0 : panoramas.length) > 0 && (tour.mpPasswordActive ? showcaseLoaded : true) && !flowIsActive;
        var audio;
        if ((openedPanoHotspot === null || openedPanoHotspot === void 0 ? void 0 : openedPanoHotspot.type) === "music") {
            audio = BaseTour_audioHandler.getAudio(AudioModule/* MusicObjectKey.PANORAMAS */.NO.PANORAMAS, openedPanoHotspot.defaultId);
            this.setState({
                tourAudioPlaying: false
            });
        }
        var _this = this;
        var handleSoundControlClose = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var tour;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            tour = _this.state.tour;
                            _this.setState({
                                openedPanoHotspot: null
                            });
                            if (!(tour === null || tour === void 0 ? void 0 : tour.autoplayMusic)) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                _this.resumeTourMusic()
                            ];
                        case 1:
                            _state.sent();
                            _state.label = 2;
                        case 2:
                            return [
                                4,
                                BaseTour_audioHandler.stopAudioByType(AudioModule/* MusicObjectKey.PANORAMAS */.NO.PANORAMAS)
                            ];
                        case 3:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            });
            return function handleSoundControlClose() {
                return _ref.apply(this, arguments);
            };
        }();
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                showPanorama && openedPanoHotspot && audio && /*#__PURE__*/ (0,jsx_runtime.jsx)(SoundControls["default"], {
                    audio: audio,
                    onClose: handleSoundControlClose
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Panorama, {
                    panoramas: panoramas,
                    markMinimap: this.markMinimap,
                    panoPose: this.state.panoPose,
                    activePano: this.state.activePano,
                    compass: tour.panoramaCompass,
                    transition: tour.panoramaTransition,
                    isChatGuest: room && socket/* default */.Z && socket/* default.connected */.Z.connected && !host,
                    defaultPanorama: tour.defaultPanorama,
                    updatePanoRotation: this.updatePanoRotation,
                    openHotspot: this.openedPanoHotspot,
                    onSceneChange: this.handlePanoSceneChange,
                    handleTogglePano: this.handleTogglePano
                })
            ]
        });
    };
    _proto.renderBottomBar = function renderBottomBar(isFullScreen, toggleFullscreen) {
        var _this = this;
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
        var _state = this.state, tour = _state.tour, room = _state.room, sharePopupOn = _state.sharePopupOn, minimapVisible = _state.minimapVisible, panoramaOn = _state.panoramaOn, measurementsOn = _state.measurementsOn, whiteLabelData = _state.whiteLabelData, reel = _state.reel, reelStep = _state.reelStep, translation = _state.translation, currentFloor = _state.currentFloor, isVSEnabled = _state.isVSEnabled, ticketing = _state.ticketing, mpFloors = _state.mpFloors, host = _state.host, activeSweepGroup = _state.activeSweepGroup, sweepGroups = _state.sweepGroups, hideBottomBarForWhile = _state.hideBottomBarForWhile, tourMode = _state.tourMode, clickedTag = _state.clickedTag, changeReel = _state.changeReel, chatParticipant = _state.chatParticipant, flowIsActive = _state.flowIsActive;
        var activeSweepGroupObject = sweepGroups.find(function(g) {
            return g.id === activeSweepGroup;
        });
        var firstAudio = BaseTour_audioHandler.getFirstMusic();
        var audio;
        if ((firstAudio === null || firstAudio === void 0 ? void 0 : (ref = firstAudio.type) === null || ref === void 0 ? void 0 : ref.name) === AudioModule/* MusicObjectKey.TAGS */.NO.TAGS) {
            audio = firstAudio.audio;
        }
        var _this1 = this;
        var handleSoundControlClose = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var tour;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            tour = _this1.state.tour;
                            _this1.setState({
                                clickedTag: false
                            });
                            if (!(tour === null || tour === void 0 ? void 0 : tour.autoplayMusic)) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                _this1.resumeTourMusic()
                            ];
                        case 1:
                            _state.sent();
                            _state.label = 2;
                        case 2:
                            return [
                                4,
                                BaseTour_audioHandler.stopAudioByType(AudioModule/* MusicObjectKey.TAGS */.NO.TAGS)
                            ];
                        case 3:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            });
            return function handleSoundControlClose() {
                return _ref.apply(this, arguments);
            };
        }();
        var setTourMusicState = function(state) {
            _this.setState({
                tourAudioPlaying: state
            });
        };
        var isAudioControlEnabled = this.isTourReadyForAudio();
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                tour.musicControl && clickedTag && audio && /*#__PURE__*/ (0,jsx_runtime.jsx)(SoundControls["default"], {
                    vsObjects: this.vsObjects,
                    audio: audio,
                    onClose: handleSoundControlClose,
                    flowIsActive: flowIsActive || !this.state.isNavigationBackgroundVisible
                }),
                !this.state.showIntro && !this.state.startScreenOn && /*#__PURE__*/ (0,jsx_runtime.jsx)(bottomBar_BottomBarWithRecoil, {
                    audio: BaseTour_audioHandler.getAudio(AudioModule/* MusicObjectKey.TOUR */.NO.TOUR, tour.id),
                    host: host,
                    musicPausedByUser: this.state.musicPausedByUser,
                    activeSweepGroup: activeSweepGroupObject,
                    tourAudioPlaying: this.state.tourAudioPlaying,
                    setTourMusicState: setTourMusicState,
                    allowedTours: ticketing === null || ticketing === void 0 ? void 0 : (ref1 = ticketing.ticketingTourTicket) === null || ref1 === void 0 ? void 0 : ref1.accessTours,
                    showTicketRestrictedAreaPopup: this.showTicketRestrictedAreaPopup,
                    onTicketingReel: this.handleTicketingReel,
                    toggleSketchfabPopup: this.toggleSketchfabPopup,
                    isFull: isFullScreen,
                    translation: translation,
                    vsObjects: this.vsObjects,
                    changeFull: toggleFullscreen,
                    mainPlaying: this.state.tourAudioPlaying,
                    openShare: function() {
                        _this.setState({
                            sharePopupOn: !sharePopupOn
                        });
                    },
                    reelVideos: this.state.reelVideos,
                    reel: reel,
                    changeReel: changeReel,
                    mpFloors: mpFloors,
                    room: room,
                    loadModel: this.loadModel,
                    tour: tour,
                    reelStep: reelStep,
                    sharePopupOn: sharePopupOn,
                    isVSEnabled: isVSEnabled,
                    moveToStep: this.moveToStep,
                    playTour: this.playTour,
                    tourPlaying: this.state.tourPlaying,
                    showcase: this.showCaseTemp.showcase,
                    showcaseTag: this.showcase.Tag,
                    tourMode: tourMode,
                    changeViewMode: this.changeViewMode,
                    measurementsOn: measurementsOn,
                    panoramaOn: panoramaOn,
                    measurementsMode: this.measurementsMode,
                    changeFloor: this.changeFloor,
                    defurnishEnabled: ((ref2 = this.iframe) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.contentWindow) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.document) === null || ref4 === void 0 ? void 0 : ref4.querySelector(".mode-defurnish button")) ? true : false,
                    onDefurnish: function() {
                        var ref, ref1, ref2, ref3;
                        (ref3 = (ref = _this.iframe) === null || ref === void 0 ? void 0 : (ref1 = ref.contentWindow) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.document) === null || ref2 === void 0 ? void 0 : ref2.querySelector(".mode-defurnish button")) === null || ref3 === void 0 ? void 0 : ref3.click();
                    },
                    showPanorama: tour.panorama,
                    toggleExternalPopup: this.toggleExternalPopup,
                    handleToggleMusic: this.handleToggleMusic,
                    isAudioControlEnabled: isAudioControlEnabled,
                    takeScreenshot: this.takeScreenshot,
                    takePano: this.takePano,
                    whitelabel: whiteLabelData,
                    showMinimapClick: function() {
                        _this.setState({
                            minimapVisible: !minimapVisible
                        });
                    },
                    showPanoramaClick: this.handleTogglePano,
                    onHelpClick: function() {
                        _this.setState({
                            showHelpModal: true,
                            showTermsModal: false
                        });
                    },
                    onTermsClick: function() {
                        _this.setState({
                            showTermsModal: true,
                            showHelpModal: false
                        });
                    },
                    toggleVS: this.toggleVS,
                    openVR: this.openVR,
                    onStartVideo: function() {
                        _this.setState({
                            videoPlaying: true
                        });
                        BaseTour_audioHandler.pauseAllMusic();
                    },
                    onStopVideo: function() {
                        BaseTour_audioHandler.playAudio({
                            type: AudioModule/* MusicObj.TOUR */.nR.TOUR,
                            id: _this.state.tour.id
                        });
                        _this.setState({
                            videoPlaying: false
                        });
                    },
                    currentFloor: currentFloor,
                    onMuteClick: this.toggleMuteParticipants,
                    onFullscreenClick: this.toggleFullscreenVideo,
                    onPinClick: this.addPinnedVideo,
                    initialDuplicates: (ref5 = this.props) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.tourData) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.tour) === null || ref7 === void 0 ? void 0 : ref7.initialDuplicates,
                    audioOnly: this.state.audioOnly,
                    hideForWhile: hideBottomBarForWhile,
                    showCaseTemp: this.showCaseTemp,
                    iframe: this.iframe,
                    toggleThreadsDrawer: function() {
                        return _this.setState(function(prevState) {
                            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevState), {
                                isThreadsDrawerOpen: !prevState.isThreadsDrawerOpen
                            });
                        });
                    },
                    closeThreadsDrawer: function() {
                        return _this.setState({
                            isThreadsDrawerOpen: false,
                            selectedThread: null
                        });
                    },
                    openThreadsDrawer: function() {
                        return _this.setState({
                            isThreadsDrawerOpen: true
                        });
                    },
                    isThreadsDrawerOpen: this.state.isThreadsDrawerOpen,
                    threadsLoaded: this.state.threadsLoaded,
                    selectedThread: this.state.selectedThread,
                    threads: Array.from(this.state.allTags, function(param) {
                        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), value = _param[1];
                        return value;
                    }).filter(function(t) {
                        return t.isThread;
                    }),
                    appState: this.state.appState,
                    addThreadToSpace: this.addThreadToSpace,
                    removeThreadFromSpace: this.removeThreadFromSpace,
                    toggleThreadVisibility: this._changeTagPos,
                    hideElements: this.hideElements,
                    avatar: chatParticipant,
                    moveToTagIO: function(tagSid) {
                        var tags = Array.from(_this.state.allTags.values());
                        var foundTag = tags.find(function(t) {
                            return tagSid && (t.sid === tagSid || t.defaultSid === tagSid);
                        });
                        if (!foundTag) return;
                        _this.moveToTagIO(foundTag, false);
                    },
                    flowIsActive: flowIsActive,
                    onToggleBottomBarActions: this.handleUserBottomBarActions,
                    getShareLocation: this.getShareLocation,
                    isRtl: (ref8 = tour.client) === null || ref8 === void 0 ? void 0 : ref8.rtl
                })
            ]
        });
    };
    _proto.injectChildComponents = function injectChildComponents() {};
    /** experience handlers * */ _proto.renderGameContent = function renderGameContent() {};
    _proto.hideItemsFromConditions = function hideItemsFromConditions() {};
    _proto.renderEndGameScreen = function renderEndGameScreen() {};
    _proto.handleGameStart = function handleGameStart(username, skipValidation) {};
    _proto.tryButtonPlaySound = function tryButtonPlaySound() {};
    /** experience handlers * */ _proto.isRenderAuth = function isRenderAuth() {
        var tour = this.state.tour;
        var p = (0,util_all/* getQueryVariable */.Dv)(window.location.href, "p");
        if (!tour || tour.password && p && atob(decodeURIComponent(p)) === tour.password) {
            return false;
        }
        return !!tour.password;
    };
    _proto.renderAuth = function renderAuth() {
        // Login screen has been combined with IntroScreen, so we don't need this function to return the Login component anymore
        // But we still need the function because it get's overriden in the GameTour component
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    };
    _proto.initPathDistanceUpdates = function initPathDistanceUpdates() {
        var _this = this;
        this.showCaseTemp.navigationManager.component.inputs.onDistanceChanged = function(distance) {
            _this.setState({
                actionPathNavbarDistance: distance
            });
        };
    };
    _proto.setIotModalOpen = function setIotModalOpen(open, showDescr) {
        this.setState({
            iotModalOpen: open,
            iotModalShowDescription: showDescr
        });
    };
    _proto.setTagPopupOpen = function setTagPopupOpen(open, showDescr) {
        this.setState({
            tagPopupOpen: open,
            tagPopupShowDescription: showDescr
        });
    };
    _proto.setGalleryOpen = function setGalleryOpen() {
        this.setState({
            galleryArr: []
        });
    };
    _proto.getValueOnWindowLocationObject = function getValueOnWindowLocationObject(key) {
        var value = "";
        try {
            var ref, ref1, ref2;
            value = ((ref = this.iframe) === null || ref === void 0 ? void 0 : (ref1 = ref.contentWindow) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.location) === null || ref2 === void 0 ? void 0 : ref2[key]) || "";
        } catch (e) {
            value = "";
        }
        return value;
    };
    _proto.setAllSweepsEnabled = function setAllSweepsEnabled(enabled) {
        var _Sweep, _Sweep1;
        if (!this.state.sweeps) {
            console.error(this.state.sweeps, "Attempted to enable/disable sweeps before they were initialized");
            return;
        }
        if (enabled) (_Sweep = this.showCaseTemp.showcase.Sweep).enable.apply(_Sweep, (0,_to_consumable_array/* default */.Z)(this.state.sweeps.map(function(s) {
            return s.sid;
        })));
        if (!enabled) (_Sweep1 = this.showCaseTemp.showcase.Sweep).disable.apply(_Sweep1, (0,_to_consumable_array/* default */.Z)(this.state.sweeps.map(function(s) {
            return s.sid;
        })));
    };
    _proto.render = function render() {
        var _this = this;
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
        (0,renderDebug/* dLog */.a)("BaseTour");
        var _state = this.state, tour = _state.tour, game = _state.game, gameStatus = _state.gameStatus, sweepGroups = _state.sweepGroups, measurementsOn = _state.measurementsOn, allowGuestBeforeHost = _state.allowGuestBeforeHost, room = _state.room, activeSweepGroup = _state.activeSweepGroup, sharePopupOn = _state.sharePopupOn, overlayOn = _state.overlayOn, showcaseLoaded = _state.showcaseLoaded, currentSweep = _state.currentSweep, tokenRemainingTime = _state.tokenRemainingTime, tokenExpiresAt = _state.tokenExpiresAt, showSketchfabPopup = _state.showSketchfabPopup, whiteLabelData = _state.whiteLabelData, minimapVisible = _state.minimapVisible, minimapOn = _state.minimapOn, minimaps = _state.minimaps, selectedMinimap = _state.selectedMinimap, mapWalkerX = _state.mapWalkerX, mapWalkerY = _state.mapWalkerY, mapWalkerRotation = _state.mapWalkerRotation, lock = _state.lock, tagPopOn = _state.tagPopOn, panoPopOn = _state.panoPopOn, openedTag = _state.openedTag, openedPanoHotspot = _state.openedPanoHotspot, vsActionPopOn = _state.vsActionPopOn, openedVSAction = _state.openedVSAction, contactPopupOn = _state.contactPopupOn, externalPopupOn = _state.externalPopupOn, externalPopupUrl = _state.externalPopupUrl, panoramaOn = _state.panoramaOn, host = _state.host, selectedMarker = _state.selectedMarker, showHelpModal = _state.showHelpModal, showTermsModal = _state.showTermsModal, panoramas = _state.panoramas, interacted = _state.interacted, showIntro = _state.showIntro, containerId = _state.containerId, loadingTags = _state.loadingTags, agents = _state.agents, tourEmail = _state.tourEmail, translation = _state.translation, tourType = _state.tourType, reelVideos = _state.reelVideos, experiencePopUpIsOpen = _state.experiencePopUpIsOpen, initialDuplicates = _state.initialDuplicates, experiencePopUpData = _state.experiencePopUpData, forcePlayGameIntro = _state.forcePlayGameIntro, menuSettings = _state.menuSettings, iot = _state.iot, // --- to add
        ticketingOpen = _state.ticketingOpen, ticketing = _state.ticketing, avatar = _state.avatar, chatParticipant = _state.chatParticipant, iframeUrl = _state.iframeUrl, audioOnly = _state.audioOnly, showBottomBar = _state.showBottomBar, iframeSettings = _state.iframeSettings, startScreenOn = _state.startScreenOn, isThreadsDrawerOpen = _state.isThreadsDrawerOpen, confirmDialog = _state.confirmDialog, isShowProduct = _state.isShowProduct, gameLockPopOn = _state.gameLockPopOn, flowIsActive = _state.flowIsActive, flows = _state.flows, mainFlow = _state.mainFlow, videoChatOn = _state.videoChatOn, bottomBarChatOn = _state.bottomBarChatOn, startFlowFromAsset = _state.startFlowFromAsset;
        var _props = this.props, _tour = _props._tour, tourImage = _props.tourImage, tourData = _props.tourData;
        var tourForIS = tour || (tourData === null || tourData === void 0 ? void 0 : tourData.tour);
        var preview = !!_tour;
        var loadSweeps = !showIntro && !startScreenOn && !loadingTags && showcaseLoaded && sweepGroups && sweepGroups.length > 0;
        var isEcommerceTour = tourType === Tour/* TourType.ECommerce */.v.ECommerce;
        var showMinimap = this.isGameTour() ? gameStatus !== components_types/* GameStatus.NotStarted */.XI.NotStarted : showcaseLoaded && !flowIsActive;
        // For tours with MP pass, we show panorama only after password was entered and showcase is loaded
        var showPanorama = panoramaOn && (panoramas === null || panoramas === void 0 ? void 0 : panoramas.length) > 0 && (tour.mpPasswordActive ? showcaseLoaded : true) && !flowIsActive;
        var commonConditions = showcaseLoaded && !measurementsOn && !startScreenOn && !showIntro && (room ? host : true);
        var overlapMenu = this.state.menuOpen && (showHelpModal || showTermsModal);
        // If room is set, it means it's a Hub call and we show menu only to the host
        var showMenu = !this.isGameTour() && ((tour === null || tour === void 0 ? void 0 : tour.menuEnabled) || (iot === null || iot === void 0 ? void 0 : (ref = iot.menuSettings) === null || ref === void 0 ? void 0 : ref.active)) && commonConditions && !flowIsActive && !overlapMenu;
        var showIot = (tour === null || tour === void 0 ? void 0 : tour.enableIot) && commonConditions;
        var hasAcceptedCookies = this.context.hasAcceptedCookies;
        var ticketingContentTickets = [];
        if ((ticketing === null || ticketing === void 0 ? void 0 : (ref1 = ticketing.ticketingOrderedTicket) === null || ref1 === void 0 ? void 0 : ref1.ticketType) === "tourByYourself") ticketingContentTickets = ticketing === null || ticketing === void 0 ? void 0 : ticketing.ticketingToursByYourself;
        else if ((ticketing === null || ticketing === void 0 ? void 0 : (ref2 = ticketing.ticketingOrderedTicket) === null || ref2 === void 0 ? void 0 : ref2.ticketType) === "gameTour") ticketingContentTickets = ticketing === null || ticketing === void 0 ? void 0 : ticketing.ticketingGameTour;
        else if ((ticketing === null || ticketing === void 0 ? void 0 : (ref3 = ticketing.ticketingOrderedTicket) === null || ref3 === void 0 ? void 0 : ref3.ticketType) === "guidedTour") ticketingContentTickets = ticketing === null || ticketing === void 0 ? void 0 : ticketing.ticketingGuidedTour;
        var isMobile = deviceManager/* default.isMobile */.Z.isMobile();
        var isChrome = deviceManager/* default.isChrome */.Z.isChrome();
        var isIOS = deviceManager/* default.isIOS */.Z.isIOS();
        var tourStarted = this.isTourReadyForAudio();
        var isBusinessOrEnterprise = ((ref4 = this.state.tour) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.user) === null || ref5 === void 0 ? void 0 : ref5.enterprise) || ((ref6 = this.state.tour) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.user) === null || ref7 === void 0 ? void 0 : ref7.subscription) === (User/* UserSubscription.Business */.MX.Business || User/* UserSubscription.Enterprise */.MX.Enterprise);
        var chatsOverlap = (videoChatOn || bottomBarChatOn) && deviceManager/* default.isMobile */.Z.isMobile();
        var renderTagTooltip = function(tag) {
            var ref;
            var _state = _this.state, selectedTag = _state.selectedTag, lastTagHovered = _state.lastTagHovered, isTagHovered = _state.isTagHovered, tour = _state.tour, traneData = _state.traneData;
            //TODO: REMOVE, this is for trane only
            if ((tour === null || tour === void 0 ? void 0 : tour.slug) === "trane-demo") {
                var ref1, ref2;
                var devices = [];
                traneData === null || traneData === void 0 ? void 0 : (ref1 = traneData.data) === null || ref1 === void 0 ? void 0 : ref1.sensors.map(function(sensor) {
                    devices.push({
                        id: 1,
                        providerId: 1,
                        tourId: tour.id,
                        value: sensor.value,
                        name: sensor.name
                    });
                });
                tag = Object.assign({}, tag, {
                    iotDevices: devices,
                    title: traneData === null || traneData === void 0 ? void 0 : (ref2 = traneData.data) === null || ref2 === void 0 ? void 0 : ref2.date
                });
                selectedTag = tag;
                lastTagHovered = tag;
            }
            if (!tag || experiencePopUpIsOpen || showPanorama || _this.state.tagPopupOpen || _this.state.iotModalOpen) return null;
            if ((ref = tag.iotDevices) === null || ref === void 0 ? void 0 : ref.length) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* TagTooltipCustom */.Bg, {
                    tag: isTagHovered && lastTagHovered ? lastTagHovered : selectedTag,
                    camera: _this.camera,
                    THREE: _this.THREE,
                    renderer: _this.renderer,
                    setIotModalOpen: function(open, showDescr) {
                        var ref, ref1;
                        _this.setIotModalOpen(open, showDescr);
                        _this.updateIotState({
                            openCamera: (ref1 = lastTagHovered === null || lastTagHovered === void 0 ? void 0 : (ref = lastTagHovered.iotDevices) === null || ref === void 0 ? void 0 : ref.filter(function(d) {
                                return d.videoUrl;
                            })) === null || ref1 === void 0 ? void 0 : ref1[0],
                            openFavouriteCameras: null
                        });
                    },
                    providers: iot === null || iot === void 0 ? void 0 : iot.providers,
                    sidebarWidth: null,
                    handleUnlock: function(d) {
                        return _this.updateIotState({
                            lockDeviceId: d.id
                        });
                    },
                    iotDevices: iot === null || iot === void 0 ? void 0 : iot.devices
                });
            }
            if (tag.treedisStyle) {
                var tagToShow = null;
                var hideTooltipOnMove = function() {
                    _this.showcase.Sweep.current.subscribe(function(currentSweep) {
                        if (currentSweep.sid === "") {
                            _this.setState({
                                isTagHovered: false
                            });
                        }
                    });
                    _this.renderer.domElement.removeEventListener("click", hideTooltipOnMove);
                };
                if (isTagHovered && tag.hoverTooltip) {
                    tagToShow = lastTagHovered;
                } else if (tag.clickPopup && selectedTag) {
                    tagToShow = selectedTag;
                }
                if (tagToShow) {
                    _this.renderer.domElement.addEventListener("click", hideTooltipOnMove);
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* BaseTagTooltip */.sK, {
                        setTagPopupOpen: function(open, showDescr) {
                            _this.setTagPopupOpen(open, showDescr);
                        },
                        tag: tagToShow,
                        camera: _this.camera,
                        renderer: _this.renderer,
                        handleClickDescriptionLink: _this.handleClickDescriptionLink,
                        pauseTourMusic: BaseTour_audioHandler.stopTourMusic,
                        playTourMusic: BaseTour_audioHandler.resumeMusic,
                        translation: _this.state.translation
                    });
                }
            }
        };
        // Off intro screen if navigation enabled
        if (tour && (tour === null || tour === void 0 ? void 0 : tour.navigationWebEnabled)) {
            this.setState({
                startScreenOn: false
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                !this.state.interacted && /*#__PURE__*/ (0,jsx_runtime.jsx)(InteractedListener, {
                    onInteracted: function() {
                        _this.setState({
                            interacted: true
                        });
                    },
                    showcase: this.showcase
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FullScreen/* default */.Z, {
                    attrs: {
                        id: "global-fullscreen",
                        class: classnames_default()((tour === null || tour === void 0 ? void 0 : (ref8 = tour.client) === null || ref8 === void 0 ? void 0 : ref8.rtl) && "rtl")
                    },
                    rootBody: true,
                    children: function(param) {
                        var isFullScreen = param.isFullScreen, toggleFullscreen = param.toggleFullscreen;
                        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28, ref29, ref30, ref31, ref32, ref33;
                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                _this.state.mondelezTabletVideo.videoId && /*#__PURE__*/ (0,jsx_runtime.jsx)(MondelezTabletVideo/* default */.Z, {
                                    videoId: _this.state.mondelezTabletVideo.videoId,
                                    onClose: function() {
                                        return _this.setState({
                                            mondelezTabletVideo: {
                                                videoId: undefined,
                                                sweepsHistory: _this.state.mondelezTabletVideo.sweepsHistory
                                            }
                                        });
                                    }
                                }),
                                (_this.state.selectedTag || _this.state.isTagHovered) && !startScreenOn && !isShowProduct && !tagPopOn && !gameLockPopOn && _this.state.appState === "playing" && renderTagTooltip(_this.state.tagHovered || _this.state.selectedTag),
                                _this.state.tagPopupOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "tag-popup-container",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* TagPopup */.KD, {
                                        open: _this.state.tagPopupOpen,
                                        setOpen: function(open, showDescr) {
                                            _this.setTagPopupOpen(open, showDescr);
                                        },
                                        showDescription: _this.state.tagPopupShowDescription,
                                        tag: _this.state.tagHovered || _this.state.selectedTag,
                                        pauseTourMusic: BaseTour_audioHandler.stopTourMusic,
                                        playTourMusic: BaseTour_audioHandler.resumeMusic,
                                        translation: _this.state.translation
                                    })
                                }),
                                ((ref = _this.state.tour) === null || ref === void 0 ? void 0 : ref.enableIot) && ((ref1 = _this.state.tour) === null || ref1 === void 0 ? void 0 : ref1.iot2FAEnabled) && !((ref2 = _this.state.tour) === null || ref2 === void 0 ? void 0 : ref2.isSample) && /*#__PURE__*/ (0,jsx_runtime.jsx)(IotLoginModal, {
                                    tour: _this.state.tour
                                }),
                                ((ref3 = _this.state.galleryArr) === null || ref3 === void 0 ? void 0 : ref3.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_GalleryDialog, {
                                    open: ((ref4 = _this.state.galleryArr) === null || ref4 === void 0 ? void 0 : ref4.length) > 0,
                                    setOpen: function() {
                                        return _this.setGalleryOpen();
                                    },
                                    gallery: _this.state.galleryArr,
                                    title: _this.state.galleryName
                                }),
                                ((ref5 = _this.state.tour) === null || ref5 === void 0 ? void 0 : ref5.enableIot) && /*#__PURE__*/ (0,jsx_runtime.jsx)(IotTourModal, {
                                    open: _this.state.iotModalOpen,
                                    setOpen: function(open, showDescr) {
                                        _this.setIotModalOpen(open, showDescr);
                                        _this.updateIotState({
                                            openCamera: null,
                                            openFavouriteCameras: null
                                        });
                                    },
                                    tag: _this.state.lastTagHovered || _this.state.selectedTag,
                                    providers: iot === null || iot === void 0 ? void 0 : iot.providers,
                                    moveToTagIO: function(tag) {
                                        _this.moveToTagIO(tag, false);
                                    },
                                    handleUnlock: function(d) {
                                        return _this.updateIotState({
                                            lockDeviceId: d.id
                                        });
                                    },
                                    iotDevices: iot === null || iot === void 0 ? void 0 : iot.devices,
                                    openCamera: iot.openCamera,
                                    openFavouriteCameras: iot.openFavouriteCameras,
                                    newDoorNotification: iot.newDoorNotification,
                                    handleMoveToLock: function(d) {
                                        return _this.updateIotState({
                                            moveToDevice: d
                                        });
                                    },
                                    tags: Array.from(_this.state.allTags.values())
                                }),
                                showMenu && /*#__PURE__*/ (0,jsx_runtime.jsx)(menu_wrapper_MenuWrapper, {
                                    tour: _this.state.tour,
                                    sendTagToGA: _this.sendTagToGA,
                                    menuSettings: menuSettings,
                                    rtl: tour === null || tour === void 0 ? void 0 : (ref6 = tour.client) === null || ref6 === void 0 ? void 0 : ref6.rtl,
                                    open: _this.state.menuOpen && !isThreadsDrawerOpen,
                                    bmItems: _this.state.menus,
                                    toggleContactPopup: _this.toggleContactPopup,
                                    toggleExternalPopup: _this.toggleExternalPopup,
                                    moveToMPLabels: _this.moveToMPLabels,
                                    loadModel: _this.loadModelMenu,
                                    tourEmail: tourEmail,
                                    iotMenu: iot === null || iot === void 0 ? void 0 : iot.menuSettings,
                                    iotDevices: iot === null || iot === void 0 ? void 0 : iot.devices,
                                    providers: iot === null || iot === void 0 ? void 0 : (ref7 = iot.providers) === null || ref7 === void 0 ? void 0 : ref7.map(function(provider) {
                                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, provider), {
                                            icon: (provider === null || provider === void 0 ? void 0 : provider.icon) ? "".concat("https://api.treedis.com" || 0, "/v1/public/icons/").concat(provider === null || provider === void 0 ? void 0 : provider.icon) : ""
                                        });
                                    }),
                                    sendToGA: analytic/* sendToGA */.o$,
                                    whitelabel: whiteLabelData,
                                    hideTriggerButton: isEcommerceTour || isThreadsDrawerOpen,
                                    currentSid: currentSweep === null || currentSweep === void 0 ? void 0 : currentSweep.sid,
                                    // If minimap is ON, we subtract it's height from Menu's height so they don't overlap
                                    minimapHeight: minimapVisible && !!(tourForIS === null || tourForIS === void 0 ? void 0 : tourForIS.minimap) ? minimapOn ? 450 : 200 : 0,
                                    translation: _this.state.translation,
                                    onClose: _this.closeMenu,
                                    onOpen: _this.openMenu,
                                    onWidthChange: _this.changeWidthMenu,
                                    handleLock: _this.handleLockMenu,
                                    handleMoveToLock: _this.handleMoveToLockMenu,
                                    handleOpenCamera: _this.handleOpenCameraMenu,
                                    favouriteCameras: iot === null || iot === void 0 ? void 0 : iot.favouriteCameras,
                                    activeMenuId: ((ref8 = _this.state) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.activeMenu) === null || ref9 === void 0 ? void 0 : ref9.subSubMenuId) || ((ref10 = _this.state) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.activeMenu) === null || ref11 === void 0 ? void 0 : ref11.subMenuId) || ((ref12 = _this.state) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.activeMenu) === null || ref13 === void 0 ? void 0 : ref13.menuId)
                                }),
                                showIot && /*#__PURE__*/ (0,jsx_runtime.jsx)(IotLogic, {
                                    showcase: _this.showCaseTemp,
                                    iot: iot,
                                    tourId: tour === null || tour === void 0 ? void 0 : tour.id,
                                    tourSlug: tour === null || tour === void 0 ? void 0 : tour.slug,
                                    updateIotState: _this.updateIotState,
                                    setState: function(newState) {
                                        return _this.setState(newState);
                                    },
                                    moveToTagIO: function(tagSid) {
                                        var tags = Array.from(_this.state.allTags.values());
                                        var foundTag = tags.find(function(t) {
                                            return tagSid && (t.sid === tagSid || t.defaultSid === tagSid);
                                        });
                                        if (!foundTag) return;
                                        _this.moveToTagIO(foundTag, false);
                                    }
                                }),
                                !chatsOverlap && !(tour === null || tour === void 0 ? void 0 : tour.menuEnabled) && showcaseLoaded && (tour === null || tour === void 0 ? void 0 : tour.contactForm) && ((tour === null || tour === void 0 ? void 0 : tour.client) && (tour === null || tour === void 0 ? void 0 : tour.client.email) || (tourEmail === null || tourEmail === void 0 ? void 0 : tourEmail.menuGetInTouch)) && tourType === Tour/* TourType.Regular */.v.Regular && !isThreadsDrawerOpen && !tour.navigationWebEnabled && !flowIsActive && /*#__PURE__*/ (0,jsx_runtime.jsx)(GetInTouchButton, {
                                    onClick: _this.toggleContactPopup,
                                    tooltipOn: tour === null || tour === void 0 ? void 0 : tour.getInTouchTooltipOn,
                                    translation: translation,
                                    rightOffset: _this.state.menuOpen ? _this.state.menuWidth : 0
                                }),
                                !chatsOverlap && showcaseLoaded && (tour === null || tour === void 0 ? void 0 : tour.customButton) && tourType === Tour/* TourType.Regular */.v.Regular && !measurementsOn && !startScreenOn && !showIntro && !isThreadsDrawerOpen && !flowIsActive && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                    sx: {
                                        padding: "4px 0px 4px 4px",
                                        position: "absolute",
                                        top: "190px",
                                        transition: "all 225ms cubic-bezier(0, 0, 0.2, 1) 0ms",
                                        right: "".concat(_this.state.menuOpen ? "".concat(_this.state.menuWidth, "px") : "0px"),
                                        zIndex: 1,
                                        overflow: "hidden"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomButton, {
                                        onClick: _this.handleCustomButton,
                                        tourId: tour === null || tour === void 0 ? void 0 : tour.id,
                                        customButtonIcon: tour === null || tour === void 0 ? void 0 : tour.customButtonIcon
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ScreenNavigationArrow/* ScreenNavigationArrow */.Q, {
                                    refProp: _this.pathArrowRefBaseTour
                                }),
                                !renderDebug/* stopLogs */.d && /*#__PURE__*/ (0,jsx_runtime.jsx)(DebugWindow, {}),
                                _this.state.gameTrialErr && _this.state.tourType === Tour/* TourType.Game */.v.Game && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "gameTrialErr",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "gameTrialErr-text",
                                            children: _this.state.gameTrialErr
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(units/* Button */.zx, {
                                            onClick: function() {
                                                return window.close();
                                            },
                                            children: "Close"
                                        })
                                    ]
                                }),
                                experiencePopUpIsOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(ExperiencePopUp, {
                                    isRtl: (ref14 = tour.client) === null || ref14 === void 0 ? void 0 : ref14.rtl,
                                    onInit: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                                        return (0,tslib_es6.__generator)(this, function(_state) {
                                            BaseTour_audioHandler.pauseAllMusic();
                                            return [
                                                2
                                            ];
                                        });
                                    }),
                                    tourId: tour === null || tour === void 0 ? void 0 : tour.id,
                                    getCurrentLanguage: _this.getCurrentLanguage,
                                    tryButtonPlaySound: _this.tryButtonPlaySound,
                                    experiencePopUpData: experiencePopUpData,
                                    isOpen: experiencePopUpIsOpen,
                                    setIsOpen: function(status) {
                                        // as I understand this using only for closing experience from itself
                                        BaseTour_audioHandler.resumeMusic();
                                        _this.state.onExperienceCloseCallback();
                                        _this.setState({
                                            experiencePopUpIsOpen: status,
                                            closedElementPopup: !status,
                                            onExperienceCloseCallback: function() {
                                                return undefined;
                                            }
                                        });
                                    }
                                }),
                                _this.state.vsHTMLPopup.show && deviceManager/* default.isMobile */.Z.isMobile() && /*#__PURE__*/ (0,jsx_runtime.jsx)(VSHTMLPopup, {
                                    setShow: _this.setVsHTMLPopupShow,
                                    src: _this.state.vsHTMLPopup.src
                                }),
                                ticketingOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(TicketingRouter, {
                                    matterId: tour.slug,
                                    parentTourId: tour.parentId,
                                    tourId: tour.id,
                                    gameId: tour.gameId,
                                    ticketing: ticketing,
                                    reactAppDomain: _this.root,
                                    reactAws: _this.props.reactAws,
                                    tourImage: tourImage,
                                    onTicketLoginSuccess: _this.onTicketLoginSuccess,
                                    translation: translation,
                                    whiteLabelData: whiteLabelData
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    id: "".concat(containerId, "-tour-root"),
                                    className: classnames_default()(preview ? "preview base-tour tour-container" : "base-tour tour-container", isMobile && "no-visible-scrollbar", tourType === Tour/* TourType.Game */.v.Game && host && "game-container"),
                                    // eslint-disable-next-line no-return-assign
                                    ref: function(el) {
                                        return _this.root = el;
                                    },
                                    children: [
                                        tokenRemainingTime > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "countDownWrap",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "countDown",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Countdown, {
                                                    date: tokenExpiresAt,
                                                    zeroPadDays: 0,
                                                    onComplete: function() {
                                                        _this.props.history.push("/");
                                                    }
                                                })
                                            })
                                        }),
                                        !ticketingOpen && tour && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                            children: _this.isRenderAuth() && _this.isGameTour() ? _this.renderAuth() : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: classnames_default()("inner", {
                                                    mobile: isMobile,
                                                    isChromeInIOS: isIOS && isChrome
                                                }),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "ui-wrap",
                                                        children: [
                                                            _this.state.showActionPathBar && !_this.isGameTour() && _this.showCaseTemp && _this.showCaseTemp.navigationManager && /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionPathNavbarWithRecoil, {
                                                                tourType: _this.state.tourType,
                                                                navigationMode: _this.state.tourType === Tour/* TourType.Kiosk */.v.Kiosk || tour.navigationWebEnabled,
                                                                measurementsOn: _this.state.measurementsOn,
                                                                pathFinderLine: _this.showCaseTemp.navigationManager,
                                                                setVisible: _this.setActionPathNavbarVisible,
                                                                sdk: _this.showCaseTemp.showcase,
                                                                enableNavBar: _this.state.actionPathNavbarData.enableNavBar,
                                                                destinationTitle: _this.state.actionPathNavbarData.destinationTitle,
                                                                icon: _this.state.actionPathNavbarData.icon,
                                                                autoNavigation: _this.state.actionPathNavbarData.autoNavigation,
                                                                enableTeleportBtn: _this.state.actionPathNavbarData.enableTeleportBtn,
                                                                distance: _this.state.actionPathNavbarDistance,
                                                                playButtonType: _this.state.actionPathNavbarPlayButtonType,
                                                                setPlayButtonType: _this.setActionPathNavbarPlayButtonType,
                                                                setActionPathFinished: _this.setActionPathFinished,
                                                                setTeleportFinished: _this.setTeleportFinished,
                                                                rtl: (ref15 = tour.client) === null || ref15 === void 0 ? void 0 : ref15.rtl,
                                                                translation: _this.state.translation,
                                                                resetNavigationByCloseButton: _this.resetNavigationByCloseButton
                                                            }),
                                                            tour.messengerLink && tour.messengerGreeting && _this.messenger !== 0 && !room && /*#__PURE__*/ (0,jsx_runtime.jsx)(MessengerCustomerChat, {
                                                                pageId: tour.messengerLink,
                                                                loggedInGreeting: tour.messengerGreeting,
                                                                loggedOutGreeting: tour.messengerGreeting,
                                                                themeColor: (whiteLabelData === null || whiteLabelData === void 0 ? void 0 : whiteLabelData.secondaryColor) || "#ea475c"
                                                            }),
                                                            externalPopupUrl && externalPopupOn && /*#__PURE__*/ (0,jsx_runtime.jsx)(ExternalPopup, {
                                                                show: externalPopupUrl && externalPopupOn,
                                                                url: externalPopupUrl,
                                                                onClose: _this.toggleExternalPopupNull,
                                                                logo: (whiteLabelData === null || whiteLabelData === void 0 ? void 0 : whiteLabelData.active) ? whiteLabelData === null || whiteLabelData === void 0 ? void 0 : whiteLabelData.logo : defaultLogo,
                                                                iframeSettings: iframeSettings
                                                            }),
                                                            _this.injectChildComponents(),
                                                            !_this.isGameTour() && !_this.state.panoramaOn && (tour === null || tour === void 0 ? void 0 : tour.gameId) && ((ref16 = _this.state) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.game) === null || ref17 === void 0 ? void 0 : (ref18 = ref17.paths) === null || ref18 === void 0 ? void 0 : ref18.length) === 1 && !_this.state.showIntro && _this.isTourReadyForAudio() && /*#__PURE__*/ (0,jsx_runtime.jsx)(RegularPaths, {
                                                                panoIsOpen: panoramaOn,
                                                                pathfinderDataState: _this.state.pathfinderDataState,
                                                                setPathfinderDataState: _this.setPathfinderDataState,
                                                                isRtl: (ref19 = tour.client) === null || ref19 === void 0 ? void 0 : ref19.rtl,
                                                                translation: _this.state.translation,
                                                                gameId: game.id,
                                                                gamePaths: _this.state.game.paths,
                                                                allTags: _this.state.allTags,
                                                                polygons: _this.state.polygons,
                                                                showcase: _this.showCaseTemp,
                                                                vsObjects: _this.vsObjects,
                                                                sweeps: _this.state.sweeps,
                                                                currentSweep: _this.state.currentSweep,
                                                                clickedElement: _this.state.clickedElement,
                                                                onAction: _this.onPathAction,
                                                                __hideItems: _this.__hideConditions,
                                                                __revealItems: _this.__revealConditions,
                                                                showElements: _this.showElements,
                                                                hideElements: _this.hideElements
                                                            }),
                                                            tagPopOn && /*#__PURE__*/ (0,jsx_runtime.jsx)(TagsPopup, {
                                                                logo: whiteLabelData === null || whiteLabelData === void 0 ? void 0 : whiteLabelData.logo,
                                                                obj: openedTag,
                                                                type: "tags",
                                                                tourId: tour.id,
                                                                closePop: _this.closeTagPop
                                                            }),
                                                            !ticketingOpen && (ticketing === null || ticketing === void 0 ? void 0 : ticketing.ticketingOrderedTicket) && /*#__PURE__*/ (0,jsx_runtime.jsx)(RenderTicketingContent, {
                                                                tickets: ticketingContentTickets,
                                                                translation: ticketing === null || ticketing === void 0 ? void 0 : ticketing.ticketingTranslation,
                                                                tourSlug: tour.slug,
                                                                ticketingOrderedTicket: ticketing === null || ticketing === void 0 ? void 0 : ticketing.ticketingOrderedTicket,
                                                                ticketTimeLeftMs: _this.state.ticketTimeLeftMs,
                                                                ticketModalInfo: _this.state.ticketModalInfo,
                                                                root: _this.root,
                                                                tourId: tour.id,
                                                                gameId: tour.gameId,
                                                                ticketingGeneral: ticketing === null || ticketing === void 0 ? void 0 : ticketing.ticketingGeneral,
                                                                showTicketModal: _this.state.showTicketModal
                                                            }),
                                                            openedPanoHotspot && panoPopOn && /*#__PURE__*/ (0,jsx_runtime.jsx)(PanoPopup, {
                                                                hotspot: openedPanoHotspot,
                                                                show: panoPopOn,
                                                                onClose: _this.closePanoPop,
                                                                logo: whiteLabelData === null || whiteLabelData === void 0 ? void 0 : whiteLabelData.logo
                                                            }),
                                                            _this.state.showPathFinderPopup && /*#__PURE__*/ (0,jsx_runtime.jsx)(PathFinderPopup, {
                                                                open: _this.state.showPathFinderPopup,
                                                                closePopup: _this.closePathFinderPop
                                                            }),
                                                            vsActionPopOn && /*#__PURE__*/ (0,jsx_runtime.jsx)(VSActionsPopup, {
                                                                tourId: tour.id,
                                                                object: openedVSAction,
                                                                onClose: _this.closeActionPop
                                                            }),
                                                            contactPopupOn && showcaseLoaded && /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactPopup, {
                                                                agents: agents,
                                                                rtl: (ref20 = tour.client) === null || ref20 === void 0 ? void 0 : ref20.rtl,
                                                                translation: translation,
                                                                to: (tourEmail === null || tourEmail === void 0 ? void 0 : tourEmail.menuGetInTouch) || (tour === null || tour === void 0 ? void 0 : (ref21 = tour.client) === null || ref21 === void 0 ? void 0 : ref21.email),
                                                                legalBookingBox: tour.legalBookingBox,
                                                                legalBookingBox2: tour.legalBookingBox2,
                                                                userId: tour.userId,
                                                                tourId: tour.id,
                                                                title: tour.title,
                                                                client: tour.client,
                                                                hideClientContact: tour.hideClientContact,
                                                                phone: tourEmail === null || tourEmail === void 0 ? void 0 : tourEmail.contactPhone,
                                                                name: tourEmail === null || tourEmail === void 0 ? void 0 : tourEmail.contactName,
                                                                toggleContactPopup: _this.toggleContactPopup
                                                            }),
                                                            !room && tour.ad && /*#__PURE__*/ (0,jsx_runtime.jsx)(AdRedesigned/* default */.Z, {
                                                                to: tourEmail && tourEmail.leadForms || tour.client && tour.client.email,
                                                                tour: tour,
                                                                translation: translation,
                                                                rtl: _this.state.rtl,
                                                                whitelabel: whiteLabelData,
                                                                form: {
                                                                    imageSrc: "".concat("https://cdn.treedis.com", "/tours/").concat(tour.id, "/ad.webp").concat((0,util_all/* getVersion */.bo)(tour.updatedAt)),
                                                                    phone: tour.leadsTimedPhone,
                                                                    name: tour.leadsTimedName,
                                                                    email: tour.leadsTimedEmail,
                                                                    checkbox1: tour.legalBookingBox,
                                                                    checkbox2: tour.legalBookingBox2,
                                                                    url: tour.adUrl,
                                                                    time: tour.adTime
                                                                }
                                                            }),
                                                            showPanorama && _this.renderPanorama(),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "overlay ".concat(overlayOn ? "open" : "")
                                                            }),
                                                            room && _this.showCaseTemp && _this.pose && !startScreenOn && /*#__PURE__*/ (0,jsx_runtime.jsx)(MemoizedVideo, {
                                                                iframeId: _this.state.iframeId,
                                                                sdk: _this.showCaseTemp.showcase,
                                                                tour: tour,
                                                                host: host,
                                                                audioOnly: audioOnly,
                                                                measurementsOn: measurementsOn,
                                                                room: room,
                                                                slug: tour.slug,
                                                                name: chatParticipant === null || chatParticipant === void 0 ? void 0 : chatParticipant.name,
                                                                avatar: chatParticipant,
                                                                reelVideos: reelVideos,
                                                                endCall: _this.videoEndCall,
                                                                clientId: tour.clientId,
                                                                tourId: tour.id,
                                                                enterprise: isBusinessOrEnterprise,
                                                                translation: translation,
                                                                allowGuestBeforeHost: allowGuestBeforeHost,
                                                                changeTour: _this.videoChangeTour,
                                                                addTrack: _this.addTrack,
                                                                removeTrack: _this.removeTrack,
                                                                pinnedVideos: _this.state.pinnedVideos,
                                                                removePinnedVideo: _this.removePinnedVideo,
                                                                onToggleMute: _this.toggleMuteParticipants,
                                                                onToggleFullscreen: _this.toggleFullscreenVideo,
                                                                dominantSpeaker: _this.state.dominantSpeaker,
                                                                fullscreenVideo: _this.state.fullscreenVideo,
                                                                addVideoReel: _this.addVideoReel,
                                                                enableAvatar: tour === null || tour === void 0 ? void 0 : tour.enableAvatar,
                                                                imageInsteadOfAvatar: tour === null || tour === void 0 ? void 0 : tour.imageInsteadOfAvatar,
                                                                setAvatar: _this.setAvatar,
                                                                getAvatarImage: _this.getAvatarImage,
                                                                setAvatarImage: _this.setAvatarImage,
                                                                updateAvatarsInList: _this.updateAvatarsInList,
                                                                isWalkieTalkieOn: ((ref22 = _this.props) === null || ref22 === void 0 ? void 0 : (ref23 = ref22.tourData) === null || ref23 === void 0 ? void 0 : (ref24 = ref23.tour) === null || ref24 === void 0 ? void 0 : ref24.isWalkieTalkieOn) && audioOnly,
                                                                onToggleVideoActions: _this.handleUserVideoActions
                                                            }),
                                                            _this.showCaseTemp && !_this.state.startScreenOn && !avatar && !room && (tour === null || tour === void 0 ? void 0 : tour.enableAvatar) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                id: "video-name-overlay",
                                                                className: "overlay",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IntroPopup, {
                                                                    sdk: _this.showCaseTemp.showcase,
                                                                    enableAvatar: tour === null || tour === void 0 ? void 0 : tour.enableAvatar,
                                                                    avatarType: (tour === null || tour === void 0 ? void 0 : tour.imageInsteadOfAvatar) ? "image" : "model",
                                                                    translation: translation,
                                                                    setAvatar: _this.setAvatar,
                                                                    setAvatarImage: _this.setAvatarImage,
                                                                    getAvatarImage: _this.getAvatarImage,
                                                                    audioOnly: audioOnly
                                                                })
                                                            }),
                                                            tour.legalNote && !_this.state.startScreenOn && /*#__PURE__*/ (0,jsx_runtime.jsx)(LegalNote, {
                                                                note: tour.legalNote,
                                                                clientLogoWidth: _this.state.clientLogoWidth
                                                            }),
                                                            showcaseLoaded && !tour.unbranded && tour.client && tour.client.logo && !room && !_this.state.startScreenOn && !_this.state.showNewHintModal && !_this.state.hideLogo && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: ((ref25 = tour.client) === null || ref25 === void 0 ? void 0 : ref25.website) ? ((ref26 = tour.client.website) === null || ref26 === void 0 ? void 0 : ref26.includes("https://")) ? tour.client.website : "https://".concat(tour.client.website) : "",
                                                                target: "_blank",
                                                                rel: "noreferrer",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                    className: tour.client.widthLogo ? "logo width" : "logo",
                                                                    style: {
                                                                        display: "block",
                                                                        zIndex: 100
                                                                    },
                                                                    src: "".concat("https://cdn.treedis.com", "/clients/").concat(tour.client.id, "/logo.png").concat(util_all/* getVersion */.bo(tour.client.updatedAt)),
                                                                    alt: "",
                                                                    onLoad: function(event) {
                                                                        _this.setState({
                                                                            clientLogoWidth: event.target.width
                                                                        });
                                                                    }
                                                                })
                                                            }),
                                                            _this.state.markerPopupOn && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_MarkerPopup, {
                                                                onClose: function() {
                                                                    _this.setState({
                                                                        overlayOn: false,
                                                                        markerPopupOn: false
                                                                    });
                                                                },
                                                                primaryAction: _this.toggleExternalPopup.bind(_this, _this.state.selectedMarker.external),
                                                                secondaryAction: function() {
                                                                    return _this.moveModel(selectedMarker.url);
                                                                }
                                                            }),
                                                            showMinimap && /*#__PURE__*/ (0,jsx_runtime.jsx)(Minimap, {
                                                                tour: tour,
                                                                minimapOn: minimapOn,
                                                                minimapVisible: minimapVisible,
                                                                minimaps: minimaps,
                                                                navigationSweeps: _this.state.navigationSweeps,
                                                                selectedMinimap: selectedMinimap,
                                                                mapWalkerX: mapWalkerX,
                                                                mapWalkerY: mapWalkerY,
                                                                mapWalkerRotation: mapWalkerRotation,
                                                                markerClick: _this.markerClick,
                                                                onClick: function() {
                                                                    _this.setState({
                                                                        minimapOn: !minimapOn
                                                                    });
                                                                }
                                                            }),
                                                            _this.state.appointmentsModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(Appointment, {
                                                                tour: tour,
                                                                translation: translation,
                                                                tourEmail: tourEmail,
                                                                rtl: tour.client && tour.client.rtl,
                                                                appointmentsModal: _this.state.appointmentsModal,
                                                                toggleAppointmentsModal: _this.toggleAppointmentsModal,
                                                                appointmentTime: tour.appointmentTime
                                                            }),
                                                            sharePopupOn && /*#__PURE__*/ (0,jsx_runtime.jsx)(Share, {
                                                                tourType: tourType,
                                                                closeOnOutsideClick: tourType === Tour/* TourType.ECommerce */.v.ECommerce,
                                                                getLocation: _this.getShareLocation,
                                                                onClose: function() {
                                                                    _this.setState({
                                                                        sharePopupOn: false
                                                                    });
                                                                },
                                                                tour: tour,
                                                                translation: translation,
                                                                onColor: (whiteLabelData === null || whiteLabelData === void 0 ? void 0 : whiteLabelData.secondaryColor) || "#ea475c"
                                                            }),
                                                            showBottomBar && ((ref27 = _this.showCaseTemp) === null || ref27 === void 0 ? void 0 : ref27.showcase) && _this.renderBottomBar(isFullScreen, toggleFullscreen),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Sweep, {
                                                                show: loadSweeps && currentSweep && !panoramaOn && (avatar || !room || !(tour === null || tour === void 0 ? void 0 : tour.enableAvatar)),
                                                                flowIsActive: flowIsActive,
                                                                renderer: _this.renderer,
                                                                interacted: _this.state.interacted,
                                                                tourReadyForAudio: tourStarted,
                                                                hideSubtitlesGroupId: _this.state.hideSubtitlesGroupId,
                                                                videoContainer: {
                                                                    pause: BaseTour_audioHandler.stopTourMusic,
                                                                    play: _this.resumeTourMusic
                                                                },
                                                                tour: tour,
                                                                tourEmail: tourEmail,
                                                                whitelabel: whiteLabelData,
                                                                groups: sweepGroups,
                                                                selectedGroup: _this.state.activeSweepGroup,
                                                                noAudioMode: tour.noAudioMode && room,
                                                                translation: translation,
                                                                setIsSubtitleVisible: function(status) {
                                                                    return _this.setState({
                                                                        isSubtitleVisible: status
                                                                    });
                                                                },
                                                                showPanoramaClick: function(panoramaId) {
                                                                    var pIndex = panoramas.findIndex(function(p) {
                                                                        return p.id === panoramaId;
                                                                    });
                                                                    panoramas[pIndex].default = true;
                                                                    _this.setState({
                                                                        panoramas: panoramas,
                                                                        panoramaOn: !panoramaOn
                                                                    });
                                                                },
                                                                onInteractedChange: function(interacted) {
                                                                    _this.setState({
                                                                        interacted: interacted
                                                                    });
                                                                },
                                                                logo: whiteLabelData === null || whiteLabelData === void 0 ? void 0 : whiteLabelData.logo
                                                            }),
                                                            showHelpModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(Help, {
                                                                translation: translation,
                                                                onClose: function() {
                                                                    _this.setState({
                                                                        showHelpModal: false
                                                                    });
                                                                }
                                                            }),
                                                            showTermsModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(Terms, {
                                                                translation: translation,
                                                                tourId: tour.id,
                                                                onClose: function() {
                                                                    _this.setState({
                                                                        showTermsModal: false
                                                                    });
                                                                }
                                                            }),
                                                            lock && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "lock-layer"
                                                            }),
                                                            !showIntro && !startScreenOn && showcaseLoaded && (tour.music && tour.autoplayMusic || activeSweepGroup) && !room && !interacted && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                id: "music-cover",
                                                                style: {
                                                                    zIndex: 2,
                                                                    position: "fixed",
                                                                    height: "100vh",
                                                                    width: "100vw",
                                                                    top: 0,
                                                                    left: 0
                                                                },
                                                                onClick: function() {
                                                                    _this.setState({
                                                                        interacted: true
                                                                    });
                                                                }
                                                            }),
                                                            tourForIS && startScreenOn && (_this.isRenderAuth() || tourForIS.introScreen || _this.isGameTour()) && /*#__PURE__*/ (0,jsx_runtime.jsx)(IntroScreen, {
                                                                rtl: (ref28 = tourForIS.client) === null || ref28 === void 0 ? void 0 : ref28.rtl,
                                                                tour: tourForIS,
                                                                initialDuplicates: initialDuplicates,
                                                                introScreen: tourForIS.introScreen,
                                                                whiteLabelData: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, whiteLabelData), {
                                                                    isWLUser: !!(tourForIS === null || tourForIS === void 0 ? void 0 : (ref29 = tourForIS.user) === null || ref29 === void 0 ? void 0 : ref29.whitelabelId)
                                                                }),
                                                                translation: translation,
                                                                onStart: _this.onPlayClick,
                                                                isGameTour: _this.isGameTour,
                                                                onFinish: _this.onIntroScreenFinished,
                                                                onUnmount: _this.onIntroScreenUnmount,
                                                                preventSubmit: (tourForIS === null || tourForIS === void 0 ? void 0 : tourForIS.cookieIsMandatory) && !(0,CookieConsent/* allowUsesCookie */.q7)() && window.self === window.top,
                                                                preventSubmitCallback: function() {
                                                                    return _this.setState({
                                                                        showCookieFullScreen: true
                                                                    });
                                                                },
                                                                inputs: _this.isGameTour() && !(tourForIS === null || tourForIS === void 0 ? void 0 : tourForIS.collectLeads) ? {
                                                                    name: !!(game === null || game === void 0 ? void 0 : game.registration),
                                                                    email: false,
                                                                    phone: false
                                                                } : {
                                                                    name: tourForIS === null || tourForIS === void 0 ? void 0 : tourForIS.collectLeads,
                                                                    phone: (tourForIS === null || tourForIS === void 0 ? void 0 : tourForIS.collectLeads) && (tourForIS === null || tourForIS === void 0 ? void 0 : tourForIS.leadsPhone),
                                                                    email: (tourForIS === null || tourForIS === void 0 ? void 0 : tourForIS.collectLeads) && (tourForIS === null || tourForIS === void 0 ? void 0 : tourForIS.leadsEmail)
                                                                },
                                                                checkbox: _this.isGameTour() && !(tourForIS === null || tourForIS === void 0 ? void 0 : tourForIS.collectLeads) ? {
                                                                    legal1: "",
                                                                    legal2: ""
                                                                } : {
                                                                    legal1: (tourForIS === null || tourForIS === void 0 ? void 0 : tourForIS.collectLeads) ? (tourForIS === null || tourForIS === void 0 ? void 0 : tourForIS.legalBookingBox) || "" : "",
                                                                    legal2: (tourForIS === null || tourForIS === void 0 ? void 0 : tourForIS.collectLeads) ? (tourForIS === null || tourForIS === void 0 ? void 0 : tourForIS.legalBookingBox2) || "" : ""
                                                                }
                                                            }),
                                                            showIntro && (!(tour === null || tour === void 0 ? void 0 : tour.enableAvatar) || (tour === null || tour === void 0 ? void 0 : tour.enableAvatar) && avatar) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ClipScreen/* default */.Z, {
                                                                videoUrl: (game === null || game === void 0 ? void 0 : game.introClipUrl) || "".concat("https://cdn.treedis.com", "/tours/").concat(tour.id, "/game/").concat(game.id, "/").concat(game.uploadedIntroUrl).concat(util_all/* getVersion */.bo(game.updatedAt)) || 0,
                                                                close: function() {
                                                                    _this.onCloseIntro();
                                                                },
                                                                hideSkipBtn: game === null || game === void 0 ? void 0 : game.hideSkipBtn,
                                                                forcePlay: forcePlayGameIntro,
                                                                subtitles: (ref30 = _this.getCurrentLanguage()) === null || ref30 === void 0 ? void 0 : ref30.languageCode,
                                                                onStartEvent: function() {},
                                                                iframe: _this.iframe
                                                            }) : _this.renderGameContent(),
                                                            !_this.isGameTour() && (game === null || game === void 0 ? void 0 : game.book) && tourStarted && /*#__PURE__*/ (0,jsx_runtime.jsx)(GameBookHandle/* GameBookHandle */.V, {
                                                                isEcommerce: tourType === Tour/* TourType.ECommerce */.v.ECommerce,
                                                                gameBook: game.book,
                                                                onToggleGameBookModal: function() {
                                                                    return _this.setState(function(state) {
                                                                        return {
                                                                            showBook: !state.showBook
                                                                        };
                                                                    });
                                                                },
                                                                showBook: _this.state.showBook,
                                                                showBookBtn: (game === null || game === void 0 ? void 0 : game.gameBookOn) && (game === null || game === void 0 ? void 0 : game.book) && !_this.state.showBook,
                                                                closeGameBook: function() {
                                                                    return _this.setState({
                                                                        showBook: false
                                                                    });
                                                                },
                                                                unlockedChapterIds: _this.state.unlockedChapterIds,
                                                                tryButtonPlaySound: _this.tryButtonPlaySound,
                                                                moveToSweep: _this.moveToSweep,
                                                                tourType: tourType
                                                            })
                                                        ]
                                                    }),
                                                    !showIntro && iframeUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)(loadTourIframe_LoadTourIframe, {
                                                        iframeId: _this.state.iframeId,
                                                        mesurementsOn: measurementsOn,
                                                        iframeStyle: getIframeStyle({
                                                            tour: _this.state.tour,
                                                            activeSweepGroup: _this.state.activeSweepGroup,
                                                            sweepGroups: _this.state.sweepGroups
                                                        }),
                                                        cb: function(el) {
                                                            _this.iframe = el;
                                                            _this.hideIframeButtons();
                                                        },
                                                        iframeUrl: iframeUrl,
                                                        isFullScreen: isFullScreen
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                tour && !tour.hideCookie && /*#__PURE__*/ (0,jsx_runtime.jsx)(CookieConsent/* CustomCookieConsent */.Le, {
                                    tour: tour,
                                    loaded: showcaseLoaded,
                                    message: tour && (translation === null || translation === void 0 ? void 0 : translation.cookieConsentText),
                                    messageMandatoryTitle: tour && (translation === null || translation === void 0 ? void 0 : translation.cookieConsentTextMandatoryTitle),
                                    messageMandatoryDescription: tour && (translation === null || translation === void 0 ? void 0 : translation.cookieConsentTextMandatoryDescription),
                                    accept: tour && (translation === null || translation === void 0 ? void 0 : translation.cookieConsentAccept),
                                    acceptMandatory: tour && (translation === null || translation === void 0 ? void 0 : translation.cookieConsentAcceptMandatory),
                                    decline: tour && (translation === null || translation === void 0 ? void 0 : translation.cookieConsentDecline),
                                    declineMandatory: tour && (translation === null || translation === void 0 ? void 0 : translation.cookieConsentDeclineMandatory),
                                    showFullScreen: _this.state.showCookieFullScreen || tour.cookieIsMandatory && !startScreenOn,
                                    startScreenOn: startScreenOn,
                                    onAccept: function() {
                                        // If loadTourAfterCookie is true, it means that tour loading was paused until user accept the cookie, so on accept we need to load the tour
                                        if (tour.cookieIsMandatory && tour.loadTourAfterCookie) {
                                            _this.getTour({
                                                slug: _this.props.matterId,
                                                tourData: tourData,
                                                bypassCookieCheck: true,
                                                url: (0,getLocationUrl/* getLocationUrl */.v)()
                                            });
                                        }
                                    }
                                }),
                                tour && tour.navigationWebEnabled && tourType === Tour/* TourType.Regular */.v.Regular && !startScreenOn && !showIntro && /*#__PURE__*/ (0,jsx_runtime.jsx)(NavigationWrapper/* NavigationWrapper */.d, {
                                    showTeleportLoading: _this.state.showTeleportLoading,
                                    endTeleportName: _this.state.endTeleportName,
                                    endTpType: _this.state.endTpType,
                                    setShowTeleportLoading: function(val) {
                                        return _this.setState({
                                            showTeleportLoading: val
                                        });
                                    },
                                    appState: _this.state.appState,
                                    isBackgroundVisible: _this.state.isNavigationBackgroundVisible,
                                    setBackgroundVisible: function(val) {
                                        return _this.setState({
                                            isNavigationBackgroundVisible: val
                                        });
                                    },
                                    targetLocation: _this.state.navigationTarget,
                                    tour: tour,
                                    setDestination: _this.setNavigationDestination,
                                    moveToStartingPoint: _this.moveToNavigationStartingPoint,
                                    actionPathFinished: _this.state.actionPathFinished,
                                    tourType: tourType,
                                    setActionPathFinished: _this.setActionPathFinished,
                                    pathFinderLine: (ref31 = _this.showCaseTemp) === null || ref31 === void 0 ? void 0 : ref31.navigationManager,
                                    rtl: (ref32 = tour.client) === null || ref32 === void 0 ? void 0 : ref32.rtl,
                                    translation: _this.state.translation,
                                    setDescriptionEnabled: function(val) {
                                        return _this.setState({
                                            descriptionEnabled: val
                                        });
                                    },
                                    allSweeps: _this.state.allSweeps,
                                    currentSweep: _this.currentSweep,
                                    THREE: _this.THREE,
                                    setActionPathNavbarPlayButtonType: _this.setActionPathNavbarPlayButtonType,
                                    showcaseLoaded: showcaseLoaded,
                                    allTags: _this.state.allTags,
                                    teleportPoints: _this.teleportPoints,
                                    showActionPathBar: _this.state.showActionPathBar,
                                    resetNavigationByCloseButton: _this.resetNavigationByCloseButton,
                                    shouldNavReset: _this.state.shouldNavReset
                                }),
                                (flows === null || flows === void 0 ? void 0 : flows.length) > 0 && showcaseLoaded && tour && !showIntro && !startScreenOn && !tour.navigationWebEnabled && tourType === Tour/* TourType.Regular */.v.Regular && // this.state.appState === 'playing' &&
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(flows_FlowsContainer, {
                                    setFlowActive: function(flow) {
                                        return _this.setState({
                                            flowIsActive: flow,
                                            contactPopupOn: false,
                                            overlayOn: false
                                        });
                                    },
                                    moveToSweep: _this.moveToSweep,
                                    hideElements: _this.hideElements,
                                    showElements: _this.showElements,
                                    showCaseTemp: _this.showCaseTemp,
                                    showcase: _this.showcase,
                                    tags: Array.from(_this.state.allTags.values()),
                                    setFlowsObjects: function(data) {
                                        return _this.setState(data);
                                    },
                                    polygons: _this.state.polygons,
                                    vsObjects: _this.vsObjects,
                                    navigationManager: _this.showCaseTemp.navigationManager,
                                    sweeps: _this.state.sweeps,
                                    allSweeps: _this.state.allSweeps,
                                    currentFloor: _this.state.currentFloor,
                                    appState: _this.state.appState,
                                    flowsProps: flows,
                                    mainFlow: mainFlow,
                                    flowsVisibleAssets: _this.state.flowsVisibleAssets,
                                    tourCustomButton: tour === null || tour === void 0 ? void 0 : tour.customButton,
                                    tour: tour,
                                    flowsMenuMeshComponent: _this.flowsMenuMeshComponent,
                                    flowsBarMeshComponent: _this.flowsBarMeshComponent,
                                    vrEventManager: _this.vrEventManager,
                                    startFlowFromAsset: startFlowFromAsset,
                                    setSelectedFlowAsset: function(val) {
                                        return _this.setState({
                                            startFlowFromAsset: val
                                        });
                                    }
                                }),
                                showSketchfabPopup && /*#__PURE__*/ (0,jsx_runtime.jsx)(SketchfabPopup, {
                                    show: showSketchfabPopup,
                                    vsObjects: _this.vsObjects,
                                    onClose: _this.toggleSketchfabPopup(false)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_SetDataToRecoil, {
                                    translation: translation,
                                    tourConfigsInput: {
                                        rtl: tour === null || tour === void 0 ? void 0 : (ref33 = tour.client) === null || ref33 === void 0 ? void 0 : ref33.rtl,
                                        tourType: tourType
                                    }
                                }),
                                // Disabled on Georgia Pacific due to closing VR mode crashing tour during outro. Remove condition when fixed
                                !_this.getValueOnWindowLocationObject("href").includes("m=mEMx41aqAaq") && _this.renderCrashScreen(),
                                tour && (!tour.loadTourAfterCookie || tour.loadTourAfterCookie && hasAcceptedCookies) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                                            src: "https://www.googletagmanager.com/gtag/js?id=G-R2FVP1NTYY"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                                            dangerouslySetInnerHTML: {
                                                __html: "\n                    window.dataLayer = window.dataLayer || [];\n                    function gtag(){dataLayer.push(arguments);}\n                    gtag('js', new Date());\n\n                    gtag('config', 'G-R2FVP1NTYY');\n                  "
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                                            id: "google-leapis",
                                            strategy: "afterInteractive",
                                            type: "text/javascript",
                                            src: "https://maps.googleapis.com/maps/api/js?key=AIzaSyAxJYg1iR0WMy4vpFa3zB7E0Dx7lz8h5dk&libraries=places"
                                        })
                                    ]
                                })
                            ]
                        });
                    }
                }),
                confirmDialog.open && /*#__PURE__*/ (0,jsx_runtime.jsx)(ConfirmDialog, (0,_object_spread/* default */.Z)({}, confirmDialog))
            ]
        });
    };
    (0,_create_class/* default */.Z)(BaseTour, [
        {
            key: "isFreeUser",
            get: function get() {
                var ref, ref1, ref2, ref3;
                // If subscription is unknown/undefined yet, we shouldn't block any features
                if (![
                    User/* UserSubscription.Free */.MX.Free,
                    User/* UserSubscription.Growth */.MX.Growth,
                    User/* UserSubscription.Business */.MX.Business,
                    User/* UserSubscription.Enterprise */.MX.Enterprise
                ].includes((ref = this.state.tour) === null || ref === void 0 ? void 0 : (ref1 = ref.user) === null || ref1 === void 0 ? void 0 : ref1.subscription)) {
                    return false;
                }
                return ((ref2 = this.state.tour) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.user) === null || ref3 === void 0 ? void 0 : ref3.subscription) === User/* UserSubscription.Free */.MX.Free;
            }
        }
    ]);
    return BaseTour;
}(react.PureComponent);
BaseTour.whyDidYouRender = true;
BaseTour.contextType = useCookies/* CookieAcceptanceContext */.cg;



/***/ }),

/***/ 82107:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ game_ClipScreen; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(80562);
// EXTERNAL MODULE: ./node_modules/@treedis/tour-loader/dist/index.js + 149 modules
var dist = __webpack_require__(83625);
// EXTERNAL MODULE: ./node_modules/@vimeo/player/dist/player.es.js
var player_es = __webpack_require__(48333);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(18533);
// EXTERNAL MODULE: ./store/index.ts + 8 modules
var store = __webpack_require__(70989);
// EXTERNAL MODULE: ./components/util/deviceManager.ts
var deviceManager = __webpack_require__(99080);
;// CONCATENATED MODULE: ./components/tour/game/ClipScreen/types.ts
var PlayerType;
(function(PlayerType) {
    PlayerType[PlayerType["NOTSET"] = 0] = "NOTSET";
    PlayerType[PlayerType["NONE"] = 1] = "NONE";
    PlayerType[PlayerType["YOUTUBE"] = 2] = "YOUTUBE";
    PlayerType[PlayerType["VIMEO"] = 3] = "VIMEO";
    PlayerType[PlayerType["YOUKU"] = 4] = "YOUKU";
})(PlayerType || (PlayerType = {}));

;// CONCATENATED MODULE: ./components/tour/game/ClipScreen/data.ts

var getPlayerType = function(url) {
    if (url.includes("https://vimeo.com/")) {
        return PlayerType.VIMEO;
    }
    if (url.includes("https://www.youtube.com/") || url.includes("youtu.be")) {
        return PlayerType.YOUTUBE;
    }
    if (url.includes("youku.com")) {
        return PlayerType.YOUKU;
    }
    return PlayerType.NONE;
};
var getVimeoId = function(url) {
    var match = /vimeo.*\/(\d+)/i.exec(url);
    if (match) {
        return match[1];
    }
    return "";
};
var getYoutubeId = function(url) {
    var videoId = url.split("v=")[1] || url.split("youtu.be/")[1];
    var ampersandPosition = videoId.indexOf("&");
    if (ampersandPosition !== -1) {
        videoId = videoId.substring(0, ampersandPosition);
    }
    return videoId;
};
var getYoukuId = function(url) {
    var match = /id_(\w+)/i.exec(url);
    if (match) {
        return match[1];
    }
    return "";
};

;// CONCATENATED MODULE: ./components/tour/game/ClipScreen/index.tsx
/* eslint-disable @typescript-eslint/ban-ts-comment */ 
function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .cs-introWrap {\n    height: 100%;\n  }\n  #intro-clip-iframe {\n    background: black;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}











var PERCENT_AFTER_START_EVENT = 0.7;
var LoaderWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ClipScreen__LoaderWrap",
    componentId: "sc-d3ede5d-0"
})(_templateObject());
var MainWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ClipScreen__MainWrap",
    componentId: "sc-d3ede5d-1"
})(_templateObject1());
var ClipScreen = function(props) {
    var videoUrl = props.videoUrl, close = props.close, disableAutoplay = props.disableAutoplay, hideBtnGroup = props.hideBtnGroup, showControls = props.showControls, noMobile = props.noMobile, subtitles = props.subtitles, onStartEvent = props.onStartEvent, _autoClose = props.autoClose, autoClose = _autoClose === void 0 ? true : _autoClose, hideSkipBtn = props.hideSkipBtn;
    var ref = (0,react.useState)(true), loading = ref[0], setLoading = ref[1];
    var ref1 = (0,react.useState)(false), muted = ref1[0], setMuted = ref1[1];
    var ref2 = (0,react.useState)(PlayerType.NOTSET), type = ref2[0], setType = ref2[1];
    var translation = (0,store/* useRecoilValue */.sJ)(store/* translationDataState */.Jv);
    var player = (0,react.useRef)(null);
    var isEventStarted = (0,react.useRef)(false);
    var isMobile = deviceManager/* default.isMobile */.Z.isMobile();
    var ref3 = (0,react.useState)(false), showPlayBtn = ref3[0], setShowPlayBtn = ref3[1];
    var subtitlesCustomReplace = function(subCode) {
        // vimeo only
        // vimeo have different language codes (non iso) for some languages
        // for more check
        // https://vimeo.zendesk.com/hc/en-us/articles/224968828-Captions-and-subtitles#h_01FH9P8GQJ1ERMDZB2DRHJKAR0
        var subsToReplace = {
            he: "iw"
        };
        return subsToReplace[subCode] || subCode;
    };
    var loadVimeoVideo = (0,react.useCallback)(function() {
        var playerVars = {
            id: getVimeoId(videoUrl),
            autoplay: !disableAutoplay && !deviceManager/* default.isIOS */.Z.isIOS(),
            controls: !!showControls || deviceManager/* default.isIOS */.Z.isIOS(),
            dnt: true
        };
        if (subtitles) playerVars.texttrack = subtitlesCustomReplace(subtitles);
        var introClipBlock = document.querySelector("#intro-clip-iframe");
        player.current = new player_es/* default */.Z(introClipBlock, playerVars);
        player.current.on("timeupdate", function(data) {
            if (onStartEvent && data.percent >= PERCENT_AFTER_START_EVENT && !isEventStarted.current) {
                onStartEvent();
                isEventStarted.current = true;
            }
        });
        player.current.on("loaded", function() {
            setLoading(false);
            if (disableAutoplay) return;
            player.current.play().catch(function() {
            // nothing
            });
        });
        if (close) player.current.on("ended", function() {
            return autoClose && close();
        });
    }, [
        videoUrl,
        disableAutoplay,
        showControls,
        subtitles,
        close,
        onStartEvent,
        autoClose
    ]);
    var loadYKUVideo = (0,react.useCallback)(function() {
        var container = window.document.getElementById("intro-clip-iframe");
        var iframe = document.createElement("iframe");
        iframe.setAttribute("src", "https://player.youku.com/embed/".concat(getYoukuId(videoUrl), "?autoplay=1&controls=0&rel=0&showinfo=0"));
        iframe.style.width = "100%";
        iframe.style.height = "100%";
        setTimeout(function() {
            return setLoading(false);
        }, 2000);
        container.appendChild(iframe);
    }, [
        videoUrl
    ]);
    var loadYTVideo = (0,react.useCallback)(function() {
        // @ts-ignore
        var playerVars = {
            autoplay: disableAutoplay ? 0 : 1,
            controls: showControls ? 1 : 0,
            rel: 0,
            showinfo: 0,
            disablekb: 1,
            fs: 0,
            modestbranding: 1
        };
        if (subtitles) playerVars.hl = subtitles;
        // @ts-ignore
        player.current = new window.YT.Player("intro-clip-iframe", {
            videoId: getYoutubeId(videoUrl),
            playerVars: playerVars,
            events: {
                onStateChange: function(event) {
                    // @ts-ignore
                    if (event.data === window.YT.PlayerState.ENDED && close) {
                        if (autoClose) close();
                    }
                },
                onReady: function(event) {
                    setLoading(false);
                    if (disableAutoplay) return;
                    event.target.playVideo();
                }
            }
        });
    }, [
        disableAutoplay,
        showControls,
        subtitles,
        videoUrl,
        close,
        autoClose
    ]);
    var loadNativeVideo = (0,react.useCallback)(function() {
        if (videoUrl) {
            var videoElement = document.createElement("video");
            // create source element with type mp4
            var sourceElement = document.createElement("source");
            sourceElement.type = "video/mp4";
            sourceElement.src = videoUrl;
            videoElement.appendChild(sourceElement);
            videoElement.controls = false;
            videoElement.autoplay = !disableAutoplay;
            videoElement.style.width = "100%";
            videoElement.style.height = "100%";
            videoElement.setAttribute("playsinline", "");
            videoElement.setAttribute("webkit-playsinline", "");
            var autoplaySuccessful = false;
            videoElement.addEventListener("play", function() {
                autoplaySuccessful = true;
            });
            videoElement.addEventListener("canplaythrough", function() {
                setLoading(false);
                if (!autoplaySuccessful) {
                    setShowPlayBtn(true);
                }
            });
            videoElement.addEventListener("ended", function() {
                if (autoClose) {
                    close();
                }
            });
            videoElement.addEventListener("click", function() {
                videoElement.play();
                setShowPlayBtn(false);
            });
            player.current = videoElement;
            document.getElementById("intro-clip-iframe").appendChild(videoElement);
        }
    }, [
        autoClose,
        close,
        disableAutoplay,
        videoUrl
    ]);
    (0,react.useEffect)(function() {
        // should load video once
        if (!videoUrl || type !== PlayerType.NOTSET) return;
        var newType = getPlayerType(videoUrl);
        switch(newType){
            case PlayerType.VIMEO:
                loadVimeoVideo();
                break;
            case PlayerType.YOUTUBE:
                // @ts-ignore
                if (!window.YT) {
                    var tag = document.createElement("script");
                    tag.src = "https://www.youtube.com/iframe_api";
                    // @ts-ignore
                    window.onYouTubeIframeAPIReady = loadYTVideo;
                    var firstScriptTag = document.getElementsByTagName("script")[0];
                    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
                } else {
                    loadYTVideo();
                }
                break;
            case PlayerType.YOUKU:
                loadYKUVideo();
                break;
            default:
                loadNativeVideo();
                break;
        }
        setType(newType);
    }, [
        loadNativeVideo,
        loadVimeoVideo,
        loadYKUVideo,
        loadYTVideo,
        type,
        videoUrl
    ]);
    var mute = (0,react.useCallback)(function() {
        if (!player.current) return;
        switch(type){
            case PlayerType.VIMEO:
                player.current.setMuted(true);
                break;
            case PlayerType.YOUTUBE:
                player.current.mute();
                break;
            default:
                player.current.muted = true;
                break;
        }
        setMuted(true);
    }, [
        type
    ]);
    var unMute = (0,react.useCallback)(function() {
        if (!player.current) return;
        switch(type){
            case PlayerType.VIMEO:
                player.current.setMuted(false);
                break;
            case PlayerType.YOUTUBE:
                player.current.unMute();
                break;
            default:
                player.current.muted = false;
                break;
        }
        setMuted(false);
    }, [
        type
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MainWrap, {
        id: "intro",
        className: classnames_default()("intro", deviceManager/* default.isMobile */.Z.isMobile() && "mobile"),
        children: [
            loading && /*#__PURE__*/ (0,jsx_runtime.jsx)(LoaderWrap, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Loader */.aN, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    display: loading ? "none" : "initial"
                },
                className: "cs-introWrap",
                children: [
                    !hideBtnGroup && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "intro-btn-group",
                        children: [
                            type !== PlayerType.YOUKU && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: "intro-button",
                                onClick: muted ? unMute : mute,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                    className: "fas ".concat(muted ? "fa-volume-slash" : "fa-volume")
                                })
                            }),
                            !hideSkipBtn && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: "intro-button",
                                onClick: close || function() {
                                    return null;
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                    children: (translation === null || translation === void 0 ? void 0 : translation.skip) || "Skip"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        id: "intro-clip-iframe",
                        className: classnames_default()(!noMobile && isMobile && "mobile")
                    })
                ]
            }),
            showPlayBtn && /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                sx: {
                    position: "fixed",
                    top: "45%",
                    left: "50%",
                    zIndex: 5,
                    color: "rgba(0,0,0,0.8)",
                    transform: "translateX(-50%)",
                    "&>i": {
                        fontSize: "7vw !important"
                    }
                },
                onClick: function() {
                    var ref;
                    (ref = player.current) === null || ref === void 0 ? void 0 : ref.play();
                    setShowPlayBtn(false);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                    className: "fa-solid fa-circle-play"
                })
            })
        ]
    });
};
function areEqual(prevProps, nextProps) {
    return prevProps.videoUrl !== nextProps.videoUrl;
}
/* harmony default export */ var game_ClipScreen = (/*#__PURE__*/(0,react.memo)(ClipScreen, areEqual));


/***/ }),

/***/ 66183:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Ad": function() { return /* reexport */ styled_BackgroundFilter; },
  "zx": function() { return /* reexport */ styled_Button; },
  "hE": function() { return /* reexport */ styled_ButtonGroup; },
  "iz": function() { return /* reexport */ styled_Divider; },
  "JO": function() { return /* reexport */ styled_Icon; },
  "Hb": function() { return /* reexport */ styled_IconAndText; },
  "x4": function() { return /* reexport */ styled_Result; },
  "fC": function() { return /* reexport */ styled_Root; },
  "$0": function() { return /* reexport */ styled_ScoreTitle; },
  "iA": function() { return /* reexport */ styled_Table; },
  "Dx": function() { return /* reexport */ styled_Title; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(18533);
;// CONCATENATED MODULE: ./components/tour/game/FinishScreen/styled/Root/style.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: white;\n  font-size: 16px;\n  font-family: Roboto;\n  text-align: center;\n  position: fixed;\n  z-index: 9999;\n  width: 100%;\n  background-color: #333;\n\n  ",
        "}\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var RootStyled = styled_components_browser_esm/* default.div.attrs */.ZP.div.attrs(function() {
    return {
        className: "game-endgame-screen"
    };
}).withConfig({
    displayName: "style__RootStyled",
    componentId: "sc-4cffba9-0"
})(_templateObject(), function(param) {
    var backgroundImage = param.backgroundImage;
    return backgroundImage && "\n    background: url(".concat(backgroundImage, ") center center/cover no-repeat fixed black;\n    height: 100vh !important;\n    overflow: auto;\n  ");
});

;// CONCATENATED MODULE: ./components/tour/game/FinishScreen/styled/Root/index.tsx





var Root = function(_param) /*#__PURE__*/ {
    var children = _param.children, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return (0,jsx_runtime.jsx)(RootStyled, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, restProps), {
        children: children
    }));
};
/* harmony default export */ var styled_Root = (Root);

;// CONCATENATED MODULE: ./components/tour/game/FinishScreen/styled/Title/style.tsx

function style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 2em;\n  text-align: center;\n  padding: 1em 0;\n"
    ]);
    style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var TitleStyled = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__TitleStyled",
    componentId: "sc-90112200-0"
})(style_templateObject());

;// CONCATENATED MODULE: ./components/tour/game/FinishScreen/styled/Title/index.tsx





var Title = function(_param) /*#__PURE__*/ {
    var children = _param.children, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return (0,jsx_runtime.jsx)(TitleStyled, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, restProps), {
        children: children
    }));
};
/* harmony default export */ var styled_Title = (Title);

;// CONCATENATED MODULE: ./components/tour/game/FinishScreen/styled/Icon/style.tsx

function Icon_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fill: white;\n  width: 9em;\n"
    ]);
    Icon_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var IconStyled = styled_components_browser_esm/* default.img.attrs */.ZP.img.attrs(function(props) {
    return {
        src: props.src || "/experience/winner.svg"
    };
}).withConfig({
    displayName: "style__IconStyled",
    componentId: "sc-94e9bb99-0"
})(Icon_style_templateObject());

;// CONCATENATED MODULE: ./components/tour/game/FinishScreen/styled/Icon/index.tsx





var Icon = function(_param) /*#__PURE__*/ {
    var children = _param.children, finishScreenImage = _param.finishScreenImage, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "finishScreenImage"
    ]);
    return (0,jsx_runtime.jsx)(IconStyled, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        src: finishScreenImage
    }, restProps), {
        children: children
    }));
};
/* harmony default export */ var styled_Icon = (Icon);

;// CONCATENATED MODULE: ./components/tour/game/FinishScreen/styled/Result/style.tsx

function Result_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 1em;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 1em;\n\n  & > div {\n    margin-right: 0.4em;\n  }\n"
    ]);
    Result_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var ResultStyled = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__ResultStyled",
    componentId: "sc-2f58580c-0"
})(Result_style_templateObject());

;// CONCATENATED MODULE: ./components/tour/game/FinishScreen/styled/Result/index.tsx





var Result = function(_param) /*#__PURE__*/ {
    var children = _param.children, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return (0,jsx_runtime.jsx)(ResultStyled, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, restProps), {
        children: children
    }));
};
/* harmony default export */ var styled_Result = (Result);

;// CONCATENATED MODULE: ./components/tour/game/FinishScreen/styled/ButtonGroup/style.tsx

function ButtonGroup_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 1em;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n\n  & > button {\n    margin-right: 0.4em;\n  }\n"
    ]);
    ButtonGroup_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var ButtonGroupStyled = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__ButtonGroupStyled",
    componentId: "sc-d796d490-0"
})(ButtonGroup_style_templateObject());

;// CONCATENATED MODULE: ./components/tour/game/FinishScreen/styled/ButtonGroup/index.tsx





var ButtonGroup = function(_param) {
    var show = _param.show, children = _param.children, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "show",
        "children"
    ]);
    return show && /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonGroupStyled, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, restProps), {
        children: children
    }));
};
/* harmony default export */ var styled_ButtonGroup = (ButtonGroup);

;// CONCATENATED MODULE: ./components/tour/game/FinishScreen/styled/Button/style.tsx

function Button_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  padding: 4px 10px;\n  min-height: 30px;\n  background: rgba(107, 107, 107, 0.01);\n  border: 1px solid #ffffff;\n  border-radius: 4px;\n  color: white;\n\n  & > i {\n    margin-right: 0.2em;\n  }\n\n  &:hover {\n    opacity: 0.7;\n  }\n"
    ]);
    Button_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var ButtonStyled = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    displayName: "style__ButtonStyled",
    componentId: "sc-e4813169-0"
})(Button_style_templateObject());

;// CONCATENATED MODULE: ./components/tour/game/FinishScreen/styled/Button/index.tsx





var Button = function(_param) {
    var show = _param.show, children = _param.children, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "show",
        "children"
    ]);
    if (!show) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonStyled, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, restProps), {
        children: children
    }));
};
/* harmony default export */ var styled_Button = (Button);

;// CONCATENATED MODULE: ./components/tour/game/FinishScreen/styled/Divider/style.tsx

function Divider_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  opacity: 0.5;\n  border: 1px solid #EBEBEB;\n  border-radius: 3px;\n"
    ]);
    Divider_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var DividerStyled = styled_components_browser_esm/* default.hr.withConfig */.ZP.hr.withConfig({
    displayName: "style__DividerStyled",
    componentId: "sc-c7ed6026-0"
})(Divider_style_templateObject());

;// CONCATENATED MODULE: ./components/tour/game/FinishScreen/styled/Divider/index.tsx





var Divider = function(_param) /*#__PURE__*/ {
    var children = _param.children, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return (0,jsx_runtime.jsx)(DividerStyled, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, restProps), {
        children: children
    }));
};
/* harmony default export */ var styled_Divider = (Divider);

;// CONCATENATED MODULE: ./components/tour/game/FinishScreen/styled/Table/style.tsx

function Table_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  margin: auto;\n\n  td,\n  tr {\n    padding: 0.5em 1em;\n  }\n"
    ]);
    Table_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var TableStyled = styled_components_browser_esm/* default.table.withConfig */.ZP.table.withConfig({
    displayName: "style__TableStyled",
    componentId: "sc-98ec64af-0"
})(Table_style_templateObject());

;// CONCATENATED MODULE: ./components/tour/game/FinishScreen/styled/Table/index.tsx





var Table = function(_param) /*#__PURE__*/ {
    var children = _param.children, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return (0,jsx_runtime.jsx)(TableStyled, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, restProps), {
        children: children
    }));
};
/* harmony default export */ var styled_Table = (Table);

;// CONCATENATED MODULE: ./components/tour/game/FinishScreen/styled/ScoreTitle/style.tsx

function ScoreTitle_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 1.5em;\n  text-align: center;\n  padding-bottom: 1em;\n"
    ]);
    ScoreTitle_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var ScoreTitleStyled = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__ScoreTitleStyled",
    componentId: "sc-a5c622f5-0"
})(ScoreTitle_style_templateObject());

;// CONCATENATED MODULE: ./components/tour/game/FinishScreen/styled/ScoreTitle/index.tsx





var ScoreTitle = function(_param) /*#__PURE__*/ {
    var children = _param.children, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return (0,jsx_runtime.jsx)(ScoreTitleStyled, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, restProps), {
        children: children
    }));
};
/* harmony default export */ var styled_ScoreTitle = (ScoreTitle);

;// CONCATENATED MODULE: ./components/tour/game/FinishScreen/styled/BackgroundFilter/style.tsx

function BackgroundFilter_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  backdrop-filter: blur(10px);\n  background: rgba(0, 0, 0, 0.5);\n  width: 100%;\n  height: 100%;\n  max-width: initial;\n  max-height: initial;\n  color: white;\n  display: flex;\n  overflow-y: auto !important;\n  & > div {\n    ",
        "\n  }\n"
    ]);
    BackgroundFilter_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var BgFilterStyled = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__BgFilterStyled",
    componentId: "sc-29cf44ca-0"
})(BackgroundFilter_style_templateObject(), function(param) {
    var rtl = param.rtl;
    return rtl ? "direction:rtl;" : "";
});

;// CONCATENATED MODULE: ./components/tour/game/FinishScreen/styled/BackgroundFilter/index.tsx





var BackgroundFilter = function(_param) /*#__PURE__*/ {
    var children = _param.children, rtl = _param.rtl, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "rtl"
    ]);
    return (0,jsx_runtime.jsx)(BgFilterStyled, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        rtl: rtl
    }, restProps), {
        children: children
    }));
};
/* harmony default export */ var styled_BackgroundFilter = (BackgroundFilter);

;// CONCATENATED MODULE: ./components/tour/game/FinishScreen/styled/IconAndText/styled.tsx

function styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 1em;\n  height: 1em;\n  margin-right: 0.5em;\n"
    ]);
    styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 1em;\n  text-align: center;\n  line-height: normal;\n  letter-spacing: 0.1px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

var Image = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    displayName: "styled__Image",
    componentId: "sc-d5108a00-0"
})(styled_templateObject());
var Text = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    displayName: "styled__Text",
    componentId: "sc-d5108a00-1"
})(_templateObject1());
var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styled__Container",
    componentId: "sc-d5108a00-2"
})(_templateObject2());


;// CONCATENATED MODULE: ./components/tour/game/FinishScreen/styled/IconAndText/index.tsx


var IconAndText = function(param) {
    var src = param.src, text = param.text, show = param.show;
    if (!show) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                src: src
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                children: text
            })
        ]
    });
};
/* harmony default export */ var styled_IconAndText = (IconAndText);

;// CONCATENATED MODULE: ./components/tour/game/FinishScreen/styled/index.ts













/***/ }),

/***/ 25406:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "V": function() { return /* binding */ GameBookHandle; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/lodash/sortBy.js
var sortBy = __webpack_require__(89734);
var sortBy_default = /*#__PURE__*/__webpack_require__.n(sortBy);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/recoil/es/recoil.js
var recoil = __webpack_require__(2804);
// EXTERNAL MODULE: ./components/tour/game/gameBook/types.ts
var types = __webpack_require__(81389);
// EXTERNAL MODULE: ./store/index.ts + 8 modules
var store = __webpack_require__(70989);
// EXTERNAL MODULE: ./units/Icon/index.ts + 53 modules
var Icon = __webpack_require__(95829);
// EXTERNAL MODULE: ./units/Iframe/style.tsx
var style = __webpack_require__(54811);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(18533);
// EXTERNAL MODULE: ./components/util/index.ts + 7 modules
var util = __webpack_require__(97666);
;// CONCATENATED MODULE: ./components/tour/game/gameBook/styled/Root/style.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100vw;\n  height: 100vh;\n  background: rgba(0, 0, 0, 0.65);\n  z-index: 120;\n  position: absolute;\n  top: 0;\n  display: flex;\n  flex-direction: column;\n  color: white;\n  font-size: 16px;\n  font-family: Roboto;\n\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var RootStyled = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__RootStyled",
    componentId: "sc-4278e250-0"
})(_templateObject(), function(param) {
    var background = param.background, opacity = param.opacity, color = param.color, theme = param.theme;
    var styles = "";
    if (background && opacity) {
        var ref = (0,util/* hexToRgb */.oo)(background), r = ref.r, g = ref.g, b = ref.b;
        styles += "background-color: rgba(".concat(r, ",").concat(g, ",").concat(b, ", ").concat(opacity, ");");
    }
    if (color) {
        styles += "color: ".concat(color, ";");
    }
    if (theme.device.mobile) {
        styles += "";
    }
    return styles;
});

;// CONCATENATED MODULE: ./components/tour/game/gameBook/styled/Root/index.tsx





var Root = function(_param) /*#__PURE__*/ {
    var children = _param.children, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return (0,jsx_runtime.jsx)(RootStyled, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, restProps), {
        children: children
    }));
};
/* harmony default export */ var styled_Root = (Root);

;// CONCATENATED MODULE: ./components/tour/game/gameBook/styled/Header/style.tsx

function style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 1em 2em;\n  /* Frosted background */\n  backdrop-filter: blur(80px);\n  -webkit-backdrop-filter: blur(80px);\n\n  h2 {\n    font-size: 2em;\n    font-weight: 500;\n    line-height: 0.8em;\n    letter-spacing: 0;\n    text-align: left;\n  }\n\n  .close-modal {\n    position: absolute;\n    right: 35px;\n    cursor: pointer;\n\n    &:hover {\n      opacity: 0.7;\n    }\n  }\n\n  ",
        "\n"
    ]);
    style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var HeaderStyled = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__HeaderStyled",
    componentId: "sc-d339e66e-0"
})(style_templateObject(), function(param) {
    var theme = param.theme;
    return theme.device.mobile && "\n  ";
});

;// CONCATENATED MODULE: ./components/tour/game/gameBook/styled/Header/index.tsx





var Header = function(_param) /*#__PURE__*/ {
    var children = _param.children, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return (0,jsx_runtime.jsx)(HeaderStyled, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, restProps), {
        children: children
    }));
};
/* harmony default export */ var styled_Header = (Header);

;// CONCATENATED MODULE: ./components/tour/game/gameBook/styled/List/style.tsx

function List_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-height: 80vh;\n  overflow-y: auto;\n  font-size: 1em;\n  width: 200px;\n\n  .chapter {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    font-size: 1em;\n    width: 100%;\n    color: #fff;\n    position: relative;\n    cursor: pointer;\n    padding: 0.5em 1.25em;\n    overflow-wrap: anywhere;\n\n    &.active {\n      background-color: #2055ff;\n      ",
        "\n    }\n\n    &:hover {\n      background-color: #2055ff;\n      ",
        "\n      opacity: 0.7;\n    }\n\n    &.locked {\n      cursor: none;\n      pointer-events: none;\n      opacity: 0.7;\n    }\n\n    ",
        "\n  }\n\n  ",
        "\n"
    ]);
    List_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var ListStyled = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    displayName: "style__ListStyled",
    componentId: "sc-27471df0-0"
})(List_style_templateObject(), function(param) {
    var buttonColor = param.buttonColor;
    return buttonColor && "background-color: ".concat(buttonColor, ";");
}, function(param) {
    var buttonColor = param.buttonColor;
    return buttonColor && "background-color: ".concat(buttonColor, ";");
}, function(param) {
    var color = param.color;
    return color && "color: ".concat(color, ";");
}, function(param) {
    var theme = param.theme;
    return theme.device.mobile && "\n  ";
});

;// CONCATENATED MODULE: ./components/tour/game/gameBook/styled/List/index.tsx





var List = function(_param) /*#__PURE__*/ {
    var children = _param.children, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return (0,jsx_runtime.jsx)(ListStyled, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, restProps), {
        children: children
    }));
};
/* harmony default export */ var styled_List = (List);

;// CONCATENATED MODULE: ./components/tour/game/gameBook/styled/Content/style.tsx

function Content_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: start;\n  padding: 3em 10em;\n\n  ",
        "\n"
    ]);
    Content_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var ContentStyled = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__ContentStyled",
    componentId: "sc-3a0c8cfe-0"
})(Content_style_templateObject(), function(param) {
    var theme = param.theme;
    return theme.device.mobile && "\n      padding: 1em 6em;\n  ";
});

;// CONCATENATED MODULE: ./components/tour/game/gameBook/styled/Content/index.tsx





var Content = function(_param) /*#__PURE__*/ {
    var children = _param.children, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return (0,jsx_runtime.jsx)(ContentStyled, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, restProps), {
        children: children
    }));
};
/* harmony default export */ var styled_Content = (Content);

;// CONCATENATED MODULE: ./components/tour/game/gameBook/styled/Main/style.tsx

function Main_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  img {\n    max-height: 70vh;\n    width: 100%;\n  }\n\n  p {\n    max-height: 70vh;\n    width: 30vw;\n    min-height: 50vh;\n    word-wrap: break-word;\n    overflow-y: auto;\n  }\n\n  ",
        "\n"
    ]);
    Main_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var MainStyled = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__MainStyled",
    componentId: "sc-9195c60f-0"
})(Main_style_templateObject(), function(param) {
    var theme = param.theme;
    return theme.device.mobile && "\n    p {\n      width: 50vw;\n    }\n  ";
});

;// CONCATENATED MODULE: ./components/tour/game/gameBook/styled/Main/index.tsx





var Main = function(_param) /*#__PURE__*/ {
    var children = _param.children, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return (0,jsx_runtime.jsx)(MainStyled, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, restProps), {
        children: children
    }));
};
/* harmony default export */ var styled_Main = (Main);

;// CONCATENATED MODULE: ./components/tour/game/gameBook/styled/Footer/style.tsx

function Footer_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: flex-end;\n\n  button {\n    font-size: 1em;\n    background-color: #2055ff;\n    padding: 0.4em 1em;\n    color: white;\n\n    &:hover {\n      opacity: 0.7;\n    }\n\n    ",
        "\n  }\n\n  ",
        "\n"
    ]);
    Footer_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var FooterStyled = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__FooterStyled",
    componentId: "sc-d65b2058-0"
})(Footer_style_templateObject(), function(param) {
    var buttonColor = param.buttonColor, color = param.color;
    return buttonColor && color && "\n      background-color: ".concat(buttonColor, ";\n      color: ").concat(color, "\n    ");
}, function(param) {
    var theme = param.theme;
    return theme.device.mobile && "\n  ";
});

;// CONCATENATED MODULE: ./components/tour/game/gameBook/styled/Footer/index.tsx





var Footer = function(_param) {
    var show = _param.show, children = _param.children, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "show",
        "children"
    ]);
    return show && /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterStyled, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, restProps), {
        children: children
    }));
};
/* harmony default export */ var styled_Footer = (Footer);

;// CONCATENATED MODULE: ./components/tour/game/gameBook/styled/index.ts







// EXTERNAL MODULE: ./components/util/deviceManager.ts
var deviceManager = __webpack_require__(99080);
;// CONCATENATED MODULE: ./components/tour/game/BannerHorizontalViewOnly/styled/Root/style.tsx

function Root_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100vw;\n  height: 100vh;\n  height: 100%;\n  background: rgba(0, 0, 0, 1);\n  z-index: 1200;\n  position: absolute;\n  top: 0;\n  font-family: WorkSans;\n\n  display: flex;\n  flex-direction: column;\n  justify-content: start;\n\n  .game-book-no-content {\n    padding: 70px 60px 30px 60px;\n    font-family: WorkSans;\n    font-size: 28px;\n    font-weight: 600;\n    font-stretch: normal;\n    font-style: normal;\n    line-height: 1.36;\n    letter-spacing: -0.56px;\n    text-align: center;\n    color: var(--white);\n  }\n"
    ]);
    Root_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var style_RootStyled = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__RootStyled",
    componentId: "sc-7d6a60d3-0"
})(Root_style_templateObject());

;// CONCATENATED MODULE: ./components/tour/game/BannerHorizontalViewOnly/styled/Root/index.tsx





var Root_Root = function(_param) /*#__PURE__*/ {
    var children = _param.children, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return (0,jsx_runtime.jsx)(style_RootStyled, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, restProps), {
        children: children
    }));
};
/* harmony default export */ var BannerHorizontalViewOnly_styled_Root = (Root_Root);

;// CONCATENATED MODULE: ./components/tour/game/BannerHorizontalViewOnly/styled/Header/style.tsx

function Header_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .close-modal {\n    right: 10px;\n    position: absolute;\n    color: white;\n  }\n"
    ]);
    Header_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var style_HeaderStyled = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__HeaderStyled",
    componentId: "sc-881094ed-0"
})(Header_style_templateObject());

;// CONCATENATED MODULE: ./components/tour/game/BannerHorizontalViewOnly/styled/Header/index.tsx





var Header_Header = function(_param) /*#__PURE__*/ {
    var children = _param.children, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return (0,jsx_runtime.jsx)(style_HeaderStyled, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, restProps), {
        children: children
    }));
};
/* harmony default export */ var BannerHorizontalViewOnly_styled_Header = (Header_Header);

;// CONCATENATED MODULE: ./components/tour/game/BannerHorizontalViewOnly/styled/index.ts



;// CONCATENATED MODULE: ./components/tour/game/BannerHorizontalViewOnly/BannerHorizontalViewOnly.tsx






var BannerHorizontalViewOnly = function(param) {
    var show = param.show, onClose = param.onClose;
    var translation = (0,recoil/* useRecoilValue */.sJ)(store/* translationDataState */.Jv);
    if (!show) return null;
    var isMobile = deviceManager/* default.isMobile */.Z.isMobile();
    var isHorMob = deviceManager/* default.isHorizontalMobileView */.Z.isHorizontalMobileView();
    if (isMobile && !isHorMob) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BannerHorizontalViewOnly_styled_Root, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerHorizontalViewOnly_styled_Header, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default.Close */.Z.Close, {
                        className: "close-modal",
                        onClick: onClose,
                        fontSize: "large"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "game-book-no-content",
                    children: (translation === null || translation === void 0 ? void 0 : translation.expGbNoContent) || "Available only for horizontal view"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    className: "game-book-gif",
                    src: "/experience/mobile.gif",
                    alt: "Screen orientation"
                })
            ]
        });
    }
    return null;
};

// EXTERNAL MODULE: ./_helpers/base.tsx
var base = __webpack_require__(41154);
// EXTERNAL MODULE: ./node_modules/@mui/base/ClickAwayListener/ClickAwayListener.js
var ClickAwayListener = __webpack_require__(23926);
// EXTERNAL MODULE: ./_models/Tour.tsx + 1 modules
var Tour = __webpack_require__(40784);
// EXTERNAL MODULE: ./_helpers/renderDebug.ts
var renderDebug = __webpack_require__(66725);
;// CONCATENATED MODULE: ./components/tour/game/gameBook/index.tsx


















var GameBook = function(param) {
    var onClose = param.onClose, book = param.book, unlockedChapterIds = param.unlockedChapterIds, tryButtonPlaySound = param.tryButtonPlaySound, show = param.show, moveToSweep = param.moveToSweep, tourType = param.tourType;
    var backgroundColor = book.backgroundColor, backgroundOpacity = book.backgroundOpacity, textColor = book.textColor, buttonColor = book.buttonColor, chapterLocked = book.chapterLocked;
    if (!show) return null;
    var ref = (0,react.useState)(), activePage = ref[0], setActivePage = ref[1];
    var ref1 = (0,react.useState)([]), pages = ref1[0], setPages = ref1[1];
    var translation = (0,recoil/* useRecoilValue */.sJ)(store/* translationDataState */.Jv);
    (0,react.useEffect)(function() {
        var ref;
        if ((book === null || book === void 0 ? void 0 : (ref = book.chapters) === null || ref === void 0 ? void 0 : ref.length) > 0) {
            var data = sortBy_default()(book.chapters, "order").reduce(function(acc, chapter) {
                acc.push({
                    id: chapter.id,
                    title: chapter.title,
                    description: chapter.description,
                    url: chapter.img ? "".concat("https://cdn.treedis.com", "/games/").concat(book.gameId, "/book/").concat(book.id, "/chapter/").concat(chapter.id, "/").concat(chapter.img) : undefined,
                    moveToSweepUuid: chapter.sweepUuid,
                    locationType: chapter === null || chapter === void 0 ? void 0 : chapter.locationType,
                    locationTourLink: chapter === null || chapter === void 0 ? void 0 : chapter.locationTourLink
                });
                return acc;
            }, [
                {
                    id: 0,
                    title: (translation === null || translation === void 0 ? void 0 : translation.experienceCover) || "Cover",
                    description: book.description,
                    url: book.img ? "".concat("https://cdn.treedis.com", "/games/").concat(book.gameId, "/book/").concat(book.id, "/").concat(book.img) : undefined,
                    moveToSweepUuid: undefined,
                    locationType: undefined,
                    locationTourLink: undefined
                }, 
            ]);
            setPages(data);
            setActivePage(data[0]);
        }
    }, [
        book
    ]);
    (0,react.useEffect)(function() {
        handleMoveToSweep(true);
    }, [
        activePage
    ]);
    var isPageLocked = function(chapterId) {
        if (chapterId === 0 || !chapterLocked) return false;
        return !unlockedChapterIds.includes(chapterId);
    };
    var changePage = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(page) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!!isPageLocked(page.id)) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            tryButtonPlaySound()
                        ];
                    case 1:
                        _state.sent();
                        setActivePage(page);
                        _state.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        });
        return function changePage(page) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleMoveToSweep = function() {
        var first = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        try {
            if (activePage && (first && !activePage.url || !first)) {
                if (activePage.locationType === types/* GameBookLocationType.sweep */.d.sweep && activePage.moveToSweepUuid) {
                    moveToSweep(activePage.moveToSweepUuid);
                } else if (activePage.locationType === types/* GameBookLocationType.tourLink */.d.tourLink && activePage.locationTourLink) {
                    var parsedLink = (0,base/* parseTourLink */.Qs)(activePage.locationTourLink);
                    if (parsedLink) {
                        moveToSweep(parsedLink.s, {
                            x: parsedLink.x,
                            y: parsedLink.y
                        });
                    }
                } else if (activePage.id !== 0) {
                    onClose();
                }
            }
        } catch (err) {
            console.error("gameBook handleMoveToSweep error");
        }
    };
    //timeout will prevent reopen configs closed by sidebar configs icon
    var handleClickAway = function(ev) {
        if (tourType === Tour/* TourType.ECommerce */.v.ECommerce) {
            window.setTimeout(function() {
                onClose();
            }, 100);
        }
    };
    (0,renderDebug/* dLog */.a)("GameBook");
    //disable for mobile
    if (deviceManager/* default.isMobile */.Z.isMobile()) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerHorizontalViewOnly, {
                onClose: onClose,
                show: show
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ClickAwayListener/* default */.Z, {
                mouseEvent: "onMouseUp",
                onClickAway: handleClickAway,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "handleClickAwayNotWorksWithoutThisWrap",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled_Root, {
                        background: backgroundColor,
                        opacity: backgroundOpacity,
                        color: textColor,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled_Header, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        children: (book === null || book === void 0 ? void 0 : book.description) || (translation === null || translation === void 0 ? void 0 : translation.expJournBook) || "Journey book"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default.Close */.Z.Close, {
                                        className: "close-modal",
                                        onClick: onClose,
                                        fontSize: "large"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled_Content, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled_Main, {
                                        children: [
                                            activePage ? activePage.url ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                className: "book",
                                                src: activePage.url,
                                                alt: ""
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "page-description",
                                                children: activePage.description
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(style/* Loader */.aN, {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_Footer, {
                                                show: !!(activePage === null || activePage === void 0 ? void 0 : activePage.moveToSweepUuid),
                                                buttonColor: buttonColor,
                                                color: textColor,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                    onClick: function() {
                                                        return handleMoveToSweep();
                                                    },
                                                    children: [
                                                        (translation === null || translation === void 0 ? void 0 : translation.experienceTeleport) || "Take me there",
                                                        " ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default.ArrowRight */.Z.ArrowRight, {
                                                            fontSize: "inherit"
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_List, {
                                        color: textColor,
                                        buttonColor: buttonColor,
                                        children: (pages || []).map(function(page) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                className: classnames_default()("chapter", isPageLocked(page.id) && "locked", !isPageLocked(page.id) && activePage.id === page.id && "active"),
                                                onClick: function() {
                                                    return changePage(page);
                                                },
                                                children: [
                                                    page.title,
                                                    isPageLocked(page.id) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default.Lock */.Z.Lock, {
                                                        fontSize: "inherit"
                                                    })
                                                ]
                                            }, page.id);
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var game_gameBook = (/*#__PURE__*/(0,react.memo)(GameBook));

// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
;// CONCATENATED MODULE: ./components/tour/game/OpenGameBook/components/ChapterDetails/styled/Root/style.tsx

function styled_Root_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  z-index: 999;\n  top: 20px;\n  right: 260px;\n  color: #ffffff;\n  background: rgba(0, 0, 0, 0.4);\n  backdrop-filter: blur(15px);\n  border-radius: 15px;\n  display: flex;\n  flex-direction: column;\n  padding: 1.25em;\n  justify-content: space-between;\n  max-width: 60%;\n  min-width: 320px;\n  min-height: 320px;\n\n  ",
        "\n"
    ]);
    styled_Root_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var Root_style_RootStyled = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__RootStyled",
    componentId: "sc-2405e9d5-0"
})(styled_Root_style_templateObject(), function(param) {
    var background = param.background, opacity = param.opacity, color = param.color, withFooter = param.withFooter, theme = param.theme;
    var styles = "";
    if (!withFooter) {
        styles += "justify-content: flex-start;";
    }
    if (background && opacity) {
        var ref = (0,util/* hexToRgb */.oo)(background), r = ref.r, g = ref.g, b = ref.b;
        styles += "background-color: rgba(".concat(r, ",").concat(g, ",").concat(b, ", ").concat(opacity, ");");
    }
    if (color) {
        styles += "color: ".concat(color, ";");
    }
    if (theme.device.mobile) {
        styles += "";
    }
    return styles;
});

;// CONCATENATED MODULE: ./components/tour/game/OpenGameBook/components/ChapterDetails/styled/Root/index.tsx





var styled_Root_Root = function(_param) /*#__PURE__*/ {
    var children = _param.children, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return (0,jsx_runtime.jsx)(Root_style_RootStyled, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, restProps), {
        children: children
    }));
};
/* harmony default export */ var ChapterDetails_styled_Root = (styled_Root_Root);

;// CONCATENATED MODULE: ./components/tour/game/OpenGameBook/components/ChapterDetails/styled/Header/style.tsx

function styled_Header_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n\n  h2 {\n    font-size: 1.25em;\n  }\n\n  ",
        "\n"
    ]);
    styled_Header_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var Header_style_HeaderStyled = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__HeaderStyled",
    componentId: "sc-87aa418e-0"
})(styled_Header_style_templateObject(), function(param) {
    var theme = param.theme;
    return theme.device.mobile && "\n  ";
});

;// CONCATENATED MODULE: ./components/tour/game/OpenGameBook/components/ChapterDetails/styled/Header/index.tsx





var styled_Header_Header = function(_param) /*#__PURE__*/ {
    var children = _param.children, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return (0,jsx_runtime.jsx)(Header_style_HeaderStyled, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, restProps), {
        children: children
    }));
};
/* harmony default export */ var ChapterDetails_styled_Header = (styled_Header_Header);

;// CONCATENATED MODULE: ./components/tour/game/OpenGameBook/components/ChapterDetails/styled/Body/style.tsx

function Body_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 1em 0;\n\n  img {\n    max-height: 70vh;\n    width: 100%;\n  }\n\n  p {\n    overflow-wrap: anywhere;\n  }\n\n  ",
        "\n"
    ]);
    Body_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var BodyStyled = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__BodyStyled",
    componentId: "sc-d3e442b0-0"
})(Body_style_templateObject(), function(param) {
    var theme = param.theme;
    return theme.device.mobile && "\n    img {\n      max-height: 60vh;\n    }\n  ";
});

;// CONCATENATED MODULE: ./components/tour/game/OpenGameBook/components/ChapterDetails/styled/Body/index.tsx





var Body = function(_param) /*#__PURE__*/ {
    var children = _param.children, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return (0,jsx_runtime.jsx)(BodyStyled, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, restProps), {
        children: children
    }));
};
/* harmony default export */ var styled_Body = (Body);

;// CONCATENATED MODULE: ./components/tour/game/OpenGameBook/components/ChapterDetails/styled/Footer/style.tsx

function styled_Footer_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: flex-end;\n\n  button {\n    font-size: 1em;\n    background-color: #2055ff;\n    padding: 0.4em 1em;\n    color: white;\n\n    &:hover {\n      opacity: 0.7;\n    }\n\n    ",
        "\n  }\n\n  ",
        "\n"
    ]);
    styled_Footer_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var style_FooterStyled = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__FooterStyled",
    componentId: "sc-1575e035-0"
})(styled_Footer_style_templateObject(), function(param) {
    var buttonColor = param.buttonColor, color = param.color;
    return buttonColor && color && "\n      background-color: ".concat(buttonColor, ";\n      color: ").concat(color, "\n    ");
}, function(param) {
    var theme = param.theme;
    return theme.device.mobile && "\n  ";
});

;// CONCATENATED MODULE: ./components/tour/game/OpenGameBook/components/ChapterDetails/styled/Footer/index.tsx





var Footer_Footer = function(_param) {
    var show = _param.show, children = _param.children, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "show",
        "children"
    ]);
    return show && /*#__PURE__*/ (0,jsx_runtime.jsx)(style_FooterStyled, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, restProps), {
        children: children
    }));
};
/* harmony default export */ var ChapterDetails_styled_Footer = (Footer_Footer);

;// CONCATENATED MODULE: ./components/tour/game/OpenGameBook/components/ChapterDetails/styled/index.ts





;// CONCATENATED MODULE: ./components/tour/game/OpenGameBook/components/ChapterDetails/ChapterDetails.tsx









var ChapterDetails = /*#__PURE__*/ (0,react.memo)(function(param) {
    var book = param.book, chapter = param.chapter, onClose = param.onClose, moveToSweep = param.moveToSweep;
    if (!chapter || !(chapter.locationType === types/* GameBookLocationType.sweep */.d.sweep && chapter.moveToSweepUuid)) return null;
    var translation = (0,recoil/* useRecoilValue */.sJ)(store/* translationDataState */.Jv);
    var backgroundColor = book.backgroundColor, backgroundOpacity = book.backgroundOpacity, textColor = book.textColor, buttonColor = book.buttonColor;
    var showFooter = !!chapter.moveToSweepUuid;
    var handleMoveToSweep = function() {
        try {
            if (chapter) {
                if (chapter.locationType === types/* GameBookLocationType.sweep */.d.sweep && chapter.moveToSweepUuid) {
                    moveToSweep(chapter.moveToSweepUuid);
                } else if (chapter.locationType === types/* GameBookLocationType.tourLink */.d.tourLink && chapter.locationTourLink) {
                    var parsedLink = (0,base/* parseTourLink */.Qs)(chapter.locationTourLink);
                    if (parsedLink) {
                        moveToSweep(parsedLink.s, {
                            x: parsedLink.x,
                            y: parsedLink.y
                        });
                    }
                }
                onClose();
            }
        } catch (err) {
            console.error("gameBook ChapterDetails handleMoveToSweep error");
        }
    };
    return /*#__PURE__*/ react_dom.createPortal(/*#__PURE__*/ (0,jsx_runtime.jsxs)(ChapterDetails_styled_Root, {
        background: backgroundColor,
        opacity: backgroundOpacity,
        color: textColor,
        withFooter: showFooter,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ChapterDetails_styled_Header, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        children: chapter.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default.Close */.Z.Close, {
                        onClick: onClose
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_Body, {
                children: chapter.url ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: chapter.url,
                    alt: ""
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: chapter.description
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ChapterDetails_styled_Footer, {
                show: showFooter,
                buttonColor: buttonColor,
                color: textColor,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                    onClick: handleMoveToSweep,
                    children: [
                        (translation === null || translation === void 0 ? void 0 : translation.experienceTeleport) || "Take me there",
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default.ArrowRight */.Z.ArrowRight, {
                            fontSize: "inherit"
                        })
                    ]
                })
            })
        ]
    }), document.getElementById("page-root"));
});

;// CONCATENATED MODULE: ./components/tour/game/OpenGameBook/components/ChapterDetails/index.ts

/* harmony default export */ var components_ChapterDetails = (ChapterDetails);

;// CONCATENATED MODULE: ./components/tour/game/OpenGameBook/styled/Root/style.tsx

function OpenGameBook_styled_Root_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  width: 200px;\n  top: 210px;\n  right: 50px;\n  z-index: 110;\n  background: rgba(0, 0, 0, 0.4);\n  backdrop-filter: blur(15px);\n  border-radius: 15px;\n  padding: 0.5em 0;\n  color: white;\n  font-size: 16px;\n  font-family: Roboto;\n\n  ",
        "\n"
    ]);
    OpenGameBook_styled_Root_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var styled_Root_style_RootStyled = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__RootStyled",
    componentId: "sc-1da506d6-0"
})(OpenGameBook_styled_Root_style_templateObject(), function(param) {
    var background = param.background, opacity = param.opacity, color = param.color, customTop = param.customTop, theme = param.theme;
    var styles = "";
    if (background && opacity) {
        var ref = (0,util/* hexToRgb */.oo)(background), r = ref.r, g = ref.g, b = ref.b;
        styles += "background-color: rgba(".concat(r, ",").concat(g, ",").concat(b, ", ").concat(opacity, ");");
    }
    if (color) {
        styles += "color: ".concat(color, ";");
    }
    if (theme.device.mobile) {
        styles += "";
    }
    if (customTop) {
        styles += "top: ".concat(customTop, ";");
    }
    return styles;
});

;// CONCATENATED MODULE: ./components/tour/game/OpenGameBook/styled/Root/index.tsx





var OpenGameBook_styled_Root_Root = function(_param) /*#__PURE__*/ {
    var children = _param.children, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return (0,jsx_runtime.jsx)(styled_Root_style_RootStyled, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, restProps), {
        children: children
    }));
};
/* harmony default export */ var OpenGameBook_styled_Root = (OpenGameBook_styled_Root_Root);

;// CONCATENATED MODULE: ./components/tour/game/OpenGameBook/styled/Header/style.tsx

function OpenGameBook_styled_Header_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0.5em 1.25em;\n\n  h2 {\n    font-size: 0.8em;\n    font-weight: 500;\n    line-height: 0.8em;\n    letter-spacing: 0;\n    text-align: left;\n  }\n\n  ",
        "\n"
    ]);
    OpenGameBook_styled_Header_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var styled_Header_style_HeaderStyled = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__HeaderStyled",
    componentId: "sc-9a2c996e-0"
})(OpenGameBook_styled_Header_style_templateObject(), function(param) {
    var theme = param.theme;
    return theme.device.mobile && "\n  ";
});

;// CONCATENATED MODULE: ./components/tour/game/OpenGameBook/styled/Header/index.tsx





var OpenGameBook_styled_Header_Header = function(_param) /*#__PURE__*/ {
    var children = _param.children, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return (0,jsx_runtime.jsx)(styled_Header_style_HeaderStyled, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, restProps), {
        children: children
    }));
};
/* harmony default export */ var OpenGameBook_styled_Header = (OpenGameBook_styled_Header_Header);

;// CONCATENATED MODULE: ./components/tour/game/OpenGameBook/styled/List/style.tsx

function styled_List_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-height: 80vh;\n  overflow-y: auto;\n  font-size: 1em;\n  ",
        "\n\n  .chapter {\n    display: block;\n    font-size: ",
        ";\n    width: 100%;\n    color: #fff;\n    position: relative;\n    cursor: pointer;\n    overflow: hidden;\n    padding: 0.5em 1.25em;\n    overflow-wrap: anywhere;\n\n    &:hover {\n      background-color: #2055ff;\n      ",
        "\n    }\n\n    ",
        "\n  }\n\n  ",
        "\n"
    ]);
    styled_List_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var style_ListStyled = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__ListStyled",
    componentId: "sc-dcf0b53e-0"
})(styled_List_style_templateObject(), function(param) {
    var isHorizontalMobileView = param.isHorizontalMobileView;
    return isHorizontalMobileView && "height: 100px; overflow-y: scroll;";
}, function(param) {
    var isHorizontalMobileView = param.isHorizontalMobileView;
    return isHorizontalMobileView ? "0.8em" : "1em";
}, function(param) {
    var buttonColor = param.buttonColor;
    return buttonColor && "background-color: ".concat(buttonColor, ";");
}, function(param) {
    var color = param.color;
    return color && "color: ".concat(color, ";");
}, function(param) {
    var theme = param.theme;
    return theme.device.mobile && "\n  ";
});

;// CONCATENATED MODULE: ./components/tour/game/OpenGameBook/styled/List/index.tsx





var List_List = function(_param) /*#__PURE__*/ {
    var children = _param.children, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return (0,jsx_runtime.jsx)(style_ListStyled, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, restProps), {
        children: children
    }));
};
/* harmony default export */ var OpenGameBook_styled_List = (List_List);

;// CONCATENATED MODULE: ./components/tour/game/OpenGameBook/styled/index.ts




;// CONCATENATED MODULE: ./components/tour/game/OpenGameBook/OpenGameBook.tsx














var OpenGameBook = function(param) {
    var book = param.book, show = param.show, unlockedChapterIds = param.unlockedChapterIds, onClose = param.onClose, moveToSweep = param.moveToSweep, tourType = param.tourType;
    if (!show) return null;
    var translation = (0,recoil/* useRecoilValue */.sJ)(store/* translationDataState */.Jv);
    var sbIsOpen = (0,recoil/* useRecoilValue */.sJ)(store/* sidebarOpenState */.eo);
    var backgroundColor = book.backgroundColor, backgroundOpacity = book.backgroundOpacity, textColor = book.textColor, buttonColor = book.buttonColor, chapterLocked = book.chapterLocked;
    var ref = (0,react.useState)(), activeData = ref[0], setActiveData = ref[1];
    var isEcommerce = tourType === Tour/* TourType.ECommerce */.v.ECommerce;
    var isHorizontalMobileView = deviceManager/* default.isHorizontalMobileView */.Z.isHorizontalMobileView();
    var isChapterLocked = function(chapterId) {
        if (!chapterLocked) return false;
        return !unlockedChapterIds.includes(chapterId);
    };
    var openChapter = function(chapterId) {
        var data;
        if (chapterId === 0) {
            data = {
                title: (translation === null || translation === void 0 ? void 0 : translation.experienceCover) || "Cover",
                description: book.description,
                url: book.img ? "".concat("https://cdn.treedis.com", "/games/").concat(book.gameId, "/book/").concat(book.id, "/").concat(book.img) : undefined,
                moveToSweepUuid: undefined
            };
        } else if (!isChapterLocked(chapterId)) {
            var chapter = book.chapters.find(function(x) {
                return x.id === chapterId;
            });
            data = {
                // ...chapter,
                locationType: chapter.locationType,
                locationTourLink: chapter.locationTourLink,
                title: chapter.title,
                description: chapter.description,
                url: chapter.img ? "".concat("https://cdn.treedis.com", "/games/").concat(book.gameId, "/book/").concat(book.id, "/chapter/").concat(chapter.id, "/").concat(chapter.img) : undefined,
                moveToSweepUuid: chapter.sweepUuid
            };
        }
        if (data) {
            setActiveData(data);
        }
    };
    (0,react.useEffect)(function() {
        try {
            if (activeData) {
                if (activeData.locationType === types/* GameBookLocationType.sweep */.d.sweep && activeData.moveToSweepUuid) {
                    moveToSweep(activeData.moveToSweepUuid);
                } else if (activeData.locationType === types/* GameBookLocationType.tourLink */.d.tourLink && activeData.locationTourLink) {
                    var parsedLink = (0,base/* parseTourLink */.Qs)(activeData.locationTourLink);
                    if (parsedLink) {
                        moveToSweep(parsedLink.s, {
                            x: parsedLink.x,
                            y: parsedLink.y
                        });
                    }
                }
                setActiveData(undefined);
            }
        } catch (err) {
            console.error("gameBook ChapterDetails handleMoveToSweep error");
        }
    }, [
        activeData,
        moveToSweep,
        onClose
    ]);
    var eCommerceStyle = {
        top: "100px",
        marginTop: 0,
        right: sbIsOpen ? "180px" : "50px"
    };
    //timeout will prevent reopen configs closed by sidebar configs icon
    var handleClickAway = function(ev) {
        if (isEcommerce) {
            window.setTimeout(function() {
                onClose();
            }, 100);
        }
    };
    //disable for mobile
    if (deviceManager/* default.isMobile */.Z.isMobile()) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerHorizontalViewOnly, {
                show: show,
                onClose: onClose
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ClickAwayListener/* default */.Z, {
                mouseEvent: "onMouseUp",
                onClickAway: handleClickAway,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "handleClickAwayNotWorksWithoutThisWrap",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(OpenGameBook_styled_Root, {
                        background: backgroundColor,
                        opacity: backgroundOpacity,
                        color: textColor,
                        style: isEcommerce ? eCommerceStyle : undefined,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(OpenGameBook_styled_Header, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        children: (book === null || book === void 0 ? void 0 : book.description) || (translation === null || translation === void 0 ? void 0 : translation.expJournBook) || "Journey book"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default.Close */.Z.Close, {
                                        onClick: onClose
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(OpenGameBook_styled_List, {
                                buttonColor: buttonColor,
                                color: textColor,
                                isHorizontalMobileView: isHorizontalMobileView,
                                children: [
                                    book.img && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        className: "chapter",
                                        onClick: function() {
                                            return openChapter(0);
                                        },
                                        children: (translation === null || translation === void 0 ? void 0 : translation.experienceCover) || "Cover"
                                    }, "0"),
                                    sortBy_default()(book.chapters || [], "order").map(function(chapter) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                            className: "d-flex justify-content-between align-center chapter",
                                            onClick: function() {
                                                return openChapter(chapter.id);
                                            },
                                            children: [
                                                chapter.title,
                                                isChapterLocked(chapter.id) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default.Lock */.Z.Lock, {
                                                    fontSize: "inherit"
                                                })
                                            ]
                                        }, chapter.id);
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ChapterDetails, {
                                book: book,
                                chapter: activeData,
                                onClose: function() {
                                    return setActiveData(undefined);
                                },
                                moveToSweep: moveToSweep
                            })
                        ]
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/tour/game/OpenGameBook/index.ts

/* harmony default export */ var game_OpenGameBook = (OpenGameBook);

// EXTERNAL MODULE: ./_models/game/GameBook.ts
var game_GameBook = __webpack_require__(97741);
;// CONCATENATED MODULE: ./components/tour/game/GameBookHandle/index.tsx
// import GameBookBtn from '../gameBookBtn';




// import { TourType } from '@/_models/Tour';
var GameBookHandle = function(param) {
    var isEcommerce = param.isEcommerce, gameBook = param.gameBook, showBook = param.showBook, tourType = param.tourType, closeGameBook = param.closeGameBook, unlockedChapterIds = param.unlockedChapterIds, moveToSweep = param.moveToSweep, tryButtonPlaySound = param.tryButtonPlaySound;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            (gameBook === null || gameBook === void 0 ? void 0 : gameBook.type) === game_GameBook/* GameBookType.Close */.u6.Close && showBook && /*#__PURE__*/ (0,jsx_runtime.jsx)(game_gameBook, {
                tourType: tourType,
                show: showBook,
                onClose: closeGameBook,
                book: gameBook,
                unlockedChapterIds: unlockedChapterIds,
                tryButtonPlaySound: tryButtonPlaySound,
                moveToSweep: function(sweepUuid, rotation) {
                    moveToSweep(sweepUuid, rotation);
                    closeGameBook();
                }
            }),
            (gameBook === null || gameBook === void 0 ? void 0 : gameBook.type) === game_GameBook/* GameBookType.Open */.u6.Open && showBook && /*#__PURE__*/ (0,jsx_runtime.jsx)(game_OpenGameBook, {
                show: showBook,
                onClose: closeGameBook,
                book: gameBook,
                unlockedChapterIds: unlockedChapterIds,
                moveToSweep: moveToSweep,
                tourType: tourType
            })
        ]
    });
};


/***/ }),

/***/ 20000:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ ScreenNavigationArrow; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var ScreenNavigationArrow = function(param) {
    var refProp = param.refProp, _zIndex = param.zIndex, zIndex = _zIndex === void 0 ? 100 : _zIndex;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "direction-arrow",
        ref: refProp,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
            src: "/images/direction-arrow.svg",
            className: "direction-arrow-image",
            alt: "arrow",
            style: {
                zIndex: zIndex
            }
        })
    });
};


/***/ }),

/***/ 2520:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ AdRedesigned; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(20414);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67836);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(22841);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(75158);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(61225);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(71927);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(31470);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(10160);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(21448);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(68346);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(9144);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(61953);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(29630);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(49837);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(91359);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(62026);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(54225);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(74821);
/* harmony import */ var components_new__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48517);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_toastify__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72132);
/* harmony import */ var _components_util__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97666);
/* harmony import */ var _models_TourLead__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(60988);











var Input = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.forwardRef)(function Input(param, ref) {
    var label = param.label, type = param.type;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        inputRef: ref,
        sx: {
            "& .MuiInputBase-root": {
                height: "50px"
            }
        },
        label: label,
        type: type,
        fullWidth: true,
        required: true
    });
});
var LegalCheckbox = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.forwardRef)(function(param, ref) {
    var label = param.label;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
        componentsProps: {
            typography: {
                fontSize: {
                    xs: "14px",
                    md: "16px"
                }
            }
        },
        sx: {
            m: 0
        },
        // @ts-ignore
        control: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
            ref: ref,
            required: true
        }),
        label: label
    });
});
function AdRedesigned(param) {
    var tour = param.tour, form = param.form, to = param.to, translation = param.translation, whitelabel = param.whitelabel, rtl = param.rtl;
    var id = tour.id, title = tour.title, userId = tour.userId, clientId = tour.clientId;
    var phone = form.phone, name = form.name, email = form.email, checkbox1 = form.checkbox1, url = form.url, time = form.time, checkbox2 = form.checkbox2;
    var primaryColor = (whitelabel === null || whitelabel === void 0 ? void 0 : whitelabel.primaryColor) || "#2055ff";
    var secondaryColor = (whitelabel === null || whitelabel === void 0 ? void 0 : whitelabel.secondaryColor) || "#000000";
    var hasOnlyImage = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        return !name && !email && !phone && !checkbox1 && !checkbox2;
    }, [
        email,
        name,
        phone,
        checkbox1,
        checkbox2
    ]);
    var isDesktop = (0,_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(function(theme) {
        return theme.breakpoints.up("md");
    });
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), open = ref[0], setOpen = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), submitted = ref1[0], setSubmitted = ref1[1];
    var onClose = function() {
        setOpen(false);
    };
    var validatePhone = function(value) {
        var regex = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/;
        return regex.test(value);
    };
    var validateEmail = function(emailStr) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(emailStr).toLowerCase());
    };
    var nameRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    var emailRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    var phoneRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    var legalRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    var legalRef2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    var handleSubmit = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(function(event) {
            var ref, ref1, ref2, ref3, ref4, nameValue, emailValue, phoneValue, checkbox1Value, checkbox2Value, params, error;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        event.preventDefault();
                        nameValue = (ref = nameRef.current) === null || ref === void 0 ? void 0 : ref.value;
                        emailValue = (ref1 = emailRef.current) === null || ref1 === void 0 ? void 0 : ref1.value;
                        phoneValue = (ref2 = phoneRef.current) === null || ref2 === void 0 ? void 0 : ref2.value;
                        checkbox1Value = (ref3 = legalRef.current) === null || ref3 === void 0 ? void 0 : ref3.checked;
                        checkbox2Value = (ref4 = legalRef2.current) === null || ref4 === void 0 ? void 0 : ref4.checked;
                        if (email && !validateEmail(emailValue)) {
                            react_toastify__WEBPACK_IMPORTED_MODULE_3__/* .toast.error */ .Am.error("Please enter a valid email address");
                            return [
                                2
                            ];
                        }
                        if (phone && !validatePhone(phoneValue)) {
                            react_toastify__WEBPACK_IMPORTED_MODULE_3__/* .toast.error */ .Am.error("Please enter a valid phone number");
                            return [
                                2
                            ];
                        }
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            5,
                            6
                        ]);
                        setSubmitted(true);
                        (0,_components_util__WEBPACK_IMPORTED_MODULE_4__/* .sendToGA */ .o$)("event", {
                            eventCategory: "Lead",
                            eventAction: "submit",
                            eventLabel: time ? "image" : "sweep"
                        });
                        params = {
                            link: window.location.href,
                            tour: title,
                            userId: userId,
                            clientId: clientId,
                            name: nameValue,
                            email: emailValue,
                            phone: phoneValue,
                            legalBookingBox: checkbox1Value,
                            legalBookingBox2: checkbox2Value
                        };
                        return [
                            4,
                            (0,_components_util__WEBPACK_IMPORTED_MODULE_4__/* .fetchData */ .rQ)("public/sendEmail", "POST", {
                                to: to,
                                params: params
                            })
                        ];
                    case 2:
                        _state.sent();
                        react_toastify__WEBPACK_IMPORTED_MODULE_3__/* .toast.success */ .Am.success("E-Mail sent");
                        return [
                            4,
                            (0,_components_util__WEBPACK_IMPORTED_MODULE_4__/* .fetchData */ .rQ)("public/setTourLead", "POST", {
                                name: params.name,
                                email: params.email,
                                phone: params.phone,
                                category: _models_TourLead__WEBPACK_IMPORTED_MODULE_5__/* .LeadCategory.InTourLeadImage */ .k.InTourLeadImage,
                                tourId: id
                            })
                        ];
                    case 3:
                        _state.sent();
                        return [
                            3,
                            6
                        ];
                    case 4:
                        error = _state.sent();
                        react_toastify__WEBPACK_IMPORTED_MODULE_3__/* .toast.error */ .Am.error(error.message);
                        return [
                            3,
                            6
                        ];
                    case 5:
                        onClose();
                        return [
                            7
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSubmit(event) {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        // If time is present, then it's a timed lead form, if not, then it's a 3Dscan lead form
        if (time) {
            setTimeout(function() {
                setOpen(true);
                (0,_components_util__WEBPACK_IMPORTED_MODULE_4__/* .sendToGA */ .o$)("event", {
                    eventCategory: "Lead",
                    eventAction: "open",
                    eventLabel: "image"
                });
            }, time * 1000);
        } else {
            setOpen(true);
            (0,_components_util__WEBPACK_IMPORTED_MODULE_4__/* .sendToGA */ .o$)("event", {
                eventCategory: "Lead",
                eventAction: "open",
                eventLabel: "sweep"
            });
        }
    }, [
        time
    ]);
    var topButtonsMargin = "16px";
    var _obj, _obj1;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
        theme: function() {
            return (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({
                // @ts-ignore
                palette: {
                    primary: {
                        main: primaryColor
                    },
                    secondary: {
                        main: secondaryColor
                    }
                }
            });
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
            dir: rtl ? "rtl" : "ltr",
            open: open,
            maxWidth: "md",
            sx: {
                "& .MuiDialog-paper": {
                    width: "100%",
                    borderRadius: "25px",
                    overflow: "hidden"
                }
            },
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                    onClick: onClose,
                    sx: (_obj = {
                        position: "absolute",
                        top: topButtonsMargin
                    }, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(_obj, rtl ? "left" : "right", topButtonsMargin), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(_obj, "width", "32px"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(_obj, "height", "32px"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(_obj, "minHeight", "32px"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(_obj, "zIndex", 1), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(_obj, "boxShadow", "none"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(_obj, "fontSize", "18px"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(_obj, "background", "#fff"), _obj),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                        className: "fa-regular fa-times"
                    })
                }),
                url && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                    component: _mui_material__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z,
                    target: "_blank",
                    href: url,
                    sx: (_obj1 = {
                        position: "absolute",
                        top: topButtonsMargin
                    }, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(_obj1, rtl ? "right" : "left", topButtonsMargin), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(_obj1, "zIndex", 1), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(_obj1, "boxShadow", "none"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(_obj1, "color", "#fff"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(_obj1, "fontWeight", "bolder"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(_obj1, "cursor", "pointer"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(_obj1, "background", "rgba(0,0,0,0.4)"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(_obj1, "&:hover", {
                        textDecoration: "none",
                        color: "#fff"
                    }), _obj1),
                    label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                        direction: "row",
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                    className: "fa-regular fa-arrow-up-right-from-square"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
                                variant: "body2",
                                sx: {
                                    color: "#fff",
                                    mx: 1
                                },
                                children: (translation === null || translation === void 0 ? void 0 : translation.clickToOpen) || "Click to Open"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z, {
                    sx: {
                        background: "#fff",
                        width: "100%",
                        padding: "0",
                        display: "flex",
                        flexDirection: "column"
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_new__WEBPACK_IMPORTED_MODULE_1__/* .Image */ .Ee, {
                            src: form.imageSrc,
                            ratio: hasOnlyImage ? "4/3" : "21/9",
                            objectFit: "cover"
                        }),
                        !hasOnlyImage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                            sx: {
                                overflowY: "auto",
                                padding: {
                                    xs: 2
                                }
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("form", {
                                onSubmit: handleSubmit,
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z, {
                                        sx: {
                                            padding: 0
                                        },
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                                            spacing: 2,
                                            children: [
                                                name && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Input, {
                                                    ref: nameRef,
                                                    label: (translation === null || translation === void 0 ? void 0 : translation.name) || "Name"
                                                }),
                                                email && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Input, {
                                                    ref: emailRef,
                                                    label: (translation === null || translation === void 0 ? void 0 : translation.email) || "E-Mail",
                                                    type: "email"
                                                }),
                                                phone && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Input, {
                                                    ref: phoneRef,
                                                    label: (translation === null || translation === void 0 ? void 0 : translation.phone) || "Phone"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                                                    sx: {
                                                        marginX: "-8px !important",
                                                        width: "100%",
                                                        textAlign: rtl ? "right" : "left"
                                                    },
                                                    children: [
                                                        checkbox1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LegalCheckbox, {
                                                            ref: legalRef,
                                                            label: checkbox1
                                                        }),
                                                        checkbox2 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LegalCheckbox, {
                                                            ref: legalRef2,
                                                            label: checkbox2
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z, {
                                        sx: {
                                            padding: 0,
                                            mt: 2
                                        },
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z, {
                                            type: "submit",
                                            fullWidth: true,
                                            variant: "contained",
                                            size: "large",
                                            disabled: submitted,
                                            sx: {
                                                height: isDesktop ? "56px" : "50px"
                                            },
                                            children: (translation === null || translation === void 0 ? void 0 : translation.submit) || "Submit"
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
}


/***/ }),

/***/ 32847:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CustomReel; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(4111);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(88029);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(71418);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_util__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97666);








var CustomReel = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(CustomReel, Component);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(CustomReel);
    function CustomReel(props) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(this, CustomReel);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            reelStep: -1,
            reel: []
        };
        _this.scrollHorizontally = _this.scrollHorizontally.bind((0,_swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_this));
        return _this;
    }
    var _proto = CustomReel.prototype;
    _proto.scrollHorizontally = function scrollHorizontally(e) {
        if (this.reel) {
            e = window.event || e;
            var delta = Math.max(-1, Math.min(1, e.wheelDelta || -e.detail));
            this.reel.scrollLeft -= delta * 10; // Multiplied by 40
            e.preventDefault();
        }
    };
    _proto.componentDidMount = function componentDidMount() {
        if (this.reel) {
            this.reel.addEventListener("DOMMouseScroll", this.scrollHorizontally, false);
            this.reel.addEventListener("mousewheel", this.scrollHorizontally, false);
        }
    };
    _proto.render = function render() {
        var _this = this;
        var _state = this.state, reelStep = _state.reelStep, reel = _state.reel;
        var _props = this.props, loadModel = _props.loadModel, tourId = _props.tourId, _isBlackBackground = _props.isBlackBackground, isBlackBackground = _isBlackBackground === void 0 ? true : _isBlackBackground;
        var filteredReel = reel.filter(function(r) {
            return !r.hide;
        });
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            id: "reel-bar",
            ref: function(e) {
                _this.reel = e;
            },
            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()({
                white: !isBlackBackground
            }),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "scroll-div reels-block",
                style: {
                    width: "".concat(170 * filteredReel.length, "px")
                },
                children: filteredReel.map(function(p, i) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        onClick: function() {
                            if (p.url || p.tag || p.panoramaId) {
                                loadModel(p.title, p.url, p.type, p.tag, p.panoramaId, true, false, p.iframeSettings);
                                (0,_components_util__WEBPACK_IMPORTED_MODULE_3__/* .sendToGA */ .o$)("event", {
                                    eventCategory: "Highlight",
                                    eventAction: "click",
                                    eventLabel: p.title,
                                    eventId: p.id
                                });
                            }
                            _this.setState({
                                reelStep: i
                            });
                        },
                        className: reelStep === i ? "preview active" : "preview",
                        style: p.imageId ? {
                            backgroundImage: "url(".concat("https://cdn.treedis.com", "/tours/").concat(tourId, "/images/").concat(p.image.url, ")")
                        } : {},
                        children: [
                            p.type === "matterport" || p.type === "matterport-instant" || p.type === "treedis" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                className: "fas fa-walking"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                children: p.title
                            })
                        ]
                    }, i);
                })
            })
        });
    };
    CustomReel.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.reel !== prevState.reel) {
            return {
                reelStep: -1,
                reel: nextProps.reel
            };
        }
        return {};
    };
    return CustomReel;
}(react__WEBPACK_IMPORTED_MODULE_1__.Component);



/***/ }),

/***/ 18621:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Reel; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(4111);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(88029);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(71418);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_util__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97666);








var Reel = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(Reel, Component);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(Reel);
    function Reel(props) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(this, Reel);
        var _this;
        _this = _super.call(this, props);
        _this.state = {};
        _this.scrollHorizontally = _this.scrollHorizontally.bind((0,_swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_this));
        return _this;
    }
    var _proto = Reel.prototype;
    _proto.scrollHorizontally = function scrollHorizontally(e) {
        if (this.reel) {
            e = window.event || e;
            var delta = Math.max(-1, Math.min(1, e.wheelDelta || -e.detail));
            this.reel.scrollLeft -= delta * 10; // Multiplied by 40
            e.preventDefault();
        }
    };
    _proto.componentDidMount = function componentDidMount() {
        if (this.reel) {
            this.reel.addEventListener("DOMMouseScroll", this.scrollHorizontally, false);
            this.reel.addEventListener("mousewheel", this.scrollHorizontally, false);
        }
    };
    _proto.render = function render() {
        var _this = this;
        var _props = this.props, reel = _props.reel, move = _props.move, reelStep = _props.reelStep, _isBlackBackground = _props.isBlackBackground, isBlackBackground = _isBlackBackground === void 0 ? true : _isBlackBackground;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            id: "reel-bar",
            ref: function(e) {
                _this.reel = e;
            },
            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()({
                white: !isBlackBackground
            }),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "scroll-div",
                style: {
                    width: "".concat(170 * reel.length, "px")
                },
                children: reel.map(function(p, i) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        onClick: function() {
                            move(i);
                            (0,_components_util__WEBPACK_IMPORTED_MODULE_3__/* .sendToGA */ .o$)("event", {
                                eventCategory: "Highlight",
                                eventAction: "click",
                                eventLabel: p.name,
                                eventId: p.id
                            });
                        },
                        className: reelStep === i ? "preview active" : "preview",
                        style: {
                            backgroundImage: "url(".concat(p.thumbnailUrl, ")")
                        },
                        children: [
                            !p.is360 && p.mode === "mode.inside" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                className: "fas fa-walking"
                            }),
                            p.is360 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: "/images/panorama.png",
                                alt: "panorama-icon"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                children: p.name
                            })
                        ]
                    }, i);
                })
            })
        });
    };
    return Reel;
}(react__WEBPACK_IMPORTED_MODULE_1__.Component);



/***/ }),

/***/ 3405:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ bottomBar_ReelVideoBar; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/styles/useTheme.js
var useTheme = __webpack_require__(62097);
// EXTERNAL MODULE: ./node_modules/@treedis/tour-loader/dist/index.js + 149 modules
var dist = __webpack_require__(83625);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(18533);
;// CONCATENATED MODULE: ./components/tour/regular/bottomBar/ReelVideoBar/ReelVideo/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 100%;\n  width: 100%;\n  position: relative;\n\n  video {\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    top: 0;\n    left: 0;\n    object-fit: cover;\n    z-index: 1;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: ",
        ";\n  width: 100%;\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1;\n\n  p {\n    font-size: 15px;\n    color: #fff;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 100%;\n  width: 100%;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

var Root = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__Root",
    componentId: "sc-2befb480-0"
})(_templateObject());
var NameContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__NameContainer",
    componentId: "sc-2befb480-1"
})(_templateObject1(), function(props) {
    return props.avatarImage ? "auto" : "100%";
});
var Video = styled_components_browser_esm/* default.video.withConfig */.ZP.video.withConfig({
    displayName: "styles__Video",
    componentId: "sc-2befb480-2"
})(_templateObject2());

// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Box/Box.js + 1 modules
var Box = __webpack_require__(61953);
;// CONCATENATED MODULE: ./components/tour/regular/bottomBar/ReelVideoBar/ReelVideo/index.tsx
// import { Icon } from '@/units/index';




function ReelVideo(param) {
    var track = param.track, name = param.name, enabled = param.enabled, avatarImage = param.avatarImage;
    var ref = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        try {
            var el = ref.current;
            if (el && !el.src && track && typeof track.attach === "function") {
                // attach only if no media is attached, don't reattach. Find better way to handle it
                el.muted = true;
                console.log("Attaching ".concat(name));
                track.attach(el);
            }
            return function() {
                console.log("Detaching ".concat(name));
                if (track && typeof track.detach === "function") {
                    track.detach(el);
                }
            };
        } catch (err) {
            console.error(err);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        track
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Root, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Video, {
                ref: ref,
                style: {
                    visibility: enabled ? "visible" : "hidden"
                }
            }),
            avatarImage && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                component: "img",
                m: 0,
                width: "100%",
                height: "calc(100% - 38px)",
                sx: {
                    objectFit: "contain"
                },
                src: avatarImage,
                alt: "avatar preview"
            }),
            !enabled && /*#__PURE__*/ (0,jsx_runtime.jsx)(NameContainer, {
                avatarImage: avatarImage,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: name
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/tour/regular/bottomBar/ReelVideoBar/styles.ts

function styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  background: rgba(0, 0, 0, 0.3);\n  position: absolute;\n  left: 0;\n  display: flex;\n  align-items: center;\n  overflow-x: auto;\n  overflow-y: hidden;\n  z-index: 1000;\n  padding: 12px 6px;\n\n  ",
        "\n\n  &::-webkit-scrollbar-track {\n    background: var(--color-primary);\n  }\n\n  &::-webkit-scrollbar-thumb {\n    border-radius: 6px;\n    background: var(--color-secondary);\n  }\n\n  &::-webkit-scrollbar {\n    width: 4px;\n    height: var(--scroll-bar-size);\n    background: var(--color-primary);\n  }\n\n  @media screen and (max-width: 768px) {\n  }\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: auto;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  margin: 0 auto;\n"
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: center;\n  width: 160px;\n  height: 100%;\n  margin: 0 6px;\n  display: inline-block;\n  text-align: center;\n  position: relative;\n  overflow: hidden;\n  border: 1px solid #000;\n  background-color: rgba(0, 0, 0, 0.7);\n\n  .loader {\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    top: 0;\n    left: 0;\n    color: #fff;\n    z-index: 0;\n\n    span {\n      background: none;\n      animation: rotate 1s linear infinite;\n      position: absolute;\n      width: 100%;\n      height: 100%;\n      top: 0;\n      left: 0;\n    }\n    p {\n      position: absolute;\n      width: 100%;\n      height: 100%;\n      padding-top: 20px;\n      text-align: center;\n    }\n  }\n"
    ]);
    styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  display: flex;\n  align-items: center;\n  z-index: 2;\n  padding: 4px 0;\n  background-color: rgba(0, 0, 0, 0.7);\n  color: #fff;\n\n  span {\n    width: 100%;\n    font-size: 12px;\n    text-align: start;\n    margin-left: 5px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  i {\n    font-size: 11px;\n    cursor: pointer;\n    margin: 0 2px;\n    min-width: 14px;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}

var styles_Root = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__Root",
    componentId: "sc-999e4be3-0"
})(styles_templateObject(), function(param) {
    var show = param.show;
    return show ? "\n        height: 150px;\n        top: 0;\n        transition: top, height 0.3s ease;\n      " : "\n        height: 0;\n        top: 150px;\n        transition: top 0s ease 0.3s, height 0.3s ease;\n      ";
});
var Reels = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__Reels",
    componentId: "sc-999e4be3-1"
})(styles_templateObject1());
var Reel = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__Reel",
    componentId: "sc-999e4be3-2"
})(styles_templateObject2());
var Bar = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__Bar",
    componentId: "sc-999e4be3-3"
})(_templateObject3());

;// CONCATENATED MODULE: ./components/tour/regular/bottomBar/ReelVideoBar/index.tsx






var ReelVideoBar = function(props) {
    var show = props.show, videos = props.videos, host = props.host, onMuteClick = props.onMuteClick, onFullscreenClick = props.onFullscreenClick, onPinClick = props.onPinClick, audioOnly = props.audioOnly;
    var reelRef = (0,react.useRef)(null);
    var palette = (0,useTheme/* default */.Z)().palette;
    var ref = (0,react.useState)([]), reels = ref[0], setReels = ref[1];
    var scrollHorizontally = (0,react.useCallback)(function(e) {
        if (reelRef === null || reelRef === void 0 ? void 0 : reelRef.current) {
            e = window.event || e;
            var delta = Math.max(-1, Math.min(1, e.wheelDelta || -e.detail));
            reelRef.current.scrollLeft -= delta * 10;
            e.preventDefault();
        }
    }, []);
    (0,react.useEffect)(function() {
        if (videos !== reels) {
            setReels(videos);
        }
    }, [
        reels,
        videos
    ]);
    (0,react.useEffect)(function() {
        var ref = reelRef === null || reelRef === void 0 ? void 0 : reelRef.current;
        if (ref) {
            ref.addEventListener("DOMMouseScroll", scrollHorizontally, false);
            ref.addEventListener("mousewheel", scrollHorizontally, false);
        }
        return function() {
            if (ref) {
                ref.removeEventListener("DOMMouseScroll", scrollHorizontally);
                ref.removeEventListener("mousewheel", scrollHorizontally);
            }
        };
    }, [
        scrollHorizontally
    ]);
    var handleMuteClick = (0,react.useCallback)(function(item) {
        return function() {
            if (host) {
                onMuteClick(item.sid);
            }
        };
    }, [
        onMuteClick
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_Root, {
        show: show,
        ref: reelRef,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Reels, {
            children: reels.map(function(item, i) {
                var ref;
                /*#__PURE__*/ return (0,jsx_runtime.jsxs)(Reel, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ReelVideo, {
                            track: item.track,
                            enabled: item.enabled,
                            name: item.name,
                            // eslint-disable-next-line no-nested-ternary
                            avatarImage: audioOnly && (item === null || item === void 0 ? void 0 : item.avatarImage)
                        }, ((ref = item.track) === null || ref === void 0 ? void 0 : ref.id) || item.sid),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Bar, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: item.enabled || item.joining ? item.name : ""
                                }),
                                !item.self && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Icon */.JO, {
                                    type: "fas",
                                    sx: {
                                        color: item.muted ? palette.error.main : palette.success.main
                                    },
                                    icon: item.muted ? "fa-microphone-slash microphone off" : "fa-microphone microphone on",
                                    onClick: handleMuteClick(item),
                                    fontSize: "11px"
                                }),
                                !audioOnly && /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                    className: item.fullscreen ? "fas fa-compress" : "fas fa-expand",
                                    onClick: function() {
                                        onFullscreenClick(item);
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                    className: "far fa-circle",
                                    onClick: function() {
                                        return onPinClick(item);
                                    }
                                })
                            ]
                        })
                    ]
                }, item.sid);
            })
        })
    });
};
/* harmony default export */ var bottomBar_ReelVideoBar = (ReelVideoBar);


/***/ }),

/***/ 67644:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(828);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(81719);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(29630);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(9144);
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2804);
/* harmony import */ var store__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70989);
/* harmony import */ var _helpers_renderDebug__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(66725);
/* harmony import */ var _models_virtualStaging_VideoRenderer_component__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(23276);











function formatDuration(value) {
    var minute = Math.floor(value / 60);
    var secondsLeft = Math.floor(value - minute * 60);
    return "".concat(minute, ":").concat(secondsLeft < 10 ? "0".concat(secondsLeft) : secondsLeft);
}
var TinyText = (0,_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
    fontSize: "0.75rem",
    fontWeight: 500,
    letterSpacing: 0.2
});
var SoundControls = function(param) {
    var audio = param.audio, onClose = param.onClose, vsObjects = param.vsObjects, flowIsActive = param.flowIsActive;
    var ref;
    (0,_helpers_renderDebug__WEBPACK_IMPORTED_MODULE_5__/* .dLog */ .a)("SoundControls");
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0), soundTime = ref1[0], setSoundTime = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isShowVolumeRange = ref2[0], toggleVolumeRange = ref2[1];
    var ref3 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,recoil__WEBPACK_IMPORTED_MODULE_3__/* .useRecoilState */ .FV)(store__WEBPACK_IMPORTED_MODULE_4__/* .audioConfigsState */ .hm), 2), audioConfigs = ref3[0], setAudioConfigs = ref3[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (audio) {
            var updateSoundTime = function() {
                setSoundTime(audio.currentTime / audio.duration * 100);
            };
            audio.addEventListener("timeupdate", updateSoundTime);
            audio.addEventListener("ended", function() {
                setSoundTime(0);
            });
            return function() {
                audio.removeEventListener("timeupdate", updateSoundTime);
            };
        }
    }, []);
    var setTogglePlay = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        if (audio) {
            if (audio.paused) {
                var vsVideos = vsObjects === null || vsObjects === void 0 ? void 0 : vsObjects.filter(function(obj) {
                    var ref;
                    return ((ref = obj.node) === null || ref === void 0 ? void 0 : ref.componentType) === _models_virtualStaging_VideoRenderer_component__WEBPACK_IMPORTED_MODULE_6__/* .videoRendererType */ .Im;
                });
                vsVideos === null || vsVideos === void 0 ? void 0 : vsVideos.forEach(function(obj) {
                    var _node = obj.node, vsVideo = _node.video, muteBtn = _node.muteBtn;
                    if (!muteBtn.active) {
                        vsVideo.muted = true;
                        muteBtn.active = true;
                        muteBtn.makeBtn(muteBtn.inputs.src);
                    }
                });
                audio.play();
            } else {
                audio.pause();
            }
        }
    }, [
        vsObjects
    ]);
    var handleClose = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(mode) {
        return function() {
            if (audio) {
                if (mode === "close") {
                    audio.pause();
                    if (audio === null || audio === void 0 ? void 0 : audio.closeReceivers) {
                        var ref;
                        audio === null || audio === void 0 ? void 0 : (ref = audio.closeReceivers) === null || ref === void 0 ? void 0 : ref.dispatchEvent(new Event("close"));
                    }
                }
                if (onClose && typeof onClose === "function") {
                    onClose();
                }
            }
        };
    }, [
        onClose
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "sounds",
        style: {
            bottom: flowIsActive ? "260px" : "90px"
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "container-controls",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                        className: "fas fa-minus",
                        onClick: handleClose("hide")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                        className: "fas fa-times",
                        onClick: handleClose("close")
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "sound-range",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                    type: "range",
                    step: "0.1",
                    min: "0",
                    max: "100",
                    value: soundTime,
                    onChange: function(data) {
                        if (audio) {
                            audio.currentTime = parseFloat(data.target.value) * audio.duration / 100;
                        }
                    }
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "sound-controls",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "left-side",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "play"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("fas", (audio === null || audio === void 0 ? void 0 : audio.paused) ? "fa-play" : "fa-pause"),
                                onClick: setTogglePlay
                            })
                        ]
                    }),
                    (audio === null || audio === void 0 ? void 0 : (ref = audio.textTracks) === null || ref === void 0 ? void 0 : ref.length) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(audioConfigs.captionsEnabled ? "fas fa-closed-captioning" : "fal fa-closed-captioning"),
                            onClick: function() {
                                return setAudioConfigs((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, audioConfigs), {
                                    captionsEnabled: !audioConfigs.captionsEnabled
                                }));
                            }
                        })
                    }) : null,
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "volume",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                className: "fas fa-volume-up",
                                onClick: function() {
                                    return toggleVolumeRange(!isShowVolumeRange);
                                }
                            }),
                            isShowVolumeRange && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                type: "range",
                                step: "0.1",
                                min: "0",
                                max: "1",
                                value: (audio === null || audio === void 0 ? void 0 : audio.volume) || 1,
                                onChange: function(data) {
                                    if (audio) {
                                        audio.volume = parseFloat(data.target.value);
                                    }
                                }
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                direction: "row",
                spacing: 0.5,
                sx: {
                    color: "#fff"
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TinyText, {
                        children: "".concat(formatDuration((audio === null || audio === void 0 ? void 0 : audio.currentTime) || 0))
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TinyText, {
                        children: "/"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TinyText, {
                        children: formatDuration((audio === null || audio === void 0 ? void 0 : audio.duration) || 0)
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(SoundControls));


/***/ }),

/***/ 44:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ FullScreen; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4111);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88029);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71418);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* eslint-disable prefer-promise-reject-errors,class-methods-use-this */ // noinspection TypeScriptValidateTypes









var FullScreenContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)({
    isFullScreen: false,
    toggleFullscreen: function() {
        return null;
    }
});
var FullScreenStateProvider = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(FullScreenStateProvider, Component);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(FullScreenStateProvider);
    function FullScreenStateProvider(props) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this, FullScreenStateProvider);
        var _this;
        _this = _super.call(this, props);
        _this.targetRef = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createRef)();
        _this.state = {
            isFullScreen: false,
            // eslint-disable-next-line react/no-unused-state
            toggleFullscreen: _this.toggleFullscreen.bind((0,_swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_this))
        };
        return _this;
    }
    var _proto = FullScreenStateProvider.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var _this = this;
        var targetElem = this.getTargetElement();
        targetElem.onfullscreenchange = function(event) {
            var isTargetElem = targetElem === event.target;
            if (!isTargetElem) {
                // Need to sync state when fullscreen mode turned off but isFullScreen is true
                // Case when more than one fullscreen mode is active and user closed mode by ESC tab
                if (_this.state.isFullScreen === true && !document.fullscreenElement) {
                    _this.setState({
                        isFullScreen: false
                    });
                }
                return;
            }
            var isFullScreen = document.fullscreenElement === event.target;
            _this.setState({
                isFullScreen: isFullScreen
            });
        };
        // eslint-disable-next-line react/destructuring-assignment
        if (this.props.startFullscreen) {
            this.toggleFullscreen();
        }
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        var targetElem = this.getTargetElement();
        targetElem.onfullscreenchange = null;
    };
    _proto.toggleFullscreen = function toggleFullscreen() {
        if (!this.state.isFullScreen) {
            var ref;
            (ref = this.openFullscreen()) === null || ref === void 0 ? void 0 : ref.catch(console.error);
        } else {
            var ref1;
            (ref1 = this.exitFullscreen()) === null || ref1 === void 0 ? void 0 : ref1.catch(console.error);
        }
        // noinspection TypeScriptValidateTypes
        this.setState({
            isFullScreen: !this.state.isFullScreen
        });
    };
    _proto.exitFullscreen = function exitFullscreen() {
        if (document.exitFullscreen) {
            return document.exitFullscreen();
        }
        if (document.webkitExitFullscreen) {
            return document.webkitExitFullscreen();
        }
        if (document.msExitFullscreen) {
            return document.msExitFullscreen();
        }
        return Promise.reject("API does not response");
    };
    _proto.openFullscreen = function openFullscreen() {
        var elem = this.getTargetElement();
        if (elem.requestFullscreen) {
            return elem.requestFullscreen();
        }
        if (elem.webkitRequestFullscreen) {
            return elem.webkitRequestFullscreen();
        }
        if (elem.msRequestFullscreen) {
            return elem.msRequestFullscreen();
        }
        return Promise.reject("API does not response");
    };
    _proto.getTargetElement = function getTargetElement() {
        var rootBody = this.props.rootBody;
        return rootBody ? window.document.body : this.targetRef.current;
    };
    _proto.render = function render() {
        var _props = this.props, children = _props.children, attrs = _props.attrs;
        var attr = {
            id: attrs === null || attrs === void 0 ? void 0 : attrs.id,
            className: attrs === null || attrs === void 0 ? void 0 : attrs.class
        };
        var customStyles = (attrs === null || attrs === void 0 ? void 0 : attrs.styles) || {};
        var styles = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
            height: "100%",
            width: "100%",
            background: "#fff"
        }, customStyles);
        return(// eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FullScreenContext.Provider, {
            value: this.state,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                ref: this.targetRef
            }, attr), {
                style: styles,
                children: children
            }))
        }));
    };
    return FullScreenStateProvider;
}(react__WEBPACK_IMPORTED_MODULE_1__.Component);
function FullScreen(_param) {
    var children = _param.children, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FullScreenStateProvider, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, rest), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FullScreenContext.Consumer, {
            children: children
        })
    }));
}


/***/ }),

/***/ 39901:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ MondelezTabletVideo; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(31470);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(78944);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(25425);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(61953);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(9942);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(9144);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(17575);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(70918);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(59248);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(21448);
/* harmony import */ var _mui_material_IconButton__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(80562);
/* harmony import */ var _treedis_tour_loader__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83625);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_player__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22004);








var INIT_SETTINGS = {
    url: "",
    playing: false,
    volume: 1,
    played: 0,
    duration: 0
};
function formatDuration(value) {
    var minute = Math.floor(value / 60);
    var secondLeft = value - minute * 60;
    return "".concat(minute, ":").concat(secondLeft < 10 ? "0".concat(secondLeft) : secondLeft);
}
function MondelezTabletVideo(param) {
    var videoId = param.videoId, onClose = param.onClose;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), videoReady = ref[0], setVideoReady = ref[1];
    var containerRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    var playerRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, INIT_SETTINGS), {
        url: "https://mondelez-cdn.enterprise.treedis.com/videos/".concat(videoId)
    })), player = ref1[0], setPlayer = ref1[1];
    var handleSeek = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(value) {
        var newValue = player.played + value;
        if (newValue < 0) {
            var ref;
            playerRef === null || playerRef === void 0 ? void 0 : (ref = playerRef.current) === null || ref === void 0 ? void 0 : ref.seekTo(0);
            setPlayer(function(prev) {
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, prev), {
                    played: 0
                });
            });
        }
        if (newValue > player.duration) {
            var ref1;
            playerRef === null || playerRef === void 0 ? void 0 : (ref1 = playerRef.current) === null || ref1 === void 0 ? void 0 : ref1.seekTo(player.duration);
            setPlayer(function(prev) {
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, prev), {
                    played: player.duration
                });
            });
        } else if (newValue > 0 && newValue < player.duration) {
            var ref2;
            playerRef === null || playerRef === void 0 ? void 0 : (ref2 = playerRef.current) === null || ref2 === void 0 ? void 0 : ref2.seekTo(newValue);
            setPlayer(function(prev) {
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, prev), {
                    played: newValue
                });
            });
        }
    }, [
        player.duration,
        player.played
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        open: true,
        fullScreen: true,
        onClose: onClose,
        PaperProps: {
            sx: {
                background: "rgba(127,127,127,0.9)",
                backdropFilter: "blur(0)"
            }
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
            ref: containerRef,
            sx: {
                position: "relative",
                width: "100%",
                display: "flex",
                alignItems: "end",
                overflow: "hidden",
                padding: 0
            },
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_IconButton__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                    onClick: onClose,
                    sx: {
                        position: "absolute",
                        top: "10px",
                        right: "10px",
                        zIndex: 999,
                        color: "#fff"
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                        className: "fa-solid fa-times"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                    timeout: 1500,
                    in: true,
                    direction: "up",
                    container: containerRef.current,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                        sx: {
                            position: "relative",
                            width: "100%",
                            height: "auto",
                            maxHeight: "100vh"
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                component: "img",
                                src: "/images/ipad_and_hands.png",
                                sx: {
                                    width: "100%",
                                    height: "auto",
                                    maxHeight: "100vh",
                                    objectFit: "contain",
                                    visibility: "visible !important",
                                    zIndex: 2,
                                    position: "relative",
                                    marginBottom: "-7px"
                                }
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                sx: {
                                    position: "absolute",
                                    top: "50%",
                                    left: "50%",
                                    transform: "translate(-48%, -56%)",
                                    width: "min(55%, 110vh)",
                                    height: "80%",
                                    background: "white",
                                    zIndex: 1
                                },
                                children: [
                                    !videoReady && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                        sx: {
                                            zIndex: 99,
                                            position: "absolute",
                                            width: "100%",
                                            height: "100%",
                                            background: "#fff",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center"
                                        },
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_treedis_tour_loader__WEBPACK_IMPORTED_MODULE_1__/* .Loader */ .aN, {
                                            color: "#2055FF"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                        in: true,
                                        timeout: 1000,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                            width: "100%",
                                            height: "100%",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_player__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                                ref: playerRef,
                                                width: "100%",
                                                height: "100%",
                                                url: player.url,
                                                volume: player.volume,
                                                playing: player.playing,
                                                onReady: function() {
                                                    setTimeout(function() {
                                                        setVideoReady(true);
                                                    }, 500);
                                                },
                                                onEnded: function() {
                                                    return setTimeout(function() {
                                                        onClose();
                                                    }, 500);
                                                },
                                                onProgress: function(progress) {
                                                    setPlayer(function(prev) {
                                                        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, prev), {
                                                            played: Math.floor(progress.playedSeconds)
                                                        });
                                                    });
                                                },
                                                onDuration: function(duration) {
                                                    setPlayer(function(prev) {
                                                        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, prev), {
                                                            duration: Math.floor(duration)
                                                        });
                                                    });
                                                }
                                            })
                                        })
                                    })
                                ]
                            }),
                            !player.playing && videoReady && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_IconButton__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                sx: {
                                    position: "absolute",
                                    top: "40%",
                                    left: "50%",
                                    zIndex: 5,
                                    width: "50px",
                                    height: "50px",
                                    color: "rgba(0,0,0,0.8)",
                                    transform: "translateX(-50%)",
                                    "&>i": {
                                        fontSize: "7vw"
                                    }
                                },
                                onClick: function() {
                                    return setPlayer(function(prev) {
                                        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, prev), {
                                            playing: !player.playing
                                        });
                                    });
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                    className: "fa-solid fa-circle-play"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                direction: "row",
                                spacing: 2,
                                alignItems: "center",
                                sx: {
                                    position: "absolute",
                                    bottom: "2%",
                                    left: "50%",
                                    transform: "translateX(-50%)",
                                    borderRadius: "10px",
                                    background: "rgba(255,255,255,0.8)",
                                    px: 1
                                },
                                zIndex: 5,
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_IconButton__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                        onClick: function() {
                                            return setPlayer(function(prev) {
                                                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, prev), {
                                                    playing: !player.playing
                                                });
                                            });
                                        },
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                            className: "fa-solid ".concat(player.playing ? "fa-pause" : "fa-play")
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                        title: "-10s",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_IconButton__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                            onClick: function() {
                                                return handleSeek(-10);
                                            },
                                            disabled: player.played === 0,
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                className: "fa-solid fa-undo"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                        title: "+10s",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_IconButton__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                            onClick: function() {
                                                return handleSeek(10);
                                            },
                                            disabled: player.played === 0,
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                className: "fa-solid fa-redo"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                        enterDelay: 100,
                                        placement: "right",
                                        arrow: false,
                                        components: {
                                            Tooltip: _mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z
                                        },
                                        componentsProps: {
                                            tooltip: {
                                                sx: {
                                                    background: "rgba(255,255,255,0.8)",
                                                    mr: 2
                                                }
                                            }
                                        },
                                        title: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .ZP, {
                                            size: "small",
                                            value: player.volume * 100,
                                            onChange: function(e, value) {
                                                if (Number(value)) {
                                                    setPlayer(function(prev) {
                                                        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, prev), {
                                                            volume: Number(value) / 100
                                                        });
                                                    });
                                                }
                                            },
                                            min: 0,
                                            max: 100,
                                            sx: {
                                                width: "200px"
                                            }
                                        }),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_IconButton__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                            onClick: function() {
                                                return setPlayer(function(prev) {
                                                    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, prev), {
                                                        volume: player.volume > 0 ? 0 : 1
                                                    });
                                                });
                                            },
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                className: "fa-solid ".concat(player.volume === 0 ? "fa-volume-slash" : "fa-volume")
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                        label: "".concat(formatDuration(player.played), " / ").concat(formatDuration(player.duration))
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
}


/***/ }),

/***/ 39611:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70989);
/* eslint-disable react/self-closing-comp */ /* eslint-disable jsx-a11y/control-has-associated-label,jsx-a11y/interactive-supports-focus,jsx-a11y/no-static-element-interactions,react/no-danger */ 

// eslint-disable-next-line import/no-extraneous-dependencies



var Chat = function(props) {
    var chatOpen = props.chatOpen, _messages = props.messages, messages = _messages === void 0 ? [] : _messages, onSubmit = props.onSubmit, toggleChatClick = props.toggleChatClick, currentUserId = props.currentUserId;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), message = ref[0], setMessage = ref[1];
    var messagesEndRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var ref1 = (0,_store__WEBPACK_IMPORTED_MODULE_4__/* .useRecoilValue */ .sJ)(_store__WEBPACK_IMPORTED_MODULE_4__/* .translationDataState */ .Jv) || {}, _typeHere = ref1.typeHere, typeHere = _typeHere === void 0 ? "Type Here" : _typeHere, _chat = ref1.chat, chat = _chat === void 0 ? "Chat" : _chat;
    var handleMessageChange = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(e) {
        setMessage(e.target.value);
    }, []);
    var handleMessageSubmit = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(e) {
        if (e.keyCode !== 13 || !message) return;
        onSubmit(e, message);
        setMessage("");
    }, [
        message,
        onSubmit
    ]);
    var handleSendMessage = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(e) {
        onSubmit(e, message);
        setMessage("");
    }, [
        message,
        onSubmit
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (messagesEndRef.current) {
            messagesEndRef.current.scrollIntoView({
                behavior: "smooth"
            });
        }
    }, [
        messages
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: chatOpen ? "chat open" : "chat",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                className: "fas fa-times",
                onClick: toggleChatClick
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                children: chat
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "messages",
                children: [
                    messages.map(function(item, index) {
                        var ref;
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: classnames__WEBPACK_IMPORTED_MODULE_3___default()("messge-wrap", currentUserId === item.from && "own-message"),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    src: item.avatarImage || "/images/face_1.png",
                                    alt: "user_image"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                    className: "message",
                                    children: [
                                        currentUserId !== item.from && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("i", {
                                            className: "name",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                    className: "name-itself",
                                                    children: item.name
                                                }),
                                                " ",
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                    className: "ml-3",
                                                    children: moment__WEBPACK_IMPORTED_MODULE_2___default()(item.timestamp).format("HH:mm")
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                            className: "content",
                                            dangerouslySetInnerHTML: {
                                                __html: (ref = item.text) === null || ref === void 0 ? void 0 : ref.replace(/(?:(?:https?|ftp|file):\/\/|www\.|ftp\.)(?:\([-A-Z0-9+&@#\/%=~_|$?!:,.]*\)|[-A-Z0-9+&@#\/%=~_|$?!:,.])*(?:\([-A-Z0-9+&@#\/%=~_|$?!:,.]*\)|[A-Z0-9+&@#\/%=~_|$])/gim, function(f) {
                                                    return '<a href="'.concat(f, '" target="_blank">').concat(f, "</a>");
                                                })
                                            }
                                        }),
                                        currentUserId === item.from && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                            className: "name",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                children: moment__WEBPACK_IMPORTED_MODULE_2___default()(item.timestamp).format("HH:mm")
                                            })
                                        })
                                    ]
                                }, item.timestamp)
                            ]
                        }, "".concat(item.from, "_").concat(moment__WEBPACK_IMPORTED_MODULE_2___default()(item.timestamp).format("HH:mm:ss"), "_").concat(index));
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        ref: messagesEndRef
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "send",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: "/images/chat_send_g3.png",
                        alt: "send_icon",
                        onClick: handleSendMessage
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                        type: "text",
                        onChange: handleMessageChange,
                        value: message,
                        placeholder: typeHere,
                        onKeyDown: handleMessageSubmit
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Chat);


/***/ }),

/***/ 49058:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ getLocationUrl; }
/* harmony export */ });
function getLocationUrl() {
    // If params are included, return the url which will get passed to getTour and load specific tour location
    var params = [
        "s=",
        "x=",
        "y="
    ];
    var hasParams = params.every(function(param) {
        return window.location.href.includes(param);
    });
    var url = hasParams ? window.location.href : null;
    return url;
}


/***/ }),

/***/ 19004:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "G$": function() { return /* reexport */ hooks_useGame; },
  "AG": function() { return /* reexport */ useGlobalDOMEvents; },
  "ZK": function() { return /* reexport */ hooks_useLanguage; },
  "OT": function() { return /* reexport */ hooks_useToggle; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./hooks/useGlobalDOMEvents.ts
/* eslint-disable @typescript-eslint/ban-ts-comment,no-restricted-syntax */ 

function useGlobalDOMEvents(props) {
    var deps = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    (0,react.useEffect)(function() {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = Object.entries(props)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _value = (0,_sliced_to_array/* default */.Z)(_step.value, 2), key = _value[0], func = _value[1];
                // @ts-ignore
                window.addEventListener(key, func, false);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return function() {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = Object.entries(props)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _value = (0,_sliced_to_array/* default */.Z)(_step.value, 2), key = _value[0], func = _value[1];
                    // @ts-ignore
                    window.removeEventListener(key, func, false);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
}

;// CONCATENATED MODULE: ./hooks/useToggle.tsx

var initialDefault = false;
var useToggle = function(initial) {
    var ref = (0,react.useState)(initial !== null && initial !== void 0 ? initial : initialDefault), isOpen = ref[0], setIsOpen = ref[1];
    var set = (0,react.useCallback)(function(value) {
        return setIsOpen(value);
    }, [
        setIsOpen
    ]);
    var open = (0,react.useCallback)(function() {
        return setIsOpen(true);
    }, [
        setIsOpen
    ]);
    var close = (0,react.useCallback)(function() {
        return setIsOpen(false);
    }, [
        setIsOpen
    ]);
    var toggle = (0,react.useCallback)(function() {
        return setIsOpen(function(prev) {
            return !prev;
        });
    }, [
        setIsOpen
    ]);
    return {
        isOpen: isOpen,
        set: set,
        open: open,
        close: close,
        toggle: toggle
    };
};
/* harmony default export */ var hooks_useToggle = (useToggle);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./api/TreedisPublicDAO.ts
var TreedisPublicDAO = __webpack_require__(80250);
;// CONCATENATED MODULE: ./hooks/useLanguage.ts




var useLanguage = function(param) {
    var initialDuplicates = param.initialDuplicates, tourSlug = param.tourSlug;
    var languageOptions = (0,react.useMemo)(function() {
        return initialDuplicates === null || initialDuplicates === void 0 ? void 0 : initialDuplicates.map(function(duplicate) {
            return {
                label: (duplicate === null || duplicate === void 0 ? void 0 : duplicate.language) || (duplicate === null || duplicate === void 0 ? void 0 : duplicate.languageEn),
                value: duplicate.slug
            };
        }).filter(function(o) {
            return !!o.label;
        });
    }, [
        initialDuplicates
    ]);
    var defaultLanguage = (0,react.useMemo)(function() {
        return languageOptions === null || languageOptions === void 0 ? void 0 : languageOptions.find(function(o) {
            return o.value === tourSlug;
        });
    }, [
        languageOptions,
        tourSlug
    ]);
    var handleChange = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(lang) {
            var ref, ref1, tourRes, slug, gameId, pathnames, newPathname;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            TreedisPublicDAO/* default.getTourBySlug */.Z.getTourBySlug({
                                slug: lang.value
                            })
                        ];
                    case 1:
                        tourRes = _state.sent();
                        slug = tourRes === null || tourRes === void 0 ? void 0 : (ref = tourRes.tour) === null || ref === void 0 ? void 0 : ref.slug;
                        gameId = tourRes === null || tourRes === void 0 ? void 0 : (ref1 = tourRes.tour) === null || ref1 === void 0 ? void 0 : ref1.gameId;
                        pathnames = window.location.pathname.split("/");
                        pathnames.shift();
                        switch(pathnames[0]){
                            case "tour":
                                newPathname = "tour/".concat(slug);
                                break;
                            case "experience":
                                if (gameId) {
                                    newPathname = "experience/".concat(gameId, "/").concat(slug);
                                } else {
                                    console.error("No experience configuration for tour ".concat(slug));
                                }
                                break;
                            case "e-commerce-tour":
                                newPathname = "e-commerce-tour/".concat(slug);
                                break;
                            default:
                                break;
                        }
                        if (newPathname) {
                            window.location.replace("".concat(window.location.origin, "/").concat(newPathname));
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function(lang) {
            return _ref.apply(this, arguments);
        };
    }(), []);
    return {
        languageOptions: languageOptions,
        defaultLanguage: defaultLanguage,
        handleChange: handleChange
    };
};
/* harmony default export */ var hooks_useLanguage = (useLanguage);

// EXTERNAL MODULE: ./node_modules/recoil/es/recoil.js
var recoil = __webpack_require__(2804);
// EXTERNAL MODULE: ./store/index.ts + 8 modules
var store = __webpack_require__(70989);
// EXTERNAL MODULE: ./components/types.ts
var types = __webpack_require__(31828);
;// CONCATENATED MODULE: ./hooks/useGame.ts





var useGame = function(param) {
    var game = param.game, analytic = param.analytic, gameStatus = param.gameStatus, onEndExperience = param.onEndExperience;
    var ref = (0,react.useState)(0), gameTime = ref[0], setGameTime = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,recoil/* useRecoilState */.FV)(store/* lockTimerState */.bG), 2), lockTimer = ref1[0], setLockTimer = ref1[1];
    // 2nd level
    var initGameData = function() {
        var limitTime = game.limitTime * 60 * 1000;
        var currentGameTime = game.timerType === "stopwatch" ? 1 : limitTime;
        setGameTime(currentGameTime);
        analytic.setTime(game.timerType === "stopwatch" ? 1 : 0);
    };
    var mainGameTimer = function() {
        if (gameStatus === types/* GameStatus.SuccessfullyEndedWithoutFinalScreen */.XI.SuccessfullyEndedWithoutFinalScreen || gameStatus === types/* GameStatus.NotStarted */.XI.NotStarted) {
            return;
        }
        if ((lockTimer === null || lockTimer === void 0 ? void 0 : lockTimer.running) && (lockTimer === null || lockTimer === void 0 ? void 0 : lockTimer.value)) {
            // eslint-disable-next-line @typescript-eslint/no-shadow
            setLockTimer(function(lockTimer) {
                if ((lockTimer === null || lockTimer === void 0 ? void 0 : lockTimer.running) && (lockTimer === null || lockTimer === void 0 ? void 0 : lockTimer.value)) return {
                    running: lockTimer.running,
                    value: lockTimer.value - 1
                };
                return lockTimer;
            });
        }
        var currentGameTime = gameTime;
        if (game.timerType === "stopwatch") currentGameTime += 1000;
        else currentGameTime -= 1000;
        analytic.setTime(game.timerType === "stopwatch" ? currentGameTime : game.limitTime * 60 * 1000 - currentGameTime);
        if (currentGameTime > 0 && (!game.limitTime || currentGameTime < game.limitTime * 60 * 1000)) {
            setGameTime(currentGameTime);
        } else {
            // end experience setstate result screen
            onEndExperience();
        }
    };
    (0,react.useEffect)(function() {
        if (gameStatus === types/* GameStatus.Started */.XI.Started) {
            initGameData();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        gameStatus
    ]);
    (0,react.useEffect)(function() {
        var timerInterval = setTimeout(mainGameTimer, 1000);
        return function cleanup() {
            clearTimeout(timerInterval);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        gameTime
    ]);
    return {
        gameTime: gameTime
    };
};
/* harmony default export */ var hooks_useGame = (useGame);

;// CONCATENATED MODULE: ./hooks/index.ts






/***/ }),

/***/ 12978:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ units_Iframe; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-player/lib/index.js
var lib = __webpack_require__(22004);
;// CONCATENATED MODULE: ./units/Iframe/IframeStyledHOC.tsx




var IframeStyledHOC = function(_param) {
    var onLoad = _param.onLoad, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "onLoad"
    ]);
    var playerRef = (0,react.useRef)();
    var getPlayerInstanceAndTryToPlay = function() {
        try {
            if (rest.autoplay) {
                var ref;
                // youtube autoplay fix
                var ytPlayer = (ref = playerRef.current) === null || ref === void 0 ? void 0 : ref.getInternalPlayer();
                if (typeof (ytPlayer === null || ytPlayer === void 0 ? void 0 : ytPlayer.playVideo) === "function") {
                    ytPlayer === null || ytPlayer === void 0 ? void 0 : ytPlayer.playVideo();
                }
            }
            onLoad();
        } catch (err) {
            console.error(err);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, {
        width: "100%",
        height: "100%",
        controls: true,
        url: rest.url,
        onReady: getPlayerInstanceAndTryToPlay,
        playing: rest.autoplay,
        muted: rest.mute,
        ref: playerRef
    });
};
/* harmony default export */ var Iframe_IframeStyledHOC = (/*#__PURE__*/(0,react.memo)(IframeStyledHOC));

// EXTERNAL MODULE: ./units/Iframe/style.tsx
var style = __webpack_require__(54811);
;// CONCATENATED MODULE: ./units/Iframe/index.tsx





var Iframe = function(_param) {
    var src = _param.src, logoSrc = _param.logoSrc, useModernPlayer = _param.useModernPlayer, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "src",
        "logoSrc",
        "useModernPlayer"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(style/* Root */.fC, {
        children: useModernPlayer ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Iframe_IframeStyledHOC, (0,_object_spread/* default */.Z)({
            width: "100%",
            height: "100%",
            src: src,
            onLoad: function() {}
        }, rest)) : /*#__PURE__*/ (0,jsx_runtime.jsx)(style/* IframeStyled */.C, (0,_object_spread/* default */.Z)({
            width: "100%",
            height: "100%",
            src: src,
            allow: "accelerometer; encrypted-media; gyroscope; picture-in-picture; autoplay; fullscreen; camera; microphone; clipboard-read; clipboard-write; display-capture; geolocation; xr-spatial-tracking",
            onLoad: function() {}
        }, rest))
    });
};
/* harmony default export */ var units_Iframe = (Iframe);


/***/ }),

/***/ 54811:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ IframeStyled; },
/* harmony export */   "aN": function() { return /* binding */ Loader; },
/* harmony export */   "fC": function() { return /* binding */ Root; }
/* harmony export */ });
/* unused harmony exports Logo, Spinner */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18533);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100% !important;\n  height: 100% !important;\n  position: relative;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n  top: 0;\n  right: 0;\n  left: 0;\n  bottom: 0;\n  pointer-events: none;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 115px;\n  height: 115px;\n  object-fit: contain;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n\n  & img {\n    object-fit: contain;\n    height: 100%;\n    width: 100%;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  min-width: 150px;\n  min-height: 150px;\n  width: 150px;\n  height: 150px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n\n  &::after {\n    content: ' ';\n    display: block;\n    width: 100%;\n    height: 100%;\n    margin: 0;\n    position: absolute;\n    border-radius: 50%;\n    border: 3px solid #fff;\n    border-color: var(--color-secondary) transparent var(--color-secondary) transparent;\n    animation: ",
        " 1.2s linear infinite;\n    top: 0;\n    left: 0;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  html body img {\n    height: 100%;\n    width: 100%;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}

var spinner = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .keyframes */ .F4)(_templateObject());
var Root = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "style__Root",
    componentId: "sc-5c3f9880-0"
})(_templateObject1());
var Loader = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "style__Loader",
    componentId: "sc-5c3f9880-1"
})(_templateObject2());
var Logo = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "style__Logo",
    componentId: "sc-5c3f9880-2"
})(_templateObject3());
var Spinner = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "style__Spinner",
    componentId: "sc-5c3f9880-3"
})(_templateObject4(), spinner);
var IframeStyled = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].iframe.withConfig */ .ZP.iframe.withConfig({
    displayName: "style__IframeStyled",
    componentId: "sc-5c3f9880-4"
})(_templateObject5());


/***/ }),

/***/ 99151:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18533);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: ",
        ";\n  height: ",
        ";\n  position: absolute;\n  bottom: 70px;\n  left: ",
        ";\n  z-index: 100;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 100%;\n  width: 100%;\n  position: relative;\n  top: 0;\n  left: 0;\n  transition: all 0.25s ease;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  right: -10px;\n  top: -10px;\n  background: rgba(0, 0, 0, 0.6);\n  border-radius: 50%;\n  color: #fff;\n  padding: 8px;\n  font-size: 14px;\n  line-height: 10px;\n  z-index: 2;\n  cursor: pointer;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

var Container = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "VideoBox__Container",
    componentId: "sc-ccea8b1d-0"
})(_templateObject(), function(param) {
    var width = param.width, isMobile = param.isMobile, landscape = param.landscape;
    return isMobile ? !landscape ? "95vw" : "70vw" : "".concat(width || 350, "px");
}, function(param) {
    var height = param.height, isMobile = param.isMobile;
    return isMobile ? "auto" : "".concat(height || 200, "px");
}, function(param) {
    var isMobile = param.isMobile, landscape = param.landscape;
    return isMobile && !landscape ? "10px" : "60px";
});
var Iframe = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].iframe.withConfig */ .ZP.iframe.withConfig({
    displayName: "VideoBox__Iframe",
    componentId: "sc-ccea8b1d-1"
})(_templateObject1());
var Icon = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].i.withConfig */ .ZP.i.withConfig({
    displayName: "VideoBox__Icon",
    componentId: "sc-ccea8b1d-2"
})(_templateObject2());
/* harmony default export */ __webpack_exports__["Z"] = ({
    Container: Container,
    Iframe: Iframe,
    Icon: Icon
});


/***/ }),

/***/ 19326:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "zx": function() { return /* reexport */ units_Button; },
  "PZ": function() { return /* reexport */ units_CloseButton; },
  "dY": function() { return /* reexport */ units_FullscreenButton; },
  "JO": function() { return /* reexport */ units_Icon/* default */.Z; },
  "c6": function() { return /* reexport */ VideoBox/* default */.Z; }
});

// UNUSED EXPORTS: Alert, Checkbox, Collapse, DatePicker, Field, Form, Iframe, Input, Text, Watermark

// EXTERNAL MODULE: ./units/Alert/index.tsx + 1 modules
var Alert = __webpack_require__(47835);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var src_object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var src_object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var src_object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./units/Button/defaultProps.ts
var defaultProps = {
    palette: "default",
    size: "medium",
    variant: "solid",
    flow: "auto",
    type: "button",
    borderRadius: "small"
};
/* harmony default export */ var Button_defaultProps = (defaultProps);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(18533);
;// CONCATENATED MODULE: ./units/Button/style.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-template-columns: 1fr auto;\n  grid-template-rows: 1fr;\n  align-items: center;\n  overflow: hidden;\n\n  height: ",
        ";\n\n  min-width: ",
        ";\n\n  width: ",
        ";\n\n  color: ",
        ";\n\n  border-style: solid;\n\n  border-radius: ",
        ";\n\n  border-width: ",
        ";\n\n  border-color: ",
        ";\n\n  --background: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: inherit;\n  height: inherit;\n  background: var(--background);\n\n  width: ",
        ";\n\n  text-decoration: ",
        ";\n\n  font-size: ",
        ";\n\n  font-family: 'Lato', sans-serif;\n  font-weight: normal;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  gap: ",
        ";\n\n  padding: 0 1rem;\n\n  &[disabled] {\n    opacity: 0.6;\n  }\n\n  & > svg {\n    font-size: inherit;\n  }\n\n  transition: 0.3s background ease-in;\n\n  &:hover {\n    background: ",
        ";\n  }\n\n  & + & {\n    border-left: 1px solid currentColor;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  to {\n    transform: rotate(1turn);\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  animation: ",
        " 1s linear infinite;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}

var SIZES = {
    // XXSMALL: 20,
    XSMALL: 30,
    SMALL: 40,
    MEDIUM: 50
};
var style_Root = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__Root",
    componentId: "sc-7c7d2c4-0"
})(_templateObject(), function(param) {
    var size = param.size, variant = param.variant;
    switch(variant){
        case "link":
            {
                return "auto";
            }
        default:
            {
                switch(size){
                    case "xsmall":
                        {
                            return "".concat(SIZES.XSMALL, "px");
                        }
                    case "small":
                        {
                            return "".concat(SIZES.SMALL, "px");
                        }
                    default:
                        {
                            return "".concat(SIZES.MEDIUM, "px");
                        }
                }
            }
    }
}, function(param) {
    var flow = param.flow, size = param.size;
    switch(flow){
        case "square":
            {
                switch(size){
                    case "xsmall":
                        {
                            return "".concat(SIZES.XSMALL, "px");
                        }
                    case "small":
                        {
                            return "".concat(SIZES.SMALL, "px");
                        }
                    default:
                        {
                            return "".concat(SIZES.MEDIUM, "px");
                        }
                }
            }
        case "fluid":
            {
                return "unset";
            }
        default:
            {
                return "80px";
            }
    }
}, function(param) {
    var flow = param.flow, size = param.size;
    switch(flow){
        case "square":
            {
                switch(size){
                    case "xsmall":
                        {
                            return "".concat(SIZES.XSMALL, "px");
                        }
                    case "small":
                        {
                            return "".concat(SIZES.SMALL, "px");
                        }
                    default:
                        {
                            return "".concat(SIZES.MEDIUM, "px");
                        }
                }
            }
        case "fluid":
            {
                return "100%";
            }
        default:
            {
                return "initial";
            }
    }
}, function(param) {
    var palette = param.palette, variant = param.variant;
    switch(variant){
        case "transparent":
            {
                switch(palette){
                    case "primary":
                        {
                            return "var(color-secondary)";
                        }
                    case "secondary":
                        {
                            return "#fff";
                        }
                    default:
                        {
                            return "var(color-primary)";
                        }
                }
            }
        case "ghost":
        case "soft":
        case "link":
            {
                switch(palette){
                    case "primary":
                        {
                            return "var(color-secondary)";
                        }
                    default:
                        {
                            return "var(color-primary)";
                        }
                }
            }
        // case "solid"
        default:
            {
                return "#fff";
            }
    }
}, function(param) {
    var borderRadius = param.borderRadius;
    switch(borderRadius){
        case "large":
            {
                return "15px";
            }
        case "medium":
            {
                return "10px";
            }
        case "small":
            {
                return "5px";
            }
        case "none":
            {
                return "0px";
            }
        default:
            {
                return "4px";
            }
    }
}, function(param) {
    var variant = param.variant, size = param.size;
    switch(variant){
        case "ghost":
            {
                switch(size){
                    case "xsmall":
                        {
                            return "1px";
                        }
                    case "small":
                        {
                            return "1px";
                        }
                    default:
                        {
                            return "2px";
                        }
                }
            }
        default:
            {
                return "0";
            }
    }
}, function(param) {
    var palette = param.palette, variant = param.variant;
    switch(variant){
        case "ghost":
            {
                switch(palette){
                    case "primary":
                        {
                            return "var(color-secondary)";
                        }
                    default:
                        {
                            return "var(color-primary)";
                        }
                }
            }
        case "soft":
            {
                switch(palette){
                    case "primary":
                        {
                            return "var(color-secondary)";
                        }
                    default:
                        {
                            return "var(color-primary)";
                        }
                }
            }
        // case "transparent"
        // case "solid"
        // case "link"
        default:
            {
                return "transparent";
            }
    }
}, function(param) {
    var palette = param.palette, variant = param.variant;
    switch(variant){
        case "transparent":
        case "ghost":
        case "link":
            {
                return "transparent";
            }
        case "soft":
            {
                switch(palette){
                    case "primary":
                        {
                            // TODO: add opacity
                            return "rgb(234 71 92 / .2)";
                        }
                    default:
                        {
                            // TODO: add opacity
                            return "rgb(41 41 41 / .2)";
                        }
                }
            }
        // case "solid"
        default:
            {
                switch(palette){
                    case "primary":
                        {
                            return "var(--color-secondary)";
                        }
                    default:
                        {
                            return "var(--color-primary)";
                        }
                }
            }
    }
});
var ButtonStyled = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    displayName: "style__ButtonStyled",
    componentId: "sc-7c7d2c4-1"
})(_templateObject1(), function(param) {
    var flow = param.flow, size = param.size;
    switch(flow){
        case "square":
            {
                switch(size){
                    case "xsmall":
                        {
                            return "".concat(SIZES.XSMALL, "px");
                        }
                    case "small":
                        {
                            return "".concat(SIZES.SMALL, "px");
                        }
                    default:
                        {
                            return "".concat(SIZES.MEDIUM, "px");
                        }
                }
            }
        case "fluid":
            {
                return "100%";
            }
        default:
            {
                return "initial";
            }
    }
}, function(param) {
    var variant = param.variant;
    switch(variant){
        case "link":
            {
                return "underline";
            }
        // case "solid"
        // case "link"
        default:
            {
                return "none";
            }
    }
}, function(param) {
    var size = param.size;
    switch(size){
        case "xsmall":
            {
                return "14px";
            }
        case "small":
            {
                return "16px";
            }
        default:
            {
                return "20px";
            }
    }
}, function(param) {
    var size = param.size;
    switch(size){
        case "xsmall":
            {
                return "4px";
            }
        case "small":
            {
                return "6px";
            }
        default:
            {
                return "10px";
            }
    }
}, function(param) {
    var variant = param.variant;
    switch(variant){
        case "transparent":
            {
                return "rgba(0, 0, 0, .2)";
            }
        default:
            {
                return "var(--background)";
            }
    }
});
var rotate = (0,styled_components_browser_esm/* keyframes */.F4)(_templateObject2());
var Rotate = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "style__Rotate",
    componentId: "sc-7c7d2c4-2"
})(_templateObject3(), rotate);

;// CONCATENATED MODULE: ./units/Button/index.tsx







var Button = function(_param) /*#__PURE__*/ {
    var _palette = _param.palette, palette = _palette === void 0 ? Button_defaultProps.palette : _palette, _size = _param.size, size = _size === void 0 ? Button_defaultProps.size : _size, _variant = _param.variant, variant = _variant === void 0 ? Button_defaultProps.variant : _variant, _flow = _param.flow, flow = _flow === void 0 ? Button_defaultProps.flow : _flow, _type = _param.type, type = _type === void 0 ? Button_defaultProps.type : _type, _borderRadius = _param.borderRadius, borderRadius = _borderRadius === void 0 ? Button_defaultProps.borderRadius : _borderRadius, disabled = _param.disabled, loading = _param.loading, className = _param.className, onClear = _param.onClear, onClick = _param.onClick, onMouseDown = _param.onMouseDown, children = _param.children, restProps = (0,src_object_without_properties/* default */.Z)(_param, [
        "palette",
        "size",
        "variant",
        "flow",
        "type",
        "borderRadius",
        "disabled",
        "loading",
        "className",
        "onClear",
        "onClick",
        "onMouseDown",
        "children"
    ]);
    return (0,jsx_runtime.jsxs)(style_Root, {
        palette: palette,
        size: size,
        variant: variant,
        flow: flow,
        borderRadius: borderRadius,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonStyled, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                palette: palette,
                size: size,
                variant: variant,
                flow: flow,
                borderRadius: borderRadius,
                type: type,
                onClick: onClick,
                onMouseDown: onMouseDown,
                disabled: disabled || loading,
                className: className
            }, restProps), {
                children: [
                    loading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Rotate, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(units_Icon/* default.Loading */.Z.Loading, {})
                    }),
                    children
                ]
            })),
            onClear && /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonStyled, {
                palette: palette,
                size: size,
                flow: "square",
                variant: "transparent",
                borderRadius: borderRadius,
                type: "button",
                disabled: disabled || loading,
                onClick: onClear,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(units_Icon/* default.Close */.Z.Close, {})
            })
        ]
    });
};
/* harmony default export */ var units_Button = (Button);

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/rc-checkbox/es/index.js
var es = __webpack_require__(50132);
// EXTERNAL MODULE: ./node_modules/rc-util/lib/omit.js
var omit = __webpack_require__(18475);
;// CONCATENATED MODULE: ./units/Checkbox/Group/index.tsx









var GroupContext = /*#__PURE__*/ (0,react.createContext)(null);
var CheckboxGroup = function(_param) {
    var defaultValue = _param.defaultValue, children = _param.children, _options = _param.options, options = _options === void 0 ? [] : _options, _prefixCls = _param.prefixCls, prefixCls = _prefixCls === void 0 ? "checkbox" : _prefixCls, className = _param.className, style = _param.style, onChange = _param.onChange, restProps = (0,src_object_without_properties/* default */.Z)(_param, [
        "defaultValue",
        "children",
        "options",
        "prefixCls",
        "className",
        "style",
        "onChange"
    ]);
    var ref = (0,react.useState)(restProps.value || defaultValue || []), value = ref[0], setValue = ref[1];
    var ref1 = (0,react.useState)([]), registeredValues = ref1[0], setRegisteredValues = ref1[1];
    (0,react.useEffect)(function() {
        if ("value" in restProps) {
            setValue(restProps.value || []);
        }
    }, [
        restProps
    ]);
    var getOptions = function() {
        return options.map(function(option) {
            if (typeof option === "string") {
                return {
                    label: option,
                    value: option
                };
            }
            return option;
        });
    };
    var cancelValue = function(val) {
        setRegisteredValues(function(prevValues) {
            return prevValues.filter(function(v) {
                return v !== val;
            });
        });
    };
    var registerValue = function(val) {
        setRegisteredValues(function(prevValues) {
            return (0,_to_consumable_array/* default */.Z)(prevValues).concat([
                val
            ]);
        });
    };
    var toggleOption = function(option) {
        var optionIndex = value.indexOf(option.value);
        var newValue = (0,_to_consumable_array/* default */.Z)(value);
        if (optionIndex === -1) {
            newValue.push(option.value);
        } else {
            newValue.splice(optionIndex, 1);
        }
        if (!("value" in restProps)) {
            setValue(newValue);
        }
        var opts = getOptions();
        onChange === null || onChange === void 0 ? void 0 : onChange(newValue.filter(function(val) {
            return registeredValues.indexOf(val) !== -1;
        }).sort(function(a, b) {
            var indexA = opts.findIndex(function(opt) {
                return opt.value === a;
            });
            var indexB = opts.findIndex(function(opt) {
                return opt.value === b;
            });
            return indexA - indexB;
        }));
    };
    var groupPrefixCls = "".concat(prefixCls, "-group");
    var domProps = (0,omit/* default */.Z)(restProps, [
        "value",
        "disabled"
    ]);
    if (options && options.length > 0) {
        children = getOptions().map(function(option) {
            var ref;
            /*#__PURE__*/ return (0,jsx_runtime.jsx)(Checkbox_Checkbox, {
                prefixCls: prefixCls,
                disabled: "disabled" in option ? option.disabled : restProps.disabled,
                value: option.value,
                checked: value.indexOf(option.value) !== -1,
                onChange: option.onChange,
                className: "".concat(groupPrefixCls, "-item"),
                style: option.style,
                children: option.label
            }, (ref = option.value) === null || ref === void 0 ? void 0 : ref.toString());
        });
    }
    var context = {
        toggleOption: toggleOption,
        value: value,
        disabled: restProps.disabled,
        name: restProps.name,
        // https://github.com/ant-design/ant-design/issues/16376
        registerValue: registerValue,
        cancelValue: cancelValue
    };
    var classString = classnames_default()(groupPrefixCls, className);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        className: classString,
        style: style
    }, domProps), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GroupContext.Provider, {
            value: context,
            children: react.Children.map(children, function(child) {
                return /*#__PURE__*/ (0,react.cloneElement)(child, {
                    value: value,
                    toggleOption: toggleOption
                });
            })
        })
    }));
};
/* harmony default export */ var Group = (/*#__PURE__*/(0,react.memo)(CheckboxGroup));

;// CONCATENATED MODULE: ./units/Checkbox/Checkbox/style.tsx

function style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-template-columns: auto 1fr;\n  align-items: center;\n  gap: 10px;\n  cursor: pointer;\n\n  & .checkbox {\n    width: 20px;\n    height: 20px;\n    display: block;\n    border-radius: 2px;\n    position: relative;\n    overflow: hidden;\n\n    & .checkbox-input {\n      position: absolute;\n      top: 0;\n      right: 0;\n      bottom: 0;\n      left: 0;\n      display: block;\n      height: 100%;\n      width: 100%;\n      margin: 0;\n      padding: 0;\n      opacity: 0;\n    }\n\n    & .checkbox-inner {\n      position: absolute;\n      top: 0;\n      right: 0;\n      bottom: 0;\n      left: 0;\n      display: block;\n      height: 100%;\n      width: 100%;\n      border: 2px solid #2c2c2c;\n      transition: background 0.2s ease-in;\n\n      border-color: ",
        ";\n    }\n\n    &.checkbox-checked {\n      & .checkbox-inner {\n        background: #2c2c2c;\n\n        &:after {\n          // eslint-disable-next-line max-len\n          content: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' aria-hidden='true'%3E%3Cpath fill='%23fff' d='M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z'%3E%3C/path%3E%3C/svg%3E\");\n          position: absolute;\n          top: 0;\n          right: 0;\n          bottom: 0;\n          left: 0;\n        }\n      }\n    }\n\n    &.checkbox-indeterminate {\n      & .checkbox-inner {\n        background: #2c2c2c;\n        opacity: 0.8;\n\n        &:after {\n          // eslint-disable-next-line max-len\n          content: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' aria-hidden='true'%3E%3Cpath fill='%23fff' d='M19 13H5v-2h14v2z'%3E%3C/path%3E%3C/svg%3E\");\n          position: absolute;\n          top: 0;\n          right: 0;\n          bottom: 0;\n          left: 0;\n        }\n      }\n    }\n  }\n"
    ]);
    style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var style_SIZES = {
    // XXSMALL: 20,
    // XSMALL: 30,
    SMALL: 40,
    MEDIUM: 50
};
var Checkbox_style_Root = styled_components_browser_esm/* default.label.withConfig */.ZP.label.withConfig({
    displayName: "style__Root",
    componentId: "sc-7b231797-0"
})(style_templateObject(), function(param) {
    var palette = param.palette;
    switch(palette){
        case "primary":
            {
                return "#ea475c";
            }
        default:
            {
                return "#292929";
            }
    }
});

;// CONCATENATED MODULE: ./units/Checkbox/Checkbox/index.tsx











var InternalCheckbox = function(_param, ref) {
    var _prefixCls = _param.prefixCls, prefixCls = _prefixCls === void 0 ? "checkbox" : _prefixCls, className = _param.className, children = _param.children, _indeterminate = _param.indeterminate, indeterminate = _indeterminate === void 0 ? false : _indeterminate, style = _param.style, onMouseEnter = _param.onMouseEnter, onMouseLeave = _param.onMouseLeave, _skipGroup = _param.skipGroup, skipGroup = _skipGroup === void 0 ? false : _skipGroup, palette = _param.palette, restProps = (0,src_object_without_properties/* default */.Z)(_param, [
        "prefixCls",
        "className",
        "children",
        "indeterminate",
        "style",
        "onMouseEnter",
        "onMouseLeave",
        "skipGroup",
        "palette"
    ]);
    var checkboxGroup = (0,react.useContext)(GroupContext);
    var prevValue = (0,react.useRef)(restProps.value);
    (0,react.useEffect)(function() {
        checkboxGroup === null || checkboxGroup === void 0 ? void 0 : checkboxGroup.registerValue(restProps.value);
    }, [
        checkboxGroup,
        restProps.value
    ]);
    (0,react.useEffect)(function() {
        if (skipGroup) {
            return;
        }
        if (restProps.value !== prevValue.current) {
            checkboxGroup === null || checkboxGroup === void 0 ? void 0 : checkboxGroup.cancelValue(prevValue.current);
            checkboxGroup === null || checkboxGroup === void 0 ? void 0 : checkboxGroup.registerValue(restProps.value);
        }
        // eslint-disable-next-line consistent-return
        return function() {
            return checkboxGroup === null || checkboxGroup === void 0 ? void 0 : checkboxGroup.cancelValue(restProps.value);
        };
    }, [
        checkboxGroup,
        restProps.value,
        skipGroup
    ]);
    var checkboxProps = (0,src_object_spread/* default */.Z)({}, restProps);
    if (checkboxGroup && !skipGroup) {
        checkboxProps.onChange = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            if (restProps.onChange) {
                var _restProps;
                (_restProps = restProps).onChange.apply(_restProps, (0,_to_consumable_array/* default */.Z)(args));
            }
            if (checkboxGroup.toggleOption) {
                checkboxGroup.toggleOption({
                    label: children,
                    value: restProps.value
                });
            }
        };
        checkboxProps.name = checkboxGroup.name;
        checkboxProps.checked = checkboxGroup.value.indexOf(restProps.value) !== -1;
        checkboxProps.disabled = restProps.disabled || checkboxGroup.disabled;
    }
    var _obj;
    var classString = classnames_default()((_obj = {}, (0,_define_property/* default */.Z)(_obj, "".concat(prefixCls, "-wrapper"), true), (0,_define_property/* default */.Z)(_obj, "".concat(prefixCls, "-wrapper-checked"), checkboxProps.checked), (0,_define_property/* default */.Z)(_obj, "".concat(prefixCls, "-wrapper-disabled"), checkboxProps.disabled), _obj), className);
    var checkboxClass = classnames_default()((0,_define_property/* default */.Z)({}, "".concat(prefixCls, "-indeterminate"), indeterminate));
    return(// eslint-disable-next-line jsx-a11y/label-has-associated-control
    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Checkbox_style_Root, {
        palette: palette,
        className: classString,
        style: style,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* default */.Z, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, checkboxProps), {
                prefixCls: prefixCls,
                className: checkboxClass,
                // @ts-ignore
                ref: ref
            })),
            children
        ]
    }));
};
// @ts-ignore
var Checkbox = /*#__PURE__*/ (0,react.forwardRef)(InternalCheckbox);
Checkbox.displayName = "Checkbox";
/* harmony default export */ var Checkbox_Checkbox = (Checkbox);

// EXTERNAL MODULE: ./node_modules/rc-collapse/assets/index.css
var assets = __webpack_require__(29969);
// EXTERNAL MODULE: ./node_modules/rc-collapse/es/index.js + 3 modules
var rc_collapse_es = __webpack_require__(16538);
;// CONCATENATED MODULE: ./units/Collapse/Panel/style.tsx

function Panel_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  &.rc-collapse-item {\n    padding: 0;\n    color: #666;\n    transition: 0.2s background ease-in;\n\n    & > .rc-collapse-header {\n      --background: ",
        ";\n\n      background: var(--background);\n      display: grid;\n      grid-template-columns: 1fr auto;\n      grid-template-areas: 'content arrow';\n      align-items: center;\n      overflow: hidden;\n      line-height: 1;\n      padding: 0;\n\n      &:hover {\n        background: ",
        ";\n      }\n\n      & .arrow {\n        grid-area: arrow;\n        border: none;\n        display: block;\n        width: 40px;\n        margin: 0;\n        position: relative;\n        top: 0;\n        background: transparent;\n        transition: 0.2s transform ease-in;\n        transform: rotate(180deg);\n        padding-bottom: 100%;\n\n        &:before {\n          content: url(\"data:image/svg+xml,%0A%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'%3E%3Ctitle%3EChevron Up%3C/title%3E%3Cpath fill='none' stroke='%23727272' stroke-linecap='round' stroke-linejoin='round' stroke-width='48' d='M112 328l144-144 144 144'/%3E%3C/svg%3E\");\n          position: absolute;\n          top: 0;\n          right: 0;\n          bottom: 0;\n          left: 0;\n          padding: 10px;\n        }\n      }\n\n      & .arrow + * {\n        grid-area: content;\n      }\n    }\n\n    &.rc-collapse-item-active {\n      & > .rc-collapse-header {\n        & .arrow {\n          transform: rotate(0deg);\n        }\n      }\n    }\n  }\n"
    ]);
    Panel_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var PanelStyled = (0,styled_components_browser_esm/* default */.ZP)(rc_collapse_es/* default.Panel */.Z.Panel).withConfig({
    displayName: "style__PanelStyled",
    componentId: "sc-e8df8a15-0"
})(Panel_style_templateObject(), function(param) {
    var palette = param.palette;
    switch(palette){
        case "primary":
            {
                return "#ea475c";
            }
        default:
            {
                return "#292929";
            }
    }
}, function(param) {
    var palette = param.palette;
    switch(palette){
        case "primary":
            {
                return "#ea475ccc";
            }
        default:
            {
                return "#292929cc";
            }
    }
});

;// CONCATENATED MODULE: ./units/Collapse/Panel/index.tsx






var Panel = function(_param) /*#__PURE__*/ {
    var // custom
    palette = _param.palette, restProps = (0,src_object_without_properties/* default */.Z)(_param, [
        "palette"
    ]);
    return (0,jsx_runtime.jsx)(PanelStyled, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, restProps), {
        // custom
        palette: palette
    }));
};
/* harmony default export */ var Collapse_Panel = (Panel);

;// CONCATENATED MODULE: ./units/Collapse/style.tsx

function Collapse_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 0;\n  border: none;\n  margin-bottom: 12px;\n  background: transparent;\n\n  & .rc-collapse-content {\n    padding: 0;\n    background: transparent;\n\n    & .rc-collapse-content-box {\n      margin: 8px 0;\n    }\n  }\n"
    ]);
    Collapse_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var CollapseStyled = (0,styled_components_browser_esm/* default */.ZP)(rc_collapse_es/* default */.Z).withConfig({
    displayName: "style__CollapseStyled",
    componentId: "sc-ffd29dd0-0"
})(Collapse_style_templateObject());

;// CONCATENATED MODULE: ./units/Collapse/index.tsx






var Collapse = function(_param) /*#__PURE__*/ {
    var palette = _param.palette, rest = (0,src_object_without_properties/* default */.Z)(_param, [
        "palette"
    ]);
    return (0,jsx_runtime.jsx)(CollapseStyled, (0,src_object_spread/* default */.Z)({
        // custom
        palette: palette
    }, rest));
};
Collapse.Panel = Collapse_Panel;
/* harmony default export */ var units_Collapse = (Collapse);

;// CONCATENATED MODULE: ./units/Checkbox/Collapsable/style.tsx

function Collapsable_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0;\n  height: 100%;\n  display: grid;\n  justify-content: inherit;\n\n  & > label {\n    padding-left: 25px;\n  }\n"
    ]);
    Collapsable_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var Header = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__Header",
    componentId: "sc-f04741cd-0"
})(Collapsable_style_templateObject());

;// CONCATENATED MODULE: ./units/Checkbox/Collapsable/index.tsx






var defaultCheckedList = [];
var Collapsable_CheckboxGroup = function(param) {
    var name = param.name, label = param.label, children = param.children, onChangeAll = param.onChangeAll;
    var optionsAll = (0,react.useMemo)(function() {
        return children.map(function(e) {
            return e.props.name;
        });
    }, [
        children
    ]);
    var ref = (0,react.useState)(defaultCheckedList), checkedList = ref[0], setCheckedList = ref[1];
    var ref1 = (0,react.useState)(false), indeterminate = ref1[0], setIndeterminate = ref1[1];
    var ref2 = (0,react.useState)(false), checkAll = ref2[0], setCheckAll = ref2[1];
    var handleChange = (0,react.useCallback)(function(list) {
        setCheckedList(list);
        setIndeterminate(!!list.length && list.length < optionsAll.length);
        setCheckAll(list.length === optionsAll.length);
    }, [
        optionsAll
    ]);
    var onCheckAllChange = (0,react.useCallback)(function(e) {
        setCheckedList(e.target.checked ? optionsAll : []);
        setIndeterminate(false);
        setCheckAll(e.target.checked);
        // sorting out nodes with the same state as group checkbox
        var list = children.filter(function(node) {
            return node.props.checked !== e.target.checked;
        });
        onChangeAll === null || onChangeAll === void 0 ? void 0 : onChangeAll(e.target.checked, list.map(function(event) {
            return event.props.name;
        }));
    }, [
        children,
        onChangeAll,
        optionsAll
    ]);
    var header = (0,react.useMemo)(function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox_Checkbox, {
                indeterminate: indeterminate,
                onChange: onCheckAllChange,
                checked: checkAll,
                name: name,
                palette: "primary",
                children: label
            })
        });
    }, [
        name,
        label,
        indeterminate,
        onCheckAllChange,
        checkAll
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(units_Collapse, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(units_Collapse.Panel, {
            header: header,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Group, {
                name: name,
                value: checkedList,
                onChange: handleChange,
                children: children
            })
        })
    });
};
/* harmony default export */ var Collapsable = (/*#__PURE__*/(0,react.memo)(Collapsable_CheckboxGroup));

;// CONCATENATED MODULE: ./units/Checkbox/index.tsx




var units_Checkbox_Checkbox = Checkbox_Checkbox;
units_Checkbox_Checkbox.Collapsable = Collapsable;
units_Checkbox_Checkbox.Group = Group;
/* harmony default export */ var units_Checkbox = ((/* unused pure expression or super */ null && (units_Checkbox_Checkbox)));

;// CONCATENATED MODULE: ./units/CloseButton/style.tsx

function CloseButton_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n  width: 30px;\n  height: 30px;\n  z-index: 3;\n  top: ",
        ";\n  right: ",
        ";\n  border-radius: 50%;\n  background-color: var(--color-primary);\n\n  cursor: pointer;\n\n  svg,\n  i {\n    color: #fff;\n    font-size: 14px;\n    transition: all 0.3s ease;\n  }\n\n  &:hover {\n    svg,\n    i {\n      color: var(--color-secondary);\n    }\n  }\n\n  @media screen and (max-width: 425px) and (orientation: portrait) {\n    right: ",
        ";\n    top: 0px;\n    width: 40px;\n    height: 40px;\n    border-radius: 0 7px 0 0;\n\n    i {\n      font-size: 25px;\n    }\n  }\n"
    ]);
    CloseButton_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var CloseButtonStyled = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    displayName: "style__CloseButtonStyled",
    componentId: "sc-95670290-0"
})(CloseButton_style_templateObject(), function(param) {
    var isFullscreen = param.isFullscreen;
    return !isFullscreen ? "15px" : "68px";
}, function(param) {
    var isFullscreen = param.isFullscreen;
    return !isFullscreen ? "-33px" : "18px";
}, function(param) {
    var isFullscreen = param.isFullscreen;
    return !isFullscreen ? "0px" : "18px";
});

;// CONCATENATED MODULE: ./units/CloseButton/index.tsx


var CloseButton = function(param) {
    var onClick = param.onClick, isFullscreen = param.isFullscreen;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseButtonStyled, {
        onClick: onClick,
        isFullscreen: isFullscreen,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
            className: "fas fa-times"
        })
    });
};
/* harmony default export */ var units_CloseButton = (CloseButton);

// EXTERNAL MODULE: ./node_modules/rc-field-form/es/index.js + 13 modules
var rc_field_form_es = __webpack_require__(54216);
;// CONCATENATED MODULE: ./units/Field/Group/style.tsx

function Group_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-auto-flow: column;\n  gap: ",
        ";\n"
    ]);
    Group_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__Content",
    componentId: "sc-1d2645c-0"
})(Group_style_templateObject(), function(param) {
    var gap = param.gap;
    return "".concat(gap !== null && gap !== void 0 ? gap : 0, "px");
});

;// CONCATENATED MODULE: ./units/Field/style.tsx

function Field_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: ",
        ";\n"
    ]);
    Field_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: 'Lato', sans-serif;\n  font-size: 12px;\n  margin: 0 0 6px;\n  display: grid;\n  grid-template-areas: 'icon label lock';\n  grid-template-columns: auto 1fr auto;\n  align-items: center;\n\n  color: ",
        ";\n\n  font-weight: ",
        ";\n\n  & svg {\n    font-size: 15px;\n    margin-right: 9px;\n  }\n"
    ]);
    style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function style_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-area: icon;\n"
    ]);
    style_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function style_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-area: label;\n"
    ]);
    style_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-area: lock;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: #ea475c;\n  margin-top: 10px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}

var Field_style_SIZES = {
    // XXSMALL: 20,
    // XSMALL: 30,
    SMALL: 40,
    MEDIUM: 50
};
var Label = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__Label",
    componentId: "sc-4f2f6e14-0"
})(Field_style_templateObject(), function(param) {
    var labelInline = param.labelInline;
    if (labelInline) {
        return "flex";
    }
    return "block";
});
var Title = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__Title",
    componentId: "sc-4f2f6e14-1"
})(style_templateObject1(), function(param) {
    var labelPalette = param.labelPalette;
    switch(labelPalette){
        case "primary":
            {
                return "#fff";
            }
        default:
            {
                return "#888";
            }
    }
}, function(param) {
    var labelPalette = param.labelPalette;
    switch(labelPalette){
        case "primary":
            {
                return "normal";
            }
        default:
            {
                return "bolder";
            }
    }
});
var Icon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__Icon",
    componentId: "sc-4f2f6e14-2"
})(style_templateObject2());
var Name = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__Name",
    componentId: "sc-4f2f6e14-3"
})(style_templateObject3());
var Lock = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__Lock",
    componentId: "sc-4f2f6e14-4"
})(_templateObject4());
var Error = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__Error",
    componentId: "sc-4f2f6e14-5"
})(_templateObject5());

;// CONCATENATED MODULE: ./units/Field/Group/index.tsx



var Group_Group = function(param) {
    var label = param.label, labelIcon = param.labelIcon, labelPalette = param.labelPalette, gap = param.gap, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Label, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Title, {
                labelPalette: labelPalette,
                children: [
                    labelIcon,
                    label
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Content, {
                gap: gap,
                children: children
            })
        ]
    });
};
/* harmony default export */ var Field_Group = (Group_Group);

;// CONCATENATED MODULE: ./units/Field/index.tsx








var Field = function(_param) {
    var name = _param.name, label = _param.label, labelIcon = _param.labelIcon, labelPalette = _param.labelPalette, noStyle = _param.noStyle, labelInline = _param.labelInline, lockable = _param.lockable, isLocked = _param.isLocked, isLockedByDefault = _param.isLockedByDefault, children = _param.children, restProps = (0,src_object_without_properties/* default */.Z)(_param, [
        "name",
        "label",
        "labelIcon",
        "labelPalette",
        "noStyle",
        "labelInline",
        "lockable",
        "isLocked",
        "isLockedByDefault",
        "children"
    ]);
    var ref;
    var ref1 = (0,react.useState)((ref = isLocked !== null && isLocked !== void 0 ? isLocked : isLockedByDefault) !== null && ref !== void 0 ? ref : false), locked = ref1[0], setLocked = ref1[1];
    (0,react.useEffect)(function() {
        if (typeof isLocked === "boolean") {
            setLocked(isLocked);
        }
    }, [
        isLocked
    ]);
    if (noStyle) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(rc_field_form_es/* Field */.gN, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
            name: name
        }, restProps), {
            children: function(control, meta, form) {
                var childNode = typeof children === "function" ? children((0,src_object_spread/* default */.Z)({}, lockable ? {
                    disabled: locked
                } : {}, control), meta, form) : /*#__PURE__*/ (0,react.cloneElement)(children, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, control), {
                    name: name
                }));
                return childNode;
            }
        }));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(rc_field_form_es/* Field */.gN, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        name: name
    }, restProps), {
        children: function(control, meta, form) {
            var error = name && form.getFieldError(name)[0] || "";
            var childNode = typeof children === "function" ? children((0,src_object_spread/* default */.Z)({}, lockable ? {
                disabled: locked
            } : {}, control), meta, form) : /*#__PURE__*/ (0,react.cloneElement)(children, (0,src_object_spread/* default */.Z)((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, control), {
                name: name
            }), lockable ? {
                disabled: locked
            } : {}));
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Label, {
                labelInline: labelInline,
                children: [
                    label && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Title, {
                        labelPalette: labelPalette,
                        children: [
                            labelIcon && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                                children: labelIcon
                            }),
                            label && /*#__PURE__*/ (0,jsx_runtime.jsx)(Name, {
                                children: label
                            })
                        ]
                    }),
                    childNode,
                    error && /*#__PURE__*/ (0,jsx_runtime.jsx)(Error, {
                        children: error
                    })
                ]
            });
        }
    }));
};
Field.Group = Field_Group;
/* harmony default export */ var units_Field = ((/* unused pure expression or super */ null && (Field)));

;// CONCATENATED MODULE: ./units/Form/style.tsx

function Form_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 100%;\n\n  /* global override */\n  max-height: unset !important;\n  overflow: unset !important;\n"
    ]);
    Form_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var style_Form = (0,styled_components_browser_esm/* default */.ZP)(rc_field_form_es/* default */.ZP).withConfig({
    displayName: "style__Form",
    componentId: "sc-a03062af-0"
})(Form_style_templateObject());

;// CONCATENATED MODULE: ./units/Form/index.tsx

/* harmony default export */ var units_Form = ((/* unused pure expression or super */ null && (Form)));

;// CONCATENATED MODULE: ./units/FullscreenButton/style.tsx

function FullscreenButton_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n  width: 30px;\n  height: 30px;\n  z-index: 3;\n  border-radius: 50%;\n  top: ",
        ";\n  right: ",
        ";\n  background-color: var(--color-secondary);\n\n  cursor: pointer;\n\n  svg,\n  i {\n    color: #fff;\n    font-size: 14px;\n    transition: all 0.3s ease;\n  }\n\n  &:hover {\n    svg,\n    i {\n      color: var(--color-primary);\n    }\n  }\n\n  @media screen and (max-width: 425px) and (orientation: portrait) {\n    top: ",
        ";\n    right: ",
        ";\n  }\n"
    ]);
    FullscreenButton_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var FullscreenButtonStyled = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    displayName: "style__FullscreenButtonStyled",
    componentId: "sc-17a6388c-0"
})(FullscreenButton_style_templateObject(), function(param) {
    var isFullscreen = param.isFullscreen;
    return !isFullscreen ? "48px" : "100px";
}, function(param) {
    var isFullscreen = param.isFullscreen;
    return !isFullscreen ? "-33px" : "18px";
}, function(param) {
    var isFullscreen = param.isFullscreen;
    return !isFullscreen ? "52px" : "100px";
}, function(param) {
    var isFullscreen = param.isFullscreen;
    return !isFullscreen ? "-15px" : "18px";
});
/* harmony default export */ var style = (FullscreenButtonStyled);

// EXTERNAL MODULE: ./components/util/deviceManager.ts
var deviceManager = __webpack_require__(99080);
;// CONCATENATED MODULE: ./units/FullscreenButton/index.tsx



var FullscreenButton = function(param) {
    var onClick = param.onClick, isFullscreen = param.isFullscreen;
    return !deviceManager/* default.isMobile */.Z.isMobile() ? /*#__PURE__*/ (0,jsx_runtime.jsx)(style, {
        onClick: onClick,
        isFullscreen: isFullscreen,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
            className: isFullscreen ? "fas fa-compress" : "fas fa-expand"
        })
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};
/* harmony default export */ var units_FullscreenButton = (FullscreenButton);

// EXTERNAL MODULE: ./units/Iframe/index.tsx + 1 modules
var Iframe = __webpack_require__(12978);
// EXTERNAL MODULE: ./node_modules/rc-textarea/es/index.js + 2 modules
var rc_textarea_es = __webpack_require__(57239);
;// CONCATENATED MODULE: ./units/Input/TextArea/style.tsx

function TextArea_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n\n  color: ",
        ";\n\n  font-size: ",
        ";\n\n  font-family: 'Lato', sans-serif;\n  font-weight: normal;\n  border-radius: 4px;\n  border: none;\n  margin: 0;\n  line-height: 1.2;\n\n  &[disabled] {\n    opacity: 0.6;\n  }\n"
    ]);
    TextArea_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var TextArea_style_SIZES = {
    // XXSMALL: 20,
    XSMALL: 30,
    SMALL: 40,
    MEDIUM: 50
};
var TextAreaStyled = (0,styled_components_browser_esm/* default */.ZP)(rc_textarea_es/* default */.Z).withConfig({
    displayName: "style__TextAreaStyled",
    componentId: "sc-ea1cbca6-0"
})(TextArea_style_templateObject(), function(param) {
    var palette = param.palette;
    switch(palette){
        case "primary":
            {
                return "#ea475c";
            }
        case "secondary":
            {
                return "rgba(255, 255, 255, 0.5)";
            }
        case "tertiary":
            {
                return "rgba(255, 255, 255, 1)";
            }
        default:
            {
                return "rgba(136, 136, 136, 0.1)";
            }
    }
}, function(param) {
    var palette = param.palette;
    switch(palette){
        case "primary":
            {
                return "#fff";
            }
        default:
            {
                return "#292929";
            }
    }
}, function(param) {
    var xsize = param.xsize;
    switch(xsize){
        case "xsmall":
            {
                return "14px";
            }
        case "small":
            {
                return "16px";
            }
        default:
            {
                return "20px";
            }
    }
});

;// CONCATENATED MODULE: ./units/Input/TextArea/index.tsx




var autoSizeDefault = {
    minRows: 3,
    maxRows: 5
};
var TextArea = function(_param) /*#__PURE__*/ {
    var palette = _param.palette, design = _param.design, size = _param.size, _autoSize = _param.autoSize, autoSize = _autoSize === void 0 ? autoSizeDefault : _autoSize, _value = _param.value, value = _value === void 0 ? "" : _value, placeholder = _param.placeholder, name = _param.name, disabled = _param.disabled, onChange = _param.onChange, _prefixCls = _param.prefixCls, prefixCls = _prefixCls === void 0 ? "textarea" : _prefixCls, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "palette",
        "design",
        "size",
        "autoSize",
        "value",
        "placeholder",
        "name",
        "disabled",
        "onChange",
        "prefixCls"
    ]);
    return (0,jsx_runtime.jsx)(TextAreaStyled, (0,src_object_spread/* default */.Z)({
        palette: palette,
        design: design,
        xsize: size,
        autoSize: autoSize,
        value: value,
        placeholder: placeholder,
        name: name,
        disabled: disabled,
        onChange: onChange,
        prefixCls: prefixCls
    }, props));
};
/* harmony default export */ var Input_TextArea = (TextArea);

;// CONCATENATED MODULE: ./units/Input/style.tsx

function Input_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: ",
        ";\n\n  background: ",
        ";\n\n  color: ",
        ";\n\n  font-size: ",
        ";\n\n  font-family: 'Lato', sans-serif;\n  font-weight: normal;\n  min-width: 60px;\n  border-radius: 4px;\n  border: none;\n  margin: 0;\n\n  &[disabled] {\n    opacity: 0.6;\n  }\n"
    ]);
    Input_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var Input_style_SIZES = {
    // XXSMALL: 20,
    XSMALL: 30,
    SMALL: 40,
    MEDIUM: 50
};
var InputStyled = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
    displayName: "style__InputStyled",
    componentId: "sc-60cb3ca-0"
})(Input_style_templateObject(), function(param) {
    var xsize = param.xsize;
    switch(xsize){
        case "xsmall":
            {
                return "".concat(Input_style_SIZES.XSMALL, "px");
            }
        case "small":
            {
                return "".concat(Input_style_SIZES.SMALL, "px");
            }
        default:
            {
                return "".concat(Input_style_SIZES.MEDIUM, "px");
            }
    }
}, function(param) {
    var palette = param.palette;
    switch(palette){
        case "primary":
            {
                return "#ea475c";
            }
        case "secondary":
            {
                return "rgba(255, 255, 255, 0.5)";
            }
        case "tertiary":
            {
                return "rgba(255, 255, 255, 1)";
            }
        default:
            {
                return "rgba(136, 136, 136, 0.1)";
            }
    }
}, function(param) {
    var palette = param.palette;
    switch(palette){
        case "primary":
            {
                return "#fff";
            }
        default:
            {
                return "#292929";
            }
    }
}, function(param) {
    var xsize = param.xsize;
    switch(xsize){
        case "xsmall":
            {
                return "14px";
            }
        case "small":
            {
                return "16px";
            }
        default:
            {
                return "20px";
            }
    }
});

;// CONCATENATED MODULE: ./units/Input/index.tsx
// noinspection TypeScriptValidateTypes





var Input = function(_param) /*#__PURE__*/ {
    var palette = _param.palette, design = _param.design, size = _param.size, value = _param.value, min = _param.min, max = _param.max, step = _param.step, onChange = _param.onChange, onBlur = _param.onBlur, placeholder = _param.placeholder, name = _param.name, disabled = _param.disabled, onKeyDown = _param.onKeyDown, tabIndex = _param.tabIndex, type = _param.type, className = _param.className, restProps = (0,src_object_without_properties/* default */.Z)(_param, [
        "palette",
        "design",
        "size",
        "value",
        "min",
        "max",
        "step",
        "onChange",
        "onBlur",
        "placeholder",
        "name",
        "disabled",
        "onKeyDown",
        "tabIndex",
        "type",
        "className"
    ]);
    return (0,jsx_runtime.jsx)(InputStyled, (0,src_object_spread/* default */.Z)({
        palette: palette,
        design: design,
        xsize: size,
        value: value,
        min: min,
        max: max,
        step: step,
        onChange: onChange,
        onBlur: onBlur,
        placeholder: placeholder,
        name: name,
        disabled: disabled,
        onKeyDown: onKeyDown,
        tabIndex: tabIndex,
        type: type,
        className: className
    }, restProps));
};
Input.TextArea = Input_TextArea;
/* harmony default export */ var units_Input = ((/* unused pure expression or super */ null && (Input)));

;// CONCATENATED MODULE: ./units/Text/style.tsx

function Text_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n\n  font-weight: ",
        ";\n\n  text-transform: ",
        ";\n  text-decoration: ",
        ";\n  overflow-wrap: anywhere;\n"
    ]);
    Text_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var Text_style_Root = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "style__Root",
    componentId: "sc-51413b4b-0"
})(Text_style_templateObject(), function(param) {
    var palette = param.palette;
    switch(palette){
        case "primary":
            {
                return "#ea475c";
            }
        case "secondary":
            {
                return "#888";
            }
        default:
            {
                return "#fff";
            }
    }
}, function(param) {
    var weight = param.weight;
    switch(weight){
        case "regular":
            {
                return "bolder";
            }
        case "strong":
            {
                return "bold";
            }
        // case "weak"
        default:
            {
                return "normal";
            }
    }
}, function(param) {
    var uppercase = param.uppercase;
    return uppercase ? "uppercase" : "none";
}, function(param) {
    var underline = param.underline;
    return underline ? "underline" : "none";
});

;// CONCATENATED MODULE: ./units/Text/index.tsx


var Text = function(param) {
    var size = param.size, weight = param.weight, align = param.align, truncate = param.truncate, underline = param.underline, uppercase = param.uppercase, palette = param.palette, children = param.children;
    return /*#__PURE__*/ _jsx(Root, {
        size: size,
        weight: weight,
        align: align,
        truncate: truncate,
        underline: underline,
        uppercase: uppercase,
        palette: palette,
        children: children
    });
};
/* harmony default export */ var units_Text = ((/* unused pure expression or super */ null && (Text)));

// EXTERNAL MODULE: ./units/Icon/index.ts + 53 modules
var units_Icon = __webpack_require__(95829);
// EXTERNAL MODULE: ./units/VideoBox/index.tsx
var VideoBox = __webpack_require__(99151);
;// CONCATENATED MODULE: ./units/Watermark/style.tsx

function Watermark_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: fixed;\n  width: 100%;\n  top: 30%;\n  text-align: center;\n  opacity: 0.5;\n  z-index: 99999;\n  color: white;\n  transform: rotate(-30deg);\n  font-size: 30vh;\n  pointer-events: none;\n  @media (orientation: portrait) {\n    transform: rotate(-45deg);\n    font-size: 22vh;\n  }\n"
    ]);
    Watermark_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var style_WatermarkStyled = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "style__WatermarkStyled",
    componentId: "sc-74f85d7c-0"
})(Watermark_style_templateObject());
/* harmony default export */ var Watermark_style = ((/* unused pure expression or super */ null && (style_WatermarkStyled)));

;// CONCATENATED MODULE: ./units/Watermark/index.tsx





var Watermark = function(_param) {
    var id = _param.id, show = _param.show, children = _param.children, restProps = _object_without_properties(_param, [
        "id",
        "show",
        "children"
    ]);
    if (show) {
        return /*#__PURE__*/ _jsx(WatermarkStyled, _object_spread_props(_object_spread({
            id: id
        }, restProps), {
            children: children
        }));
    }
    return null;
};
/* harmony default export */ var units_Watermark = ((/* unused pure expression or super */ null && (Watermark)));

// EXTERNAL MODULE: ./node_modules/react-datepicker/dist/react-datepicker.css
var react_datepicker = __webpack_require__(39828);
;// CONCATENATED MODULE: ./units/DatePicker/index.tsx



var DatePickerCreator = function(param) {
    var dateFormat = param.dateFormat, startDate = param.startDate, handleDateChange = param.handleDateChange;
    return /*#__PURE__*/ _jsx(DatePicker, {
        dateFormat: dateFormat,
        selected: startDate,
        onChange: handleDateChange,
        autoComplete: "disable_autocomplete"
    });
};
/* harmony default export */ var units_DatePicker = ((/* unused pure expression or super */ null && (DatePickerCreator)));

;// CONCATENATED MODULE: ./units/index.ts

















/***/ }),

/***/ 19245:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getRatio; }
/* harmony export */ });
function getRatio() {
    var ratio = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "1/1";
    return ({
        "4/3": "calc(100% / 4 * 3)",
        "3/4": "calc(100% / 3 * 4)",
        "6/4": "calc(100% / 6 * 4)",
        "4/6": "calc(100% / 4 * 6)",
        "16/9": "calc(100% / 16 * 9)",
        "9/16": "calc(100% / 9 * 16)",
        "21/9": "calc(100% / 21 * 9)",
        "9/21": "calc(100% / 9 * 21)",
        "1/1": "100%"
    })[ratio];
}


/***/ }),

/***/ 1098:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ow": function() { return /* binding */ getHorizontalAngleBetweenPoints; },
/* harmony export */   "Qm": function() { return /* binding */ getHorizontalRotationBetweenPoints; },
/* harmony export */   "bP": function() { return /* binding */ getVerticalRotationBetweenPoints; }
/* harmony export */ });
/* unused harmony export getRotationBetweenPoints */
/* harmony import */ var three__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99477);

var getHorizontalRotationBetweenPoints = function(point1, point2) {
    var vOX = new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4(0, 0, 1); // OX axis
    var direction = new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4();
    direction.subVectors(point1, point2);
    direction.y = 0;
    direction.normalize();
    vOX.normalize();
    var dot = direction.dot(vOX);
    var cross = new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4().crossVectors(vOX, direction).y;
    var horizontalRotation = Math.acos(dot);
    if (cross < 0) {
        horizontalRotation = -horizontalRotation;
    }
    return three__WEBPACK_IMPORTED_MODULE_0__/* .MathUtils.radToDeg */ .M8C.radToDeg(horizontalRotation);
};
var getVerticalRotationBetweenPoints = function(point1, point2) {
    var p1 = point1.clone();
    var p2 = point2.clone();
    p1.y = 0;
    p2.y = 0;
    var deltaXZ = p1.distanceTo(p2);
    var deltaY = point2.y - point1.y;
    var angleRadians = Math.atan2(deltaY, deltaXZ);
    return three__WEBPACK_IMPORTED_MODULE_0__/* .MathUtils.radToDeg */ .M8C.radToDeg(angleRadians);
};
var getRotationBetweenPoints = function(point1, point2) {
    var point1Vec3 = point1.isVector3 ? point1 : new THREE.Vector3(point1.x, point1.y, point1.z);
    var point2Vec3 = point1.isVector3 ? point1 : new THREE.Vector3(point2.x, point2.y, point2.z);
    var pitchDegrees = getVerticalRotationBetweenPoints(point1Vec3, point2Vec3);
    var yawDegrees = getHorizontalRotationBetweenPoints(point1Vec3, point2Vec3);
    return {
        pitchDegrees: pitchDegrees,
        yawDegrees: yawDegrees
    };
};
var getHorizontalAngleBetweenPoints = function(point1, point2, point3) {
    var p1 = new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4(point1.x, 0, point1.z);
    var p2 = new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4(point2.x, 0, point2.z);
    var p3 = new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4(point3.x, 0, point3.z);
    var vector21 = new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4().subVectors(p1, p2).normalize();
    var vector23 = new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4().subVectors(p3, p2).normalize();
    var angle = vector21.angleTo(vector23);
    var cross = new three__WEBPACK_IMPORTED_MODULE_0__/* .Vector3 */ .Pa4().crossVectors(vector21, vector23).y;
    var isLeftTurn = cross < 0;
    return {
        angle: angle,
        isLeftTurn: isLeftTurn
    };
};


/***/ }),

/***/ 75410:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 48628:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 31601:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 67792:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 52007:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 75042:
/***/ (function() {

/* (ignored) */

/***/ })

}]);